import _extends from '@babel/runtime/helpers/extends';
import * as React from 'react';

const SvgAccessSecurity = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 30 30"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 61737"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#707070",
  d: "m16.011 24.346 6.415-3.207.681 1.363-6.414 3.207Z",
  "data-name": "Path 75953"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#707070",
  d: "M23.379 10.379h1.523v9.242h-1.523Z",
  "data-name": "Path 75954"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#707070",
  d: "m16.018 5.655.682-1.363 6.414 3.207-.681 1.363Z",
  "data-name": "Path 75955"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#707070",
  d: "m6.872 22.507.682-1.363 6.414 3.207-.681 1.363Z",
  "data-name": "Path 75956"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#707070",
  d: "m6.878 7.492 6.415-3.207.681 1.363L7.56 8.855Z",
  "data-name": "Path 75957"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#707070",
  d: "M5.097 10.379H6.62v9.242H5.097Z",
  "data-name": "Path 75958"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#4fabf7",
  "data-name": "Group 61723"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15 2a2.285 2.285 0 1 0 2.285 2.285A2.28 2.28 0 0 0 15 2",
  "data-name": "Path 75959"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15 23.43a2.285 2.285 0 1 0 2.285 2.285A2.28 2.28 0 0 0 15 23.43",
  "data-name": "Path 75960"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.859 23.429a2.285 2.285 0 1 1 2.285-2.285 2.29 2.29 0 0 1-2.285 2.285",
  "data-name": "Path 75961"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.859 11.14a2.285 2.285 0 1 1 2.285-2.285 2.29 2.29 0 0 1-2.285 2.285",
  "data-name": "Path 75962"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#1886ea",
  d: "M24.14 11.14a2.285 2.285 0 1 1 2.285-2.285 2.29 2.29 0 0 1-2.285 2.285",
  "data-name": "Path 75963"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1886ea",
  d: "M24.14 23.429a2.285 2.285 0 1 1 2.285-2.285 2.29 2.29 0 0 1-2.285 2.285",
  "data-name": "Path 75964"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00467d",
  d: "M18.808 12.664v1.574h-1.523v-1.574a2.285 2.285 0 1 0-4.57 0v1.574h-1.524v-1.574a3.809 3.809 0 1 1 7.617 0",
  "data-name": "Path 75965"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#033a5d",
  d: "M18.809 12.664v1.574h-1.523v-1.574A2.28 2.28 0 0 0 15 10.378V8.855a3.81 3.81 0 0 1 3.809 3.809",
  "data-name": "Path 75966"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffcb00",
  d: "M9.668 13.477v6.145h10.664v-6.145Z",
  "data-name": "Path 75967"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ff9800",
  d: "M15 13.477h5.332v6.145H15Z",
  "data-name": "Path 75968"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M14.238 15h1.523v1.523h-1.523Z",
  "data-name": "Path 75969"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M15 15h.762v1.523H15Z",
  "data-name": "Path 75970"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1886ea",
  d: "M17.285 25.715A2.28 2.28 0 0 1 15 28v-4.57a2.28 2.28 0 0 1 2.285 2.285",
  "data-name": "Path 75971"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1886ea",
  d: "M15 6.57V2a2.285 2.285 0 0 1 0 4.57",
  "data-name": "Path 75972"
})));

const SvgBenefitManagement = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 30 30"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 61759"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "welfare (1)",
  transform: "translate(2 2)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 4,
  cy: 4,
  r: 4,
  fill: "#4ad395",
  "data-name": "Ellipse 1465",
  transform: "translate(18)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e6e6e6",
  d: "M23.182 2.081a2.96 2.96 0 0 1-1.078-.781 3 3 0 0 1-1.078.781 3 3 0 0 1-1.086.238h-.005a8.3 8.3 0 0 0 .278 2.353A3.7 3.7 0 0 0 22.102 6.5a3.7 3.7 0 0 0 1.889-1.828 8.3 8.3 0 0 0 .278-2.353 3 3 0 0 1-1.087-.238",
  "data-name": "Path 71613"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M23.182 2.081a2.96 2.96 0 0 1-1.081-.781v5.2a3.7 3.7 0 0 0 1.889-1.828 8.3 8.3 0 0 0 .278-2.353 3 3 0 0 1-1.086-.238",
  "data-name": "Path 71614"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 4,
  cy: 4,
  r: 4,
  fill: "#90d2fc",
  "data-name": "Ellipse 1466",
  transform: "translate(18 18)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#8a8a8a",
  d: "m22.102 19.935-2.167 2.167h4.334Z",
  "data-name": "Path 71615"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M20.801 22.101h2.6v2.167h-2.6Z",
  "data-name": "Path 71616"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 4,
  cy: 4,
  r: 4,
  fill: "#ff515c",
  "data-name": "Ellipse 1467",
  transform: "translate(0 18)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M5.942 21.244h-1.3v-1.3H2.908v1.3h-1.3v1.733h1.3v1.3h1.734v-1.3h1.3Z",
  "data-name": "Path 71617"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 4,
  cy: 4,
  r: 4,
  fill: "#ff9800",
  "data-name": "Ellipse 1468"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M3.9 3.467a.433.433 0 1 1 .433-.433H5.2a1.3 1.3 0 0 0-.867-1.22V1.3h-.866v.513A1.3 1.3 0 0 0 3.9 4.334a.433.433 0 1 1-.433.433H2.6a1.3 1.3 0 0 0 .867 1.22V6.5h.867v-.513a1.3 1.3 0 0 0-.434-2.52",
  "data-name": "Path 71618"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#00467d",
  "data-name": "Group 56978"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.416 25.562h-.013c-.295.01-.592.009-.882 0l.032-.867c.27.01.547.011.823 0Z",
  "data-name": "Path 71619"
}), /*#__PURE__*/React.createElement("path", {
  d: "m14.311 25.501-.089-.862c.276-.029.554-.068.826-.116l.15.854c-.295.051-.595.093-.887.124",
  "data-name": "Path 71620"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.627 25.494a12 12 0 0 1-.887-.129l.154-.852q.415.074.826.12Z",
  "data-name": "Path 71621"
}), /*#__PURE__*/React.createElement("path", {
  d: "m16.076 25.189-.211-.841c.27-.068.54-.146.8-.232l.272.823q-.424.14-.861.25",
  "data-name": "Path 71622"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.864 25.174a13 13 0 0 1-.86-.254l.275-.822c.264.088.534.168.8.237Z",
  "data-name": "Path 71623"
}), /*#__PURE__*/React.createElement("path", {
  d: "m24.915 17.01-.821-.277q.133-.394.237-.8l.839.216q-.112.438-.255.861",
  "data-name": "Path 71624"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.067 16.951a13 13 0 0 1-.251-.86l.84-.213c.068.269.147.539.234.8Z",
  "data-name": "Path 71625"
}), /*#__PURE__*/React.createElement("path", {
  d: "m25.364 15.275-.853-.156q.074-.408.12-.826l.862.1a13 13 0 0 1-.129.882",
  "data-name": "Path 71626"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.628 15.214a12 12 0 0 1-.125-.888l.862-.089c.029.273.068.552.116.826Z",
  "data-name": "Path 71627"
}), /*#__PURE__*/React.createElement("path", {
  d: "m25.559 13.498-.866-.034c.011-.274.011-.556 0-.835v-.053l.866-.028v.053q.018.446 0 .897",
  "data-name": "Path 71628"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.44 13.431v-.022a14 14 0 0 1 0-.868l.866.031q-.015.401 0 .81Z",
  "data-name": "Path 71629"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.633 11.741a11 11 0 0 0-.118-.826l.853-.153c.052.293.1.591.127.887Z",
  "data-name": "Path 71630"
}), /*#__PURE__*/React.createElement("path", {
  d: "m1.367 11.739-.862-.1q.048-.45.128-.888l.852.154q-.072.414-.118.834",
  "data-name": "Path 71631"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.339 10.1q-.104-.407-.235-.8l.822-.273c.094.281.179.571.253.86Z",
  "data-name": "Path 71632"
}), /*#__PURE__*/React.createElement("path", {
  d: "m1.663 10.093-.842-.215c.074-.289.159-.579.254-.861l.822.275q-.129.396-.234.801",
  "data-name": "Path 71633"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.697 1.896c-.26-.088-.53-.166-.8-.235l.214-.84q.438.112.862.253Z",
  "data-name": "Path 71634"
}), /*#__PURE__*/React.createElement("path", {
  d: "m9.31 1.894-.273-.823c.284-.094.574-.179.861-.252l.213.84a12 12 0 0 0-.8.235Z",
  "data-name": "Path 71635"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.081 1.484a11 11 0 0 0-.826-.118l.091-.862c.3.031.6.074.888.126Z",
  "data-name": "Path 71636"
}), /*#__PURE__*/React.createElement("path", {
  d: "m10.927 1.484-.153-.853c.3-.053.6-.1.888-.126l.089.862q-.408.043-.824.117",
  "data-name": "Path 71637"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.423 1.308q-.4-.014-.8 0l-.068-.865h.062c.27-.009.552-.008.832 0Z",
  "data-name": "Path 71638"
})), /*#__PURE__*/React.createElement("circle", {
  cx: 6.5,
  cy: 6.5,
  r: 6.5,
  fill: "#00467d",
  "data-name": "Ellipse 1469",
  transform: "translate(7 7)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M14.734 13.001h-3.467a1.734 1.734 0 0 0-1.733 1.733v3.242a6.05 6.05 0 0 0 6.934 0v-3.242a1.734 1.734 0 0 0-1.734-1.733",
  "data-name": "Path 71639"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1.95,
  cy: 1.95,
  r: 1.95,
  fill: "#fff",
  "data-name": "Ellipse 1470",
  transform: "translate(11.05 9.1)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#405d80",
  d: "M10.617 14.734h.433v3.9h-.433Z",
  "data-name": "Path 71640"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#405d80",
  d: "M14.951 14.734h.433v3.9h-.433Z",
  "data-name": "Path 71641"
}))));

const SvgBlackDollar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 30 30"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M15.002 2.502a12.5 12.5 0 1 0 12.5 12.5 12.5 12.5 0 0 0-12.5-12.5m1.76 20.109v2.391h-3.337v-2.416c-2.137-.45-3.949-1.825-4.087-4.249h2.45c.125 1.312 1.025 2.337 3.312 2.337 2.45 0 3-1.225 3-1.987 0-1.037-.55-2.012-3.337-2.674-3.1-.75-5.224-2.025-5.224-4.587 0-2.15 1.737-3.549 3.887-4.012V5.002h3.336v2.437a4.42 4.42 0 0 1 3.562 4.237h-2.45c-.062-1.387-.8-2.337-2.774-2.337-1.875 0-3 .85-3 2.05 0 1.05.812 1.737 3.337 2.387s5.224 1.737 5.224 4.887c-.012 2.287-1.725 3.537-3.9 3.949Z",
  "data-name": "Path 1317"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h30v30H0Z",
  "data-name": "Path 1318"
}));

const SvgCashieringAccessSecurity = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 18.234 18.234"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#e21118",
  d: "m4.791 11.116-.332.1-.16 1.283 1.315-.563Z",
  "data-name": "Path 12104"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffdf47",
  d: "M11.071 10.094a.326.326 0 0 0-.326.326v3.908h6.512V10.42a.326.326 0 0 0-.325-.326h-.739l-.348.348a.32.32 0 0 1-.4.049l-.482-.286q-.091.04-.185.075l-.137.544a.326.326 0 0 1-.316.247h-.65a.326.326 0 0 1-.316-.247l-.137-.544q-.091-.034-.185-.075l-.482.286a.32.32 0 0 1-.4-.049l-.345-.348Zm3.908 1.628h.651v.651h-.652Zm-1.3 0h.651v.651h-.655Zm-1.3 0h.651v.651h-.651Z",
  "data-name": "Path 12105"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e21118",
  d: "M7.162 10.611v-.983a3.5 3.5 0 0 1-1.953 0v.983l.977.98Z",
  "data-name": "Path 12106"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffdf47",
  d: "m15.612 16.178.251.755h2.229l-.734-1.955h-6.715l-.732 1.953h2.225l.251-.755a.33.33 0 0 1 .309-.221h2.605a.33.33 0 0 1 .309.221Z",
  "data-name": "Path 12107"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffdf47",
  d: "M12.826 16.932h2.351l-.108-.326h-2.133Z",
  "data-name": "Path 12108"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e21118",
  d: "m7.912 11.217-.332-.1-.824.821 1.315.563Z",
  "data-name": "Path 12109"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e21118",
  d: "M3.256 3.819a7.2 7.2 0 0 1 2.527-1.53.33.33 0 0 1 .387.212 2.6 2.6 0 0 0 .586.954 1.39 1.39 0 0 1 1.059-.525.33.33 0 0 1 .309.221 1.82 1.82 0 0 0 .993.954V2.93a2.931 2.931 0 0 0-5.861 0Z",
  "data-name": "Path 12110"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e21118",
  d: "M3.256 6.186a2.93 2.93 0 0 0 2.931 2.931 3.05 3.05 0 0 0 2.657-1.692 2.6 2.6 0 0 0 .274-1.238V4.796a2.62 2.62 0 0 1-1.495-1.185 1.02 1.02 0 0 0-.495.443.326.326 0 0 1-.436.143 2.5 2.5 0 0 1-1.019-1.192 8.8 8.8 0 0 0-2.417 1.69Zm4.233-1.3h.651v.651h-.651Zm-1.3 2.605a.65.65 0 0 0 .651-.651h.651a1.303 1.303 0 1 1-2.605 0h.652a.65.65 0 0 0 .651.651M4.236 4.886h.651v.651h-.651Z",
  "data-name": "Path 12111"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e21118",
  d: "M0 18.234h1.628v-3.581h.651v3.581h6.838v-.976a.3.3 0 0 1 .019-.114l.957-2.55v-2.692l-1.5-.469.192 1.553a.32.32 0 0 1-.127.3.34.34 0 0 1-.2.065.3.3 0 0 1-.119-.029l-2.152-.921-2.152.921a.3.3 0 0 1-.127.026.34.34 0 0 1-.2-.065.32.32 0 0 1-.127-.3l.192-1.553-1.719.537A2.92 2.92 0 0 0 0 14.769Z",
  "data-name": "Path 12112"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffdf47",
  d: "M9.768 17.583h8.466v.651H9.768Z",
  "data-name": "Path 12113"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffdf47",
  d: "M16.605 8.139v-.651l-.72-.179a2 2 0 0 0-.2-.472l.381-.635-.459-.459-.635.381a2 2 0 0 0-.472-.2l-.174-.715h-.651l-.179.72a2 2 0 0 0-.472.2l-.635-.381-.459.459.381.635a2 2 0 0 0-.2.472l-.72.179v.651l.72.179a2 2 0 0 0 .2.472l-.381.635.459.459.635-.381a2 2 0 0 0 .472.2l.179.72h.651l.179-.72a2 2 0 0 0 .472-.2l.635.381.459-.459-.381-.635a2 2 0 0 0 .2-.472ZM14 9.116a1.3 1.3 0 1 1 1.3-1.3 1.3 1.3 0 0 1-1.3 1.3",
  "data-name": "Path 12114"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e21118",
  d: "M9.768 4.558v1.3a.651.651 0 0 0 0-1.3",
  "data-name": "Path 12115"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e21118",
  d: "M2.605 5.858v-1.3a.651.651 0 0 0 0 1.3",
  "data-name": "Path 12116"
}));

const SvgCashieringAdvancedSearch = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: "1em",
  height: "1em",
  viewBox: "0 0 80 80"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "cashiering-advanced-search_svg__g",
  x1: 0.978,
  x2: 0.263,
  y1: 0.047,
  y2: 0.702,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.996,
  stopColor: "#ebeff2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "cashiering-advanced-search_svg__a",
  x1: 0.451,
  x2: 0.688,
  y1: -0.115,
  y2: 2.232,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#ffc444"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.996,
  stopColor: "#f36f56"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "cashiering-advanced-search_svg__h",
  x1: 0.473,
  x2: 1.052,
  y1: 0.366,
  y2: 2.183,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.004,
  stopColor: "#e38ddd"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9571f6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "cashiering-advanced-search_svg__d",
  x1: -0.012,
  x2: 1.499,
  y1: 0.026,
  y2: 1.304,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#aa80f9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.996,
  stopColor: "#6165d7"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "cashiering-advanced-search_svg__i",
  x1: -62.208,
  x2: -63,
  y1: -39.109,
  y2: -37.174,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#ff9085"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fb6fbb"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "cashiering-advanced-search_svg__b",
  x1: 21.132,
  x2: 21.312,
  y1: -2.049,
  y2: 2.987,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#311944"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#a03976"
})), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#cashiering-advanced-search_svg__a",
  id: "cashiering-advanced-search_svg__j",
  x1: 77.768,
  x2: 77.646,
  y1: 1.568,
  y2: -4.648
}), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#cashiering-advanced-search_svg__b",
  id: "cashiering-advanced-search_svg__k",
  x1: 33.191,
  x2: 33.476,
  y1: -1.267,
  y2: 1.684
}), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#cashiering-advanced-search_svg__a",
  id: "cashiering-advanced-search_svg__l",
  x1: 55.207,
  x2: 55.12,
  y1: 1.66,
  y2: -2.722
}), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#cashiering-advanced-search_svg__c",
  id: "cashiering-advanced-search_svg__m",
  x1: 11.856,
  x2: 12.857,
  y1: 0.522,
  y2: 0.522
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "cashiering-advanced-search_svg__c",
  x1: 0.974,
  x2: 0.276,
  y1: -0.105,
  y2: 0.797,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#301fe6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#181073"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "cashiering-advanced-search_svg__f",
  x1: 12.639,
  x2: 13.713,
  y1: 0.522,
  y2: 0.522,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#ab316d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#792d3d"
})), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#cashiering-advanced-search_svg__c",
  id: "cashiering-advanced-search_svg__n",
  x1: 5.859,
  x2: 6.855,
  y1: 0.524,
  y2: 0.524
}), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#cashiering-advanced-search_svg__a",
  id: "cashiering-advanced-search_svg__o",
  x1: 0.549,
  x2: 0.293,
  y1: 0.204,
  y2: 3.433
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "cashiering-advanced-search_svg__p",
  x1: 61.406,
  x2: 60.656,
  y1: 21.005,
  y2: 19.33,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#444b8c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.996,
  stopColor: "#3e4177"
})), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#cashiering-advanced-search_svg__a",
  id: "cashiering-advanced-search_svg__q",
  x1: 0.44,
  x2: 0.938,
  y1: -0.008,
  y2: 4.489
}), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#cashiering-advanced-search_svg__d",
  id: "cashiering-advanced-search_svg__r",
  x1: 0,
  x2: 1,
  y1: 0.5,
  y2: 0.5
}), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#cashiering-advanced-search_svg__a",
  id: "cashiering-advanced-search_svg__s",
  x1: 135.564,
  x2: 136.443,
  y1: -147.934,
  y2: -147.934
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "cashiering-advanced-search_svg__e",
  x2: 1,
  y1: 0.5,
  y2: 0.5,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#444b8c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.996,
  stopColor: "#26264f"
})), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#cashiering-advanced-search_svg__e",
  id: "cashiering-advanced-search_svg__t",
  x1: -38.487,
  x2: -38.99,
  y1: 7.002,
  y2: 6.458
}), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#cashiering-advanced-search_svg__e",
  id: "cashiering-advanced-search_svg__u",
  x1: -41.614,
  x2: -40.89,
  y1: 6.551,
  y2: 7.318
}), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#cashiering-advanced-search_svg__a",
  id: "cashiering-advanced-search_svg__v",
  x1: -334.03,
  x2: -333.826,
  y1: -104.429,
  y2: -106.161
}), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#cashiering-advanced-search_svg__f",
  id: "cashiering-advanced-search_svg__w",
  x1: -0.335,
  x2: 3.133,
  y1: 1.325,
  y2: -2.462
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "cashiering-advanced-search_svg__x",
  x1: -0.032,
  x2: 0.597,
  y1: 1.208,
  y2: 0.374,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fcb148"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.052,
  stopColor: "#fdb946"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.142,
  stopColor: "#fec144"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.318,
  stopColor: "#ffc444"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.485,
  stopColor: "#fdb946"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.775,
  stopColor: "#f99c4c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.866,
  stopColor: "#f8924f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f8924f"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 33492"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h80v80H0z",
  "data-name": "Rectangle 23454"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 33490"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 33469"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2829.429 401.6a12.15 12.15 0 0 1-7.213-2.188c-4.707-3.6-5.325-10.97-3.987-16.1 1.149-4.408 4.461-7.928 11.086-14.968 6.239-6.63 8.643-7.824 8.54-10.872-.146-4.345-5.179-6.315-4.589-11.41a5.62 5.62 0 0 1 1.877-3.878c2.676-2 7.342.14 9.741 1.984 2.315 1.779 5.237 5.37 4.668 9.024-.412 2.647-2.306 3.079-2.143 5.375s2.132 2.571 3.888 5.992c.7 1.367 2.11 4.111 1.469 6.946-.83 3.667-4.336 4.168-4.267 7.022.05 2.063 1.9 2.475 2.438 4.74.713 2.981-1.619 5.9-3.593 8.3-2.323 2.822-8.592 10.451-17.915 10.033",
  "data-name": "Path 31094",
  style: {
    fill: "#e21118"
  },
  transform: "translate(-2779.419 -328.648)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2870.982 354.842c-1.289 1.586 4.808 5.237 5.39 12.206.626 7.5-5.516 14.262-8.354 17.388-4.843 5.333-7.572 5.284-10.182 10.474-1.033 2.054-3.186 6.333-1.487 10.923.158.426 1.989 5.154 6.392 6.373 4.994 1.383 9.5-2.8 13.382-6.4 2.346-2.177 7.032-6.527 5.759-9.458-.778-1.792-3.6-2.641-5.693-2.52-2.981.172-4.867 2.342-5.26 1.928-.354-.373.837-2.492 2.766-4.363 3.861-3.744 6.734-2.67 9.469-5.907.332-.392 2.913-3.539 2-6.942-.525-1.963-2.227-4.061-3.918-4.006-1.914.063-2.989 2.855-3.513 2.591-.5-.252.177-2.958 1.239-5.534 1.559-3.786 2.645-4.137 2.99-6.349a9.46 9.46 0 0 0-1.727-6.574c-2.699-3.739-8.151-5.186-9.253-3.83",
  "data-name": "Path 31095",
  opacity: 0.16,
  style: {
    mixBlendMode: "screen",
    isolation: "isolate",
    fill: "#0045ff"
  },
  transform: "translate(-2813.791 -340.345)"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 33482"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 33479"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 33475"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 33472"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#d8dee8",
  d: "m50.652 10.472-36.628-1.24a1.45 1.45 0 0 0-1.518 1.449v66.537a1.41 1.41 0 0 0 1.518 1.414l36.628-2.083a1.5 1.5 0 0 0 1.37-1.5V11.942a1.456 1.456 0 0 0-1.37-1.47",
  "data-name": "Path 31098"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 33471",
  opacity: 0.3,
  style: {
    mixBlendMode: "multiply",
    isolation: "isolate"
  }
}, /*#__PURE__*/React.createElement("path", {
  fill: "#d8dee8",
  d: "M35.623 59.604c-.623-7.608 4.05-10.748 2.268-17.641-2.2-8.52-10.675-8.885-13.561-17.24-1.105-3.2-1.542-8.041 1.622-15.087l-11.93-.4a1.45 1.45 0 0 0-1.518 1.449v66.533a1.41 1.41 0 0 0 1.518 1.414l32.66-1.857c-8.308-6.434-10.676-12.495-11.059-17.171",
  "data-name": "Path 31099"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#cashiering-advanced-search_svg__g)",
  d: "m2601.892 315.921-36.628-1.2a.6.6 0 0 0-.623.6v66.458a.58.58 0 0 0 .623.581l36.628-2.041a.616.616 0 0 0 .564-.617v-63.177a.6.6 0 0 0-.564-.604",
  "data-name": "Path 31100",
  transform: "translate(-2551.24 -304.609)"
})), /*#__PURE__*/React.createElement("g", {
  fill: "#d8dee8",
  "data-name": "Group 33473"
}, /*#__PURE__*/React.createElement("path", {
  d: "m43.734 61.625-22.226.8a.99.99 0 0 0-.95.983.907.907 0 0 0 .95.912l22.226-.856a.95.95 0 0 0 .893-.953.87.87 0 0 0-.893-.886",
  "data-name": "Path 31101"
}), /*#__PURE__*/React.createElement("path", {
  d: "m43.734 64.902-22.226.9a1 1 0 0 0-.95.988.9.9 0 0 0 .95.908l22.226-.956a.955.955 0 0 0 .893-.957.863.863 0 0 0-.893-.883",
  "data-name": "Path 31102"
}), /*#__PURE__*/React.createElement("path", {
  d: "m43.734 68.181-22.226 1a1 1 0 0 0-.95.992.9.9 0 0 0 .95.9l22.226-1.055a.96.96 0 0 0 .893-.961.86.86 0 0 0-.893-.876",
  "data-name": "Path 31103"
})), /*#__PURE__*/React.createElement("g", {
  fill: "#d8dee8",
  "data-name": "Group 33474"
}, /*#__PURE__*/React.createElement("path", {
  d: "m32.209 13.974-11.18-.317a.454.454 0 0 0-.471.456.486.486 0 0 0 .471.483l11.18.3a.445.445 0 0 0 .457-.45.476.476 0 0 0-.457-.472",
  "data-name": "Path 31104"
}), /*#__PURE__*/React.createElement("path", {
  d: "m32.209 15.621-11.18-.292a.455.455 0 0 0-.471.457.484.484 0 0 0 .471.481l11.18.278a.446.446 0 0 0 .457-.451.474.474 0 0 0-.457-.473",
  "data-name": "Path 31105"
}), /*#__PURE__*/React.createElement("path", {
  d: "m32.209 17.27-11.18-.267a.457.457 0 0 0-.471.459.483.483 0 0 0 .471.48l11.18.254a.447.447 0 0 0 .457-.452.473.473 0 0 0-.457-.474",
  "data-name": "Path 31106"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 33478"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 33476"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#cashiering-advanced-search_svg__a)",
  d: "M2653.622 482.6a4.78 4.78 0 0 1 3.676-2.53l.111-6.785a11.48 11.48 0 0 0-10.2 6.925Z",
  "data-name": "Path 31107",
  transform: "translate(-2625.721 -447.627)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#cashiering-advanced-search_svg__h)",
  d: "M2709.822 599.829a4.8 4.8 0 0 1-4.665 4.006 4.7 4.7 0 0 1-1.948-.4l-3.555 5.845a11.25 11.25 0 0 0 5.5 1.314 11.55 11.55 0 0 0 11.215-10.516Z",
  "data-name": "Path 31108",
  transform: "translate(-2673.023 -561.775)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#cashiering-advanced-search_svg__d)",
  d: "m2642.285 569.472 3.566-5.85a4.83 4.83 0 0 1-1.761-3.742 5 5 0 0 1 .117-1.064l-6.416-2.381a11.7 11.7 0 0 0-.52 3.465 11.57 11.57 0 0 0 5.014 9.572",
  "data-name": "Path 31109",
  transform: "translate(-2616.752 -522.633)"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 33477"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2763.085 438.987a4.79 4.79 0 0 1 4 4.313l10.84.428v-.014a15.975 15.975 0 0 0-14.659-16Z",
  "data-name": "Path 31110",
  style: {
    fill: "#e21118"
  },
  transform: "translate(-2730.237 -406.524)"
}))), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M2587.77 364.236c-.623-7.607 4.05-10.747 2.268-17.639-2.2-8.519-10.673-8.884-13.557-17.238-1.06-3.069-1.505-7.644 1.25-14.229l-11.555-.378a.6.6 0 0 0-.623.6V381.8a.58.58 0 0 0 .623.581l31.661-1.764c-7.508-6.143-9.7-11.899-10.067-16.381",
  "data-name": "Path 31111",
  opacity: 0.35,
  style: {
    mixBlendMode: "soft-light",
    isolation: "isolate"
  },
  transform: "translate(-2552.063 -304.635)"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 33480"
}, /*#__PURE__*/React.createElement("path", {
  d: "m2452.34 391.853-23.485-.234a.96.96 0 0 1-.962-.945v-8.932a.92.92 0 0 1 .962-.912l20.445.487a.936.936 0 0 1 .91.93v7.677Z",
  "data-name": "Path 31112",
  opacity: 0.3,
  style: {
    mixBlendMode: "multiply",
    isolation: "isolate",
    fill: "#e21118"
  },
  transform: "translate(-2427.893 -364.236)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m2478.81 406.094-15.552-.3v-1.074l15.552.325Z",
  "data-name": "Path 31113",
  opacity: 0.67,
  style: {
    fill: "#e21118"
  },
  transform: "translate(-2459.792 -385.786)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m2478.81 427.906-15.552-.26v-1.071l15.552.282Z",
  "data-name": "Path 31114",
  opacity: 0.67,
  style: {
    fill: "#e21118"
  },
  transform: "translate(-2459.792 -405.499)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m2478.81 449.717-15.552-.217v-1.071l15.552.239Z",
  "data-name": "Path 31115",
  opacity: 0.67,
  style: {
    fill: "#e21118"
  },
  transform: "translate(-2459.792 -425.211)"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 33481"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#cashiering-advanced-search_svg__i)",
  d: "m2741.931 722.217 15.838-.34a.74.74 0 0 1 .746.756v7.374a.79.79 0 0 1-.746.8l-16.693.563a.756.756 0 0 1-.782-.765v-9.639Z",
  "data-name": "Path 31116",
  opacity: 0.3,
  style: {
    mixBlendMode: "multiply",
    isolation: "isolate"
  },
  transform: "translate(-2709.68 -671.037)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m33.433 57.422 12.7-.38v.891l-12.7.4Z",
  "data-name": "Path 31117",
  opacity: 0.67
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m33.433 55.609 12.7-.349v.891l-12.7.364Z",
  "data-name": "Path 31118",
  opacity: 0.67
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m33.433 53.795 12.7-.318v.891l-12.7.333Z",
  "data-name": "Path 31119",
  opacity: 0.67
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 33485"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#cashiering-advanced-search_svg__b)",
  d: "M3000.558 999.346a21 21 0 0 0-2.743 1.431c-.044.2 1.738-.07 2.465-.043s1.326-.19 1.259-.5-.323-1.082-.323-1.082Z",
  "data-name": "Path 31120",
  transform: "translate(-2941.964 -921.966)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#cashiering-advanced-search_svg__j)",
  d: "m3024.78 989.59.167 1.216a.95.95 0 0 0 .715-.029l.119-1.335Z",
  "data-name": "Path 31121",
  transform: "translate(-2966.287 -913.207)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#cashiering-advanced-search_svg__k)",
  d: "m3136.749 990.938.316.5a.6.6 0 0 1 .073.472c-.109.42-.327 1.238-.422 1.452-.13.291-1.878.467-1.878.467s-.156-.219.206-.485.6-.308.723-.7a10 10 0 0 0 .21-1.5Z",
  "data-name": "Path 31122",
  transform: "translate(-3065.529 -914.556)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#cashiering-advanced-search_svg__l)",
  d: "M3141.266 976.521a16 16 0 0 1 .681 1.795s.183.232.527-.112.156-.154.156-.154l-.069-1.677Z",
  "data-name": "Path 31123",
  transform: "translate(-3071.358 -901.419)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#cashiering-advanced-search_svg__m)",
  d: "M3008.178 725.878a132.7 132.7 0 0 0 1.424 24.885 12 12 0 0 0 1.177-.024 30 30 0 0 0 .994-3.2 31 31 0 0 0 .69-3.751c.511-4.112-.1-4.469.315-7.517.368-2.7.9-2.806 1.515-6.638.667-4.158.162-4.781-.084-5.005-1.052-.962-3.503-.304-6.031 1.25",
  "data-name": "Path 31124",
  transform: "translate(-2951.231 -673.937)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#cashiering-advanced-search_svg__f)",
  d: "M3018.251 724.627c-1-.912-3.274-.353-5.677 1.049 2.775 2.983 3.081 4.922 2.752 6.181-.372 1.423-1.51 1.836-1.5 3.391.01 1.911 1.736 2.413 1.7 4.436-.021 1.337-.779 1.325-.954 2.978-.207 1.955.785 2.626.468 4.073a3.91 3.91 0 0 1-1.648 2.276q.123.892.254 1.758.331.01.7 0 .246-.007.477-.024a30 30 0 0 0 .994-3.2 31 31 0 0 0 .69-3.751c.51-4.112-.1-4.469.315-7.517.368-2.7.9-2.806 1.514-6.638.664-4.165.164-4.787-.085-5.012",
  "data-name": "Path 31125",
  opacity: 0.3,
  style: {
    mixBlendMode: "multiply",
    isolation: "isolate"
  },
  transform: "translate(-2955.278 -673.942)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#cashiering-advanced-search_svg__n)",
  d: "M3026.5 722.19a81.5 81.5 0 0 1 11.23 23.886 1.46 1.46 0 0 0 .8.122 1.5 1.5 0 0 0 .9-.49 23.5 23.5 0 0 0 .193-5.788 20 20 0 0 0-.824-4.348c-.663-2.12-1.115-2.238-1.979-4.481-.9-2.328-.682-2.91-1.542-5.823a38.5 38.5 0 0 0-1.917-5.108Z",
  "data-name": "Path 31126",
  transform: "translate(-2967.837 -670.314)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#faf8ff",
  d: "M48.947 46.965c.022.847 1.415 1.593 2.536 1.822 2.621.535 5.659-1.369 7.1-3.476.283-.414.6-.915.674-.876.171.088-1.4 2.676-2.087 5.62-.35 1.506-.258 2.211-.911 3.214-.148.227-.331.464-.267.732.161.673 1.7.848 2.767.969a25 25 0 0 0 3.218.1c1.663-.024 1.794-.111 2.174.076 1.157.568 1.079 1.928 1.95 2.11.731.152 1.473-.664 1.708-.923 1.222-1.346 1.157-2.968 1.374-4.6a24.35 24.35 0 0 1 4.593-10.611c.613-.8 1.04-1.221 1.066-1.965.078-2.183-3.38-4.593-6.26-4.87a21.6 21.6 0 0 0-3.527.073c-.53.05-1.093.123-1.7.229a14 14 0 0 0-3.536.913c-4.2 1.924-3.287 6.206-7.837 9.166-1.564 1.015-3.059 1.41-3.035 2.297",
  "data-name": "Path 31127"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#cashiering-advanced-search_svg__o)",
  d: "M3079.8 538.244a6.3 6.3 0 0 0 .6 1.725c.375.648 1.929.881 2.252.994s-.488.676-1.351.881a10.7 10.7 0 0 1-3.883.066c-.495-.272.321-.355.915-.667a2.15 2.15 0 0 0 .609-2.121c-.184-.541.858-.878.858-.878",
  "data-name": "Path 31128",
  transform: "translate(-3013.629 -506.225)"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 33483"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#cashiering-advanced-search_svg__p)",
  d: "M3080.632 517.221c-.626-.448-.8-1.658-.452-1.93.1-.078.194-.042 1.608.525.7.282 1.047.432 1.161.742a1 1 0 0 1-.019.646 2.5 2.5 0 0 1-.288.479c-.152.219-.142.211-.188.275a3.5 3.5 0 0 1-.723.707 2.4 2.4 0 0 0-.115-.4 2.1 2.1 0 0 0-.256-.476 2.4 2.4 0 0 0-.728-.568",
  "data-name": "Path 31129",
  transform: "translate(-3016.099 -485.493)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#cashiering-advanced-search_svg__q)",
  d: "M3086.866 533.352a1.3 1.3 0 0 1-1.169.528c-.679-.074-.713-1.607-.263-1.913a.86.86 0 0 1 .677-.057c.138.045.183.105.41.175.209.064.27.043.332.1.077.071.128.238-.025.679a.37.37 0 0 1 .4-.113.23.23 0 0 1 .087.092c.085.18-.08.396-.449.509",
  "data-name": "Path 31130",
  transform: "translate(-3020.727 -500.473)"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#cashiering-advanced-search_svg__r)",
  d: "M2934.847 649.609c1.9-.428 2.658-.414 3.6-1.171 1.564-1.26 1.8-3.179 2.708-3.156.43.011.778.45 1.027.88l-.687 1.075c0-.014 0-.024-.012-.028-.076-.039-.391.463-.673.876-1.442 2.106-4.48 4.01-7.1 3.476a4.56 4.56 0 0 1-2.124-1.033 33 33 0 0 1 3.261-.919",
  "data-name": "Path 31131",
  opacity: 0.3,
  style: {
    mixBlendMode: "multiply",
    isolation: "isolate"
  },
  transform: "translate(-2882.223 -602.774)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#cashiering-advanced-search_svg__s)",
  d: "M2908.376 701.757a7.3 7.3 0 0 1-1.711-.38c-.639-.273-1.052.119-.993.391s1.11.65 1.53.664 1.174-.675 1.174-.675",
  "data-name": "Path 31132",
  transform: "translate(-2858.846 -653.288)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M72.621 54.141a7.34 7.34 0 0 0 5.575-1.546c3.051-2.822 1.538-8.2.475-10.506a13.15 13.15 0 0 0-4.333-5.033c-1.461-1.118-2.353-1.8-3.426-1.648-2.775.4-4.7 6.082-3.173 7.711.5.533.993.231 2.436.691.47.15 3.978 1.267 4.589 3.851.427 1.808-.661 3.926-2.6 5.348Z",
  "data-name": "Path 31133"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#cashiering-advanced-search_svg__r)",
  d: "M3003.958 640.556c1.3-.823 1.5-1.658 2.956-2.222 1.9-.733 2.807.2 3.747-.553 1.119-.894.128-2.452.966-5.156.142-.459 1.221-3.945 3.7-4.389a3.34 3.34 0 0 1 3.267 1.214c.46.766.032 1.337.591 2.182s1.227.638 1.939 1.343a3.99 3.99 0 0 1 .283 4.812 4.7 4.7 0 0 1-2.26 1.331 11 11 0 0 1-1.942.57 5.13 5.13 0 0 0 1.8-4.676 5.4 5.4 0 0 0-3.082-3.243 22.5 22.5 0 0 0-2.5 7.313c-.217 1.636-.151 3.259-1.374 4.6-.235.259-.977 1.075-1.708.923-.871-.181-.792-1.542-1.949-2.11-.38-.186-.511-.1-2.174-.076a25 25 0 0 1-3.217-.1c-.95-.108-2.27-.259-2.664-.764a6.94 6.94 0 0 0 3.621-.999",
  "data-name": "Path 31134",
  opacity: 0.3,
  style: {
    mixBlendMode: "multiply",
    isolation: "isolate"
  },
  transform: "translate(-2944.239 -587.353)"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 33484"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#cashiering-advanced-search_svg__e)",
  d: "m2914.643 684.676.134-.395a1.17 1.17 0 0 0-.785-1.5l-25.367-7.727-.773 2.62 25.239 7.774a1.25 1.25 0 0 0 1.552-.772",
  "data-name": "Path 31135",
  transform: "translate(-2842.778 -629.631)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#cashiering-advanced-search_svg__e)",
  d: "M2634.321 504.6a13.72 13.72 0 0 1 17.056-10.116 14.66 14.66 0 0 1 9.711 18.315 13.69 13.69 0 0 1-17.326 9.4 14.72 14.72 0 0 1-9.441-17.599m24.559 7.523a12.316 12.316 0 0 0-8.137-15.332 11.52 11.52 0 0 0-14.342 8.446 12.36 12.36 0 0 0 7.947 14.825 11.5 11.5 0 0 0 14.532-7.941Z",
  "data-name": "Path 31136",
  transform: "translate(-2613.681 -466.27)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#d8dee8",
  d: "m2888.625 675.057 3.235.985a3.36 3.36 0 0 0 1.088 1.983c1.634 1.354 3.815-.123 6.859 1.465 1.527.8 1.237 1.3 2.669 1.86 2.367.919 3.45-.354 5.545.483 2.119.846 2.327 2.675 3.529 2.61.514-.028 1.176-.4 1.913-1.82l.531.162a1.17 1.17 0 0 1 .785 1.5l-.134.395a1.25 1.25 0 0 1-1.552.775l-25.239-7.774Z",
  "data-name": "Path 31137",
  opacity: 0.3,
  style: {
    mixBlendMode: "multiply",
    isolation: "isolate"
  },
  transform: "translate(-2842.778 -629.631)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M30.068 54.841a11.9 11.9 0 0 0 15.042-8.207 12.744 12.744 0 0 0-8.424-15.876 11.92 11.92 0 0 0-14.838 8.75 12.79 12.79 0 0 0 8.22 15.333",
  "data-name": "Path 31138",
  opacity: 0.56
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#cashiering-advanced-search_svg__t)",
  d: "M2629.307 511.3a13.72 13.72 0 0 1 17.056-10.116 14.66 14.66 0 0 1 9.711 18.315 13.693 13.693 0 0 1-17.327 9.4 14.72 14.72 0 0 1-9.44-17.599m24.559 7.523a12.315 12.315 0 0 0-8.137-15.332 11.52 11.52 0 0 0-14.342 8.446 12.36 12.36 0 0 0 7.947 14.825 11.5 11.5 0 0 0 14.532-7.935Z",
  "data-name": "Path 31139",
  transform: "translate(-2609.159 -472.318)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#cashiering-advanced-search_svg__u)",
  d: "M2637 519.3a12.94 12.94 0 0 1 16.1-9.523 13.83 13.83 0 0 1 9.154 17.258 12.916 12.916 0 0 1-16.337 8.884A13.885 13.885 0 0 1 2637 519.3m23.825 7.3a12.316 12.316 0 0 0-8.137-15.332 11.52 11.52 0 0 0-14.341 8.446 12.36 12.36 0 0 0 7.946 14.825 11.5 11.5 0 0 0 14.535-7.939Z",
  "data-name": "Path 31140",
  transform: "translate(-2616.121 -480.093)"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#cashiering-advanced-search_svg__v)",
  d: "m3144.21 752.175-.257-.637a1.3 1.3 0 0 1-.762-.221 1 1 0 0 0-.616-.147c-.1.027-.461.011-.046.209s.413.345.239.508a3 3 0 0 1-1.069.529c-.237.017.192.384.431.431a1.48 1.48 0 0 0 1.117-.18c.178-.104.963-.492.963-.492",
  "data-name": "Path 31141",
  transform: "translate(-3071.687 -698.277)"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 33489"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#cashiering-advanced-search_svg__w)",
  d: "m2866.774 216.811-17.1-1.048a2.16 2.16 0 0 0-2.278 2.192v15.97a2.32 2.32 0 0 0 2.278 2.331l.951.009v3.935c0 .589.7.877 1.276.225l3.576-4.112 11.293.034a1.99 1.99 0 0 0 1.909-2.087v-15.245a2.143 2.143 0 0 0-1.905-2.204",
  "data-name": "Path 31142",
  transform: "translate(-2841.118 -163.542)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#cashiering-advanced-search_svg__x)",
  d: "m2872.3 232.1-17.1-.089a2.32 2.32 0 0 1-2.278-2.331v-15.974a2.16 2.16 0 0 1 2.278-2.192l17.1 1.048a2.143 2.143 0 0 1 1.909 2.2v15.244a1.99 1.99 0 0 1-1.909 2.094",
  "data-name": "Path 31143",
  transform: "translate(-2846.105 -159.708)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2859.57 235.955v-16.79a1.15 1.15 0 0 1 1.213-1.168l17.859 1.034a1.14 1.14 0 0 1 1.017 1.174v16.031a1.06 1.06 0 0 1-1.017 1.112l-17.858-.15a1.24 1.24 0 0 1-1.214-1.243",
  "data-name": "Path 31144",
  style: {
    fill: "#e21118"
  },
  transform: "translate(-2852.094 -165.557)"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 33488"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 33487"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 33486"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M18.956 64.361a1.1 1.1 0 0 0-.22-.724 2.1 2.1 0 0 0-.768-.515q-.551-.248-1.02-.5a3.7 3.7 0 0 1-.807-.578 2.3 2.3 0 0 1-.521-.745 2.5 2.5 0 0 1-.182-1.01 2.1 2.1 0 0 1 .646-1.6 2.62 2.62 0 0 1 1.716-.675v-1.225l.893.038v1.246a2.6 2.6 0 0 1 1.605.933 2.86 2.86 0 0 1 .58 1.831l-1.883-.064a1.66 1.66 0 0 0-.224-.935.76.76 0 0 0-.64-.348.69.69 0 0 0-.575.22.97.97 0 0 0-.206.658 1 1 0 0 0 .237.691 2.4 2.4 0 0 0 .759.507q.52.246.983.506a4 4 0 0 1 .795.582 2.4 2.4 0 0 1 .523.743 2.4 2.4 0 0 1 .189 1 2.17 2.17 0 0 1-.6 1.6 2.5 2.5 0 0 1-1.65.693v1.171l-.893-.017v-1.173a2.9 2.9 0 0 1-1.89-.912 2.87 2.87 0 0 1-.661-1.963l1.909.052a1.6 1.6 0 0 0 .285 1.016 1.01 1.01 0 0 0 .807.366.76.76 0 0 0 .6-.22.9.9 0 0 0 .213-.649",
  "data-name": "Path 31145"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M24.184 55.961a.2.2 0 0 1 .18.2v12.72a.18.18 0 0 1-.18.185l-12.48-.207a.2.2 0 0 1-.19-.2V55.593a.18.18 0 0 1 .19-.185Zm0-.721-12.48-.573a.877.877 0 0 0-.917.893v13.086a.944.944 0 0 0 .917.949l12.48.188a.87.87 0 0 0 .867-.895v-12.7a.94.94 0 0 0-.867-.948",
  "data-name": "Path 31146"
}))), /*#__PURE__*/React.createElement("path", {
  d: "M2885.876 417.249v-4.742l5.542.062-4.442 5.105a.628.628 0 0 1-1.1-.425",
  "data-name": "Path 31147",
  style: {
    fill: "#e21118"
  },
  transform: "translate(-2875.822 -341.008)"
})))));

const SvgCashieringBusinessInsight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 21.801 21.5"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 49757"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h21.5v21.5H0z",
  "data-name": "Rectangle 13489"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 13655"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#ffdf47",
  d: "M21.702 2.329a.38.38 0 0 0-.357-.145l-2.763.447a.2.2 0 0 0-.135.089.25.25 0 0 0-.039.168l.06.45a.21.21 0 0 0 .234.191l1.264-.217-8.719 6.88-3.583-2.583L0 14.331v1.16l7.71-6.763 3.556 2.565 9.358-7.384-.364 1.41a.25.25 0 0 0 .018.173.2.2 0 0 0 .123.108l.4.124a.2.2 0 0 0 .056.009.21.21 0 0 0 .2-.165l.733-2.829a.47.47 0 0 0-.088-.41",
  "data-name": "Path 24159"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#e21118",
  "data-name": "Group 13654"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.238 19.356h1.888v-5.545l-1.888-1.362Z",
  "data-name": "Path 24160"
}), /*#__PURE__*/React.createElement("path", {
  d: "m18.317 8.334-1.749 1.38v9.642h1.749Z",
  "data-name": "Path 24161"
}), /*#__PURE__*/React.createElement("path", {
  d: "m16.013 10.152-1.888 1.49v7.714h1.888Z",
  "data-name": "Path 24162"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.795 19.356h1.888v-7.307l-1-.718-.893.782Z",
  "data-name": "Path 24163"
}), /*#__PURE__*/React.createElement("path", {
  d: "m13.569 12.08-1.888 1.49v5.786h1.888Z",
  "data-name": "Path 24164"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.354 16.884.002 18.069v1.287h1.352Z",
  "data-name": "Path 24165"
}), /*#__PURE__*/React.createElement("path", {
  d: "m6.239 12.6-1.888 1.655v5.1h1.888Z",
  "data-name": "Path 24166"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.873 7.893v11.463h1.786V6.486Z",
  "data-name": "Path 24167"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.908 19.357h1.888v-4.614l-1.888 1.655Z",
  "data-name": "Path 24168"
})))));

const SvgCashieringCancellationReason = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "2.69 1.029 26 30.205"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cashiering-cancellation-reason_svg__cls-5{fill:#1f4254}")), /*#__PURE__*/React.createElement("g", {
  id: "cashiering-cancellation-reason_svg__Group_50397",
  "data-name": "Group 50397",
  transform: "translate(9064 -23237)"
}, /*#__PURE__*/React.createElement("g", {
  id: "cashiering-cancellation-reason_svg__file",
  transform: "matrix(1.6624 0 0 1.6624 -9061.31 23238.03)"
}, /*#__PURE__*/React.createElement("path", {
  id: "cashiering-cancellation-reason_svg__Path_64964",
  d: "M97.585 57.7a1.384 1.384 0 0 0-1.38-1.38h-10.35a1.384 1.384 0 0 0-1.38 1.38v12.88a1.384 1.384 0 0 0 1.38 1.38h7.819l3.91-3.68Z",
  "data-name": "Path 64964",
  style: {
    fill: "#dadee0"
  },
  transform: "translate(-81.945 -53.79)"
}), /*#__PURE__*/React.createElement("path", {
  id: "cashiering-cancellation-reason_svg__Path_64965",
  d: "M30.685 3.91a1.384 1.384 0 0 1 1.38-1.38h9.2V1.38A1.384 1.384 0 0 0 39.885 0h-10.35a1.384 1.384 0 0 0-1.38 1.38v12.88a1.384 1.384 0 0 0 1.38 1.38h1.15Z",
  "data-name": "Path 64965",
  style: {
    fill: "#e21118"
  },
  transform: "translate(-28.155)"
}), /*#__PURE__*/React.createElement("path", {
  id: "cashiering-cancellation-reason_svg__Path_64966",
  d: "M290.645 322.56h2.53l-3.91 3.68v-2.3a1.384 1.384 0 0 1 1.38-1.38",
  "data-name": "Path 64966",
  style: {
    fill: "#f2f2f2"
  },
  transform: "translate(-277.535 -308.07)"
}), /*#__PURE__*/React.createElement("g", {
  id: "cashiering-cancellation-reason_svg__Group_50324",
  "data-name": "Group 50324",
  transform: "translate(5.635 5.635)"
}, /*#__PURE__*/React.createElement("path", {
  id: "cashiering-cancellation-reason_svg__Path_64967",
  d: "M153.94 177.33h6.21a.345.345 0 1 0 0-.69h-6.21a.345.345 0 1 0 0 .69",
  className: "cashiering-cancellation-reason_svg__cls-5",
  "data-name": "Path 64967",
  transform: "translate(-153.595 -174.34)"
}), /*#__PURE__*/React.createElement("path", {
  id: "cashiering-cancellation-reason_svg__Path_64968",
  d: "M153.94 126.13h6.21a.345.345 0 1 0 0-.69h-6.21a.345.345 0 1 0 0 .69",
  className: "cashiering-cancellation-reason_svg__cls-5",
  "data-name": "Path 64968",
  transform: "translate(-153.595 -125.44)"
}), /*#__PURE__*/React.createElement("path", {
  id: "cashiering-cancellation-reason_svg__Path_64969",
  d: "M153.94 228.53h6.21a.345.345 0 1 0 0-.69h-6.21a.345.345 0 1 0 0 .69",
  className: "cashiering-cancellation-reason_svg__cls-5",
  "data-name": "Path 64969",
  transform: "translate(-153.595 -223.24)"
}), /*#__PURE__*/React.createElement("path", {
  id: "cashiering-cancellation-reason_svg__Path_64970",
  d: "M153.94 279.73h3.45a.345.345 0 0 0 0-.69h-3.45a.345.345 0 1 0 0 .69",
  className: "cashiering-cancellation-reason_svg__cls-5",
  "data-name": "Path 64970",
  transform: "translate(-153.595 -272.14)"
})))));

const SvgCashieringCancellation = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 29.738 37.172"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#E21118",
  d: "M17.889 3.842H4.76a1.26 1.26 0 0 0-1.278 1.233v30.867a1.26 1.26 0 0 0 1.278 1.232h23.7a1.26 1.26 0 0 0 1.277-1.232V5.074a1.26 1.26 0 0 0-1.277-1.233Z",
  "data-name": "Path 68592"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M27.288 35.322H6.251a.57.57 0 0 1-.577-.562V6.205a.57.57 0 0 1 .577-.562h21.036a.57.57 0 0 1 .577.562v28.559a.57.57 0 0 1-.577.562",
  "data-name": "Path 68593"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E21100",
  d: "M18.867 2.213a2.221 2.221 0 0 0-4.443 0H9.559V6.96h14.173V2.213Z",
  "data-name": "Path 68594"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M17.594 2.286a.964.964 0 1 1-.964-.964.964.964 0 0 1 .964.964",
  "data-name": "Path 68595"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E21118",
  d: "M9.56 5.643h14.173V6.96H9.56z",
  "data-name": "Rectangle 26102"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M15.508 9.369h3.432v.648h-3.432z",
  "data-name": "Rectangle 26103"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M15.566 10.974h9.571v.648h-9.571z",
  "data-name": "Rectangle 26104"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M15.566 12.537h9.571v.648h-9.571z",
  "data-name": "Rectangle 26105"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M15.566 14.099h9.571v.648h-9.571z",
  "data-name": "Rectangle 26106"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M15.566 20.189h9.571v.648h-9.571z",
  "data-name": "Rectangle 26107"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M15.566 21.751h9.571v.648h-9.571z",
  "data-name": "Rectangle 26108"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M15.566 23.314h9.571v.648h-9.571z",
  "data-name": "Rectangle 26109"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M15.566 29.378h9.571v.648h-9.571z",
  "data-name": "Rectangle 26110"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M15.566 30.818h9.571v.648h-9.571z",
  "data-name": "Rectangle 26111"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M15.566 32.415h9.571v.648h-9.571z",
  "data-name": "Rectangle 26112"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M15.508 18.572h3.432v.648h-3.432z",
  "data-name": "Rectangle 26113"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M15.508 27.775h3.432v.648h-3.432z",
  "data-name": "Rectangle 26114"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffcb00",
  d: "M13.821 12.079a2.74 2.74 0 1 1-2.74-2.74 2.74 2.74 0 0 1 2.74 2.74",
  "data-name": "Path 68596"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M10.79 13.557 9.216 12.05l.588-.614.96.919 1.574-1.642.614.588Z",
  "data-name": "Path 68597"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4ad395",
  d: "M13.821 30.246a2.74 2.74 0 1 1-2.74-2.74 2.74 2.74 0 0 1 2.74 2.74",
  "data-name": "Path 68598"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M10.79 31.737 9.216 30.23l.588-.614.96.919 1.574-1.642.614.588Z",
  "data-name": "Path 68599"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4fabf7",
  d: "M15.652 26.151a6.939 6.939 0 1 0-9.812-.157 6.94 6.94 0 0 0 9.812.157",
  "data-name": "Path 68600"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M10.827 26.654a5.479 5.479 0 1 1 5.566-5.391 5.48 5.48 0 0 1-5.566 5.391",
  "data-name": "Path 68601"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#434b56",
  d: "M5.838 25.899a7 7 0 0 1-.7-.86L3.981 26.16l1.712 1.767 1.185-1.148a7 7 0 0 1-1.04-.88",
  "data-name": "Path 68602"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4fabf7",
  d: "m2.084 31.206 3.608-3.494-1.711-1.767-3.606 3.494a1.23 1.23 0 0 0 1.711 1.767",
  "data-name": "Path 68603"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ff5163",
  d: "M15.237 21.186a4.314 4.314 0 1 1-4.314-4.314 4.314 4.314 0 0 1 4.314 4.314",
  "data-name": "Path 68604"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m10.466 23.535-2.478-2.372.926-.967 1.511 1.446 2.478-2.584.967.926Z",
  "data-name": "Path 68605"
}));

const SvgCashieringLogout = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 20 20"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#e21118",
  d: "M12.212 10.833a.824.824 0 0 0-.814.833v3.33a.825.825 0 0 1-.814.833H8.141V3.333a1.68 1.68 0 0 0-1.109-1.584l-.241-.083h3.792a.825.825 0 0 1 .817.83v2.5a.814.814 0 1 0 1.628 0v-2.5a2.475 2.475 0 0 0-2.444-2.5H1.832a1 1 0 0 0-.087.018c-.04.001-.077-.018-.117-.018A1.65 1.65 0 0 0 0 1.666v15a1.68 1.68 0 0 0 1.109 1.584l4.9 1.672a1.636 1.636 0 0 0 2.133-1.589v-.837h2.442a2.475 2.475 0 0 0 2.442-2.5v-3.33a.824.824 0 0 0-.814-.833m0 0",
  "data-name": "Path 11536"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffdf47",
  d: "m19.737 7.791-3.59-3.59a.9.9 0 0 0-1.532.634v2.692h-3.59a.9.9 0 1 0 0 1.795h3.59v2.692a.9.9 0 0 0 1.532.635l3.59-3.59a.9.9 0 0 0 0-1.268m0 0",
  "data-name": "Path 11537"
}));

const SvgCashieringManager = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 15 15"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 48624"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 33532"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M2 2h12v12H2z",
  "data-name": "Rectangle 21199"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 29060"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 29056"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 29055"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#e21118",
  d: "M6.561 2.27a2.8 2.8 0 1 0 2.8 2.8 2.806 2.806 0 0 0-2.8-2.8",
  "data-name": "Path 30939"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 29058"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 29057"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#e21118",
  d: "M13.229 8.989q-.008-.2-.006-.394a.18.18 0 0 0-.184-.184 2.47 2.47 0 0 1-1.838-.695.19.19 0 0 0-.258 0 2.47 2.47 0 0 1-1.838.695.18.18 0 0 0-.184.184q.002.192-.006.394c-.025 1.291-.062 3.062 2.1 3.806l.061.012.061-.012c2.142-.744 2.112-2.509 2.092-3.806m-2.306 1.789a.2.2 0 0 1-.129.049h-.006a.17.17 0 0 1-.129-.062l-.572-.633.277-.246.449.5 1-.947.252.271Z",
  "data-name": "Path 30940"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 29059"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#e21118",
  d: "M10.777 12.898c-2.158-.744-2.121-2.515-2.1-3.806 0-.1.006-.2.006-.3a4 4 0 0 0-1.5-.292H5.94a4 4 0 0 0-2.864 1.208 4.09 4.09 0 0 0-1.184 2.88.31.31 0 0 0 .311.311h8.573Z",
  "data-name": "Path 30941"
}))))));

const SvgCashieringRoles = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 30 30"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#e21118",
  d: "M26.978 12.332a11.93 11.93 0 0 0-8.032-7.889 3.51 3.51 0 0 0-6.933-.017h-1.542v-.492a4.007 4.007 0 0 0-8.012 0v3.388a6.3 6.3 0 0 0 2-.6V3.934a2.003 2.003 0 0 1 4.006 0v2.792a6.3 6.3 0 0 0 2 .6V5.41h1.542a3.51 3.51 0 0 0 6.921.058 10.95 10.95 0 0 1 7 6.876 3.429 3.429 0 0 0 0 6.789 10.95 10.95 0 0 1-7 6.876 3.51 3.51 0 0 0-6.921.058H6.465v.984h5.548a3.51 3.51 0 0 0 6.933-.017 11.93 11.93 0 0 0 8.032-7.889 3.43 3.43 0 0 0 0-6.811Zm-12-5.735-1.356-1.331.708-.7.647.636 1.649-1.62.708.7Zm0 21.639-1.356-1.331.708-.7.647.636 1.649-1.62.708.7Zm11.016-10.82-1.355-1.331.708-.7.647.636 1.649-1.62.708.7Z",
  "data-name": "Path 11974"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e21118",
  d: "M4.426 26.066h.984v.984h-.984Z",
  "data-name": "Path 11975"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e21118",
  d: "M2.459 26.066h.984v.984h-.984Z",
  "data-name": "Path 11976"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e21118",
  d: "M7.227 20.024c2.565-.892 5.56-2.421 5.56-3.795 0-2.023-1.424-6.6-1.833-7.871a7.15 7.15 0 0 1-4.56-1.783 7.15 7.15 0 0 1-4.56 1.783C1.424 9.631 0 14.205 0 16.229c0 1.374 3 2.9 5.56 3.795a2.57 2.57 0 0 0 1.666 0Zm4.573-3.919-.984.03a8 8 0 0 0-.1-.915l.971-.155a9 9 0 0 1 .113 1.04m-.3-2.032-.962.2c-.063-.3-.136-.62-.214-.944l.956-.232q.127.507.22.976m-.725-2.9q.135.478.26.959l-.952.248a50 50 0 0 0-.256-.941ZM5.41 16.721v-2.732a1.967 1.967 0 1 1 1.967 0v2.732Z",
  "data-name": "Path 11979"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#ffdf47",
  "data-name": "Group 10858"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.501 21.147c.529 0 1.092-.751 1.48-1.967h-2.96c.43 1.353 1.03 1.967 1.48 1.967",
  "data-name": "Path 11977"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.501 10.328c-.45 0-1.051.614-1.48 1.967h2.961c-.389-1.216-.951-1.967-1.481-1.967",
  "data-name": "Path 11978"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.955 15.246h3.5a12 12 0 0 0-.223-1.967H13.6c.155.7.281 1.372.355 1.967",
  "data-name": "Path 11980"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.454 16.23h-3.433a2.8 2.8 0 0 1-1.027 1.967h4.233a12 12 0 0 0 .227-1.967",
  "data-name": "Path 11981"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.64 19.18q-.115.07-.232.139a5.44 5.44 0 0 0 2.215 1.504 6.8 6.8 0 0 1-.682-1.643Z",
  "data-name": "Path 11982"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.381 10.651a6.8 6.8 0 0 1 .686 1.641h1.659a5.43 5.43 0 0 0-2.345-1.641",
  "data-name": "Path 11983"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.165 11.656a6 6 0 0 1 .464-.99 6 6 0 0 0-.653.288q.1.345.189.7Z",
  "data-name": "Path 11984"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.388 13.279h-2.073a13.5 13.5 0 0 1 .2 1.967h2.445a5.4 5.4 0 0 0-.572-1.967",
  "data-name": "Path 11985"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.96 16.23h-2.445a13.5 13.5 0 0 1-.2 1.967h2.073a5.4 5.4 0 0 0 .572-1.967",
  "data-name": "Path 11986"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.725 19.18h-1.658a6.8 6.8 0 0 1-.684 1.643 5.43 5.43 0 0 0 2.342-1.643",
  "data-name": "Path 11987"
})));

const SvgCashieringStationSettings = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 20.05 19.846"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#e21118",
  d: "M1.316 7.244a5 5 0 0 0 .437 1.037l-.527.665a.545.545 0 0 0 .041.723l.908.908a.543.543 0 0 0 .723.041l.66-.523a4.8 4.8 0 0 0 1.078.456l.1.85a.544.544 0 0 0 .54.482h1.282a.544.544 0 0 0 .54-.482l.095-.819a4.9 4.9 0 0 0 1.155-.467l.639.505a.545.545 0 0 0 .723-.041l.908-.908a.543.543 0 0 0 .041-.723l-.5-.63a4.7 4.7 0 0 0 .475-1.136l.766-.088a.544.544 0 0 0 .482-.54V5.27a.544.544 0 0 0-.482-.54l-.755-.088a4.8 4.8 0 0 0-.456-1.123l.465-.587a.545.545 0 0 0-.041-.723l-.904-.906a.543.543 0 0 0-.723-.04l-.57.452a4.8 4.8 0 0 0-1.181-.495L7.149.482A.544.544 0 0 0 6.609 0H5.326a.544.544 0 0 0-.54.482l-.087.738a4.8 4.8 0 0 0-1.211.512l-.589-.469a.545.545 0 0 0-.723.041l-.908.908a.543.543 0 0 0-.041.723l.495.626a4.7 4.7 0 0 0-.449 1.132l-.792.09a.544.544 0 0 0-.482.54v1.284a.544.544 0 0 0 .482.54ZM5.969 3.77a2.123 2.123 0 1 1-2.123 2.123A2.126 2.126 0 0 1 5.969 3.77",
  "data-name": "Path 11039"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffdf47",
  d: "m18.658 7.56-.677-.572a.536.536 0 0 0-.714.019l-.374.351a3.9 3.9 0 0 0-1-.323l-.105-.516a.54.54 0 0 0-.572-.43l-.884.075a.54.54 0 0 0-.493.518l-.017.525a3.9 3.9 0 0 0-.953.5l-.447-.3a.537.537 0 0 0-.708.1l-.572.682a.536.536 0 0 0 .019.714l.391.417a4 4 0 0 0-.288.955l-.559.114a.54.54 0 0 0-.43.572l.075.884a.54.54 0 0 0 .518.493l.6.019a4 4 0 0 0 .428.817l-.338.51a.537.537 0 0 0 .1.708l.677.572a.536.536 0 0 0 .714-.019l.443-.415a4 4 0 0 0 .91.3l.123.607a.54.54 0 0 0 .572.43l.884-.075a.54.54 0 0 0 .493-.518l.019-.594a4 4 0 0 0 .91-.46l.488.323a.537.537 0 0 0 .708-.1l.572-.678a.536.536 0 0 0-.019-.714l-.394-.417a3.9 3.9 0 0 0 .31-.959l.538-.11a.54.54 0 0 0 .43-.572l-.075-.884a.54.54 0 0 0-.518-.493l-.54-.017a4 4 0 0 0-.449-.886l.295-.443a.535.535 0 0 0-.091-.71m-3.332 5.11a1.738 1.738 0 1 1 1.585-1.878 1.74 1.74 0 0 1-1.58 1.878Z",
  "data-name": "Path 11040"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e21118",
  d: "M4.409 15.05a.537.537 0 0 0-.482.529l-.006.544a.536.536 0 0 0 .469.54l.4.052a3 3 0 0 0 .284.695l-.258.318a.536.536 0 0 0 .032.714l.381.389a.537.537 0 0 0 .714.049l.32-.247a3.1 3.1 0 0 0 .714.312l.043.413a.537.537 0 0 0 .529.482l.544.007a.536.536 0 0 0 .54-.469l.049-.391a3.2 3.2 0 0 0 .774-.3l.3.243a.536.536 0 0 0 .714-.032l.389-.381a.537.537 0 0 0 .049-.714l-.23-.3a3.1 3.1 0 0 0 .327-.753l.357-.037a.537.537 0 0 0 .482-.529l.006-.544a.536.536 0 0 0-.469-.54l-.348-.045a3.2 3.2 0 0 0-.295-.753l.217-.267a.536.536 0 0 0-.032-.714l-.381-.389a.537.537 0 0 0-.714-.049l-.26.2a3.2 3.2 0 0 0-.783-.34l-.034-.338a.537.537 0 0 0-.529-.482l-.544-.006a.536.536 0 0 0-.54.469l-.043.336a3.3 3.3 0 0 0-.811.331l-.269-.219a.536.536 0 0 0-.714.032l-.391.383a.537.537 0 0 0-.049.714l.23.3a3.2 3.2 0 0 0-.308.753Zm3.512-.615a1.415 1.415 0 1 1-1.432 1.4 1.416 1.416 0 0 1 1.435-1.4Z",
  "data-name": "Path 11041"
}));

const SvgCashieringUser = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  "data-name": "user (2)",
  viewBox: "0 0 30 30"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#ffdf47",
  d: "M15 4.706c2.416 0 4.375 2.239 4.375 5s-1.959 5-4.375 5-4.375-2.239-4.375-5 1.959-5 4.375-5",
  "data-name": "Path 81476"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e21118",
  d: "M15 0a15 15 0 1 0 15 15A15 15 0 0 0 15 0m0 3.516a6.152 6.152 0 1 1-6.152 6.152A6.16 6.16 0 0 1 15 3.516m9.988 17.156a11.487 11.487 0 0 1-19.975 0l-.313-.546.417-.471a6.16 6.16 0 0 1 4.608-2.077h10.548a6.16 6.16 0 0 1 4.608 2.077l.417.471Z",
  "data-name": "Path 12071"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffdf47",
  d: "M9.914 19.159a4.06 4.06 0 0 0-2.735 1.081 9.012 9.012 0 0 0 15.642 0 4.06 4.06 0 0 0-2.734-1.081Z",
  "data-name": "Path 12072"
}));

const SvgChangePasswordContrast = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 30 30"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 61718"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#685e68",
  d: "M20.362 12.042H17.79V8.396a2.789 2.789 0 0 0-5.577 0v3.647H9.639V8.396a5.363 5.363 0 1 1 10.725 0Z",
  "data-name": "Path 75938"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#554e56",
  d: "M15.792 3.089a5.37 5.37 0 0 0-4.58 5.306v3.647H9.641V8.396a5.37 5.37 0 0 1 5.363-5.363 5.5 5.5 0 0 1 .788.056",
  "data-name": "Path 75939"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ff4755",
  d: "M21.649 11.918v10.8a.82.82 0 0 1-.819.819H9.17a.82.82 0 0 1-.82-.819v-10.8a.82.82 0 0 1 .82-.82h11.66a.82.82 0 0 1 .819.82",
  "data-name": "Path 75940"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M16.337 20.481h-2.673a.25.25 0 0 1-.248-.277l.4-3.587a.32.32 0 0 0-.05-.207 1.463 1.463 0 1 1 2.462 0 .32.32 0 0 0-.05.207l.4 3.587a.25.25 0 0 1-.241.277",
  "data-name": "Path 75941"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fc2b3a",
  d: "M10.703 23.539H9.17a.82.82 0 0 1-.82-.819v-10.8a.82.82 0 0 1 .82-.82h1.533a.833.833 0 0 0-.833.833v10.769a.833.833 0 0 0 .833.837",
  "data-name": "Path 75942"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffaa20",
  d: "M28 20.1v5.619a1.25 1.25 0 0 1-1.248 1.248H3.248A1.25 1.25 0 0 1 2 25.719V20.1a1.25 1.25 0 0 1 1.248-1.244h23.5A1.25 1.25 0 0 1 28 20.1",
  "data-name": "Path 75943"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 61718"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#ff9800",
  d: "M4.787 26.967H3.248A1.25 1.25 0 0 1 2 25.719V20.1a1.25 1.25 0 0 1 1.248-1.244h1.54a1.27 1.27 0 0 0-1.268 1.268v5.579a1.27 1.27 0 0 0 1.267 1.264",
  "data-name": "Path 75944"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m7.848 23.749-1.1-.634 1.1-.634a.387.387 0 1 0-.387-.67l-1.1.634v-1.267a.387.387 0 0 0-.773 0v1.267l-1.1-.633a.387.387 0 1 0-.387.67l1.1.634-1.1.634a.387.387 0 1 0 .387.67l1.1-.634v1.27a.387.387 0 1 0 .773 0v-1.267l1.1.634a.387.387 0 0 0 .387-.67Z",
  "data-name": "Path 75945"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m19.867 23.749-1.1-.634 1.1-.634a.387.387 0 0 0-.387-.67l-1.1.634v-1.267a.387.387 0 1 0-.773 0v1.267l-1.1-.634a.387.387 0 1 0-.387.67l1.1.634-1.1.634a.387.387 0 1 0 .387.67l1.1-.634v1.272a.387.387 0 0 0 .773 0V23.79l1.1.634a.387.387 0 0 0 .387-.67Z",
  "data-name": "Path 75946"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m13.858 23.749-1.1-.634 1.1-.634a.387.387 0 0 0-.387-.67l-1.1.634v-1.267a.387.387 0 1 0-.773 0v1.267l-1.1-.634a.387.387 0 0 0-.387.67l1.1.634-1.1.634a.387.387 0 1 0 .387.67l1.1-.634v1.272a.387.387 0 0 0 .773 0V23.79l1.1.634a.387.387 0 0 0 .387-.67Z",
  "data-name": "Path 75947"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m25.716 23.62-1.071-.618 1.071-.618a.387.387 0 0 0-.387-.67l-1.071.618v-1.241a.387.387 0 0 0-.773 0v1.236l-1.071-.618a.387.387 0 0 0-.387.67l1.071.618-1.071.618a.387.387 0 1 0 .387.67l1.071-.618v1.236a.387.387 0 0 0 .773 0v-1.232l1.071.618a.387.387 0 0 0 .387-.67Z",
  "data-name": "Path 75948"
}))));

const SvgChangePassword = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 30 30"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 61718"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#685e68",
  d: "M20.362 12.042H17.79V8.396a2.789 2.789 0 0 0-5.577 0v3.647H9.639V8.396a5.363 5.363 0 1 1 10.725 0Z",
  "data-name": "Path 75938"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#554e56",
  d: "M15.792 3.089a5.37 5.37 0 0 0-4.58 5.306v3.647H9.641V8.396a5.37 5.37 0 0 1 5.363-5.363 5.5 5.5 0 0 1 .788.056",
  "data-name": "Path 75939"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ff4755",
  d: "M21.649 11.918v10.8a.82.82 0 0 1-.819.819H9.17a.82.82 0 0 1-.82-.819v-10.8a.82.82 0 0 1 .82-.82h11.66a.82.82 0 0 1 .819.82",
  "data-name": "Path 75940"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M16.337 20.481h-2.673a.25.25 0 0 1-.248-.277l.4-3.587a.32.32 0 0 0-.05-.207 1.463 1.463 0 1 1 2.462 0 .32.32 0 0 0-.05.207l.4 3.587a.25.25 0 0 1-.241.277",
  "data-name": "Path 75941"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fc2b3a",
  d: "M10.703 23.539H9.17a.82.82 0 0 1-.82-.819v-10.8a.82.82 0 0 1 .82-.82h1.533a.833.833 0 0 0-.833.833v10.769a.833.833 0 0 0 .833.837",
  "data-name": "Path 75942"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffe2c2",
  d: "M28 20.1v5.619a1.25 1.25 0 0 1-1.248 1.248H3.248A1.25 1.25 0 0 1 2 25.719V20.1a1.25 1.25 0 0 1 1.248-1.244h23.5A1.25 1.25 0 0 1 28 20.1",
  "data-name": "Path 75943"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 61718"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#ff9800",
  d: "M4.787 26.967H3.248A1.25 1.25 0 0 1 2 25.719V20.1a1.25 1.25 0 0 1 1.248-1.244h1.54a1.27 1.27 0 0 0-1.268 1.268v5.579a1.27 1.27 0 0 0 1.267 1.264",
  "data-name": "Path 75944"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m7.848 23.749-1.1-.634 1.1-.634a.387.387 0 1 0-.387-.67l-1.1.634v-1.267a.387.387 0 0 0-.773 0v1.267l-1.1-.633a.387.387 0 1 0-.387.67l1.1.634-1.1.634a.387.387 0 1 0 .387.67l1.1-.634v1.27a.387.387 0 1 0 .773 0v-1.267l1.1.634a.387.387 0 0 0 .387-.67Z",
  "data-name": "Path 75945"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m19.867 23.749-1.1-.634 1.1-.634a.387.387 0 0 0-.387-.67l-1.1.634v-1.267a.387.387 0 1 0-.773 0v1.267l-1.1-.634a.387.387 0 1 0-.387.67l1.1.634-1.1.634a.387.387 0 1 0 .387.67l1.1-.634v1.272a.387.387 0 0 0 .773 0V23.79l1.1.634a.387.387 0 0 0 .387-.67Z",
  "data-name": "Path 75946"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m13.858 23.749-1.1-.634 1.1-.634a.387.387 0 0 0-.387-.67l-1.1.634v-1.267a.387.387 0 1 0-.773 0v1.267l-1.1-.634a.387.387 0 0 0-.387.67l1.1.634-1.1.634a.387.387 0 1 0 .387.67l1.1-.634v1.272a.387.387 0 0 0 .773 0V23.79l1.1.634a.387.387 0 0 0 .387-.67Z",
  "data-name": "Path 75947"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m25.716 23.62-1.071-.618 1.071-.618a.387.387 0 0 0-.387-.67l-1.071.618v-1.241a.387.387 0 0 0-.773 0v1.236l-1.071-.618a.387.387 0 0 0-.387.67l1.071.618-1.071.618a.387.387 0 1 0 .387.67l1.071-.618v1.236a.387.387 0 0 0 .773 0v-1.232l1.071.618a.387.387 0 0 0 .387-.67Z",
  "data-name": "Path 75948"
}))));

const SvgCrmBillItemSettings = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  id: "crm-bill-item-settings_svg__svg1",
  width: "1em",
  height: "1em",
  viewBox: "0 0 210 297"
}, props), /*#__PURE__*/React.createElement("defs", {
  id: "crm-bill-item-settings_svg__defs1"
}, /*#__PURE__*/React.createElement("style", {
  id: "style1"
}, ".crm-bill-item-settings_svg__b{fill:#e6f7fe}.crm-bill-item-settings_svg__e{fill:#f7e365}.crm-bill-item-settings_svg__f{fill:#62a4fb}.crm-bill-item-settings_svg__h{fill:#e175a5}.crm-bill-item-settings_svg__j{fill:#30569f}")), /*#__PURE__*/React.createElement("g", {
  id: "crm-bill-item-settings_svg__layer1"
}, /*#__PURE__*/React.createElement("g", {
  id: "crm-bill-item-settings_svg__g1",
  transform: "matrix(9.52743 0 0 9.49832 19.153 44.934)"
}, /*#__PURE__*/React.createElement("path", {
  id: "crm-bill-item-settings_svg__path1",
  d: "M22.724 0h11.125a.87.87 0 0 1 .615.255l3.667 3.667a.87.87 0 0 1 .255.615v16a.87.87 0 0 1-.87.87H22.724a.87.87 0 0 1-.87-.87V.87a.87.87 0 0 1 .87-.87",
  className: "crm-bill-item-settings_svg__b",
  style: {
    fill: "#e5e9eb",
    fillOpacity: 1,
    stroke: "none",
    strokeWidth: 0.112242,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(-21.854)"
})), /*#__PURE__*/React.createElement("g", {
  id: "crm-bill-item-settings_svg__g2",
  transform: "matrix(9.52743 0 0 9.49832 126.09 44.934)"
}, /*#__PURE__*/React.createElement("path", {
  id: "crm-bill-item-settings_svg__path2",
  d: "M295.394 3.922 291.727.255a.87.87 0 0 0-.615-.255h-.771v3.306a2 2 0 0 0 2 2h1.305a.87.87 0 0 1 .87.87v14.358a.87.87 0 0 1-.87.87h1.131a.87.87 0 0 0 .87-.87v-16a.87.87 0 0 0-.255-.615z",
  style: {
    fill: "#cbd1d8",
    fillOpacity: 1
  },
  transform: "translate(-290.341)"
})), /*#__PURE__*/React.createElement("g", {
  id: "crm-bill-item-settings_svg__g3",
  transform: "matrix(9.52743 0 0 9.49832 136.865 45.684)"
}, /*#__PURE__*/React.createElement("path", {
  id: "crm-bill-item-settings_svg__path3",
  d: "M317.4 5.121a.87.87 0 0 0 .87.87h3.23a.9.9 0 0 0-.176-.255l-3.671-3.666a.9.9 0 0 0-.255-.176z",
  style: {
    fill: "#a9b0bc",
    fillOpacity: 1
  },
  transform: "translate(-317.398 -1.894)"
})), /*#__PURE__*/React.createElement("g", {
  id: "crm-bill-item-settings_svg__g6",
  transform: "matrix(9.52743 0 0 9.49832 39.875 101.136)"
}, /*#__PURE__*/React.createElement("path", {
  id: "crm-bill-item-settings_svg__path4",
  d: "M78.5 147.62h-4a.61.61 0 0 1-.609-.609v-4.873a.61.61 0 0 1 .609-.609h4a.61.61 0 0 1 .609.609v4.872a.61.61 0 0 1-.609.61",
  className: "crm-bill-item-settings_svg__e",
  transform: "translate(-73.886 -141.529)"
}), /*#__PURE__*/React.createElement("g", {
  id: "crm-bill-item-settings_svg__g5",
  transform: "translate(6.961)"
}, /*#__PURE__*/React.createElement("path", {
  id: "crm-bill-item-settings_svg__path5",
  d: "M245 147.62h-4a.61.61 0 0 1-.609-.609v-4.873a.61.61 0 0 1 .609-.609h4a.61.61 0 0 1 .609.609v4.872a.61.61 0 0 1-.609.61",
  className: "crm-bill-item-settings_svg__e",
  transform: "translate(-240.39 -141.529)"
}))), /*#__PURE__*/React.createElement("g", {
  id: "crm-bill-item-settings_svg__g10",
  transform: "matrix(9.52743 0 0 9.49832 106.196 135.842)"
}, /*#__PURE__*/React.createElement("path", {
  id: "crm-bill-item-settings_svg__path6",
  d: "M250.828 234.37v-.414a.345.345 0 0 0-.274-.337l-.609-.127a.34.34 0 0 1-.265-.257q-.035-.155-.081-.305a.34.34 0 0 1 .1-.354l.464-.414a.345.345 0 0 0 .069-.429l-.207-.359a.345.345 0 0 0-.406-.155l-.592.195a.34.34 0 0 1-.357-.09q-.107-.115-.223-.223a.34.34 0 0 1-.09-.357l.195-.592a.345.345 0 0 0-.155-.406l-.359-.207a.345.345 0 0 0-.429.069l-.414.464a.34.34 0 0 1-.354.1q-.15-.046-.305-.081a.34.34 0 0 1-.257-.265l-.127-.609a.345.345 0 0 0-.337-.274h-.415a.345.345 0 0 0-.337.274l-.127.609a.34.34 0 0 1-.257.265q-.155.035-.305.081a.34.34 0 0 1-.354-.1l-.414-.464a.345.345 0 0 0-.429-.069l-.359.207a.345.345 0 0 0-.155.406l.195.592a.34.34 0 0 1-.09.357q-.116.107-.223.223a.34.34 0 0 1-.357.09l-.592-.195a.345.345 0 0 0-.406.155l-.207.359a.345.345 0 0 0 .069.429l.464.414a.34.34 0 0 1 .1.354q-.046.15-.081.305a.34.34 0 0 1-.265.257l-.609.127a.345.345 0 0 0-.274.337v.414a.345.345 0 0 0 .274.337l.609.127a.34.34 0 0 1 .265.257q.035.155.081.305a.34.34 0 0 1-.1.354l-.464.414a.345.345 0 0 0-.069.429l.207.359a.345.345 0 0 0 .406.155l.592-.195a.34.34 0 0 1 .357.09q.107.116.223.223a.34.34 0 0 1 .09.357l-.195.592a.345.345 0 0 0 .155.406l.359.207a.345.345 0 0 0 .429-.069l.414-.464a.34.34 0 0 1 .354-.1q.15.046.305.081a.34.34 0 0 1 .257.265l.127.609a.345.345 0 0 0 .337.274h.414a.345.345 0 0 0 .337-.274l.127-.609a.34.34 0 0 1 .257-.265q.155-.035.305-.081a.34.34 0 0 1 .354.1l.414.464a.345.345 0 0 0 .429.069l.359-.207a.345.345 0 0 0 .155-.406l-.195-.592a.34.34 0 0 1 .09-.357q.116-.107.223-.223a.34.34 0 0 1 .357-.09l.592.195a.345.345 0 0 0 .406-.155l.207-.359a.345.345 0 0 0-.069-.429l-.464-.414a.34.34 0 0 1-.1-.354q.046-.15.081-.305a.34.34 0 0 1 .265-.257l.609-.127a.344.344 0 0 0 .274-.337z",
  className: "crm-bill-item-settings_svg__f",
  transform: "translate(-240.387 -228.942)"
}), /*#__PURE__*/React.createElement("g", {
  id: "crm-bill-item-settings_svg__g7",
  transform: "translate(2.259 2.259)"
}, /*#__PURE__*/React.createElement("path", {
  id: "crm-bill-item-settings_svg__path7",
  d: "m302.325 285.387-.609-.127a.34.34 0 0 1-.265-.257q-.035-.155-.081-.305a.34.34 0 0 1 .1-.354l.464-.414a.344.344 0 0 0 .066-.43l-.207-.359a.345.345 0 0 0-.406-.155l-.592.195a.4.4 0 0 1-.114.017 6 6 0 0 1 .066.862 5.33 5.33 0 0 1-5.329 5.329 5.4 5.4 0 0 1-.787-.058v.019l-.195.592a.345.345 0 0 0 .155.406l.359.207a.345.345 0 0 0 .429-.069l.414-.464a.34.34 0 0 1 .354-.1q.15.046.305.081a.34.34 0 0 1 .257.265l.127.609a.344.344 0 0 0 .337.274h.414a.344.344 0 0 0 .337-.274l.127-.609a.34.34 0 0 1 .257-.265q.155-.035.305-.081a.34.34 0 0 1 .354.1l.414.464a.345.345 0 0 0 .429.069l.359-.207a.345.345 0 0 0 .155-.406l-.195-.592a.34.34 0 0 1 .09-.357q.116-.107.223-.223a.34.34 0 0 1 .357-.09l.592.195a.345.345 0 0 0 .406-.155l.207-.359a.345.345 0 0 0-.069-.429l-.464-.414a.34.34 0 0 1-.1-.354q.046-.15.081-.305a.34.34 0 0 1 .265-.257l.609-.127a.344.344 0 0 0 .274-.337v-.414a.345.345 0 0 0-.275-.337",
  style: {
    fill: "#5392f9"
  },
  transform: "translate(-294.416 -282.969)"
})), /*#__PURE__*/React.createElement("g", {
  id: "crm-bill-item-settings_svg__g8",
  transform: "translate(2.393 2.393)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "crm-bill-item-settings_svg__ellipse7",
  cx: 2.828,
  cy: 2.828,
  r: 2.828,
  className: "crm-bill-item-settings_svg__b"
})), /*#__PURE__*/React.createElement("g", {
  id: "crm-bill-item-settings_svg__g9",
  transform: "translate(4.177 4.176)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "crm-bill-item-settings_svg__ellipse8",
  cx: 1.044,
  cy: 1.044,
  r: 1.044,
  className: "crm-bill-item-settings_svg__f"
}))), /*#__PURE__*/React.createElement("g", {
  id: "crm-bill-item-settings_svg__g11",
  transform: "matrix(9.52743 0 0 9.49832 36.893 58.156)"
}, /*#__PURE__*/React.createElement("path", {
  id: "crm-bill-item-settings_svg__path10",
  d: "M73.926 34.693h-7.194a.345.345 0 0 1-.345-.345v-.7a.345.345 0 0 1 .345-.345h7.194a.345.345 0 0 1 .345.345v.7a.345.345 0 0 1-.345.345",
  className: "crm-bill-item-settings_svg__h",
  transform: "translate(-66.387 -33.301)"
})), /*#__PURE__*/React.createElement("g", {
  id: "crm-bill-item-settings_svg__g12",
  transform: "matrix(9.52743 0 0 9.49832 36.893 221.793)"
}, /*#__PURE__*/React.createElement("path", {
  id: "crm-bill-item-settings_svg__path11",
  d: "M71.925 446.791h-5.193a.345.345 0 0 1-.345-.345v-.7a.345.345 0 0 1 .345-.345h5.193a.345.345 0 0 1 .345.345v.7a.345.345 0 0 1-.345.345",
  style: {
    fill: "#ad7fdd"
  },
  transform: "translate(-66.387 -445.399)"
})), /*#__PURE__*/React.createElement("g", {
  id: "crm-bill-item-settings_svg__g13",
  transform: "matrix(9.52743 0 0 9.49832 50.156 111.375)"
}, /*#__PURE__*/React.createElement("path", {
  id: "crm-bill-item-settings_svg__path12",
  d: "M101.045 167.956H100a.314.314 0 0 1 0-.627h1.044a.314.314 0 1 1 0 .627z",
  className: "crm-bill-item-settings_svg__j",
  transform: "translate(-99.687 -167.329)"
})), /*#__PURE__*/React.createElement("g", {
  id: "crm-bill-item-settings_svg__g14",
  transform: "matrix(9.52743 0 0 9.49832 50.156 124.596)"
}, /*#__PURE__*/React.createElement("path", {
  id: "crm-bill-item-settings_svg__path13",
  d: "M102.437 201.257H100a.314.314 0 0 1 0-.627h2.436a.314.314 0 1 1 0 .627z",
  className: "crm-bill-item-settings_svg__j",
  transform: "translate(-99.687 -200.63)"
})), /*#__PURE__*/React.createElement("g", {
  id: "crm-bill-item-settings_svg__g15",
  transform: "matrix(9.52743 0 0 9.49832 50.156 137.828)"
}, /*#__PURE__*/React.createElement("path", {
  id: "crm-bill-item-settings_svg__path14",
  d: "M102.437 234.558H100a.314.314 0 1 1 0-.627h2.436a.314.314 0 1 1 0 .627z",
  className: "crm-bill-item-settings_svg__j",
  transform: "translate(-99.687 -233.931)"
})), /*#__PURE__*/React.createElement("g", {
  id: "crm-bill-item-settings_svg__g16",
  transform: "matrix(9.52743 0 0 9.49832 116.476 111.375)"
}, /*#__PURE__*/React.createElement("path", {
  id: "crm-bill-item-settings_svg__path15",
  d: "M267.549 167.956H266.5a.314.314 0 1 1 0-.627h1.044a.314.314 0 0 1 0 .627z",
  className: "crm-bill-item-settings_svg__j",
  transform: "translate(-266.191 -167.329)"
})), /*#__PURE__*/React.createElement("g", {
  id: "crm-bill-item-settings_svg__g17",
  transform: "matrix(9.52743 0 0 9.49832 116.476 124.596)"
}, /*#__PURE__*/React.createElement("path", {
  id: "crm-bill-item-settings_svg__path16",
  d: "M268.68 201.257h-2.18a.314.314 0 0 1 0-.627h2.175a.314.314 0 0 1 0 .627z",
  className: "crm-bill-item-settings_svg__j",
  transform: "translate(-266.191 -200.63)"
})), /*#__PURE__*/React.createElement("g", {
  id: "crm-bill-item-settings_svg__g18",
  transform: "matrix(9.52743 0 0 9.49832 36.893 81.626)"
}, /*#__PURE__*/React.createElement("path", {
  id: "crm-bill-item-settings_svg__path17",
  d: "M68.092 93.029H66.7a.314.314 0 0 1 0-.627h1.392a.314.314 0 1 1 0 .627",
  className: "crm-bill-item-settings_svg__f",
  transform: "translate(-66.386 -92.402)"
})), /*#__PURE__*/React.createElement("g", {
  id: "crm-bill-item-settings_svg__g19",
  transform: "matrix(9.52743 0 0 9.49832 63.418 81.626)"
}, /*#__PURE__*/React.createElement("path", {
  id: "crm-bill-item-settings_svg__path18",
  d: "M138.087 93.029H133.3a.314.314 0 0 1 0-.627h4.786a.314.314 0 1 1 0 .627z",
  className: "crm-bill-item-settings_svg__f",
  transform: "translate(-132.988 -92.402)"
})), /*#__PURE__*/React.createElement("g", {
  id: "crm-bill-item-settings_svg__g20",
  transform: "matrix(9.52743 0 0 9.49832 70.878 176.666)"
}, /*#__PURE__*/React.createElement("path", {
  id: "crm-bill-item-settings_svg__path19",
  d: "M154.034 332.379h-2a.314.314 0 0 1 0-.627h2a.314.314 0 1 1 0 .627",
  className: "crm-bill-item-settings_svg__h",
  transform: "translate(-151.719 -331.752)"
})), /*#__PURE__*/React.createElement("g", {
  id: "crm-bill-item-settings_svg__g21",
  transform: "matrix(9.52743 0 0 9.49832 49.327 176.666)"
}, /*#__PURE__*/React.createElement("path", {
  id: "crm-bill-item-settings_svg__path20",
  d: "M98.789 332.379h-.87a.314.314 0 1 1 0-.627h.87a.314.314 0 0 1 0 .627",
  className: "crm-bill-item-settings_svg__h",
  transform: "translate(-97.605 -331.752)"
})), /*#__PURE__*/React.createElement("g", {
  id: "crm-bill-item-settings_svg__g22",
  transform: "matrix(9.52743 0 0 9.49832 36.893 189.888)"
}, /*#__PURE__*/React.createElement("path", {
  id: "crm-bill-item-settings_svg__path21",
  d: "M72.268 365.68H66.7a.314.314 0 0 1 0-.627h5.569a.314.314 0 0 1 0 .627z",
  className: "crm-bill-item-settings_svg__h",
  transform: "translate(-66.386 -365.053)"
})), /*#__PURE__*/React.createElement("g", {
  id: "crm-bill-item-settings_svg__g23",
  transform: "matrix(9.52743 0 0 9.49832 36.893 203.11)"
}, /*#__PURE__*/React.createElement("path", {
  id: "crm-bill-item-settings_svg__path22",
  d: "M70.006 398.981H66.7a.314.314 0 0 1 0-.627h3.306a.314.314 0 0 1 0 .627",
  className: "crm-bill-item-settings_svg__h",
  transform: "translate(-66.386 -398.354)"
})), /*#__PURE__*/React.createElement("g", {
  id: "crm-bill-item-settings_svg__g24",
  transform: "matrix(9.52743 0 0 9.49832 81.663 203.11)"
}, /*#__PURE__*/React.createElement("path", {
  id: "crm-bill-item-settings_svg__path23",
  d: "M179.96 398.981h-.87a.314.314 0 1 1 0-.627h.87a.314.314 0 1 1 0 .627",
  className: "crm-bill-item-settings_svg__h",
  transform: "translate(-178.776 -398.354)"
}))));

const SvgDollarOrange = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 30 30"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#ff9800",
  d: "M15.004 2.504a12.5 12.5 0 1 0 12.5 12.5 12.5 12.5 0 0 0-12.5-12.5m1.762 20.106v2.387h-3.341v-2.412c-2.137-.45-3.949-1.824-4.086-4.249h2.449c.125 1.312 1.025 2.337 3.311 2.337 2.449 0 3-1.225 3-1.987 0-1.037-.55-2.012-3.336-2.674-3.1-.75-5.223-2.024-5.223-4.586 0-2.149 1.737-3.549 3.886-4.011V5.004h3.336V7.44a4.42 4.42 0 0 1 3.561 4.236h-2.449c-.062-1.387-.8-2.337-2.774-2.337-1.874 0-3 .85-3 2.049 0 1.05.812 1.737 3.336 2.387s5.223 1.737 5.223 4.886c-.012 2.287-1.724 3.536-3.9 3.949Z",
  "data-name": "Path 1317"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h30v30H0Z",
  "data-name": "Path 1318"
}));

const SvgEInvoiceDoc = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32",
  width: "1em",
  height: "1em"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#dadee0",
  d: "M25.926 10.672a1.776 1.776 0 0 0-1.771-1.771H10.872a1.776 1.776 0 0 0-1.771 1.771v16.532a1.776 1.776 0 0 0 1.771 1.771h10.036l5.018-4.723Z",
  "data-name": "Path 71848"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.4 5.018a1.776 1.776 0 0 1 1.771-1.771h11.811V1.771A1.776 1.776 0 0 0 43.211 0H29.926a1.776 1.776 0 0 0-1.771 1.771V18.3a1.776 1.776 0 0 0 1.771 1.771H31.4Z",
  "data-name": "Path 71849",
  style: {
    fill: "#ff9800"
  },
  transform: "translate(-22.301 5.654)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f2f2f2",
  d: "M22.68 24.252h3.247l-5.018 4.723v-2.952a1.776 1.776 0 0 1 1.771-1.771",
  "data-name": "Path 71850"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#1f4254",
  "data-name": "Group 57451"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.53 16.725h7.971a.443.443 0 0 0 0-.886H13.53a.443.443 0 0 0 0 .886",
  "data-name": "Path 71851"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.53 13.773h7.971a.443.443 0 1 0 0-.886H13.53a.443.443 0 1 0 0 .886",
  "data-name": "Path 71852"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.53 19.677h7.971a.443.443 0 1 0 0-.886H13.53a.443.443 0 1 0 0 .886",
  "data-name": "Path 71853"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.53 22.629h4.428a.443.443 0 1 0 0-.886H13.53a.443.443 0 0 0 0 .886",
  "data-name": "Path 71854"
})));

const SvgEInvoiceEnquiryDocs = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 500 500",
  width: "1em",
  height: "1em"
}, props), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(15.62494 0 0 17.17246 200335.568 -114238.347)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M101.3 58.091a1.776 1.776 0 0 0-1.771-1.771H86.246a1.776 1.776 0 0 0-1.771 1.771v16.532a1.776 1.776 0 0 0 1.771 1.771h10.036l5.018-4.723Z",
  "data-name": "Path 71848",
  style: {
    fill: "#ffebcc"
  },
  transform: "translate(-12898.374 6596.581)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f2f2f2",
  d: "M-12800.32 6668.252h3.247l-5.018 4.723v-2.952a1.776 1.776 0 0 1 1.771-1.771",
  "data-name": "Path 71850"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-12818.933 6649.654)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21.84 5.309c.179-.962-.543-2.01-1.178-2.013l-4.746-.02c.086 19.652-.032.456.038 20.045h2.623l3.263-4.648z",
  "data-name": "Path 71848",
  style: {
    fill: "#ffcc80"
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f2f2f2",
  d: "M44.981 18.598h3.247l-5.018 4.723v-2.952a1.776 1.776 0 0 1 1.771-1.771",
  "data-name": "Path 71850"
})), /*#__PURE__*/React.createElement("g", {
  fill: "#1f4254",
  "data-name": "Group 57451"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-12809.47 6660.725h7.971a.443.443 0 0 0 0-.886h-7.971a.443.443 0 0 0 0 .886",
  "data-name": "Path 71851"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-12809.47 6657.773h7.971a.443.443 0 1 0 0-.886h-7.971a.443.443 0 1 0 0 .886",
  "data-name": "Path 71852"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-12809.47 6663.677h7.971a.443.443 0 1 0 0-.886h-7.971a.443.443 0 1 0 0 .886",
  "data-name": "Path 71853"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-12809.47 6666.629h4.428a.443.443 0 1 0 0-.886h-4.428a.443.443 0 0 0 0 .886",
  "data-name": "Path 71854"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 66565",
  transform: "matrix(16.66663 0 0 13.06507 -39101.005 44814.02)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#ffb454",
  d: "M2359.014-3416.7a.4.4 0 0 1-.307-.143l-.807-.957a.6.6 0 0 0-.446-.2h-5.054a.4.4 0 0 0-.4.4v18.9a1.2 1.2 0 0 0 1.2 1.2h.787l9.463-1.7 1.283-10.242-1.281-7.258Z",
  "data-name": "Path 81631"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ff7d47",
  d: "M2369.698-3416.699h-6.246v17.5l5.446 1.7a1.2 1.2 0 0 0 1.2-1.2v-17.6a.4.4 0 0 0-.4-.4",
  "data-name": "Path 81632"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f7f9fa",
  d: "m2363.452-3414.276.4 2.042-.4 1.52h-7.588v-3.162a.4.4 0 0 1 .4-.4Z",
  "data-name": "Path 81633"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#d7e8ff",
  d: "M2370.639-3414.276h-7.187v3.562h7.588v-3.162a.4.4 0 0 0-.401-.4",
  "data-name": "Path 81634"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffe278",
  d: "m2363.452-3411.861.681 2.419-.681 11.944h-10.251a1.2 1.2 0 0 0 1.2-1.2v-12.763a.4.4 0 0 1 .4-.4Z",
  "data-name": "Path 81635"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffb454",
  d: "M2372.101-3411.861h-8.649v14.362h8.649a.4.4 0 0 0 .4-.4v-13.562a.4.4 0 0 0-.4-.4",
  "data-name": "Path 81636"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M2347-3423h30v30h-30z",
  "data-name": "Rectangle 27533"
})), /*#__PURE__*/React.createElement("g", {
  style: {
    transformOrigin: "464.553px 297.313px"
  },
  transform: "matrix(.7969 .00002 .0042 1.08279 -171.587 367.777)"
}, /*#__PURE__*/React.createElement("g", {
  style: {
    transformOrigin: "286.499px 132.54px"
  },
  transform: "matrix(-.01741 .5066 -.64796 -.02866 82.136 -78.12)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#365e7d",
  d: "M305.003 327.025c98.19 65.988 161.398 129.196 161.398 129.196s6.279 21.631-23.681 51.592-51.592 23.681-51.592 23.681-63.208-63.208-129.196-161.398"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2b4d66",
  d: "m261.936 370.096 15.639-15.639C353.383 437.93 416.604 502.142 431.823 517.5c-24.166 18.787-40.693 13.997-40.693 13.997s-63.212-63.213-129.194-161.401"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 165.424,
  cy: 230.518,
  r: 195.474,
  fill: "#e7a561"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e49542",
  d: "M180.201 425.449c-4.883.361-9.799.547-14.77.547-107.956 0-195.481-87.525-195.481-195.481s87.525-195.47 195.481-195.47c4.971 0 9.887.186 14.77.547C79.143 43.136-.51 127.519-.51 230.515s79.653 187.39 180.711 194.934"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 165.424,
  cy: 230.514,
  r: 153.781,
  fill: "#f9f6f6"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e7ecf6",
  d: "M11.643 230.517c0-84.931 68.85-153.782 153.782-153.782 7.172 0 14.221.493 21.124 1.434C111.613 88.468 53.89 152.758 53.89 230.517s57.723 142.049 132.658 152.347a156 156 0 0 1-21.124 1.434c-84.93.001-153.781-68.85-153.781-153.781"
}))));

const SvgEInvoicePendingAlertDoc = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 500 500",
  width: "1em",
  height: "1em"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 9158",
  transform: "matrix(-13.73768 0 0 13.7377 374.488 36.683)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M22.675 2.424h-.877v21.551a2.6 2.6 0 0 1-2.6 2.6H4.245v.8a1.66 1.66 0 0 0 1.657 1.649h16.77a1.66 1.66 0 0 0 1.657-1.657V4.077a1.655 1.655 0 0 0-1.654-1.653",
  "data-name": "Path 12279",
  style: {
    fill: "#fc8d00"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "m12.134 29.038 10.523.005a1.66 1.66 0 0 0 1.659-1.659V4.059A1.66 1.66 0 0 0 22.657 2.4l-10.523-.004z",
  "data-name": "Path 12280",
  style: {
    fill: "#ffb454"
  }
}), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(-1.2582 0 0 -1.34666 60.677 31.092)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M101.3 58.091a1.776 1.776 0 0 0-1.771-1.771H86.246a1.776 1.776 0 0 0-1.771 1.771v16.532a1.776 1.776 0 0 0 1.771 1.771h10.036l5.018-4.723Z",
  "data-name": "Path 71848",
  style: {
    fill: "#ffebcc"
  },
  transform: "translate(-53.073 -53.073)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M48.226 5.021a1.775 1.775 0 0 0-1.771-1.771l-7.874-.002c0 .005-.116 16.254 0 20.076h4.627l5.018-4.723z",
  "data-name": "Path 71848",
  style: {
    fill: "#ffcc80"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M291.036 322.56h3.247l-5.018 4.723v-2.952a1.776 1.776 0 0 1 1.771-1.771",
  "data-name": "Path 71850",
  style: {
    fill: "#ffac28"
  },
  transform: "translate(-246.055 -303.962)"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57451",
  transform: "translate(35.388 7.233)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#1f4254",
  d: "M.443 3.838h7.971a.443.443 0 0 0 0-.886H.443a.443.443 0 0 0 0 .886",
  "data-name": "Path 71851"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1f4254",
  d: "M.443 6.79h7.971a.443.443 0 1 0 0-.886H.443a.443.443 0 1 0 0 .886",
  "data-name": "Path 71853"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1f4254",
  d: "M.449.89h4.428a.443.443 0 1 0 0-.886H.449a.444.444 0 0 0 0 .886",
  "data-name": "Path 71854",
  style: {
    pointerEvents: "none"
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1f4254",
  d: "M.446 9.726h7.971a.443.443 0 1 0 0-.886H.446a.443.443 0 0 0 0 .886",
  "data-name": "Path 71852"
})))), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(2.27565 0 0 2.27565 -441.454 -542.441)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M391.193 368.058v-19.517h-56.687v19.517c0 12.877 8.053 23.804 19.238 27.722-11.185 3.918-19.238 14.845-19.238 27.722v19.517h56.687v-19.517c0-12.877-8.053-23.804-19.239-27.722 11.185-3.918 19.239-14.845 19.239-27.722",
  style: {
    fill: "#5ad7ff"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M391.193 368.058v-19.517h-28.138v94.478h28.138v-19.517c0-12.877-8.053-23.804-19.239-27.722 11.185-3.918 19.239-14.845 19.239-27.722",
  style: {
    fill: "#23aae6"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M341.234 443.019h43.23l-18.096-24.294.425 10.05-3.62-14.985-.197.213-2.634 4.567-.213.155z",
  style: {
    fill: "#ffedb5"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M366.368 418.725v-.095l-3.163-4.226-.041.217-.109 28.398h21.409z",
  style: {
    fill: "#fecb81"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M392.624 351.118h-59.55a6.013 6.013 0 0 1 0-12.025h59.55a6.013 6.013 0 1 1 0 12.025",
  style: {
    fill: "#365e7d"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M392.624 339.093h-29.57v12.025h29.57a6.013 6.013 0 0 0 0-12.025",
  style: {
    fill: "#243e52"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M392.624 452.467h-59.55a6.013 6.013 0 0 1 0-12.025h59.55a6.013 6.013 0 1 1 0 12.025",
  style: {
    fill: "#365e7d"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M392.624 440.442h-29.57v12.025h29.57a6.013 6.013 0 0 0 0-12.025",
  style: {
    fill: "#243e52"
  }
})));

const SvgEInvoicePendingDoc = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 500 500",
  width: "1em",
  height: "1em"
}, props), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(18.06108 0 0 15.62504 231586.179 -103847.675)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#ffebcc",
  d: "M-12797.074 6654.672a1.776 1.776 0 0 0-1.771-1.771h-13.283a1.776 1.776 0 0 0-1.771 1.771v16.532a1.776 1.776 0 0 0 1.771 1.771h10.036l5.018-4.723Z",
  "data-name": "Path 71848"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.4 5.018a1.776 1.776 0 0 1 1.771-1.771h11.811V1.771A1.776 1.776 0 0 0 43.211 0H29.926a1.776 1.776 0 0 0-1.771 1.771V18.3a1.776 1.776 0 0 0 1.771 1.771H31.4Z",
  "data-name": "Path 71849",
  style: {
    fill: "#ffda80"
  },
  transform: "translate(-12845.301 6649.654)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fec244",
  d: "M-12800.32 6668.252h3.247l-5.018 4.723v-2.952a1.776 1.776 0 0 1 1.771-1.771",
  "data-name": "Path 71850"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#1f4254",
  "data-name": "Group 57451"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-12809.47 6660.725h7.971a.443.443 0 0 0 0-.886h-7.971a.443.443 0 0 0 0 .886",
  "data-name": "Path 71851"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-12809.47 6657.773h7.971a.443.443 0 1 0 0-.886h-7.971a.443.443 0 1 0 0 .886",
  "data-name": "Path 71852"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-12809.47 6663.677h7.971a.443.443 0 1 0 0-.886h-7.971a.443.443 0 1 0 0 .886",
  "data-name": "Path 71853"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-12809.47 6666.629h4.428a.443.443 0 1 0 0-.886h-4.428a.443.443 0 0 0 0 .886",
  "data-name": "Path 71854"
})), /*#__PURE__*/React.createElement("path", {
  d: "M28.238 1.922A1.776 1.776 0 0 1 30.009.151H41.82v-1.476a1.776 1.776 0 0 0-1.771-1.771H26.764a1.776 1.776 0 0 0-1.771 1.771v16.529a1.776 1.776 0 0 0 1.771 1.771h1.474z",
  "data-name": "Path 71849",
  style: {
    fill: "#e67500"
  },
  transform: "translate(-12845.301 6649.654)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(19.7862 0 0 19.11668 254831.539 -127784.512)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#ff4155",
  d: "M-12859 6709.521a4.987 4.987 0 1 1 4.987-4.987 5 5 0 0 1-4.987 4.987",
  "data-name": "Path 64972"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M-12857.85 6706.452a.77.77 0 0 1-.542-.225l-1.151-1.151a.76.76 0 0 1-.225-.542v-2.3a.767.767 0 0 1 1.534 0v1.984l.926.926a.767.767 0 0 1-.542 1.31Z",
  "data-name": "Path 64974"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ff4155",
  d: "M-12859 6699.547a4.987 4.987 0 0 0 0 9.974v-3.9l-.542-.542a.76.76 0 0 1-.225-.542v-2.3a.767.767 0 0 1 .767-.767Z",
  "data-name": "Path 64976"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M-12859.001 6701.465a.767.767 0 0 0-.767.767v2.3a.76.76 0 0 0 .225.542l.542.542Z",
  "data-name": "Path 64978"
})));

const SvgEInvoicePropertyTitle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "#ffd754",
  "data-name": "Group 50353"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.917 21.515 7.843 24.686a.44.44 0 0 1-.5-.363L4.862 7.541a.44.44 0 0 1 .363-.5l11.074-1.783a.44.44 0 0 1 .5.363l2.479 15.394a.44.44 0 0 1-.363.5Z",
  "data-name": "Path 65107"
}), /*#__PURE__*/React.createElement("path", {
  d: "m13.082 21.515 11.074 3.171a.44.44 0 0 0 .5-.363l2.479-16.782a.44.44 0 0 0-.363-.5l-11.07-1.785a.44.44 0 0 0-.5.363l-2.479 15.394a.44.44 0 0 0 .363.5Z",
  "data-name": "Path 65108"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.917 21.515 7.843 24.686a.44.44 0 0 1-.5-.363L4.862 7.541a.44.44 0 0 1 .363-.5l11.074-1.783a.44.44 0 0 1 .5.363l2.479 15.394a.44.44 0 0 1-.363.5Z",
  "data-name": "Path 65109"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#fabf1e",
  d: "M16.801 5.62a.44.44 0 0 0-.5-.363l-7.26 1.169v15.619c0 .279.226 1.43.5 1.43h4.28l5.093-1.958a.44.44 0 0 0 .363-.5Z",
  "data-name": "Path 65110"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fabf1e",
  d: "M15.702 5.257a.44.44 0 0 0-.5.363l-2.479 15.394a.44.44 0 0 0 .363.5l5.093 1.958h4.28c.279 0 .5-1.151.5-1.43V6.426Z",
  "data-name": "Path 65111"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffebcc",
  d: "M21.608 21.305H10.391a.44.44 0 0 1-.438-.438V5.274a.44.44 0 0 1 .438-.438h11.216a.44.44 0 0 1 .438.438v15.592a.44.44 0 0 1-.437.439",
  "data-name": "Path 65112"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffebcc",
  d: "M21.608 4.836H20.52a.44.44 0 0 1 .438.438v15.592a.44.44 0 0 1-.438.438h1.088a.44.44 0 0 0 .438-.438V5.274a.44.44 0 0 0-.438-.438",
  "data-name": "Path 65113"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ff9e22",
  d: "m19.195 18.304-.344.922a.71.71 0 0 1-.664.461h-4.375a.71.71 0 0 1-.664-.461l-.344-.922a.71.71 0 0 0-.664-.461h-7.3a.34.34 0 0 0-.339.339v6.07a2.91 2.91 0 0 0 2.912 2.912h17.173a2.91 2.91 0 0 0 2.915-2.907v-6.07a.34.34 0 0 0-.339-.339h-7.3a.71.71 0 0 0-.667.456",
  "data-name": "Path 65114"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#cc831e",
  "data-name": "Group 50354"
}, /*#__PURE__*/React.createElement("path", {
  d: "m11.409 18.304.344.922a.71.71 0 0 0 .664.461h1.4a.71.71 0 0 1-.664-.461l-.344-.922a.71.71 0 0 0-.664-.461h-1.4a.71.71 0 0 1 .664.461",
  "data-name": "Path 65115"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.103 17.843v6.41a2.91 2.91 0 0 1-2.912 2.912h1.4a2.91 2.91 0 0 0 2.912-2.912v-6.07a.34.34 0 0 0-.339-.339Z",
  "data-name": "Path 65116"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#cc831e",
  d: "M19.958 23.595h-7.917a.253.253 0 0 1-.253-.253v-1.7a.253.253 0 0 1 .253-.253h7.917a.253.253 0 0 1 .253.253v1.7a.253.253 0 0 1-.253.253",
  "data-name": "Path 65117"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#7f5112",
  d: "M19.957 21.393h-1.043a.253.253 0 0 1 .253.253v1.7a.253.253 0 0 1-.253.253h1.043a.253.253 0 0 0 .253-.253v-1.7a.253.253 0 0 0-.253-.253",
  "data-name": "Path 65118"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 50370"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 50357"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 50355"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#30579d",
  d: "M13.18 7.764h-1.284a.347.347 0 1 1 0-.694h1.284a.347.347 0 1 1 0 .694",
  "data-name": "Path 65119"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 50356"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#30579d",
  d: "M20.103 7.764h-4.985a.347.347 0 1 1 0-.694h4.985a.347.347 0 0 1 0 .694",
  "data-name": "Path 65120"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 50360"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 50358"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#30579d",
  d: "M13.18 9.753h-1.284a.347.347 0 1 1 0-.694h1.284a.347.347 0 1 1 0 .694",
  "data-name": "Path 65121"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 50359"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#30579d",
  d: "M20.103 9.753h-4.985a.347.347 0 1 1 0-.694h4.985a.347.347 0 0 1 0 .694",
  "data-name": "Path 65122"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 50363"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 50361"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#30579d",
  d: "M13.18 11.745h-1.284a.347.347 0 1 1 0-.694h1.284a.347.347 0 1 1 0 .694",
  "data-name": "Path 65123"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 50362"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#30579d",
  d: "M20.103 11.745h-4.985a.347.347 0 1 1 0-.694h4.985a.347.347 0 1 1 0 .694",
  "data-name": "Path 65124"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 50366"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 50364"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#30579d",
  d: "M13.18 13.737h-1.284a.347.347 0 0 1 0-.694h1.284a.347.347 0 0 1 0 .694",
  "data-name": "Path 65125"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 50365"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#30579d",
  d: "M20.103 13.737h-4.985a.347.347 0 0 1 0-.694h4.985a.347.347 0 0 1 0 .694",
  "data-name": "Path 65126"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 50369"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 50367"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#30579d",
  d: "M13.18 15.73h-1.284a.347.347 0 1 1 0-.694h1.284a.347.347 0 1 1 0 .694",
  "data-name": "Path 65127"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 50368"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#30579d",
  d: "M20.103 15.73h-4.985a.347.347 0 1 1 0-.694h4.985a.347.347 0 1 1 0 .694",
  "data-name": "Path 65128"
})))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 50371"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#7f5112",
  d: "M18.631 25.755h-5.263a.347.347 0 1 1 0-.694h5.263a.347.347 0 1 1 0 .694",
  "data-name": "Path 65129"
})));

const SvgEInvoiceResetLock = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 500 500",
  width: "1em",
  height: "1em"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 66352",
  transform: "matrix(16.66658 0 0 16.66664 -62749.682 54866.588)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M3765-3292h30v30h-30z",
  "data-name": "Rectangle 27534"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 66351"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#4d4d80",
  "data-name": "Group 66345"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3768.492-3277.269a11.287 11.287 0 0 1 11.239-11.239 11.55 11.55 0 0 1 6.469 2.081.734.734 0 0 0-.849.483.745.745 0 0 0 .474.944l3.165 1.054a.746.746 0 0 0 .943-.943l-1.055-3.166a.746.746 0 1 0-1.415.472l.1.289a13.07 13.07 0 0 0-7.832-2.706 12.78 12.78 0 0 0-12.731 12.731 12.7 12.7 0 0 0 .972 4.756.746.746 0 0 0 1.383-.559 11.2 11.2 0 0 1-.863-4.2Z",
  "data-name": "Path 82068"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3791.491-3282.024a.746.746 0 0 0-1.383.559 11.137 11.137 0 0 1-10.377 15.436 11.55 11.55 0 0 1-6.472-2.081.736.736 0 0 0 .85-.483.745.745 0 0 0-.471-.943l-3.165-1.055a.746.746 0 0 0-.943.943l1.054 3.17a.746.746 0 0 0 1.415-.472l-.1-.289a13.07 13.07 0 0 0 7.829 2.707 12.628 12.628 0 0 0 11.763-17.492",
  "data-name": "Path 82069"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#443d66",
  d: "M3785.354-3285.944a.745.745 0 0 0 .471.943l3.165 1.055a.746.746 0 0 0 .943-.943l-1.055-3.165a.746.746 0 1 0-1.415.472l.1.289a13.07 13.07 0 0 0-7.832-2.707v1.492a11.55 11.55 0 0 1 6.472 2.081.734.734 0 0 0-.849.483",
  "data-name": "Path 82070"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#443d66",
  d: "M3792.462-3277.269a12.7 12.7 0 0 0-.972-4.756.746.746 0 0 0-1.383.559 11.137 11.137 0 0 1-10.376 15.437v1.492a12.78 12.78 0 0 0 12.731-12.732",
  "data-name": "Path 82071"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "calendar (2)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fd646f",
  d: "M3819-3295.618v2.293h-13.314v-2.293a.894.894 0 0 1 .893-.893h11.527a.894.894 0 0 1 .893.893",
  "data-name": "Path 82082"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fc4755",
  d: "M3809.26-3296.511v1.668a.3.3 0 0 1-.3.3h-1.366a.3.3 0 0 1-.3-.3v-1.668Z",
  "data-name": "Path 82083"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fc4755",
  d: "M3816.914-3296.511v1.668a.3.3 0 0 1-.3.3h-1.366a.3.3 0 0 1-.3-.3v-1.668Z",
  "data-name": "Path 82084"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fc4755",
  d: "M3806.163-3296.408v3.083h-.477v-2.293a.89.89 0 0 1 .477-.79",
  "data-name": "Path 82085"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#e6e6e6",
  "data-name": "Group 66350"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3808.128-3291.542h1.532a.15.15 0 0 1 .15.149v1.53a.15.15 0 0 1-.15.15h-1.532a.15.15 0 0 1-.149-.15v-1.531a.15.15 0 0 1 .15-.148",
  "data-name": "Path 82086"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3808.128-3289.265h1.532a.15.15 0 0 1 .15.149v1.533a.15.15 0 0 1-.15.149h-1.532a.15.15 0 0 1-.149-.15v-1.532a.15.15 0 0 1 .15-.15",
  "data-name": "Path 82087"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3808.128-3286.988h1.532a.15.15 0 0 1 .15.149v1.532a.15.15 0 0 1-.15.149h-1.532a.15.15 0 0 1-.149-.15v-1.531a.15.15 0 0 1 .15-.15",
  "data-name": "Path 82088"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3810.406-3291.542h1.565a.15.15 0 0 1 .15.149v1.53a.15.15 0 0 1-.15.15h-1.565a.15.15 0 0 1-.149-.15v-1.531a.15.15 0 0 1 .15-.148",
  "data-name": "Path 82089"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3810.406-3289.265h1.565a.15.15 0 0 1 .15.149v1.533a.15.15 0 0 1-.15.149h-1.565a.15.15 0 0 1-.149-.15v-1.532a.15.15 0 0 1 .15-.15",
  "data-name": "Path 82090"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3810.406-3286.988h1.565a.15.15 0 0 1 .15.149v1.532a.15.15 0 0 1-.15.149h-1.565a.15.15 0 0 1-.149-.15v-1.531a.15.15 0 0 1 .15-.15",
  "data-name": "Path 82091"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3812.715-3291.542h1.565a.15.15 0 0 1 .15.149v1.53a.15.15 0 0 1-.15.15h-1.565a.15.15 0 0 1-.149-.15v-1.531a.15.15 0 0 1 .15-.148",
  "data-name": "Path 82092"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3812.715-3289.265h1.565a.15.15 0 0 1 .15.149v1.533a.15.15 0 0 1-.15.149h-1.565a.15.15 0 0 1-.149-.15v-1.532a.15.15 0 0 1 .15-.15",
  "data-name": "Path 82093"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3812.715-3286.988h1.565a.15.15 0 0 1 .15.149v1.532a.15.15 0 0 1-.15.149h-1.565a.15.15 0 0 1-.149-.15v-1.531a.15.15 0 0 1 .15-.15",
  "data-name": "Path 82094"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3816.705-3291.393v1.53a.15.15 0 0 1-.149.15h-1.53a.15.15 0 0 1-.15-.15v-1.531a.15.15 0 0 1 .15-.15h1.531a.15.15 0 0 1 .15.15Z",
  "data-name": "Path 82095"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3815.025-3289.265h1.532a.15.15 0 0 1 .15.149v1.533a.15.15 0 0 1-.15.149h-1.532a.15.15 0 0 1-.149-.15v-1.532a.15.15 0 0 1 .15-.15",
  "data-name": "Path 82096"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3815.025-3286.988h1.532a.15.15 0 0 1 .15.149v1.532a.15.15 0 0 1-.15.149h-1.532a.15.15 0 0 1-.149-.15v-1.531a.15.15 0 0 1 .15-.15",
  "data-name": "Path 82097"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#f5f5f5",
  d: "M3805.686-3293.533v9.44a.893.893 0 0 0 .893.894h11.527a.893.893 0 0 0 .893-.893v-9.441Z",
  "data-name": "Path 82098"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#50758d",
  d: "M3809.26-3297.7v2.38a.3.3 0 0 1-.3.3h-.889a.3.3 0 0 1-.3-.3v-2.38a.3.3 0 0 1 .3-.3h.893a.3.3 0 0 1 .296.3",
  "data-name": "Path 82099"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffac5c",
  d: "M3807.98-3291.542h1.83v1.83h-1.83Z",
  "data-name": "Path 82100"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffac5c",
  d: "M3814.876-3291.542h1.83v1.83h-1.83Z",
  "data-name": "Path 82101"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffac5c",
  d: "M3810.256-3291.542h1.863v1.83h-1.863Z",
  "data-name": "Path 82102"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffac5c",
  d: "M3807.98-3289.266h1.83v1.83h-1.83Z",
  "data-name": "Path 82103"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e6e6e6",
  d: "M3814.876-3289.266h1.83v1.83h-1.83Z",
  "data-name": "Path 82104"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffac5c",
  d: "M3810.256-3289.266h1.863v1.83h-1.863Z",
  "data-name": "Path 82105"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e6e6e6",
  d: "M3807.98-3286.988h1.83v1.83h-1.83Z",
  "data-name": "Path 82106"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e6e6e6",
  d: "M3814.876-3286.988h1.83v1.83h-1.83Z",
  "data-name": "Path 82107"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e6e6e6",
  d: "M3810.256-3286.988h1.863v1.83h-1.863Z",
  "data-name": "Path 82108"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffac5c",
  d: "M3812.566-3291.542h1.863v1.83h-1.863Z",
  "data-name": "Path 82109"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffac5c",
  d: "M3812.566-3289.266h1.863v1.83h-1.863Z",
  "data-name": "Path 82110"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e6e6e6",
  d: "M3812.566-3286.988h1.863v1.83h-1.863Z",
  "data-name": "Path 82111"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#50758d",
  d: "M3816.914-3297.7v2.38a.3.3 0 0 1-.3.3h-.889a.3.3 0 0 1-.3-.3v-2.38a.3.3 0 0 1 .3-.3h.894a.3.3 0 0 1 .295.3",
  "data-name": "Path 82112"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e6e6e6",
  d: "M3805.686-3293.533v9.44a.893.893 0 0 0 .893.894h.33a.89.89 0 0 1-.732-.88v-8.823a.24.24 0 0 1 .223-.155h12.6v-.476Z",
  "data-name": "Path 82113"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2b597f",
  d: "M3808.545-3295.022h-.474a.3.3 0 0 1-.3-.3v-2.378a.3.3 0 0 1 .3-.3h.18v2.68a.3.3 0 0 0 .294.298",
  "data-name": "Path 82114"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2b597f",
  d: "M3816.2-3295.022h-.475a.3.3 0 0 1-.3-.3v-2.378a.3.3 0 0 1 .3-.3h.18v2.68a.3.3 0 0 0 .294.298",
  "data-name": "Path 82115"
})))), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(16.66667 0 0 16.66666 -27770.669 120447.129)"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 61737",
  transform: "translate(-72 -2)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1.34397 0 0 1.40412 1695.896 -7228.53)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#00467d",
  d: "M46.234 10.664v1.574h-1.523v-1.574c0-1.759-1.904-2.858-3.427-1.979a2.29 2.29 0 0 0-1.143 1.979v1.574h-1.524v-1.574c-.048-2.932 3.097-4.816 5.659-3.391a3.81 3.81 0 0 1 1.958 3.391",
  "data-name": "Path 75965"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#033a5d",
  d: "M46.235 10.664v1.574h-1.523v-1.574a2.283 2.283 0 0 0-2.286-2.286V6.855a3.81 3.81 0 0 1 3.809 3.809",
  "data-name": "Path 75966"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffcb00",
  d: "M37.094 11.477v6.145h10.664v-6.145z",
  "data-name": "Path 75967"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ff9800",
  d: "M42.426 11.477h5.332v6.145h-5.332z",
  "data-name": "Path 75968"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M41.664 13h1.523v1.523h-1.523z",
  "data-name": "Path 75969"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M42.426 13h.762v1.523h-.762z",
  "data-name": "Path 75970"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(1749 -7221)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#707070",
  d: "m43.437 22.346 6.415-3.207.681 1.363-6.414 3.207Z",
  "data-name": "Path 75953"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#707070",
  d: "M50.805 8.379h1.523v9.242h-1.523Z",
  "data-name": "Path 75954"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#707070",
  d: "m43.444 3.655.682-1.363 6.414 3.207-.681 1.363Z",
  "data-name": "Path 75955"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#707070",
  d: "m34.298 20.507.682-1.363 6.414 3.207-.681 1.363Z",
  "data-name": "Path 75956"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#707070",
  d: "m34.304 5.492 6.415-3.207.681 1.363-6.414 3.207Z",
  "data-name": "Path 75957"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#707070",
  d: "M32.523 8.379h1.523v9.242h-1.523Z",
  "data-name": "Path 75958"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 61723",
  transform: "translate(31)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#4fabf7",
  d: "M11.426 0a2.285 2.285 0 1 0 2.285 2.285A2.28 2.28 0 0 0 11.426 0",
  "data-name": "Path 75959"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4fabf7",
  d: "M11.426 21.43a2.285 2.285 0 1 0 2.285 2.285 2.28 2.28 0 0 0-2.285-2.285",
  "data-name": "Path 75960"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4fabf7",
  d: "M2.285 21.429a2.285 2.285 0 1 1 2.285-2.285 2.29 2.29 0 0 1-2.285 2.285",
  "data-name": "Path 75961"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4fabf7",
  d: "M2.285 9.14A2.285 2.285 0 1 1 4.57 6.855 2.29 2.29 0 0 1 2.285 9.14",
  "data-name": "Path 75962"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1886ea",
  d: "M20.566 9.14c-1.759 0-2.858-1.904-1.979-3.428.88-1.523 3.078-1.523 3.958 0a2.289 2.289 0 0 1-1.979 3.428",
  "data-name": "Path 75963"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1886ea",
  d: "M20.566 21.429c-1.759 0-2.858-1.904-1.979-3.428.88-1.523 3.078-1.523 3.958 0a2.289 2.289 0 0 1-1.979 3.428",
  "data-name": "Path 75964"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1886ea",
  d: "M13.711 23.715A2.28 2.28 0 0 1 11.426 26v-4.57a2.28 2.28 0 0 1 2.285 2.285",
  "data-name": "Path 75971"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1886ea",
  d: "M11.426 4.57V0c1.759 0 2.858 1.904 1.979 3.428a2.29 2.29 0 0 1-1.979 1.142",
  "data-name": "Path 75972"
}))))));

const SvgEinvoiceCompleted = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024",
  width: "1em",
  height: "1em"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M102.502 544.87V288.836c.069-47.684 52.975-85.23 121.037-85.606 49.937-.273 99.908 0 149.846-.137 6.075 0 8.157 1.024 7.953 5.462a273 273 0 0 0 0 28.433c.239 4.778-1.536 6.28-8.67 6.246q-72.704-.273-145.442-.068c-32.154.068-57.788 13.278-65.57 33.314-1.639 4.233-1.878 8.533-1.878 12.868v511.557c0 27.204 27.307 45.977 67.38 46.045q123.391.103 246.817.069 146.774 0 293.547-.069c32.085 0 57.412-12.663 65.434-32.426 2.048-5.018 2.423-10.138 2.423-15.326 0-33.587-4.198-153.395-4.437-187.05-.068-4.711 1.604-6.486 8.738-6.247 13.79.41 27.17.205 40.96 0 5.393-.103 7.031 1.16 6.997 4.915-.204 36.523 5.291 159.266 4.438 195.755-.956 39.73-47.514 74.786-104.244 79.667-24.576 2.082-49.288.956-73.966.956q-243.303.17-486.605.034c-60.416 0-109.875-27.307-122.266-67.175a68.3 68.3 0 0 1-2.594-20.309zm598.05-341.708q34.817-.035 69.633 0c68.949.273 122.094 37.717 122.129 86.016 0 23.552-5.12 79.872-4.847 103.355 6.246.137.068 4.335 0 0 13.482-.341-13.517-.307 0 0-6.827.171-51.2 0-51.2 0 .375-22.664-.888-78.643-.922-101.307 0-28.604-26.863-47.855-67.584-48.06-48.47-.24-96.939-.137-145.408.034-6.758 0-9.25-1.024-8.909-6.076a239 239 0 0 0 0-27.818c-.239-4.78 1.468-6.35 8.67-6.28 26.146.34 52.292.136 78.439.136"
}), /*#__PURE__*/React.createElement("path", {
  d: "M497.562 246.409h-94.277c-4.164 0-8.055.546-7.611-4.199 2.082-23.723 9.08-46.455 25.565-67.481a102.4 102.4 0 0 1 25.054-22.938 93.18 93.18 0 0 1 101.445-.512c22.391 14.37 34.747 32.904 42.94 53.009 4.778 11.742 6.826 23.757 8.499 35.874.614 4.676-.786 6.554-8.227 6.349-15.53-.41-31.13-.137-46.694-.137zm24.337-56.798c.102-9.319-11.196-17.238-24.576-17.204s-24.576 8.022-24.406 17.408c.171 9.046 11.264 16.794 24.235 16.93 13.21.171 24.678-7.748 24.747-17.134m-25.19 113.425H327.611c-2.56 0-6.35.341-7.373-.683-2.048-1.877 1.331-3.652 2.73-5.256 14.849-16.726 34.612-30.038 58.198-40.62a27.3 27.3 0 0 1 11.537-2.32q104.858.102 209.647.034c3.925 0 7.373.512 10.752 2.048 23.927 10.615 43.895 24.03 58.88 40.96 1.297 1.536 4.164 3.072 2.867 4.847-1.365 1.877-4.813.887-7.27.887q-85.402.069-170.872.034z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00B259",
  d: "M380.45 596.617c-39.117 0-78.268-.103-117.419.102-4.061 0-5.802-1.297-5.188-7.066.205-1.809.103-3.72.034-5.563q-.17-3.892 2.663-3.55c.75.102 1.502 0 2.253 0q117.896 0 235.724.102c1.536 0 4.199-1.672 4.506 1.877.41 4.404.99 9.182-.444 13.312-.614 1.741-2.799.717-4.266.717q-58.915.069-117.863.069m.137-69.086c39.082 0 78.233.102 117.35-.137 4.096 0 5.803 1.365 5.12 7.1a17 17 0 0 0 0 3.686c.512 4.438-.956 5.462-4.028 5.462-14.302-.205-28.57-.103-42.871-.103q-96.393 0-192.751-.068c-1.843 0-4.676 1.57-5.29-1.365a34.1 34.1 0 0 1 .102-13.415c.512-2.287 2.662-1.126 4.096-1.126l101.103-.034zm-.034 122.095c-39.151 0-78.268-.103-117.42.102-4.027.034-5.529-1.195-5.29-7.066.444-10.513-.956-9.01 6.861-9.01q116.94-.07 233.882.033c1.57 0 4.198-1.536 4.505 1.912.41 4.369 1.024 9.148-.444 13.278-.648 1.706-2.798.716-4.266.716H380.518Zm117.623 37q113.664 0 227.362.068c3.618 0 9.216-1.365 10.48 1.366a18.1 18.1 0 0 1 0 13.38c-.547 1.74-4.063 1.195-6.316 1.195h-33.45c-143.053 0-286.14-.069-429.159.102-7.577 0-9.489-1.672-9.216-6.656.683-11.093-1.4-9.42 13.824-9.42q113.255-.035 226.475 0Zm0 52.907c76.356 0 152.713.17 229.069-.17 9.967-.035 9.694 3.14 9.728 8.089 0 5.051.102 8.123-9.796 8.123-153.02-.238-306.04-.17-459.094-.238-3.242 0-8.465 1.365-9.42-1.502-1.434-4.267-1.946-9.08.409-13.312 1.092-1.98 5.359-.922 8.192-.922q115.473-.102 230.878-.068ZM327.373 419.908c0 10.172-.41 20.344.17 30.515.342 5.223-2.048 6.622-9.318 6.486-17.067-.273-17.1 0-17.1-12.083 0-24.099.17-48.23-.137-72.363-.069-5.188 1.638-7.236 9.762-6.997 16.384.443 16.418.102 21.436 11.434 3.89 8.773 7.748 17.545 13.55 26.146 0-10.342.376-20.684-.17-31.027-.273-5.12 1.945-6.656 9.318-6.485 17.101.307 17.101 0 17.101 11.98 0 24.577-.205 49.084.17 73.592.069 4.745-1.945 5.871-8.43 5.803-19.354-.103-19.354.068-24.61-13.107l-9.694-24.064zm212.002-8.499c0 8.226.444 16.452-.068 24.678-.888 14.234-14.575 22.7-36.182 22.802-20.923.136-34.577-8.056-36.044-22.119-1.673-16.043-.615-32.085-.512-48.128.102-17.237 17.305-27.648 46.523-24.132 15.736 1.877 25.259 10.172 26.283 21.606l.102 2.458v22.87zm-31.232-.205c0-8.635.102-17.271-.034-25.873-.034-2.594.375-6.11-4.881-6.144-5.223-.102-5.29 3.482-5.325 6.008a2082 2082 0 0 0 0 52.36c.034 2.39-.444 6.11 5.325 5.803 5.29-.307 4.778-3.72 4.813-6.28.17-8.602.068-17.238.068-25.874m-87.347 11.81c2.048-16.861 4.437-33.382 5.905-49.937.512-5.53 2.355-8.43 11.161-7.509 7.168.683 16.726-2.185 21.163 1.126 4.608 3.414.068 9.763-.785 14.78-3.994 23.689-8.329 47.377-12.39 71.032-.513 2.935-1.775 4.437-6.452 4.369a1195 1195 0 0 0-36.932 0c-4.608.068-6.178-1.297-6.758-4.165q-8.124-40.96-16.52-81.851c-.854-4.096.887-5.291 6.826-5.36 26.248-.306 26.146-.409 28.194 18.194q1.911 16.589 4.198 33.177c.24 1.98-.068 4.096 2.39 6.144m207.36-11.468c0 8.67-.171 17.305.102 25.94.102 2.56.137 5.872 5.598 5.94 5.973.068 5.94-3.345 6.144-6.178.307-3.925.478-7.85.102-11.742-.41-3.891 1.912-5.188 7.134-4.813 2.048.137 4.096 0 6.144 0 19.422 0 19.285 0 18.09 13.551-.853 9.694-5.256 17.92-18.91 21.914-14.984 4.369-29.9 3.857-43.758-2.39-6.52-2.97-9.83-7.748-10.65-13.038-3.003-18.91-2.491-37.854-.682-56.764 1.024-9.967 9.625-16.111 23.04-18.842a68.3 68.3 0 0 1 27.784.103c12.288 2.56 20.037 8.021 22.119 17.271 1.433 6.144 1.024 12.288 1.33 18.5.137 2.8-1.091 4.165-5.426 4.096a410 410 0 0 0-20.241 0c-4.71.103-6.11-1.263-5.94-4.437a205 205 0 0 0-.068-16.043c-.068-2.525-.58-5.222-5.188-5.563-5.393-.376-6.417 2.662-6.485 5.29-.308 9.08-.103 18.125-.103 27.205zm55.842-.273c0-13.415.205-26.795-.137-40.21-.102-4.3 1.741-5.7 7.953-5.563q18.944.512 37.888 0c6.042-.137 7.953 1.502 7.168 5.359v.614c.17 11.435.17 11.537-15.701 12.152-3.994.136-6.11.853-5.7 3.857.136 1.024 0 2.048 0 3.106-.034 10.103-.034 10.24 14.336 10.683 4.232.137 5.87 1.093 5.461 3.994-.102 1.024 0 2.048 0 3.072.068 9.626.068 9.796-13.483 9.967-5.188.068-6.826 1.468-6.314 4.779.17 1.024 0 2.048 0 3.072 0 12.049-.034 12.185 16.93 12.629 4.983.137 6.383 1.297 6.485 4.745.512 13.312.683 13.312-17.783 13.312-9.114 0-18.262-.342-27.307.068-7.51.375-10.24-.99-10.001-6.69.683-12.971.239-25.942.205-38.912zm-396.561-.205c0 13.38-.205 26.794.136 40.175.103 4.164-1.297 5.666-7.68 5.7-23.893.068-23.893.205-23.893-16.486 0-23.075.102-46.149-.17-69.223-.07-4.198 1.467-5.632 7.747-5.666 23.894-.205 23.894-.341 23.894 16.452zm264.874.648c0-13.38.205-26.76-.136-40.14-.137-4.404 1.16-6.554 8.124-6.042q8.328.546 16.725 0c5.632-.273 6.86 1.468 6.827 5.052q-.24 40.755.068 81.578c0 3.926-2.15 4.915-7.27 4.71a205 205 0 0 0-17.58 0c-5.597.274-6.928-1.365-6.826-4.983.239-13.414.102-26.794.068-40.175"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00B259",
  d: "M989.047 421.069c0 12.083-4.778 23.79-13.346 32.324L763.29 665.805a45.74 45.74 0 0 1-64.615 0L592.828 560.06a45.739 45.739 0 0 1 64.648-64.546L731 569.003l180.054-180.156a45.739 45.739 0 0 1 77.994 32.222"
}));

const SvgEinvoiceConsolidate = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024",
  width: "1em",
  height: "1em"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#E9E9E9",
  d: "M460.8 102.4a426.667 426.667 0 1 0 0 853.333 426.667 426.667 0 1 0 0-853.333"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF1DD",
  d: "M846.677 599.518c3.414 2.662 97.588-4.199 137.148 4.028 0 0 30.652-134.144-57.378-139.435s-118.58 49.22-118.58 49.22z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFB13D",
  d: "m753.664 457.762 172.783 6.349s-62.942.853-55.979 80.691 42.462 313.003-47.65 313.242-91.545-41.063-91.545-41.063l22.425-359.219Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF1DD",
  d: "m672.973 420.318 66.799-15.6s44.646-4.027 50.688 35.773 4.266 275.592 2.39 324.232 2.661 86.016 29.934 93.32l-198.485 3.448z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F5F5F5",
  d: "M863.334 635.119a2.05 2.05 0 0 1-2.048-1.946c0-.546-3.276-54.613-9.113-99.567-6.042-46.694 19.422-56.524 20.48-56.934a2.05 2.05 0 0 1 2.662 1.229 2.05 2.05 0 0 1-1.229 2.628c-.955.341-23.45 9.318-17.851 52.565 5.836 45.09 9.113 99.328 9.147 99.84a2.05 2.05 0 0 1-1.911 2.185z",
  style: {
    mixBlendMode: "soft-light"
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFBC58",
  d: "M537.259 423.56s121.583 6.69 202.513-18.841c0 0-53.794-3.686-53.794 120.9 0 95.232 14.063 277.095 1.775 311.603s-58.3 80.896-124.246 41.029c-65.911-39.868-26.282-454.69-26.282-454.69Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M670.174 695.91a2.05 2.05 0 0 1-2.048-2.013c0-.069-.137-6.52-.751-28.672a2.048 2.048 0 1 1 4.096-.137c.614 22.187.717 28.672.717 28.74a2.05 2.05 0 0 1-1.98 2.082z",
  style: {
    mixBlendMode: "soft-light"
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F5F5F5",
  d: "M668.672 641.81a2.05 2.05 0 0 1-2.048-1.98c-.41-14.405-1.126-30.38-1.843-47.241-.956-22.801-1.98-46.422-2.526-69.12-1.4-59.972 8.465-82.978 16.964-91.716 4.642-4.78 8.534-4.916 8.943-4.916a2.048 2.048 0 0 1 .068 4.096c-.477.069-23.995 2.663-21.845 92.433.512 22.7 1.502 46.251 2.492 69.052.717 16.896 1.433 32.836 1.843 47.309a2.05 2.05 0 0 1-1.98 2.082z",
  style: {
    mixBlendMode: "overlay"
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF1DD",
  d: "M504.9 236.749s134.144 14.677 151.45-8.124c0 0-13.756-41.062-54.58-38.332S504.9 236.75 504.9 236.75"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FF9800",
  d: "M68.574 282.965c11.673 131.823 36.25 410.727 46.967 546.577 2.39 30.277 26.556 54.204 56.798 56.15 107.69 6.929 350.072 20.377 443.05 7.85a62.12 62.12 0 0 1-34.508-56.183l4.95-609.621c.17-21.504 21.538-37 41.642-29.457q19.012 7.168 28.877 30.344c-8.772-25.668-22.596-44.442-54.58-38.332 0 0-312.831 3.14-464.622 12.596A73.59 73.59 0 0 0 68.54 282.93Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF1DD",
  d: "m145.954 220.33 420.318-16.213c-17.34 128.683-10.035 390.827-3.413 649.148.41 15.36 9.352 29.116 23.176 35.67 0 0-280.371 3.242-400.862-5.325a60.76 60.76 0 0 1-55.705-51.747C112.98 721.17 73.387 435.2 81.647 283.887a67.106 67.106 0 0 1 64.307-63.556"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M148.48 362.53c59.05-1.4 285.935-7.134 343.21-8.533 7.237-.205 13.21 4.266 13.21 9.898 0 5.291-5.461 9.694-12.288 9.9l-343.04 9.83c-6.622.204-12.322-3.55-13.175-8.636l-.205-1.263c-.99-5.803 4.71-10.991 12.288-11.196m-3.755 62.26c1.024 1.296 2.868 2.081 4.779 2.047l235.554-3.96c2.97-.033 5.325-1.91 5.325-4.198V406.63c0-2.389-2.526-4.3-5.632-4.198l-228.966 6.622c-10.206.307-16.282 8.943-11.06 15.735m24.576 382.567c44.613.478 215.894 1.945 259.14 2.32 5.462.07 9.763 4.711 9.524 10.31a9.796 9.796 0 0 1-9.694 9.522l-259.038-1.024a9.73 9.73 0 0 1-9.557-9.045l-.103-1.297a9.9 9.9 0 0 1 9.728-10.786"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FF9800",
  d: "m231.492 316.69-1.536-58.71 10.24-.273 1.536 58.709zm63.625-1.708-13.312.342-19.217-41.984h-.512q1.126 4.847 1.297 10.376l.853 32.086-10.103.273-1.536-58.71 13.346-.341 19.046 41.609h.444a58 58 0 0 1-1.024-10.036l-.853-32.017 10.035-.273 1.536 58.71Zm33.962-59.665 10.991-.273-12.253 59.05-13.824.376-15.258-58.333 10.99-.274 8.602 35.636q1.127 4.608 2.39 13.073.648-7.27 1.74-13.176zm55.945 27.853q.375 14.575-4.847 22.528a17.75 17.75 0 0 1-15.36 8.26 17.75 17.75 0 0 1-15.838-7.407q-5.666-7.68-6.041-22.357-.376-14.575 4.88-22.494a18.09 18.09 0 0 1 15.463-8.192 17.75 17.75 0 0 1 15.77 7.407q5.632 7.68 5.973 22.255m-30.959.82q.307 10 2.936 15.223 2.662 5.154 7.543 5.052 9.899-.24 9.318-20.822-.512-20.548-10.308-20.275-4.983.102-7.373 5.427t-2.116 15.36Zm42.223 28.33-1.536-58.71 10.24-.272 1.57 58.709zm40.721-51.132q-4.71.137-7.236 5.7-2.56 5.633-2.321 15.36.546 20.412 11.161 20.14a19.46 19.46 0 0 0 9.66-3.243l.239 9.728a19.46 19.46 0 0 1-10.889 3.14 17.07 17.07 0 0 1-15.394-7.51q-5.53-7.714-5.905-22.016t4.881-22.425a17.41 17.41 0 0 1 15.019-8.397 21.5 21.5 0 0 1 12.527 3.652l-3.38 8.943a34 34 0 0 0-3.89-2.15 10.24 10.24 0 0 0-4.472-.922m46.25 48.81-26.384.684-1.57-58.71 26.385-.682.273 9.455-15.497.41.341 13.994 14.405-.41.239 9.49-14.336.34.41 16.282 15.496-.41z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M511.283 761.754H159.95a8.875 8.875 0 0 1-8.67-8.09l-26.112-272.213a8.875 8.875 0 0 1 8.533-9.865l363.964-7.646a8.875 8.875 0 0 1 8.875 8.534l13.448 279.859a8.875 8.875 0 0 1-8.704 9.42"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#9B9B9B",
  d: "M511.283 763.255H159.95a10.24 10.24 0 0 1-10.172-9.454l-26.112-272.18a10.58 10.58 0 0 1 2.628-8.123 10.24 10.24 0 0 1 7.339-3.414l363.998-7.68a10.24 10.24 0 0 1 10.41 10.001l13.415 279.86a10.58 10.58 0 0 1-2.867 7.85 10.24 10.24 0 0 1-7.305 3.175Zm-13.448-297.813h-.137L133.7 473.088a6.83 6.83 0 0 0-5.188 2.423 7.85 7.85 0 0 0-1.843 5.803l26.112 272.18c.341 3.856 3.413 6.758 7.168 6.758h351.3c1.946 0 3.755-.785 5.12-2.253a7.5 7.5 0 0 0 2.082-5.598l-13.414-279.893a7.305 7.305 0 0 0-7.202-7.1Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF1DD",
  d: "M428.954 760.934a1.5 1.5 0 0 1-1.502-1.4l-18.774-289.177a1.502 1.502 0 1 1 3.004-.204l18.773 289.177a1.5 1.5 0 0 1-1.399 1.604z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#9B9B9B",
  d: "M132.574 512.034a2.116 2.116 0 0 1-.034-4.232l372.326-8.329a2.15 2.15 0 0 1 2.15 2.082 2.05 2.05 0 0 1-2.047 2.15z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#9B9B9B",
  d: "M132.54 557.33a1.502 1.502 0 0 1 0-3.005l375.398-9.01c.853 0 1.536.648 1.57 1.467a1.5 1.5 0 0 1-1.467 1.536l-375.467 9.011Zm3.515 44.884a1.502 1.502 0 0 1 0-3.003l376.457-7.1c.853 0 1.502.683 1.536 1.502a1.5 1.5 0 0 1-1.468 1.536l-376.49 7.065Zm4.984 41.131a1.502 1.502 0 0 1 0-3.004l373.692-3.413a1.502 1.502 0 0 1 0 3.072zm4.744 48.128a1.502 1.502 0 0 1 0-3.004l366.729-5.12c.82 0 1.502.649 1.536 1.468 0 .82-.683 1.536-1.502 1.536l-366.728 5.12h-.069Z",
  opacity: 0.39
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF1DD",
  d: "M149.606 730.35a1.502 1.502 0 0 1 0-3.037l365.125-6.246a1.434 1.434 0 0 1 1.502 1.467 1.5 1.5 0 0 1-1.468 1.536l-365.124 6.28Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FF9800",
  d: "M288.256 807.663q-1.707 0-3.55-2.458c-4.847-6.485-5.973-16.69-6.246-26.214q-3.516 5.768-7.1 11.264l-.785-1.092q3.925-6.11 7.85-12.527c-.238-12.8.171-25.703 1.161-38.4.615-7.749 1.502-15.94 3.789-23.382a20.5 20.5 0 0 1 3.96-7.782c2.082-2.15 4.812-2.39 6.655-.58 2.048 2.014 2.629 5.905 2.868 8.67 1.433 16.554-2.97 31.744-6.93 41.574a147 147 0 0 1-10.41 20.48c.205 9.694 1.092 20.31 5.94 26.795q1.535 2.116 2.866 2.048c1.468-.069 2.594-2.048 3.516-3.994q6.076-12.63 9.318-27.204a34.1 34.1 0 0 1 1.639-8.329l1.024.546q-.683 4.096-1.57 8.124a34.1 34.1 0 0 0 .204 8.363c.205 1.502 1.093 6.485 3.653 7.168 1.945.546 3.823-1.434 5.973-6.212l7.51-16.726-.683 4.403c-.376 2.458-1.024 8.363 1.433 9.83 1.4.854 2.902-.34 4.438-1.638 1.536-1.263 3.106-2.56 4.847-2.218l.58.102-.103.82c-.41 3.413-.204 7.645 1.707 8.26 1.229.41 2.253-.956 3.413-2.56 1.024-1.332 2.048-2.731 3.346-3.175l.273 1.57c-1.024.342-1.98 1.605-2.868 2.8-1.263 1.706-2.594 3.55-4.437 2.935-2.458-.785-2.97-5.12-2.628-9.216-1.16.102-2.355 1.058-3.584 2.082-1.707 1.433-3.516 2.901-5.393 1.74-1.81-1.057-2.663-3.89-2.492-7.987l-4.437 9.9c-1.536 3.378-3.926 7.782-7.1 6.894-2.185-.614-3.891-3.755-4.506-8.43a34 34 0 0 1-.341-3.756q-3.174 12.118-8.294 22.87c-1.093 2.253-2.458 4.574-4.404 4.676h-.102Zm2.867-100.796a4.44 4.44 0 0 0-3.14 1.502 17.1 17.1 0 0 0-3.584 7.168c-2.219 7.236-3.072 15.258-3.686 22.87a405 405 0 0 0-1.23 36.42c3.482-5.94 6.76-12.186 9.49-18.91 3.891-9.626 8.192-24.44 6.792-40.55-.341-3.892-1.092-6.281-2.389-7.544a3.4 3.4 0 0 0-2.253-.956M792.27 331.093a91.82 91.82 0 0 0 0-129.706 91.273 91.273 0 0 0-129.331 0 91.82 91.82 0 0 0 0 129.706 91.273 91.273 0 0 0 129.365 0Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#einvoice-consolidate_svg__a)",
  d: "M786.295 325.905a83.15 83.15 0 0 0 0-117.35 82.603 82.603 0 0 0-117.043 0 83.15 83.15 0 0 0 0 117.35 82.603 82.603 0 0 0 117.078 0Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#einvoice-consolidate_svg__b)",
  d: "m814.08 243.985.785 69.154.102 10.718a2.56 2.56 0 0 1-2.423 2.628l-137.011 4.847a2.526 2.526 0 0 1-2.594-2.457l-.546-10.684-3.414-68.233a4.437 4.437 0 0 1 4.54-4.096l133.768-8.192a6.383 6.383 0 0 1 6.759 6.315Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#7D97F4",
  d: "M811.554 321.81a2.39 2.39 0 0 1-2.32 2.457l-130.493 4.608a2.39 2.39 0 0 1-2.526-2.253l-3.652-73.66c-.068-1.297 1.4-3.891 4.267-3.789l127.42-7.782a6.14 6.14 0 0 1 4.54 1.604 5.8 5.8 0 0 1 1.91 4.301z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M794.556 325.632a.51.51 0 0 1-.512-.478q.034-.512.478-.546l14.609-.512a3.41 3.41 0 0 0 2.32-1.16 3.41 3.41 0 0 0 .956-2.39l-1.57-44.817q.034-.444.478-.512.512.034.546.478l1.57 44.817a4.44 4.44 0 0 1-1.228 3.14 4.44 4.44 0 0 1-3.038 1.468z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M673.621 281.122a.51.51 0 0 1-.512-.512l-.921-26.863a5.8 5.8 0 0 1 1.297-3.891 4.78 4.78 0 0 1 3.618-1.843l11.605-.41q.478.034.512.478a.51.51 0 0 1-.478.546l-11.605.41a3.76 3.76 0 0 0-2.833 1.468 4.78 4.78 0 0 0-1.092 3.208l.921 26.863a.51.51 0 0 1-.478.546Z",
  style: {
    mixBlendMode: "soft-light"
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#einvoice-consolidate_svg__c)",
  d: "m703.898 274.91-16.93.58a2.526 2.526 0 0 0-2.424 2.628l.444 12.937a2.526 2.526 0 0 0 2.628 2.423l16.896-.58a2.526 2.526 0 0 0 2.458-2.628l-.444-12.903a2.526 2.526 0 0 0-2.628-2.457"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M692.565 287.983a1.37 1.37 0 0 1-.853-.341 1.37 1.37 0 0 1-.41-.888l-.136-4.267a1.365 1.365 0 0 1 1.229-1.33l4.812-.171q.547 0 .922.34a1.37 1.37 0 0 1 .41.888l.136 4.267c0 .683-.512 1.297-1.229 1.331l-4.812.17zm4.677-5.973-4.813.17a.34.34 0 0 0-.273.273l.17 4.267q0 .102.069.17l.204.069 4.78-.17q.272 0 .272-.274l-.136-4.232a.34.34 0 0 0-.273-.273",
  opacity: 0.8
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M684.749 284.194a.51.51 0 0 1-.512-.478q0-.512.512-.546l6.929-.239q.478.034.512.478a.51.51 0 0 1-.478.546l-6.93.24zm.068 1.74a.51.51 0 0 1-.512-.477q.034-.512.478-.546l6.963-.239q.478.034.512.478a.51.51 0 0 1-.478.546zm14.404-2.252a.512.512 0 0 1 0-1.024l7.51-.273q.478 0 .512.512a.51.51 0 0 1-.478.512l-7.51.273zm.069 1.74a.51.51 0 0 1-.512-.477q.034-.512.477-.546l7.51-.273q.546 0 .546.512a.51.51 0 0 1-.478.512zm-6.076-3.242a.68.68 0 0 1-.512-.341l-1.707-6.28a.512.512 0 1 1 1.024-.274l1.707 6.247a.512.512 0 0 1-.512.682Zm4.028-.136h-.103a.51.51 0 0 1-.41-.615l1.332-6.383a.512.512 0 1 1 1.024.205l-1.366 6.383a.68.68 0 0 1-.477.41m-5.12 11.98h-.103a.51.51 0 0 1-.41-.614l1.298-6.349a.51.51 0 0 1 .58-.41q.444.171.41.615l-1.263 6.349a.51.51 0 0 1-.512.41m7.065-.24a.68.68 0 0 1-.478-.375l-1.775-6.246a.512.512 0 1 1 1.024-.273l1.741 6.246a.51.51 0 0 1-.341.614z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#BDD0FB",
  d: "m702.737 255.18-18.876.683a3.07 3.07 0 0 0-2.901 3.107v.34a3.07 3.07 0 0 0 3.14 2.936l18.842-.682a3.07 3.07 0 0 0 2.901-3.106v-.342a3.07 3.07 0 0 0-3.106-2.935m6.485 48.606a2.9 2.9 0 0 1-2.764 2.97l-20.89.716a2.867 2.867 0 0 1-2.97-2.765v-.034a2.867 2.867 0 0 1 2.765-3.004l20.89-.75a2.9 2.9 0 0 1 2.97 2.798zm30.106-1.093a2.9 2.9 0 0 1-2.799 2.97l-20.89.75a2.9 2.9 0 0 1-2.97-2.764v-.068a2.867 2.867 0 0 1 2.766-2.97l20.89-.75a2.9 2.9 0 0 1 2.969 2.798zm30.037-1.058a2.9 2.9 0 0 1-2.73 2.97l-20.89.75a2.867 2.867 0 0 1-.205-5.802l20.856-.75a2.9 2.9 0 0 1 3.003 2.764v.068Zm6.827-3.14 20.89-.75a2.867 2.867 0 0 1 2.97 2.798v.034a2.867 2.867 0 0 1-2.766 2.97l-20.89.75a2.867 2.867 0 0 1-2.969-2.764v-.068a2.867 2.867 0 0 1 2.765-2.97"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#BDD0FB",
  d: "m688.128 314.982 38.81-1.365a2.287 2.287 0 0 1 2.389 2.185v.068a2.287 2.287 0 0 1-2.219 2.39l-38.81 1.365a2.287 2.287 0 0 1-2.389-2.22v-.067a2.287 2.287 0 0 1 2.219-2.39Zm108.885-2.696a2.287 2.287 0 0 1-2.218 2.39l-16.862.58a2.287 2.287 0 0 1-2.355-2.22v-.033a2.287 2.287 0 0 1 2.218-2.39l16.828-.58a2.287 2.287 0 0 1 2.39 2.219v.068Z",
  opacity: 0.8
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FF9800",
  d: "M714.957 225.417a20.275 20.275 0 0 0-15.121-37.547 20.275 20.275 0 0 0 15.12 37.547"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M690.756 198.997q-.205 0-.341-.068a.785.785 0 0 1-.341-1.024 19.46 19.46 0 0 1 20.82-10.445.82.82 0 0 1 .65.922.785.785 0 0 1-.922.648 17.89 17.89 0 0 0-19.183 9.558.68.68 0 0 1-.683.443Z",
  opacity: 0.71
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M719.94 219.204a17.17 17.17 0 0 0 0-24.234 17.067 17.067 0 0 0-24.166 0 17.17 17.17 0 0 0 0 24.234 17.067 17.067 0 0 0 24.166 0",
  opacity: 0.71
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FF9800",
  d: "M706.185 219.819v-1.844a13.7 13.7 0 0 1-5.223-1.126 1.024 1.024 0 0 1-.614-1.297l.478-1.707a1.092 1.092 0 0 1 1.467-.716c1.366.546 3.038 1.024 4.813 1.024 1.81 0 3.277-.683 3.277-1.946 0-1.195-1.092-1.877-3.686-2.594-3.687-1.024-6.35-2.628-6.35-5.905 0-2.936 2.151-5.189 5.906-5.803v-1.877c0-.58.478-1.058 1.058-1.058h1.092c.615 0 1.092.477 1.092 1.058v1.706a13.7 13.7 0 0 1 4.13.717 1.024 1.024 0 0 1 .683 1.331l-.443 1.605a1.09 1.09 0 0 1-1.434.716 10.2 10.2 0 0 0-4.062-.75c-2.184 0-2.833.921-2.833 1.774 0 1.024 1.331 1.707 4.198 2.595 4.13 1.228 5.837 2.935 5.837 6.041 0 2.8-2.082 5.36-6.144 5.974v2.082a1.024 1.024 0 0 1-1.058 1.092h-1.092a1.024 1.024 0 0 1-1.092-1.092m94.958-30.038a35.157 35.157 0 1 0-68.505-15.974 35.157 35.157 0 1 0 68.505 15.974"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m737.894 167.936-.34-.102a.785.785 0 0 1-.342-1.024 33.11 33.11 0 0 1 35.703-17.818c.41.068.683.478.615.887a.785.785 0 0 1-.922.649 31.74 31.74 0 0 0-34.03 16.964.68.68 0 0 1-.684.444",
  opacity: 0.71
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M779.435 210.022a29.9 29.9 0 0 0-23.552-54.852 29.9 29.9 0 0 0-15.565 39.253 29.696 29.696 0 0 0 39.117 15.6",
  opacity: 0.71
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FF9800",
  d: "M764.757 204.766v-3.277a27.3 27.3 0 0 1-9.113-1.98 1.88 1.88 0 0 1-1.024-2.218l.819-3.004a1.877 1.877 0 0 1 2.56-1.263 20.5 20.5 0 0 0 8.397 1.775c3.106 0 5.666-1.092 5.666-3.345 0-2.048-1.877-3.277-6.383-4.506-6.451-1.775-11.093-4.574-11.093-10.274 0-5.12 3.754-9.08 10.24-10.103v-3.277c0-1.024.887-1.877 1.911-1.877h1.912c1.024 0 1.877.853 1.877 1.877v2.935c3.14.137 5.393.683 7.202 1.297.922.342 1.434 1.332 1.195 2.253l-.751 2.833a1.877 1.877 0 0 1-2.492 1.263 20.5 20.5 0 0 0-7.066-1.297c-3.857 0-4.983 1.604-4.983 3.072 0 1.74 2.321 2.97 7.339 4.506 7.168 2.15 10.137 5.12 10.137 10.513 0 4.915-3.618 9.318-10.684 10.445v3.618a1.877 1.877 0 0 1-1.877 1.911h-1.911a1.877 1.877 0 0 1-1.878-1.911Zm52.839 84.207a36.35 36.35 0 0 0 0-51.337 36.18 36.18 0 0 0-51.2 0 36.386 36.386 0 0 0 0 51.337 36.18 36.18 0 0 0 51.2 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M762.163 249.003q-.205 0-.341-.069a.785.785 0 0 1-.341-1.058 34.13 34.13 0 0 1 36.693-18.33.785.785 0 0 1-.307 1.57 32.77 32.77 0 0 0-35.021 17.443.68.68 0 0 1-.683.444",
  opacity: 0.71
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M821.043 276.07a30.72 30.72 0 0 0-16.316-40.277 30.72 30.72 0 0 0-23.859 56.593 30.583 30.583 0 0 0 40.175-16.316",
  opacity: 0.71
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FF9800",
  d: "M789.777 286.925v-3.345a27.3 27.3 0 0 1-9.352-2.048 2.05 2.05 0 0 1-1.059-2.287l.854-3.072a1.946 1.946 0 0 1 2.628-1.297 23.9 23.9 0 0 0 8.636 1.809c3.208 0 5.802-1.127 5.802-3.448 0-2.116-1.911-3.379-6.553-4.608-6.622-1.843-11.4-4.744-11.4-10.581 0-5.29 3.856-9.318 10.546-10.41v-3.346c0-1.092.888-1.945 1.946-1.945h1.946c1.092 0 1.945.853 1.945 1.945v3.004c3.209.137 5.564.683 7.407 1.331a1.954 1.954 0 0 1 1.229 2.355l-.785 2.868a1.946 1.946 0 0 1-2.56 1.297 20.5 20.5 0 0 0-7.27-1.297c-3.96 0-5.12 1.638-5.12 3.106 0 1.809 2.389 3.072 7.577 4.676 7.373 2.219 10.41 5.29 10.41 10.82 0 5.052-3.754 9.592-10.99 10.718v3.755a1.946 1.946 0 0 1-1.946 1.945h-1.945a1.946 1.946 0 0 1-1.946-1.945m73.967-63.01a26.624 26.624 0 0 0-12.015-35.67 26.487 26.487 0 0 0-35.533 12.05 26.624 26.624 0 0 0 12.015 35.635c13.107 6.485 29.014 1.126 35.499-12.05Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m818.176 201.899-.341-.103a.785.785 0 0 1-.376-1.024 25.26 25.26 0 0 1 27.136-13.55c.41.068.683.477.615.92a.785.785 0 0 1-.922.615 23.55 23.55 0 0 0-25.43 12.698.68.68 0 0 1-.682.41Z",
  opacity: 0.71
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M845.722 234.564a22.528 22.528 0 0 0-10.24-43.861 22.528 22.528 0 0 0 10.24 43.861",
  opacity: 0.71
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FF9800",
  d: "M838.383 229.444v-2.423a20.5 20.5 0 0 1-6.827-1.502 1.365 1.365 0 0 1-.785-1.673l.615-2.287a1.434 1.434 0 0 1 1.945-.921 17.1 17.1 0 0 0 6.315 1.331c2.39 0 4.267-.853 4.267-2.56 0-1.536-1.366-2.458-4.78-3.345-4.88-1.365-8.362-3.482-8.362-7.782 0-3.857 2.8-6.827 7.714-7.612v-2.458c0-.785.649-1.433 1.434-1.433h1.434c.785 0 1.399.682 1.399 1.433v2.219c2.39.068 4.096.478 5.461.956.683.273 1.058 1.024.854 1.706l-.546 2.117a1.434 1.434 0 0 1-1.878.99 13.7 13.7 0 0 0-5.325-.99c-2.9 0-3.754 1.228-3.754 2.287 0 1.365 1.74 2.252 5.53 3.413 5.427 1.638 7.645 3.891 7.645 7.953 0 3.686-2.73 7.031-8.055 7.85v2.731a1.365 1.365 0 0 1-1.434 1.434h-1.433a1.365 1.365 0 0 1-1.434-1.4Zm-662.255 58.027a34 34 0 0 1-.273 3.823h-28.74a10.24 10.24 0 0 0 3.345 7.236 10.24 10.24 0 0 0 7.373 2.73q6.314 0 8.874-5.256h8.397a17.07 17.07 0 0 1-17.271 11.81 17.75 17.75 0 0 1-16.384-9.216 20.5 20.5 0 0 1-2.39-10.24 20.5 20.5 0 0 1 2.321-10.171 17.07 17.07 0 0 1 6.622-6.827 20.5 20.5 0 0 1 9.83-2.39q5.325 0 9.49 2.322a17.07 17.07 0 0 1 6.485 6.553 20.5 20.5 0 0 1 2.321 9.626m-8.124-2.458a8.88 8.88 0 0 0-3.072-6.895 10.92 10.92 0 0 0-7.44-2.594 10.24 10.24 0 0 0-6.896 2.594 10.24 10.24 0 0 0-3.413 6.895zm44.647-5.802v6.553h-28.058v-6.553z"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "einvoice-consolidate_svg__a",
  x1: 18.898,
  x2: 23.746,
  y1: 7.829,
  y2: 7.829,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DAE3FE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E9EFFD"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "einvoice-consolidate_svg__b",
  x1: 19.6,
  x2: 23.876,
  y1: 8.335,
  y2: 8.335,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4042E2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4F52FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "einvoice-consolidate_svg__c",
  x1: 21.806,
  x2: 20.18,
  y1: 7.724,
  y2: 8.408,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FE7062"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF928E"
}))));

const SvgEinvoicePending = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024",
  width: "1em",
  height: "1em"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M102.502 544.87V288.802c.069-47.684 52.975-85.23 121.037-85.606 49.937-.273 99.908 0 149.846-.137 6.075 0 8.157 1.024 7.953 5.462a273 273 0 0 0 0 28.433c.239 4.778-1.536 6.28-8.67 6.246a21094 21094 0 0 0-145.442-.068c-32.154.068-57.788 13.278-65.57 33.314-1.639 4.232-1.878 8.533-1.878 12.868V800.87c0 27.205 27.307 45.978 67.38 46.046q123.391.103 246.817.069 146.774 0 293.547-.069c32.085 0 57.412-12.663 65.434-32.426 2.048-5.018 2.423-10.138 2.423-15.326 0-33.587.103-67.209-.136-100.83 0-4.745 1.638-6.485 8.772-6.247 13.79.376 27.648.274 41.404.035 5.393-.069 7.031 1.16 6.997 4.949-.205 36.488.512 72.977-.341 109.466-.956 39.73-47.514 74.786-104.244 79.667-24.576 2.082-49.288.955-73.966.955q-243.303.171-486.605.035c-60.416 0-109.875-27.307-122.266-67.175a68.3 68.3 0 0 1-2.594-20.275q.068-127.454.034-254.874z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M700.553 203.162q34.816-.035 69.632 0c68.949.273 122.094 37.717 122.129 86.016 0 23.552-.171 47.035.102 70.52.068 4.334 0 334.233 0 343.927-11.776 33.655-43.725-4.267-57.207-3.892 4.471 0-.103-335.53 0-340.48.375-22.698.17-45.363.136-68.027 0-28.604-26.863-47.855-67.584-48.06-48.47-.24-96.939-.137-145.408.034-6.758 0-9.25-1.024-8.909-6.076a239 239 0 0 0 0-27.818c-.239-4.78 1.468-6.35 8.67-6.28 26.146.34 52.292.136 78.439.136m-202.991 43.247h-94.277c-4.164 0-8.055.546-7.611-4.199 2.082-23.723 9.08-46.455 25.565-67.481a102.4 102.4 0 0 1 25.054-22.938 93.18 93.18 0 0 1 101.445-.512c22.391 14.37 34.747 32.904 42.94 53.009 4.778 11.742 6.826 23.757 8.499 35.874.614 4.676-.786 6.554-8.227 6.349-15.53-.41-31.13-.137-46.694-.137h-46.694Zm24.337-56.798c.102-9.319-11.196-17.238-24.576-17.204s-24.576 8.022-24.406 17.408c.171 9.046 11.264 16.794 24.235 16.93 13.21.171 24.678-7.748 24.747-17.134"
}), /*#__PURE__*/React.createElement("path", {
  d: "M496.708 303.036H327.612c-2.56 0-6.35.341-7.373-.683-2.048-1.877 1.331-3.652 2.73-5.256 14.849-16.726 34.612-30.038 58.198-40.62a27.3 27.3 0 0 1 11.537-2.32q104.858.102 209.647.034c3.925 0 7.373.512 10.752 2.048 23.927 10.615 43.895 24.03 58.88 40.96 1.297 1.536 4.164 3.072 2.867 4.847-1.365 1.877-4.813.887-7.27.887q-85.402.069-170.872.034zM380.45 596.616c-39.117 0-78.268-.102-117.419.103-4.061 0-5.802-1.297-5.188-7.066.205-1.809.103-3.72.034-5.563q-.17-3.892 2.663-3.55c.75.102 1.502 0 2.253 0q117.896 0 235.724.102c1.536 0 4.199-1.672 4.506 1.877.41 4.404.99 9.182-.444 13.312-.614 1.741-2.799.717-4.266.717q-58.915.069-117.863.069m.137-69.086c39.082 0 78.233.102 117.35-.137 4.096 0 5.803 1.365 5.12 7.1a17 17 0 0 0 0 3.686c.512 4.438-.956 5.462-4.028 5.462-14.302-.205-28.57-.103-42.871-.103q-96.393 0-192.751-.068c-1.843 0-4.676 1.57-5.29-1.365a34.1 34.1 0 0 1 .102-13.415c.512-2.287 2.662-1.126 4.096-1.126l101.103-.034h17.135Zm-.034 122.095c-39.151 0-78.268-.103-117.42.102-4.027.034-5.529-1.195-5.29-7.066.444-10.513-.956-9.01 6.861-9.01q116.94-.07 233.882.033c1.57 0 4.198-1.536 4.505 1.912.41 4.369 1.024 9.148-.444 13.278-.648 1.706-2.798.716-4.266.716H380.518Zm117.623 37q113.664 0 227.362.068c3.618 0 9.216-1.365 10.48 1.366a18.1 18.1 0 0 1 0 13.38c-.547 1.74-4.063 1.195-6.316 1.195h-33.45c-143.053 0-286.14-.069-429.159.102-7.577 0-9.489-1.672-9.216-6.656.683-11.093-1.4-9.42 13.824-9.42q113.255-.035 226.475 0Zm0 52.907c76.356 0 152.713.17 229.069-.17 9.967-.035 9.694 3.14 9.728 8.089 0 5.051.102 8.123-9.796 8.123-153.02-.238-306.04-.17-459.094-.238-3.242 0-8.465 1.365-9.42-1.502-1.434-4.267-1.946-9.08.409-13.312 1.092-1.98 5.359-.922 8.192-.922q115.473-.102 230.878-.068Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00B259",
  d: "M327.373 419.908c0 10.172-.41 20.344.17 30.515.342 5.223-2.048 6.622-9.318 6.486-17.067-.273-17.1 0-17.1-12.083 0-24.099.17-48.23-.137-72.363-.069-5.188 1.638-7.236 9.762-6.997 16.384.443 16.418.102 21.436 11.434 3.89 8.773 7.748 17.545 13.55 26.146 0-10.342.376-20.684-.17-31.027-.273-5.12 1.945-6.656 9.318-6.485 17.101.307 17.101 0 17.101 11.98 0 24.577-.205 49.084.17 73.592.069 4.745-1.945 5.871-8.43 5.803-19.354-.103-19.354.068-24.61-13.107l-9.694-24.064zm212.002-8.499c0 8.226.444 16.452-.068 24.678-.888 14.234-14.575 22.7-36.182 22.802-20.923.136-34.577-8.056-36.044-22.119-1.673-16.043-.615-32.085-.512-48.128.102-17.237 17.305-27.648 46.523-24.132 15.736 1.877 25.259 10.172 26.283 21.606l.102 2.458v22.87zm-31.232-.205c0-8.635.102-17.271-.034-25.873-.034-2.594.375-6.11-4.881-6.144-5.223-.102-5.29 3.482-5.325 6.008a2082 2082 0 0 0 0 52.36c.034 2.39-.444 6.11 5.325 5.803 5.29-.307 4.778-3.72 4.813-6.28.17-8.602.068-17.238.068-25.874m-87.347 11.81c2.048-16.861 4.437-33.382 5.905-49.937.512-5.53 2.355-8.43 11.161-7.509 7.168.683 16.726-2.185 21.163 1.126 4.608 3.414.068 9.763-.785 14.78-3.994 23.689-8.329 47.377-12.39 71.066-.513 2.901-1.775 4.403-6.452 4.335a1195 1195 0 0 0-36.932 0c-4.608.068-6.178-1.297-6.758-4.165q-8.124-40.96-16.52-81.851c-.854-4.096.887-5.291 6.826-5.36 26.248-.306 26.146-.409 28.194 18.194q1.911 16.589 4.198 33.177c.24 1.98-.068 4.096 2.39 6.144m207.36-11.468c0 8.67-.171 17.305.102 25.94.102 2.56.137 5.872 5.598 5.94 5.973.068 5.94-3.345 6.144-6.178.307-3.925.478-7.85.102-11.742-.41-3.891 1.912-5.188 7.134-4.813 2.048.137 4.096 0 6.144 0 19.422 0 19.285 0 18.09 13.551-.853 9.694-5.256 17.92-18.91 21.914-14.984 4.369-29.9 3.857-43.758-2.39-6.52-2.97-9.83-7.748-10.65-13.038-3.003-18.91-2.491-37.854-.682-56.764 1.024-9.967 9.625-16.111 23.04-18.842a68.3 68.3 0 0 1 27.784.103c12.288 2.56 20.037 8.021 22.119 17.271 1.433 6.144 1.024 12.288 1.33 18.5.137 2.8-1.091 4.165-5.426 4.096a410 410 0 0 0-20.241 0c-4.71.103-6.11-1.263-5.94-4.437a205 205 0 0 0-.068-16.043c-.068-2.525-.58-5.222-5.188-5.563-5.393-.376-6.417 2.662-6.485 5.29-.308 9.08-.103 18.125-.103 27.205zm55.842-.273c0-13.415.205-26.795-.137-40.21-.102-4.3 1.741-5.7 7.953-5.563q18.944.512 37.888 0c6.042-.137 7.953 1.467 7.168 5.359v.614c.17 11.435.17 11.537-15.701 12.152-3.994.136-6.11.853-5.7 3.857.136 1.024 0 2.048 0 3.106-.034 10.103-.034 10.24 14.336 10.683 4.232.137 5.87 1.093 5.461 3.994-.102 1.024 0 2.048 0 3.072.068 9.592.068 9.796-13.483 9.967-5.188.068-6.826 1.468-6.314 4.779.17 1.024 0 2.048 0 3.072 0 12.049-.034 12.185 16.93 12.629 4.983.137 6.383 1.297 6.485 4.745.512 13.312.683 13.312-17.783 13.312-9.114 0-18.262-.342-27.307.068-7.51.375-10.24-.99-10.001-6.69.683-12.971.239-25.942.205-38.912zm-396.561-.205c0 13.38-.205 26.794.136 40.175.103 4.164-1.297 5.666-7.68 5.7-23.893.068-23.893.205-23.893-16.486 0-23.075.102-46.149-.17-69.223-.07-4.198 1.467-5.632 7.747-5.666 23.894-.205 23.894-.341 23.894 16.452zm264.874.648c0-13.38.205-26.76-.136-40.14-.137-4.404 1.16-6.554 8.124-6.042q8.328.546 16.725 0c5.632-.273 6.86 1.468 6.827 5.052q-.24 40.755.068 81.578c0 3.926-2.15 4.915-7.27 4.71a205 205 0 0 0-17.58 0c-5.597.274-6.928-1.365-6.826-4.983.239-13.414.102-26.794.068-40.175"
}));

const SvgEinvoiceReject = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024",
  width: "1em",
  height: "1em"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M102.502 544.87V288.836c.069-47.684 52.975-85.23 121.037-85.606 49.937-.273 99.908 0 149.846-.137 6.075 0 8.157 1.024 7.953 5.462a273 273 0 0 0 0 28.433c.239 4.778-1.536 6.28-8.67 6.246q-72.704-.273-145.442-.068c-32.154.068-57.788 13.278-65.57 33.314-1.639 4.233-1.878 8.533-1.878 12.868v511.557c0 27.204 27.307 45.977 67.38 46.045q123.391.103 246.817.069 146.774 0 293.547-.069c32.085 0 57.412-12.663 65.434-32.426 2.048-5.018 2.423-10.138 2.423-15.326 0-33.587-.068 20.855-.341-12.732 0-4.779 1.638-6.485 8.772-6.28 13.79.375 27.477.204 41.267 0 5.393-.103 7.032 1.16 6.998 4.915-.205 36.522.853-15.019 0 21.504-.956 39.697-47.514 74.752-104.244 79.633-24.576 2.082-49.288.956-73.966.956q-243.303.17-486.605.034c-60.416 0-109.875-27.307-122.266-67.175a68.3 68.3 0 0 1-2.594-20.309q.068-127.488.034-254.84zm598.05-341.708q34.817-.035 69.633 0c68.949.273 122.094 37.717 122.129 86.016 0 23.552-5.12 182.272-4.847 205.755.068 4.335-10.82 17.204-17.067 17.067 13.483-.341-13.517-.307 0 0-6.827.17-34.133 0-34.133 0 .375-22.665-.888-198.11-.922-220.774 0-28.604-26.863-47.855-67.584-48.06-48.47-.24-96.939-.137-145.408.034-6.758 0-9.25-1.024-8.909-6.076a239 239 0 0 0 0-27.818c-.239-4.78 1.468-6.35 8.67-6.28 26.146.34 52.292.136 78.439.136"
}), /*#__PURE__*/React.createElement("path", {
  d: "M497.562 246.409h-94.277c-4.164 0-8.055.546-7.611-4.199 2.082-23.723 9.08-46.455 25.565-67.481a102.4 102.4 0 0 1 25.054-22.938 93.18 93.18 0 0 1 101.445-.512c22.391 14.37 34.747 32.904 42.94 53.009 4.778 11.742 6.826 23.757 8.499 35.874.614 4.676-.786 6.554-8.227 6.349-15.53-.41-31.13-.137-46.694-.137zm24.337-56.798c.102-9.319-11.196-17.238-24.576-17.204s-24.576 8.022-24.406 17.408c.171 9.046 11.264 16.794 24.235 16.93 13.21.171 24.678-7.748 24.747-17.134m-25.19 113.425H327.611c-2.56 0-6.35.341-7.373-.683-2.048-1.877 1.331-3.652 2.73-5.256 14.849-16.726 34.612-30.038 58.198-40.62a27.3 27.3 0 0 1 11.537-2.32q104.858.102 209.647.034c3.925 0 7.373.512 10.752 2.048 23.927 10.615 43.895 24.03 58.88 40.96 1.297 1.536 4.164 3.072 2.867 4.847-1.365 1.877-4.813.887-7.27.887q-85.402.069-170.872.034z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FF1B40",
  d: "M380.45 596.617c-39.117 0-78.268-.103-117.419.102-4.061 0-5.802-1.297-5.188-7.066.205-1.809.103-3.72.034-5.563q-.17-3.892 2.663-3.55c.75.102 1.502 0 2.253 0q117.896 0 235.724.102c1.536 0 4.199-1.672 4.506 1.877.41 4.404.99 9.182-.444 13.312-.614 1.741-2.799.717-4.266.717q-58.915.069-117.863.069m.137-69.086c39.082 0 78.233.102 117.35-.137 4.096 0 5.803 1.365 5.12 7.1a17 17 0 0 0 0 3.686c.512 4.438-.956 5.462-4.028 5.462-14.302-.205-28.57-.103-42.871-.103q-96.393 0-192.751-.068c-1.843 0-4.676 1.57-5.29-1.365a34.1 34.1 0 0 1 .102-13.415c.512-2.287 2.662-1.126 4.096-1.126l101.103-.034zm-.034 122.095c-39.151 0-78.268-.103-117.42.102-4.027.034-5.529-1.195-5.29-7.066.444-10.513-.956-9.01 6.861-9.01q116.94-.07 233.882.033c1.57 0 4.198-1.536 4.505 1.912.41 4.369 1.024 9.148-.444 13.278-.648 1.706-2.798.716-4.266.716H380.518Zm117.623 37q113.664 0 227.362.068c3.618 0 9.216-1.365 10.48 1.366a18.1 18.1 0 0 1 0 13.38c-.547 1.74-4.063 1.195-6.316 1.195h-33.45c-143.053 0-286.14-.069-429.159.102-7.577 0-9.489-1.672-9.216-6.656.683-11.093-1.4-9.42 13.824-9.42q113.255-.035 226.475 0Zm0 52.907c76.356 0 152.713.17 229.069-.17 9.967-.035 9.694 3.14 9.728 8.089 0 5.051.102 8.123-9.796 8.123-153.02-.238-306.04-.17-459.094-.238-3.242 0-8.465 1.365-9.42-1.502-1.434-4.267-1.946-9.08.409-13.312 1.092-1.98 5.359-.922 8.192-.922q115.473-.102 230.878-.068Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00B259",
  d: "M327.373 419.908c0 10.172-.41 20.344.17 30.515.342 5.223-2.048 6.622-9.318 6.486-17.067-.273-17.1 0-17.1-12.083 0-24.099.17-48.23-.137-72.363-.069-5.188 1.638-7.236 9.762-6.997 16.384.443 16.418.102 21.436 11.434 3.89 8.773 7.748 17.545 13.55 26.146 0-10.342.376-20.684-.17-31.027-.273-5.12 1.945-6.656 9.318-6.485 17.101.307 17.101 0 17.101 11.98 0 24.577-.205 49.084.17 73.592.069 4.745-1.945 5.871-8.43 5.803-19.354-.103-19.354.068-24.61-13.107l-9.694-24.064zm212.002-8.499c0 8.226.444 16.452-.068 24.678-.888 14.234-14.575 22.7-36.182 22.802-20.923.136-34.577-8.056-36.044-22.119-1.673-16.043-.615-32.085-.512-48.128.102-17.237 17.305-27.648 46.523-24.132 15.736 1.877 25.259 10.172 26.283 21.606l.102 2.458v22.87zm-31.232-.205c0-8.635.102-17.271-.034-25.873-.034-2.594.375-6.11-4.881-6.144-5.223-.102-5.29 3.482-5.325 6.008a2082 2082 0 0 0 0 52.36c.034 2.39-.444 6.11 5.325 5.803 5.29-.307 4.778-3.72 4.813-6.28.17-8.602.068-17.238.068-25.874m-87.347 11.81c2.048-16.861 4.437-33.382 5.905-49.937.512-5.53 2.355-8.43 11.161-7.509 7.168.683 16.726-2.185 21.163 1.126 4.608 3.414.068 9.763-.785 14.78-3.994 23.689-8.329 47.377-12.39 71.032-.513 2.935-1.775 4.437-6.452 4.369a1195 1195 0 0 0-36.932 0c-4.608.068-6.178-1.297-6.758-4.165q-8.124-40.96-16.52-81.851c-.854-4.096.887-5.291 6.826-5.36 26.248-.306 26.146-.409 28.194 18.194q1.911 16.589 4.198 33.177c.24 1.98-.068 4.096 2.39 6.144m207.36-11.468c0 8.67-.171 17.305.102 25.94.102 2.56.137 5.872 5.598 5.94 5.973.068 5.94-3.345 6.144-6.178.307-3.925.478-7.85.102-11.742-.41-3.891 1.912-5.188 7.134-4.813 2.048.137 4.096 0 6.144 0 19.422 0 19.285 0 18.09 13.551-.853 9.694-5.256 17.92-18.91 21.914-14.984 4.369-29.9 3.857-43.758-2.39-6.52-2.97-9.83-7.748-10.65-13.038-3.003-18.91-2.491-37.854-.682-56.764 1.024-9.967 9.625-16.111 23.04-18.842a68.3 68.3 0 0 1 27.784.103c12.288 2.56 20.037 8.021 22.119 17.271 1.433 6.144 1.024 12.288 1.33 18.5.137 2.8-1.091 4.165-5.426 4.096a410 410 0 0 0-20.241 0c-4.71.103-6.11-1.263-5.94-4.437a205 205 0 0 0-.068-16.043c-.068-2.525-.58-5.222-5.188-5.563-5.393-.376-6.417 2.662-6.485 5.29-.308 9.08-.103 18.125-.103 27.205zm55.842-.273c0-13.415.205-26.795-.137-40.21-.102-4.3 1.741-5.7 7.953-5.563q18.944.512 37.888 0c6.042-.137 7.953 1.502 7.168 5.359v.614c.17 11.435.17 11.537-15.701 12.152-3.994.136-6.11.853-5.7 3.857.136 1.024 0 2.048 0 3.106-.034 10.103-.034 10.24 14.336 10.683 4.232.137 5.87 1.093 5.461 3.994-.102 1.024 0 2.048 0 3.072.068 9.626.068 9.796-13.483 9.967-5.188.068-6.826 1.468-6.314 4.779.17 1.024 0 2.048 0 3.072 0 12.049-.034 12.185 16.93 12.629 4.983.137 6.383 1.297 6.485 4.745.512 13.312.683 13.312-17.783 13.312-9.114 0-18.262-.342-27.307.068-7.51.375-10.24-.99-10.001-6.69.683-12.971.239-25.942.205-38.912zm-396.561-.205c0 13.38-.205 26.794.136 40.175.103 4.164-1.297 5.666-7.68 5.7-23.893.068-23.893.205-23.893-16.486 0-23.075.102-46.149-.17-69.223-.07-4.198 1.467-5.632 7.747-5.666 23.894-.205 23.894-.341 23.894 16.452zm264.874.648c0-13.38.205-26.76-.136-40.14-.137-4.404 1.16-6.554 8.124-6.042q8.328.546 16.725 0c5.632-.273 6.86 1.468 6.827 5.052q-.24 40.755.068 81.578c0 3.926-2.15 4.915-7.27 4.71a205 205 0 0 0-17.58 0c-5.597.274-6.928-1.365-6.826-4.983.239-13.414.102-26.794.068-40.175"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#einvoice-reject_svg__a)",
  d: "M978.33 544.495 874.906 646.963 978.33 749.466c15.36 15.257 15.36 39.936 0 55.193-7.68 7.612-17.75 11.435-27.853 11.435a39.25 39.25 0 0 1-27.819-11.435L819.2 702.157 715.776 804.659a39.49 39.49 0 0 1-55.706 0 38.775 38.775 0 0 1 0-55.193l103.424-102.503L660.07 544.495a38.775 38.775 0 0 1 0-55.194 39.595 39.595 0 0 1 55.672 0L819.2 591.77 922.624 489.3a39.595 39.595 0 0 1 55.706 0c15.36 15.224 15.36 39.936 0 55.194"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "einvoice-reject_svg__a",
  x1: 24,
  x2: 24,
  y1: 14,
  y2: 23.909,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FC2B3A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FC2B3A"
}))));

const SvgFile = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 30 30"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 24797"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h30v30H0z",
  "data-name": "Rectangle 6520"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 9159"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#002672",
  "data-name": "Group 9158"
}, /*#__PURE__*/React.createElement("path", {
  d: "M25.902 3.396h-.877v21.551a2.6 2.6 0 0 1-2.6 2.6H6.472v.8a1.66 1.66 0 0 0 1.657 1.649h17.77a1.66 1.66 0 0 0 1.657-1.657V5.049a1.655 1.655 0 0 0-1.654-1.653",
  "data-name": "Path 12279"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.54 26.6h8.885a1.66 1.66 0 0 0 1.657-1.657V1.657A1.66 1.66 0 0 0 22.425 0H10.586v.548a2 2 0 0 1 .009.175v4.54A2.336 2.336 0 0 1 8.261 7.6h-4.54c-.047 0-.1 0-.144-.006h-.576v17.353A1.66 1.66 0 0 0 4.658 26.6zm.335-5.633H8.082a.783.783 0 1 1 0-1.566h5.8a.783.783 0 1 1 0 1.566Zm5.8-4H8.082a.783.783 0 1 1 0-1.566h11.589a.783.783 0 1 1 0 1.566ZM8.082 11.162h11.589a.783.783 0 1 1 0 1.566H8.082a.783.783 0 0 1 0-1.566",
  "data-name": "Path 12280"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.721 6.657h4.554a1.39 1.39 0 0 0 1.378-1.378V.725a.7.7 0 0 0-.7-.7.68.68 0 0 0-.489.207L3.226 5.467a.7.7 0 0 0 .495 1.19",
  "data-name": "Path 12281"
})))));

const SvgHeaderBackIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 20 20"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#ff9800",
  d: "M10 12.5V15l-5-5 5-5v2.5h5v5Z",
  "data-name": "Path 81442"
}));

const SvgHeaderSwitchIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 20 20"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "#ff9800",
  "data-name": "Group 65368"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 65292"
}, /*#__PURE__*/React.createElement("path", {
  d: "m11.894 9.331-.883.883 1.383 1.391h-6.3v1.249h6.3l-1.387 1.387.883.883 2.894-2.894Z",
  "data-name": "Path 70690"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.902 7.27h-6.3l1.387-1.387L8.106 5 5.212 7.894l2.894 2.894.883-.883-1.387-1.387h6.3Z",
  "data-name": "Path 70691"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 65293"
}, /*#__PURE__*/React.createElement("path", {
  d: "m11.891 9.332-.883.883 1.387 1.387h-2.54v1.249h2.54l-1.387 1.387.883.883 2.894-2.894Z",
  "data-name": "Path 70692"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.854 7.27h4.048v1.249H9.854z",
  "data-name": "Rectangle 27448"
}))));

const SvgHimsxAppsIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 162 45"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M2.417 37V13.378h4.77v9.297h9.345v-9.297h4.77V37h-4.77V26.671H7.187V37zm23.686 0V13.378h4.77V37zm9.266 0V13.378h7.138l4.286 16.113 4.238-16.113h7.154V37h-4.431V18.405L49.064 37h-4.591L39.8 18.405V37zm26.345-7.686 4.64-.451q.42 2.335 1.692 3.432 1.29 1.096 3.465 1.096 2.303 0 3.464-.967 1.176-.983 1.176-2.288 0-.838-.5-1.418-.481-.596-1.707-1.032-.838-.29-3.819-1.03-3.835-.951-5.382-2.337-2.175-1.95-2.175-4.754 0-1.804 1.015-3.367 1.031-1.58 2.949-2.401 1.933-.822 4.657-.822 4.446 0 6.687 1.95 2.255 1.95 2.368 5.204l-4.77.21q-.306-1.821-1.32-2.61-1-.806-3.014-.806-2.078 0-3.255.854-.757.548-.757 1.466 0 .838.709 1.434.902.758 4.383 1.58 3.48.82 5.14 1.707 1.676.87 2.61 2.401.95 1.515.95 3.755 0 2.03-1.127 3.802c-1.127 1.772-1.816 2.063-3.19 2.643q-2.063.854-5.14.854-4.48 0-6.881-2.063-2.4-2.078-2.868-6.042"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFB11F",
  d: "M83 37.022S103.269 11.15 161.64 0c0 0-35.936 7.686-65.823 37.022z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFB11F",
  d: "m108.241 28.841 6.384-4.732 17.36 12.908h-12.712zm-9.589-7.063 6.86-4.508-9.156-6.543H83.887z"
}));

const SvgHimsxAuditLog = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#himsx-audit-log_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFBD86",
  d: "m2.203 6.79-.047-.192a11.43 11.43 0 0 0-1.64 5.918c0 2.164.599 4.19 1.64 5.917l.047-.201zm19.677-.13-.25.249-.02.017V18.52l.046.215a11.43 11.43 0 0 0 1.828-6.218c0-2.14-.585-4.142-1.604-5.857M5.92 22.078l-.21.047A11.43 11.43 0 0 0 12 24c2.322 0 4.483-.69 6.29-1.875l-.21-.047zM16.569 4.636l-.01-.034h-.762a.19.19 0 0 1-.188-.188V3.226c0-.103.085-.187.188-.187h.762l.01-.034q.091-.315.247-.598l.017-.03-.498-.499A11.45 11.45 0 0 0 12 1.031a11.46 11.46 0 0 0-8.776 4.078h13.528a3 3 0 0 1-.183-.473"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F3F0FF",
  d: "M21.63 6.909a.186.186 0 0 1-.264 0l-.54-.54-.03.018c-.188.103-.39.187-.598.247l-.034.01v.762a.19.19 0 0 1-.187.188h-1.188a.19.19 0 0 1-.188-.188v-.762l-.034-.01a3 3 0 0 1-.597-.247l-.031-.017-.54.539a.186.186 0 0 1-.264 0l-.84-.84a.19.19 0 0 1 0-.266l.538-.539-.017-.03-.064-.125H2.402l-.246.047v13.277a11.54 11.54 0 0 0 3.554 3.692h12.58a11.55 11.55 0 0 0 3.366-3.39V6.882l-.025.026Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E2DEFF",
  d: "M2.156 5.156v13.277A11.5 11.5 0 0 0 4.5 21.211V5.156z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0182FC",
  d: "m16.569 4.636-.01-.034h-.762a.19.19 0 0 1-.188-.188V3.226c0-.103.085-.187.188-.187h.762l.01-.034a3 3 0 0 1 .183-.474H2.86a.703.703 0 0 0-.703.703v1.922h14.62a3 3 0 0 1-.207-.52Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0172FB",
  d: "M5.203 2.531H2.86a.703.703 0 0 0-.703.703v1.922H4.5V3.234c0-.388.315-.703.703-.703"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FD4755",
  d: "M3.68 4.125a.352.352 0 1 0 0-.703.352.352 0 0 0 0 .703"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FEE45A",
  d: "M4.71 4.125a.352.352 0 1 0 0-.703.352.352 0 0 0 0 .703"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#68CA44",
  d: "M5.742 4.125a.352.352 0 1 0 0-.703.352.352 0 0 0 0 .703"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B3DAFE",
  d: "M12 6.89c-.582 0-1.133.13-1.628.36a1.478 1.478 0 0 1-1.944 2.025A3.867 3.867 0 1 0 12 6.89"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#8AC9FE",
  d: "m9.337 13.56.579-.42a3.85 3.85 0 0 1-.822-2.382c0-.48.088-.938.248-1.362a1.48 1.48 0 0 1-.914-.121c-.19.456-.295.957-.295 1.483 0 1.103.463 2.098 1.204 2.802"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0182FC",
  d: "M13.216 12.508a2.12 2.12 0 0 1-2.432 0L9.337 13.56A3.85 3.85 0 0 0 12 14.625c1.033 0 1.97-.405 2.664-1.065z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0172FB",
  d: "M10.743 12.538 9.337 13.56c.235.224.499.417.784.577l1.543-1.225a2.2 2.2 0 0 1-.92-.374Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#26A6FE",
  d: "M12 12.938a2.18 2.18 0 1 0 0-4.36 2.18 2.18 0 0 0 0 4.36"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0593FC",
  d: "M11.25 10.758a2.18 2.18 0 0 1 1.465-2.06 2.18 2.18 0 1 0 0 4.118 2.18 2.18 0 0 1-1.465-2.058"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B5ADD5",
  d: "M22.969 2.992h-.727a3 3 0 0 0-.252-.608l.514-.513a.234.234 0 0 0 0-.332l-.84-.84a.234.234 0 0 0-.331 0l-.514.514A3 3 0 0 0 20.21.96V.235A.234.234 0 0 0 19.977 0h-1.188a.234.234 0 0 0-.235.234v.728a3 3 0 0 0-.607.25L17.433.7a.234.234 0 0 0-.331 0l-.84.84a.234.234 0 0 0 0 .332l.513.513q-.159.287-.251.608h-.727a.234.234 0 0 0-.235.234v1.188c0 .13.106.235.235.235h.727q.093.32.251.607l-.514.514a.234.234 0 0 0 0 .332l.84.84c.092.091.24.091.332 0l.514-.514q.286.159.607.251v.727c0 .13.105.235.235.235h1.188c.13 0 .234-.105.234-.235V6.68q.32-.093.608-.251l.514.514c.091.091.24.091.331 0l.84-.84a.234.234 0 0 0 0-.332l-.514-.514q.159-.286.252-.607h.727c.13 0 .234-.105.234-.235V3.226a.234.234 0 0 0-.234-.234"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#9182B0",
  d: "M19.383 5.86a2.04 2.04 0 1 0 0-4.079 2.04 2.04 0 0 0 0 4.078Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#7A6D98",
  d: "M18.968 4.738a1.007 1.007 0 0 1 0-1.835 2.05 2.05 0 0 1 1.118-.997 2.04 2.04 0 1 0 0 3.83 2.05 2.05 0 0 1-1.118-.998"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B5ADD5",
  d: "M19.383 4.828a1.008 1.008 0 1 0 0-2.015 1.008 1.008 0 0 0 0 2.015"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#A79BC6",
  d: "M19.313 3.82c0-.387.218-.723.539-.891a1.008 1.008 0 1 0 0 1.784 1.01 1.01 0 0 1-.54-.893Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B5ADD5",
  d: "M17.578 16.969h-5.531a.352.352 0 1 1 0-.703h5.531a.352.352 0 1 1 0 .703m-6.75 0H8.297a.352.352 0 0 1 0-.703h2.531a.352.352 0 1 1 0 .703m-4.172.351a.703.703 0 1 0 0-1.406.703.703 0 0 0 0 1.406m10.922 1.735H8.297a.352.352 0 0 1 0-.703h9.281a.351.351 0 1 1 0 .703m-10.922.351a.703.703 0 1 0 0-1.406.703.703 0 0 0 0 1.406"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E8B800",
  d: "M9.07 9.469a1.523 1.523 0 1 0 0-3.047 1.523 1.523 0 0 0 0 3.047"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D7AA02",
  d: "M8.531 7.945c0-.669.432-1.237 1.031-1.441a1.523 1.523 0 1 0 0 2.883 1.52 1.52 0 0 1-1.03-1.442Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FEDF30",
  d: "m9.154 7.11.215.435c.013.027.04.046.07.05l.48.07a.093.093 0 0 1 .052.16l-.348.338a.1.1 0 0 0-.026.083l.082.478a.093.093 0 0 1-.136.098l-.43-.225a.1.1 0 0 0-.086 0l-.43.225a.093.093 0 0 1-.135-.098l.082-.478a.1.1 0 0 0-.027-.083l-.347-.339a.093.093 0 0 1 .051-.159l.48-.07a.1.1 0 0 0 .07-.05l.216-.436a.093.093 0 0 1 .167 0Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B3DAFE",
  d: "M17.953 11.813a1.078 1.078 0 1 0 0-2.157 1.078 1.078 0 0 0 0 2.156Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#8AC9FE",
  d: "M17.813 10.734c0-.427.248-.796.609-.97a1.078 1.078 0 1 0 0 1.942 1.08 1.08 0 0 1-.61-.972Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B3DAFE",
  d: "M6.047 11.813a1.078 1.078 0 1 0 0-2.157 1.078 1.078 0 0 0 0 2.156Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#8AC9FE",
  d: "M5.906 10.734c0-.427.249-.796.61-.97a1.078 1.078 0 1 0 0 1.942 1.08 1.08 0 0 1-.61-.972"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "himsx-audit-log_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
}))));

const SvgHimsxLogout = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#2196F3",
  d: "M13.547 12.865a2.046 2.046 0 0 1 0-4.092h1.364V6.046a2.047 2.047 0 0 0-2.046-2.05H5.534a.68.68 0 0 0-.637.925l4.944 12.957a.68.68 0 0 0 .637.44h2.387a2.05 2.05 0 0 0 2.046-2.047v-3.406z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#607D8B",
  d: "M16.697 14.178a.68.68 0 0 1-.421-.63v-2.046h-2.728a.682.682 0 0 1 0-1.364h2.728V8.092a.682.682 0 0 1 1.164-.482l2.728 2.728a.68.68 0 0 1 0 .964L17.44 14.03a.68.68 0 0 1-.743.148"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#64B5F6",
  d: "M9.9 5.432 5.8 4.067A1.373 1.373 0 0 0 4 5.364v12.275a1.37 1.37 0 0 0 .924 1.293l4.1 1.366a1.365 1.365 0 0 0 1.796-1.295V6.732a1.37 1.37 0 0 0-.92-1.3"
}));

const SvgHimsxProjectSetup = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#himsx-project-setup_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#9FACBA",
  d: "M17.512 12.836a.33.33 0 0 0 .463.03l.703-.62a.328.328 0 0 0 0-.492l-.703-.62a.328.328 0 1 0-.433.493l.05.045h-1.207v-7.9h1.208l-.051.044a.328.328 0 1 0 .433.492l.703-.619a.328.328 0 0 0 0-.492l-.703-.618a.328.328 0 0 0-.433.493l.05.043h-1.535a.33.33 0 0 0-.329.328v8.229h-1.044V6.425a.975.975 0 0 0-.974-.974h-3.42a.974.974 0 0 0-.973.974v5.247H8.271V3.443a.33.33 0 0 0-.328-.328H6.41l.049-.043a.328.328 0 0 0-.433-.493l-.703.617a.328.328 0 0 0 0 .493l.702.62a.327.327 0 0 0 .463-.03.33.33 0 0 0-.029-.463l-.05-.045h1.207v7.9H6.407l.051-.044a.328.328 0 1 0-.434-.492l-.703.619a.328.328 0 0 0 0 .492l.703.62a.327.327 0 0 0 .463-.03.33.33 0 0 0-.029-.463l-.05-.045h1.207v7.9H6.407l.051-.044a.328.328 0 1 0-.434-.492l-.703.619a.328.328 0 0 0 0 .492l.704.618a.327.327 0 0 0 .463-.03.33.33 0 0 0-.03-.463l-.05-.043h1.535a.33.33 0 0 0 .328-.328v-8.229h1.046v5.247c0 .537.437.974.973.974h3.42a.975.975 0 0 0 .974-.974v-5.247h1.044v8.229c0 .181.147.328.329.328h1.534l-.049.043a.328.328 0 0 0 .433.493l.703-.618a.328.328 0 0 0 0-.492l-.703-.62a.328.328 0 0 0-.433.493l.05.045h-1.207v-7.9h1.208l-.051.044a.33.33 0 0 0-.03.463"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FE646F",
  d: "M13.71 5.45h-3.42a.974.974 0 0 0-.973.975v11.15c0 .537.437.974.973.974h3.42a.975.975 0 0 0 .974-.974V6.425a.975.975 0 0 0-.974-.974Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FD4755",
  d: "M14.105 5.535a.97.97 0 0 1 .18.562v11.15a.975.975 0 0 1-.974.974H9.89a1 1 0 0 1-.394-.084.97.97 0 0 0 .793.412h3.42a.975.975 0 0 0 .974-.974V6.425a.98.98 0 0 0-.579-.89Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M13.062 8.282h-2.124a.328.328 0 1 0 0 .657h2.124a.328.328 0 0 0 0-.657m-.831-.699h.83a.328.328 0 0 0 0-.656h-.83a.328.328 0 0 0 0 .656m-1.293 0h.335a.328.328 0 0 0 0-.656h-.335a.328.328 0 1 0 0 .656m2.124 2.056h-2.124a.328.328 0 1 0 0 .656h2.124a.328.328 0 0 0 0-.656m0 1.355h-.83a.328.328 0 0 0 0 .656h.83a.328.328 0 0 0 0-.656m-2.124.656h.335a.328.328 0 0 0 0-.656h-.335a.328.328 0 1 0 0 .656m2.124.7h-2.124a.328.328 0 1 0 0 .656h2.124a.328.328 0 0 0 0-.656m0 1.355h-.83a.328.328 0 0 0 0 .656h.83a.328.328 0 0 0 0-.656m-2.124.656h.335a.328.328 0 0 0 0-.656h-.335a.328.328 0 1 0 0 .656m2.124.701h-2.124a.328.328 0 1 0 0 .656h2.124a.328.328 0 0 0 0-.656m0 1.355h-.83a.328.328 0 0 0 0 .656h.83a.328.328 0 0 0 0-.656m-1.789 0h-.335a.328.328 0 1 0 0 .656h.335a.328.328 0 0 0 0-.656"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#6CF5C2",
  d: "M3.924.532h-2.71a.84.84 0 0 0-.839.84v4.144c0 .463.376.84.84.84h2.709a.84.84 0 0 0 .84-.84V1.37a.84.84 0 0 0-.84-.84Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#514B7F",
  d: "M3.924 17.645h-2.71a.84.84 0 0 0-.839.84v4.143c0 .464.376.84.84.84h2.709a.84.84 0 0 0 .84-.84v-4.144a.84.84 0 0 0-.84-.84Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F4D34E",
  d: "M3.924 9.089h-2.71a.84.84 0 0 0-.839.838v4.146a.84.84 0 0 0 .84.838h2.709a.84.84 0 0 0 .84-.838V9.927a.84.84 0 0 0-.84-.838"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#6CF5C2",
  d: "M22.787.532h-2.711a.84.84 0 0 0-.84.84v4.144c0 .463.377.84.84.84h2.71a.84.84 0 0 0 .839-.84V1.37a.84.84 0 0 0-.838-.84Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#514B7F",
  d: "M22.787 17.645h-2.711a.84.84 0 0 0-.84.84v4.143c0 .463.377.84.84.84h2.71a.84.84 0 0 0 .839-.84v-4.144a.84.84 0 0 0-.838-.84Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F4D34E",
  d: "M22.787 9.089h-2.711a.84.84 0 0 0-.84.838v4.146a.84.84 0 0 0 .84.838h2.71a.84.84 0 0 0 .839-.838V9.927a.84.84 0 0 0-.838-.838"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2B2F5B",
  d: "M4.22 17.7a.83.83 0 0 1 .136.456V22.3a.84.84 0 0 1-.84.84H.806a.8.8 0 0 1-.295-.055c.15.23.41.383.704.383h2.709a.84.84 0 0 0 .84-.84v-4.144a.84.84 0 0 0-.545-.785Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F87F02",
  d: "M4.22 9.144a.83.83 0 0 1 .136.455v4.146a.84.84 0 0 1-.84.838H.806a.8.8 0 0 1-.295-.055.84.84 0 0 0 .704.383h2.709a.84.84 0 0 0 .84-.838V9.927a.84.84 0 0 0-.544-.783"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00E499",
  d: "M4.22.587a.83.83 0 0 1 .136.456v4.145a.84.84 0 0 1-.84.84H.806a.8.8 0 0 1-.295-.055.84.84 0 0 0 .704.383h2.709a.84.84 0 0 0 .84-.84V1.372a.84.84 0 0 0-.545-.785ZM23.08.586a.84.84 0 0 1 .137.457v4.145a.84.84 0 0 1-.838.84h-2.711a.8.8 0 0 1-.296-.055c.15.23.41.383.704.383h2.71a.84.84 0 0 0 .839-.84V1.37a.84.84 0 0 0-.544-.785Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F87F02",
  d: "M23.081 9.143a.83.83 0 0 1 .136.456v4.146a.84.84 0 0 1-.838.838h-2.711a.8.8 0 0 1-.296-.055c.15.23.41.383.704.383h2.71a.84.84 0 0 0 .839-.838V9.927a.84.84 0 0 0-.544-.784"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2B2F5B",
  d: "M23.08 17.699a.84.84 0 0 1 .137.457v4.145a.84.84 0 0 1-.838.84h-2.711a.8.8 0 0 1-.296-.056c.15.23.41.383.704.383h2.71a.84.84 0 0 0 .839-.84v-4.144a.84.84 0 0 0-.544-.785Z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "himsx-project-setup_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
}))));

const SvgHimsxRaceMapping = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "himsx-race-mapping_svg__a",
  width: 24,
  height: 24,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
})), /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  mask: "url(#himsx-race-mapping_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFDCD5",
  d: "M19.907 1.741c-2.496-.501-7.685 1.88-10.649 1.88h-1.53c.218 1.642.147 4.036.147 5.264h1.383c3.317 0 3.093 1.436 5.857 1.436V8.938c1.228 0 3.621.071 5.264-.148.97-.129 1.52-.29 1.815-.717.26-.376.367-.986-.191-1.545.42-.242.91-1.535-.286-2.225.263-.456-.028-1.38-.83-1.549-.094-.594-.429-.902-.98-1.013"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#BB6B57",
  d: "M20.379 8.79c-1.643.219-4.037.148-5.264.148v1.383c0 3.316-1.436 3.093-1.436 5.856h1.383c0 1.228-.071 3.622.148 5.265.129.969.29 1.519.717 1.815.376.26.986.367 1.544-.192.243.42 1.536.91 2.226-.285.456.263 1.38-.029 1.549-.83.594-.095.902-.43 1.013-.98.501-2.496-1.88-7.685-1.88-10.65z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E5AE8C",
  d: "M13.679 16.177c-3.316 0-3.093-1.436-5.856-1.436v1.384c-1.228 0-3.622-.072-5.265.147-.969.13-1.519.291-1.815.718-.26.375-.367.986.192 1.544-.421.243-.91 1.535.285 2.226-.263.455.028 1.379.83 1.548.094.594.43.903.98 1.013 2.496.502 7.685-1.88 10.649-1.88h1.53c-.218-1.642-.147-4.036-.147-5.264z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#CC9081",
  d: "M7.823 14.742c0-3.317 1.435-3.093 1.435-5.857H7.875c0-1.228.072-3.622-.147-5.264-.13-.97-.291-1.52-.718-1.816-.375-.26-.986-.366-1.544.192-.243-.42-1.535-.91-2.226.286-.456-.263-1.379.028-1.548.83-.594.094-.903.429-1.014.98-.5 2.496 1.88 7.684 1.88 10.649v1.53c1.643-.219 4.037-.147 5.265-.147z"
})));

const SvgHimsxSystemSetting = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "url(#himsx-system-setting_svg__a)",
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
  id: "himsx-system-setting_svg__a",
  width: 1,
  height: 1,
  patternContentUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("use", {
  href: "#himsx-system-setting_svg__b",
  transform: "scale(.00195)"
})), /*#__PURE__*/React.createElement("image", {
  id: "himsx-system-setting_svg__b",
  width: 512,
  height: 512,
  "data-name": "settings.png",
  href: "data:image/png;base64,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"
})));

const SvgHimsxUnitSetup = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#himsx-unit-setup_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFA001",
  d: "M17.083 4.906V14.97L8.54 19.876 0 14.97V4.906L8.541 0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F87F02",
  d: "M17.083 4.906V14.97L8.54 19.876V0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F4D34E",
  d: "M17.083 4.906 8.54 9.81 0 4.906 8.541 0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFA41F",
  d: "M17.083 4.906 8.54 9.81V0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#514B7F",
  d: "M22.633 19.017a5.6 5.6 0 0 1-.355.858l.636 1.297-1.742 1.742-1.297-.636a5.6 5.6 0 0 1-.858.355L18.551 24h-2.465l-.467-1.367a5.6 5.6 0 0 1-.857-.355l-1.297.636-1.743-1.742.637-1.297a5.5 5.5 0 0 1-.355-.858l-1.367-.466v-2.465l1.367-.467a5.6 5.6 0 0 1 .355-.857l-.637-1.297 1.743-1.743 1.297.637a5.6 5.6 0 0 1 .857-.355l.467-1.367h2.465l.466 1.367q.448.143.858.355l1.297-.637 1.742 1.743-.636 1.297q.211.411.355.857l1.367.467v2.465z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2B2F5B",
  d: "M22.633 19.017a5.6 5.6 0 0 1-.355.858l.636 1.297-1.742 1.742-1.297-.636a5.6 5.6 0 0 1-.858.355L18.55 24h-1.232V10.637h1.232l.467 1.367q.446.143.858.355l1.297-.637 1.742 1.743-.636 1.297q.211.411.355.857l1.367.467v2.465z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F2F2FC",
  d: "M20.271 17.319a2.953 2.953 0 1 1-5.905 0 2.953 2.953 0 0 1 5.905 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D8D8FC",
  d: "M20.271 17.319a2.953 2.953 0 0 1-2.953 2.952v-5.906a2.953 2.953 0 0 1 2.953 2.954"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "himsx-unit-setup_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
}))));

const SvgHimsxUnitTypeMapping = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#himsx-unit-type-mapping_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#CAD0D7",
  fillRule: "evenodd",
  d: "m14.741.86 8.438 4.822c.045.026.071.07.071.122V16.69a.14.14 0 0 1-.14.14h-8.438a.14.14 0 0 1-.141-.14V.982c0-.052.025-.096.07-.122a.14.14 0 0 1 .14 0",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E4E8EB",
  fillRule: "evenodd",
  d: "M7.09 3.712h8.72V16.83H7.09V3.71Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F76C82",
  fillRule: "evenodd",
  d: "m11.52.78 3.015 1.723 2.626 1.5a.14.14 0 0 1 .066.159.14.14 0 0 1-.136.104H5.808a.14.14 0 0 1-.136-.104.14.14 0 0 1 .067-.159l2.625-1.5L11.38.779a.14.14 0 0 1 .14 0Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#A9B0BB",
  fillRule: "evenodd",
  d: "m15.81 5.955 3.943 2.254v8.622h-3.944z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#CAD0D7",
  fillRule: "evenodd",
  d: "M8.222 5.638h6.456v11.193H8.222z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#A9B0BB",
  fillRule: "evenodd",
  d: "M11.45 7.096c.645 0 1.172.528 1.172 1.173v1.592a.14.14 0 0 1-.14.14h-2.064a.14.14 0 0 1-.14-.14V8.269c0-.645.527-1.173 1.172-1.173",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FDCD56",
  fillRule: "evenodd",
  d: "M13.147 17.893c-1.263 0-1.896 1.529-1.003 2.42a.42.42 0 0 1 0 .596l-.907.907a.42.42 0 0 1-.595 0c-.892-.893-2.421-.26-2.421 1.003a.42.42 0 0 1-.421.42H6.518a.42.42 0 0 1-.421-.42c0-1.264-1.528-1.897-2.421-1.003a.42.42 0 0 1-.596 0l-.906-.907a.42.42 0 0 1 0-.595c.892-.892.26-2.421-1.003-2.421a.42.42 0 0 1-.421-.421V16.19a.42.42 0 0 1 .421-.421c1.262 0 1.895-1.529 1.003-2.421a.42.42 0 0 1 0-.596l.906-.906a.42.42 0 0 1 .596 0c.892.892 2.42.259 2.42-1.003 0-.233.19-.421.422-.421H7.8a.42.42 0 0 1 .42.421c0 1.262 1.53 1.895 2.422 1.003a.42.42 0 0 1 .595 0l.907.906a.42.42 0 0 1 0 .596c-.893.892-.26 2.42 1.003 2.42a.42.42 0 0 1 .42.422v1.282a.42.42 0 0 1-.42.42Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F4F6F8",
  d: "M10.057 18.035a3.133 3.133 0 1 0-5.788-2.4 3.133 3.133 0 0 0 5.788 2.4"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#66D4F1",
  fillRule: "evenodd",
  d: "M2.62 17.159a.328.328 0 1 1 0-.656h2.43c.1 0 .189.045.25.115l1.102 1.118 1.147-2.518a.327.327 0 0 1 .544-.078l1.191 1.37 2.413-.006a.327.327 0 0 1 0 .654l-2.548.005a.33.33 0 0 1-.261-.112l-.955-1.099-1.127 2.474a.327.327 0 0 1-.537.107L4.913 17.16H2.621Z",
  clipRule: "evenodd"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "himsx-unit-type-mapping_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
}))));

const SvgHome = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 30 30"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#ff4155",
  d: "M21.412 5.757h2.994v5.227h-2.994z",
  "data-name": "Rectangle 26115"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ff4155",
  d: "M20.269 3.089h5.281V5.92h-5.281z",
  "data-name": "Rectangle 26116"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fcbc45",
  d: "M4.287 16.038V28h21.209V16.038L14.887 5.43a930 930 0 0 1-10.6 10.608",
  "data-name": "Path 68764"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M25.55 16.101 14.946 5.43c-2.11 2.069-3.733 3.7-5.356 5.335L4.29 16.1v2.45L14.887 7.88l10.6 10.671v.327-2.777h.054Z",
  "data-name": "Path 68765"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M18.104 28H11.68v-6.315a3.22 3.22 0 0 1 3.212-3.212 3.22 3.22 0 0 1 3.212 3.212Z",
  "data-name": "Path 68766"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ff4155",
  d: "M27.512 13.868 16.192 2.49a1.76 1.76 0 0 0-2.437 0L2.488 13.868a1.783 1.783 0 0 0 0 2.45 1.76 1.76 0 0 0 2.437 0L15 6.192l10.075 10.126a1.76 1.76 0 0 0 2.438 0 1.78 1.78 0 0 0-.001-2.45",
  "data-name": "Path 68767"
}));

const SvgIfcax7Days = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 512 512"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#f3f5f9",
  d: "M512 512H62V214.842l22.5 12.964c17.038 9.817 35.508 14.589 54.846 14.169 38.111-.829 72.202-24.308 91.253-57.327l1.528-2.648H482c16.569 0 30 13.431 30 30z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e1e6f0",
  d: "M482 182H287v330h225V212c0-16.569-13.431-30-30-30"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f73",
  d: "M512 212H214.842l12.949-22.485C237.078 173.387 242 155.237 242 137c0-9.463-1.084-17.944-3.34-25.942L233.299 92H512z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 135,
  cy: 135,
  r: 135,
  fill: "#6cf"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#59abff",
  d: "M270 135C270 60.441 209.561 0 135 0v270c74.561 0 135-60.441 135-135"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 135,
  cy: 135,
  r: 105,
  fill: "#f3f5f9"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e1e6f0",
  d: "M240 135c0-57.897-47.103-105-105-105v210c57.897 0 105-47.103 105-105"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#66538c",
  d: "M210 150h-90V60h30v60h60z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#443d66",
  d: "M150 60h-15v90h75v-30h-60z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e64c2e",
  d: "M287 92h225v120H287z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#443d66",
  d: "M392 62h30v90h-30z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#66538c",
  d: "m297.928 425.193-29.121-7.28L297.781 302H242v-30h94.219z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#443d66",
  d: "M287 302h10.781L287 345.13v77.331l10.928 2.732L336.219 272H287z"
}));

const SvgIfcaxAccessSecurity = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 20 20"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57336"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h20v20H0z",
  "data-name": "Rectangle 26174"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#384949",
  d: "m10.778 17.189 4.932-2.466.524 1.048-4.932 2.466Z",
  "data-name": "Path 69280"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#384949",
  d: "M16.445 6.445h1.172v7.109h-1.172Z",
  "data-name": "Path 69281"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#384949",
  d: "m10.783 2.811.524-1.048 4.932 2.466-.524 1.048Z",
  "data-name": "Path 69282"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4a696f",
  d: "m3.748 15.774.524-1.048 4.932 2.466-.524 1.048Z",
  "data-name": "Path 69283"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4a696f",
  d: "m3.753 4.225 4.932-2.466.524 1.048-4.932 2.466Z",
  "data-name": "Path 69284"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4a696f",
  d: "M2.383 6.445h1.172v7.109H2.383Z",
  "data-name": "Path 69285"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#83ede6",
  "data-name": "Group 57335"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10 0a1.755 1.755 0 1 0 1.242.514A1.76 1.76 0 0 0 10 0",
  "data-name": "Path 69286"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10 16.484a1.755 1.755 0 1 0 1.244.514A1.76 1.76 0 0 0 10 16.484",
  "data-name": "Path 69287"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.969 16.485a1.758 1.758 0 1 1 1.758-1.758 1.76 1.76 0 0 1-1.758 1.758",
  "data-name": "Path 69288"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.969 7.032a1.758 1.758 0 1 1 1.758-1.758 1.76 1.76 0 0 1-1.758 1.758",
  "data-name": "Path 69289"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#64e1dc",
  d: "M17.031 7.032a1.758 1.758 0 1 1 1.758-1.758 1.76 1.76 0 0 1-1.758 1.758",
  "data-name": "Path 69290"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#64e1dc",
  d: "M17.031 16.485a1.758 1.758 0 1 1 1.758-1.758 1.76 1.76 0 0 1-1.758 1.758",
  "data-name": "Path 69291"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4a696f",
  d: "M12.929 8.203v1.211h-1.172V8.203a1.758 1.758 0 0 0-3.516 0v1.211H7.07V8.203a2.93 2.93 0 1 1 5.859 0",
  "data-name": "Path 69292"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#384949",
  d: "M12.93 8.203v1.211h-1.172V8.203A1.755 1.755 0 0 0 10 6.445V5.273a2.93 2.93 0 0 1 2.93 2.93",
  "data-name": "Path 69293"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffb64c",
  d: "M5.898 8.828v4.727h8.2V8.828Z",
  "data-name": "Path 69294"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ff9100",
  d: "M10 8.828h4.1v4.727H10Z",
  "data-name": "Path 69295"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4a696f",
  d: "M9.414 10h1.172v1.172H9.414Z",
  "data-name": "Path 69296"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#384949",
  d: "M10 10h.586v1.172H10Z",
  "data-name": "Path 69297"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#64e1dc",
  d: "M11.758 18.242A1.755 1.755 0 0 1 10 20v-3.516a1.755 1.755 0 0 1 1.758 1.758",
  "data-name": "Path 69298"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#64e1dc",
  d: "M10 3.516V0a1.758 1.758 0 0 1 0 3.516",
  "data-name": "Path 69299"
})));

const SvgIfcaxAccountxIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  xmlSpace: "preserve",
  width: "1em",
  height: "1em",
  viewBox: "0 0 341.333 341.333"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "ifcax-accountx-icon_svg__b",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 256h256V0H0Z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "ifcax-accountx-icon_svg__c",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  d: "M37.894 222.033h181.212v-20.196H37.894Z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "ifcax-accountx-icon_svg__d",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  d: "M37.894 137.033h181.212v-20.196H37.894Z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "ifcax-accountx-icon_svg__e",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  d: "M37.894 48.033h181.212V27.837H37.894Z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "ifcax-accountx-icon_svg__f",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.894 93.033h232.212V72.837H11.894Z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "ifcax-accountx-icon_svg__g",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.894 180.033h232.212v-20.196H11.894Z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "ifcax-accountx-icon_svg__h",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.88 234.84H169V-27.24H3.88Z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "ifcax-accountx-icon_svg__a",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.88 234.84H169V-27.24H3.88Z"
})), /*#__PURE__*/React.createElement("mask", {
  id: "ifcax-accountx-icon_svg__i",
  width: 1,
  height: 1,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#ifcax-accountx-icon_svg__a)"
}, /*#__PURE__*/React.createElement("image", {
  xlinkHref: "data:image/png;base64,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",
  width: 1,
  height: 1,
  preserveAspectRatio: "none",
  style: {
    imageRendering: "optimizeSpeed"
  },
  transform: "matrix(165.12 0 0 -262.07999 3.88 234.84)"
}))), /*#__PURE__*/React.createElement("mask", {
  id: "ifcax-accountx-icon_svg__j",
  width: 1,
  height: 1,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("image", {
  xlinkHref: "data:image/png;base64,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",
  width: 1,
  height: 1,
  preserveAspectRatio: "none",
  style: {
    imageRendering: "optimizeSpeed"
  }
}))), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#ifcax-accountx-icon_svg__b)",
  transform: "matrix(1.33333 0 0 -1.33333 0 341.333)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h-115.522c-31.768 0-57.76 25.992-57.76 57.761v115.521c0 31.769 25.992 57.761 57.76 57.761H0c31.768 0 57.761-25.992 57.761-57.761V57.761C57.761 25.992 31.768 0 0 0",
  style: {
    fill: "#faaf22",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(186.135 11.194)"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#ifcax-accountx-icon_svg__c)",
  opacity: 0.27
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0 7.67.035 5.901-4.32-4.41-2.619z",
  style: {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(38.589 218.036)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0 3.742 3.004 11.05-8.319-7.76.019z",
  style: {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(53.049 207.152)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0s12.581 13.714 38.212 20.196c0 0-18.336-6.584-29.668-20.196z",
  style: {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(37.894 201.837)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0 7.67.035 5.901-4.32-4.41-2.619z",
  style: {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(108.589 218.036)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0 3.742 3.004 11.05-8.319-7.76.019z",
  style: {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(123.049 207.152)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0s12.581 13.714 38.212 20.196c0 0-18.336-6.584-29.668-20.196z",
  style: {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(107.894 201.837)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0 7.67.035 5.901-4.32-4.41-2.619z",
  style: {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(181.589 218.036)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0 3.742 3.004 11.05-8.319-7.76.019z",
  style: {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(196.049 207.152)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0s12.581 13.714 38.212 20.196c0 0-18.336-6.584-29.668-20.196z",
  style: {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(180.894 201.837)"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#ifcax-accountx-icon_svg__d)",
  opacity: 0.27
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0 7.67.035 5.901-4.32-4.41-2.619z",
  style: {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(38.589 133.036)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0 3.742 3.004 11.05-8.319-7.76.019z",
  style: {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(53.049 122.152)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0s12.581 13.714 38.212 20.196c0 0-18.336-6.584-29.668-20.196z",
  style: {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(37.894 116.837)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0 7.67.035 5.901-4.32-4.41-2.619z",
  style: {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(108.589 133.036)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0 3.742 3.004 11.05-8.319-7.76.019z",
  style: {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(123.049 122.152)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0s12.581 13.714 38.212 20.196c0 0-18.336-6.584-29.668-20.196z",
  style: {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(107.894 116.837)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0 7.67.035 5.901-4.32-4.41-2.619z",
  style: {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(181.589 133.036)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0 3.742 3.004 11.05-8.319-7.76.019z",
  style: {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(196.049 122.152)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0s12.581 13.714 38.212 20.196c0 0-18.336-6.584-29.668-20.196z",
  style: {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(180.894 116.837)"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#ifcax-accountx-icon_svg__e)",
  opacity: 0.27
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0 7.67.035 5.901-4.32-4.41-2.619z",
  style: {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(38.589 44.036)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0 3.742 3.004 11.05-8.319-7.76.019z",
  style: {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(53.049 33.152)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0s12.581 13.714 38.212 20.196c0 0-18.336-6.584-29.668-20.196z",
  style: {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(37.894 27.837)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0 7.67.035 5.901-4.32-4.41-2.619z",
  style: {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(108.589 44.036)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0 3.742 3.004 11.05-8.319-7.76.019z",
  style: {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(123.049 33.152)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0s12.581 13.714 38.212 20.196c0 0-18.336-6.584-29.668-20.196z",
  style: {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(107.894 27.837)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0 7.67.035 5.901-4.32-4.41-2.619z",
  style: {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(181.589 44.036)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0 3.742 3.004 11.05-8.319-7.76.019z",
  style: {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(196.049 33.152)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0s12.581 13.714 38.212 20.196c0 0-18.336-6.584-29.668-20.196z",
  style: {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(180.894 27.837)"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#ifcax-accountx-icon_svg__f)",
  opacity: 0.27
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0 7.67.035 5.901-4.32-4.41-2.619z",
  style: {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(74.589 89.037)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0 3.742 3.004 11.05-8.319-7.76.019z",
  style: {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(89.049 78.152)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0s12.581 13.714 38.212 20.196c0 0-18.336-6.584-29.668-20.196z",
  style: {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(73.894 72.837)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0 7.67.035 5.901-4.32-4.41-2.619z",
  style: {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(12.589 89.037)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0 3.742 3.004 11.05-8.319-7.76.019z",
  style: {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(27.049 78.152)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0s12.581 13.714 38.212 20.196c0 0-18.336-6.584-29.668-20.196z",
  style: {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(11.894 72.837)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0 7.67.035 5.901-4.32-4.41-2.619z",
  style: {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(142.589 89.037)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0 3.742 3.004 11.05-8.319-7.76.019z",
  style: {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(157.049 78.152)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0s12.581 13.714 38.212 20.196c0 0-18.336-6.584-29.668-20.196z",
  style: {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(141.894 72.837)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0 7.67.035 5.901-4.32-4.41-2.619z",
  style: {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(206.589 89.037)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0 3.742 3.004 11.05-8.319-7.76.019z",
  style: {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(221.049 78.152)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0s12.581 13.714 38.212 20.196c0 0-18.336-6.584-29.668-20.196z",
  style: {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(205.894 72.837)"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#ifcax-accountx-icon_svg__g)",
  opacity: 0.27
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0 7.67.035 5.901-4.32-4.41-2.619z",
  style: {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(74.589 176.036)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0 3.742 3.004 11.05-8.319-7.76.019z",
  style: {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(89.049 165.152)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0s12.581 13.714 38.212 20.196c0 0-18.336-6.584-29.668-20.196z",
  style: {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(73.894 159.837)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0 7.67.035 5.901-4.32-4.41-2.619z",
  style: {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(12.589 176.036)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0 3.742 3.004 11.05-8.319-7.76.019z",
  style: {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(27.049 165.152)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0s12.581 13.714 38.212 20.196c0 0-18.336-6.584-29.668-20.196z",
  style: {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(11.894 159.837)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0 7.67.035 5.901-4.32-4.41-2.619z",
  style: {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(142.589 176.036)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0 3.742 3.004 11.05-8.319-7.76.019z",
  style: {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(157.049 165.152)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0s12.581 13.714 38.212 20.196c0 0-18.336-6.584-29.668-20.196z",
  style: {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(141.894 159.837)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0 7.67.035 5.901-4.32-4.41-2.619z",
  style: {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(206.589 176.036)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0 3.742 3.004 11.05-8.319-7.76.019z",
  style: {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(221.049 165.152)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0s12.581 13.714 38.212 20.196c0 0-18.336-6.584-29.668-20.196z",
  style: {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(205.894 159.837)"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#ifcax-accountx-icon_svg__h)",
  opacity: 0.39
}, /*#__PURE__*/React.createElement("g", {
  mask: "url(#ifcax-accountx-icon_svg__i)"
}, /*#__PURE__*/React.createElement("image", {
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAArAAAARECAYAAACNlyKDAAAABHNCSVQICAgIfAhkiAAAFOpJREFUeJzt1kENACAQwLAD/55BAy+ypFWw59bMnAEAgIj9OwAAAF4YWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApBhYAgBQDCwBAioEFACDFwAIAkGJgAQBIMbAAAKQYWAAAUgwsAAApF8YLCYeWxDyKAAAAAElFTkSuQmCC",
  width: 1,
  height: 1,
  mask: "url(#ifcax-accountx-icon_svg__j)",
  preserveAspectRatio: "none",
  style: {
    imageRendering: "optimizeSpeed"
  },
  transform: "matrix(165.12 0 0 -262.07999 3.88 234.84)"
}))), /*#__PURE__*/React.createElement("text", {
  style: {
    fontVariant: "normal",
    fontWeight: 700,
    fontStretch: "normal",
    fontSize: "187.887px",
    fontFamily: "Arial",
    writingMode: "lr-tb",
    fill: "#231f20",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "matrix(1 0 0 -1 17.095 60.495)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "A")), /*#__PURE__*/React.createElement("path", {
  d: "m0 0 35.006.158 26.93-19.716L41.809-31.51Z",
  style: {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(72.642 134.962)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0 17.076 13.709 50.433-37.965-35.416.086Z",
  style: {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(138.634 85.288)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0s57.415 62.587 174.389 92.172c0 0-83.68-30.048-135.397-92.172z",
  style: {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(69.472 61.03)"
})));

const SvgIfcaxAppDev = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 66 66"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#ff4823",
  d: "m62.57 14.13-2.81-.69a10.8 10.8 0 0 0-1.32-3.18l1.5-2.48c.19-.32.14-.73-.12-.99L58.4 5.37a.815.815 0 0 0-.99-.12l-2.48 1.5c-.97-.6-2.04-1.05-3.18-1.32l-.69-2.81a.82.82 0 0 0-.79-.62h-2.01c-.37 0-.7.25-.78.61l-.69 2.81c-1.14.27-2.21.72-3.18 1.32l-2.48-1.5a.815.815 0 0 0-.99.12L38.7 6.79c-.26.26-.31.67-.12.99l1.5 2.48c-.6.97-1.05 2.04-1.32 3.18l-2.81.69c-.36.09-.61.41-.61.78v2.01c0 .37.25.7.61.78l2.81.69c.27 1.14.72 2.21 1.32 3.17l-1.5 2.48c-.19.32-.14.73.12.99l1.42 1.42c.26.26.67.31.99.12l2.48-1.5c.97.6 2.04 1.05 3.18 1.32l.69 2.81c.09.36.41.61.78.61h2.01c.37 0 .7-.25.78-.61l.69-2.81c1.14-.27 2.21-.72 3.18-1.32l2.48 1.5c.32.19.73.14.99-.12l1.42-1.42c.26-.26.31-.67.12-.99l-1.5-2.48c.6-.97 1.05-2.04 1.32-3.17l2.81-.69c.36-.09.61-.41.61-.78v-2.01a.746.746 0 0 0-.58-.78m-13.31 7.62a5.83 5.83 0 1 1 0-11.66 5.83 5.83 0 0 1 0 11.66"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#009aff",
  d: "M51.37 19.82c0-1.11-.9-2.01-2.01-2.01H3.99c-1.11 0-2.01.9-2.01 2.01v27.37h49.39z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M49.36 17.81H21.88c0 2.21 1.79 4 4 4h21.49v5.36c0 2.21 1.79 4 4 4V19.82c0-1.11-.9-2.01-2.01-2.01",
  opacity: 0.35
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e6e9ee",
  d: "M1.98 47.19v6.61c0 1.11.9 2.01 2.01 2.01h45.37c1.11 0 2.01-.9 2.01-2.01v-6.61z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.97 49.87c-17.75 0-32.13-14.39-32.13-32.13H3.99c-1.11 0-2.01.9-2.01 2.01v33.97c0 1.11.9 2.01 2.01 2.01h45.36c1.11 0 2.01-.9 2.01-2.01v-3.85z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  fill: "#aab2bd",
  d: "M19.32 55.81h14.71v4.17H19.32z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e6e9ee",
  d: "M38.16 59.98H15.2c-1.11 0-2.01.9-2.01 2.01V64h26.98v-2.01c0-1.11-.9-2.01-2.01-2.01"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fec200",
  d: "M61.91 29.48H32.54c-1.11 0-2.01.9-2.01 2.01v4.62h33.4v-4.62a2.025 2.025 0 0 0-2.02-2.01"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.25 33.86c-2.42 0-4.38-1.96-4.38-4.38h-.25c-1.11 0-2.01.9-2.01 2.01v4.62h33.4v-2.26H37.25z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M10.42 34.72c-.26 0-.51-.1-.71-.29l-3.4-3.4c-.19-.19-.29-.44-.29-.71s.11-.52.29-.71l3.4-3.4a.996.996 0 1 1 1.41 1.41l-2.7 2.7 2.7 2.7c.39.39.39 1.02 0 1.41a.96.96 0 0 1-.7.29M20.7 34.72c-.26 0-.51-.1-.71-.29a.996.996 0 0 1 0-1.41l2.7-2.7-2.7-2.7a.996.996 0 1 1 1.41-1.41l3.4 3.4c.19.19.29.44.29.71s-.11.52-.29.71l-3.4 3.4c-.19.2-.44.29-.7.29M12.54 37.8a.994.994 0 0 1-.9-1.42l6.04-12.95c.23-.5.83-.72 1.33-.48.5.23.72.83.48 1.33l-6.04 12.95c-.17.35-.53.57-.91.57"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5d5b68",
  d: "M30.53 36.12v25.87c0 1.11.9 2.01 2.01 2.01h29.38c1.11 0 2.01-.9 2.01-2.01V36.12z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ff4823",
  d: "M58.9 40.14H35.55c-.55 0-1 .45-1 1v9.28c0 .55.45 1 1 1H58.9c.55 0 1-.45 1-1v-9.28c0-.56-.44-1-1-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M59.9 50.42v-.09l-10.22-4.55 10.22-4.55v-.1c0-.55-.45-1-1-1h-1.46l-10.22 4.55L37 40.13h-1.46c-.55 0-1 .45-1 1v.1l10.22 4.55-10.22 4.55v.09c0 .55.45 1 1 1H37l10.22-4.55 10.22 4.55h1.46c.56 0 1-.45 1-1",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("g", {
  fill: "#fff"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 34.82,
  cy: 32.8,
  r: 1.01
}), /*#__PURE__*/React.createElement("circle", {
  cx: 38.44,
  cy: 32.8,
  r: 1.01
}), /*#__PURE__*/React.createElement("circle", {
  cx: 42.06,
  cy: 32.8,
  r: 1.01
})), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M44.18 56.7h-9.64c-.55 0-1-.45-1-1s.45-1 1-1h9.64c.55 0 1 .45 1 1s-.45 1-1 1M39.15 61.14h-4.61c-.55 0-1-.45-1-1s.45-1 1-1h4.61c.55 0 1 .45 1 1s-.45 1-1 1M59.9 56.86h-9.64c-.55 0-1-.45-1-1s.45-1 1-1h9.64c.55 0 1 .45 1 1s-.44 1-1 1M54.87 61.14h-4.61c-.55 0-1-.45-1-1s.45-1 1-1h4.61c.55 0 1 .45 1 1s-.44 1-1 1"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 26.68,
  cy: 51.5,
  r: 1.01,
  fill: "#009aff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M58.41 58.75c-12.5 0-22.64-10.14-22.64-22.64h-5.25v25.87c0 1.11.9 2.01 2.01 2.01h29.38c1.11 0 2.01-.9 2.01-2.01v-3.24h-5.51z",
  opacity: 0.1
}));

const SvgIfcaxAxIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  id: "ifcax-ax-icon_svg__Layer_1",
  viewBox: "0 0 232.21 231.04",
  width: "1em",
  height: "1em"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "ifcax-ax-icon_svg__drop-shadow-1",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: 2,
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "blur",
  stdDeviation: 5
}), /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#000",
  floodOpacity: 0.39
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "blur",
  operator: "in"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "SourceGraphic"
})), /*#__PURE__*/React.createElement("style", null, ".ifcax-ax-icon_svg__cls-1{fill:#fff}.ifcax-ax-icon_svg__cls-5{opacity:.27}")), /*#__PURE__*/React.createElement("rect", {
  width: 231.04,
  height: 231.04,
  x: 0.96,
  rx: 57.76,
  ry: 57.76,
  style: {
    fill: "#faaf22"
  }
}), /*#__PURE__*/React.createElement("g", {
  className: "ifcax-ax-icon_svg__cls-5"
}, /*#__PURE__*/React.createElement("path", {
  d: "m26.69 24.2 7.68-.03 5.9 4.32-4.41 2.61zM41.15 35.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-ax-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26 40.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM96.69 24.2l7.68-.03 5.9 4.32-4.41 2.61zM111.15 35.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-ax-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M96 40.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM169.69 24.2l7.68-.03 5.9 4.32-4.41 2.61zM184.15 35.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-ax-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M169 40.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2z",
  className: "ifcax-ax-icon_svg__cls-1"
})), /*#__PURE__*/React.createElement("g", {
  className: "ifcax-ax-icon_svg__cls-5"
}, /*#__PURE__*/React.createElement("path", {
  d: "m26.69 109.2 7.68-.03 5.9 4.32-4.41 2.61zM41.15 120.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-ax-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26 125.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM96.69 109.2l7.68-.03 5.9 4.32-4.41 2.61zM111.15 120.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-ax-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M96 125.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM169.69 109.2l7.68-.03 5.9 4.32-4.41 2.61zM184.15 120.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-ax-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M169 125.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2z",
  className: "ifcax-ax-icon_svg__cls-1"
})), /*#__PURE__*/React.createElement("g", {
  className: "ifcax-ax-icon_svg__cls-5"
}, /*#__PURE__*/React.createElement("path", {
  d: "m26.69 198.2 7.68-.03 5.9 4.32-4.41 2.61zM41.15 209.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-ax-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26 214.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM96.69 198.2l7.68-.03 5.9 4.32-4.41 2.61zM111.15 209.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-ax-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M96 214.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM169.69 198.2l7.68-.03 5.9 4.32-4.41 2.61zM184.15 209.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-ax-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M169 214.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2z",
  className: "ifcax-ax-icon_svg__cls-1"
})), /*#__PURE__*/React.createElement("g", {
  className: "ifcax-ax-icon_svg__cls-5"
}, /*#__PURE__*/React.createElement("path", {
  d: "m62.69 153.2 7.68-.03 5.9 4.32-4.41 2.61zM77.15 164.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-ax-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M62 169.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM.69 153.2l7.68-.03 5.9 4.32-4.41 2.61zM15.15 164.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-ax-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 169.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM130.69 153.2l7.68-.03 5.9 4.32-4.41 2.61zM145.15 164.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-ax-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M130 169.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM194.69 153.2l7.68-.03 5.9 4.32-4.41 2.61zM209.15 164.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-ax-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M194 169.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2z",
  className: "ifcax-ax-icon_svg__cls-1"
})), /*#__PURE__*/React.createElement("g", {
  className: "ifcax-ax-icon_svg__cls-5"
}, /*#__PURE__*/React.createElement("path", {
  d: "m62.69 66.2 7.68-.03 5.9 4.32-4.41 2.61zM77.15 77.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-ax-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M62 82.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM.69 66.2l7.68-.03 5.9 4.32-4.41 2.61zM15.15 77.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-ax-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 82.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM130.69 66.2l7.68-.03 5.9 4.32-4.41 2.61zM145.15 77.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-ax-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M130 82.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM194.69 66.2l7.68-.03 5.9 4.32-4.41 2.61zM209.15 77.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-ax-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M194 82.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2z",
  className: "ifcax-ax-icon_svg__cls-1"
})), /*#__PURE__*/React.createElement("g", {
  style: {
    filter: "url(#ifcax-ax-icon_svg__drop-shadow-1)"
  }
}, /*#__PURE__*/React.createElement("path", {
  d: "M140.15 181.74h-29.54l-11.74-30.55H45.11l-11.1 30.55H5.2L57.59 47.25H86.3zm-50-53.21L71.62 78.62l-18.16 49.91h36.7Z",
  style: {
    fill: "#231f20"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "m60.75 107.28 35-.16 26.93 19.71-20.12 11.96zM126.74 156.95l17.08-13.71 50.43 37.96-35.42-.08z",
  className: "ifcax-ax-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M57.58 181.21S115 118.62 231.97 89.04c0 0-83.68 30.05-135.4 92.17z",
  className: "ifcax-ax-icon_svg__cls-1"
}));

const SvgIfcaxBill = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 500 500"
}, props), /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  clipRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#e8dab2",
  d: "M86.7 493.66h362.88c18.23 0 33.14-14.91 33.14-33.14V39.47c0-18.23-14.91-33.14-33.14-33.14H86.7c-18.23 0-33.14 14.91-33.14 33.14v421.05c0 18.23 14.91 33.14 33.14 33.14"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fdb714",
  d: "M17.29 200.98c0 10.45 6.81 19.01 15.14 19.01h50.96c8.33 0 15.14-8.55 15.14-19.01 0-10.45-6.81-19.01-15.14-19.01H32.43c-8.33 0-15.14 8.55-15.14 19.01m0-98.05c0 10.45 6.81 19.01 15.14 19.01h50.96c8.33 0 15.14-8.55 15.14-19.01 0-10.45-6.81-19.01-15.14-19.01H32.43c-8.33.01-15.14 8.56-15.14 19.01m0 294.14c0 10.45 6.81 19.01 15.14 19.01h50.96c8.33 0 15.14-8.55 15.14-19.01 0-10.45-6.81-19.01-15.14-19.01H32.43c-8.33 0-15.14 8.55-15.14 19.01m0-98.05c0 10.45 6.81 19.01 15.14 19.01h50.96c8.33 0 15.14-8.55 15.14-19.01 0-10.45-6.81-19.01-15.14-19.01H32.43c-8.33 0-15.14 8.56-15.14 19.01"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#00b2ca"
}, /*#__PURE__*/React.createElement("path", {
  d: "M152.28 223.74v52.53c0 7.06 5.78 12.84 12.84 12.84h52.53c7.06 0 12.84-5.78 12.84-12.84v-52.53c0-7.06-5.78-12.84-12.84-12.84h-52.53c-7.07-.01-12.84 5.77-12.84 12.84M152.28 357.4v52.53c0 7.06 5.78 12.84 12.84 12.84h52.53c7.06 0 12.84-5.78 12.84-12.84V357.4c0-7.06-5.78-12.84-12.84-12.84h-52.53c-7.07-.01-12.84 5.77-12.84 12.84M152.28 90.08v52.53c0 7.06 5.78 12.84 12.84 12.84h52.53c7.06 0 12.84-5.78 12.84-12.84V90.08c0-7.06-5.78-12.84-12.84-12.84h-52.53c-7.07-.01-12.84 5.77-12.84 12.84"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#010101",
  d: "M272.36 367.01c-3.5 0-6.34-2.84-6.34-6.34s2.84-6.34 6.34-6.34h146.61c3.5 0 6.34 2.84 6.34 6.34s-2.84 6.34-6.34 6.34zm0 45.97c-3.5 0-6.34-2.84-6.34-6.34s2.84-6.34 6.34-6.34h146.61c3.5 0 6.34 2.84 6.34 6.34s-2.84 6.34-6.34 6.34zm0-313.29c-3.5 0-6.34-2.84-6.34-6.34s2.84-6.34 6.34-6.34h146.61c3.5 0 6.34 2.84 6.34 6.34s-2.84 6.34-6.34 6.34zm0 45.97c-3.5 0-6.34-2.84-6.34-6.34s2.84-6.34 6.34-6.34h146.61c3.5 0 6.34 2.84 6.34 6.34s-2.84 6.34-6.34 6.34zm0 87.69c-3.5 0-6.34-2.84-6.34-6.34s2.84-6.34 6.34-6.34h146.61c3.5 0 6.34 2.84 6.34 6.34s-2.84 6.34-6.34 6.34zm0 45.97c-3.5 0-6.34-2.84-6.34-6.34s2.84-6.34 6.34-6.34h146.61c3.5 0 6.34 2.84 6.34 6.34s-2.84 6.34-6.34 6.34zM158.61 90.08v52.53c0 1.78.73 3.41 1.92 4.59a6.5 6.5 0 0 0 4.59 1.92h52.53c1.78 0 3.41-.73 4.59-1.92a6.5 6.5 0 0 0 1.92-4.59V90.08c0-1.78-.73-3.41-1.92-4.59a6.5 6.5 0 0 0-4.59-1.92h-52.53c-1.78 0-3.41.73-4.59 1.92a6.44 6.44 0 0 0-1.92 4.59m-12.67 52.53V90.08c0-5.28 2.16-10.08 5.63-13.55s8.27-5.63 13.55-5.63h52.53c5.28 0 10.08 2.16 13.55 5.63s5.63 8.27 5.63 13.55v52.53c0 5.28-2.16 10.08-5.63 13.55s-8.27 5.63-13.55 5.63h-52.53c-5.28 0-10.08-2.16-13.55-5.63-3.47-3.48-5.63-8.27-5.63-13.55m12.67 214.79v52.53c0 1.78.73 3.41 1.92 4.59a6.5 6.5 0 0 0 4.59 1.92h52.53c1.78 0 3.41-.73 4.59-1.92a6.5 6.5 0 0 0 1.92-4.59V357.4c0-1.78-.73-3.41-1.92-4.59a6.5 6.5 0 0 0-4.59-1.92h-52.53c-1.78 0-3.41.73-4.59 1.92a6.44 6.44 0 0 0-1.92 4.59m-12.67 52.52V357.4c0-5.28 2.16-10.08 5.63-13.55s8.27-5.63 13.55-5.63h52.53c5.28 0 10.08 2.16 13.55 5.63s5.63 8.27 5.63 13.55v52.53c0 5.28-2.16 10.08-5.63 13.55s-8.27 5.63-13.55 5.63h-52.53c-5.28 0-10.08-2.16-13.55-5.63-3.47-3.48-5.63-8.28-5.63-13.56m12.67-186.18v52.53c0 1.78.73 3.41 1.92 4.59a6.5 6.5 0 0 0 4.59 1.92h52.53c1.78 0 3.41-.73 4.59-1.92a6.5 6.5 0 0 0 1.92-4.59v-52.53c0-1.78-.73-3.41-1.92-4.59a6.5 6.5 0 0 0-4.59-1.92h-52.53c-1.78 0-3.41.73-4.59 1.92a6.44 6.44 0 0 0-1.92 4.59m-12.67 52.52v-52.53c0-5.28 2.16-10.08 5.63-13.55s8.27-5.63 13.55-5.63h52.53c5.28 0 10.08 2.16 13.55 5.63s5.63 8.27 5.63 13.55v52.53c0 5.28-2.16 10.08-5.63 13.55s-8.27 5.63-13.55 5.63h-52.53c-5.28 0-10.08-2.16-13.55-5.63s-5.63-8.26-5.63-13.55M23.62 200.98c0 3.76 1.17 7.12 3.06 9.49 1.56 1.96 3.61 3.18 5.75 3.18h50.96c2.14 0 4.18-1.22 5.75-3.18 1.89-2.37 3.06-5.73 3.06-9.49s-1.17-7.12-3.06-9.49c-1.56-1.96-3.61-3.18-5.75-3.18H32.43c-2.14 0-4.18 1.22-5.75 3.18-1.88 2.37-3.06 5.72-3.06 9.49m-12.67 0c0 6.69 2.23 12.84 5.83 17.36 3.92 4.93 9.46 7.98 15.64 7.98h14.79v47.36H32.43c-6.19 0-11.72 3.06-15.64 7.98-3.6 4.52-5.83 10.67-5.83 17.36s2.23 12.84 5.83 17.36c3.92 4.93 9.46 7.98 15.64 7.98h14.79v47.36H32.43c-6.19 0-11.72 3.06-15.64 7.98-3.6 4.52-5.83 10.67-5.83 17.36s2.23 12.84 5.83 17.36c3.92 4.93 9.46 7.98 15.64 7.98h14.79v38.12c0 10.86 4.44 20.73 11.59 27.88 7.15 7.16 17.02 11.6 27.89 11.6h362.88c10.86 0 20.73-4.44 27.88-11.59s11.59-17.02 11.59-27.88V39.47c0-10.86-4.44-20.73-11.59-27.88C470.3 4.44 460.43 0 449.57 0H86.7C75.83 0 65.96 4.44 58.81 11.59S47.22 28.61 47.22 39.47v38.12H32.43c-6.19 0-11.72 3.06-15.64 7.98-3.6 4.52-5.83 10.67-5.83 17.36s2.23 12.84 5.83 17.36c3.92 4.93 9.46 7.98 15.64 7.98h14.79v47.36H32.43c-6.19 0-11.72 3.06-15.64 7.98-3.6 4.53-5.84 10.68-5.84 17.37m48.94-25.35h23.5c6.19 0 11.72 3.06 15.64 7.98 3.6 4.52 5.83 10.67 5.83 17.36s-2.23 12.84-5.83 17.36c-3.92 4.93-9.46 7.98-15.64 7.98h-23.5v47.36h23.5c6.19 0 11.72 3.06 15.64 7.98 3.6 4.52 5.83 10.67 5.83 17.36s-2.23 12.84-5.83 17.36c-3.92 4.93-9.46 7.98-15.64 7.98h-23.5v47.36h23.5c6.19 0 11.72 3.06 15.64 7.98 3.6 4.52 5.83 10.67 5.83 17.36s-2.23 12.84-5.83 17.36c-3.92 4.93-9.46 7.98-15.64 7.98h-23.5v38.12c0 7.36 3.02 14.06 7.88 18.93 4.86 4.86 11.56 7.88 18.93 7.88h362.88c7.36 0 14.06-3.02 18.92-7.88s7.88-11.56 7.88-18.93V39.47c0-7.36-3.02-14.06-7.88-18.93-4.86-4.86-11.56-7.88-18.92-7.88H86.7c-7.36 0-14.06 3.02-18.93 7.88-4.86 4.86-7.88 11.56-7.88 18.93v38.12h23.5c6.19 0 11.72 3.06 15.64 7.98 3.6 4.52 5.83 10.67 5.83 17.36s-2.23 12.84-5.83 17.36c-3.92 4.93-9.46 7.98-15.64 7.98h-23.5zm-36.27-72.7c0-3.76 1.17-7.12 3.06-9.49 1.56-1.96 3.61-3.18 5.75-3.18h50.96c2.14 0 4.18 1.22 5.75 3.18 1.89 2.37 3.06 5.73 3.06 9.49s-1.17 7.12-3.06 9.49c-1.56 1.96-3.61 3.18-5.75 3.18H32.43c-2.14 0-4.18-1.22-5.75-3.18-1.88-2.37-3.06-5.72-3.06-9.49m0 294.14c0-3.76 1.17-7.12 3.06-9.49 1.56-1.96 3.61-3.18 5.75-3.18h50.96c2.14 0 4.18 1.22 5.75 3.18 1.89 2.37 3.06 5.73 3.06 9.49s-1.17 7.12-3.06 9.49c-1.56 1.96-3.61 3.18-5.75 3.18H32.43c-2.14 0-4.18-1.22-5.75-3.18-1.88-2.38-3.06-5.73-3.06-9.49m0-98.05c0-3.76 1.17-7.12 3.06-9.49 1.56-1.96 3.61-3.18 5.75-3.18h50.96c2.14 0 4.18 1.22 5.75 3.18 1.89 2.37 3.06 5.73 3.06 9.49s-1.17 7.12-3.06 9.49c-1.56 1.96-3.61 3.18-5.75 3.18H32.43c-2.14 0-4.18-1.22-5.75-3.18-1.88-2.37-3.06-5.72-3.06-9.49"
})));

const SvgIfcaxBilling = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  "data-name": "budget (1)",
  viewBox: "0 0 34.528 34.528"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 66513"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff5f5",
  d: "M26.772 0H9.239a1.01 1.01 0 0 0-1.012 1.012v33.516h25.289a1.01 1.01 0 0 0 1.012-1.012V7.755Z",
  "data-name": "Path 82207"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2dff4",
  d: "M21.377 0v34.528h12.139a1.01 1.01 0 0 0 1.012-1.012V7.755L26.772 0Z",
  "data-name": "Path 82208"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#d5d3ea",
  d: "M26.772 0v6.744a1.01 1.01 0 0 0 1.012 1.012h6.744Z",
  "data-name": "Path 82209"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#005edf",
  d: "M20.362 6.069H12.27a1.012 1.012 0 0 1 0-2.023h8.092a1.012 1.012 0 1 1 0 2.023",
  "data-name": "Path 82210"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#005edf",
  d: "M20.362 10.115H12.27a1.012 1.012 0 0 1 0-2.023h8.092a1.012 1.012 0 1 1 0 2.023",
  "data-name": "Path 82211"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffb454",
  d: "M30.239 22.099a4.1 4.1 0 0 0-2.3-1.883 36 36 0 0 1-.708-.257V15.93a1.9 1.9 0 0 1 .814.428 1.012 1.012 0 0 0 1.522-1.333 3.9 3.9 0 0 0-2.335-1.161v-.715a1.012 1.012 0 1 0-2.023 0v.832c-.1.026-.21.054-.318.086a3.75 3.75 0 0 0-2.571 2.941 3.32 3.32 0 0 0 1.09 3.267 8.6 8.6 0 0 0 1.8 1.04v5.137a3.55 3.55 0 0 1-1.762-.7 1.011 1.011 0 1 0-1.107 1.693 5.46 5.46 0 0 0 2.869 1.037v.852a1.012 1.012 0 1 0 2.023 0v-.941a4.4 4.4 0 0 0 2.016-1.055 4.58 4.58 0 0 0 1.411-2.6 4.1 4.1 0 0 0-.421-2.639m-5.58-3.414a1.34 1.34 0 0 1-.351-1.3 1.8 1.8 0 0 1 .9-1.271v2.936a5 5 0 0 1-.549-.365m4 5.717a2.52 2.52 0 0 1-1.431 1.871v-4.161l.034.012a1.965 1.965 0 0 1 1.401 2.278Z",
  "data-name": "Path 82212"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#005edf",
  d: "M14.432 34.528H2.023A2.023 2.023 0 0 1 0 32.505V14.297a2.023 2.023 0 0 1 2.023-2.023h12.409a2.023 2.023 0 0 1 2.023 2.023v18.208a2.023 2.023 0 0 1-2.023 2.023",
  "data-name": "Path 82213"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00429b",
  d: "M14.427 12.274h-6.2v22.254h6.2a2.023 2.023 0 0 0 2.023-2.023V14.297a2.023 2.023 0 0 0-2.023-2.023",
  "data-name": "Path 82214"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1.147,
  cy: 1.147,
  r: 1.147,
  fill: "#e2dff4",
  "data-name": "Ellipse 2043",
  transform: "translate(11.472 20.65)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1.147,
  cy: 1.147,
  r: 1.147,
  fill: "#fff5f5",
  "data-name": "Ellipse 2044",
  transform: "translate(3.059 20.65)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1.147,
  cy: 1.147,
  r: 1.147,
  fill: "#e2dff4",
  "data-name": "Ellipse 2045",
  transform: "translate(11.472 24.474)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1.147,
  cy: 1.147,
  r: 1.147,
  fill: "#fff5f5",
  "data-name": "Ellipse 2046",
  transform: "translate(3.059 24.474)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1.147,
  cy: 1.147,
  r: 1.147,
  fill: "#e2dff4",
  "data-name": "Ellipse 2047",
  transform: "translate(11.472 28.298)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1.147,
  cy: 1.147,
  r: 1.147,
  fill: "#fff5f5",
  "data-name": "Ellipse 2048",
  transform: "translate(3.059 28.298)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#8cbcff",
  d: "M2.158 18.343h12.139a.337.337 0 0 0 .337-.337v-3.372a.337.337 0 0 0-.337-.337H2.158a.337.337 0 0 0-.337.337v3.372a.337.337 0 0 0 .337.337",
  "data-name": "Path 82215"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4895ff",
  d: "M14.296 14.297H8.227v4.046h6.069a.337.337 0 0 0 .337-.337v-3.372a.337.337 0 0 0-.337-.337",
  "data-name": "Path 82216"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1.147,
  cy: 1.147,
  r: 1.147,
  fill: "#fff5f5",
  "data-name": "Ellipse 2049",
  transform: "translate(6.883 20.65)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2dff4",
  d: "M8.227 20.703v2.023a1.012 1.012 0 1 0 0-2.023",
  "data-name": "Path 82217"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1.147,
  cy: 1.147,
  r: 1.147,
  fill: "#fff5f5",
  "data-name": "Ellipse 2050",
  transform: "translate(6.883 24.474)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2dff4",
  d: "M8.227 24.749v2.023a1.012 1.012 0 1 0 0-2.023",
  "data-name": "Path 82218"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1.147,
  cy: 1.147,
  r: 1.147,
  fill: "#fff5f5",
  "data-name": "Ellipse 2051",
  transform: "translate(6.883 28.298)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2dff4",
  d: "M8.227 28.458v2.023a1.012 1.012 0 1 0 0-2.023",
  "data-name": "Path 82219"
}));

const SvgIfcaxBrochure = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 30 30"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 66563"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h30v30H0z",
  "data-name": "Rectangle 26199"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "brochure (1)",
  transform: "translate(3 -5.44)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#01c0fa",
  d: "M23.607 10.329V26.37a.89.89 0 0 1-.889.889h-7.31a1.5 1.5 0 0 0-.522.095h-.742l-5.423 4.7a1.5 1.5 0 0 1-.522.095H.889A.89.89 0 0 1 0 31.261v-6.506L14.886 9.534a1.5 1.5 0 0 1 .522-.095h7.31a.89.89 0 0 1 .889.889Z",
  "data-name": "Path 81655"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#08a9f1",
  "data-name": "Group 66020"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.754 27.353a1.5 1.5 0 0 0-.409.23l-5.346 4.243a1.5 1.5 0 0 1-.931.325h1.135a1.5 1.5 0 0 0 .931-.325l5.346-4.243a1.5 1.5 0 0 1 .409-.23v-.095h-.613a1.5 1.5 0 0 0-.522.095",
  "data-name": "Path 81656"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.718 9.44h-1.135a.89.89 0 0 1 .889.889V26.37a.89.89 0 0 1-.889.889h1.135a.89.89 0 0 0 .889-.889V10.329a.89.89 0 0 0-.889-.889",
  "data-name": "Path 81657"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#739ad6",
  d: "M14.886 9.534v17.818a1.5 1.5 0 0 0-.409.23l-5.346 4.243a1.5 1.5 0 0 1-.409.23l-1.135-9.379 1.135-8.439a1.5 1.5 0 0 0 .409-.23l5.345-4.243a1.5 1.5 0 0 1 .41-.23",
  "data-name": "Path 81658"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#08a9f1",
  d: "M7.586 22.677v9.473h.613a1.5 1.5 0 0 0 .522-.094v-7.283Z",
  "data-name": "Path 81659"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#08a9f1",
  d: "M22.718 9.44h-1.135a.89.89 0 0 1 .889.889V26.37a.89.89 0 0 1-.889.889h1.135a.89.89 0 0 0 .889-.889V10.329a.89.89 0 0 0-.889-.889",
  "data-name": "Path 81660"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#739ad6",
  d: "M7.995 31.825a1.5 1.5 0 0 1-.409.23v.095h.613a1.5 1.5 0 0 0 .523-.095v-.807Z",
  "data-name": "Path 81661"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5a84c8",
  d: "m14.476 9.765-.726.576v16.595a.68.68 0 0 1-.3.568q-.056.037-.11.079l-4.62 3.666v.807a1.5 1.5 0 0 0 .409-.23l5.346-4.243a1.5 1.5 0 0 1 .409-.23V9.535a1.5 1.5 0 0 0-.409.23Z",
  "data-name": "Path 81662"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fcf3e3",
  d: "M8.721 14.237v10.535A8.02 8.02 0 0 1 0 24.755V15.22a.89.89 0 0 1 .889-.889H8.2a1.5 1.5 0 0 0 .522-.095Z",
  "data-name": "Path 81663"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fee8c7",
  d: "M8.199 14.332h-.613v9.572a1.49 1.49 0 0 1-.828 1.336 8 8 0 0 1-2.952.792q.281.02.567.02a8 8 0 0 0 4.348-1.281V14.237a1.5 1.5 0 0 1-.522.095",
  "data-name": "Path 81664"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffd15b",
  d: "m4.618 21.749.324.115a.627.627 0 0 0 .837-.608l-.009-.344a.63.63 0 0 1 .13-.4l.21-.273a.627.627 0 0 0-.32-.984l-.33-.1a.63.63 0 0 1-.34-.247l-.194-.284a.627.627 0 0 0-1.034 0l-.194.284a.63.63 0 0 1-.34.247l-.33.1a.627.627 0 0 0-.32.984l.21.273a.63.63 0 0 1 .13.4l-.009.344a.627.627 0 0 0 .837.608l.324-.115a.63.63 0 0 1 .418 0",
  "data-name": "Path 81665"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 66021"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#ffc344",
  d: "m5.785 19.257-.33-.1a.63.63 0 0 1-.34-.247l-.194-.284a.627.627 0 0 0-1.034 0l-.05.074.144.21a.63.63 0 0 0 .34.247l.33.1a.627.627 0 0 1 .32.984l-.21.273a.63.63 0 0 0-.13.4l.009.344a.62.62 0 0 1-.182.459.6.6 0 0 1 .156.034l.324.115a.627.627 0 0 0 .837-.608l-.009-.344a.63.63 0 0 1 .13-.4l.21-.273a.627.627 0 0 0-.321-.984",
  "data-name": "Path 81666"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#ffd15b",
  d: "M21.085 14.317h-3.676a.51.51 0 0 1-.509-.509v-1.537a.51.51 0 0 1 .509-.509h3.676a.51.51 0 0 1 .509.509v1.536a.51.51 0 0 1-.509.51",
  "data-name": "Path 81667"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffc344",
  d: "M21.086 11.762h-1.135a.51.51 0 0 1 .509.509v1.536a.51.51 0 0 1-.509.509h1.135a.51.51 0 0 0 .509-.509v-1.536a.51.51 0 0 0-.509-.509",
  "data-name": "Path 81668"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffd15b",
  d: "M21.085 18.611h-3.676a.51.51 0 0 1-.509-.509v-1.537a.51.51 0 0 1 .509-.509h3.676a.51.51 0 0 1 .509.509v1.536a.51.51 0 0 1-.509.51",
  "data-name": "Path 81669"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffc344",
  d: "M21.086 16.056h-1.135a.51.51 0 0 1 .509.509v1.536a.51.51 0 0 1-.509.509h1.135a.51.51 0 0 0 .509-.509v-1.536a.51.51 0 0 0-.509-.509",
  "data-name": "Path 81670"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 66024"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 66022"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#ffd15b",
  d: "M5.453 28.703H3.269a.356.356 0 1 1 0-.712h2.183a.356.356 0 1 1 0 .712Z",
  "data-name": "Path 81671"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 66023"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fcf3e3",
  d: "M6.857 30.19H1.864a.356.356 0 0 1 0-.712h4.993a.356.356 0 0 1 0 .712",
  "data-name": "Path 81672"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 66028"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 66025"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#ffd15b",
  d: "M10.585 16.966a.356.356 0 0 1-.222-.635l2.666-2.116a.356.356 0 0 1 .443.558l-2.666 2.116a.36.36 0 0 1-.221.077",
  "data-name": "Path 81673"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 66026"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fcf3e3",
  d: "M10.585 18.937a.356.356 0 0 1-.222-.635l2.666-2.116a.356.356 0 0 1 .443.558l-2.666 2.116a.36.36 0 0 1-.221.077",
  "data-name": "Path 81674"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 66027"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fcf3e3",
  d: "M10.585 20.908a.356.356 0 0 1-.222-.635l2.666-2.116a.356.356 0 0 1 .443.558l-2.666 2.116a.36.36 0 0 1-.221.077",
  "data-name": "Path 81675"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 66031"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 66029"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#ffd15b",
  d: "M10.585 25.042a.356.356 0 0 1-.222-.635l2.666-2.116a.356.356 0 0 1 .443.558l-2.666 2.116a.36.36 0 0 1-.221.077",
  "data-name": "Path 81676"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 66030"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fcf3e3",
  d: "M10.585 27.008a.356.356 0 0 1-.222-.635l2.666-2.116a.356.356 0 0 1 .443.558l-2.666 2.116a.36.36 0 0 1-.221.077",
  "data-name": "Path 81677"
}))), /*#__PURE__*/React.createElement("circle", {
  cx: 0.349,
  cy: 0.349,
  r: 0.349,
  fill: "#ffd15b",
  "data-name": "Ellipse 2006",
  transform: "translate(16.901 21.173)"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 66032"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fcf3e3",
  d: "M21.227 21.877H18.58a.356.356 0 0 1 0-.712h2.647a.356.356 0 0 1 0 .712",
  "data-name": "Path 81678"
})), /*#__PURE__*/React.createElement("circle", {
  cx: 0.349,
  cy: 0.349,
  r: 0.349,
  fill: "#ffd15b",
  "data-name": "Ellipse 2007",
  transform: "translate(16.901 23.084)"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 66033"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fcf3e3",
  d: "M21.227 23.789H18.58a.356.356 0 0 1 0-.712h2.647a.356.356 0 0 1 0 .712",
  "data-name": "Path 81679"
})))));

const SvgIfcaxBug = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 14 14"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h14v14H0z",
  "data-name": "Rectangle 27720"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "bug (1)"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#333",
  "data-name": "Group 65604"
}, /*#__PURE__*/React.createElement("path", {
  d: "m2.346 12.936-.644-.2.6-1.9 1.743-.684.247.629-1.443.567Z",
  "data-name": "Path 81454"
}), /*#__PURE__*/React.createElement("path", {
  d: "m3.693 7.163-1.388-.545-.6-1.9.644-.2.505 1.591 1.089.428Z",
  "data-name": "Path 81455"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.483 9.936 1 9.464l1.329-1.36h1.487v.676h-1.2Z",
  "data-name": "Path 81456"
})), /*#__PURE__*/React.createElement("g", {
  fill: "#1a1a1a",
  "data-name": "Group 65605"
}, /*#__PURE__*/React.createElement("path", {
  d: "m11.168 12.936-.505-1.591-1.443-.567.247-.629 1.743.684.6 1.9Z",
  "data-name": "Path 81457"
}), /*#__PURE__*/React.createElement("path", {
  d: "m9.821 7.163-.247-.629 1.089-.428.505-1.591.644.2-.6 1.9Z",
  "data-name": "Path 81458"
}), /*#__PURE__*/React.createElement("path", {
  d: "m12.031 9.936-1.13-1.157h-1.2v-.676h1.487l1.329 1.36Z",
  "data-name": "Path 81459"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  d: "M6.227 3.561h-.676v-.493a.394.394 0 0 0-.393-.393v-.676a1.07 1.07 0 0 1 1.069 1.069Z",
  "data-name": "Path 81460"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1a1a1a",
  d: "M7.963 3.561h-.676v-.493a1.07 1.07 0 0 1 1.069-1.069v.676a.394.394 0 0 0-.393.393Z",
  "data-name": "Path 81461"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffa900",
  d: "M6.757 12.284a3.13 3.13 0 0 1-3.129-3.129V6.026h6.256v3.129a3.13 3.13 0 0 1-3.127 3.129",
  "data-name": "Path 81462"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f80",
  d: "M6.757 12.285V6.026h3.129v3.129a3.13 3.13 0 0 1-3.129 3.13",
  "data-name": "Path 81463"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4d4d4d",
  d: "M6.757 3.072a2.21 2.21 0 0 0-2.21 2.21V6.51h4.419V5.277a2.21 2.21 0 0 0-2.209-2.205",
  "data-name": "Path 81464"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  d: "M6.757 3.072V6.51h2.21V5.277a2.21 2.21 0 0 0-2.21-2.205",
  "data-name": "Path 81465"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f80",
  d: "M9.883 6.023H3.624l3.129 2.538Z",
  "data-name": "Path 81466"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e47700",
  d: "M9.886 6.023H6.757v2.538Z",
  "data-name": "Path 81467"
})));

const SvgIfcaxBusinessman = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 -4 512.002 512"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#515f75",
  d: "M190.46 386.402h52.345c26.832 0 48.582 21.75 48.582 48.586v62.446H17.55v-62.446c0-26.836 21.75-48.586 48.586-48.586h52.34"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f2f2f2",
  d: "m94.602 386.402 31.632 111.032h56.477l31.633-111.032"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f9c2af",
  d: "M190.465 324.023v62.383l-35.992 20.281-11.121-6.265-24.872-14.016v-62.422l24.872.012zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f74866",
  d: "m126.434 497.434 28.597-35.332 27.68 35.332"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ea9e8f",
  d: "m143.352 323.996-24.872-.012v62.422l24.872 14.016v-28.863c3.675.359 7.398.566 11.171.566 12.563 0 24.653-2.05 35.942-5.84v-42.262zM41.543 258.344c-18.738 0-33.93-13.598-33.93-30.375s15.192-30.375 33.93-30.375h125.082c18.738 0 33.93 13.597 33.93 30.375s-15.192 30.375-33.93 30.375"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f9c2af",
  d: "M267.504 131.117v112.98c0 62.395-50.582 112.981-112.98 112.981-62.395 0-112.981-50.586-112.981-112.98v-112.98"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ea9e8f",
  d: "M153.723 357.07c-30.883-.207-58.813-12.812-79.09-33.082-20.445-20.453-33.09-48.691-33.09-79.894v-112.98H92.41v112.984c0 31.199 6.95 59.437 18.192 79.89 11.066 20.13 26.285 32.692 43.12 33.082m0 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#515f75",
  d: "M239.5 161.813c-40.937 14.753-80.57 9.785-108.602 1.972 0 0-.011 0-.011-.008-24.41-6.804-40.016-15.773-40.016-15.773s-10.305 49.582-49.328 49.582c0 0-25.961-45.922-25.148-88.41.425-22.035 18.59-38.516 39.242-38.516 3.86 0 7.8.57 11.726 1.797 11.063-29.7 40.282-48.496 71.914-46.57 4.93.304 9.887.695 14.864 1.144.949.078 1.914.168 2.863.258.098.008.195.02.297.027C208.938 32.164 261.238 41.61 291.969 7.61c.004 0 50.793 117.004-52.469 154.204m0 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3b485b",
  d: "M139.281 25.887c4.926.304 9.883.695 14.86 1.148-45.563-1.926-81.758 98.414-23.25 136.742-24.41-6.804-40.02-15.773-40.02-15.773s-10.305 49.582-49.328 49.582c0 0-25.961-45.922-25.145-88.41.422-22.035 18.59-38.516 39.239-38.516 3.86 0 7.804.57 11.73 1.797 11.059-29.7 40.278-48.496 71.914-46.57m0 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f74866",
  d: "m129.71 431.45 24.013 30.652 24.812-30.653-24.062-24.761z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f4af9d",
  d: "M395.2 297.664v41.121h-63.837v-41.12h53.203zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f9c2af",
  d: "M395.2 297.664v41.121h-38.11v-41.12zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#515f75",
  d: "M331.367 338.781h63.828v158.293h-63.828zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3b485b",
  d: "M331.367 338.781h25.531v158.293h-25.53zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#dd8c22",
  d: "M457.578 178.215v119.144H350.68c-24.957 0-51.024-24.855-52.407-56.164a65 65 0 0 1-.078-3.402c0-32.91 26.633-59.578 52.485-59.578zM213.426 272.652H191.68c-15.125 0-27.395-15.601-27.395-34.863 0-19.258 12.27-34.871 27.395-34.871h21.754"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#efa233",
  d: "M363.957 178.215v119.144H251.383c-24.953 0-45.344-24.855-46.73-56.164a70 70 0 0 1-.079-3.402c0-32.91 20.961-59.578 46.813-59.578zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#dd8c22",
  d: "M350.148 241.195v56.164h-98.765c-24.953 0-45.348-24.855-46.73-56.164zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#79bbe8",
  d: "M410.77 237.793c0 22.41-9.735 41.941-24.114 52.11-6.719 4.753-14.46 7.456-22.699 7.456-25.848 0-46.809-26.668-46.809-59.566 0-32.91 20.961-59.578 46.809-59.578 8.242 0 15.98 2.71 22.7 7.465 14.378 10.156 24.113 29.687 24.113 52.113m0 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#aedbf4",
  d: "M410.77 237.793c0 22.41-9.735 41.941-24.114 52.11-14.379-10.169-24.117-29.7-24.117-52.11 0-22.426 9.738-41.957 24.117-52.113 14.38 10.156 24.114 29.687 24.114 52.113m0 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#79bbe8",
  d: "M504.387 237.79c0-32.903-20.957-59.58-46.809-59.58s-46.808 26.677-46.808 59.58c0 32.901 20.957 59.573 46.808 59.573s46.809-26.672 46.809-59.574m0 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#aedbf4",
  d: "M504.387 237.793c0 22.41-9.735 41.941-24.114 52.11-14.378-10.169-24.113-29.7-24.113-52.11 0-22.426 9.735-41.957 24.113-52.113 14.38 10.156 24.114 29.687 24.114 52.113m0 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f4af9d",
  d: "M305.836 282.957v53.2h-63.832v-53.2c0-5.879 4.766-10.633 10.633-10.633h42.566c5.867 0 10.633 4.754 10.633 10.633m0 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f9c2af",
  d: "M305.836 282.957v53.2H267.73v-53.2a10.624 10.624 0 0 1 10.633-10.633h16.84c5.867 0 10.633 4.754 10.633 10.633m0 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#515f75",
  d: "M242.004 336.152h63.832v160.922h-63.832zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3b485b",
  d: "M242.004 336.152h25.535v160.922h-25.535zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M211.27 306.988a7.6 7.6 0 0 0 0-10.761 7.61 7.61 0 0 0-10.762 0c-12.317 12.316-32.356 12.316-44.672 0a7.613 7.613 0 0 0-10.766 0 7.61 7.61 0 0 0 0 10.761c9.13 9.13 21.114 13.692 33.102 13.692s23.973-4.563 33.098-13.692m0 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M457.578 170.602H324.61a7.61 7.61 0 0 0-7.609 7.613 7.61 7.61 0 0 0 7.61 7.61h4.898c-12.18 12.331-19.969 31.042-19.969 51.964 0 20.918 7.79 39.629 19.969 51.961l-16.059.008v-6.801c0-10.062-8.187-18.246-18.246-18.246h-42.566c-10.059 0-18.242 8.184-18.242 18.246v1.637c-5.614-3.59-10.442-8.871-14.149-15.305a7 7 0 0 0-.398-.707c-4.84-8.691-7.668-19.387-7.668-30.793s2.793-21.96 7.511-30.543a7.4 7.4 0 0 0 .657-1.148c7.172-12.317 18.41-20.274 31.03-20.274h41.22a7.612 7.612 0 1 0 0-15.222H275.12v-19.348c12.598-9.758 22.086-21.879 28.313-36.3 21.414-49.583-3.414-107.915-4.48-110.372a7.615 7.615 0 0 0-12.629-2.074c-25.11 27.765-67.766 23.394-112.927 18.77-11.046-1.133-22.464-2.305-33.66-2.985-33.015-2.012-63.117 15.984-76.898 45.312-12.137-1.906-24.445 1-34.63 8.348-12.062 8.703-19.14 22.215-19.425 37.074-.62 32.528 13.313 66.262 21.094 82.489C12.633 196.136 0 210.726 0 227.969c0 19.176 15.621 35.066 35.836 37.62 4.297 24.036 15.789 46.157 33.414 63.782 12.047 12.047 26.195 21.227 41.621 27.207v22.219h-44.73c-30.989 0-56.2 25.207-56.2 56.195v62.442c0 4.203 3.41 7.609 7.614 7.609l288.28-.355a7.613 7.613 0 0 0 7.614-7.614v-18.61a7.612 7.612 0 1 0-15.223 0v11h-48.609V343.767h48.61v103.203a7.612 7.612 0 1 0 15.222 0V304.98h10.305v192.094a7.613 7.613 0 0 0 7.613 7.614H395.2a7.61 7.61 0 0 0 7.61-7.614V304.977h54.773c30.008 0 54.422-30.141 54.422-67.188s-24.418-67.187-54.426-67.187M103.297 466.938a7.61 7.61 0 0 0-5.488-5.352l-25.407-6.352 2.418-61.214h14.035l27.297 95.8H85.88l15.465-15.468a7.61 7.61 0 0 0 1.953-7.414m13.187-72.918L142 408.395l-25.852 25.851-11.46-40.226zm75.977 0h11.797l-11.461 40.226-25.852-25.851zm-37.988 23.43 14.148 14.148-14.8 18.285-13.962-17.82zm-25.457 25.456 15.62 19.942-15.046 18.586-8.668-30.43zm50.43-.484 8.577 8.578-8.539 29.973-15.367-19.618zm-24.508 31.898 12.14 15.5h-24.687zm65.152-80.3h14.305v61.273l-23.403 6.332a7.61 7.61 0 0 0-3.395 12.727l15.465 15.468h-30.265zm7.57 78.867 6.735-1.824v8.558zm-13.402-94.09c-.043 0-.086-.004-.133 0h-16.047v-22.215a120.1 120.1 0 0 0 36.317-22.121v44.336zm-12.582-113.758h-9.996c-10.723 0-19.782-12.476-19.782-27.25 0-14.777 9.059-27.258 19.782-27.258h9.972c-3.007 8.336-4.699 17.555-4.699 27.258.004 9.617 1.688 18.856 4.723 27.25M24.008 109.316c.191-10.023 4.969-19.144 13.113-25.02C42.63 80.325 49.06 78.27 55.61 78.27c3.168 0 6.368.48 9.5 1.457a7.61 7.61 0 0 0 9.395-4.614c9.914-26.636 35.758-43.367 64.308-41.625 10.883.664 22.145 1.817 33.032 2.934 42.597 4.363 86.511 8.863 116.902-15.356 5.723 17.922 14.578 55.747.711 87.852-9.098 21.066-26.773 36.457-52.535 45.734-72.23 26.028-141.574-12.859-142.258-13.25a7.62 7.62 0 0 0-6.914-.347 7.61 7.61 0 0 0-4.332 5.398c-.09.414-8.563 39.559-37.434 43.25-6.066-11.93-22.605-47.57-21.976-80.387M15.223 227.97c0-10.262 7.898-18.957 18.707-21.79v37.91q.001 2.862.136 5.704c-10.882-2.797-18.843-11.52-18.843-21.824m33.93 16.12v-39.452c15.452-2.332 28.554-11.86 38.21-27.918 3.86-6.422 6.516-12.82 8.242-17.797 8.168 3.812 21.766 9.402 39.008 13.719 47.453 11.875 84.633 4.562 107.469-3.664a133 133 0 0 0 17.816-7.907v9.532h-8.52c-16.964 0-32.136 9.636-42.124 24.707h-17.57c-17.16 0-31.47 15.066-34.434 34.87h-12.672c-4.203 0-7.61 3.41-7.61 7.614s3.407 7.613 7.61 7.613h12.672c2.965 19.797 17.273 34.86 34.43 34.86h17.586c6.457 9.773 15.113 17.312 25.129 21.367v11.195c-20.079 23.317-49.036 36.637-79.875 36.637-28.145 0-54.606-10.957-74.508-30.86-19.899-19.898-30.86-46.363-30.86-74.515M154.52 364.689c9.66 0 19.16-1.153 28.332-3.36v20.633l-28.38 15.988-28.378-15.988v-20.633c9.199 2.215 18.722 3.36 28.426 3.36M25.168 434.992c0-20.355 14.918-37.281 34.395-40.437l-2.618 66.261a7.62 7.62 0 0 0 5.762 7.688l18.363 4.59-16.722 16.726h-39.18zm224.45-106.449v-45.586a3.025 3.025 0 0 1 3.019-3.023h42.566a3.025 3.025 0 0 1 3.02 3.023v45.586zm173.507-142.719c-4.906 4.969-9.094 10.98-12.355 17.746-3.258-6.765-7.446-12.777-12.352-17.746zm-98.36 51.965c0-28.652 17.583-51.965 39.196-51.965s39.195 23.313 39.195 51.965-17.582 51.961-39.195 51.961-39.195-23.309-39.195-51.96m62.817 93.379h-48.605v-25.895h48.609v25.895zm0 158.297h-48.605V346.39h48.609v143.074zm10.836-199.715c4.906-4.969 9.094-10.977 12.352-17.746 3.261 6.77 7.449 12.777 12.355 17.746zm59.16 0c-21.613 0-39.195-23.309-39.195-51.96 0-28.653 17.582-51.966 39.195-51.966s39.2 23.313 39.2 51.965-17.587 51.961-39.2 51.961m0 0"
}));

const SvgIfcaxCandidate = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 511.998 511.998"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#365e7d",
  d: "M342.554 299.486c98.19 65.988 161.398 129.196 161.398 129.196s6.279 21.631-23.681 51.592-51.592 23.681-51.592 23.681-63.208-63.208-129.196-161.398"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2b4d66",
  d: "m299.487 342.557 15.639-15.639c75.808 83.473 139.029 147.685 154.248 163.043-24.166 18.787-40.693 13.997-40.693 13.997s-63.212-63.213-129.194-161.401"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 202.975,
  cy: 202.979,
  r: 195.474,
  fill: "#e7a561"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e49542",
  d: "M217.752 397.91c-4.883.361-9.799.547-14.77.547-107.956 0-195.481-87.525-195.481-195.481S95.026 7.506 202.982 7.506c4.971 0 9.887.186 14.77.547C116.694 15.597 37.041 99.98 37.041 202.976s79.653 187.39 180.711 194.934"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 202.975,
  cy: 202.975,
  r: 153.781,
  fill: "#f9f6f6"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e7ecf6",
  d: "M49.194 202.978c0-84.931 68.85-153.782 153.782-153.782 7.172 0 14.221.493 21.124 1.434-74.936 10.299-132.659 74.589-132.659 152.348s57.723 142.049 132.658 152.347a156 156 0 0 1-21.124 1.434c-84.93.001-153.781-68.85-153.781-153.781"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#b17a4a",
  d: "M115.79 264.465c-14.961 0-27.089-12.128-27.089-27.089 0-2.059.23-4.064.665-5.992 3.514-15.564 26.424-13.011 26.424 2.944h173.37c0-15.955 22.91-18.508 26.424-2.944a27.2 27.2 0 0 1 .665 5.992c0 14.961-12.128 27.089-27.089 27.089"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#c38959",
  d: "M225.979 314.259h-47.008c-34.894 0-63.18-28.287-63.18-63.18v-89.107l86.687-53.291 86.682 53.291v89.107c0 34.893-28.287 63.18-63.181 63.18"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#365e7d",
  d: "M289.164 131.479v37.172s-12.638-20.804-32.639-20.804c-19.993 0-28.133 24.706-54.048 24.706-25.906 0-34.055-24.706-54.048-24.706s-32.639 20.804-32.639 20.804v-37.172c0-23.826 19.32-43.137 43.145-43.137h87.085c23.825 0 43.144 19.311 43.144 43.137"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2b4d66",
  d: "M158.934 88.342h41.721c-23.826 0-43.145 19.311-43.145 43.137v18.171c-2.788-1.131-5.775-1.804-9.081-1.804-19.993 0-32.639 20.804-32.639 20.804v-37.172c-.001-23.825 19.319-43.136 43.144-43.136"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#b17a4a",
  d: "M220.469 314.255h-41.496c-34.893 0-63.181-28.289-63.181-63.173V168.65s12.647-20.804 32.639-20.804c3.22 0 6.138.639 8.865 1.718v101.518c0 34.884 28.28 63.173 63.173 63.173"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 409.3,
  cy: 109.485,
  r: 95.199,
  fill: "#95d6a4"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#78c2a4",
  d: "M420.054 204.088c-3.524.4-7.118.6-10.75.6-52.58 0-95.204-42.623-95.204-95.204 0-52.573 42.623-95.196 95.204-95.196 3.632 0 7.226.2 10.75.6-47.517 5.34-84.454 45.655-84.454 94.596.001 48.949 36.937 89.264 84.454 94.604"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f9f6f6",
  d: "m381.386 165.219-29.764-49.791c-2.868-4.798-1.304-11.012 3.494-13.88l15.015-8.976c4.798-2.868 11.012-1.304 13.88 3.494l15.104 25.266 31.023-62.586c2.483-5.008 8.555-7.056 13.563-4.573l15.673 7.769c5.008 2.483 7.056 8.555 4.573 13.563l-43.712 88.186a10.12 10.12 0 0 1-8.67 5.618l-21.094.829a10.12 10.12 0 0 1-9.085-4.919"
}), /*#__PURE__*/React.createElement("path", {
  d: "M509.253 423.381c-.533-.534-53.065-52.771-135.126-111.17 19.096-29.798 30.016-64.105 31.601-100.096 1.186.041 2.376.069 3.572.069 56.628 0 102.698-46.071 102.698-102.699S465.928 6.786 409.3 6.786c-32.004 0-60.633 14.718-79.482 37.737A202.93 202.93 0 0 0 202.97.004c-27.506 0-54.18 5.409-79.283 16.077a7.5 7.5 0 0 0 5.867 13.805c23.237-9.875 47.938-14.883 73.416-14.883a187.92 187.92 0 0 1 118.197 41.814 102.1 102.1 0 0 0-10.958 25.672c-29.526-26.4-67.095-40.796-107.228-40.796-88.936 0-161.29 72.35-161.29 161.28 0 88.936 72.354 161.29 161.29 161.29 88.93 0 161.279-72.354 161.279-161.29 0-.405-.011-.811-.014-1.216a101.9 101.9 0 0 0 26.537 8.75c-1.861 47.556-21.321 91.992-55.235 125.732-35.464 35.284-82.548 54.715-132.578 54.715C99.323 390.954 15 306.627 15 202.974c0-32.557 8.453-64.634 24.446-92.763 15.516-27.291 37.823-50.475 64.51-67.045a7.5 7.5 0 1 0-7.912-12.743C67.236 48.31 43.156 73.336 26.406 102.797 9.131 133.182 0 167.823 0 202.974c0 111.924 91.052 202.98 202.97 202.98 39.304 0 76.919-11.117 109.248-31.841 22.302 31.352 46.085 61.853 70.805 90.729a7.48 7.48 0 0 0 5.701 2.623c1.726 0 3.46-.593 4.873-1.803a7.5 7.5 0 0 0 .82-10.575c-24.393-28.495-47.865-58.593-69.881-89.532a205.8 205.8 0 0 0 41.033-41.024c72.736 51.777 121.845 98.522 131.385 107.798.434 5.079-.346 21-21.988 42.643-21.646 21.645-37.565 22.42-42.644 21.988-2.86-2.938-9.273-9.622-18.222-19.507a7.501 7.501 0 0 0-11.121 10.066c12.578 13.897 20.08 21.423 20.394 21.737.894.895 2 1.55 3.216 1.903.447.13 3.084.837 7.436.837 2.924 0 6.622-.319 10.949-1.348 13.518-3.212 27.178-11.647 40.6-25.069 32.719-32.719 25.886-57.927 25.578-58.985a7.5 7.5 0 0 0-1.899-3.213M409.3 21.786c48.357 0 87.698 39.342 87.698 87.699s-39.341 87.699-87.698 87.699-87.699-39.342-87.699-87.699 39.341-87.699 87.699-87.699m-60.04 181.188c0 80.665-65.62 146.29-146.279 146.29-80.665 0-146.29-65.625-146.29-146.29 0-80.659 65.625-146.28 146.29-146.28 39.551 0 76.363 15.409 104.048 43.461a104 104 0 0 0-.428 9.33c0 34.065 16.675 64.303 42.287 82.996.246 3.478.372 6.994.372 10.493"
}), /*#__PURE__*/React.createElement("path", {
  d: "M300.221 213.583a23 23 0 0 0-3.562.698v-82.797c0-27.923-22.717-50.641-50.64-50.641H158.93c-27.924 0-50.641 22.717-50.641 50.641v82.798a23 23 0 0 0-3.562-.698c-10.943-1.22-20.256 5.422-22.679 16.152a34.8 34.8 0 0 0-.849 7.641c0 17.571 13.173 32.113 30.16 34.296 8.838 28.958 35.799 50.086 67.61 50.086h47.01c31.811 0 58.772-21.128 67.61-50.086 16.987-2.183 30.158-16.725 30.158-34.295 0-2.573-.285-5.144-.85-7.644-2.419-10.73-11.741-17.368-22.676-16.151M158.931 95.842h87.089c19.651 0 35.64 15.988 35.64 35.641v18.092c-6.432-4.964-14.921-9.229-25.133-9.229-11.979 0-20.484 6.799-27.988 12.798-7.661 6.124-14.897 11.908-26.06 11.908-11.166 0-18.403-5.785-26.065-11.911-4.978-3.979-10.125-8.094-16.358-10.552-3.816-1.51-7.619-2.243-11.624-2.243-10.216 0-18.708 4.268-25.141 9.235v-18.098c-.001-19.652 15.987-35.641 35.64-35.641m-62.73 141.534c0-1.465.162-2.926.48-4.34 1.075-4.758 5.161-4.682 6.385-4.545 1.226.136 5.224.961 5.224 5.838h.002v16.75c0 1.494.062 2.974.154 4.445-7.17-2.913-12.245-9.945-12.245-18.148m185.458 13.702c0 30.701-24.978 55.679-55.679 55.679h-47.01c-30.701 0-55.679-24.978-55.679-55.679V170.96c3.111-4.276 12.548-15.614 25.139-15.614 2.081 0 4.079.39 6.114 1.195 4.141 1.633 8.202 4.879 12.502 8.317 8.468 6.77 19.007 15.194 35.432 15.194 16.42 0 26.958-8.423 35.425-15.192 6.65-5.315 11.903-9.514 18.623-9.514 12.593 0 22.031 11.342 25.133 15.605zm14.846 4.445c.092-1.471.154-2.951.154-4.445v-16.75c0-4.876 3.999-5.701 5.225-5.838 1.223-.136 5.309-.214 6.384 4.543.319 1.417.481 2.878.481 4.342 0 8.204-5.074 15.235-12.244 18.148"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 161.828,
  cy: 222.191,
  rx: 8.225,
  ry: 13.624
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 243.122,
  cy: 222.191,
  rx: 8.225,
  ry: 13.624
}), /*#__PURE__*/React.createElement("path", {
  d: "M208.796 263.316c-1.688 1.688-3.933 2.618-6.321 2.618s-4.632-.93-6.32-2.618a7.5 7.5 0 0 0-10.606 0 7.5 7.5 0 0 0-.001 10.607 23.78 23.78 0 0 0 16.928 7.012c6.396 0 12.407-2.49 16.929-7.012a7.502 7.502 0 0 0-10.609-10.607M345.185 119.279l29.766 49.79a17.61 17.61 0 0 0 15.811 8.568l21.102-.831a17.59 17.59 0 0 0 15.088-9.781l36.598-73.818.002-.003 7.114-14.362a17.5 17.5 0 0 0 .915-13.459 17.5 17.5 0 0 0-8.874-10.162l-15.671-7.762a17.5 17.5 0 0 0-13.458-.914 17.51 17.51 0 0 0-10.161 8.873l-24.916 50.27-8.052-13.466a17.5 17.5 0 0 0-10.824-8.049 17.5 17.5 0 0 0-13.343 1.966l-15.018 8.975c-8.334 4.989-11.062 15.829-6.079 24.165m13.779-11.293 15.013-8.972c.484-.29.957-.374 1.343-.374a2.609 2.609 0 0 1 2.254 1.278l15.105 25.263a7.52 7.52 0 0 0 6.732 3.645 7.5 7.5 0 0 0 6.425-4.164l31.019-62.582a2.62 2.62 0 0 1 1.513-1.322 2.61 2.61 0 0 1 2.006.139l15.671 7.762a2.61 2.61 0 0 1 1.322 1.513 2.61 2.61 0 0 1-.14 2.006l-43.719 88.193a2.6 2.6 0 0 1-2.235 1.446l-21.103.831a2.62 2.62 0 0 1-2.346-1.279l-29.765-49.787a2.63 2.63 0 0 1 .905-3.596"
}));

const SvgIfcaxCashBook = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: "1em",
  height: "1em",
  viewBox: "0 0 80 80"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "ifcax-cash-book_svg__a",
  x1: -1.634,
  x2: -0.445,
  y1: -0.856,
  y2: -0.856,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#00c0ff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5558ff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ifcax-cash-book_svg__i",
  x1: 0.5,
  x2: 0.5,
  y2: 1,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#0045ff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#0003c1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ifcax-cash-book_svg__j",
  x1: 0.978,
  x2: 0.263,
  y1: 0.047,
  y2: 0.702,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.996,
  stopColor: "#ebeff2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ifcax-cash-book_svg__b",
  x1: 0.451,
  x2: 0.688,
  y1: -0.115,
  y2: 2.232,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#ffc444"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.996,
  stopColor: "#f36f56"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ifcax-cash-book_svg__k",
  x1: 0.473,
  x2: 1.052,
  y1: 0.366,
  y2: 2.183,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.004,
  stopColor: "#e38ddd"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9571f6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ifcax-cash-book_svg__e",
  x1: -0.012,
  x2: 1.499,
  y1: 0.026,
  y2: 1.304,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#aa80f9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.996,
  stopColor: "#6165d7"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ifcax-cash-book_svg__d",
  x1: 0.974,
  x2: 0.276,
  y1: -0.105,
  y2: 0.797,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#301fe6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#181073"
})), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#ifcax-cash-book_svg__a",
  id: "ifcax-cash-book_svg__l",
  x1: 1.021,
  x2: 0.334,
  y1: -1.082,
  y2: 1.042
}), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#ifcax-cash-book_svg__a",
  id: "ifcax-cash-book_svg__m",
  x1: 0.5,
  x2: 0.5,
  y1: 0,
  y2: 1
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ifcax-cash-book_svg__n",
  x1: -62.208,
  x2: -63,
  y1: -39.109,
  y2: -37.174,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#ff9085"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fb6fbb"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ifcax-cash-book_svg__c",
  x1: 21.132,
  x2: 21.312,
  y1: -2.049,
  y2: 2.987,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#311944"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#a03976"
})), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#ifcax-cash-book_svg__b",
  id: "ifcax-cash-book_svg__o",
  x1: 77.768,
  x2: 77.646,
  y1: 1.568,
  y2: -4.648
}), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#ifcax-cash-book_svg__c",
  id: "ifcax-cash-book_svg__p",
  x1: 33.191,
  x2: 33.476,
  y1: -1.267,
  y2: 1.684
}), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#ifcax-cash-book_svg__b",
  id: "ifcax-cash-book_svg__q",
  x1: 55.207,
  x2: 55.12,
  y1: 1.66,
  y2: -2.722
}), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#ifcax-cash-book_svg__d",
  id: "ifcax-cash-book_svg__r",
  x1: 11.856,
  x2: 12.857,
  y1: 0.522,
  y2: 0.522
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ifcax-cash-book_svg__g",
  x1: 12.639,
  x2: 13.713,
  y1: 0.522,
  y2: 0.522,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#ab316d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#792d3d"
})), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#ifcax-cash-book_svg__d",
  id: "ifcax-cash-book_svg__s",
  x1: 5.859,
  x2: 6.855,
  y1: 0.524,
  y2: 0.524
}), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#ifcax-cash-book_svg__b",
  id: "ifcax-cash-book_svg__t",
  x1: 0.549,
  x2: 0.293,
  y1: 0.204,
  y2: 3.433
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ifcax-cash-book_svg__u",
  x1: 61.406,
  x2: 60.656,
  y1: 21.005,
  y2: 19.33,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#444b8c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.996,
  stopColor: "#3e4177"
})), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#ifcax-cash-book_svg__b",
  id: "ifcax-cash-book_svg__v",
  x1: 0.44,
  x2: 0.938,
  y1: -0.008,
  y2: 4.489
}), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#ifcax-cash-book_svg__e",
  id: "ifcax-cash-book_svg__w",
  x1: 0,
  x2: 1,
  y1: 0.5,
  y2: 0.5
}), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#ifcax-cash-book_svg__b",
  id: "ifcax-cash-book_svg__x",
  x1: 135.564,
  x2: 136.443,
  y1: -147.934,
  y2: -147.934
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ifcax-cash-book_svg__f",
  x2: 1,
  y1: 0.5,
  y2: 0.5,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#444b8c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.996,
  stopColor: "#26264f"
})), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#ifcax-cash-book_svg__f",
  id: "ifcax-cash-book_svg__y",
  x1: -38.487,
  x2: -38.99,
  y1: 7.002,
  y2: 6.458
}), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#ifcax-cash-book_svg__f",
  id: "ifcax-cash-book_svg__z",
  x1: -41.614,
  x2: -40.89,
  y1: 6.551,
  y2: 7.318
}), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#ifcax-cash-book_svg__b",
  id: "ifcax-cash-book_svg__A",
  x1: -334.03,
  x2: -333.826,
  y1: -104.429,
  y2: -106.161
}), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#ifcax-cash-book_svg__g",
  id: "ifcax-cash-book_svg__B",
  x1: -0.335,
  x2: 3.133,
  y1: 1.325,
  y2: -2.462
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ifcax-cash-book_svg__h",
  x1: -0.032,
  x2: 0.597,
  y1: 1.208,
  y2: 0.374,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fcb148"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.052,
  stopColor: "#fdb946"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.142,
  stopColor: "#fec144"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.318,
  stopColor: "#ffc444"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.485,
  stopColor: "#fdb946"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.775,
  stopColor: "#f99c4c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.866,
  stopColor: "#f8924f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f8924f"
})), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#ifcax-cash-book_svg__h",
  id: "ifcax-cash-book_svg__C",
  x1: 0.66,
  x2: 0.229,
  y1: 0.944,
  y2: -0.194
}), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#ifcax-cash-book_svg__h",
  id: "ifcax-cash-book_svg__D",
  x1: -0.495,
  x2: 2.887,
  y1: 1.321,
  y2: -3.15
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 33492"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h80v80H0z",
  "data-name": "Rectangle 23454"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 33490"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 33469"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#ifcax-cash-book_svg__a)",
  d: "M2829.429 401.6a12.15 12.15 0 0 1-7.213-2.188c-4.707-3.6-5.325-10.97-3.987-16.1 1.149-4.408 4.461-7.928 11.086-14.968 6.239-6.63 8.643-7.824 8.54-10.872-.146-4.345-5.179-6.315-4.589-11.41a5.62 5.62 0 0 1 1.877-3.878c2.676-2 7.342.14 9.741 1.984 2.315 1.779 5.237 5.37 4.668 9.024-.412 2.647-2.306 3.079-2.143 5.375s2.132 2.571 3.888 5.992c.7 1.367 2.11 4.111 1.469 6.946-.83 3.667-4.336 4.168-4.267 7.022.05 2.063 1.9 2.475 2.438 4.74.713 2.981-1.619 5.9-3.593 8.3-2.323 2.822-8.592 10.451-17.915 10.033",
  "data-name": "Path 31094",
  transform: "translate(-2779.419 -328.648)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ifcax-cash-book_svg__i)",
  d: "M2870.982 354.842c-1.289 1.586 4.808 5.237 5.39 12.206.626 7.5-5.516 14.262-8.354 17.388-4.843 5.333-7.572 5.284-10.182 10.474-1.033 2.054-3.186 6.333-1.487 10.923.158.426 1.989 5.154 6.392 6.373 4.994 1.383 9.5-2.8 13.382-6.4 2.346-2.177 7.032-6.527 5.759-9.458-.778-1.792-3.6-2.641-5.693-2.52-2.981.172-4.867 2.342-5.26 1.928-.354-.373.837-2.492 2.766-4.363 3.861-3.744 6.734-2.67 9.469-5.907.332-.392 2.913-3.539 2-6.942-.525-1.963-2.227-4.061-3.918-4.006-1.914.063-2.989 2.855-3.513 2.591-.5-.252.177-2.958 1.239-5.534 1.559-3.786 2.645-4.137 2.99-6.349a9.46 9.46 0 0 0-1.727-6.574c-2.699-3.739-8.151-5.186-9.253-3.83",
  "data-name": "Path 31095",
  opacity: 0.16,
  style: {
    mixBlendMode: "screen",
    isolation: "isolate"
  },
  transform: "translate(-2813.791 -340.345)"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 33482"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 33479"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 33475"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 33472"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#d8dee8",
  d: "m50.652 10.472-36.628-1.24a1.45 1.45 0 0 0-1.518 1.449v66.537a1.41 1.41 0 0 0 1.518 1.414l36.628-2.083a1.5 1.5 0 0 0 1.37-1.5V11.942a1.456 1.456 0 0 0-1.37-1.47",
  "data-name": "Path 31098"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 33471",
  opacity: 0.3,
  style: {
    mixBlendMode: "multiply",
    isolation: "isolate"
  }
}, /*#__PURE__*/React.createElement("path", {
  fill: "#d8dee8",
  d: "M35.623 59.604c-.623-7.608 4.05-10.748 2.268-17.641-2.2-8.52-10.675-8.885-13.561-17.24-1.105-3.2-1.542-8.041 1.622-15.087l-11.93-.4a1.45 1.45 0 0 0-1.518 1.449v66.533a1.41 1.41 0 0 0 1.518 1.414l32.66-1.857c-8.308-6.434-10.676-12.495-11.059-17.171",
  "data-name": "Path 31099"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ifcax-cash-book_svg__j)",
  d: "m2601.892 315.921-36.628-1.2a.6.6 0 0 0-.623.6v66.458a.58.58 0 0 0 .623.581l36.628-2.041a.616.616 0 0 0 .564-.617v-63.177a.6.6 0 0 0-.564-.604",
  "data-name": "Path 31100",
  transform: "translate(-2551.24 -304.609)"
})), /*#__PURE__*/React.createElement("g", {
  fill: "#d8dee8",
  "data-name": "Group 33473"
}, /*#__PURE__*/React.createElement("path", {
  d: "m43.734 61.625-22.226.8a.99.99 0 0 0-.95.983.907.907 0 0 0 .95.912l22.226-.856a.95.95 0 0 0 .893-.953.87.87 0 0 0-.893-.886",
  "data-name": "Path 31101"
}), /*#__PURE__*/React.createElement("path", {
  d: "m43.734 64.902-22.226.9a1 1 0 0 0-.95.988.9.9 0 0 0 .95.908l22.226-.956a.955.955 0 0 0 .893-.957.863.863 0 0 0-.893-.883",
  "data-name": "Path 31102"
}), /*#__PURE__*/React.createElement("path", {
  d: "m43.734 68.181-22.226 1a1 1 0 0 0-.95.992.9.9 0 0 0 .95.9l22.226-1.055a.96.96 0 0 0 .893-.961.86.86 0 0 0-.893-.876",
  "data-name": "Path 31103"
})), /*#__PURE__*/React.createElement("g", {
  fill: "#d8dee8",
  "data-name": "Group 33474"
}, /*#__PURE__*/React.createElement("path", {
  d: "m32.209 13.974-11.18-.317a.454.454 0 0 0-.471.456.486.486 0 0 0 .471.483l11.18.3a.445.445 0 0 0 .457-.45.476.476 0 0 0-.457-.472",
  "data-name": "Path 31104"
}), /*#__PURE__*/React.createElement("path", {
  d: "m32.209 15.621-11.18-.292a.455.455 0 0 0-.471.457.484.484 0 0 0 .471.481l11.18.278a.446.446 0 0 0 .457-.451.474.474 0 0 0-.457-.473",
  "data-name": "Path 31105"
}), /*#__PURE__*/React.createElement("path", {
  d: "m32.209 17.27-11.18-.267a.457.457 0 0 0-.471.459.483.483 0 0 0 .471.48l11.18.254a.447.447 0 0 0 .457-.452.473.473 0 0 0-.457-.474",
  "data-name": "Path 31106"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 33478"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 33476"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#ifcax-cash-book_svg__b)",
  d: "M2653.622 482.6a4.78 4.78 0 0 1 3.676-2.53l.111-6.785a11.48 11.48 0 0 0-10.2 6.925Z",
  "data-name": "Path 31107",
  transform: "translate(-2625.721 -447.627)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ifcax-cash-book_svg__k)",
  d: "M2709.822 599.829a4.8 4.8 0 0 1-4.665 4.006 4.7 4.7 0 0 1-1.948-.4l-3.555 5.845a11.25 11.25 0 0 0 5.5 1.314 11.55 11.55 0 0 0 11.215-10.516Z",
  "data-name": "Path 31108",
  transform: "translate(-2673.023 -561.775)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ifcax-cash-book_svg__e)",
  d: "m2642.285 569.472 3.566-5.85a4.83 4.83 0 0 1-1.761-3.742 5 5 0 0 1 .117-1.064l-6.416-2.381a11.7 11.7 0 0 0-.52 3.465 11.57 11.57 0 0 0 5.014 9.572",
  "data-name": "Path 31109",
  transform: "translate(-2616.752 -522.633)"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 33477"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#ifcax-cash-book_svg__d)",
  d: "M2763.085 438.987a4.79 4.79 0 0 1 4 4.313l10.84.428v-.014a15.975 15.975 0 0 0-14.659-16Z",
  "data-name": "Path 31110",
  transform: "translate(-2730.237 -406.524)"
}))), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M2587.77 364.236c-.623-7.607 4.05-10.747 2.268-17.639-2.2-8.519-10.673-8.884-13.557-17.238-1.06-3.069-1.505-7.644 1.25-14.229l-11.555-.378a.6.6 0 0 0-.623.6V381.8a.58.58 0 0 0 .623.581l31.661-1.764c-7.508-6.143-9.7-11.899-10.067-16.381",
  "data-name": "Path 31111",
  opacity: 0.35,
  style: {
    mixBlendMode: "soft-light",
    isolation: "isolate"
  },
  transform: "translate(-2552.063 -304.635)"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 33480"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#ifcax-cash-book_svg__l)",
  d: "m2452.34 391.853-23.485-.234a.96.96 0 0 1-.962-.945v-8.932a.92.92 0 0 1 .962-.912l20.445.487a.936.936 0 0 1 .91.93v7.677Z",
  "data-name": "Path 31112",
  opacity: 0.3,
  style: {
    mixBlendMode: "multiply",
    isolation: "isolate"
  },
  transform: "translate(-2427.893 -364.236)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ifcax-cash-book_svg__m)",
  d: "m2478.81 406.094-15.552-.3v-1.074l15.552.325Z",
  "data-name": "Path 31113",
  opacity: 0.67,
  transform: "translate(-2459.792 -385.786)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ifcax-cash-book_svg__m)",
  d: "m2478.81 427.906-15.552-.26v-1.071l15.552.282Z",
  "data-name": "Path 31114",
  opacity: 0.67,
  transform: "translate(-2459.792 -405.499)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ifcax-cash-book_svg__m)",
  d: "m2478.81 449.717-15.552-.217v-1.071l15.552.239Z",
  "data-name": "Path 31115",
  opacity: 0.67,
  transform: "translate(-2459.792 -425.211)"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 33481"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#ifcax-cash-book_svg__n)",
  d: "m2741.931 722.217 15.838-.34a.74.74 0 0 1 .746.756v7.374a.79.79 0 0 1-.746.8l-16.693.563a.756.756 0 0 1-.782-.765v-9.639Z",
  "data-name": "Path 31116",
  opacity: 0.3,
  style: {
    mixBlendMode: "multiply",
    isolation: "isolate"
  },
  transform: "translate(-2709.68 -671.037)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m33.433 57.422 12.7-.38v.891l-12.7.4Z",
  "data-name": "Path 31117",
  opacity: 0.67
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m33.433 55.609 12.7-.349v.891l-12.7.364Z",
  "data-name": "Path 31118",
  opacity: 0.67
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m33.433 53.795 12.7-.318v.891l-12.7.333Z",
  "data-name": "Path 31119",
  opacity: 0.67
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 33485"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#ifcax-cash-book_svg__c)",
  d: "M3000.558 999.346a21 21 0 0 0-2.743 1.431c-.044.2 1.738-.07 2.465-.043s1.326-.19 1.259-.5-.323-1.082-.323-1.082Z",
  "data-name": "Path 31120",
  transform: "translate(-2941.964 -921.966)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ifcax-cash-book_svg__o)",
  d: "m3024.78 989.59.167 1.216a.95.95 0 0 0 .715-.029l.119-1.335Z",
  "data-name": "Path 31121",
  transform: "translate(-2966.287 -913.207)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ifcax-cash-book_svg__p)",
  d: "m3136.749 990.938.316.5a.6.6 0 0 1 .073.472c-.109.42-.327 1.238-.422 1.452-.13.291-1.878.467-1.878.467s-.156-.219.206-.485.6-.308.723-.7a10 10 0 0 0 .21-1.5Z",
  "data-name": "Path 31122",
  transform: "translate(-3065.529 -914.556)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ifcax-cash-book_svg__q)",
  d: "M3141.266 976.521a16 16 0 0 1 .681 1.795s.183.232.527-.112.156-.154.156-.154l-.069-1.677Z",
  "data-name": "Path 31123",
  transform: "translate(-3071.358 -901.419)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ifcax-cash-book_svg__r)",
  d: "M3008.178 725.878a132.7 132.7 0 0 0 1.424 24.885 12 12 0 0 0 1.177-.024 30 30 0 0 0 .994-3.2 31 31 0 0 0 .69-3.751c.511-4.112-.1-4.469.315-7.517.368-2.7.9-2.806 1.515-6.638.667-4.158.162-4.781-.084-5.005-1.052-.962-3.503-.304-6.031 1.25",
  "data-name": "Path 31124",
  transform: "translate(-2951.231 -673.937)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ifcax-cash-book_svg__g)",
  d: "M3018.251 724.627c-1-.912-3.274-.353-5.677 1.049 2.775 2.983 3.081 4.922 2.752 6.181-.372 1.423-1.51 1.836-1.5 3.391.01 1.911 1.736 2.413 1.7 4.436-.021 1.337-.779 1.325-.954 2.978-.207 1.955.785 2.626.468 4.073a3.91 3.91 0 0 1-1.648 2.276q.123.892.254 1.758.331.01.7 0 .246-.007.477-.024a30 30 0 0 0 .994-3.2 31 31 0 0 0 .69-3.751c.51-4.112-.1-4.469.315-7.517.368-2.7.9-2.806 1.514-6.638.664-4.165.164-4.787-.085-5.012",
  "data-name": "Path 31125",
  opacity: 0.3,
  style: {
    mixBlendMode: "multiply",
    isolation: "isolate"
  },
  transform: "translate(-2955.278 -673.942)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ifcax-cash-book_svg__s)",
  d: "M3026.5 722.19a81.5 81.5 0 0 1 11.23 23.886 1.46 1.46 0 0 0 .8.122 1.5 1.5 0 0 0 .9-.49 23.5 23.5 0 0 0 .193-5.788 20 20 0 0 0-.824-4.348c-.663-2.12-1.115-2.238-1.979-4.481-.9-2.328-.682-2.91-1.542-5.823a38.5 38.5 0 0 0-1.917-5.108Z",
  "data-name": "Path 31126",
  transform: "translate(-2967.837 -670.314)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#faf8ff",
  d: "M48.947 46.965c.022.847 1.415 1.593 2.536 1.822 2.621.535 5.659-1.369 7.1-3.476.283-.414.6-.915.674-.876.171.088-1.4 2.676-2.087 5.62-.35 1.506-.258 2.211-.911 3.214-.148.227-.331.464-.267.732.161.673 1.7.848 2.767.969a25 25 0 0 0 3.218.1c1.663-.024 1.794-.111 2.174.076 1.157.568 1.079 1.928 1.95 2.11.731.152 1.473-.664 1.708-.923 1.222-1.346 1.157-2.968 1.374-4.6a24.35 24.35 0 0 1 4.593-10.611c.613-.8 1.04-1.221 1.066-1.965.078-2.183-3.38-4.593-6.26-4.87a21.6 21.6 0 0 0-3.527.073c-.53.05-1.093.123-1.7.229a14 14 0 0 0-3.536.913c-4.2 1.924-3.287 6.206-7.837 9.166-1.564 1.015-3.059 1.41-3.035 2.297",
  "data-name": "Path 31127"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ifcax-cash-book_svg__t)",
  d: "M3079.8 538.244a6.3 6.3 0 0 0 .6 1.725c.375.648 1.929.881 2.252.994s-.488.676-1.351.881a10.7 10.7 0 0 1-3.883.066c-.495-.272.321-.355.915-.667a2.15 2.15 0 0 0 .609-2.121c-.184-.541.858-.878.858-.878",
  "data-name": "Path 31128",
  transform: "translate(-3013.629 -506.225)"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 33483"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#ifcax-cash-book_svg__u)",
  d: "M3080.632 517.221c-.626-.448-.8-1.658-.452-1.93.1-.078.194-.042 1.608.525.7.282 1.047.432 1.161.742a1 1 0 0 1-.019.646 2.5 2.5 0 0 1-.288.479c-.152.219-.142.211-.188.275a3.5 3.5 0 0 1-.723.707 2.4 2.4 0 0 0-.115-.4 2.1 2.1 0 0 0-.256-.476 2.4 2.4 0 0 0-.728-.568",
  "data-name": "Path 31129",
  transform: "translate(-3016.099 -485.493)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ifcax-cash-book_svg__v)",
  d: "M3086.866 533.352a1.3 1.3 0 0 1-1.169.528c-.679-.074-.713-1.607-.263-1.913a.86.86 0 0 1 .677-.057c.138.045.183.105.41.175.209.064.27.043.332.1.077.071.128.238-.025.679a.37.37 0 0 1 .4-.113.23.23 0 0 1 .087.092c.085.18-.08.396-.449.509",
  "data-name": "Path 31130",
  transform: "translate(-3020.727 -500.473)"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ifcax-cash-book_svg__w)",
  d: "M2934.847 649.609c1.9-.428 2.658-.414 3.6-1.171 1.564-1.26 1.8-3.179 2.708-3.156.43.011.778.45 1.027.88l-.687 1.075c0-.014 0-.024-.012-.028-.076-.039-.391.463-.673.876-1.442 2.106-4.48 4.01-7.1 3.476a4.56 4.56 0 0 1-2.124-1.033 33 33 0 0 1 3.261-.919",
  "data-name": "Path 31131",
  opacity: 0.3,
  style: {
    mixBlendMode: "multiply",
    isolation: "isolate"
  },
  transform: "translate(-2882.223 -602.774)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ifcax-cash-book_svg__x)",
  d: "M2908.376 701.757a7.3 7.3 0 0 1-1.711-.38c-.639-.273-1.052.119-.993.391s1.11.65 1.53.664 1.174-.675 1.174-.675",
  "data-name": "Path 31132",
  transform: "translate(-2858.846 -653.288)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M72.621 54.141a7.34 7.34 0 0 0 5.575-1.546c3.051-2.822 1.538-8.2.475-10.506a13.15 13.15 0 0 0-4.333-5.033c-1.461-1.118-2.353-1.8-3.426-1.648-2.775.4-4.7 6.082-3.173 7.711.5.533.993.231 2.436.691.47.15 3.978 1.267 4.589 3.851.427 1.808-.661 3.926-2.6 5.348Z",
  "data-name": "Path 31133"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ifcax-cash-book_svg__w)",
  d: "M3003.958 640.556c1.3-.823 1.5-1.658 2.956-2.222 1.9-.733 2.807.2 3.747-.553 1.119-.894.128-2.452.966-5.156.142-.459 1.221-3.945 3.7-4.389a3.34 3.34 0 0 1 3.267 1.214c.46.766.032 1.337.591 2.182s1.227.638 1.939 1.343a3.99 3.99 0 0 1 .283 4.812 4.7 4.7 0 0 1-2.26 1.331 11 11 0 0 1-1.942.57 5.13 5.13 0 0 0 1.8-4.676 5.4 5.4 0 0 0-3.082-3.243 22.5 22.5 0 0 0-2.5 7.313c-.217 1.636-.151 3.259-1.374 4.6-.235.259-.977 1.075-1.708.923-.871-.181-.792-1.542-1.949-2.11-.38-.186-.511-.1-2.174-.076a25 25 0 0 1-3.217-.1c-.95-.108-2.27-.259-2.664-.764a6.94 6.94 0 0 0 3.621-.999",
  "data-name": "Path 31134",
  opacity: 0.3,
  style: {
    mixBlendMode: "multiply",
    isolation: "isolate"
  },
  transform: "translate(-2944.239 -587.353)"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 33484"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#ifcax-cash-book_svg__f)",
  d: "m2914.643 684.676.134-.395a1.17 1.17 0 0 0-.785-1.5l-25.367-7.727-.773 2.62 25.239 7.774a1.25 1.25 0 0 0 1.552-.772",
  "data-name": "Path 31135",
  transform: "translate(-2842.778 -629.631)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ifcax-cash-book_svg__f)",
  d: "M2634.321 504.6a13.72 13.72 0 0 1 17.056-10.116 14.66 14.66 0 0 1 9.711 18.315 13.69 13.69 0 0 1-17.326 9.4 14.72 14.72 0 0 1-9.441-17.599m24.559 7.523a12.316 12.316 0 0 0-8.137-15.332 11.52 11.52 0 0 0-14.342 8.446 12.36 12.36 0 0 0 7.947 14.825 11.5 11.5 0 0 0 14.532-7.941Z",
  "data-name": "Path 31136",
  transform: "translate(-2613.681 -466.27)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#d8dee8",
  d: "m2888.625 675.057 3.235.985a3.36 3.36 0 0 0 1.088 1.983c1.634 1.354 3.815-.123 6.859 1.465 1.527.8 1.237 1.3 2.669 1.86 2.367.919 3.45-.354 5.545.483 2.119.846 2.327 2.675 3.529 2.61.514-.028 1.176-.4 1.913-1.82l.531.162a1.17 1.17 0 0 1 .785 1.5l-.134.395a1.25 1.25 0 0 1-1.552.775l-25.239-7.774Z",
  "data-name": "Path 31137",
  opacity: 0.3,
  style: {
    mixBlendMode: "multiply",
    isolation: "isolate"
  },
  transform: "translate(-2842.778 -629.631)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M30.068 54.841a11.9 11.9 0 0 0 15.042-8.207 12.744 12.744 0 0 0-8.424-15.876 11.92 11.92 0 0 0-14.838 8.75 12.79 12.79 0 0 0 8.22 15.333",
  "data-name": "Path 31138",
  opacity: 0.56
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ifcax-cash-book_svg__y)",
  d: "M2629.307 511.3a13.72 13.72 0 0 1 17.056-10.116 14.66 14.66 0 0 1 9.711 18.315 13.693 13.693 0 0 1-17.327 9.4 14.72 14.72 0 0 1-9.44-17.599m24.559 7.523a12.315 12.315 0 0 0-8.137-15.332 11.52 11.52 0 0 0-14.342 8.446 12.36 12.36 0 0 0 7.947 14.825 11.5 11.5 0 0 0 14.532-7.935Z",
  "data-name": "Path 31139",
  transform: "translate(-2609.159 -472.318)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ifcax-cash-book_svg__z)",
  d: "M2637 519.3a12.94 12.94 0 0 1 16.1-9.523 13.83 13.83 0 0 1 9.154 17.258 12.916 12.916 0 0 1-16.337 8.884A13.885 13.885 0 0 1 2637 519.3m23.825 7.3a12.316 12.316 0 0 0-8.137-15.332 11.52 11.52 0 0 0-14.341 8.446 12.36 12.36 0 0 0 7.946 14.825 11.5 11.5 0 0 0 14.535-7.939Z",
  "data-name": "Path 31140",
  transform: "translate(-2616.121 -480.093)"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ifcax-cash-book_svg__A)",
  d: "m3144.21 752.175-.257-.637a1.3 1.3 0 0 1-.762-.221 1 1 0 0 0-.616-.147c-.1.027-.461.011-.046.209s.413.345.239.508a3 3 0 0 1-1.069.529c-.237.017.192.384.431.431a1.48 1.48 0 0 0 1.117-.18c.178-.104.963-.492.963-.492",
  "data-name": "Path 31141",
  transform: "translate(-3071.687 -698.277)"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 33489"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#ifcax-cash-book_svg__B)",
  d: "m2866.774 216.811-17.1-1.048a2.16 2.16 0 0 0-2.278 2.192v15.97a2.32 2.32 0 0 0 2.278 2.331l.951.009v3.935c0 .589.7.877 1.276.225l3.576-4.112 11.293.034a1.99 1.99 0 0 0 1.909-2.087v-15.245a2.143 2.143 0 0 0-1.905-2.204",
  "data-name": "Path 31142",
  transform: "translate(-2806.29 -215.344)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ifcax-cash-book_svg__h)",
  d: "m2872.3 232.1-17.1-.089a2.32 2.32 0 0 1-2.278-2.331v-15.974a2.16 2.16 0 0 1 2.278-2.192l17.1 1.048a2.143 2.143 0 0 1 1.909 2.2v15.244a1.99 1.99 0 0 1-1.909 2.094",
  "data-name": "Path 31143",
  transform: "translate(-2811.277 -211.51)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ifcax-cash-book_svg__C)",
  d: "M2859.57 235.955v-16.79a1.15 1.15 0 0 1 1.213-1.168l17.859 1.034a1.14 1.14 0 0 1 1.017 1.174v16.031a1.06 1.06 0 0 1-1.017 1.112l-17.858-.15a1.24 1.24 0 0 1-1.214-1.243",
  "data-name": "Path 31144",
  transform: "translate(-2817.266 -217.359)"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 33488"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 33487"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 33486"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M53.784 12.559a1.1 1.1 0 0 0-.219-.724 2.1 2.1 0 0 0-.769-.515q-.551-.248-1.019-.5a3.7 3.7 0 0 1-.808-.578 2.3 2.3 0 0 1-.521-.745 2.5 2.5 0 0 1-.182-1.01 2.1 2.1 0 0 1 .646-1.6 2.62 2.62 0 0 1 1.716-.675V4.987l.893.038v1.246a2.6 2.6 0 0 1 1.605.933 2.86 2.86 0 0 1 .581 1.831l-1.884-.064a1.66 1.66 0 0 0-.224-.935.76.76 0 0 0-.639-.348.69.69 0 0 0-.576.22.97.97 0 0 0-.206.658 1 1 0 0 0 .237.691 2.4 2.4 0 0 0 .759.507q.521.246.983.506a4 4 0 0 1 .795.582 2.4 2.4 0 0 1 .523.743 2.4 2.4 0 0 1 .189 1 2.17 2.17 0 0 1-.6 1.6 2.5 2.5 0 0 1-1.65.693v1.171l-.893-.017v-1.173a2.9 2.9 0 0 1-1.89-.912 2.87 2.87 0 0 1-.661-1.963l1.909.052a1.6 1.6 0 0 0 .285 1.016 1.01 1.01 0 0 0 .807.366.76.76 0 0 0 .6-.22.9.9 0 0 0 .213-.649",
  "data-name": "Path 31145"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M59.012 4.159a.2.2 0 0 1 .18.2v12.72a.18.18 0 0 1-.18.185l-12.48-.207a.2.2 0 0 1-.19-.2V3.791a.18.18 0 0 1 .19-.185Zm0-.721-12.48-.573a.877.877 0 0 0-.917.893v13.086a.944.944 0 0 0 .917.949l12.48.188a.87.87 0 0 0 .867-.895v-12.7a.94.94 0 0 0-.867-.948",
  "data-name": "Path 31146"
}))), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ifcax-cash-book_svg__D)",
  d: "M2885.876 417.249v-4.742l5.542.062-4.442 5.105a.628.628 0 0 1-1.1-.425",
  "data-name": "Path 31147",
  transform: "translate(-2840.994 -392.81)"
})))));

const SvgIfcaxChinaIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  id: "ifcax-china-icon_svg__Layer_2",
  viewBox: "0 0 232.21 231.04",
  width: "1em",
  height: "1em"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".ifcax-china-icon_svg__cls-1{fill:#fff}.ifcax-china-icon_svg__cls-3{fill:#1a1a1a}.ifcax-china-icon_svg__cls-4{opacity:.27}")), /*#__PURE__*/React.createElement("g", {
  id: "ifcax-china-icon_svg__Layer_1-2"
}, /*#__PURE__*/React.createElement("rect", {
  width: 231.04,
  height: 231.04,
  x: 0.96,
  rx: 57.76,
  ry: 57.76,
  style: {
    fill: "#f9ae21"
  }
}), /*#__PURE__*/React.createElement("g", {
  className: "ifcax-china-icon_svg__cls-4"
}, /*#__PURE__*/React.createElement("path", {
  d: "m26.69 24.2 7.68-.03 5.9 4.32-4.41 2.61zM41.15 35.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-china-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26 40.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM96.69 24.2l7.68-.03 5.9 4.32-4.41 2.61zM111.15 35.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-china-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M96 40.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM169.69 24.2l7.68-.03 5.9 4.32-4.41 2.61zM184.15 35.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-china-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M169 40.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2z",
  className: "ifcax-china-icon_svg__cls-1"
})), /*#__PURE__*/React.createElement("g", {
  className: "ifcax-china-icon_svg__cls-4"
}, /*#__PURE__*/React.createElement("path", {
  d: "m26.69 109.2 7.68-.03 5.9 4.32-4.41 2.61zM41.15 120.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-china-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26 125.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM96.69 109.2l7.68-.03 5.9 4.32-4.41 2.61zM111.15 120.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-china-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M96 125.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM169.69 109.2l7.68-.03 5.9 4.32-4.41 2.61zM184.15 120.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-china-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M169 125.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2z",
  className: "ifcax-china-icon_svg__cls-1"
})), /*#__PURE__*/React.createElement("g", {
  className: "ifcax-china-icon_svg__cls-4"
}, /*#__PURE__*/React.createElement("path", {
  d: "m26.69 198.2 7.68-.03 5.9 4.32-4.41 2.61zM41.15 209.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-china-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26 214.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM96.69 198.2l7.68-.03 5.9 4.32-4.41 2.61zM111.15 209.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-china-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M96 214.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM169.69 198.2l7.68-.03 5.9 4.32-4.41 2.61zM184.15 209.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-china-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M169 214.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2z",
  className: "ifcax-china-icon_svg__cls-1"
})), /*#__PURE__*/React.createElement("g", {
  className: "ifcax-china-icon_svg__cls-4"
}, /*#__PURE__*/React.createElement("path", {
  d: "m62.69 153.2 7.68-.03 5.9 4.32-4.41 2.61zM77.15 164.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-china-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M62 169.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM.69 153.2l7.68-.03 5.9 4.32-4.41 2.61zM15.15 164.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-china-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 169.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM130.69 153.2l7.68-.03 5.9 4.32-4.41 2.61zM145.15 164.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-china-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M130 169.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM194.69 153.2l7.68-.03 5.9 4.32-4.41 2.61zM209.15 164.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-china-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M194 169.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2z",
  className: "ifcax-china-icon_svg__cls-1"
})), /*#__PURE__*/React.createElement("g", {
  className: "ifcax-china-icon_svg__cls-4"
}, /*#__PURE__*/React.createElement("path", {
  d: "m62.69 66.2 7.68-.03 5.9 4.32-4.41 2.61zM77.15 77.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-china-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M62 82.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM.69 66.2l7.68-.03 5.9 4.32-4.41 2.61zM15.15 77.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-china-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 82.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM130.69 66.2l7.68-.03 5.9 4.32-4.41 2.61zM145.15 77.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-china-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M130 82.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM194.69 66.2l7.68-.03 5.9 4.32-4.41 2.61zM209.15 77.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-china-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M194 82.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2z",
  className: "ifcax-china-icon_svg__cls-1"
})), /*#__PURE__*/React.createElement("path", {
  d: "M19.37 154.48h38.44v14.92c2.75 1.1 4.85 1.91 6.3 2.42q-1.545 6.825-3.24 8.43c-1.695 1.605-3.11 1.61-5.96 1.61h-6.2c-5.03 0-7.55-2.35-7.55-7.05v-4.95h-6.1c-.55 2.82-1.42 4.96-2.6 6.44-1.18 1.47-2.96 2.77-5.32 3.89-2.37 1.12-5.31 2.02-8.82 2.72-1.27-1.87-2.7-3.87-4.3-6 8.36-.87 13.04-3.22 14.02-7.05h-8.67v-15.39Zm26.29-11.15h8.15c-.97 1.08-1.92 2.13-2.87 3.15h12.62v5.4H14.13v-5.4h12.35l-2.5-3.1h8c.73.97 1.5 2 2.3 3.1h8.92c.83-1.02 1.66-2.07 2.47-3.15Zm-29.59-6h18.72l-1.02-4 8.4-.3.5 4.3h19.09v5.4H16.08v-5.4Zm34.59 27.14v-4.6H26.52v4.6zm.05 11.79h2.6c.92 0 1.64-.16 2.17-.47.53-.32.89-.74 1.06-1.27s.47-2.08.89-4.65h-9.27v3.95c0 1.63.85 2.45 2.55 2.45ZM76.98 133.09l6.9 2a96 96 0 0 1-5.35 12.75v27.91c6.01-5.03 9.35-12.75 10-23.17h-8.2v-6.55h8.32c.08-4.25.12-8.48.12-12.7h6.7c0 1.13-.05 5.36-.15 12.7h19.89v6.55h-11.05v19.39c0 1.57.6 2.35 1.8 2.35h.95q1.425 0 1.77-.99c.345-.99.59-3.53 1.07-8.61 2 .93 4.08 1.8 6.25 2.6-.52 4.07-.97 6.93-1.35 8.61-.38 1.67-1.15 2.87-2.31 3.57-1.16.71-2.6 1.06-4.34 1.06h-4.25c-4.2 0-6.3-2.32-6.3-6.95v-21.04h-2.1c-.38 12.91-4.42 22.74-12.1 29.49-1.7-2.3-3.28-4.27-4.75-5.92v5.97h-6.7v-23.42a73 73 0 0 1-3.6 4.52c-.5-2.87-1.12-5.88-1.85-9.05 4.06-5 7.6-12.03 10.6-21.09Zm26.44.45c3.23 1.9 6.21 3.96 8.95 6.2l-4.25 5q-2.25-1.905-8.55-6.75zM119.49 174.53l-.55-6.6c3.08-.22 6.46-.49 10.15-.82v-4.62h-9.6v-6.05c1.1-3.45 2.13-7.18 3.1-11.2h-3.55v-5.9h4.9c.43-2 .85-4.06 1.25-6.2l6.55.55-1.4 5.65h10.3v5.9h-11.82c-1.02 3.73-2.09 7.51-3.22 11.34h3.5v-8.55h6v8.55h5.8v5.9h-5.8v4.02l6.5-.67c-.17 1.9-.28 4.01-.35 6.35l-6.15.65v9.75h-6v-9.12l-9.6 1.07Zm29.64-25.29h6.45c-.02 2.57-.14 4.99-.38 7.27 2.88 9.41 7.44 15.69 13.67 18.82-1.27 1.83-2.7 4.06-4.3 6.7-5.2-3.42-9.06-8.26-11.6-14.54-2.2 6.03-6.05 11.13-11.55 15.29-1.93-2.53-3.57-4.46-4.9-5.8 4.65-3.32 7.91-6.89 9.78-10.72s2.81-9.5 2.81-17.02Zm18.79-9.2v6l-2.8 9.65-6.45-1.3 2.4-8.2h-13.04c-1.28 3.68-2.62 7.01-4 10-1.13-.87-3.07-2-5.8-3.4 3.33-6.8 5.61-13.45 6.85-19.94l6.65 1.05c-.57 2.13-1.14 4.18-1.72 6.15h17.92ZM180.8 133.34l6.9 2c-1.2 3.57-2.43 6.92-3.7 10.07v37.11h-6.7v-22.77c-1.35 2.45-2.73 4.71-4.15 6.77-.6-3.63-1.18-6.75-1.75-9.35 3.5-6.6 6.63-14.54 9.4-23.84Zm5.4 26.74h15.94v-9.55h-6.87c-.97 3.15-1.99 5.96-3.07 8.45-1.83-1-3.92-1.98-6.25-2.95 2.23-5.37 4.13-11.86 5.7-19.49l6.75 1.65c-.43 2.07-.88 4.03-1.35 5.9h5.1v-10.8h7.25v10.8h10.45v6.45H209.4v9.55h11.8v6.45h-11.8v16.04h-7.25v-16.04h-15.94v-6.45Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M97.95 55.23H49.68v3.35h3.04a7.8 7.8 0 0 1 3.84 1c.79.46 1.31.99 1.55 1.58.25.63.54 2.18.54 5.99v40.51c0 4.67-.59 6.16-.94 6.62-1.02 1.31-2.65 1.95-4.99 1.95h-3.04v3.35h28.56v-3.35h-3.09c-1.33 0-2.63-.34-3.85-1-.81-.46-1.35-.99-1.58-1.57-.25-.63-.54-2.18-.54-5.99V88.79h10.6c1.95 0 3.41.26 4.35.76.93.5 1.63 1.23 2.16 2.23.54 1.02.82 2.7.85 4.99v.81h.01c1.85 0 3.34-1.5 3.34-3.34V74.71h-3.26l-.08.73c-.38 3.21-1.11 5.35-2.18 6.37-1.05 1-2.8 1.51-5.19 1.51h-8.13a2.48 2.48 0 0 1-2.48-2.48V60.31h13.01c3.15 0 5.48.29 6.93.87 1.41.56 2.62 1.48 3.58 2.72.99 1.28 1.88 3.35 2.66 6.17l.17.6h3.1l-.67-15.42ZM155.18 103.79l-2.74-1.77-.46.63c-3.64 5.06-7.01 8.47-10 10.15-2.97 1.66-6.47 2.51-10.37 2.51-4.51 0-8.58-1.08-12.08-3.21-3.49-2.12-6.14-5.22-7.88-9.2-1.76-4.04-2.66-8.89-2.66-14.42 0-6.73.95-12.43 2.83-16.94 1.85-4.44 4.41-7.71 7.61-9.73 3.21-2.02 6.86-3.04 10.85-3.04 4.75 0 8.87 1.36 12.25 4.03 3.4 2.69 6.06 7.19 7.91 13.37l.18.59c1.58 0 2.83-1.34 2.73-2.92L152 53.79h-3.04l-.15.64c-.3 1.33-.81 2.36-1.48 3.06-.46.44-.99.65-1.61.65-.19 0-.8-.09-2.41-.93-4.5-2.27-9.14-3.42-13.78-3.42-5.95 0-11.51 1.49-16.53 4.44-5.03 2.95-9.03 7.16-11.89 12.51-2.86 5.34-4.31 11.27-4.31 17.64 0 7.91 2.2 14.89 6.54 20.74 5.84 7.89 14.18 11.9 24.8 11.9 5.89 0 11.06-1.35 15.37-4.01 4.29-2.65 8.09-6.87 11.29-12.55zM216.85 116.24c-2.36-.14-4.21-.78-5.5-1.9-1.33-1.16-2.87-3.8-4.57-7.86l-22.04-52.67h-2.71l-22.28 52.11c-1.86 4.41-3.55 7.35-5.04 8.75-.45.43-1.62 1.05-4.66 1.59l-.68.12v3.22h21.39v-3.3l-.76-.05c-3.54-.25-4.91-.81-5.44-1.23-.71-.57-1.05-1.18-1.05-1.88 0-1.09.51-2.81 1.51-5.13l4.04-9.4h23.19l3.58 8.52c1.18 2.82 1.78 4.87 1.78 6.11 0 .76-.33 1.4-1.01 1.95-.51.41-1.71.93-4.59 1.07l-.78.04v3.31h26.39v-3.31l-.77-.05Zm-31.07-22.71H171.2l9.66-22.42 7.67 18.28c.83 1.97-.62 4.14-2.75 4.14M208.57 53.09c0 4.71-3.7 8.41-8.51 8.41s-8.56-3.7-8.56-8.41 3.8-8.3 8.56-8.3 8.51 3.7 8.51 8.3m-14.94 0c0 3.7 2.73 6.63 6.48 6.63s6.33-2.94 6.33-6.58-2.68-6.68-6.38-6.68-6.43 2.99-6.43 6.63m5.11 4.36h-1.92v-8.3c.76-.15 1.82-.25 3.19-.25 1.57 0 2.28.25 2.89.61.46.35.81 1.01.81 1.82 0 .91-.71 1.62-1.72 1.92v.1c.81.3 1.27.91 1.52 2.03.25 1.27.41 1.77.61 2.08h-2.08c-.25-.3-.41-1.06-.66-2.03-.15-.91-.66-1.32-1.72-1.32h-.91v3.34Zm.05-4.71h.91c1.06 0 1.92-.35 1.92-1.22 0-.76-.56-1.27-1.77-1.27-.51 0-.86.05-1.06.1v2.38ZM17.59 58.59h3.04c1.33 0 2.63.34 3.84 1 .79.46 1.31.99 1.54 1.58.25.63.54 2.18.54 5.99v40.51c0 4.67-.59 6.16-.94 6.62-1.02 1.31-2.65 1.95-4.99 1.95h-3.04v3.35h28.51v-3.35H43c-1.33 0-2.61-.34-3.81-1-.81-.46-1.35-.99-1.58-1.57-.25-.63-.54-2.18-.54-5.99V67.17c0-4.66.62-6.15.98-6.62 1.02-1.31 2.64-1.95 4.95-1.95 1.71 0 3.09-1.38 3.09-3.09v-.27h-28.5z",
  className: "ifcax-china-icon_svg__cls-3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M38.32 37.16c.58-1.6.98-3.15 1.24-4.55-1.41-.2-3.01-.33-4.71-.29q-.84.015-1.68.09c.39.39.76.79 1.12 1.21.16-.06.33-.1.51-.1.75 0 1.35.6 1.35 1.35 0 .3-.1.57-.26.8.67.96 1.28 1.98 1.82 3.04.22-.5.42-1.02.61-1.54ZM20.97 32.18c-.89 1.49-1.49 3.17-1.71 4.97.77-.61 1.56-1.17 2.37-1.69-.28-1.06-.5-2.15-.66-3.29ZM23.08 34.62c-.01-.08-.02-.16-.02-.25 0-.75.6-1.35 1.35-1.35.41 0 .78.19 1.03.48 1.94-.8 3.97-1.36 6.08-1.66-1.78-1.58-3.83-2.93-6.13-4.05-1.48.88-2.77 2.05-3.78 3.43.14 1.19.36 2.49.7 3.83.25-.15.51-.29.77-.43M42.9 32.5c-.59-1.05-1.32-2.01-2.18-2.84-.06.7-.16 1.48-.29 2.33.92.15 1.75.33 2.47.51M34.86 31.56c1.74-.04 3.38.1 4.82.3.18-1.08.28-2.04.33-2.86a12.66 12.66 0 0 0-8.18-2.99c-2.04 0-3.96.48-5.66 1.33 2.37 1.2 4.47 2.66 6.29 4.36.79-.08 1.59-.14 2.4-.15ZM24.41 35.72c-.4 0-.76-.17-1-.45-.3.16-.6.33-.89.51.66 2.27 1.69 4.62 3.28 6.77 1.48 2 3.32 3.65 5.51 4.96 2.52-2.19 4.53-4.84 6-7.94-.58-1.23-1.25-2.38-2-3.46-.16.06-.33.1-.51.1a1.344 1.344 0 0 1-1.08-2.15c-.47-.54-.96-1.06-1.48-1.56-2.28.27-4.44.82-6.49 1.66.01.07.02.14.02.21 0 .75-.6 1.35-1.35 1.35Z",
  className: "ifcax-china-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M43.36 33.39c-.14-.31-.29-.61-.46-.9zh-.03c-.83-.23-1.85-.47-3.03-.67a29.3 29.3 0 0 1-2.17 6.85q.495 1.065.9 2.19c.81 2.23 1.26 4.36 1.51 6.14 2.45-2.31 3.98-5.59 3.98-9.22 0-1.89-.42-3.69-1.16-5.3ZM37.7 40.46a25.2 25.2 0 0 1-4.94 6.71c-.26.25-.52.49-.79.73.22.12.44.24.67.35.24-.36.65-.59 1.12-.59.75 0 1.35.6 1.35 1.35q0 .15-.03.3c.76.28 1.56.53 2.38.75.86-.43 1.67-.95 2.41-1.55-.23-1.84-.68-4.12-1.55-6.51-.19-.52-.4-1.04-.61-1.54ZM28.03 50.78l-.9-.32c.3.12.6.23.9.32M34.7 49.97a1.344 1.344 0 0 1-2.29-.96v-.03c-.36-.18-.71-.36-1.05-.56-1.03.86-2.14 1.65-3.33 2.36 1.21.38 2.49.59 3.82.59 1.59 0 3.12-.29 4.52-.83-.57-.17-1.13-.36-1.67-.56ZM25.19 42.99c-1.46-1.96-2.58-4.25-3.34-6.8-.92.59-1.8 1.25-2.66 1.97 0 .17-.01.35-.01.53 0 5.33 3.29 9.89 7.95 11.76q1.92-1.095 3.57-2.43a19.8 19.8 0 0 1-5.51-5.03",
  className: "ifcax-china-icon_svg__cls-1"
})));

const SvgIfcaxClock = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 512 512"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#ff5876",
  d: "M512 256q0-4.666-.165-9.291C506.944 109.628 394.275 0 256 0S5.056 109.628.166 246.709Q.001 251.334 0 256c0 141.385 131.502 246.71 256 246.71 126.754 0 256-105.325 256-246.71"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e6485d",
  d: "M256 493.419c-138.273 0-250.922-109.631-255.814-246.71A258 258 0 0 0 0 256c0 141.385 114.615 256 256 256s256-114.615 256-256c0-3.112-.075-6.205-.185-9.29C506.922 383.789 394.273 493.419 256 493.419"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e4eef9",
  d: "M469.419 246.709C464.555 133.042 370.865 42.382 256 42.382S47.445 133.042 42.581 246.709C42.449 249.79 42.58 456.03 256 456.03s213.551-206.24 213.419-209.321"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#d5e0f2",
  d: "M256 451.037c-114.864 0-208.539-90.662-213.405-204.328a217 217 0 0 0-.213 9.29c0 117.978 95.64 213.618 213.618 213.618S469.618 373.978 469.618 256c0-3.114-.082-6.209-.213-9.29C464.539 360.376 370.864 451.037 256 451.037"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#405b6c",
  d: "M333.595 181.05c-6.089-6.005-15.893-5.938-21.897.15l-36.334 36.837 3.651 17.537 16.972 5.654 37.759-38.281c6.004-6.088 5.937-15.892-.151-21.897M234.082 219.447l-82.402-73.432c-6.385-5.69-16.172-5.126-21.861 1.259s-5.126 16.172 1.259 21.861l84.025 74.878 17.509-5.84z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#86dcff",
  d: "M365.636 355.837a7.7 7.7 0 0 1-4.976-1.814l-98.073-82.378a7.742 7.742 0 0 1 9.959-11.856l98.073 82.379a7.742 7.742 0 0 1-4.983 13.669"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2d4456",
  d: "m215.103 244.013 14.46 12.886 18.57-6.31-1.007-19.519-13.043-11.623c-9.075 5.453-15.944 14.19-18.98 24.566M275.363 218.038l-12.294 12.464v24.466h19.366l13.552-13.739c-3.724-10.076-11.151-18.349-20.624-23.191"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ff5876",
  d: "M280.783 246.708c-3.762-10.03-13.439-17.169-24.783-17.169s-21.021 7.139-24.783 17.169c-1.084 2.891-.072 26.462 24.783 26.462s25.867-23.571 24.783-26.462"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e6485d",
  d: "M256 263.88c-11.344 0-21.017-7.14-24.779-17.17a26.4 26.4 0 0 0-1.682 9.29c0 14.614 11.847 26.46 26.46 26.46s26.46-11.847 26.46-26.46c0-3.27-.597-6.399-1.681-9.29-3.761 10.029-13.434 17.17-24.778 17.17"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#405b6c"
}, /*#__PURE__*/React.createElement("path", {
  d: "M263.757 93.573V69.546a7.757 7.757 0 0 0-15.514 0v24.027c0 4.284 3.472 7.757 7.757 7.757s7.757-3.473 7.757-7.757M248.243 418.427v24.027c0 4.284 3.472 7.757 7.757 7.757s7.757-3.473 7.757-7.757v-24.027a7.757 7.757 0 0 0-15.514 0M442.454 263.757a7.757 7.757 0 0 0 0-15.514h-24.027a7.757 7.757 0 0 0 0 15.514zM69.546 248.243c-4.285 0-7.757 3.473-7.757 7.757s3.472 7.757 7.757 7.757h24.027a7.757 7.757 0 0 0 0-15.514z"
})));

const SvgIfcaxCompanies = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 483.254 483.254"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#dbd8dd",
  d: "M63.46 61.037h356.335v401.814H63.46z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#eeefee",
  d: "M141.299 0H341.95v462.846H141.299z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#69b0ee",
  d: "M79.525 79.342h45.774v54.018H79.525zM79.525 157.152h45.774v54.018H79.525zM79.525 234.956h45.774v54.018H79.525zM79.525 312.766h45.774v54.018H79.525zM79.525 390.57h45.774v54.018H79.525zM356.164 79.342h45.774v54.018h-45.774zM356.164 157.152h45.774v54.018h-45.774zM356.164 234.956h45.774v54.018h-45.774zM356.164 312.766h45.774v54.018h-45.774zM356.164 390.57h45.774v54.018h-45.774zM161.878 22.913H321.37V52.71H161.878zM161.861 76.519h159.533v29.797H161.861zM161.861 130.155h159.533v29.797H161.861zM161.861 183.79h159.533v29.797H161.861zM161.861 237.425h159.533v29.797H161.861zM161.861 291.061h159.533v29.797H161.861z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#575b6d",
  d: "M170.418 344.472h142.424v118.374H170.418z"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#eeefee"
}, /*#__PURE__*/React.createElement("path", {
  d: "M365.093 444.588h-1.715l19.283-54.018h1.721zM377.805 444.588h-9.989l19.283-54.018h9.989zM365.093 366.778h-1.715l19.283-54.012h1.721zM377.805 366.778h-9.989l19.283-54.012h9.989zM365.093 288.974h-1.715l19.283-54.018h1.721zM377.805 288.974h-9.989l19.283-54.018h9.989zM365.093 211.17h-1.715l19.283-54.018h1.721zM377.805 211.17h-9.989l19.283-54.018h9.989zM365.093 133.361h-1.715l19.283-54.019h1.721zM377.805 133.361h-9.989l19.283-54.019h9.989zM243.649 22.913 226.287 52.71h-5.398l17.261-29.797zM282.215 22.913 264.959 52.71h-27.198l17.262-29.797zM243.649 76.525l-17.362 29.791h-5.398l17.261-29.791zM282.215 76.525l-17.256 29.791h-27.198l17.262-29.791zM243.649 130.131l-17.362 29.797h-5.398l17.261-29.797zM282.215 130.131l-17.256 29.797h-27.198l17.262-29.797zM243.649 183.737l-17.362 29.797h-5.398l17.261-29.797zM282.215 183.737l-17.256 29.797h-27.198l17.262-29.797zM243.649 237.349l-17.362 29.791h-5.398l17.261-29.791zM282.215 237.349l-17.256 29.791h-27.198l17.262-29.791zM243.649 290.955l-17.362 29.796h-5.398l17.261-29.796zM282.215 290.955l-17.256 29.796h-27.198l17.262-29.796zM87.275 444.588H85.56l19.283-54.018h1.72zM99.987 444.588h-9.99l19.283-54.018h9.99zM87.275 366.778H85.56l19.283-54.012h1.72zM99.987 366.778h-9.99l19.283-54.012h9.99zM87.275 288.974H85.56l19.283-54.018h1.72zM99.987 288.974h-9.99l19.283-54.018h9.99zM87.275 211.17H85.56l19.283-54.018h1.72zM99.987 211.17h-9.99l19.283-54.018h9.99zM87.275 133.361H85.56l19.283-54.019h1.72zM99.987 133.361h-9.99l19.283-54.019h9.99z",
  opacity: 0.5
})), /*#__PURE__*/React.createElement("path", {
  fill: "#bbbbcd",
  d: "M42.314 458.379H440.94v24.876H42.314z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#eeefee",
  d: "M234.184 339.775h14.887v118.444h-14.887z"
}));

const SvgIfcaxCompanySetting = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 20 20"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57337"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h20v20H0z",
  "data-name": "Rectangle 26176"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-.568 -.568)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#7fadd3",
  d: "M20.1 9.746a.56.56 0 0 0-.353-.459l-1.112-.445a8.2 8.2 0 0 0-1.145-2.755l.472-1.105a.55.55 0 0 0-.076-.574 10 10 0 0 0-1.158-1.158.55.55 0 0 0-.574-.076l-1.105.472A8.2 8.2 0 0 0 12.293 2.5l-.445-1.112a.56.56 0 0 0-.459-.353 9 9 0 0 0-1.643 0 .56.56 0 0 0-.459.353L8.842 2.5a8.2 8.2 0 0 0-2.755 1.145l-1.106-.472a.55.55 0 0 0-.574.076 9.6 9.6 0 0 0-1.158 1.158.55.55 0 0 0-.076.574l.472 1.105A8.2 8.2 0 0 0 2.5 8.842l-1.112.445a.56.56 0 0 0-.353.459 9 9 0 0 0 0 1.643.56.56 0 0 0 .353.459l1.112.445a8.2 8.2 0 0 0 1.145 2.755l-.472 1.105a.55.55 0 0 0 .076.574 10 10 0 0 0 1.158 1.158.55.55 0 0 0 .574.076l1.105-.472a8.2 8.2 0 0 0 2.755 1.145l.445 1.112a.56.56 0 0 0 .459.353 9 9 0 0 0 1.643 0 .56.56 0 0 0 .459-.353l.445-1.112a8.2 8.2 0 0 0 2.755-1.145l1.105.472a.55.55 0 0 0 .574-.076 9.6 9.6 0 0 0 1.158-1.158.55.55 0 0 0 .076-.574l-.472-1.105a8.2 8.2 0 0 0 1.145-2.755l1.112-.445a.56.56 0 0 0 .353-.459 9 9 0 0 0 0-1.643ZM10.568 17.5a6.929 6.929 0 1 1 6.932-6.932 6.93 6.93 0 0 1-6.932 6.932",
  "data-name": "Path 69300"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 6.5,
  cy: 6.5,
  r: 6.5,
  fill: "#9fcded",
  "data-name": "Ellipse 1434",
  transform: "translate(3.997 3.997)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5c75b2",
  d: "M10.567 17.827a7.259 7.259 0 1 1 7.259-7.259 7.26 7.26 0 0 1-7.259 7.259m0-13.859a6.6 6.6 0 1 0 6.6 6.6 6.6 6.6 0 0 0-6.6-6.6",
  "data-name": "Path 69301"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2d303d",
  d: "M13.538 8.258h-.66v-1.32a.66.66 0 0 0-.66-.66h-3.3a.66.66 0 0 0-.66.66v1.32h-.66v-1.32a1.32 1.32 0 0 1 1.32-1.32h3.3a1.32 1.32 0 0 1 1.32 1.32Z",
  "data-name": "Path 69302"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#343956",
  d: "M14.857 10.238v3.3a.99.99 0 0 1-.99.99h-6.6a.99.99 0 0 1-.989-.99v-3.3Z",
  "data-name": "Path 69303"
}), /*#__PURE__*/React.createElement("rect", {
  width: 9,
  height: 3,
  fill: "#454a6e",
  "data-name": "Rectangle 26175",
  rx: 1.5,
  transform: "translate(5.997 7.997)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#efd07b",
  d: "M9.578 11.228h1.98v.66a.66.66 0 0 1-.66.66h-.66a.66.66 0 0 1-.66-.66Z",
  "data-name": "Path 69304"
}))));

const SvgIfcaxCompany = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 64 64"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#fcd770",
  d: "M58 25v4l-6.08-2.66c-.53-6.46-4.13-12.05-9.33-15.3C39.52 9.11 35.89 8 32 8c-10.48 0-19.07 8.07-19.92 18.34L6 29v-4h.42c.99 0 1.85-.7 2.04-1.68.2-.98-.33-1.96-1.25-2.34l-.38-.16 2.3-5.54.39.16c.92.38 1.97.06 2.52-.76l.01-.01c.55-.83.44-1.93-.26-2.64l-.3-.29 4.25-4.25.29.3c.41.4.94.61 1.48.61.4 0 .81-.12 1.16-.35.83-.56 1.15-1.62.77-2.54l-.16-.38 5.54-2.3.16.39c.38.92 1.35 1.44 2.33 1.25l.01-.01A2.07 2.07 0 0 0 29 2.42V2h6v.42c0 1 .7 1.85 1.68 2.04h.01c.97.2 1.95-.33 2.33-1.25l.16-.38 5.54 2.3-.16.38c-.38.92-.06 1.98.77 2.54h.01c.82.55 1.92.45 2.62-.26l.3-.3 4.25 4.25-.3.3c-.71.7-.81 1.8-.26 2.62l.01.02c.55.82 1.6 1.14 2.52.76l.39-.16 2.3 5.54-.39.16c-.92.38-1.44 1.35-1.25 2.33l.01.01A2.07 2.07 0 0 0 57.58 25z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ccd1d9",
  d: "M18 35.96A6.7 6.7 0 0 0 13.25 34H7.71c-.62 0-1.2.15-1.71.42V29l6.08-2.66L22 22v15h-3.14l-.84-1.02zM50 34.22a9.1 9.1 0 0 0-4 2.07c-.12.12-.24.23-.36.35s-.23.24-.34.36H42V22l9.92 4.34L58 29v7.29a9.1 9.1 0 0 0-4-2.07c-.64-.14-1.31-.22-2-.22s-1.36.08-2 .22M42 12v4l-20 3v-4z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e6e9ed",
  d: "M22 19v18h20V16z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#69d6f4",
  d: "M34 22h4v4h-4zM38 30v5.53A5.97 5.97 0 0 0 34 34v-4zM30 30v4c-1.54 0-2.94.58-4 1.53V30zM26 22h4v4h-4z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fcd770",
  d: "M8.56 57.58 12 62H2v-2.46c0-1.63.65-3.19 1.8-4.34.55-.55 1.2-.99 1.91-1.29zM22 62H12l3.44-4.42 2.85-3.67c.71.3 1.36.74 1.91 1.29a6.14 6.14 0 0 1 1.8 4.34z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#b4dd7f",
  d: "M15.44 57.58 12 62l-3.44-4.42L12 55z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#a0d468",
  d: "m18.29 53.91-2.85 3.67L12 55l3-2 2.35.59c.32.08.64.19.94.32M12 55l-3.44 2.58-2.85-3.67c.3-.13.62-.24.94-.32L9 53z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#b4dd7f",
  d: "M42 59.54V62H32l3.44-4.42 2.85-3.67c.71.3 1.36.74 1.91 1.29a6.14 6.14 0 0 1 1.8 4.34M28.56 57.58 32 62H22v-2.46c0-1.63.65-3.19 1.8-4.34.55-.55 1.2-.99 1.91-1.29z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ff826e",
  d: "M35.44 57.58 32 62l-3.44-4.42L32 55z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fc6e51",
  d: "m38.29 53.91-2.85 3.67L32 55l3-2 2.35.59c.32.08.64.19.94.32M32 55l-3.44 2.58-2.85-3.67c.3-.13.62-.24.94-.32L29 53z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ff826e",
  d: "M62 59.54V62H52l3.89-5 2.4-3.09c.63.27 1.2.64 1.7 1.1.07.06.14.12.21.19a6.14 6.14 0 0 1 1.8 4.34M48.11 57 52 62H42v-2.46c0-1.63.65-3.19 1.8-4.34.07-.07.14-.13.21-.19.5-.46 1.07-.83 1.7-1.1z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#b4dd7f",
  d: "M55.89 57 52 62l-3.89-5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f0d0b4",
  d: "M17 44v2a5.005 5.005 0 0 1-1.46 3.54c-.35.35-.75.64-1.19.87L12 51c-.85 0-1.65-.21-2.35-.59A4.99 4.99 0 0 1 7 46v-1.88a3.995 3.995 0 0 1 3.02-3.87c.12.99.97 1.75 1.98 1.75h3c1.1 0 2 .9 2 2"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f0d0b4",
  d: "m12 51 2.35-.59L15 53l-3 2-3-2 .65-2.59c.7.38 1.5.59 2.35.59M37 44v2a5.005 5.005 0 0 1-1.46 3.54c-.35.35-.75.64-1.19.87L32 51c-.85 0-1.65-.21-2.35-.59A4.98 4.98 0 0 1 27 46v-1.88c0-1.83 1.24-3.42 3.02-3.87.12.99.97 1.75 1.98 1.75h3c1.1 0 2 .9 2 2"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f0d0b4",
  d: "m29 53 .65-2.59c.7.38 1.5.59 2.35.59l2.35-.59L35 53l-3 2zM50.7 40.07c.53.71 1.33 1.22 2.27 1.35l2.31.33c.99.15 1.72.99 1.72 1.98V46c0 1.38-.56 2.63-1.46 3.54-.35.35-.75.64-1.19.87-.7.38-1.5.59-2.35.59s-1.65-.21-2.35-.59A4.99 4.99 0 0 1 47 46v-1.88a4.01 4.01 0 0 1 3.03-3.88l.66-.16z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f0d0b4",
  d: "m48.11 57-2.4-3.09c.3-.13.62-.24.94-.32l.6-.15a3.01 3.01 0 0 0 2.19-2.19l.21-.84c.7.38 1.5.59 2.35.59s1.65-.21 2.35-.59l.21.84a3.01 3.01 0 0 0 2.19 2.19l.6.15c.32.08.64.19.94.32L55.89 57z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#b27946",
  d: "M46.65 53.59c-.32.08-.64.19-.94.32-.63.27-1.2.64-1.7 1.1L44 55l-.5-4.03c-.33-2.64-.5-5.31-.5-7.97 0-1.95.62-3.75 2.3-6 .11-.12.22-.24.34-.36s.24-.23.36-.35a9.1 9.1 0 0 1 4-2.07c.64-.14 1.31-.22 2-.22s1.36.08 2 .22c1.52.35 2.89 1.08 4 2.07.12.12.24.23.36.35A8.95 8.95 0 0 1 61 43c0 2.66-.17 5.33-.5 7.97L60 55l-.01.01c-.5-.46-1.07-.83-1.7-1.1-.3-.13-.62-.24-.94-.32l-.6-.15a3.01 3.01 0 0 1-2.19-2.19l-.21-.84c.44-.23.84-.52 1.19-.87.9-.91 1.46-2.16 1.46-3.54v-2.27c0-.99-.73-1.83-1.72-1.98l-2.31-.33c-.94-.13-1.74-.64-2.27-1.35l-.01.01-.66.16A4.01 4.01 0 0 0 47 44.12V46c0 1.91 1.07 3.57 2.65 4.41l-.21.84a3.01 3.01 0 0 1-2.19 2.19z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#656d78",
  d: "M10.02 40.25c-.97.24-1.77.83-2.31 1.6l-1.66-.83c-.45-.22-.84-.53-1.16-.9A3.73 3.73 0 0 1 4 37.71c0-1.43.81-2.68 2-3.29.51-.27 1.09-.42 1.71-.42h5.54c1.86 0 3.53.75 4.75 1.96l.02.02.84 1.02c1.1 2.88 1.14 3.31 1.14 3.75 0 .83-.13 1.65-.39 2.43a7.7 7.7 0 0 1-2 3.14l-.71.68c.07-.32.1-.66.1-1v-2c0-1.1-.9-2-2-2h-3c-1.01 0-1.86-.76-1.98-1.75"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#656d78",
  d: "M7 44.12V46l-.59-.2a3.6 3.6 0 0 1-1.75-1.28c-.42-.58-.66-1.3-.66-2.06 0-.87.32-1.7.89-2.34.32.37.71.68 1.16.9l1.66.83c-.45.65-.71 1.43-.71 2.27M30.02 40.25A3.99 3.99 0 0 0 27 44.12V46c0 .34.03.68.1 1l-.71-.68a7.7 7.7 0 0 1-2-3.14c-.26-.78-.39-1.6-.39-2.43V40c0-1.09.29-2.12.81-3 .31-.55.72-1.05 1.19-1.47A5.97 5.97 0 0 1 30 34h4c1.54 0 2.94.58 4 1.53.47.42.88.92 1.19 1.47.52.88.81 1.91.81 3v.75c0 .83-.13 1.65-.39 2.43a7.7 7.7 0 0 1-2 3.14l-.71.68c.07-.32.1-.66.1-1v-2c0-1.1-.9-2-2-2h-3c-1.01 0-1.86-.76-1.98-1.75"
}), /*#__PURE__*/React.createElement("path", {
  d: "m61.051 54.652.445-3.558C61.83 48.416 62 45.693 62 43a9.96 9.96 0 0 0-3-7.129V24h-1.423c-.514 0-.959-.366-1.062-.887-.1-.502.172-1.01.646-1.206l1.314-.545-3.062-7.391-1.316.545a1.085 1.085 0 0 1-1.318-.41c-.285-.427-.229-1 .135-1.364l1.005-1.008-5.654-5.655-1.009 1.007a1.089 1.089 0 0 1-1.77-1.191l.544-1.31-7.395-3.062-.539 1.308a1.1 1.1 0 0 1-1.226.649A1.08 1.08 0 0 1 36 2.423V1h-8v1.423c0 .514-.366.959-.887 1.062a1.084 1.084 0 0 1-1.205-.645l-.543-1.316-7.395 3.062.544 1.309a1.09 1.09 0 0 1-.4 1.322 1.09 1.09 0 0 1-1.377-.135l-1.002-1-5.654 5.655 1 1.003c.366.367.423.945.131 1.382a1.08 1.08 0 0 1-1.31.397l-1.316-.545-3.062 7.391 1.303.541c.48.199.755.713.654 1.223A1.085 1.085 0 0 1 6.418 24H5v9.869a4.697 4.697 0 0 0-1.341 6.24 4.516 4.516 0 0 0 2.39 6.624 6 6 0 0 0 2.453 4.132l-.328 1.31-1.768.442a7.13 7.13 0 0 0-3.316 1.877A7.1 7.1 0 0 0 1 59.542V63h62v-3.458a7.08 7.08 0 0 0-1.949-4.89m-45.865-.574 1.431.358-1.365 1.755-1.522-1.142zM12 56.25l2.025 1.519L12 60.372l-2.025-2.603zm6.567-1.064c.333.207.648.444.928.724A5.1 5.1 0 0 1 21 59.542V61h-6.956zM23 59.542a5.1 5.1 0 0 1 1.505-3.633c.28-.28.595-.517.928-.724L29.956 61H23zm3-15.419v.137a6.7 6.7 0 0 1-.657-1.393A6.7 6.7 0 0 1 25 40.752V40c0-2.757 2.243-5 5-5h4c2.757 0 5 2.243 5 5v.752a6.7 6.7 0 0 1-.343 2.115A6.7 6.7 0 0 1 38 44.26V44c0-1.654-1.346-3-3-3h-3a1.001 1.001 0 0 1 0-2h1v-2h-1a3.005 3.005 0 0 0-2.962 2.523 5 5 0 0 0-3.038 4.6m3-11.043a7 7 0 0 0-2 .605V31h2zm8 .605a7 7 0 0 0-2-.605V31h2zm-9 10.438c0-1.068.563-2.029 1.438-2.563A3 3 0 0 0 32 43h3c.552 0 1 .449 1 1v2c0 2.206-1.794 4-4 4s-4-1.794-4-4zm4 12.127 2.025 1.519L32 60.372l-2.025-2.603zm3.253-.06-1.522-1.142 1.456-.971 1.431.358zM32 52c.576 0 1.132-.086 1.66-.239l.199.798L32 53.798l-1.859-1.239.199-.798A6 6 0 0 0 32 52m-3.186 2.078 1.456.97-1.522 1.142-1.365-1.755zm9.753 1.108c.333.207.648.444.928.724A5.1 5.1 0 0 1 41 59.542V61h-6.956zM43 59.542a5.1 5.1 0 0 1 1.505-3.633c.28-.28.595-.517.928-.724L49.956 61H43zM50.155 58h3.69L52 60.372zm5.246-2H48.6l-1.217-1.565.114-.029a3.99 3.99 0 0 0 2.827-2.65c.532.156 1.093.244 1.676.244s1.145-.088 1.678-.243a3.98 3.98 0 0 0 2.825 2.65l.115.029zM52 50c-2.206 0-4-1.794-4-4v-1.877c0-1.379.935-2.576 2.273-2.91l.082-.021a4.43 4.43 0 0 0 2.473 1.222l2.313.331c.49.069.859.495.859.989V46c0 2.206-1.794 4-4 4m8-7c0 2.61-.164 5.25-.488 7.845l-.301 2.405a7.2 7.2 0 0 0-1.617-.633l-.605-.151a2 2 0 0 1-1.454-1.455l-.037-.146A5.99 5.99 0 0 0 58 46v-2.266a3.01 3.01 0 0 0-2.575-2.969l-2.313-.331A2.47 2.47 0 0 1 51 38v-1h-2v1c0 .501.085.987.242 1.442A4.99 4.99 0 0 0 46 44.123V46c0 2.003.99 3.775 2.503 4.866l-.036.146a2 2 0 0 1-1.456 1.455l-.604.151a7.1 7.1 0 0 0-1.618.633l-.301-2.405A64 64 0 0 1 44 43c0-4.411 3.589-8 8-8s8 3.589 8 8M9.444 23.513a3.11 3.11 0 0 0-1.329-3.179l1.574-3.799a3.1 3.1 0 0 0 3.189-1.309 3.1 3.1 0 0 0-.011-3.449l2.908-2.908a3.1 3.1 0 0 0 3.449.01 3.1 3.1 0 0 0 1.309-3.189l3.797-1.573a3.1 3.1 0 0 0 3.186 1.327A3.09 3.09 0 0 0 29.945 3h4.109a3.092 3.092 0 0 0 5.613 1.116l3.799 1.573a3.1 3.1 0 0 0 1.314 3.193 3.09 3.09 0 0 0 3.445-.012l2.905 2.905a3.089 3.089 0 0 0 3.18 4.759l1.573 3.797a3.1 3.1 0 0 0-1.327 3.185 3.09 3.09 0 0 0 2.443 2.429v1.526l-4.167-1.823C51.652 15.146 42.63 7 32 7s-19.652 8.146-20.833 18.648L7 27.471v-1.527a3.09 3.09 0 0 0 2.444-2.431M21 21.346l-7.694 3.366C14.879 15.775 22.776 9 32 9c3.137 0 6.117.791 8.751 2.176L21 14.139zm2-5.485 18-2.7v1.978l-18 2.7zm20-3.284c3.956 2.839 6.815 7.143 7.694 12.135L43 21.346zM7 29.654l14-6.125V37h2V19.861l18-2.7V37h2V23.529l14 6.125v4.699a10 10 0 0 0-2-.892V31h-2v2.051a10 10 0 0 0-2 0V29h-2v4.461a10 10 0 0 0-2 .892V27h-2v8.871A9.97 9.97 0 0 0 42 43c0 2.693.17 5.416.504 8.093l.445 3.558A7.2 7.2 0 0 0 42 55.909a7.1 7.1 0 0 0-1.091-1.414 7.1 7.1 0 0 0-3.316-1.877l-1.768-.442-.328-1.31a6 6 0 0 0 2.298-3.337l.508-.484a8.7 8.7 0 0 0 2.251-3.544A8.7 8.7 0 0 0 41 40.752V40a6.97 6.97 0 0 0-2-4.889V29h-6v4h-2v-4h-6v6.111A6.98 6.98 0 0 0 23 40v.752c0 .937.15 1.862.446 2.747a8.7 8.7 0 0 0 2.25 3.544l.509.485a6 6 0 0 0 2.298 3.337l-.328 1.31-1.768.442a7.13 7.13 0 0 0-3.316 1.877A7.2 7.2 0 0 0 22 55.908a7.1 7.1 0 0 0-1.091-1.414 7.1 7.1 0 0 0-3.316-1.877l-1.768-.442-.328-1.31a6 6 0 0 0 2.298-3.337l.508-.484a8.7 8.7 0 0 0 2.251-3.544A8.7 8.7 0 0 0 21 40.752a7.7 7.7 0 0 0-2-5.179V27h-2v6.973a7.7 7.7 0 0 0-2-.766V29h-2v4h-2v-2H9v2H7.708c-.242 0-.475.036-.708.072zM7.708 35h5.54A5.76 5.76 0 0 1 19 40.752a6.7 6.7 0 0 1-.343 2.115A6.7 6.7 0 0 1 18 44.26V44c0-1.654-1.346-3-3-3h-3a1.001 1.001 0 0 1 0-2h1v-2h-1a3.005 3.005 0 0 0-2.962 2.523 5 5 0 0 0-1.581 1.087l-.96-.48A2.69 2.69 0 0 1 5 37.708 2.71 2.71 0 0 1 7.708 35M5 42.46c0-.28.052-.553.141-.813.149.097.3.191.461.272l.756.378A5 5 0 0 0 6 44.123v.347a2.52 2.52 0 0 1-1-2.01m3 1.663c0-1.068.563-2.029 1.438-2.563A3 3 0 0 0 12 43h3c.552 0 1 .449 1 1v2c0 2.206-1.794 4-4 4s-4-1.794-4-4zM12 52c.576 0 1.132-.086 1.66-.239l.199.798L12 53.798l-1.859-1.239.199-.798A6 6 0 0 0 12 52m-3.186 2.078 1.456.97-1.523 1.142-1.365-1.755zM3 59.542a5.1 5.1 0 0 1 1.505-3.633c.28-.28.595-.517.928-.724L9.956 61H3zM61 61h-6.956l4.523-5.814c.333.207.648.444.928.724A5.1 5.1 0 0 1 61 59.542z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31 21h-6v6h6zm-2 4h-2v-2h2zM39 21h-6v6h6zm-2 4h-2v-2h2z"
}));

const SvgIfcaxContractxIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  id: "ifcax-contractx-icon_svg__Layer_2",
  viewBox: "0 0 1020 1023",
  width: "1em",
  height: "1em"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "ifcax-contractx-icon_svg__drop-shadow-1",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: 8.68,
  dy: 8.68
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "blur",
  stdDeviation: 6.2
}), /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#000",
  floodOpacity: 0.39
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "blur",
  operator: "in"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "SourceGraphic"
})), /*#__PURE__*/React.createElement("style", null, ".ifcax-contractx-icon_svg__cls-3{fill:#faaf22}.ifcax-contractx-icon_svg__cls-4{fill:#231f20}")), /*#__PURE__*/React.createElement("g", {
  id: "ifcax-contractx-icon_svg__Layer_1-2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h1020v1023H0z",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "m420.64 557.89 107.17 33.98c-16.43 59.75-43.75 104.13-81.97 133.12-38.22 29-86.7 43.5-145.45 43.5-72.69 0-132.44-24.83-179.24-74.5-46.81-49.66-70.2-117.56-70.2-203.7 0-91.11 23.53-161.88 70.58-212.29s108.91-75.62 185.59-75.62c66.96 0 121.36 19.79 163.18 59.37 24.89 23.4 43.56 57.01 56.01 100.82L416.9 388.71c-6.48-28.38-19.98-50.78-40.52-67.22-20.54-16.43-45.5-24.65-74.87-24.65-40.58 0-73.5 14.56-98.77 43.69s-37.9 76.31-37.9 141.53c0 69.21 12.45 118.5 37.34 147.87 24.89 29.38 57.25 44.06 97.09 44.06 29.37 0 54.64-9.34 75.8-28.01s36.34-48.04 45.56-88.13Z",
  className: "ifcax-contractx-icon_svg__cls-4",
  style: {
    filter: "url(#ifcax-contractx-icon_svg__drop-shadow-1)"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "m285.22 484.1 134.39-.61L523 559.18l-77.27 45.89zM538.57 674.8l65.55-52.63 193.62 145.75-135.96-.33z",
  className: "ifcax-contractx-icon_svg__cls-3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M273.05 767.93s220.42-240.28 669.5-353.86c0 0-321.26 115.36-519.81 353.86z",
  className: "ifcax-contractx-icon_svg__cls-3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M361.17 733.83c0-5.79 1.43-11.4 4.28-16.83 2.86-5.42 6.9-9.56 12.14-12.42s11.08-4.28 17.54-4.28c9.97 0 18.15 3.24 24.52 9.72s9.56 14.66 9.56 24.56-3.22 18.24-9.66 24.8-14.54 9.84-24.31 9.84c-6.04 0-11.81-1.37-17.29-4.1s-9.65-6.74-12.51-12.01c-2.86-5.28-4.28-11.7-4.28-19.28Zm17.88.93c0 6.54 1.55 11.55 4.66 15.03q4.65 5.22 11.49 5.22c6.84 0 8.37-1.74 11.46-5.22 3.08-3.48 4.63-8.53 4.63-15.15s-1.54-11.42-4.63-14.9q-4.62-5.22-11.46-5.22c-6.84 0-8.38 1.74-11.49 5.22-3.1 3.48-4.66 8.49-4.66 15.03ZM528.28 767.73h-17.45v-33.65c0-7.12-.37-11.72-1.12-13.81-.74-2.09-1.96-3.71-3.63-4.87-1.68-1.16-3.69-1.74-6.05-1.74-3.02 0-5.73.83-8.13 2.48-2.4 1.66-4.05 3.85-4.94 6.58s-1.33 7.78-1.33 15.15v29.86h-17.45v-65.94h16.21v9.69c5.75-7.45 13-11.18 21.73-11.18 3.85 0 7.37.69 10.55 2.08q4.785 2.085 7.23 5.31c1.63 2.15 2.77 4.59 3.42 7.33q.96 4.095.96 11.73zM601.64 701.79v13.91h-11.92v26.57c0 5.38.11 8.52.34 9.41s.75 1.62 1.55 2.2c.81.58 1.79.87 2.95.87q2.415 0 7.02-1.68l1.49 13.54c-4.06 1.74-8.65 2.61-13.78 2.61-3.15 0-5.98-.53-8.51-1.58-2.53-1.06-4.38-2.42-5.56-4.1s-2-3.94-2.45-6.8c-.37-2.03-.56-6.13-.56-12.29V715.7h-8.01v-13.91h8.01v-13.1l17.51-10.18v23.28zM655.88 767.73h-17.45v-65.94h16.21v9.38c2.77-4.43 5.27-7.35 7.48-8.75 2.21-1.41 4.73-2.11 7.54-2.11 3.97 0 7.8 1.1 11.49 3.29l-5.4 15.21c-2.94-1.9-5.67-2.86-8.2-2.86s-4.51.67-6.21 2.02-3.03 3.78-4 7.3-1.46 10.89-1.46 22.1zM727.14 721.91l-15.83-2.86c1.78-6.37 4.84-11.09 9.19-14.16 4.35-3.06 10.8-4.59 19.37-4.59 7.78 0 13.58.92 17.38 2.76q5.715 2.76 8.04 7.02c1.55 2.84 2.33 8.04 2.33 15.61l-.19 20.36c0 5.8.28 10.07.84 12.82s1.6 5.7 3.13 8.85h-17.26c-.46-1.16-1.01-2.88-1.68-5.15-.29-1.03-.5-1.72-.62-2.05-2.98 2.9-6.17 5.07-9.56 6.52s-7.02 2.17-10.87 2.17c-6.79 0-12.14-1.84-16.05-5.53-3.91-3.68-5.87-8.34-5.87-13.97 0-3.73.89-7.05 2.67-9.97s4.27-5.15 7.48-6.71c3.21-1.55 7.83-2.91 13.88-4.07 8.15-1.53 13.8-2.96 16.95-4.28v-1.74c0-3.35-.83-5.74-2.48-7.17-1.66-1.43-4.78-2.14-9.38-2.14-3.1 0-5.53.61-7.26 1.83-1.74 1.22-3.15 3.36-4.22 6.43Zm23.35 14.16c-2.24.75-5.77 1.64-10.62 2.67-4.84 1.04-8.01 2.05-9.5 3.04-2.28 1.61-3.41 3.66-3.41 6.15s.91 4.55 2.73 6.33 4.14 2.67 6.95 2.67c3.14 0 6.15-1.03 9-3.1 2.11-1.57 3.5-3.5 4.16-5.77.46-1.49.68-4.32.68-8.51v-3.48ZM867.74 721.29l-17.2 3.1c-.58-3.44-1.89-6.02-3.94-7.76s-4.71-2.61-7.98-2.61c-4.35 0-7.81 1.5-10.4 4.5s-3.88 8.02-3.88 15.06c0 7.82 1.31 13.35 3.94 16.58s6.16 4.84 10.59 4.84c3.31 0 6.02-.94 8.13-2.83q3.165-2.82 4.47-9.72l17.14 2.92c-1.78 7.86-5.19 13.8-10.24 17.82s-11.82 6.02-20.3 6.02c-9.65 0-17.33-3.04-23.07-9.13-5.73-6.08-8.6-14.51-8.6-25.27s2.88-19.36 8.63-25.42 13.54-9.1 23.35-9.1c8.03 0 14.41 1.73 19.15 5.18 4.74 3.46 8.14 8.72 10.21 15.8ZM936.63 701.79v13.91h-11.92v26.57c0 5.38.11 8.52.34 9.41s.75 1.62 1.55 2.2c.81.58 1.79.87 2.95.87q2.415 0 7.02-1.68l1.49 13.54c-4.06 1.74-8.65 2.61-13.78 2.61-3.15 0-5.98-.53-8.51-1.58-2.53-1.06-4.38-2.42-5.56-4.1s-2-3.94-2.45-6.8c-.37-2.03-.56-6.13-.56-12.29V715.7h-8.01v-13.91h8.01v-13.1l17.51-10.18v23.28z",
  className: "ifcax-contractx-icon_svg__cls-4"
})));

const SvgIfcaxCrosshair = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 5
}), /*#__PURE__*/React.createElement("path", {
  d: "M23 11h-1.051c-.47-4.717-4.232-8.479-8.949-8.949V1a1 1 0 1 0-2 0v1.051C6.283 2.521 2.521 6.283 2.051 11H1a1 1 0 1 0 0 2h1.051c.471 4.717 4.232 8.479 8.949 8.949V23a1 1 0 1 0 2 0v-1.051c4.717-.471 8.479-4.232 8.949-8.949H23a1 1 0 1 0 0-2m-10.014 8.933C12.95 19.414 12.529 19 12 19s-.95.414-.986.933a8.01 8.01 0 0 1-6.946-6.946C4.587 12.95 5 12.528 5 12s-.413-.95-.933-.986a8.01 8.01 0 0 1 6.946-6.946c.037.518.458.932.987.932s.95-.414.986-.933a8.01 8.01 0 0 1 6.946 6.946c-.519.037-.932.459-.932.987s.413.95.933.986a8.01 8.01 0 0 1-6.947 6.947"
}));

const SvgIfcaxCustomerAccount = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 20 20"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 66520"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h20v20H0z",
  "data-name": "Rectangle 27533"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#38d39a",
  d: "M5.015 5.323a5.33 5.33 0 0 0-.813-2.567.439.439 0 0 1 .384-.677 3.7 3.7 0 0 1 1.429.367.8.8 0 0 0 .713 0 3.7 3.7 0 0 1 1.434-.369.439.439 0 0 1 .384.677 5.33 5.33 0 0 0-.813 2.567Z",
  "data-name": "Path 82002"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#38d39a",
  d: "M10.773 9.247c0 2.431-1.971 3.009-4.4 3.009s-4.4-.582-4.4-3.009a4.79 4.79 0 0 1 4.4-4.4 4.79 4.79 0 0 1 4.4 4.4",
  "data-name": "Path 82003"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00c072",
  d: "M8.833 5.759 4.701 9.891a2.77 2.77 0 0 0-.816 1.969v.077a8 8 0 0 0 2.488.32c2.431 0 4.4-.578 4.4-3.009a4.48 4.48 0 0 0-1.94-3.489",
  "data-name": "Path 82004"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f5c956",
  d: "M6.375 5.599a16 16 0 0 1-1.976-.155.671.671 0 0 1 .172-1.331 11.4 11.4 0 0 0 3.609 0 .671.671 0 0 1 .172 1.331 16 16 0 0 1-1.977.155",
  "data-name": "Path 82005"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5972a4",
  d: "m17.705 9.983-4.58-4.58a1.64 1.64 0 0 0-1.313-.474c-3.192 3.476-3.587 10.809 1.879 11.39l4.014-4.014a1.643 1.643 0 0 0 0-2.322",
  "data-name": "Path 82006"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3b5a9a",
  d: "M11.812 4.93a1.64 1.64 0 0 0-1.01.474l-5.294 5.294a1.643 1.643 0 0 0 0 2.323l4.58 4.58a1.643 1.643 0 0 0 2.323 0l1.281-1.281c-3.553-1.446-3.491-6.83-1.88-11.39",
  "data-name": "Path 82007"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#d3d3ff",
  d: "m9.222 13.157.256.256a.49.49 0 0 1 0 .694l-.256.256a.49.49 0 0 1-.694 0l-.256-.256a.49.49 0 0 1 0-.694l.256-.256a.49.49 0 0 1 .694 0",
  "data-name": "Path 82008"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#d3d3ff",
  d: "m7.321 11.257.256.256a.49.49 0 0 1 0 .694l-.256.256a.49.49 0 0 1-.694 0l-.256-.256a.49.49 0 0 1 0-.694l.256-.256a.49.49 0 0 1 .694 0",
  "data-name": "Path 82009"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#eeecff",
  d: "m11.378 11.512-.256-.256a.5.5 0 0 0-.357-.143 1.19 1.19 0 0 0 .171 1.465.5.5 0 0 0 .186-.116l.256-.256a.49.49 0 0 0 0-.694",
  "data-name": "Path 82010"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#d3d3ff",
  d: "M10.427 12.462a.49.49 0 0 0 .508.116 9.6 9.6 0 0 1-.171-1.465.5.5 0 0 0-.338.143l-.256.256a.49.49 0 0 0 0 .694Z",
  "data-name": "Path 82011"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#d3d3ff",
  d: "m9.222 9.356.256.256a.49.49 0 0 1 0 .694l-.256.256a.49.49 0 0 1-.694 0l-.256-.256a.49.49 0 0 1 0-.694l.256-.256a.49.49 0 0 1 .694 0",
  "data-name": "Path 82012"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ff6e80",
  d: "m13.753 13.888-.731-.731a.49.49 0 0 0-.694 0l-.917.917c-.1 1.08.3 1.623 1.227 1.623l1.116-1.116a.49.49 0 0 0-.001-.693",
  "data-name": "Path 82013"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f8475e",
  d: "m11.411 14.074-1.239 1.239a.49.49 0 0 0 0 .695l.731.731a.49.49 0 0 0 .694 0l1.04-1.04a4.5 4.5 0 0 1-1.226-1.625",
  "data-name": "Path 82014"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#38d39a",
  d: "m16.842 10.797-4.531-4.531a.49.49 0 0 0-.694 0l-.308.308a2.96 2.96 0 0 0-.467 2.5l3.861 3.861a.49.49 0 0 0 .694 0l1.445-1.445a.49.49 0 0 0 0-.693",
  "data-name": "Path 82015"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00c072",
  d: "M10.842 9.076a18 18 0 0 1 .467-2.5l-1.138 1.138a.49.49 0 0 0 0 .695Z",
  "data-name": "Path 82016"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#425460",
  "data-name": "Group 66323"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.079 8.398a.237.237 0 0 1-.168-.405l.277-.277a.238.238 0 1 1 .336.336l-.277.277a.24.24 0 0 1-.168.069",
  "data-name": "Path 82017"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.96 11.276a.237.237 0 0 1-.168-.405l.277-.277a.238.238 0 0 1 .336.336l-.277.277a.24.24 0 0 1-.168.069",
  "data-name": "Path 82018"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.858 10.209a.95.95 0 0 1-.947-1.015.238.238 0 0 1 .474.033.474.474 0 0 0 .506.506.238.238 0 0 1 .033.474Z",
  "data-name": "Path 82019"
}))));

const SvgIfcaxCxIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  id: "ifcax-cx-icon_svg__Layer_2",
  viewBox: "0 0 232.21 231.04",
  width: "1em",
  height: "1em"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "ifcax-cx-icon_svg__drop-shadow-1",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: 2,
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "blur",
  stdDeviation: 5
}), /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#000",
  floodOpacity: 0.39
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "blur",
  operator: "in"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "SourceGraphic"
})), /*#__PURE__*/React.createElement("style", null, ".ifcax-cx-icon_svg__cls-1{fill:#fff}.ifcax-cx-icon_svg__cls-5{opacity:.27}")), /*#__PURE__*/React.createElement("g", {
  id: "ifcax-cx-icon_svg__Layer_1-2"
}, /*#__PURE__*/React.createElement("rect", {
  width: 231.04,
  height: 231.04,
  x: 0.96,
  rx: 57.76,
  ry: 57.76,
  style: {
    fill: "#f9ae21"
  }
}), /*#__PURE__*/React.createElement("g", {
  className: "ifcax-cx-icon_svg__cls-5"
}, /*#__PURE__*/React.createElement("path", {
  d: "m26.69 24.2 7.68-.03 5.9 4.32-4.41 2.61zM41.15 35.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-cx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26 40.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM96.69 24.2l7.68-.03 5.9 4.32-4.41 2.61zM111.15 35.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-cx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M96 40.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM169.69 24.2l7.68-.03 5.9 4.32-4.41 2.61zM184.15 35.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-cx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M169 40.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2z",
  className: "ifcax-cx-icon_svg__cls-1"
})), /*#__PURE__*/React.createElement("g", {
  className: "ifcax-cx-icon_svg__cls-5"
}, /*#__PURE__*/React.createElement("path", {
  d: "m26.69 109.2 7.68-.03 5.9 4.32-4.41 2.61zM41.15 120.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-cx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26 125.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM96.69 109.2l7.68-.03 5.9 4.32-4.41 2.61zM111.15 120.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-cx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M96 125.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM169.69 109.2l7.68-.03 5.9 4.32-4.41 2.61zM184.15 120.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-cx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M169 125.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2z",
  className: "ifcax-cx-icon_svg__cls-1"
})), /*#__PURE__*/React.createElement("g", {
  className: "ifcax-cx-icon_svg__cls-5"
}, /*#__PURE__*/React.createElement("path", {
  d: "m26.69 198.2 7.68-.03 5.9 4.32-4.41 2.61zM41.15 209.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-cx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26 214.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM96.69 198.2l7.68-.03 5.9 4.32-4.41 2.61zM111.15 209.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-cx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M96 214.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM169.69 198.2l7.68-.03 5.9 4.32-4.41 2.61zM184.15 209.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-cx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M169 214.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2z",
  className: "ifcax-cx-icon_svg__cls-1"
})), /*#__PURE__*/React.createElement("g", {
  className: "ifcax-cx-icon_svg__cls-5"
}, /*#__PURE__*/React.createElement("path", {
  d: "m62.69 153.2 7.68-.03 5.9 4.32-4.41 2.61zM77.15 164.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-cx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M62 169.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM.69 153.2l7.68-.03 5.9 4.32-4.41 2.61zM15.15 164.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-cx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 169.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM130.69 153.2l7.68-.03 5.9 4.32-4.41 2.61zM145.15 164.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-cx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M130 169.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM194.69 153.2l7.68-.03 5.9 4.32-4.41 2.61zM209.15 164.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-cx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M194 169.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2z",
  className: "ifcax-cx-icon_svg__cls-1"
})), /*#__PURE__*/React.createElement("g", {
  className: "ifcax-cx-icon_svg__cls-5"
}, /*#__PURE__*/React.createElement("path", {
  d: "m62.69 66.2 7.68-.03 5.9 4.32-4.41 2.61zM77.15 77.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-cx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M62 82.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM.69 66.2l7.68-.03 5.9 4.32-4.41 2.61zM15.15 77.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-cx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 82.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM130.69 66.2l7.68-.03 5.9 4.32-4.41 2.61zM145.15 77.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-cx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M130 82.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM194.69 66.2l7.68-.03 5.9 4.32-4.41 2.61zM209.15 77.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-cx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M194 82.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2z",
  className: "ifcax-cx-icon_svg__cls-1"
})), /*#__PURE__*/React.createElement("g", {
  style: {
    filter: "url(#ifcax-cx-icon_svg__drop-shadow-1)"
  }
}, /*#__PURE__*/React.createElement("path", {
  d: "m99.17 130.02 25.95 8.23c-3.98 14.47-10.6 25.22-19.85 32.24-9.26 7.02-21 10.54-35.22 10.54-17.6 0-32.07-6.01-43.41-18.04s-17-28.47-17-49.33c0-22.07 5.7-39.2 17.09-51.41S53.1 43.94 71.67 43.94c16.22 0 29.39 4.79 39.52 14.38q9.045 8.505 13.56 24.42l-26.5 6.33c-1.57-6.87-4.84-12.3-9.81-16.28s-11.02-5.97-18.13-5.97c-9.83 0-17.8 3.53-23.92 10.58s-9.18 18.48-9.18 34.27c0 16.76 3.01 28.7 9.04 35.81s13.87 10.67 23.51 10.67q10.665 0 18.36-6.78c5.12-4.52 8.8-11.63 11.03-21.34Z",
  style: {
    fill: "#231f20"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "m54.92 107.2 34.89-.16 26.84 19.65-20.06 11.92zM120.69 156.71l17.02-13.67 50.26 37.84-35.29-.08z",
  className: "ifcax-cx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M51.76 180.88s57.22-62.38 173.8-91.86c0 0-83.4 29.95-134.94 91.86z",
  className: "ifcax-cx-icon_svg__cls-1"
})));

const SvgIfcaxDemoVideo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 30 30"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 66564"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 -1)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#2d393f",
  d: "m17.886 24.608-.43-2.576h-5.152l-.429 2.576Z",
  "data-name": "Path 81641"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#909fa3",
  d: "M27.76 6.147A2.147 2.147 0 0 0 25.614 4H4.147A2.147 2.147 0 0 0 2 6.147v13.738a2.147 2.147 0 0 0 2.147 2.147h21.467a2.147 2.147 0 0 0 2.147-2.147Z",
  "data-name": "Path 81642"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#86def2",
  d: "M3.717 18.597V5.717h22.326v12.88",
  "data-name": "Path 81643"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#a4ebf7",
  d: "M5.005 15.162a2.147 2.147 0 0 0 2.147 2.147h18.891V5.717H5.005Z",
  "data-name": "Path 81644"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5a6a72",
  d: "M18.315 24.608h-6.869a.859.859 0 1 0 0 1.717h6.869a.859.859 0 0 0 0-1.717",
  "data-name": "Path 81645"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#1f9fcc",
  "data-name": "Group 65996",
  transform: "translate(5.435 7.435)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 2,
  cy: 2,
  r: 2,
  "data-name": "Ellipse 2000",
  transform: "translate(1.565 .565)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1,
  cy: 1,
  r: 1,
  "data-name": "Ellipse 2001",
  transform: "translate(16.565 6.565)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.315 11.162V9.445a1.288 1.288 0 0 1 2.576 0v1.717",
  "data-name": "Path 81646"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1,
  cy: 1,
  r: 1,
  "data-name": "Ellipse 2002",
  transform: "translate(16.565 -.435)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.315 4.722V3.005a1.288 1.288 0 1 1 2.576 0v1.717",
  "data-name": "Path 81647"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1,
  cy: 1,
  r: 1,
  "data-name": "Ellipse 2003",
  transform: "translate(10.565 -.435)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.304 4.722V3.005a1.288 1.288 0 0 1 2.576 0v1.717",
  "data-name": "Path 81648"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1,
  cy: 1,
  r: 1,
  "data-name": "Ellipse 2004",
  transform: "translate(10.565 6.565)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.304 11.162V9.445a1.288 1.288 0 0 1 2.576 0v1.717",
  "data-name": "Path 81649"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 8.586v-.859a3.435 3.435 0 0 1 6.869 0v.859Z",
  "data-name": "Path 81650"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#43525b",
  d: "M2 19.885a2.147 2.147 0 0 0 2.147 2.147h21.467a2.147 2.147 0 0 0 2.147-2.147v-1.288H2Z",
  "data-name": "Path 81651"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M26.043 11.728h-5.582V5.717h-.859v6.011h-5.151V5.717h-.859v12.88h.859v-6.011h5.152v6.011h.859v-6.011h5.581Z",
  "data-name": "Path 81652"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 6.5,
  cy: 6.5,
  r: 6.5,
  fill: "#dd4334",
  "data-name": "Ellipse 2005",
  transform: "translate(15 15)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#df573d",
  d: "M21.32 15.163a6.4 6.4 0 0 0-4.1 1.477 6.44 6.44 0 0 0 9.067 9.067 6.44 6.44 0 0 0-4.967-10.544",
  "data-name": "Path 81653"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M19.174 18.597v6.011l5.152-3.005Z",
  "data-name": "Path 81654"
})), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h30v30H0z",
  "data-name": "Rectangle 26197"
})));

const SvgIfcaxDocuments = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  width: "1em",
  height: "1em",
  viewBox: "0 0 682.667 682.667"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "ifcax-documents_svg__a",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 512h512V0H0Z"
}))), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#ifcax-documents_svg__a)",
  transform: "matrix(1.33333 0 0 -1.33333 0 682.667)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h-257.242c-11.046 0-20 8.954-20 20v369.346h-33.149c-12.102 0-21.913-9.811-21.913-21.914V-24.383c0-12.102 9.811-21.913 21.913-21.913h288.477C-9.811-46.296 0-36.485 0-24.383Z",
  style: {
    fill: "#8ac9fe",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(387.09 53.796)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-369.346c0-11.046 8.954-20 20-20h257.242v-24.383c0-4.268-1.224-8.248-3.335-11.617H1.914c-12.103 0-21.914 9.811-21.914 21.914v16l10 375.815z",
  style: {
    fill: "#60b8fe",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(109.848 443.142)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h-257.242c-11.046 0-20 8.955-20 20v360.581h-33.148c-12.103 0-21.914-9.811-21.914-21.914V-33.148c0-12.102 9.811-21.914 21.914-21.914h288.476C-9.811-55.062 0-45.25 0-33.148Z",
  style: {
    fill: "#fed402",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(422.152 88.858)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-360.581c0-11.045 8.954-20 20-20h257.242v-33.148c0-1.783-.218-3.515-.62-5.175H1.914c-12.103 0-21.914 9.811-21.914 21.914v18.323l10 27.666V-5.175Z",
  style: {
    fill: "#fac600",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(144.91 469.438)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h-286.477c-12.103 0-21.914 9.811-21.914 21.914v391.815c0 12.102 9.811 21.913 21.914 21.913h221.616l86.775-88.774V21.914C21.914 9.811 12.103 0 0 0",
  style: {
    fill: "#efedef",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(433.3 68.858)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-354.954c0-12.103-9.811-21.914-21.914-21.914h30c12.103 0 21.914 9.811 21.914 21.914V-30Z",
  style: {
    fill: "#d7d0d6",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(427.214 445.726)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h-66.864c-12.101 0-21.91 9.81-21.91 21.91v66.864z",
  style: {
    fill: "#b5adb6",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(457.214 415.726)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h-66.864c-12.101 0-21.91 9.81-21.91 21.91v66.864z",
  style: {
    fill: "none",
    stroke: "#000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(457.214 415.726)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h200.156",
  style: {
    fill: "none",
    stroke: "#000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(190.984 342.267)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h200.156",
  style: {
    fill: "none",
    stroke: "#000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(190.984 286.68)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h200.156",
  style: {
    fill: "none",
    stroke: "#000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(190.984 231.091)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h64.997C77.099 0 86.91 9.811 86.91 21.914v13.148",
  style: {
    fill: "none",
    stroke: "#000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(335.242 33.796)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h-13.148C-25.25 0-35.062-9.811-35.062-21.914v-391.815c0-12.102 9.812-21.913 21.914-21.913h190.794",
  style: {
    fill: "none",
    stroke: "#000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(124.91 469.438)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v-107.018c0-12.103 9.811-21.914 21.914-21.914h288.477c12.102 0 21.913 9.811 21.913 21.914v4.383",
  style: {
    fill: "none",
    stroke: "#000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(54.786 136.432)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h-13.148c-12.103 0-21.914-9.811-21.914-21.914v-252.11",
  style: {
    fill: "none",
    stroke: "#000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(89.848 443.142)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v61.501c0 12.103 9.811 21.914 21.914 21.914H243.53l88.774-88.774v-324.954c0-12.103-9.811-21.914-21.913-21.914H21.914C9.811-352.227 0-342.416 0-330.313v297.627",
  style: {
    fill: "none",
    stroke: "#000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: 1
  },
  transform: "translate(124.91 421.085)"
})));

const SvgIfcaxEnhancement = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 597.979 597.979",
  width: "1em",
  height: "1em"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M435.856 243.239h20.265v60.796h-20.265zM435.856.054h20.265V60.85h-20.265zM537.183 141.912h60.796v20.265h-60.796zM293.998 141.912h60.796v20.265h-60.796z",
  style: {
    fill: "#e34b87"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M501.565 55.944h60.796v20.265h-60.796z",
  style: {
    fill: "#e34b87"
  },
  transform: "rotate(-45.001 531.965 66.084)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M349.885 35.688h20.265v60.796h-20.265z",
  style: {
    fill: "#e34b87"
  },
  transform: "rotate(-45.001 360.018 66.09)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M521.836 207.663h20.265v60.796h-20.265z",
  style: {
    fill: "#e34b87"
  },
  transform: "rotate(-45.001 531.969 238.069)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-52.043 373.997h494.37v57.573h-494.37z",
  style: {
    fill: "#4398d1"
  },
  transform: "rotate(-45.001 195.138 402.788)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M350.053 151.065h136.273v57.578H350.053z",
  style: {
    fill: "#c1c7c9"
  },
  transform: "rotate(-44.988 418.164 179.842)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m20.415 577.618 20.266 20.265L390.33 248.376l-20.336-20.336z",
  style: {
    fill: "#3e8cc7"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M360.213 175.656h136.263v28.777H360.213z",
  style: {
    fill: "#b8bdbf"
  },
  transform: "rotate(-45.001 428.345 190.05)"
}));

const SvgIfcaxFaqs = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 512 512"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#2e4c89",
  d: "M512 256c0 57.902-19.223 111.314-51.635 154.203-5.234 6.926-16.791 7.932-22.687 14.284-6.045 6.511-6.446 18.352-13.133 24.206C379.515 488.111 320.547 512 256 512c-69.328 0-132.22-27.559-178.318-72.319-4.706-4.569-4.134-11.789-8.479-16.706s-13.606-7.53-17.568-12.772C19.223 367.314 0 313.902 0 256 0 114.615 114.615 0 256 0s256 114.615 256 256"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#37c47a",
  d: "M438.574 0H73.427c-12.03 0-21.782 9.752-21.782 21.781v149.746c0 12.029 9.752 21.781 21.781 21.781v19.266c0 1.397 1.689 2.096 2.677 1.109l20.375-20.375h342.095c12.029 0 21.781-9.752 21.781-21.781V21.781C460.355 9.752 450.603 0 438.574 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#02af8e",
  d: "M95.208 171.527V21.781C95.208 9.752 104.959 0 116.989 0H73.426C61.397 0 51.645 9.752 51.645 21.781v149.746c0 12.029 9.752 21.781 21.781 21.781v19.726c0 1.227 1.484 1.842 2.352.974l20.7-20.7h20.511c-12.03.001-21.781-9.751-21.781-21.781"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M416.792 104.154H373.76c-4.142 0-7.5-3.357-7.5-7.5s3.358-7.5 7.5-7.5h43.033a7.5 7.5 0 1 1-.001 15M343.76 104.154h-99.177c-4.142 0-7.5-3.357-7.5-7.5s3.358-7.5 7.5-7.5h99.177c4.142 0 7.5 3.357 7.5 7.5s-3.358 7.5-7.5 7.5M373.76 158.607H244.583c-4.142 0-7.5-3.357-7.5-7.5s3.358-7.5 7.5-7.5H373.76c4.142 0 7.5 3.357 7.5 7.5s-3.358 7.5-7.5 7.5M416.792 49.701h-172.21c-4.142 0-7.5-3.357-7.5-7.5s3.358-7.5 7.5-7.5h172.21c4.142 0 7.5 3.357 7.5 7.5s-3.357 7.5-7.5 7.5"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#52bbef",
  d: "M460.355 268.142c0-12.029-9.752-21.781-21.781-21.781H73.427c-12.029 0-21.781 9.752-21.781 21.781v142.054a257 257 0 0 0 26.049 29.473h337.828l9.015 9.015a257.4 257.4 0 0 0 35.818-38.488z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1e99d6",
  d: "M116.989 246.36H73.427c-12.029 0-21.781 9.752-21.781 21.781v142.054a257 257 0 0 0 26.049 29.473h39.295c-12.029 0-21.781-9.752-21.781-21.781V268.142c-.001-12.03 9.751-21.782 21.78-21.782"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M290.809 350.515H95.256c-4.142 0-7.5-3.357-7.5-7.5s3.358-7.5 7.5-7.5h195.553c4.142 0 7.5 3.357 7.5 7.5s-3.358 7.5-7.5 7.5M290.809 404.968H138.288c-4.142 0-7.5-3.357-7.5-7.5s3.358-7.5 7.5-7.5h152.521c4.142 0 7.5 3.357 7.5 7.5s-3.358 7.5-7.5 7.5M290.809 296.062H183.667c-4.142 0-7.5-3.357-7.5-7.5s3.358-7.5 7.5-7.5h107.142c4.142 0 7.5 3.357 7.5 7.5s-3.358 7.5-7.5 7.5M153.667 296.062H95.256c-4.142 0-7.5-3.357-7.5-7.5s3.358-7.5 7.5-7.5h58.411c4.142 0 7.5 3.357 7.5 7.5s-3.358 7.5-7.5 7.5M204.583 158.167a7.48 7.48 0 0 1-5.303-2.196l-34.84-34.84a7.5 7.5 0 0 1 10.606-10.607l34.84 34.84a7.5 7.5 0 0 1-5.303 12.803"
}), /*#__PURE__*/React.createElement("path", {
  d: "M149.709 158.607c-34.161 0-61.953-27.792-61.953-61.953s27.792-61.953 61.953-61.953 61.953 27.792 61.953 61.953-27.792 61.953-61.953 61.953m0-108.906c-25.89 0-46.953 21.063-46.953 46.953s21.063 46.953 46.953 46.953 46.953-21.063 46.953-46.953-21.063-46.953-46.953-46.953M330.807 404.97a7.5 7.5 0 0 1-7.007-10.171l40.894-107.372q.032-.086.067-.17a9.93 9.93 0 0 1 9.216-6.195h.011a9.93 9.93 0 0 1 9.218 6.176q.042.102.082.205L423.81 394.82a7.5 7.5 0 0 1-14.034 5.297l-35.81-94.89-36.148 94.91a7.5 7.5 0 0 1-7.011 4.833"
}), /*#__PURE__*/React.createElement("path", {
  d: "M404.245 378.227h-60.683c-4.142 0-7.5-3.357-7.5-7.5s3.358-7.5 7.5-7.5h60.683c4.142 0 7.5 3.357 7.5 7.5s-3.358 7.5-7.5 7.5"
})));

const SvgIfcaxFile = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 30 30"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 24797"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h30v30H0z",
  "data-name": "Rectangle 6520"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 9159"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#002672",
  "data-name": "Group 9158"
}, /*#__PURE__*/React.createElement("path", {
  d: "M25.902 3.396h-.877v21.551a2.6 2.6 0 0 1-2.6 2.6H6.472v.8a1.66 1.66 0 0 0 1.657 1.649h17.77a1.66 1.66 0 0 0 1.657-1.657V5.049a1.655 1.655 0 0 0-1.654-1.653",
  "data-name": "Path 12279"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.54 26.6h8.885a1.66 1.66 0 0 0 1.657-1.657V1.657A1.66 1.66 0 0 0 22.425 0H10.586v.548a2 2 0 0 1 .009.175v4.54A2.336 2.336 0 0 1 8.261 7.6h-4.54c-.047 0-.1 0-.144-.006h-.576v17.353A1.66 1.66 0 0 0 4.658 26.6zm.335-5.633H8.082a.783.783 0 1 1 0-1.566h5.8a.783.783 0 1 1 0 1.566Zm5.8-4H8.082a.783.783 0 1 1 0-1.566h11.589a.783.783 0 1 1 0 1.566ZM8.082 11.162h11.589a.783.783 0 1 1 0 1.566H8.082a.783.783 0 0 1 0-1.566",
  "data-name": "Path 12280"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.721 6.657h4.554a1.39 1.39 0 0 0 1.378-1.378V.725a.7.7 0 0 0-.7-.7.68.68 0 0 0-.489.207L3.226 5.467a.7.7 0 0 0 .495 1.19",
  "data-name": "Path 12281"
})))));

const SvgIfcaxFire = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 14 14"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h14v14H0z",
  "data-name": "Rectangle 27721"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "fire"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#ff641a",
  d: "M10.453 8.581a3.9 3.9 0 0 0-.254-1.171l-.006-.016c-.008-.02-.805-1.964-.432-3.032a.308.308 0 0 0-.3-.409 2.07 2.07 0 0 0-1.176.552 6.8 6.8 0 0 1-.6-2.214.308.308 0 0 0-.466-.243 5.5 5.5 0 0 0-1.875 1.789 4.4 4.4 0 0 0-.633 1.84 5 5 0 0 0 0 1.064.187.187 0 0 1-.257.194l-.792-.324a.3.3 0 0 0-.171-.022.31.31 0 0 0-.248.219 7 7 0 0 0-.165.707 4.86 4.86 0 0 0 .16 2.326 4.06 4.06 0 0 0 1.2 1.843 3.45 3.45 0 0 0 2.282.831 4.5 4.5 0 0 0 1.466-.258 3.21 3.21 0 0 0 1.827-1.566 4.03 4.03 0 0 0 .442-2.106Z",
  "data-name": "Path 81450"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ff001e",
  d: "M10.453 8.578a3.9 3.9 0 0 0-.254-1.171l-.006-.016c-.008-.02-.805-1.964-.432-3.032a.308.308 0 0 0-.3-.409 1.97 1.97 0 0 0-.979.395.2.2 0 0 1-.307-.086 7 7 0 0 1-.49-1.971.308.308 0 0 0-.466-.243q-.244.147-.466.308V12.51a4.5 4.5 0 0 0 1.436-.257 3.21 3.21 0 0 0 1.827-1.566 4.03 4.03 0 0 0 .442-2.106Z",
  "data-name": "Path 81451"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffeb00",
  d: "M7.563 7.337A.308.308 0 0 0 7 7.531c.037.492-.012 1.939-.7 2.127a.97.97 0 0 1-.924-.138.3.3 0 0 0-.3-.087.31.31 0 0 0-.222.223 5 5 0 0 0-.079.34 2.24 2.24 0 0 0 .689 2.089 1.76 1.76 0 0 0 1.164.426 2.3 2.3 0 0 0 .736-.129 1.9 1.9 0 0 0 1-.851 2.3 2.3 0 0 0 .335-1.118 5.45 5.45 0 0 0-1.136-3.076",
  "data-name": "Path 81452"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fb0",
  d: "M7.208 7.218a.31.31 0 0 0-.207.314 3.84 3.84 0 0 1-.253 1.708v3.268a2.3 2.3 0 0 0 .625-.126 1.9 1.9 0 0 0 1-.851 2.3 2.3 0 0 0 .335-1.118A5.45 5.45 0 0 0 7.56 7.338a.31.31 0 0 0-.352-.12",
  "data-name": "Path 81453"
})));

const SvgIfcaxGeneralLedger = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: "1em",
  height: "1em",
  viewBox: "0 0 80 80"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "ifcax-general-ledger_svg__e",
  x1: -1.906,
  x2: -0.874,
  y1: -0.628,
  y2: -0.628,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#0045ff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#0003c1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ifcax-general-ledger_svg__f",
  x1: -0.292,
  x2: -0.053,
  y1: 0.414,
  y2: 0.922,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#00c0ff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5558ff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ifcax-general-ledger_svg__a",
  x1: 1.24,
  x2: 0.83,
  y1: 0.048,
  y2: 0.282,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fcb148"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.052,
  stopColor: "#fdb946"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.142,
  stopColor: "#fec144"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.318,
  stopColor: "#ffc444"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.485,
  stopColor: "#fdb946"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.775,
  stopColor: "#f99c4c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.866,
  stopColor: "#f8924f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f8924f"
})), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#ifcax-general-ledger_svg__a",
  id: "ifcax-general-ledger_svg__g",
  x1: 2.456,
  x2: -1.336,
  y1: -0.159,
  y2: 1.099
}), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#ifcax-general-ledger_svg__a",
  id: "ifcax-general-ledger_svg__h",
  x1: 0.83,
  x2: -0.216,
  y1: 0.089,
  y2: 1.419
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ifcax-general-ledger_svg__i",
  x1: 1.217,
  x2: -0.928,
  y1: 0.249,
  y2: 1.029,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f57e53"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.005,
  stopColor: "#f58152"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.042,
  stopColor: "#f8994d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.084,
  stopColor: "#fbac49"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.133,
  stopColor: "#fdb946"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.196,
  stopColor: "#fec144"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.318,
  stopColor: "#ffc444"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.455,
  stopColor: "#fdb946"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.694,
  stopColor: "#f99c4c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.996,
  stopColor: "#f36f56"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ifcax-general-ledger_svg__b",
  x1: -77.782,
  x2: -76.782,
  y1: 0.5,
  y2: 0.5,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#444b8c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.996,
  stopColor: "#26264f"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ifcax-general-ledger_svg__c",
  x1: -124.309,
  x2: -125.791,
  y1: 3.008,
  y2: -12.798,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#ffc444"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.996,
  stopColor: "#f36f56"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ifcax-general-ledger_svg__d",
  x1: -10.794,
  x2: -11.026,
  y1: 0.453,
  y2: -0.325,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#31d8ff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ff80ff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ifcax-general-ledger_svg__j",
  x1: -10.794,
  x2: -11.026,
  y1: 0.453,
  y2: -0.325,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#aa80f9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.996,
  stopColor: "#6165d7"
})), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#ifcax-general-ledger_svg__b",
  id: "ifcax-general-ledger_svg__k",
  x1: -51.253,
  x2: -50.253,
  y1: 0.5,
  y2: 0.5
}), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#ifcax-general-ledger_svg__c",
  id: "ifcax-general-ledger_svg__l",
  x1: -81.822,
  x2: -83.118,
  y1: 1.18,
  y2: -11.227
}), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#ifcax-general-ledger_svg__d",
  id: "ifcax-general-ledger_svg__m",
  x1: -10.796,
  x2: -11.024,
  y1: 1.008,
  y2: -0.108
}), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#ifcax-general-ledger_svg__c",
  id: "ifcax-general-ledger_svg__n",
  x1: -11.176,
  x2: -11.828,
  y1: -0.497,
  y2: 0.363
}), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#ifcax-general-ledger_svg__c",
  id: "ifcax-general-ledger_svg__o",
  x1: -61.161,
  x2: -62.961,
  y1: -0.258,
  y2: 5.134
}), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#ifcax-general-ledger_svg__c",
  id: "ifcax-general-ledger_svg__p",
  x1: -68.496,
  x2: -70.879,
  y1: 0.015,
  y2: 4.062
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 33491"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h80v80H0z",
  "data-name": "Rectangle 23453"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 33467"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 33463"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#ifcax-general-ledger_svg__e)",
  d: "M1584.2 269.018a13.34 13.34 0 0 1-7.083-4.271c-4.037-5.1-2.708-13.1.1-18.2 2.41-4.379 6.882-7.231 15.825-12.934 8.423-5.371 11.3-5.994 12.013-9.263 1.016-4.661-3.807-8.113-1.807-13.373a6.16 6.16 0 0 1 3.041-3.619c3.385-1.4 7.771 2.128 9.827 4.735 1.983 2.515 4.123 7.123 2.533 10.857-1.151 2.705-3.282 2.653-3.727 5.14-.448 2.5 1.575 3.309 2.521 7.421.378 1.643 1.137 4.941-.31 7.784-1.87 3.677-5.735 3.265-6.43 6.32-.5 2.207 1.351 3.144 1.317 5.7-.045 3.363-3.312 5.837-6.058 7.859-3.236 2.378-11.962 8.803-21.762 5.844",
  "data-name": "Path 31064",
  transform: "translate(-1551.563 -206.036)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M1641.565 222.749c-1.8 1.339 3.7 6.866 2.444 14.436-1.355 8.144-9.71 13.683-13.571 16.243-6.588 4.368-9.478 3.58-13.653 8.4-1.653 1.907-5.1 5.878-4.524 11.218.053.5.727 6.018 5.082 8.5 4.939 2.816 10.859-.418 15.959-3.2 3.082-1.684 9.239-5.048 8.674-8.508-.345-2.115-3.122-3.78-5.376-4.214-3.217-.62-5.808 1.18-6.114.634-.276-.492 1.561-2.425 4.118-3.9 5.115-2.942 7.882-1.026 11.664-3.732.458-.328 4.052-2.979 4-6.844-.03-2.229-1.274-4.92-3.089-5.316-2.052-.448-3.948 2.232-4.435 1.81-.465-.4.985-3.1 2.808-5.553 2.679-3.606 3.929-3.687 4.891-5.947a10.38 10.38 0 0 0-.066-7.458c-1.866-4.706-7.277-7.718-8.812-6.569",
  "data-name": "Path 31065",
  opacity: 0.16,
  style: {
    mixBlendMode: "screen",
    isolation: "isolate"
  },
  transform: "translate(-1585.54 -220.006)"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 33464"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#ifcax-general-ledger_svg__f)",
  d: "M1756.784 411.565a11.16 11.16 0 0 1-5.583-4.09c-2.982-4.549-1.275-11.123 1.445-15.162 2.337-3.469 6.277-5.511 14.157-9.594 7.422-3.846 9.867-4.149 10.706-6.82 1.2-3.809-2.565-7.047-.5-11.281a5.16 5.16 0 0 1 2.806-2.788c2.926-.917 6.317 2.355 7.835 4.683 1.464 2.245 2.9 6.245 1.3 9.238-1.162 2.168-2.934 1.965-3.491 4s1.064 2.876 1.545 6.374c.192 1.4.577 4.2-.841 6.464-1.834 2.924-5.024 2.291-5.833 4.785-.584 1.8.89 2.721.67 4.848-.29 2.8-3.2 4.616-5.637 6.1-2.88 1.743-10.631 6.444-18.579 3.243",
  "data-name": "Path 31066",
  transform: "translate(-1709.649 -345.68)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M1808.421 375.2c-1.6.981 2.572 6 .955 12.214-1.739 6.686-9.117 10.676-12.527 12.521-5.818 3.146-8.167 2.273-12.008 5.975-1.52 1.465-4.687 4.517-4.611 9.01.007.417.155 5.07 3.6 7.465 3.905 2.717 9.081.465 13.541-1.475 2.695-1.173 8.078-3.515 7.866-6.441-.129-1.789-2.319-3.384-4.165-3.915-2.635-.758-4.929.548-5.143.07-.193-.43 1.483-1.9 3.724-2.938 4.483-2.069 6.646-.265 10-2.236.406-.239 3.6-2.179 3.846-5.4.142-1.86-.693-4.2-2.176-4.662-1.677-.527-3.458 1.564-3.832 1.176-.358-.371 1.053-2.508 2.756-4.417 2.5-2.8 3.551-2.779 4.522-4.59a8.68 8.68 0 0 0 .5-6.221c-1.199-4.06-5.481-6.972-6.848-6.136",
  "data-name": "Path 31067",
  opacity: 0.16,
  style: {
    mixBlendMode: "screen",
    isolation: "isolate"
  },
  transform: "translate(-1737.282 -357.769)"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 33465"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#ifcax-general-ledger_svg__a)",
  d: "M1362.6 249.1v66.844l39.508-3.043a1.71 1.71 0 0 0 1.593-1.708v-59.657a1.71 1.71 0 0 0-1.664-1.711Z",
  "data-name": "Path 31068",
  transform: "translate(-1360.144 -244.023)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f4f7fa",
  d: "M.448 7.055v62.89l39.688-2.885a1.61 1.61 0 0 0 1.5-1.607V9.324a1.61 1.61 0 0 0-1.566-1.61Z",
  "data-name": "Path 31069",
  opacity: 0.67
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ifcax-general-ledger_svg__g)",
  d: "M0 0a4.52 4.52 0 0 1 4.521 4.521V8.13A4.52 4.52 0 0 1 0 12.65z",
  "data-name": "Rectangle 23452",
  transform: "translate(41.978 9.465)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m65.05 17.571-26.486 27.8-13.658 14.338L4.86 68.241l23.419-54.534Z",
  "data-name": "Path 31070"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#d8dee8",
  d: "M30.782 16.74c-1.421-.2 26.882 3.433 26.972 3.432l-2.116 1.943-25.631-3.3Z",
  "data-name": "Path 31071"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#d8dee8",
  d: "m30.503 20.267 24.19 3.3L31.52 47.801Z",
  "data-name": "Path 31072"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ifcax-general-ledger_svg__h)",
  d: "M1337.241 240.33v63.27a1.96 1.96 0 0 0 1.661 1.938l31.912 4.949a1.674 1.674 0 0 0 1.888-1.66v-69.864a1.674 1.674 0 0 0-1.717-1.673l-31.849 1.08a1.96 1.96 0 0 0-1.895 1.96",
  "data-name": "Path 31073",
  transform: "translate(-1337.241 -233.356)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ifcax-general-ledger_svg__i)",
  d: "M1352.071 298.278c-.46-7.388 4.114-9.152 3.343-17.772-1.116-12.484-11.412-16.65-10.558-26.922a17.25 17.25 0 0 1 3.052-8.215l-8.773.3a1.96 1.96 0 0 0-1.895 1.96v63.267a1.96 1.96 0 0 0 1.661 1.938l24.586 3.813c-8.578-7.092-11.105-13.381-11.416-18.369",
  "data-name": "Path 31074",
  opacity: 0.3,
  style: {
    mixBlendMode: "multiply",
    isolation: "isolate"
  },
  transform: "translate(-1337.241 -240.652)"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 33466"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M53.097 31.84s-.311 8.228 5.123 8.848 4.5-4.5 4.5-4.5l-5.045.272s-3.229-1.859-3.749-4.4Z",
  "data-name": "Path 31075"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M53.097 31.84s-.311 8.228 5.123 8.848 4.5-4.5 4.5-4.5l-5.045.272s-3.229-1.859-3.749-4.4Z",
  "data-name": "Path 31076"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ifcax-general-ledger_svg__b)",
  d: "M2117.254 975.5s.541.54.36.9a8.5 8.5 0 0 1-1.081 1.621 1.28 1.28 0 0 1-1.081.54.453.453 0 0 1 0-.9c.541 0 1.261-1.8 1.261-1.8Z",
  "data-name": "Path 31077",
  transform: "translate(-2039.639 -900)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ifcax-general-ledger_svg__c)",
  d: "m2121.806 960.642.9 1.441a.37.37 0 0 1-.54.36l-1.081-1.081Z",
  "data-name": "Path 31078",
  transform: "translate(-2045.091 -886.579)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ifcax-general-ledger_svg__d)",
  d: "M1963.174 750.713a46.9 46.9 0 0 0 15.49 21.614l1.081-.9a15.4 15.4 0 0 0-1.621-5.223c-1.868-3.559-4.139-4.3-5.763-7.2a12.78 12.78 0 0 1-1.261-8.105Z",
  "data-name": "Path 31079",
  transform: "translate(-1902.49 -697.003)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ifcax-general-ledger_svg__j)",
  d: "M1967.87 750.82a4 4 0 0 0-.2 1.323c.043 1.936 1.534 2.7 2.294 6.225.483 2.24-.026 2.365.491 3.6 1.074 2.572 3.65 2.947 6.389 4.915a14.6 14.6 0 0 1 2.428 2.208 16 16 0 0 1 .472 2.332l-1.081.9a46.9 46.9 0 0 1-15.49-21.613Z",
  "data-name": "Path 31080",
  opacity: 0.3,
  style: {
    mixBlendMode: "multiply",
    isolation: "isolate"
  },
  transform: "translate(-1902.49 -697.003)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ifcax-general-ledger_svg__k)",
  d: "M1841.319 978.735a.64.64 0 0 1-.36.54 4.06 4.06 0 0 1-2.522-1.441c-.18-.54.541-.72.9-.36a10 10 0 0 0 1.982 1.261",
  "data-name": "Path 31081",
  transform: "translate(-1789.82 -901.61)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ifcax-general-ledger_svg__l)",
  d: "m1863.08 968.073-.773 2.028s.053.313.594.313l1.26-1.441Z",
  "data-name": "Path 31082",
  transform: "translate(-1811.402 -893.29)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ifcax-general-ledger_svg__m)",
  d: "M1871.792 716.064a69.1 69.1 0 0 1-5.223 23.595l1.441 1.261a14.3 14.3 0 0 0 4.863-5.584c1.026-2.186.674-3.078.957-5.043.039-.272.082-.517.131-.757a17 17 0 0 1 .533-1.944c.331-.959 2.681-4.743 6.674-9.313a6.13 6.13 0 0 0-2.352-2.575c-3.206-1.876-6.873.268-7.024.36",
  "data-name": "Path 31083",
  transform: "translate(-1815.251 -664.695)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M60.444 33.025c-2.486.427-4.378.871-5.223 2.173-.892 1.375.527 2.41.912 5.428.591 4.619-2.065 6.345-1.3 11a12 12 0 0 0 .518 2.012 4.76 4.76 0 0 0 1.964 2.441 12.3 12.3 0 0 0 2.488 1.2c2.521.882 3.764.369 7.155.563 5.547.317 6.378 1.926 8.884.936 2.533-1 4.366-3.7 3.829-4.856-.322-.691-1.337-.26-2.792-1.109-1.876-1.094-1.561-2.587-3.083-3.868-2.186-1.84-4.289.018-6.159-1.582-1.891-1.618-2.117-5.554-1.313-7.9.525-1.53.535-3.194.925-4.765a1 1 0 0 0-.023-.574c-.31-.9-1.961-1.076-3.209-1.195a14.3 14.3 0 0 0-3.573.096",
  "data-name": "Path 31084"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ff9085",
  d: "M1922.233 679.976c-.768-.512-.352-1.963-1.49-2.733-1.056-.715-1.879.22-3.435-.257-2-.612-1.891-2.533-3.8-3.146-1.375-.441-1.79.437-3.774.475a7.89 7.89 0 0 1-6.22-2.878 7.1 7.1 0 0 1-1.3-2.723 11.43 11.43 0 0 0-.695 5.861 12 12 0 0 0 .723 2.552 3.53 3.53 0 0 0 1.255 1.567 12.4 12.4 0 0 0 2.992 1.536c2.521.882 3.764.369 7.156.563 5.547.317 6.377 1.926 8.884.936a7.2 7.2 0 0 0 3.559-3.153c-2.197 1.593-3.297 1.772-3.855 1.4",
  "data-name": "Path 31085",
  opacity: 0.3,
  style: {
    mixBlendMode: "multiply",
    isolation: "isolate"
  },
  transform: "translate(-1846.683 -622.953)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ifcax-general-ledger_svg__n)",
  d: "M1936.588 492.974a6.7 6.7 0 0 0-.728 2.188c-.043.9.975.837.975.837l-.038.569a1.23 1.23 0 0 1-.805 1.075l-.4.148s2.623.561 4.055-.45l-.413-.04a1.234 1.234 0 0 1-1.107-1.1l-.025-.244s.452-2.815-1.514-2.983",
  "data-name": "Path 31086",
  transform: "translate(-1877.579 -464.252)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#212121",
  d: "M59.418 30.001c.136-.011.248-.183.34-.132s.087.3 0 .48a.64.64 0 0 1-.246.264 1.7 1.7 0 0 1 .294.665 2.3 2.3 0 0 1-.368 1.483c-.65 1.383.361 3.57 1.47 4.674.9.9 1.322.537 1.86 1.27 1.048 1.427-.4 3 .144 4.916.824 2.92 5.435 3.789 5.625 3.822l.2.034c2.069.329 5.2.827 7.411-.871a6.44 6.44 0 0 0 2.284-5.428 6.3 6.3 0 0 0-1.772-4.043 5.74 5.74 0 0 0-3.752-1.758c-1.066-.01-1.281.366-2.1.134a4.37 4.37 0 0 1-2.229-1.962c-.784-1.157-.466-1.4-1.03-1.974-1.106-1.115-2.4-.24-3.584-1.224-1.164-.97-.462-2.286-1.585-3.126-1.159-.866-3.376-.564-3.849.468-.395.884.472 2.342.887 2.308",
  "data-name": "Path 31087"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ifcax-general-ledger_svg__o)",
  d: "M1869.8 511.608a2.33 2.33 0 0 0-1.874-.992c-1.1.11.551.882.772 1.543s1.979.22 1.102-.551",
  "data-name": "Path 31088",
  transform: "translate(-1816.132 -480.176)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ifcax-general-ledger_svg__p)",
  d: "m1759.8 620.328-.466-2.329-.172.688a.112.112 0 0 1-.219-.011l-.074-.522s-1.708.31-.621 1.708c.908 1.162 1.552.466 1.552.466",
  "data-name": "Path 31089",
  transform: "translate(-1717.108 -577.156)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M57.133 34.634h-.791a1.47 1.47 0 0 0-1.3.779 13.3 13.3 0 0 1-5.049 5.43 27.6 27.6 0 0 1-7.3 2.484l-.754.052s2.307 3.674 8.516 2.9 7.917-5.278 7.917-5.278Z",
  "data-name": "Path 31090"
})))));

const SvgIfcaxGeneralSetting = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 512 512"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "/ FILLED_OUTLINE"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#cbe2ef",
  d: "M232 232V128a104 104 0 1 0-104 104z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#46c89d",
  d: "M96 56h16v48H96zM152 56h16v48h-16z"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#cbe2ef"
}, /*#__PURE__*/React.createElement("path", {
  d: "M280 280v104a104 104 0 1 0 104-104zM232 280v104a104 104 0 1 1-104-104zM280 232V128a104 104 0 1 1 104 104z"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#d178a1",
  d: "M336 266.515v-21.03l-20.09-4.817-6.7-16.164 10.836-17.682-14.868-14.868-17.682 10.835-16.164-6.698L266.514 176h-21.028l-4.818 20.09-16.164 6.7-17.682-10.836-14.868 14.868 10.835 17.682-6.698 16.164L176 245.486v21.029l20.09 4.817 6.7 16.164-10.836 17.682 14.868 14.868 17.682-10.835 16.164 6.698L245.486 336h21.028l4.818-20.09 16.163-6.7 17.683 10.836 14.868-14.868-10.835-17.682 6.698-16.164zM256 280a24 24 0 1 1 24-24 24 24 0 0 1-24 24"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00b378",
  d: "M440 432v-80l-56-32-56 32v80z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0071af",
  d: "M169.6 387.2 144 368l6.768-20.305a24 24 0 0 0 1.232-7.59V336a24 24 0 0 0-48 0v4.105a24 24 0 0 0 1.232 7.59L112 368l-25.6 19.2A16 16 0 0 0 80 400v32a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-32a16 16 0 0 0-6.4-12.8"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#46c89d",
  d: "M360 368h48v64h-48z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#59cea7",
  d: "M360 368h48v32h-48z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 112,
  height: 96,
  x: 328,
  y: 80,
  fill: "#0071af",
  rx: 16
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5ca4cc",
  d: "M360 80h32v48h-32z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00b378",
  d: "M80 104v64h48V88z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00a16c",
  d: "M128 104v64h48V88z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00a16c",
  d: "M64 160h128v16H64z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m225.208 318.162 8.63 3.577L239.178 344h33.646l5.338-22.26 8.63-3.578 19.584 12.001 23.787-23.788-12-19.583 3.577-8.63L344 272.822v-33.646l-22.26-5.338-3.578-8.63 12.001-19.584-23.788-23.787-19.583 12-8.63-3.577L272.822 168h-33.646l-5.338 22.26-8.63 3.578-19.584-12.001-23.787 23.788 12 19.583-3.577 8.63L168 239.178v33.646l22.26 5.338 3.578 8.63-12.001 19.584 23.788 23.787zm-23.287-53.66L184 260.207v-8.412l17.92-4.297 9.82-23.696-9.67-15.781 5.95-5.95 15.78 9.67 23.697-9.819L251.794 184h8.412l4.297 17.92 23.696 9.82 15.782-9.67 5.95 5.95-9.671 15.78 9.82 23.697 17.92 4.297v8.412l-17.92 4.297-9.82 23.696 9.67 15.782-5.95 5.95-15.78-9.671-23.697 9.82-4.297 17.92h-8.412l-4.297-17.92-23.696-9.82-15.781 9.67-5.95-5.95 9.67-15.78z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M256 288a32 32 0 1 0-32-32 32.037 32.037 0 0 0 32 32m0-48a16 16 0 1 1-16 16 16.02 16.02 0 0 1 16-16M448 347.357l-64-36.57-64 36.57V440h128zM400 392h-32v-16h32zm-32 16h32v16h-32zm64 16h-16v-64h-64v64h-16v-67.357l48-27.43 48 27.43zM128 240h24v-16h-24a96 96 0 1 1 96-96v24h16v-24a112 112 0 1 0-112 112M288 128a96 96 0 1 1 96 96h-24v16h24a112 112 0 1 0-112-112v24h16zM224 384a96 96 0 1 1-96-96h24v-16h-24a112 112 0 1 0 112 112v-24h-16z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M384 272h-24v16h24a96 96 0 1 1-96 96v-24h-16v24a112 112 0 1 0 112-112M72 400v32a24.03 24.03 0 0 0 24 24h64a24.03 24.03 0 0 0 24-24v-32a24.12 24.12 0 0 0-9.6-19.2l-20.987-15.74 4.945-14.835a32 32 0 0 0 1.642-10.12V336a32 32 0 0 0-64 0v4.105a32 32 0 0 0 1.642 10.12l4.945 14.835L81.6 380.8A24.11 24.11 0 0 0 72 400m16 0a8.04 8.04 0 0 1 3.2-6.4l30.213-22.66-8.592-25.774a16 16 0 0 1-.821-5.06V336a16 16 0 0 1 32 0v4.105a16 16 0 0 1-.821 5.06l-8.592 25.775L164.8 393.6a8.04 8.04 0 0 1 3.2 6.4v32a8.01 8.01 0 0 1-8 8H96a8.01 8.01 0 0 1-8-8zM448 160V96a24.03 24.03 0 0 0-24-24h-80a24.03 24.03 0 0 0-24 24v64a24.03 24.03 0 0 0 24 24h80a24.03 24.03 0 0 0 24-24m-80-72h16v32h-16zm-32 72V96a8.01 8.01 0 0 1 8-8h8v48h48V88h24a8.01 8.01 0 0 1 8 8v64a8.01 8.01 0 0 1-8 8h-80a8.01 8.01 0 0 1-8-8M96 56v34.234l-24 8V160h-8v16h128v-16h-8V76.9l-16 5.334V56h-16v31.567L136 92.9v-16l-24 8V56zm72 43.1V160h-32v-50.233zM120 160H88v-50.234L120 99.1z"
})));

const SvgIfcaxGroupBusinessInsight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57654"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#acb3ba",
  d: "M4 18.785h15.806v.823H4z",
  "data-name": "Rectangle 26191"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#cdd6e0",
  d: "M4.659 12.166h2.437v5.96H4.659z",
  "data-name": "Rectangle 26192"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4cdbc4",
  d: "M7.688 9.301h2.437v8.825H7.688z",
  "data-name": "Rectangle 26193"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffd15c",
  d: "M10.684 10.652h2.437v7.475h-2.437z",
  "data-name": "Rectangle 26194"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#84dbff",
  d: "M13.714 13.45h2.437v4.643h-2.437z",
  "data-name": "Rectangle 26195"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ff7058",
  d: "M16.71 8.248h2.437v9.846H16.71z",
  "data-name": "Rectangle 26196"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#cdd6e0",
  d: "M14.339 9.894 9.696 5.251l-4.05 4.05-.461-.461 4.511-4.511 4.643 4.643 3.82-3.82.461.461Z",
  "data-name": "Path 72125"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#40596b",
  "data-name": "Group 57619",
  transform: "translate(4.593 4)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0.823,
  cy: 0.823,
  r: 0.823,
  "data-name": "Ellipse 1468",
  transform: "translate(0 4.248)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 0.823,
  cy: 0.823,
  r: 0.823,
  "data-name": "Ellipse 1469",
  transform: "translate(4.281)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 0.823,
  cy: 0.823,
  r: 0.823,
  "data-name": "Ellipse 1470",
  transform: "translate(8.891 4.643)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 0.823,
  cy: 0.823,
  r: 0.823,
  "data-name": "Ellipse 1471",
  transform: "translate(12.974 .56)"
}))));

const SvgIfcaxHealthInsurance = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 16.933 16.933"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#ff6b6b",
  d: "M8.457.528a.3.3 0 0 0-.11.03s-3.142 1.567-7.06 2.09a.265.265 0 0 0-.229.263v5.554c0 3.403 1.863 5.421 3.7 6.544s3.67 1.392 3.67 1.392a.3.3 0 0 0 .078 0s1.833-.27 3.67-1.392c1.836-1.123 3.699-3.141 3.699-6.544V2.911a.265.265 0 0 0-.228-.264C11.728 2.125 8.586.557 8.586.557a.27.27 0 0 0-.13-.03"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#dbe9ee",
  d: "M8.467 3.704c-2.627 0-4.762 2.134-4.762 4.761S5.84 13.23 8.467 13.23s4.761-2.137 4.761-4.764-2.134-4.761-4.761-4.761"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ff6b6b",
  d: "M7.647 5.821a.265.265 0 0 0-.24.264v1.324H6.087a.265.265 0 0 0-.266.264V9.26a.265.265 0 0 0 .266.263h1.322v1.325a.265.265 0 0 0 .266.263h1.585a.265.265 0 0 0 .266-.263V9.524h1.322a.265.265 0 0 0 .266-.263V7.673a.265.265 0 0 0-.266-.264H9.525V6.085a.265.265 0 0 0-.266-.264H7.647"
}));

const SvgIfcaxHotelxIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  id: "ifcax-hotelx-icon_svg__Layer_2",
  viewBox: "0 0 1020 1023",
  width: "1em",
  height: "1em"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "ifcax-hotelx-icon_svg__drop-shadow-1",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: 8.68,
  dy: 8.68
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "blur",
  stdDeviation: 6.2
}), /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#000",
  floodOpacity: 0.39
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "blur",
  operator: "in"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "SourceGraphic"
})), /*#__PURE__*/React.createElement("style", null, ".ifcax-hotelx-icon_svg__cls-3{fill:#faaf22}.ifcax-hotelx-icon_svg__cls-4{fill:#231f20}")), /*#__PURE__*/React.createElement("g", {
  id: "ifcax-hotelx-icon_svg__Layer_1-2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h1020v1023H0z",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M35.67 763.59V193.54h115.1V417.9H376.3V193.54h115.1v570.05H376.3V514.34H150.77v249.25z",
  className: "ifcax-hotelx-icon_svg__cls-4",
  style: {
    filter: "url(#ifcax-hotelx-icon_svg__drop-shadow-1)"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "m274.7 457.56 144.26-.65 110.99 81.26L447 587.43zM546.67 662.28l70.37-56.5 207.84 156.46-145.95-.35z",
  className: "ifcax-hotelx-icon_svg__cls-3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M261.63 762.25s236.62-257.94 718.7-379.86c0 0-344.86 123.83-558 379.86H261.64Z",
  className: "ifcax-hotelx-icon_svg__cls-3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M509.32 712.09c0-8.1 2-15.95 5.99-23.53 4-7.58 9.65-13.37 16.98-17.37 7.32-3.99 15.5-5.99 24.53-5.99 13.95 0 25.39 4.53 34.3 13.59 8.92 9.06 13.37 20.51 13.37 34.34s-4.5 25.52-13.5 34.69c-9 9.18-20.33 13.76-34 13.76q-12.675 0-24.18-5.73c-7.67-3.82-13.5-9.42-17.5-16.8-3.99-7.38-5.99-16.37-5.99-26.96m25.01 1.3c0 9.15 2.17 16.15 6.51 21.01s9.7 7.29 16.07 7.29 11.71-2.43 16.02-7.29 6.47-11.93 6.47-21.19-2.16-15.98-6.47-20.84q-6.465-7.29-16.02-7.29c-9.555 0-11.72 2.43-16.07 7.29-4.34 4.86-6.51 11.87-6.51 21.01ZM701.46 667.28v19.45h-16.67v37.17c0 7.53.16 11.91.48 13.16s1.04 2.27 2.17 3.08 2.5 1.22 4.12 1.22q3.39 0 9.81-2.34l2.08 18.93c-5.67 2.43-12.1 3.65-19.28 3.65-4.4 0-8.37-.74-11.9-2.21q-5.295-2.22-7.77-5.73c-1.65-2.34-2.79-5.51-3.43-9.51q-.78-4.26-.78-17.19v-40.21h-11.2V667.3h11.2v-18.32l24.49-14.24v32.56h16.67ZM807.37 730.15l24.31 4.08c-3.13 8.92-8.06 15.7-14.81 20.36s-15.18 6.99-25.31 6.99c-16.04 0-27.91-5.24-35.6-15.72-6.08-8.39-9.12-18.99-9.12-31.78 0-15.28 3.99-27.25 11.98-35.91 7.99-8.65 18.09-12.98 30.31-12.98 13.72 0 24.54 4.53 32.48 13.59 7.93 9.06 11.72 22.94 11.38 41.64h-61.13c.17 7.24 2.14 12.87 5.9 16.89s8.45 6.04 14.07 6.04c3.82 0 7.03-1.04 9.64-3.13 2.61-2.08 4.57-5.44 5.91-10.07Zm1.39-24.66c-.17-7.06-2-12.43-5.47-16.11s-7.7-5.51-12.68-5.51q-7.995 0-13.2 5.82c-3.47 3.88-5.18 9.15-5.12 15.8zM888.44 759.5V632.2h24.4v127.3z",
  className: "ifcax-hotelx-icon_svg__cls-4"
})));

const SvgIfcaxHouse = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 20 20"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#ff4155",
  d: "M14.933 2.89h2.303v4.02h-2.303z",
  "data-name": "Rectangle 26115"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ff4155",
  d: "M14.053.838h4.062v2.178h-4.062z",
  "data-name": "Rectangle 26116"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fcbc45",
  d: "M1.759 10.798v9.2h16.315v-9.2l-8.158-8.16c-3.163 3.206-4.957 5-8.157 8.16",
  "data-name": "Path 68764"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M18.116 10.846 9.959 2.638c-1.623 1.591-2.872 2.848-4.12 4.1l-4.079 4.1v1.885l8.157-8.208 8.157 8.208v.251-2.128z",
  "data-name": "Path 68765"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M12.388 20H7.446v-4.863a2.475 2.475 0 0 1 2.471-2.471 2.475 2.475 0 0 1 2.471 2.471Z",
  "data-name": "Path 68766"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ff4155",
  d: "M19.625 9.13 10.917.377a1.354 1.354 0 0 0-1.875 0L.375 9.13a1.37 1.37 0 0 0 0 1.885 1.354 1.354 0 0 0 1.875 0L10 3.225l7.75 7.789a1.354 1.354 0 0 0 1.875 0 1.37 1.37 0 0 0 0-1.884",
  "data-name": "Path 68767"
}));

const SvgIfcaxHrxIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  id: "ifcax-hrx-icon_svg__Layer_2",
  viewBox: "0 0 232.21 231.04",
  width: "1em",
  height: "1em"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "ifcax-hrx-icon_svg__drop-shadow-1",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: 2,
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "blur",
  stdDeviation: 5
}), /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#000",
  floodOpacity: 0.39
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "blur",
  operator: "in"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "SourceGraphic"
})), /*#__PURE__*/React.createElement("filter", {
  id: "ifcax-hrx-icon_svg__drop-shadow-2",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: 2,
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "blur-2",
  stdDeviation: 5
}), /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#000",
  floodOpacity: 0.39
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "blur-2",
  operator: "in"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "SourceGraphic"
})), /*#__PURE__*/React.createElement("style", null, ".ifcax-hrx-icon_svg__cls-1{fill:#fff}.ifcax-hrx-icon_svg__cls-5{fill:#231f20}.ifcax-hrx-icon_svg__cls-6{opacity:.27}")), /*#__PURE__*/React.createElement("g", {
  id: "ifcax-hrx-icon_svg__Layer_1-2"
}, /*#__PURE__*/React.createElement("rect", {
  width: 231.04,
  height: 231.04,
  x: 0.96,
  rx: 57.76,
  ry: 57.76,
  style: {
    fill: "#f9ae21"
  }
}), /*#__PURE__*/React.createElement("g", {
  className: "ifcax-hrx-icon_svg__cls-6"
}, /*#__PURE__*/React.createElement("path", {
  d: "m26.69 24.2 7.68-.03 5.9 4.32-4.41 2.61zM41.15 35.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-hrx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26 40.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM96.69 24.2l7.68-.03 5.9 4.32-4.41 2.61zM111.15 35.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-hrx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M96 40.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM169.69 24.2l7.68-.03 5.9 4.32-4.41 2.61zM184.15 35.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-hrx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M169 40.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2z",
  className: "ifcax-hrx-icon_svg__cls-1"
})), /*#__PURE__*/React.createElement("g", {
  className: "ifcax-hrx-icon_svg__cls-6"
}, /*#__PURE__*/React.createElement("path", {
  d: "m26.69 109.2 7.68-.03 5.9 4.32-4.41 2.61zM41.15 120.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-hrx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26 125.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM96.69 109.2l7.68-.03 5.9 4.32-4.41 2.61zM111.15 120.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-hrx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M96 125.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM169.69 109.2l7.68-.03 5.9 4.32-4.41 2.61zM184.15 120.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-hrx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M169 125.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2z",
  className: "ifcax-hrx-icon_svg__cls-1"
})), /*#__PURE__*/React.createElement("g", {
  className: "ifcax-hrx-icon_svg__cls-6"
}, /*#__PURE__*/React.createElement("path", {
  d: "m26.69 198.2 7.68-.03 5.9 4.32-4.41 2.61zM41.15 209.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-hrx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26 214.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM96.69 198.2l7.68-.03 5.9 4.32-4.41 2.61zM111.15 209.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-hrx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M96 214.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM169.69 198.2l7.68-.03 5.9 4.32-4.41 2.61zM184.15 209.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-hrx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M169 214.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2z",
  className: "ifcax-hrx-icon_svg__cls-1"
})), /*#__PURE__*/React.createElement("g", {
  className: "ifcax-hrx-icon_svg__cls-6"
}, /*#__PURE__*/React.createElement("path", {
  d: "m62.69 153.2 7.68-.03 5.9 4.32-4.41 2.61zM77.15 164.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-hrx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M62 169.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM.69 153.2l7.68-.03 5.9 4.32-4.41 2.61zM15.15 164.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-hrx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 169.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM130.69 153.2l7.68-.03 5.9 4.32-4.41 2.61zM145.15 164.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-hrx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M130 169.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM194.69 153.2l7.68-.03 5.9 4.32-4.41 2.61zM209.15 164.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-hrx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M194 169.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2z",
  className: "ifcax-hrx-icon_svg__cls-1"
})), /*#__PURE__*/React.createElement("g", {
  className: "ifcax-hrx-icon_svg__cls-6"
}, /*#__PURE__*/React.createElement("path", {
  d: "m62.69 66.2 7.68-.03 5.9 4.32-4.41 2.61zM77.15 77.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-hrx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M62 82.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM.69 66.2l7.68-.03 5.9 4.32-4.41 2.61zM15.15 77.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-hrx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 82.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM130.69 66.2l7.68-.03 5.9 4.32-4.41 2.61zM145.15 77.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-hrx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M130 82.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM194.69 66.2l7.68-.03 5.9 4.32-4.41 2.61zM209.15 77.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-hrx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M194 82.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2z",
  className: "ifcax-hrx-icon_svg__cls-1"
})), /*#__PURE__*/React.createElement("path", {
  d: "M9.95 180.75V44.24h27.56v53.73h54.01V44.24h27.56v136.51H91.52v-59.69H37.51v59.69z",
  className: "ifcax-hrx-icon_svg__cls-5",
  style: {
    filter: "url(#ifcax-hrx-icon_svg__drop-shadow-1)"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M129.05 105.33V43.4h26.32c6.62 0 11.43.56 14.42 1.67 3 1.11 5.4 3.09 7.2 5.93s2.7 6.1 2.7 9.76c0 4.65-1.37 8.48-4.1 11.51s-6.82 4.94-12.25 5.72c2.7 1.58 4.93 3.31 6.69 5.2s4.13 5.24 7.12 10.05l7.56 12.08h-14.95l-9.04-13.47c-3.21-4.82-5.41-7.85-6.59-9.1s-2.44-2.11-3.76-2.58c-1.32-.46-3.42-.7-6.29-.7h-2.53v25.85h-12.5Zm12.5-35.73h9.25c6 0 9.74-.25 11.24-.76 1.49-.51 2.66-1.38 3.51-2.62.84-1.24 1.27-2.79 1.27-4.65 0-2.08-.56-3.77-1.67-5.05q-1.665-1.92-4.71-2.43c-1.01-.14-4.06-.21-9.12-.21h-9.76v15.71Z",
  className: "ifcax-hrx-icon_svg__cls-5",
  style: {
    filter: "url(#ifcax-hrx-icon_svg__drop-shadow-2)"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "m53.29 106.88 35.1-.16 27.01 19.77-20.19 11.99zM119.46 156.69l17.13-13.74 50.57 38.07-35.51-.09z",
  className: "ifcax-hrx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M50.11 181.02s57.58-62.76 174.88-92.43c0 0-83.92 30.13-135.78 92.43z",
  className: "ifcax-hrx-icon_svg__cls-1"
})));

const SvgIfcaxHumanresourcexIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  id: "ifcax-humanresourcex-icon_svg__Layer_2",
  viewBox: "0 0 1020 1023",
  width: "1em",
  height: "1em"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "ifcax-humanresourcex-icon_svg__drop-shadow-1",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: 8.68,
  dy: 8.68
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "blur",
  stdDeviation: 6.2
}), /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#000",
  floodOpacity: 0.39
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "blur",
  operator: "in"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "SourceGraphic"
})), /*#__PURE__*/React.createElement("filter", {
  id: "ifcax-humanresourcex-icon_svg__drop-shadow-2",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: 8.68,
  dy: 8.68
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "blur-2",
  stdDeviation: 6.2
}), /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#000",
  floodOpacity: 0.39
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "blur-2",
  operator: "in"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "SourceGraphic"
})), /*#__PURE__*/React.createElement("style", null, ".ifcax-humanresourcex-icon_svg__cls-4{fill:#faaf22}.ifcax-humanresourcex-icon_svg__cls-5{fill:#231f20}")), /*#__PURE__*/React.createElement("g", {
  id: "ifcax-humanresourcex-icon_svg__Layer_1-2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h1020v1023H0z",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M74.43 723.42V227.45h100.14v195.21h196.22V227.45h100.14v495.97H370.79V506.56H174.58v216.86z",
  className: "ifcax-humanresourcex-icon_svg__cls-5",
  style: {
    filter: "url(#ifcax-humanresourcex-icon_svg__drop-shadow-1)"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M507.17 449.39V224.4h95.61q36.06 0 52.41 6.06c10.9 4.04 19.62 11.23 26.17 21.56 6.55 10.34 9.82 22.15 9.82 35.45 0 16.88-4.96 30.82-14.89 41.82s-24.76 17.93-44.51 20.8c9.82 5.73 17.93 12.02 24.33 18.88 6.39 6.86 15.01 19.03 25.86 36.53l27.47 43.89h-54.33l-32.84-48.96c-11.66-17.5-19.64-28.52-23.94-33.07s-8.85-7.67-13.66-9.36-12.43-2.53-22.87-2.53h-9.21v93.93h-45.43Zm45.43-129.84h33.61c21.79 0 35.4-.92 40.82-2.76s9.67-5.01 12.74-9.52c3.07-4.5 4.6-10.13 4.6-16.88 0-7.57-2.02-13.68-6.06-18.34-4.04-4.65-9.75-7.6-17.11-8.82-3.68-.51-14.73-.77-33.15-.77H552.6z",
  className: "ifcax-humanresourcex-icon_svg__cls-5",
  style: {
    filter: "url(#ifcax-humanresourcex-icon_svg__drop-shadow-2)"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "m383.31 452.97 128.53-.58 98.88 72.39-73.9 43.89zM625.61 635.35l62.7-50.33 185.17 139.39-130.03-.31z",
  className: "ifcax-humanresourcex-icon_svg__cls-4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M371.67 724.42S582.48 494.62 1011.96 386c0 0-307.24 110.32-497.13 338.42z",
  className: "ifcax-humanresourcex-icon_svg__cls-4"
})));

const SvgIfcaxHxIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  id: "ifcax-hx-icon_svg__Layer_2",
  viewBox: "0 0 232.21 231.04",
  width: "1em",
  height: "1em"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "ifcax-hx-icon_svg__drop-shadow-1",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: 2,
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "blur",
  stdDeviation: 5
}), /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#000",
  floodOpacity: 0.39
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "blur",
  operator: "in"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "SourceGraphic"
})), /*#__PURE__*/React.createElement("style", null, ".ifcax-hx-icon_svg__cls-1{fill:#fff}.ifcax-hx-icon_svg__cls-5{opacity:.27}")), /*#__PURE__*/React.createElement("g", {
  id: "ifcax-hx-icon_svg__Layer_1-2"
}, /*#__PURE__*/React.createElement("rect", {
  width: 231.04,
  height: 231.04,
  x: 0.96,
  rx: 57.76,
  ry: 57.76,
  style: {
    fill: "#f9ae21"
  }
}), /*#__PURE__*/React.createElement("g", {
  className: "ifcax-hx-icon_svg__cls-5"
}, /*#__PURE__*/React.createElement("path", {
  d: "m26.69 24.2 7.68-.03 5.9 4.32-4.41 2.61zM41.15 35.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-hx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26 40.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM96.69 24.2l7.68-.03 5.9 4.32-4.41 2.61zM111.15 35.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-hx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M96 40.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM169.69 24.2l7.68-.03 5.9 4.32-4.41 2.61zM184.15 35.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-hx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M169 40.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2z",
  className: "ifcax-hx-icon_svg__cls-1"
})), /*#__PURE__*/React.createElement("g", {
  className: "ifcax-hx-icon_svg__cls-5"
}, /*#__PURE__*/React.createElement("path", {
  d: "m26.69 109.2 7.68-.03 5.9 4.32-4.41 2.61zM41.15 120.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-hx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26 125.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM96.69 109.2l7.68-.03 5.9 4.32-4.41 2.61zM111.15 120.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-hx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M96 125.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM169.69 109.2l7.68-.03 5.9 4.32-4.41 2.61zM184.15 120.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-hx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M169 125.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2z",
  className: "ifcax-hx-icon_svg__cls-1"
})), /*#__PURE__*/React.createElement("g", {
  className: "ifcax-hx-icon_svg__cls-5"
}, /*#__PURE__*/React.createElement("path", {
  d: "m26.69 198.2 7.68-.03 5.9 4.32-4.41 2.61zM41.15 209.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-hx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26 214.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM96.69 198.2l7.68-.03 5.9 4.32-4.41 2.61zM111.15 209.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-hx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M96 214.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM169.69 198.2l7.68-.03 5.9 4.32-4.41 2.61zM184.15 209.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-hx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M169 214.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2z",
  className: "ifcax-hx-icon_svg__cls-1"
})), /*#__PURE__*/React.createElement("g", {
  className: "ifcax-hx-icon_svg__cls-5"
}, /*#__PURE__*/React.createElement("path", {
  d: "m62.69 153.2 7.68-.03 5.9 4.32-4.41 2.61zM77.15 164.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-hx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M62 169.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM.69 153.2l7.68-.03 5.9 4.32-4.41 2.61zM15.15 164.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-hx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 169.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM130.69 153.2l7.68-.03 5.9 4.32-4.41 2.61zM145.15 164.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-hx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M130 169.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM194.69 153.2l7.68-.03 5.9 4.32-4.41 2.61zM209.15 164.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-hx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M194 169.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2z",
  className: "ifcax-hx-icon_svg__cls-1"
})), /*#__PURE__*/React.createElement("g", {
  className: "ifcax-hx-icon_svg__cls-5"
}, /*#__PURE__*/React.createElement("path", {
  d: "m62.69 66.2 7.68-.03 5.9 4.32-4.41 2.61zM77.15 77.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-hx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M62 82.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM.69 66.2l7.68-.03 5.9 4.32-4.41 2.61zM15.15 77.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-hx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 82.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM130.69 66.2l7.68-.03 5.9 4.32-4.41 2.61zM145.15 77.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-hx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M130 82.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM194.69 66.2l7.68-.03 5.9 4.32-4.41 2.61zM209.15 77.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-hx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M194 82.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2z",
  className: "ifcax-hx-icon_svg__cls-1"
})), /*#__PURE__*/React.createElement("g", {
  style: {
    filter: "url(#ifcax-hx-icon_svg__drop-shadow-1)"
  }
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.86 181.55V43.06h27.96v54.51h54.79V43.06h27.96v138.49H90.61V121H35.82v60.55z",
  style: {
    fill: "#231f20"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "m55.93 107.2 35.05-.16 26.96 19.74-20.15 11.97zM122 156.93l17.1-13.72 50.49 38.01-35.46-.09z",
  className: "ifcax-hx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M52.75 181.22s57.49-62.66 174.6-92.28c0 0-83.78 30.08-135.56 92.28z",
  className: "ifcax-hx-icon_svg__cls-1"
})));

const SvgIfcaxIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  id: "ifcax-icon_svg__Layer_2",
  viewBox: "0 0 232.21 231.04",
  width: "1em",
  height: "1em"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".ifcax-icon_svg__cls-1{fill:#fff}.ifcax-icon_svg__cls-3{opacity:.27}")), /*#__PURE__*/React.createElement("g", {
  id: "ifcax-icon_svg__Layer_1-2"
}, /*#__PURE__*/React.createElement("rect", {
  width: 231.04,
  height: 231.04,
  x: 0.96,
  rx: 57.76,
  ry: 57.76,
  style: {
    fill: "#f9ae21"
  }
}), /*#__PURE__*/React.createElement("g", {
  className: "ifcax-icon_svg__cls-3"
}, /*#__PURE__*/React.createElement("path", {
  d: "m26.69 24.2 7.68-.03 5.9 4.32-4.41 2.61zM41.15 35.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26 40.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM96.69 24.2l7.68-.03 5.9 4.32-4.41 2.61zM111.15 35.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M96 40.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM169.69 24.2l7.68-.03 5.9 4.32-4.41 2.61zM184.15 35.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M169 40.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2z",
  className: "ifcax-icon_svg__cls-1"
})), /*#__PURE__*/React.createElement("g", {
  className: "ifcax-icon_svg__cls-3"
}, /*#__PURE__*/React.createElement("path", {
  d: "m26.69 109.2 7.68-.03 5.9 4.32-4.41 2.61zM41.15 120.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26 125.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM96.69 109.2l7.68-.03 5.9 4.32-4.41 2.61zM111.15 120.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M96 125.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM169.69 109.2l7.68-.03 5.9 4.32-4.41 2.61zM184.15 120.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M169 125.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2z",
  className: "ifcax-icon_svg__cls-1"
})), /*#__PURE__*/React.createElement("g", {
  className: "ifcax-icon_svg__cls-3"
}, /*#__PURE__*/React.createElement("path", {
  d: "m26.69 198.2 7.68-.03 5.9 4.32-4.41 2.61zM41.15 209.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26 214.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM96.69 198.2l7.68-.03 5.9 4.32-4.41 2.61zM111.15 209.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M96 214.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM169.69 198.2l7.68-.03 5.9 4.32-4.41 2.61zM184.15 209.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M169 214.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2z",
  className: "ifcax-icon_svg__cls-1"
})), /*#__PURE__*/React.createElement("g", {
  className: "ifcax-icon_svg__cls-3"
}, /*#__PURE__*/React.createElement("path", {
  d: "m62.69 153.2 7.68-.03 5.9 4.32-4.41 2.61zM77.15 164.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M62 169.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM.69 153.2l7.68-.03 5.9 4.32-4.41 2.61zM15.15 164.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 169.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM130.69 153.2l7.68-.03 5.9 4.32-4.41 2.61zM145.15 164.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M130 169.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM194.69 153.2l7.68-.03 5.9 4.32-4.41 2.61zM209.15 164.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M194 169.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2z",
  className: "ifcax-icon_svg__cls-1"
})), /*#__PURE__*/React.createElement("g", {
  className: "ifcax-icon_svg__cls-3"
}, /*#__PURE__*/React.createElement("path", {
  d: "m62.69 66.2 7.68-.03 5.9 4.32-4.41 2.61zM77.15 77.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M62 82.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM.69 66.2l7.68-.03 5.9 4.32-4.41 2.61zM15.15 77.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 82.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM130.69 66.2l7.68-.03 5.9 4.32-4.41 2.61zM145.15 77.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M130 82.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM194.69 66.2l7.68-.03 5.9 4.32-4.41 2.61zM209.15 77.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M194 82.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2z",
  className: "ifcax-icon_svg__cls-1"
})), /*#__PURE__*/React.createElement("path", {
  d: "M97.17 93h-50.2v3.49h3.16c1.41 0 2.76.35 4 1.04.82.48 1.36 1.03 1.61 1.64.26.66.57 2.27.57 6.23v42.13c0 4.86-.62 6.4-.98 6.88-1.06 1.36-2.76 2.03-5.19 2.03h-3.16v3.49h29.7v-3.49h-3.21c-1.39 0-2.74-.35-4.01-1.04-.85-.48-1.4-1.03-1.64-1.64-.26-.65-.57-2.27-.57-6.23V127.9h11.02c2.03 0 3.55.27 4.53.79.96.52 1.7 1.27 2.25 2.32.56 1.06.86 2.81.89 5.19v.84h.01c1.92 0 3.48-1.56 3.48-3.48v-20.31h-3.39l-.09.75c-.39 3.34-1.15 5.57-2.26 6.62-1.1 1.04-2.91 1.57-5.4 1.57h-8.45a2.58 2.58 0 0 1-2.58-2.58V98.26h13.53c3.27 0 5.7.3 7.21.9 1.47.58 2.72 1.53 3.73 2.83 1.03 1.33 1.96 3.49 2.76 6.41l.17.63h3.23l-.7-16.04ZM156.67 143.49l-2.85-1.84-.47.66c-3.79 5.26-7.29 8.81-10.4 10.55-3.09 1.73-6.72 2.61-10.79 2.61-4.69 0-8.92-1.12-12.57-3.34-3.63-2.2-6.39-5.42-8.2-9.57-1.84-4.2-2.77-9.24-2.77-15 0-7 .99-12.93 2.94-17.61 1.92-4.62 4.59-8.02 7.91-10.11 3.34-2.1 7.14-3.16 11.28-3.16 4.94 0 9.23 1.41 12.74 4.19 3.53 2.79 6.3 7.47 8.22 13.91l.18.61c1.64 0 2.95-1.39 2.84-3.03l-1.4-20.84h-3.16l-.15.66c-.32 1.38-.84 2.46-1.54 3.18-.48.46-1.03.68-1.67.68-.2 0-.83-.09-2.5-.97-4.68-2.36-9.5-3.55-14.33-3.55-6.19 0-11.97 1.55-17.19 4.61-5.23 3.07-9.39 7.44-12.37 13.01-2.97 5.55-4.48 11.72-4.48 18.34 0 8.23 2.29 15.49 6.8 21.57 6.07 8.21 14.75 12.37 25.79 12.37 6.13 0 11.5-1.4 15.98-4.17 4.47-2.76 8.42-7.15 11.74-13.05l.39-.7ZM220.8 156.44c-2.45-.15-4.38-.81-5.72-1.98-1.39-1.21-2.98-3.96-4.75-8.17l-22.92-54.77h-2.82l-23.16 54.19c-1.93 4.58-3.69 7.64-5.24 9.09-.46.44-1.68 1.09-4.85 1.65l-.71.12v3.35h22.24v-3.43l-.79-.06c-3.68-.26-5.11-.84-5.66-1.28-.74-.59-1.1-1.23-1.1-1.95 0-1.13.53-2.93 1.57-5.34l4.2-9.77h24.12l3.72 8.85c1.23 2.93 1.86 5.07 1.86 6.35 0 .79-.34 1.46-1.05 2.03-.53.43-1.78.96-4.77 1.11l-.81.04v3.45h27.44v-3.44l-.8-.05Zm-32.31-23.61h-15.16l10.04-23.32 7.98 19.01c.86 2.05-.64 4.31-2.86 4.31M212.19 90.77c0 4.9-3.84 8.74-8.85 8.74s-8.9-3.84-8.9-8.74 3.95-8.64 8.9-8.64 8.85 3.84 8.85 8.64m-15.53 0c0 3.84 2.84 6.9 6.74 6.9s6.58-3.05 6.58-6.85-2.79-6.95-6.63-6.95-6.69 3.11-6.69 6.9m5.32 4.53h-2v-8.64c.79-.16 1.9-.26 3.32-.26 1.63 0 2.37.26 3 .63.47.37.84 1.05.84 1.9 0 .95-.74 1.69-1.79 2v.11c.84.32 1.32.95 1.58 2.11.26 1.32.42 1.84.63 2.16h-2.16c-.26-.32-.42-1.11-.68-2.11-.16-.95-.68-1.37-1.79-1.37h-.95v3.48Zm.05-4.9h.95c1.11 0 2-.37 2-1.26 0-.79-.58-1.32-1.84-1.32-.53 0-.9.05-1.11.11zM13.61 96.49h3.16c1.39 0 2.74.35 4 1.04.82.48 1.36 1.03 1.61 1.64.26.66.57 2.27.57 6.23v42.13c0 4.86-.62 6.4-.97 6.88-1.06 1.36-2.76 2.03-5.19 2.03h-3.16v3.49h29.65v-3.49h-3.21a8.1 8.1 0 0 1-3.96-1.04c-.85-.48-1.4-1.03-1.64-1.64-.26-.65-.57-2.27-.57-6.23V105.4c0-4.85.64-6.39 1.02-6.88 1.06-1.36 2.74-2.03 5.14-2.03 1.77 0 3.21-1.44 3.21-3.21V93H13.61z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M35.16 74.21c.61-1.66 1.01-3.27 1.29-4.73a30 30 0 0 0-4.89-.3q-.885.015-1.74.09c.4.41.79.83 1.16 1.26.16-.07.34-.1.53-.1.78 0 1.4.63 1.4 1.4 0 .31-.1.6-.27.83.7 1 1.33 2.05 1.89 3.16.23-.52.44-1.06.64-1.6ZM17.13 69.03c-.93 1.55-1.55 3.3-1.78 5.17.8-.64 1.62-1.22 2.47-1.75q-.435-1.65-.69-3.42M19.31 71.57c-.02-.08-.02-.17-.02-.26a1.398 1.398 0 0 1 2.47-.9c2.01-.83 4.13-1.41 6.33-1.73-1.85-1.65-3.98-3.05-6.37-4.21-1.54.91-2.88 2.13-3.93 3.57.14 1.24.37 2.59.73 3.99.26-.16.53-.31.8-.45ZM39.93 69.36c-.61-1.09-1.38-2.09-2.26-2.96-.06.72-.16 1.54-.31 2.42.96.16 1.82.35 2.57.53ZM31.57 68.39c1.81-.04 3.51.1 5.02.31.18-1.12.29-2.13.35-2.97a13.1 13.1 0 0 0-8.5-3.11c-2.12 0-4.12.5-5.89 1.39q3.69 1.875 6.54 4.53c.82-.09 1.65-.14 2.49-.16ZM20.69 72.72c-.41 0-.79-.18-1.04-.47-.31.17-.62.35-.93.53.68 2.36 1.75 4.81 3.41 7.04q2.31 3.12 5.73 5.16c2.62-2.28 4.71-5.03 6.24-8.25-.61-1.27-1.3-2.47-2.08-3.6-.16.07-.34.1-.53.1a1.398 1.398 0 0 1-1.12-2.24c-.49-.57-1-1.11-1.54-1.63-2.37.28-4.62.86-6.75 1.73a1.398 1.398 0 0 1-1.38 1.62Z",
  className: "ifcax-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40.4 70.29q-.225-.48-.48-.93zh-.03c-.86-.24-1.93-.49-3.15-.7-.28 1.49-.7 3.14-1.32 4.85-.28.78-.6 1.54-.94 2.28.34.74.66 1.5.94 2.28.84 2.31 1.31 4.53 1.57 6.39 2.55-2.4 4.14-5.81 4.14-9.58 0-1.97-.43-3.84-1.21-5.51ZM34.52 77.64a26.5 26.5 0 0 1-5.14 6.98c-.27.26-.54.51-.82.76.23.13.46.25.7.37a1.398 1.398 0 0 1 2.56.78c0 .11-.01.21-.04.31.79.29 1.62.55 2.48.78.9-.44 1.74-.99 2.5-1.61-.24-1.91-.7-4.28-1.61-6.77-.2-.55-.41-1.08-.64-1.6ZM24.46 88.38l-.94-.34c.31.12.62.24.94.34M31.4 87.54c-.25.25-.6.4-.98.4-.78 0-1.4-.63-1.4-1.4v-.03c-.37-.19-.74-.38-1.09-.58-1.07.89-2.23 1.71-3.46 2.45 1.25.4 2.59.61 3.97.61 1.66 0 3.24-.31 4.71-.86-.59-.18-1.17-.37-1.73-.58Z",
  className: "ifcax-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.5 80.28c-1.51-2.04-2.68-4.42-3.47-7.07-.95.61-1.87 1.3-2.77 2.05 0 .18-.01.36-.01.55 0 5.54 3.42 10.29 8.27 12.23 1.33-.76 2.57-1.6 3.71-2.53a20.5 20.5 0 0 1-5.73-5.23",
  className: "ifcax-icon_svg__cls-1"
})));

const SvgIfcaxIssueCertified = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 7.877 10.622"
}, props), /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#334249",
  d: "M1.305 6.826a.093.093 0 0 0-.14.081v2.915a.775.775 0 0 0 1.073.716l1.104-.46a1.16 1.16 0 0 1 .865-.01l1.292.5a.775.775 0 0 0 1.056-.723V6.906a.093.093 0 0 0-.14-.081L4.41 7.983a1.1 1.1 0 0 1-1.1 0Z",
  "data-name": "Path 82394"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#29343a",
  d: "m1.166 6.978 2.546 1.42a1.33 1.33 0 0 0 1.326 0l1.517-.908v-.583a.093.093 0 0 0-.14-.081L4.41 7.984a1.1 1.1 0 0 1-1.1 0L1.305 6.826a.093.093 0 0 0-.14.081Z",
  "data-name": "Path 82395"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2b8ffc",
  d: "M7.52 2.085a.093.093 0 0 0-.147-.013L4.341 5.371a.777.777 0 0 1-1.1 0 5 5 0 0 1-.326-.361c-.313-.383-.691-.936-.691-.936a.65.65 0 0 1-.011-.831.66.66 0 0 1 .831.011c.337.232.338.231.669.482a.09.09 0 0 0 .119-.006l2.542-2.335a.093.093 0 0 0-.016-.149L4.503.173a1.29 1.29 0 0 0-1.286 0L.641 1.659a1.29 1.29 0 0 0-.643 1.114v2.772a1.29 1.29 0 0 0 .643 1.114l2.574 1.486a1.29 1.29 0 0 0 1.286 0l2.574-1.486a1.29 1.29 0 0 0 .643-1.114V2.772a1.3 1.3 0 0 0-.2-.687Z",
  "data-name": "Path 82396"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1f7de3",
  d: "M3.826 5.597a.96.96 0 0 0 1.037-.214l2.783-3.029a1.3 1.3 0 0 0-.128-.266.093.093 0 0 0-.14-.018l-3.031 3.3a.77.77 0 0 1-.521.227",
  "data-name": "Path 82397"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2f4fd",
  d: "M6.922 2.803a.093.093 0 0 0-.162-.063L4.343 5.372a.777.777 0 0 1-1.1 0 5 5 0 0 1-.326-.361c-.313-.383-.691-.936-.691-.936a.65.65 0 0 1-.01-.83.66.66 0 0 1 .831.011c.337.232.338.231.669.482a.09.09 0 0 0 .119-.006l1.926-1.769a.093.093 0 0 0-.016-.149L4.105.867a.49.49 0 0 0-.488 0L1.042 2.35a.49.49 0 0 0-.244.422s.048 1.953.13 2.771a1.7 1.7 0 0 0 .059.354.13.13 0 0 0 .054.069l2.574 1.486a.49.49 0 0 0 .488 0l2.574-1.486a.49.49 0 0 0 .244-.422Z",
  "data-name": "Path 82398"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#b4d8f8",
  d: "M3.826 5.597a.96.96 0 0 0 1.037-.214l2.056-2.238v-.339a.093.093 0 0 0-.162-.063L4.34 5.375a.77.77 0 0 1-.514.222",
  "data-name": "Path 82399"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#66bc6a",
  d: "M3.766 3.539c-.274-.207-.3-.221-.614-.44a.85.85 0 0 0-1.068.011.83.83 0 0 0-.011 1.068s.383.56.7.949a5 5 0 0 0 .34.376.963.963 0 0 0 1.362 0l3.177-3.459A.764.764 0 0 0 6.574.962Z",
  "data-name": "Path 82400"
})));

const SvgIfcaxIssueChecked = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 13.217 6.017"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#69b1e9",
  d: "M8.217.986 7.231 0 3.186 4.045l-2.2-2.2L0 2.831l3.186 3.186Z",
  "data-name": "Path 82402"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2681ff",
  d: "M13.217.986 12.231 0 8.186 4.045l-2.2-2.2L5 2.831l3.186 3.186Z",
  "data-name": "Path 82403"
}));

const SvgIfcaxIssueChop = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 58 51"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#cb8252",
  d: "M34.76 46H4a2.006 2.006 0 0 1-2-2v-3l31-1c.44 1.85.62 4.55 1.76 6"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e64c3c",
  d: "m32 31-10.95 3-10.95-3c.42 0 3.37-.32 4.94-9 1.5-8.28.54-7.6-.74-9.78a7.974 7.974 0 1 1 13.5 0c-1.28 2.18-2.24 1.5-.74 9.78 1.57 8.68 4.52 9 4.94 9"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f29c1f",
  d: "M34.95 38a13 13 0 0 0 .35 3H1a1 1 0 0 1-1-1v-3a6 6 0 0 1 6-6h31a12.9 12.9 0 0 0-2.05 7"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f5efca",
  d: "M17.7 11.2a1 1 0 0 1-.864-.494A4.975 4.975 0 0 1 20.4 3.038a1 1 0 0 1 .231 1.986 2.98 2.98 0 0 0-2.064 4.667A1 1 0 0 1 17.7 11.2"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4fba6f",
  d: "M58 38c0 7.18-5.82 13-13 13s-13-5.82-13-13 5.82-13 13-13 13 5.82 13 13"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M42 45a1 1 0 0 1-.7-.288l-4-3.947a1 1 0 0 1 1.4-1.424l3.359 3.316 10.305-8.431a1 1 0 1 1 1.266 1.548l-11 9A1 1 0 0 1 42 45"
})));

const SvgIfcaxIssueDeploy = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 14 14"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 66686"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h14v14H0z",
  "data-name": "Rectangle 27566"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(1 -19.823)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#bbdefb",
  d: "M9.356 24.8a3.722 3.722 0 0 0-7.368.734c0 .084 0 .17.011.261a2.233 2.233 0 0 0 .237 4.454H2.5q-.01-.122-.012-.248a3.226 3.226 0 1 1 6.452 0q-.001.126-.012.248h.261a2.727 2.727 0 0 0 .167-5.449",
  "data-name": "Path 81503"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 2.73,
  cy: 2.73,
  r: 2.73,
  fill: "#4caf50",
  "data-name": "Ellipse 1966",
  transform: "translate(2.98 27.266)"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#fafafa",
  "data-name": "Group 65635"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.709 31.733a.25.25 0 0 1-.248-.248v-2.978a.25.25 0 0 1 .5 0v2.983a.25.25 0 0 1-.252.243",
  "data-name": "Path 81504"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.702 29.748a.25.25 0 0 1-.176-.072l-.817-.817-.817.817a.248.248 0 0 1-.351-.351l.993-.993a.25.25 0 0 1 .351 0l.993.993a.248.248 0 0 1-.176.423",
  "data-name": "Path 81505"
})))));

const SvgIfcaxIssueNoAction = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  id: "ifcax-issue-no-action_svg__a",
  viewBox: "0 0 512 512",
  width: "1em",
  height: "1em"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".ifcax-issue-no-action_svg__e{fill:#f7f7f7}")), /*#__PURE__*/React.createElement("path", {
  d: "M51.21 171.36h409.6v141.62H51.21z",
  className: "ifcax-issue-no-action_svg__e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M445.45 186.73v110.9H66.57v-110.9z",
  style: {
    fill: "#ee4659"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "m354.41 294.81 67.07 96.77-97.28 67.43-16.59-23.96-84.17-15.26c-7.88-1.43-13.67-8.29-13.67-16.33-.05-5.68 2.82-10.75 7.17-13.77 2.46-1.69 5.38-2.76 8.6-2.92l34.92-1.89 1.48-1.02-61.95-89.29c-4.97-7.17-3.43-17.46 3.69-22.43 3.58-2.51 7.88-3.33 11.88-2.56 3.99.72 7.73 2.97 10.19 6.55l33.84 48.79c-1.23-1.74-2-3.64-2.46-5.58-1.33-6.09.97-12.7 6.45-16.49 3.58-2.51 7.83-3.28 11.83-2.56s7.73 2.97 10.19 6.55l8.86 12.8c-1.43-2.1-2.3-4.4-2.66-6.76-.82-5.73 1.54-11.78 6.66-15.31 3.58-2.51 7.83-3.28 11.83-2.56 2.82.51 5.48 1.74 7.68 3.74.92.82 1.79 1.74 2.51 2.82l7.83 11.32c-1.43-2.05-2.3-4.35-2.66-6.66-.82-5.79 1.54-11.83 6.66-15.41 3.58-2.51 7.83-3.28 11.83-2.56 4.04.67 7.78 2.92 10.29 6.55Z",
  style: {
    fill: "#f7c680"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "m432.08 378.21 14.39 20.74c3.33 4.81 2.15 11.37-2.66 14.69l-103.58 71.83c-4.81 3.33-11.37 2.15-14.69-2.66l-14.39-20.74c-3.33-4.81-2.15-11.37 2.66-14.69l103.58-71.83c4.81-3.33 11.37-2.1 14.69 2.66",
  style: {
    fill: "#626c78"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 424.3,
  cy: 399,
  r: 5.89,
  className: "ifcax-issue-no-action_svg__e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M222.47 279.45c3.53 5.12-3.07 4.4-8.19 7.94s-6.76 9.98-10.29 4.86-2.25-12.08 2.82-15.67 12.13-2.25 15.67 2.87ZM229.84 391.52c6.2.56 1.38 5.17.87 11.37-.56 6.2 3.38 11.57-2.82 11.06-6.2-.56-10.75-5.99-10.24-12.19.56-6.2 5.99-10.8 12.19-10.24M125.45 258.35l-4.2 10.34h-12.39l23.09-53.25h12.39l22.73 53.25h-12.85l-4.2-10.34h-24.58Zm12.39-30.31-8.45 20.68h16.79l-8.35-20.68ZM216.84 223.94l-7.01 8.5c-3.64-4.2-8.91-6.91-13.82-6.91-9.11 0-16.18 7.07-16.18 16.33s7.07 16.44 16.18 16.44c4.81 0 10.04-2.46 13.82-6.25l7.07 7.68c-5.63 5.79-13.77 9.52-21.5 9.52-15.87 0-27.9-11.78-27.9-27.24s12.24-26.93 28.36-26.93c7.68 0 15.72 3.43 20.99 8.86ZM247.05 225.69v43.06h-12.03v-43.06h-16.18V215.5h44.49v10.19zM269.78 268.69v-53.25h12.03v53.25zM346.99 242.12c0 15.36-12.34 27.14-28.57 27.14s-28.57-11.72-28.57-27.14 12.34-26.98 28.57-26.98c16.23-.05 28.57 11.52 28.57 26.98m-44.85 0c0 9.37 7.53 16.64 16.44 16.64s16.13-7.32 16.13-16.64-7.22-16.49-16.13-16.49c-9.01-.05-16.44 7.12-16.44 16.49M392.2 268.69l-25.75-34.15v34.15h-11.47v-53.25h10.96l25.86 34.2v-34.2h11.42v53.25h-11.01Z",
  className: "ifcax-issue-no-action_svg__e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M512 256.5c0-68.1-27.4-132-75.7-180.3S324.1.5 256 .5C197.8.5 142.9 20.7 98.2 56.4q-11.7 9-22.5 19.8T55.9 98.7C20.2 143.4 0 198.3 0 256.5c0 68.1 27.4 132 75.7 180.3s112.2 75.7 180.3 75.7c57.9 0 112.8-20.2 157.5-55.9 8.1-5.7 15.6-12.6 22.8-19.8s14.1-14.7 19.8-22.8c35.7-44.7 55.9-99.6 55.9-157.5M98.8 141.6 370.9 414c-33 24.3-72.9 37.5-114.9 37.5-52.2 0-101.1-20.4-138-57-36.6-36.9-57-85.8-57-138 0-42 13.2-81.9 37.8-114.9M451 256.5c0 42-13.2 81.9-37.5 114.9L141.1 99.3c33-24.6 72.9-37.8 114.9-37.8 52.2 0 101.1 20.4 138 57 36.6 36.9 57 85.8 57 138",
  style: {
    fill: "#ff4848"
  }
}));

const SvgIfcaxIssueOpen = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 14 14"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 66684"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h14v14H0z",
  "data-name": "Rectangle 27563"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#033a5d",
  d: "M7.989 2.173h-4.3a.413.413 0 0 0-.418.4v10.11a.41.41 0 0 0 .418.4h7.761a.41.41 0 0 0 .418-.4V2.573a.413.413 0 0 0-.418-.4Z",
  "data-name": "Path 68592"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M11.066 12.482H4.178a.187.187 0 0 1-.189-.184V2.946a.187.187 0 0 1 .189-.184h6.888a.187.187 0 0 1 .189.184v9.352a.187.187 0 0 1-.189.184",
  "data-name": "Path 68593"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00467d",
  d: "M8.309 1.638a.728.728 0 0 0-1.455 0H5.261v1.554h4.641V1.638Z",
  "data-name": "Path 68594"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M7.892 1.663a.316.316 0 1 1-.316-.316.316.316 0 0 1 .316.316",
  "data-name": "Path 68595"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#033a5d",
  d: "M5.261 2.762h4.641v.431H5.261z",
  "data-name": "Rectangle 26102"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M7.209 3.982h1.124v.212H7.209z",
  "data-name": "Rectangle 26103"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M7.228 4.508h3.134v.212H7.228z",
  "data-name": "Rectangle 26104"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M7.228 5.019h3.134v.212H7.228z",
  "data-name": "Rectangle 26105"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M7.228 5.531h3.134v.212H7.228z",
  "data-name": "Rectangle 26106"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M7.228 7.525h3.134v.212H7.228z",
  "data-name": "Rectangle 26107"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M7.228 8.037h3.134v.212H7.228z",
  "data-name": "Rectangle 26108"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M7.228 8.548h3.134v.212H7.228z",
  "data-name": "Rectangle 26109"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M7.228 10.534h3.134v.212H7.228z",
  "data-name": "Rectangle 26110"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M7.228 11.006h3.134v.212H7.228z",
  "data-name": "Rectangle 26111"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M7.228 11.528h3.134v.212H7.228z",
  "data-name": "Rectangle 26112"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M7.209 6.996h1.124v.212H7.209z",
  "data-name": "Rectangle 26113"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M7.209 10.009h1.124v.212H7.209z",
  "data-name": "Rectangle 26114"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffcb00",
  d: "M6.657 4.869a.9.9 0 1 1-.9-.9.9.9 0 0 1 .9.9",
  "data-name": "Path 68596"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m5.664 5.353-.515-.493.193-.2.314.3.515-.538.2.193Z",
  "data-name": "Path 68597"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4ad395",
  d: "M6.657 10.818a.9.9 0 1 1-.9-.9.9.9 0 0 1 .9.9",
  "data-name": "Path 68598"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m5.664 11.306-.515-.493.193-.2.314.3.515-.538.2.193Z",
  "data-name": "Path 68599"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4fabf7",
  d: "M7.256 9.478a2.272 2.272 0 1 0-3.213-.051 2.27 2.27 0 0 0 3.213.051",
  "data-name": "Path 68600"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M5.677 9.642A1.794 1.794 0 1 1 7.5 7.877a1.794 1.794 0 0 1-1.823 1.765",
  "data-name": "Path 68601"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#434b56",
  d: "M4.043 9.395a2.3 2.3 0 0 1-.229-.282l-.379.367.561.579.388-.376a2.3 2.3 0 0 1-.341-.288",
  "data-name": "Path 68602"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4fabf7",
  d: "m2.813 11.133 1.181-1.144-.56-.579-1.181 1.144a.403.403 0 1 0 .56.579",
  "data-name": "Path 68603"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ff5163",
  d: "M7.12 7.851a1.413 1.413 0 1 1-1.413-1.413A1.413 1.413 0 0 1 7.12 7.851",
  "data-name": "Path 68604"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m5.559 8.621-.811-.777.3-.317.495.473.811-.846.317.3Z",
  "data-name": "Path 68605"
})));

const SvgIfcaxIssueProgress = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 14 14"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 66685"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h14v14H0z",
  "data-name": "Rectangle 27564"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 65881"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 65617"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#6e83b7",
  d: "M8.041 9.439H5.958l-1.611.364a2.37 2.37 0 0 0-1.846 2.31v.712h9v-.712a2.37 2.37 0 0 0-1.846-2.309Z",
  "data-name": "Path 81484"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 65618"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#edeff1",
  d: "M6.999 10.954A1.517 1.517 0 0 0 8.51 9.545l-.469-.106H5.957l-.469.106a1.517 1.517 0 0 0 1.511 1.409",
  "data-name": "Path 81485"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 65619"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#ffd3b3",
  d: "M5.958 8.26v1.179a1.042 1.042 0 1 0 2.084 0V8.26Z",
  "data-name": "Path 81486"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 65620"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fcb98b",
  d: "M5.958 8.798a2.63 2.63 0 0 0 2.084 0V8.26H5.958Z",
  "data-name": "Path 81487"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 65621"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#ffd3b3",
  d: "M9.154 4.964v1.421a2.155 2.155 0 0 1-4.309 0V4.964Z",
  "data-name": "Path 81488"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 65622"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#6e83b7",
  d: "m8.586 4.964.568 1.421V4.964Z",
  "data-name": "Path 81489"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 65623"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#6e83b7",
  d: "m5.413 4.964-.568 1.421V4.964Z",
  "data-name": "Path 81490"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 65624"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#ffd3b3",
  d: "M4.514 6.124h.331v-1.16h-.331a.237.237 0 0 0-.237.237v.687a.237.237 0 0 0 .237.236",
  "data-name": "Path 81491"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 65625"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#ffd3b3",
  d: "M9.486 6.124h-.332v-1.16h.331a.237.237 0 0 1 .237.237v.687a.237.237 0 0 1-.236.236",
  "data-name": "Path 81492"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 65626"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#466089",
  d: "M9.607 12.115h.237v.71h-.237Z",
  "data-name": "Path 81493"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 65627"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#466089",
  d: "M4.155 12.115h.237v.71h-.237Z",
  "data-name": "Path 81494"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 65628"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.466 4.964v-.923a2.534 2.534 0 1 1 5.067 0v.923Z",
  "data-name": "Path 81495"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 65629"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#ffe352",
  d: "M7 4.263a27 27 0 0 1 3.173.275v.426H3.827v-.426A27 27 0 0 1 7 4.263",
  "data-name": "Path 81496"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 65630"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#ffb236",
  d: "M6.999 1.507a2.5 2.5 0 0 0-1.4.42l.15 2.395H8.24l.15-2.395a2.5 2.5 0 0 0-1.391-.42",
  "data-name": "Path 81497"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 65631"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.087 3.982h1.824l.162-2.6a2.87 2.87 0 0 0-2.149 0Z",
  "data-name": "Path 81498"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 65632"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#ffe352",
  d: "M9.249 11.302v-1.59l-.663-.15v1.724a.947.947 0 0 1-.947.947H6.36a.947.947 0 0 1-.947-.947V9.564l-.663.15v1.59a.95.95 0 0 1-.165.533l-.191.28v.71h5.209v-.71l-.191-.28a.95.95 0 0 1-.163-.535",
  "data-name": "Path 81499"
})))));

const SvgIfcaxIssueQc = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 14 14"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 66687"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h14v14H0z",
  "data-name": "Rectangle 27565"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-53.53 -22.242)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#4f5659",
  d: "M56.723 30.146h6.147a.723.723 0 0 1 .723.723v3.616H56v-3.616a.723.723 0 0 1 .723-.723",
  "data-name": "Path 81509"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#7e8589",
  d: "M57.446 30.146h4.7v2.531h-4.7Z",
  "data-name": "Path 81510"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e9eef2",
  d: "m61.062 30.146-.759 2.242-.145.289h-.727l-.145-.289-.755-2.242Z",
  "data-name": "Path 81511"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#6a7073",
  d: "m60.302 32.388-.145.289h-.723l-.145-.289.145-1.157h.723Z",
  "data-name": "Path 81512"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4f5659",
  d: "M59.435 30.146h.723v1.085h-.723Z",
  "data-name": "Path 81513"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#dadcde",
  d: "m59.977 30.146-1.446 1.085v-1.085Z",
  "data-name": "Path 81514"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#dadcde",
  d: "m59.616 30.146 1.446 1.085v-1.085Z",
  "data-name": "Path 81515"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#95573a",
  d: "M64.316 33.943h-.723v-2.892h.723Z",
  "data-name": "Path 81516"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#596063",
  d: "M59.796 32.677h.723v1.808h-.723Z",
  "data-name": "Path 81517"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#6a7073",
  d: "M59.073 32.677h.723v1.808h-.723Z",
  "data-name": "Path 81518"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5e3725",
  d: "M63.231 29.604h1.446v1.446h-1.446Z",
  "data-name": "Path 81519"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 0.686,
  cy: 0.686,
  r: 0.686,
  fill: "#f0c6a4",
  "data-name": "Ellipse 1985",
  transform: "translate(61.491 27.294)"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 0.755,
  cy: 0.686,
  fill: "#f0c6a4",
  "data-name": "Ellipse 1986",
  rx: 0.755,
  ry: 0.686,
  transform: "translate(56.686 27.294)"
}), /*#__PURE__*/React.createElement("rect", {
  width: 4.667,
  height: 5.491,
  fill: "#f7cca9",
  "data-name": "Rectangle 27491",
  rx: 2.334,
  transform: "translate(57.51 24.686)"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#452d23",
  "data-name": "Group 65708",
  transform: "translate(58.745 27.796)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 0.206,
  cy: 0.137,
  "data-name": "Ellipse 1987",
  rx: 0.206,
  ry: 0.137,
  transform: "translate(1.785 .047)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 0.137,
  cy: 0.137,
  r: 0.137,
  "data-name": "Ellipse 1988",
  transform: "translate(0 .047)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.231.723H.869A.18.18 0 0 1 .688.542V.18a.181.181 0 0 1 .362 0v.181h.181a.181.181 0 1 1 0 .362",
  "data-name": "Path 81520"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#4f5659",
  d: "M62.12 27.615a1.41 1.41 0 0 1-.9-1.206s-2.865 1.034-3.761 1.206a1.84 1.84 0 0 1-.534-1.769c.176-1.333 2.862-2.711 4.474-1.161a1.61 1.61 0 0 1 1.257 1.329 2.02 2.02 0 0 1-.514 1.6Z",
  "data-name": "Path 81521"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f7cca9",
  d: "M63.593 33.039h.723a.36.36 0 0 1 .362.362v.723a.36.36 0 0 1-.362.362h-.723Z",
  "data-name": "Path 81522"
}), /*#__PURE__*/React.createElement("rect", {
  width: 0.686,
  height: 1.785,
  fill: "#95573a",
  "data-name": "Rectangle 27492",
  rx: 0.343,
  transform: "translate(64.374 29.491)"
}), /*#__PURE__*/React.createElement("rect", {
  width: 0.686,
  height: 1.785,
  fill: "#95573a",
  "data-name": "Rectangle 27493",
  rx: 0.343,
  transform: "translate(62.864 29.491)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#452d23",
  d: "M60.154 29.243h-.723a.181.181 0 1 1 0-.362h.723a.181.181 0 1 1 0 .362",
  "data-name": "Path 81523"
}))));

const SvgIfcaxIssueReopened = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 512 512"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#463c4b",
  d: "M456 392H24V184c0-17.673 14.327-32 32-32h368c17.673 0 32 14.327 32 32z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#555a6e",
  d: "M424 392H24V184c0-17.673 14.327-32 32-32h336c17.673 0 32 14.327 32 32z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#a5c3dc",
  d: "M56 432h368c17.673 0 32-14.327 32-32v-8H24v8c0 17.673 14.327 32 32 32"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#d7e6f0",
  d: "M392 432H56c-17.673 0-32-14.327-32-32v-8h400v8c0 17.673-14.327 32-32 32"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#a5c3dc",
  d: "M192 432h72v32h-72z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#d7e6f0",
  d: "M192 448h48v16h-48zM304 488H144v-8c0-8.837 7.163-16 16-16h128c8.837 0 16 7.163 16 16z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#a5c3dc",
  d: "M304 488h-48v-8c0-8.837 7.163-16 16-16h16c8.837 0 16 7.163 16 16z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#d7e6f0",
  d: "M112 324a11.96 11.96 0 0 1-8.485-3.515l-40-40c-4.686-4.687-4.686-12.284 0-16.971l40-40c4.687-4.686 12.284-4.686 16.971 0 4.686 4.687 4.686 12.284 0 16.971L88.971 272l31.515 31.515c4.686 4.687 4.686 12.284 0 16.971A11.97 11.97 0 0 1 112 324M224 324a11.96 11.96 0 0 1-8.485-3.515c-4.686-4.687-4.686-12.284 0-16.971L247.029 272l-31.515-31.515c-4.686-4.687-4.686-12.284 0-16.971 4.687-4.686 12.284-4.686 16.971 0l40 40c4.686 4.687 4.686 12.284 0 16.971l-40 40A11.96 11.96 0 0 1 224 324M151.996 324.003c-1.483 0-2.991-.276-4.453-.861-6.153-2.461-9.146-9.445-6.685-15.599l32-80c2.461-6.152 9.444-9.146 15.598-6.685 6.153 2.461 9.146 9.445 6.685 15.599l-32 80c-1.876 4.691-6.383 7.546-11.145 7.546"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#289bc3",
  d: "M296 368h160c17.673 0 32-14.327 32-32V208c0-17.673-14.327-32-32-32H296c-17.673 0-32 14.327-32 32v128c0 17.673 14.327 32 32 32"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00d2d2",
  d: "M296 368h112c17.673 0 32-14.327 32-32V208c0-17.673-14.327-32-32-32H296c-17.673 0-32 14.327-32 32v128c0 17.673 14.327 32 32 32"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ff6e91",
  d: "M328 176h-32v-70.98c0-44.044 35.169-80.589 79.211-81.016C419.684 23.573 456 59.625 456 104c0 8.837-7.163 16-16 16h-.806c-8.392 0-15.194-6.803-15.194-15.194 0-26.284-20.793-48.298-47.072-48.797C350.038 55.499 328 77.225 328 104z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#555a6e",
  d: "M384 240c0-18.425-15.573-33.214-34.274-31.921-15.791 1.091-28.577 13.895-29.65 29.688-.867 12.768 5.765 24.063 15.924 29.942V320c0 8.837 7.163 16 16 16s16-7.163 16-16v-52.292c9.562-5.533 16-15.865 16-27.708"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ff6e91",
  d: "M472 144a7.999 7.999 0 0 1-5.657-13.657l16-16a8 8 0 0 1 11.313 0 8 8 0 0 1 0 11.314l-16 16A7.97 7.97 0 0 1 472 144M408 144a7.98 7.98 0 0 1-5.657-2.343l-16-16a8 8 0 0 1 0-11.314 8 8 0 0 1 11.313 0l16 16a8 8 0 0 1 0 11.314A7.97 7.97 0 0 1 408 144"
}));

const SvgIfcaxIssues = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 29.738 37.172"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#033a5d",
  d: "M17.889 3.842H4.76a1.26 1.26 0 0 0-1.278 1.233v30.867a1.26 1.26 0 0 0 1.278 1.232h23.7a1.26 1.26 0 0 0 1.277-1.232V5.074a1.26 1.26 0 0 0-1.277-1.233Z",
  "data-name": "Path 68592"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M27.288 35.322H6.251a.57.57 0 0 1-.577-.562V6.205a.57.57 0 0 1 .577-.562h21.036a.57.57 0 0 1 .577.562v28.559a.57.57 0 0 1-.577.562",
  "data-name": "Path 68593"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00467d",
  d: "M18.867 2.213a2.221 2.221 0 0 0-4.443 0H9.559V6.96h14.173V2.213Z",
  "data-name": "Path 68594"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M17.594 2.286a.964.964 0 1 1-.964-.964.964.964 0 0 1 .964.964",
  "data-name": "Path 68595"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#033a5d",
  d: "M9.56 5.643h14.173V6.96H9.56z",
  "data-name": "Rectangle 26102"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M15.508 9.369h3.432v.648h-3.432z",
  "data-name": "Rectangle 26103"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M15.566 10.974h9.571v.648h-9.571z",
  "data-name": "Rectangle 26104"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M15.566 12.537h9.571v.648h-9.571z",
  "data-name": "Rectangle 26105"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M15.566 14.099h9.571v.648h-9.571z",
  "data-name": "Rectangle 26106"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M15.566 20.189h9.571v.648h-9.571z",
  "data-name": "Rectangle 26107"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M15.566 21.751h9.571v.648h-9.571z",
  "data-name": "Rectangle 26108"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M15.566 23.314h9.571v.648h-9.571z",
  "data-name": "Rectangle 26109"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M15.566 29.378h9.571v.648h-9.571z",
  "data-name": "Rectangle 26110"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M15.566 30.818h9.571v.648h-9.571z",
  "data-name": "Rectangle 26111"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M15.566 32.415h9.571v.648h-9.571z",
  "data-name": "Rectangle 26112"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M15.508 18.572h3.432v.648h-3.432z",
  "data-name": "Rectangle 26113"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M15.508 27.775h3.432v.648h-3.432z",
  "data-name": "Rectangle 26114"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffcb00",
  d: "M13.821 12.079a2.74 2.74 0 1 1-2.74-2.74 2.74 2.74 0 0 1 2.74 2.74",
  "data-name": "Path 68596"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M10.79 13.557 9.216 12.05l.588-.614.96.919 1.574-1.642.614.588Z",
  "data-name": "Path 68597"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4ad395",
  d: "M13.821 30.246a2.74 2.74 0 1 1-2.74-2.74 2.74 2.74 0 0 1 2.74 2.74",
  "data-name": "Path 68598"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M10.79 31.737 9.216 30.23l.588-.614.96.919 1.574-1.642.614.588Z",
  "data-name": "Path 68599"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4fabf7",
  d: "M15.652 26.151a6.939 6.939 0 1 0-9.812-.157 6.94 6.94 0 0 0 9.812.157",
  "data-name": "Path 68600"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M10.827 26.654a5.479 5.479 0 1 1 5.566-5.391 5.48 5.48 0 0 1-5.566 5.391",
  "data-name": "Path 68601"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#434b56",
  d: "M5.838 25.899a7 7 0 0 1-.7-.86L3.981 26.16l1.712 1.767 1.185-1.148a7 7 0 0 1-1.04-.88",
  "data-name": "Path 68602"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4fabf7",
  d: "m2.084 31.206 3.608-3.494-1.711-1.767-3.606 3.494a1.23 1.23 0 0 0 1.711 1.767",
  "data-name": "Path 68603"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ff5163",
  d: "M15.237 21.186a4.314 4.314 0 1 1-4.314-4.314 4.314 4.314 0 0 1 4.314 4.314",
  "data-name": "Path 68604"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m10.466 23.535-2.478-2.372.926-.967 1.511 1.446 2.478-2.584.967.926Z",
  "data-name": "Path 68605"
}));

const SvgIfcaxLogOut = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 20 20.001"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#2196f3",
  d: "M11.714 10.828a2.5 2.5 0 0 1 0-5h1.673V2.501a2.507 2.507 0 0 0-2.509-2.5h-9a.84.84 0 0 0-.682.361.83.83 0 0 0-.092.769l6.064 15.823a.84.84 0 0 0 .782.536h2.929a2.507 2.507 0 0 0 2.51-2.5v-4.162Z",
  "data-name": "Path 68768"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1d83d4",
  d: "M9.175 8.287H3.832l3.307 8.666a.835.835 0 0 0 .778.534h2.929a2.513 2.513 0 0 0 2.51-2.51v-4.18h-1.671a2.513 2.513 0 0 1-2.51-2.51",
  "data-name": "Path 68769"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#607d8b",
  d: "M15.496 12.455a.84.84 0 0 1-.516-.773V9.175h-3.347a.837.837 0 0 1 0-1.673h3.347v-2.51a.837.837 0 0 1 1.428-.592l3.347 3.347a.836.836 0 0 1 0 1.183l-3.347 3.347a.84.84 0 0 1-.912.182Z",
  "data-name": "Path 68770"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#546d79",
  d: "M19.996 8.325h-9.2a.837.837 0 0 0 .837.837h3.347v2.51a.837.837 0 0 0 1.428.592l3.347-3.347a.83.83 0 0 0 .241-.592",
  "data-name": "Path 68771"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#64b5f6",
  d: "M7.234 1.752 2.206.083A1.684 1.684 0 0 0 0 1.667v15a1.68 1.68 0 0 0 1.133 1.582l5.028 1.669a1.8 1.8 0 0 0 .533.082 1.67 1.67 0 0 0 1.673-1.667v-15a1.68 1.68 0 0 0-1.133-1.581",
  "data-name": "Path 68772"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#579ed6",
  d: "M8.367 9.96H0v6.694a1.68 1.68 0 0 0 1.133 1.588l5.028 1.676a1.8 1.8 0 0 0 .533.083 1.675 1.675 0 0 0 1.673-1.673Z",
  "data-name": "Path 68773"
}));

const SvgIfcaxMainBrochure = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 30 30"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 66566"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#3c8cff",
  d: "M25.489 4.594a.63.63 0 0 0-.588-.063l-6.523 2.608-6.522-2.609a.63.63 0 0 0-.469 0L4.634 7.233a.63.63 0 0 0-.4.586v17.566a.63.63 0 0 0 .865.586l6.522-2.609 6.522 2.609a.63.63 0 0 0 .469 0l6.757-2.7a.63.63 0 0 0 .4-.586V5.116a.63.63 0 0 0-.277-.522Z",
  "data-name": "Path 81612"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00beff",
  d: "M25.489 4.593a.63.63 0 0 0-.588-.063l-6.522 2.609-6.524-2.609a.6.6 0 0 0-.233-.045v18.878l6.522 2.609a.63.63 0 0 0 .469 0l6.757-2.7a.63.63 0 0 0 .4-.586V5.116a.63.63 0 0 0-.277-.522Z",
  "data-name": "Path 81613"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3c8cff",
  d: "M25.489 4.594a.63.63 0 0 0-.589-.064l-6.522 2.609L15 5.785v18.929l3.144 1.258a.63.63 0 0 0 .469 0l6.757-2.7a.63.63 0 0 0 .4-.586V5.116a.63.63 0 0 0-.277-.522Z",
  "data-name": "Path 81614"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5a5aff",
  d: "m18.612 25.972 6.757-2.7a.63.63 0 0 0 .4-.586V5.116a.63.63 0 0 0-.865-.586l-6.522 2.609v18.878a.6.6 0 0 0 .23-.045",
  "data-name": "Path 81615"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#c3dcf5",
  "data-name": "Group 65995"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.144 22.152a.63.63 0 0 1 .351-.82l2.7-1.081a.631.631 0 0 1 .469 1.171l-2.7 1.081a.63.63 0 0 1-.82-.351",
  "data-name": "Path 81616"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.144 19.224a.63.63 0 0 1 .351-.82l2.7-1.081a.631.631 0 0 1 .469 1.171l-2.7 1.081a.63.63 0 0 1-.82-.351",
  "data-name": "Path 81617"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.937 21.378V18.45a.63.63 0 0 1 .4-.586l2.7-1.081a.63.63 0 0 1 .865.586v2.928a.63.63 0 0 1-.4.586l-2.7 1.081a.63.63 0 0 1-.865-.586",
  "data-name": "Path 81618"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.144 16.297a.63.63 0 0 1 .351-.82l2.7-1.081a.631.631 0 0 1 .469 1.171l-2.7 1.081a.63.63 0 0 1-.82-.351",
  "data-name": "Path 81619"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#e1e6f5",
  d: "M6.982 15.755a.63.63 0 0 1 .351-.82l2.7-1.081a.631.631 0 0 1 .469 1.171l-2.7 1.081a.63.63 0 0 1-.82-.351",
  "data-name": "Path 81620"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#c3dcf5",
  d: "M19.144 13.368a.63.63 0 0 1 .351-.82l2.7-1.081a.631.631 0 0 1 .469 1.171l-2.7 1.081a.63.63 0 0 1-.82-.351",
  "data-name": "Path 81621"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e1e6f5",
  d: "M6.982 12.828a.63.63 0 0 1 .351-.82l2.7-1.081a.631.631 0 0 1 .469 1.171l-2.7 1.081a.63.63 0 0 1-.82-.351",
  "data-name": "Path 81622"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#c3dcf5",
  d: "M19.144 10.441a.63.63 0 0 1 .351-.82l2.7-1.081a.631.631 0 0 1 .469 1.171l-2.7 1.081a.63.63 0 0 1-.82-.351",
  "data-name": "Path 81623"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e1e6f5",
  d: "M6.982 9.9a.63.63 0 0 1 .351-.82l2.7-1.081a.631.631 0 0 1 .469 1.171l-2.7 1.081a.63.63 0 0 1-.82-.351",
  "data-name": "Path 81624"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#faf0fa",
  d: "m16.117 22.233-2.7-1.081a.631.631 0 0 1 .469-1.171l2.7 1.081a.631.631 0 0 1-.469 1.171",
  "data-name": "Path 81625"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e1e6f5",
  d: "M16.586 21.061 15 20.427v1.359l1.117.447a.631.631 0 0 0 .469-1.171Z",
  "data-name": "Path 81626"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#faf0fa",
  d: "m16.117 19.305-2.7-1.081a.631.631 0 0 1 .469-1.171l2.7 1.081a.631.631 0 0 1-.469 1.171",
  "data-name": "Path 81627"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e1e6f5",
  d: "M16.586 18.132 15 17.499v1.359l1.117.447a.631.631 0 0 0 .469-1.171Z",
  "data-name": "Path 81628"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e1e6f5",
  d: "m16.117 16.377-2.7-1.081a.63.63 0 0 1-.4-.586V8.854a.63.63 0 0 1 .865-.586l2.7 1.081a.63.63 0 0 1 .4.586v5.856a.63.63 0 0 1-.865.586",
  "data-name": "Path 81629"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#c3dcf5",
  d: "M16.586 9.35 15 8.716v7.215l1.117.447a.63.63 0 0 0 .865-.586V9.936a.63.63 0 0 0-.396-.586",
  "data-name": "Path 81630"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h30v30H0z",
  "data-name": "Rectangle 27534"
})));

const SvgIfcaxMarketing = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 37 37"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 66467"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h37v37H0z",
  "data-name": "Rectangle 27534"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(3.517 4.59)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 10.612,
  cy: 10.612,
  r: 10.612,
  fill: "#55c0eb",
  "data-name": "Ellipse 2008",
  transform: "translate(7.283 3.373)"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#f3f3f3",
  "data-name": "Group 66038"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.758 11.613a.094.094 0 0 1 .178.059c0 .059.059.059 0 .119v.119c.059.059 0 .059 0 .059v.119c0 .059 0 .059.059.119v.059c0 .059.059.118.119.059 0-.059.059-.119.059-.178v-.711c0-.059.059-.119.059-.178a.13.13 0 0 1 .119-.119c.059 0 .059-.059.119-.059s.059-.059.059-.119c.059-.059.059-.059.119-.059h.059c.059-.059.119-.059.178-.119v-.059h.059c.059-.059-.059-.059-.059-.119h.119v-.117a.11.11 0 0 0 0-.178h.119c.059.059.119 0 .119-.059v-.119l.059.059.119-.119c.059-.059 0-.119.059-.119h.059v-.059c.119 0 .178-.059.3-.059a.06.06 0 0 0 .059-.059.22.22 0 0 1 .059-.178.18.18 0 0 1 .119-.059.06.06 0 0 0 .059-.059.22.22 0 0 1 .178-.059h.059c.059-.059.119-.059.178-.119a.22.22 0 0 1 .178-.059.2.2 0 0 1 .059.119h-.119c-.059 0-.059.059-.119.059a.2.2 0 0 0-.059.119.22.22 0 0 0 .178-.059c.059-.059.119-.059.178-.119s.178-.059.237-.119a.06.06 0 0 1-.059-.059c-.059.119-.059 0-.119 0s-.059-.059-.119-.119.059-.119 0-.178c.059 0 .059 0 .119-.059a.2.2 0 0 0 .059-.119h-.237c-.059 0-.119.059-.178.059s-.059 0-.119.059h-.059c0-.059.119-.059.178-.119s.119-.059.178-.119.059-.059.119-.059h.711a.13.13 0 0 0 .119-.119l.059-.059h.178l.119-.059c0-.059.059-.178.059-.237h-.119c0-.059-.059-.059-.059-.119v-.059c-.059 0-.119-.059-.178-.059-.059-.059-.059-.119-.119-.178h.059v-.3c-.059 0 0-.059 0-.119v-.059c-.119.059-.178.178-.3.237l-.059-.059c-.059 0-.059.059-.119.059h-.059c-.059-.059-.059-.119-.119-.178 0-.059.119-.119.059-.237h-.119v-.119a.44.44 0 0 0-.3-.059h-.119c-.059-.059-.059-.059-.119 0h-.059c0 .059 0 .119-.059.119a.22.22 0 0 0-.059.178c-.059.059-.119.059-.178.119 0 .059 0 .059.059.059.059.059.059.059 0 .119v.059c0 .059-.059.119-.119.178s-.119.059-.178.119c-.059 0-.119.059-.178.059v.356a.13.13 0 0 0-.119.119c-.059 0-.119 0-.119.059-.059-.059-.059-.119-.119-.178l.059-.059c0-.059.059-.178.059-.237h.059c0-.059-.059-.059-.059-.119h-.112a10.6 10.6 0 0 0-1.778 3.794c.119-.056.178.003.238.062",
  "data-name": "Path 81682"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.374 21.928c-.059 0-.059-.059 0 0-.119-.059-.119-.119-.119-.178v-.059c-.059 0-.119 0-.119-.059s-.059-.059-.059-.119h.178a.36.36 0 0 0 .237.059c.059 0 .119-.059.178-.119 0-.059.059-.059.059-.119l.059-.059c0-.059.059-.119.059-.237 0-.059.059-.119.059-.178h.059c0-.059.059-.119.059-.178h.059a.22.22 0 0 1 .059-.178v-.059c-.059-.059 0-.119-.059-.178 0-.119 0-.178.059-.237l.059-.059c.059-.059.059-.059.119-.059s.059 0 .119-.059l.059-.059a.22.22 0 0 0 .178-.059.06.06 0 0 0 .059-.059l.119-.119c0-.059-.059-.059 0-.119a.22.22 0 0 0 .059-.178.06.06 0 0 1 .059-.059c.059-.059.059-.059 0-.119a.06.06 0 0 0 .059-.059c0-.059.059-.178.059-.237v-.652h.119c.059-.119.119-.178.119-.3a.06.06 0 0 1 .059-.059c.059 0 .059-.059.119-.119v-.059c.059-.059.059-.059.059-.178v-.059c.059 0 0-.059 0-.119a.36.36 0 0 0-.059-.237c0-.059-.059-.178-.178-.119-.059 0-.059-.059-.119-.059-.059-.059-.059-.119-.119-.119s-.059-.059-.119-.119l-.059-.059a.36.36 0 0 1-.237-.059c-.059 0-.059 0-.119-.059h-.059c-.059.059-.059 0-.119 0l.059-.059c-.059-.059-.059-.119-.119-.119a.22.22 0 0 0-.178-.059h-.178c0 .059 0 .059-.059.059v-.119h-.178a.06.06 0 0 1-.059-.059h-.059c0-.059.059 0 .059-.059a.06.06 0 0 0-.059-.059c0-.059.059-.119.059-.178-.059 0-.119 0-.119-.059s-.059-.178-.059-.237h-.059a.13.13 0 0 0-.119-.119l-.059-.059c-.119-.059-.178-.119-.3-.059h-.237l-.178-.178c0-.059-.059-.059-.059-.118s-.059-.059-.119-.119h-.114c0-.059 0-.059.059-.119a.3.3 0 0 0-.237-.119c0-.119-.119-.178-.178-.059a.06.06 0 0 1-.059.059c-.059 0-.178.059-.237-.059-.059.059-.178 0-.237.059v-.059c0-.119-.119-.178-.237-.119-.059.059-.119.059-.178.119v.059c.059.059 0 .119 0 .178-.059 0-.059 0-.119-.059v-.119c.059-.059.059-.118 0-.237.059 0 .059-.059.119-.059v-.059h-.119v.059c-.059 0-.059.059-.119.059s-.178.059-.237.059l-.059.059c0 .059-.059.059-.059.119v.059l-.119.119v.059-.059h-.059c0-.059 0-.119-.059-.119s-.059 0-.119-.059h-.059a.3.3 0 0 1-.237.119c-.059 0-.119 0-.119-.059a.06.06 0 0 0-.059-.059h-.059c0-.059-.059-.059-.059-.119v-.059c0-.119.059-.237.059-.356a.36.36 0 0 0 .059-.237h-.119v-.059h-.237v.711c0 .059.059.059 0 .059v.118c.059 0 .059 0 .059-.059.059.119.178.178.178.3h.178v.059h.059v.059a.06.06 0 0 0 .059-.059c.059-.059-.059-.059 0-.119.059 0 .059 0 .059-.059s.059-.059.119 0a.2.2 0 0 0 .119.059.11.11 0 0 0 0 .178c.059.059.119.119.059.237v.178c0 .059 0 .059-.059.119.059.059.059.059 0 .059a.22.22 0 0 0-.059.178h-.119v.119c0 .059 0 .119-.059.119a.116.116 0 0 0-.119.119.06.06 0 0 1-.059.059.53.53 0 0 0-.059.3h.119c0 .119-.119.178-.178.237v.059c0 .119.059.178.059.237l.059.059a.06.06 0 0 1 .059.059c0 .059 0 .059.059.119.119.119.119.237.178.415v.059c.059.059.059.119.119.178s.059.178.119.237l.059.059c0 .059.059.118.059.178a1.6 1.6 0 0 0 .356.3c.119.059.178.059.237.178a.46.46 0 0 0 .178.119v.118c.059.059 0 .119.059.237v.059a.26.26 0 0 1 0 .3v.059c.059.059 0 .119.059.178v.119a.11.11 0 0 0 0 .178v.059a12.6 12.6 0 0 0 1.719 1.838.22.22 0 0 0 .178-.059c.301-.01.301-.069.36-.129",
  "data-name": "Path 81683"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.737 4.858c-.059 0-.059 0-.119-.059-.059.059.059.059 0 .119h.415c.119 0 .237.059.356.059.059.059.059.119.119.119-.059.059-.059.059 0 .119a.114.114 0 0 1-.059.178c-.059 0-.059.059-.059.119.059 0 .119 0 .119-.059s.059-.059.059 0a.2.2 0 0 1 .059.119h.119c-.119.059-.178 0-.237.059v.059h.119v.059c-.059.059-.119.119-.178.119v-.059h-.059v.119a.3.3 0 0 0-.237.119.2.2 0 0 1-.059.119v.059c0 .059.059.059.059.119a.06.06 0 0 0-.059.059v.055c.059.059 0 .119.059.178 0 .119.059.178.059.3a.22.22 0 0 0 .178-.059c0 .059 0 .059.059.059l.059.059c.059 0 .059.059.119 0 0-.059.059-.119.119-.178s.119-.119.119-.178V6.58a.22.22 0 0 0 .178-.059h.059l.059-.059a.06.06 0 0 0-.059-.059c.059 0 .059 0 .059-.059a.06.06 0 0 0 .059-.059.06.06 0 0 1 .059-.059c.059 0 .119 0 .119-.059s.059-.059.059 0c.059.059.059.059.119 0s.059 0 .119-.059h.059c.059-.059.119-.059.178-.119a.22.22 0 0 1 .178-.059v-.119a.11.11 0 0 0 .178 0h.059a.44.44 0 0 0 .3-.059c.059-.059.178-.059.237-.119v-.059a.36.36 0 0 1-.237-.059h.119v-.067h.119v.059c.059 0 .059 0 .119.059v-.059c.059 0 .059 0 .059.059v-.059a.13.13 0 0 0-.119-.119h-.119c0-.059-.059-.059-.059-.119.059 0 .059-.059.119-.059.059-.059.059-.059.059 0s.059.059.119.059a.2.2 0 0 0 .119-.059v-.059h.119v-.059h.059c0-.059 0-.119-.059-.119h-.059c.059 0 .119 0 .119-.059a.06.06 0 0 0 .059-.059c-.059 0-.119 0-.119-.059.059 0 .059-.059.119-.059l.059-.059c.059 0 .059 0 .059-.059l.119-.119s0 .059.059 0v-.059a.75.75 0 0 0 .356-.059c-.059-.059-.059-.059-.119-.059-.059.059-.119 0-.178.059h-.063c-.059.059-.119 0-.178 0-.059.059-.059.059-.119.059v-.059h-.119v-.059a.44.44 0 0 0-.3-.059h-.652a.36.36 0 0 0-.237.059c-.059 0-.119-.059-.178-.059-.059.059-.119 0-.119.059-.059 0 0 .059-.059.059 0 .059-.059.059-.119.059s-.119-.059-.178-.059h-.178v.059h-.059a.11.11 0 0 0-.178 0h-.059c-.059-.059-.178 0-.237-.059h-.059c-.059.059-.059.059-.119.059a.22.22 0 0 0-.178.059h-.059c-.059-.059-.059-.059-.119 0h-.237a.06.06 0 0 0-.059.059v.059a.06.06 0 0 1-.059.059c-.059 0-.119.059-.237.059h-.119a.45.45 0 0 1-.237.119c.416-.059.416-.059.475.003",
  "data-name": "Path 81684"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.772 5.918c-.059 0-.059 0-.119.059h-.059a.22.22 0 0 1 .178-.059c-.237-.178-.415-.356-.593-.474-.059 0-.059 0-.119-.059a.18.18 0 0 1-.119-.059h-.059c-.059.059-.059 0-.119.059v.119a.08.08 0 0 1-.119 0 .11.11 0 0 1-.178 0h-.059c0 .059-.059 0-.059.059h-.119a.53.53 0 0 0-.3.059c-.059 0-.059 0-.059.059V5.8c-.059 0-.059.059-.119.059h-.356l.059.059.059.059h-.119c-.119 0-.119 0-.119.119h-.059c-.119 0-.119 0-.178-.119-.059 0-.059 0-.119.059 0 .059 0 .059.059.059a.2.2 0 0 1 .119.059c-.059.059-.059.059 0 .119l.059.059c0 .059.059.059.059 0a.11.11 0 0 1 .178 0c-.059 0-.059.059-.118.059a.06.06 0 0 0-.059.059h.059c0 .059 0 .119-.059.119s-.059.059-.119.059a.11.11 0 0 1-.178 0c.119.059.059-.059.119-.119s0-.119.059-.178h-.059c-.059 0-.119 0-.119-.119v-.059l-.059-.059a.13.13 0 0 0-.119-.119c0-.059 0-.119.059-.119a.75.75 0 0 0-.356-.059.36.36 0 0 1-.059.237l.059.059v.119h.119v.059h.119v.119a.2.2 0 0 1-.119-.059c-.059 0-.119-.059-.178-.059-.059-.059-.119-.059-.237-.059h-.111c-.059 0-.059 0-.118-.059a.06.06 0 0 1-.059.059c.059 0 .059.059 0 .059-.059.059-.059.059-.119 0a.11.11 0 0 0-.178 0h-.059c-.059-.059-.059 0-.059 0a.06.06 0 0 0-.059.059c-.059-.059-.059-.059-.119 0v-.113a.22.22 0 0 1-.178.059h-.059c-.059.059-.059.059-.119.059s-.059.059-.119.059a.06.06 0 0 0 .059.059h-.178c-.059 0-.059-.059-.059-.119.059 0 .059 0 .059-.119h-.178v.178h.059v.124c-.059 0-.059 0-.119-.059h-.059l-.059.059c-.059 0-.119 0-.119.059l.059.059a.26.26 0 0 1-.3-.059c0 .059 0 .119.119.119v.059c-.059 0-.178 0-.178-.059-.059 0-.119 0-.119-.059s-.059-.059 0-.119c0-.059-.059-.059-.119-.059s-.119-.059-.178-.119h.059a.36.36 0 0 0 .237.059c.059.059.059.059.119.059h.178c.059 0 .178 0 .178-.119-.059-.059-.118-.178-.237-.178-.059 0-.119-.059-.178-.059s-.178-.059-.237-.059a.22.22 0 0 0-.178-.059c-.059 0-.059-.059-.119-.059a.22.22 0 0 1-.178.059v-.119a.22.22 0 0 0-.178.059v-.059c-.059 0-.059.059-.119.059-.059-.059-.059-.059-.119 0v-.119c-.059 0-.059 0-.119.059v.059l-.059-.059c-.059 0-.119.059-.178.059-.059.059-.059.059-.119 0l-.059-.059v.119a.13.13 0 0 0-.119.119.06.06 0 0 1-.059-.059l-.118.119v.059c-.119 0-.237.178-.3.356a.46.46 0 0 0-.237.237.45.45 0 0 0-.237.119c-.059 0-.119.059-.178.059a.22.22 0 0 1-.059.178c0 .059.059.059.059.119h.059c0 .059-.059.059 0 .119v.119c.059 0 .059 0 .059.059.059.059.178 0 .178 0 .059-.059.119-.119.178-.059v-.119c0 .059.059.059.059.119.059.119.119.178.119.3 0 .059.059.119.059.178v.059h.119a.22.22 0 0 1 .178-.059.13.13 0 0 0 .119-.119v-.237c.119-.059.178-.059.237-.178-.059-.059-.119-.059-.178-.119l-.059-.059v-.178h.059a.8.8 0 0 1 .237-.178l.059-.059c0-.059.059-.119.059-.178.119-.119.237-.059.356.059l-.059.059c-.059 0-.059.059-.119.119l-.059.059a.06.06 0 0 1-.059.059c-.059 0-.059.059-.059.119.059.059.059.059.059.119s0 .059.059.119a.06.06 0 0 0 .059.059.2.2 0 0 0 .119.059.45.45 0 0 0 .237-.059.06.06 0 0 1 .059-.059h.178v.059c.059.059.119 0 .119.059-.059 0-.119.059-.178.059a.11.11 0 0 1-.178 0h-.3v.119h.119v.178h-.119a.22.22 0 0 0-.178-.059c0 .059 0 .119-.059.119v.059c.059.059 0 .119 0 .178-.059-.059-.059-.059-.119 0l-.059.059s-.059.059-.059 0c-.059-.059-.059-.059-.119 0-.059 0-.059.059-.118.059s-.119 0-.119.059h-.059v-.059h-.059c-.059-.059-.059 0-.119 0s-.118.059-.178.059a.06.06 0 0 0-.059-.059v-.059h.059c0-.059 0-.059-.059-.059 0-.059.059-.059.059-.119v-.178h-.059c-.059 0-.059.059-.119.059l-.119.119a.4.4 0 0 1 .059.356.22.22 0 0 0-.178.059.22.22 0 0 0-.178.059.06.06 0 0 0-.059.059c-.059.059-.059.119-.119.178s-.119.059-.178.119v.119c-.059 0-.119.059-.178.119h-.059s-.059-.059-.059 0v.119c-.059 0-.119.059-.178 0-.059 0-.059 0-.119.059 0 .059 0 .119.059.119h.059a.13.13 0 0 1 .119.119.22.22 0 0 1 .059.178v.059a.53.53 0 0 1-.059.3h-.474a.06.06 0 0 1-.059-.059v.059c-.059-.059-.059-.059-.119 0h-.059c-.059 0-.059.059-.059.119v.3c0 .059 0 .059-.059.119s-.059.059 0 .119a.22.22 0 0 1 .059.178.06.06 0 0 1-.059.059h.178a.13.13 0 0 1 .119.119v.059h.119a.22.22 0 0 1 .178-.059h.119c.059 0 .059 0 .119-.059s.119-.119.178-.119c.059-.059.059-.178.119-.178v-.059c-.059-.059 0-.059 0-.119a.06.06 0 0 1 .059-.059l.059-.059h.059c0-.059.059-.059.119-.119h.059l.119-.119v-.059c-.059-.059 0-.119.059-.119a.06.06 0 1 1 .119 0 .22.22 0 0 1 .178.059c.059.059.119-.059.119-.059.059 0 .119 0 .119-.059l.059-.059a.06.06 0 0 1 .059.059c.059 0 .059.059.059.119 0 .119.059.178.178.237.059 0 .059.059.119.119l.059.059a.06.06 0 0 1 .059.059.2.2 0 0 0 .118.059v.059h.119v.237c-.059.059 0 .059.059.059 0-.059 0-.059.059-.059v-.059a.06.06 0 0 0-.059-.059c-.059 0-.059-.059 0-.059v-.059h.119a.3.3 0 0 0-.237-.119v-.059c-.059-.059-.119-.059-.178-.119s-.119-.119-.119-.178l-.178-.178c0-.059 0-.119.059-.119a.2.2 0 0 1 .119-.059c0 .059.059.059.059.119.059-.059.059-.059.119 0v.059c0 .059 0 .059.059.059a.18.18 0 0 0 .119.059c.059.059.059.119.178.119q.089 0 .178.178v.3c.059.059.059.178.178.178 0 .059.059.059.119.119a.06.06 0 0 0-.059.059c.059 0 0 .059.059.059s.119 0 .119.059V11.1c0-.059 0-.059.059-.119.059 0 .059.059.119.059 0-.059 0-.119-.119-.119 0-.059-.059-.059 0-.119 0-.059-.119-.059-.059-.119s.059.059.119.059c0-.059 0-.059.059-.059a.11.11 0 0 1 .178 0h.059c.059 0 .119-.059.237-.059.059-.059-.059-.059-.059-.059 0-.059 0-.119-.059-.119v-.119l.059-.059c0-.059.059-.119.059-.237a.06.06 0 0 1 .059.059c0-.119 0-.119.059-.178a.2.2 0 0 0 .059-.119h.119v.059h.178a.06.06 0 0 0-.059.059c0 .059.059.059.059.119s.059.059.059.119c.059 0 .118-.059.178-.059 0-.059 0-.119-.059-.119a.06.06 0 0 0-.059-.059c.059 0 .119-.059.178-.059 0-.059.119-.059.178-.059h.178c-.119.059-.119.059-.119.178v.059a.2.2 0 0 1-.059.119c.059 0 .059.059.119.059a.06.06 0 0 1 .059.059c.059.059.119.059.119.119.119 0 .178.119.237.237v.059a.22.22 0 0 1-.178.059c-.119 0-.237.059-.356-.059a.22.22 0 0 1-.178-.059c-.059-.059-.119 0-.119-.059s-.059-.059-.059 0a.18.18 0 0 1-.119.059.06.06 0 0 0-.059.059.11.11 0 0 1-.178 0h-.059a.06.06 0 0 0 .059.059c0 .059-.059.059-.119.059s-.059 0-.119.059c0-.119-.059-.059-.119-.059l-.059.059v.059c.059 0 .059.059.059.119 0 .119.059.178.059.237h.118c.059.059.119.059.178.119s.119.059.119-.059v-.059a.22.22 0 0 1 .178.059l.059.059c.059 0 .178 0 .178-.059l.059-.059c.059 0 .119 0 .119.059 0 .119 0 .237.119.3h-.102v.119c0 .059-.059.119-.059.237a.13.13 0 0 1-.118.119.44.44 0 0 1-.3-.059h-.059c-.059 0-.059.059-.118.059-.059.059-.059.059-.119 0a.22.22 0 0 0-.178-.059c-.059-.059-.119-.059-.237-.059-.059-.059-.178-.059-.237-.119l-.059-.059h-.116c-.059 0-.059.059-.119.119v.237h-.059c-.059.059-.119.059-.178-.059-.059-.059-.059-.059-.119-.059a.22.22 0 0 1-.178-.059c-.059 0-.059-.119-.059-.119-.059 0-.119-.059-.178-.059 0-.059-.059 0-.059 0h-.119c-.059-.059-.119-.059-.178-.119 0-.059 0-.059.059-.059.059-.059.059-.119.059-.237h-.119c.119-.059-.059-.119 0-.178a.22.22 0 0 0-.178.059h-.3a.11.11 0 0 1-.178 0h-.119c-.059.059-.119 0-.119.059h-.059c-.059.059-.178 0-.237.119-.059 0-.059 0-.119.059a.36.36 0 0 1-.237.059h-.059c-.059.059-.119.059-.119 0-.059 0-.119 0-.059-.119-.059 0-.118 0-.118.059s0 .119-.059.119l-.118.119c-.059.059-.178.119-.178.237a.22.22 0 0 0-.059.178c0 .119 0 .237-.119.3-.059.059-.059.119-.119.119a.22.22 0 0 1-.178.059v.059c0 .059 0 .119-.119.178-.059 0-.059.059-.059.119 0 .119-.059.178-.059.237v.059h-.059a.6.6 0 0 1-.119.3.11.11 0 0 0 0 .178.11.11 0 0 1 0 .178v.119a.11.11 0 0 1 0 .178c0 .059-.059.119-.059.237v.028c-.059.059-.059.119-.059.237 0 .059 0 .059.059.119v.059a.11.11 0 0 0 0 .178c.059 0 .059.059.119.059 0 .059 0 .119.059.119v.059a.13.13 0 0 0 .119.119c0 .119.059.178.059.3.059.059.059.059.119.059a.8.8 0 0 0 .237.178l.118.119a.18.18 0 0 0 .119.059.22.22 0 0 0 .178-.059.06.06 0 0 0 .059-.059.22.22 0 0 0 .178-.059s.059.059.059 0c0 .059.119 0 .119.059h.059c0-.059.059-.059.119-.059.118-.059.237-.059.3-.178h.356c.059 0 .059 0 .119.059 0 .059.059.119.059.178s.059.059.059.119h.178c.059-.059.059 0 .119 0v.059a.06.06 0 0 1 .059.059.18.18 0 0 1 .059.119c0 .059 0 .119-.059.119s-.059.059 0 .119v.178c0 .059-.059.059-.059.119 0 .119 0 .178.119.237.059.059.119.119.119.178s.059.059.059.119.059.059.059.119.059.059.059.119v.059h.059c-.059.059-.059.059 0 .119a.36.36 0 0 1 .059.237v.237c.059.059.059.119.059.237a.22.22 0 0 1-.059.178h-.059v.059c-.059.059-.059.119-.059.237v.059a.77.77 0 0 0 0 .593.22.22 0 0 1 .059.178.45.45 0 0 0 .119.237c0 .059 0 .059.059.059a.22.22 0 0 1 .059.178v.3c.059.059 0 .119.059.178v.178c0 .059 0 .119.059.119s0 .119.119.119c0 .059.059.119.059.237 0 .059 0 .059.059.119a.18.18 0 0 0 .059.119v.3c.059.059 0 .119.059.119.059.059.119.059.178.119a.22.22 0 0 1 .178-.059h.059a.22.22 0 0 1 .178-.059h.3a.06.06 0 0 1 .059-.059h.119c.059-.059.178-.059.178-.178a.06.06 0 0 1 .059-.059c.059-.119.178-.119.178-.237.059-.059.059-.119.119-.178.119 0 .059-.119.119-.178 0-.119.059-.178.059-.3v-.076c.059 0 .059 0 .059-.059.059-.059.059-.059.119-.059s.059-.059.118-.059c0 0 .059-.059 0-.059v-.237c-.059-.059 0-.119 0-.178v-.178c.059-.059.059-.119.119-.178a.13.13 0 0 0 .119-.119.13.13 0 0 1 .119-.119.8.8 0 0 0 .237-.178l.059-.059a.06.06 0 0 1 .059-.059l.059-.059v-.652c0-.059 0-.059-.059-.119a.22.22 0 0 1-.059-.178v-.051c0-.059-.059-.059 0-.119 0 0-.059-.059 0-.059.059-.059 0-.059 0-.119v-.059l-.059-.059c-.059-.119.059-.178.059-.3 0-.059.059-.059.059-.119s.059-.119.059-.178l.059-.059c.059-.059.178-.119.178-.178v-.059a.8.8 0 0 0 .178-.237.6.6 0 0 1 .3-.237.13.13 0 0 0 .119-.119h.059c0-.059.118-.119.059-.178.059 0 0-.059.059-.119s.118-.119.059-.237v-.059c.059-.059.059-.059.059-.119.059 0 .059-.059.059-.119v-.059c.059-.059.059-.059.059-.119v-.119c.059-.059 0-.119 0-.237-.059 0-.119.059-.237.059a.06.06 0 0 1-.059.059h-.119c-.059 0-.059 0-.119.059a.06.06 0 0 1-.059.059h-.119c-.059.059-.119 0-.178 0a.157.157 0 0 0-.178-.178h.119a.22.22 0 0 0-.059-.178c-.059-.059-.178-.119-.178-.237a.06.06 0 0 0-.059-.059c-.059 0-.059-.059-.119-.059s-.059-.119-.119-.119v-.059c0-.059-.059-.178-.059-.237-.059-.059-.118-.059-.118-.119a.2.2 0 0 1-.059-.119v-.237a.22.22 0 0 0-.059-.178c-.059 0-.119-.119-.178-.178a.36.36 0 0 0-.059-.237c-.059-.059-.059-.178-.119-.237v-.119a.08.08 0 0 1 0-.119c.059 0 .059 0 .119.059.059-.059 0-.178.059-.237v.178a.06.06 0 0 1 .059.059.2.2 0 0 1 .059.119.3.3 0 0 1 .119.237.06.06 0 0 0 .059.059.22.22 0 0 1 .059.178c.059 0 .059 0 .059.059a.84.84 0 0 1 .119.356c0 .059.059.119.119.178.118.059.178.119.178.237.059.059.059.059.059.119.059.059.059.119.119.178 0 .059.059.059.059.119s-.059.178.059.237c0 .119.059.178.059.3h.119c.059 0 .059 0 .119-.059a.06.06 0 0 1 .059-.059h.119c.059 0 .119-.119.237-.119l.059-.059a.06.06 0 0 1 .059-.059h.059a.22.22 0 0 1 .178-.059.06.06 0 0 0 .059-.059v-.063a.06.06 0 0 0 .059-.059c.119-.059.178-.119.3-.119v-.122h.119c0-.059.059-.119.059-.178h.119v-.119c0-.059 0-.059.059-.119a.13.13 0 0 0 .118-.119c.059-.119.119-.178 0-.3l-.059-.059c-.059 0-.059 0-.119-.059s-.059-.059-.119-.059v-.059a.22.22 0 0 1-.059-.178.06.06 0 0 0-.059.059c0 .059-.059.059-.059.119l-.119.119a.36.36 0 0 0-.237.059.36.36 0 0 1-.059-.237v-.119h-.059v.178a.22.22 0 0 1-.059-.178c0-.119-.119-.178-.178-.237 0-.119-.119-.178-.119-.356h.119v-.059h.059c.059 0 .059 0 .119.059v.059c.059.059.059.119.119.178 0 .059.059.059.119.059s.059.059.119.059l.059.059a.06.06 0 0 1 .059.059.22.22 0 0 0 .178.059.06.06 0 0 0 .059-.059c.059 0 .059-.059.119-.059h.059c.059.059.119.059.119.119a.13.13 0 0 0 .119.119h.119c.059.059.119 0 .178.059h.119a.22.22 0 0 0 .178-.059h.415c0 .059.059.059.059.119s0 .119.059.119.059.059.118.119c.059 0 .059.059.119.059a.06.06 0 0 0 .059-.059v.059h-.119v.119c.119 0 .119.059.178.119.119.059.119 0 .237-.059a.06.06 0 0 0-.059-.059l.059-.059c0 .059.059.119 0 .119l.059.059c.059.059.059.059 0 .059-.059.059-.059.119 0 .119s.059.059.059.119v.059c.059.059 0 .178.059.237a.22.22 0 0 0 .059.178c.059.059.059.178.118.237 0 .059.059.059.059.119a.22.22 0 0 0 .059.178c0 .059.118.119.118.237.059.059.059.178.119.237a.2.2 0 0 0 .059.119c0 .059.059.059.119.059h.059v-.119h.059v-.119c0-.059.059-.059.059-.119h.059v-.237c.059-.059.059-.119 0-.119-.059-.059 0-.119-.059-.237v-.059c-.059-.059 0-.059 0-.059a.13.13 0 0 1 .119-.119c0-.059.119 0 .119-.059s.059-.119.059-.178c.059-.059.059-.119.119-.119 0-.059.059-.119.059-.178.059-.059.059-.119.119-.119a.06.06 0 0 0 .059-.059v-.059c0-.059 0-.119.059-.119.059-.059.059 0 .119 0h.059c.059 0 .119 0 .119-.059a.2.2 0 0 0 .059-.119h.059c.059.059.119.119.119.178s.059.119.118.178.119.059.119.178c.059 0 .059.059.119.059 0 .059.059.119.059.178v.237h.059c.059.059.059.059.119 0s.118-.059.178-.119v-.056c0 .059 0 .059.059.059.059.059.059.059.059.119v.059c.059.059.059.178.119.237a.22.22 0 0 1 .059.178v.652c.059.059.119.119.119.178.059.059.059.119.119.178 0 .059.059.059 0 .119v.059l.059.059h-.059c0 .059 0 .119.059.119a.22.22 0 0 1 .059.178h.059c0 .059.059.059.119.119.059 0 .059.059.118.059 0 .059.059 0 .059 0v-.119a.36.36 0 0 1-.059-.237v-.116c0-.059-.059-.119-.059-.178-.059-.059-.119-.119-.119-.178l-.059-.059c-.059 0-.119-.059-.178-.119.059-.059.059-.059 0-.119a.2.2 0 0 1-.059-.119h-.059v-.356c0-.059.118-.119 0-.178.059-.059 0-.059 0-.059.059-.059.059-.059.118 0l-.059.059.059.059h.059c0 .059 0 .059.059.059l.059.059c0 .059.059.119.059.178h.059a.8.8 0 0 0 .237.178v.059c-.059 0-.059.059-.059.119.119.059.119-.059.178-.059l.059-.059v-.059h.059a4 4 0 0 0 .059-.83v-.059c-.119-.059-.178-.178-.237-.237a.13.13 0 0 0-.119-.119.11.11 0 0 1 0-.178c0-.059.059-.059.059-.119a.13.13 0 0 1 .119-.119c.059-.059.059-.059.119-.059l.059.059c-.958-3.197-2.322-5.924-4.515-7.767",
  "data-name": "Path 81685"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.372 18.727c-.059-.059 0-.118-.059-.178s-.059-.059-.059-.178v-.062h-.119c0-.119 0-.178-.059-.237 0-.059 0-.059.059-.059-.059-.059-.178-.059-.178-.119-.059 0-.059-.059-.118-.059v-.3a.08.08 0 0 1 0-.119v-.178c0-.059-.059-.059-.119-.059v-.059c-.059-.059-.059-.059 0-.119v-.119c0-.059-.059-.178-.059-.237h-.059c0 .059 0 .119-.059.119a.22.22 0 0 0-.059.178v.059c-.059 0 0 .059-.059.119a.22.22 0 0 1-.059.178c0 .059-.059.119-.059.178 0 .119-.059.119-.118.237h-.059c-.119 0-.119 0-.178-.119-.059 0-.119-.059-.178-.118l-.059-.059a.06.06 0 0 1-.059-.059l-.059-.059c0-.059.059-.119.059-.178s.059-.059.059-.119c.059 0 .059-.059.059-.119-.059 0-.119 0-.119-.059h-.119a.22.22 0 0 1-.178-.059.18.18 0 0 1-.118-.059c0 .059 0 .119-.119.119a.22.22 0 0 0-.178.059c-.059 0-.059.059-.059.119s0 .119-.119.119v.178h-.237v-.119c0-.059-.059-.119-.119-.059s-.119.059-.237.059c0 .059 0 .059-.059.119s-.119.119-.059.178h-.118c-.059.059 0 .059 0 .119l-.059.059a.06.06 0 0 1-.059-.059s-.059-.059-.059 0l-.059.059c0 .118-.059.118-.059.178l-.118.119-.059.059c-.059 0-.119.059-.178.059-.059.059-.119.059-.237.059-.059 0-.059 0-.119.059l-.059.059c-.059.059-.119.059-.178.119l-.059.059a.06.06 0 0 1-.059-.059v.178a.3.3 0 0 0 0 .356v.119a.06.06 0 0 0-.059.059c0 .059.059.119 0 .178 0 .059.059.119.059.237v.059a.27.27 0 0 0 0 .3v.059a.36.36 0 0 0-.059.237h-.059c-.059 0-.059.059-.059.118.059.059.059.119.119.119h.119c.059 0 .119-.059.178-.119a.3.3 0 0 1 .237-.118h.178a.22.22 0 0 0 .178-.059l.059-.059c.059 0 .119-.059.178-.059.119-.059.119-.059.178-.059a.22.22 0 0 0 .178-.059.22.22 0 0 1 .178-.059h.119c.059 0 .059 0 .119-.059.059.059.119.059.178.119.059 0 .059 0 .119.059v.059c0 .059 0 .059.059.119v.178c.059 0 .059 0 .119-.059l.237-.237.059-.059c.059.059-.059.059-.059.119a.06.06 0 0 0-.059.059h.119v.119a.18.18 0 0 1 .059.119c-.059.059 0 .119 0 .237.059 0 .119.059.178.059a.11.11 0 0 0 .178 0c.059-.059.059-.059.119-.059a.2.2 0 0 0 .059.119h.119c.059 0 .059 0 .119-.059s.059-.059.118-.059a.36.36 0 0 0 .237-.059v-.059a1.3 1.3 0 0 1 .178-.3c.059 0 .059-.059.059-.119a.06.06 0 0 1 .059-.059c0-.059 0-.119.059-.119.059-.059.119-.059.119-.119.059-.059.059-.119.119-.119.059-.059.059-.059.059-.119v-.059c0-.059 0-.059.059-.118l.119-.237v-.119c0-.118.059-.178.059-.237.169.059.169.059.109 0",
  "data-name": "Path 81686"
})), /*#__PURE__*/React.createElement("g", {
  fill: "#344a5e",
  "data-name": "Group 66039",
  transform: "translate(4.794 12.562)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 1.363,
  cy: 2.49,
  "data-name": "Ellipse 2009",
  rx: 1.363,
  ry: 2.49,
  transform: "translate(8.892 5.928)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 15.947.3-1.008 8.181-.83s.178.652.534 1.838Z",
  "data-name": "Path 81687"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.959 11.382a31.4 31.4 0 0 0 .237 4.565H8.477C8.003 13.931 7.41 9.782 7.41 9.782s.237-6.64-.178-8.122L6.817 0l.474.119s2.016.474 2.312.949a7.7 7.7 0 0 1 1.126 3.735c.001 1.481-.651 4.03-.77 6.579",
  "data-name": "Path 81688"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#e8eae9",
  d: "M15.405 22.936a1.63 1.63 0 0 0 .415-.889 2.46 2.46 0 0 0-.534-1.719 1.06 1.06 0 0 0-.949-.356l-.889.237Z",
  "data-name": "Path 81689"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffd15c",
  d: "m5.979 6.93.3 2.727 4.387 3.438V9.538s1.245-.889 1.126-3.557a10 10 0 0 0-.119-2.49c-.3-1.008-.652-1.956-1.541-2.312s-3.438.356-3.972.771c-.478.475-1.011 3.854-.181 4.98",
  "data-name": "Path 81690"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#415a6b",
  d: "m5.09 5.385.83.593.178-.178a3.36 3.36 0 0 1 .415-2.016 1.07 1.07 0 0 0 .119-.593 1.085 1.085 0 0 1 .711-1.126 1 1 0 0 1 .415-.059 7 7 0 0 0 2.727-.119.4.4 0 0 1 .356.059 1.8 1.8 0 0 1 .593 1.3 4 4 0 0 0 .3 1.126 4.2 4.2 0 0 1 0 1.541h.116s.059-.415.178-1.067a9.2 9.2 0 0 0-.478-2.777A4 4 0 0 0 10.127.35 2.36 2.36 0 0 0 8.111.113a4.66 4.66 0 0 0-2.727 2.431 4.76 4.76 0 0 0-.294 2.841",
  "data-name": "Path 81691"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 1.245,
  cy: 0.534,
  fill: "#ffd15c",
  "data-name": "Ellipse 2010",
  rx: 1.245,
  ry: 0.534,
  transform: "rotate(72.78 -.623 6.334)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f7b64c",
  d: "M10.663 9.539v2.668a8.4 8.4 0 0 1-4.209-4.15 4.1 4.1 0 0 0 4.209 1.482",
  "data-name": "Path 81692"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ced6e0",
  d: "m10.663 11.139-.534.3h-.356l-2.193.3 3.083 7.173 1.838 4.328-.178-9.011Z",
  "data-name": "Path 81693"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#f3705a",
  "data-name": "Group 66040"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.129 12.74a10.4 10.4 0 0 0-.534 3.32c.119 1.363 2.193 5.513 2.193 5.513l1.067-3.379-.593-4.031c0-.059-1.126-1.363-1.126-1.363l-.889-.534z",
  "data-name": "Path 81694"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.18 11.673a5.2 5.2 0 0 1 1.008 1.126 1.07 1.07 0 0 1 1.008 0 6.3 6.3 0 0 0-.415-1.3c-.178-.237-.593 0-.593 0h-.356Z",
  "data-name": "Path 81695"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#f3f3f3",
  d: "M6.217 9.42a5 5 0 0 0 1.363.83 11.7 11.7 0 0 1 2.134 1.245s-1.363 1.3-1.423 2.134l-.059.83-2.786-3.797c.415-.412.652-1.42.771-1.242",
  "data-name": "Path 81696"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#344a5e",
  d: "M2.126 28.509a46 46 0 0 0 .415-5.158c-.178-.948-1.66-4.328-2.312-6.936-.652-2.668.3-3.379.3-3.379.83-1.067 2.134-.83 2.727-1.008a7.3 7.3 0 0 0 1.423-.711l2.193.237a34.6 34.6 0 0 1 3.553 5.217c.771 1.778 2.193 7.647 2.193 7.647s.059 1.3.3 3.32c0 .237.059.474.059.771z",
  "data-name": "Path 81697"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e8eae9",
  d: "M11.848 23.766a6.6 6.6 0 0 1-.059 2.134l2.549-.059-.3-2.608Z",
  "data-name": "Path 81698"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2e4454",
  d: "M12.382 26.498h.474c.474 0 1.245-.059 1.956-.119.652 0 1.186-.059 1.3-.059a9.3 9.3 0 0 0 2.727-.534 3.97 3.97 0 0 0 .711-2.253 5.5 5.5 0 0 0-.83-2.312s-.83-1.3-1.067-1.66c-.237-.3-.474-.534-.711-.83a1.3 1.3 0 0 1-.237-.711 1.86 1.86 0 0 0-.178-1.126 11 11 0 0 0-.593-1.126 3.43 3.43 0 0 0-.771-1.719c-.534-.534-.83-.534-.889-.534.059.059.119.119.178.119a7.1 7.1 0 0 1 1.126 3.735 20 20 0 0 1-.415 2.786s.711 1.6.83 1.778c.119.237.059.474-.356.593a3.6 3.6 0 0 1-.889.178c-.83.119-2.016.3-2.549.356a.35.35 0 0 0-.237.059c.835 1.122.42 3.379.42 3.379",
  "data-name": "Path 81699"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#415a6b",
  d: "M12.323 23.233c-.711-1.9-2.075-5.632-2.786-6.936a11.6 11.6 0 0 0-2.668-3.142l.415-.534-.889-.119s-1.482-1.186-1.6-1.245a1.9 1.9 0 0 1 .415-.474c.237-.178.474-.593.652-.593a12.8 12.8 0 0 1 3.023 2.786 21.7 21.7 0 0 1 2.668 5.513c.415 1.423.83 3.438 1.067 4.743Z",
  "data-name": "Path 81700"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f3f3f3",
  d: "M10.663 10.369a2.85 2.85 0 0 1-.534 1.126.834.834 0 0 1 .771.652l.178.652a3.1 3.1 0 0 0-.178-1.067c-.06-.355.059-1.242-.237-1.363",
  "data-name": "Path 81701"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#415a6b",
  "data-name": "Group 66041"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.5 23.411c-.237-1.245-.652-3.142-.652-3.675 0-.771-.059-4.091-.178-4.92-.119-.889-.771-3.2-.771-3.2a2.8 2.8 0 0 0 1.186 1.126l-.237.178a1.8 1.8 0 0 1 1.008.949 28 28 0 0 1 .3 4.565c0 .593-.3 3.438-.415 5.039h-.237v-.059Z",
  "data-name": "Path 81702"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.288 16.356c.356 1.427.948 3.027 1.423 4.327a21.4 21.4 0 0 0 4.92 3.735 9 9 0 0 0 1.008.415c.356.119 1.008 0 1.363.119s.593-.059 1.008-.119c.178-.059 1.423-.3 2.668-.593 1.482-.356 3.083-.711 3.083-.711a21.4 21.4 0 0 0-2.075-3.438s-1.186.119-2.075.119h-.949c-.534-.059-1.838-.178-1.956-.237a2.7 2.7 0 0 0-1.008.3c-.3.118-.415.118-.534-.415-.178-.534-.474-.771-.652-1.364a13.3 13.3 0 0 0-1.719-4.268 4.68 4.68 0 0 0-2.253-1.778 1.73 1.73 0 0 0-1.9.474c-.056.115-1.004.767-.352 3.434",
  "data-name": "Path 81703"
})))));

const SvgIfcaxMeeting = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 512 512"
}, props), /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  clipRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#e1f1ff",
  d: "M232.033 272.243h47.935a4.8 4.8 0 0 1 4.79 4.79v220.592a4.8 4.8 0 0 1-4.79 4.79h-47.935a4.8 4.8 0 0 1-4.79-4.79V277.033a4.8 4.8 0 0 1 4.79-4.79"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#d09080",
  d: "M232.033 272.243h47.935a4.8 4.8 0 0 1 4.79 4.79v220.592a4.8 4.8 0 0 1-4.79 4.79h-47.935a4.8 4.8 0 0 1-4.79-4.79V277.033a4.8 4.8 0 0 1 4.79-4.79"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#d8a595",
  d: "m127.465 249.396 36.992-3.77 33.618 3.77h115.851l39.655-4.848 30.954 4.848c2.58.396 4.763 2.154 4.763 4.79v20.948c0 2.636-2.154 4.79-4.763 4.79h-257.07a4.8 4.8 0 0 1-4.79-4.79v-20.948c0-2.636 2.182-4.536 4.79-4.79"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#a5cdff",
  d: "M53.114 147.121h21.713c1.445 0 2.862.114 4.28.312 7.144-1.304 14.683 1.559 19.048 7.909l35.433 52.016c1.701 2.523 4.082 4.11 7.966 4.224h56.521c10.432 0 18.907 8.475 18.907 18.907s-8.476 18.907-18.907 18.907h-71.573c-6.01-.029-11.934-2.948-15.562-8.277L98.892 223.43l-9.07 88.016h72.111c18.709 0 33.023 15.562 28.035 34.157l-36.737 136.8c-5.017 18.708-22.592 23.216-36.254 17.972-11.65-4.479-20.466-16.073-16.186-32.032l27.58-102.614H36.559c-15.901 0-30.557-13.124-28.941-28.97l16.555-160.696c1.615-15.817 13.01-28.942 28.941-28.942"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ebd2ff",
  d: "M458.887 147.121h-21.714c-1.445 0-2.892.114-4.309.312-7.115-1.304-14.684 1.559-19.021 7.909l-35.432 52.016c-1.73 2.523-3.969 4.167-7.966 4.224h-56.521c-10.46 0-18.907 8.475-18.907 18.907s8.447 18.907 18.907 18.907h71.545a19 19 0 0 0 15.591-8.277l12.046-17.688 9.043 88.016h-72.084c-18.736 0-33.022 15.562-28.034 34.157l36.736 136.8c5.017 18.708 22.593 23.216 36.227 17.972 11.678-4.479 20.466-16.073 16.186-32.032L383.628 365.73h91.783c15.931 0 30.586-13.124 28.942-28.97l-16.526-160.696c-1.644-15.818-13.038-28.943-28.94-28.943"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#71aaf0",
  d: "M161.933 311.446H89.822l-78.745-8.107-3.459 33.42c-1.615 15.846 13.04 28.97 28.941 28.97h91.812l-27.58 102.614c-4.28 15.959 4.535 27.553 16.186 32.032 13.662 5.244 31.237.737 36.254-17.972l36.737-136.8c4.989-18.595-9.326-34.157-28.035-34.157"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#c19ee3",
  d: "M350.066 311.446c-18.736 0-33.022 15.562-28.034 34.157l36.736 136.8c5.017 18.708 22.593 23.216 36.227 17.972 11.678-4.479 20.466-16.073 16.186-32.032l-27.552-102.614h91.783c15.931 0 30.586-13.124 28.942-28.97l-3.431-33.42-78.773 8.107z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#d8a595",
  d: "M66.38 365.729H12.409a4.8 4.8 0 0 0-4.791 4.79v127.105a4.8 4.8 0 0 0 4.791 4.79H66.38a4.8 4.8 0 0 0 4.79-4.79V370.52a4.803 4.803 0 0 0-4.79-4.791M499.563 365.729h-53.942a4.8 4.8 0 0 0-4.79 4.79v127.105a4.8 4.8 0 0 0 4.79 4.79h53.942a4.803 4.803 0 0 0 4.791-4.79V370.52a4.803 4.803 0 0 0-4.791-4.791"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ecf4ff",
  d: "M255.986 158.12c40.903 0 74.267-33.364 74.267-74.268S296.89 9.584 255.986 9.584s-74.238 33.364-74.238 74.268 33.335 74.268 74.238 74.268"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffcbbe",
  d: "M21.281 108.882c0 23.499 19.19 42.718 42.689 42.718 23.471 0 42.689-19.219 42.689-42.718V63.131c0-13.125-10.743-23.896-23.896-23.896H45.177c-13.152 0-23.896 10.771-23.896 23.896zM490.719 108.882c0 23.499-19.22 42.718-42.689 42.718-23.499 0-42.718-19.219-42.718-42.718V63.131c0-13.125 10.772-23.896 23.925-23.896h37.586c13.153 0 23.896 10.771 23.896 23.896z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f7beaf",
  d: "M490.719 108.882c0 23.499-19.22 42.718-42.689 42.718-4.224 0-8.277-.624-12.132-1.786 17.603-5.244 30.557-21.657 30.557-40.932V63.131c0-13.125-10.771-23.896-23.896-23.896h-13.351 37.614c13.153 0 23.896 10.771 23.896 23.896z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#c68b87",
  d: "M106.659 63.131V79.77c-12.019 4.479-21.883.822-27.665-2.466-4.508-2.551-5.272-2.579-5.812 1.531-1.559 11.991-6.973 45.1-51.873 31.55l-.028-47.253c-.028-13.125 10.743-23.896 23.896-23.896h37.587c13.152-.001 23.895 10.77 23.895 23.895"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#477b9e",
  d: "M405.312 63.131V79.77c12.048 4.479 21.912.822 27.694-2.466 4.479-2.551 5.272-2.579 5.783 1.531 1.587 11.991 6.973 45.1 51.873 31.55l.057-47.253c.028-13.125-10.743-23.896-23.896-23.896h-37.586c-13.153-.001-23.925 10.77-23.925 23.895"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#365e7d",
  d: "M466.228 113.247c6.463.851 14.484.142 24.435-2.863l.057-47.253c.028-13.125-10.743-23.896-23.896-23.896H429.21h13.351c13.125 0 23.896 10.771 23.896 23.896v45.751a45 45 0 0 1-.229 4.365"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f7beaf",
  d: "M82.395 79.005v29.877c0 19.275-12.954 35.688-30.558 40.932A41.9 41.9 0 0 0 63.97 151.6c23.471 0 42.689-19.219 42.689-42.718V79.77c-9.921 3.685-18.368 1.843-24.264-.765"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#bd7d79",
  d: "M82.763 39.235H58.5c13.152 0 23.896 10.771 23.896 23.896v15.874c5.896 2.608 14.343 4.45 24.264.765V63.131c-.001-13.125-10.744-23.896-23.897-23.896"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ddeafb",
  d: "M305.988 83.852c0 36.878-26.899 67.493-62.135 73.275 3.969.652 8.023.992 12.133.992 41.017 0 74.267-33.251 74.267-74.268s-33.25-74.268-74.267-74.268c-4.11 0-8.164.34-12.133.992 35.236 5.784 62.135 36.398 62.135 73.277"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#d09080",
  d: "M46.906 370.52v127.105a4.8 4.8 0 0 1-4.791 4.79H66.38a4.8 4.8 0 0 0 4.79-4.79V370.52a4.8 4.8 0 0 0-4.79-4.79H42.115a4.8 4.8 0 0 1 4.791 4.79M480.09 370.52v127.105a4.8 4.8 0 0 1-4.791 4.79h24.265a4.803 4.803 0 0 0 4.791-4.79V370.52a4.803 4.803 0 0 0-4.791-4.79h-24.265a4.8 4.8 0 0 1 4.791 4.79"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#be694f",
  d: "M260.493 279.924v217.701a4.8 4.8 0 0 1-4.79 4.79h24.265a4.8 4.8 0 0 0 4.79-4.79V279.924z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#d7bef0",
  d: "m463.563 176.063 13.352 129.742 24.009-2.466-13.096-127.275c-1.389-13.578-9.978-25.172-22.45-28.176a42.3 42.3 0 0 1-15.816 3.685c7.794 5.158 12.953 14.257 14.001 24.49"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#b592d1",
  d: "M475.299 365.729h.113zm1.616-59.924 3.175 30.954c1.644 15.846-13.012 28.97-28.941 28.97h24.262999999999998c15.931 0 30.586-13.124 28.942-28.97l-3.431-33.42zM361.745 374.602l25.172 93.742c4.11 15.25-3.771 26.532-14.655 31.408 7.029 3.458 15.449 3.43 22.733.624 11.678-4.479 20.466-16.073 16.186-32.032L383.629 365.73h-15.902c-5.018.481-7.428 3.514-5.982 8.872"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5a94db",
  d: "m165.676 345.603-36.708 136.8c-2.353 8.702-7.398 14.343-13.521 17.348.511.227 1.021.425 1.531.624 13.662 5.244 31.237.737 36.254-17.972l36.737-136.8c4.988-18.595-9.326-34.157-28.035-34.157h-24.292c18.736 0 33.051 15.562 28.034 34.157"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#8abfff",
  d: "M80.524 196.473c-1.077-1.587-3.005-1.163-3.203.793L65.812 308.98l24.01 2.466 9.07-88.016z"
})), /*#__PURE__*/React.createElement("path", {
  d: "M496.871 373.241h-48.528v121.691h48.528zm-13.38-228.898a47 47 0 0 1-3.005 2.778 38 38 0 0 1 6.548 6.747c4.536 5.981 7.427 13.436 8.249 21.43l16.555 160.724c.822 7.965-1.503 15.789-6.378 22.28 3.628.539 6.434 3.657 6.434 7.427v136.715c0 4.138-3.373 7.483-7.512 7.483H440.83a7.476 7.476 0 0 1-7.484-7.483V373.241h-39.939l25.028 93.175c2.524 9.383 1.39 17.689-2.068 24.52-3.912 7.767-10.801 13.408-18.68 16.441-8.73 3.345-18.567 3.515-27.213-.199-9.808-4.195-16.214-12.671-18.936-22.819l-36.736-136.8c-2.891-10.715-.85-21.685 6.266-30.387 7.114-8.646 17.914-13.238 28.997-13.238h63.807l-6.123-59.357c-2.919 4.309-6.178 7.455-10.94 9.723v25.625a7.476 7.476 0 0 1-7.483 7.483H292.24v215.037a7.476 7.476 0 0 1-7.482 7.483h-57.515c-4.138 0-7.511-3.345-7.511-7.483v-94.281c0-4.138 3.373-7.512 7.511-7.512 4.139 0 7.483 3.374 7.483 7.512v86.768h42.519V287.408h-42.519v86.769c0 4.167-3.345 7.512-7.483 7.512s-7.511-3.345-7.511-7.512v-86.769h-97.058c-4.139 0-7.512-3.345-7.512-7.483V254.3c-4.733-2.239-7.993-5.414-10.941-9.723l-6.095 59.357h63.778c10.971 0 21.771 4.479 28.914 12.955 7.369 8.759 9.297 19.786 6.377 30.671l-36.736 136.8c-2.722 10.148-9.155 18.624-18.935 22.819-8.674 3.713-18.481 3.544-27.213.199-7.88-3.033-14.769-8.674-18.68-16.441-3.458-6.832-4.592-15.137-2.069-24.52l25.029-93.203H78.653v129.232c0 4.138-3.373 7.483-7.512 7.483H7.618c-4.166 0-7.511-3.345-7.511-7.483V365.729c0-3.77 2.777-6.888 6.405-7.427-4.875-6.491-7.171-14.202-6.349-22.28l9.269-90.17c.425-4.11 4.11-7.115 8.221-6.69s7.086 4.11 6.661 8.221l-5.074 49.266 63.921 6.576 7.993-77.811-20.664-30.359a7.447 7.447 0 0 1 1.956-10.403c3.401-2.324 8.078-1.446 10.402 1.956l34.242 50.287c1.077 1.587 2.522 2.806 4.11 3.657 1.445.765 2.976 1.219 4.507 1.332h72.395c3.146-.028 5.982-1.275 8.023-3.345 2.069-2.069 3.345-4.904 3.345-8.05s-1.275-6.01-3.345-8.079a11.43 11.43 0 0 0-8.051-3.317H136.45c-2.381-.028-4.734-1.162-6.18-3.288l-38.323-56.239c-1.786-2.608-4.478-4.309-7.625-4.819a49.9 49.9 0 0 1-20.381 4.337 50.3 50.3 0 0 1-17.802-3.26c-3.799 1.417-7.059 4.025-9.524 7.427-2.721 3.77-4.507 8.476-5.017 13.578l-3.799 36.737c-.425 4.11-4.082 7.115-8.191 6.689-4.11-.425-7.115-4.11-6.691-8.22l3.799-36.737c.794-7.71 3.543-14.939 7.823-20.835a38 38 0 0 1 7.002-7.313c-11.254-9.553-17.802-23.471-17.802-38.268V63.131c0-8.646 3.543-16.498 9.241-22.195 5.669-5.669 13.521-9.213 22.166-9.213h37.615c8.617 0 16.469 3.543 22.167 9.213 5.697 5.697 9.212 13.549 9.212 22.195v45.751c0 13.72-5.612 26.759-15.505 36.227a26.6 26.6 0 0 1 5.669 6.009l36.085 52.951h57.684c7.285 0 13.891 2.977 18.652 7.738a26.33 26.33 0 0 1 7.738 18.681c0 4.082-.936 7.937-2.579 11.395h68.228a26.1 26.1 0 0 1-2.608-11.395c0-7.285 2.977-13.89 7.738-18.681 4.791-4.762 11.395-7.738 18.681-7.738h57.684l36.056-52.951a26.2 26.2 0 0 1 5.698-6.009c-.284-.255-.539-.51-.794-.766-9.099-9.099-14.739-21.657-14.739-35.461V63.131c0-8.646 3.543-16.498 9.212-22.195 5.697-5.669 13.549-9.213 22.195-9.213h37.586c8.646 0 16.498 3.543 22.195 9.213 5.698 5.697 9.213 13.549 9.213 22.195v45.751c.002 13.351-5.299 26.022-14.738 35.461m-2.183-24.037a62 62 0 0 1-7.228.793c-11.594.595-20.352-2.466-26.956-7.795-6.52-5.244-10.631-12.529-13.097-20.551a60 60 0 0 1-1.672-6.831c-5.159 2.211-11.85 3.912-19.531 3.175v19.786c0 9.666 3.969 18.482 10.347 24.86 6.406 6.378 15.193 10.347 24.859 10.347s18.481-3.969 24.859-10.347a35.3 35.3 0 0 0 8.419-13.437m-68.484-46.262c10.8 1.701 18.737-4.507 20.268-5.811s2.863-2.098 4.961-2.183c4.139-.198 7.625 3.005 7.823 7.115.256 5.187.992 10.431 2.467 15.193 1.643 5.386 4.224 10.12 8.163 13.294 3.855 3.118 9.325 4.876 16.893 4.507 2.948-.142 6.236-.624 9.837-1.474V63.131c0-4.507-1.843-8.618-4.819-11.594-2.977-2.977-7.087-4.819-11.594-4.819h-37.586c-4.508 0-8.59 1.842-11.565 4.819-2.977 2.976-4.848 7.086-4.848 11.594zm-384.06 30.643c3.601.851 6.859 1.333 9.836 1.474 7.568.369 13.011-1.389 16.894-4.507 3.912-3.175 6.52-7.908 8.164-13.294 1.474-4.762 2.182-10.006 2.438-15.193.198-4.11 3.713-7.313 7.823-7.115 2.154.085 3.458.907 4.989 2.183 1.615 1.389 9.524 7.483 20.238 5.811V63.131c0-4.507-1.843-8.618-4.818-11.594-2.977-2.977-7.087-4.819-11.565-4.819H45.148c-4.507 0-8.589 1.842-11.564 4.819-2.977 2.976-4.819 7.086-4.819 11.594v41.556zm70.383-15.591c-7.682.737-14.343-.964-19.502-3.175-.453 2.324-.992 4.62-1.7 6.831-2.467 8.022-6.577 15.307-13.097 20.551-6.576 5.329-15.363 8.391-26.957 7.795a62 62 0 0 1-7.228-.793c1.786 5.102 4.677 9.694 8.446 13.436 6.378 6.378 15.166 10.347 24.832 10.347 9.694 0 18.481-3.969 24.859-10.347 6.377-6.378 10.346-15.194 10.346-24.86zm366.655 66.728a50 50 0 0 1-17.772 3.26 49.9 49.9 0 0 1-20.381-4.337c-3.118.482-5.839 2.239-7.625 4.819l-38.295 56.239c-1.39 2.041-3.714 3.26-6.18 3.288h-61.624c-3.147 0-6.01 1.276-8.079 3.317-2.041 2.069-3.316 4.932-3.316 8.079s1.275 5.981 3.316 8.05a11.44 11.44 0 0 0 8.022 3.345h72.396c1.56-.113 3.09-.567 4.507-1.332a11.3 11.3 0 0 0 4.11-3.657l34.27-50.287c2.325-3.402 6.974-4.28 10.403-1.956 3.402 2.325 4.28 6.973 1.956 10.403l-20.692 30.359 8.021 77.811 63.893-6.576-12.331-119.821c-.538-5.244-2.409-10.091-5.329-13.918-2.409-3.203-5.584-5.697-9.27-7.086M212.9 59.871c-3.118-2.693-3.486-7.427-.821-10.545 2.692-3.146 7.427-3.515 10.545-.822l34.185 29.168 30.812-17.943c3.571-2.069 8.164-.85 10.232 2.721a7.463 7.463 0 0 1-2.721 10.205l-35.375 20.636c-2.693 1.559-6.151 1.332-8.618-.794zm27.893 89.008c4.025.935 6.548 4.932 5.612 8.958-.907 4.053-4.933 6.548-8.958 5.641-18.311-4.252-34.241-14.626-45.523-28.857-11.084-13.975-17.688-31.606-17.688-50.768 0-22.592 9.155-43.03 23.952-57.827s35.234-23.953 57.798-23.953c22.592 0 43.029 9.156 57.826 23.953s23.952 35.234 23.952 57.827c0 19.162-6.633 36.793-17.688 50.768-11.282 14.23-27.241 24.605-45.524 28.857-4.024.907-8.05-1.587-8.985-5.641-.907-4.025 1.616-8.022 5.641-8.958 14.91-3.458 27.921-11.934 37.133-23.584 9.015-11.367 14.429-25.767 14.429-41.442 0-18.454-7.483-35.15-19.559-47.225s-28.771-19.559-47.225-19.559c-18.425 0-35.12 7.483-47.196 19.559-12.075 12.075-19.559 28.771-19.559 47.225 0 15.675 5.386 30.076 14.4 41.442 9.241 11.65 22.252 20.126 37.162 23.584M15.101 373.241v121.691h48.558V373.241zm21.713-15.024c30.331 0 60.661.028 90.963.028a7.5 7.5 0 0 1 2.494.255c3.997 1.049 6.378 5.159 5.301 9.156L108.019 470.27c-1.474 5.527-.906 10.233.964 13.918 2.183 4.309 6.095 7.483 10.658 9.241 5.018 1.928 10.998 2.126 15.959-.028 5.641-2.409 8.845-7.171 10.375-12.897l36.736-136.828c1.615-6.038.821-12.274-3.345-17.178-4.252-5.074-10.941-7.54-17.462-7.54H89.822v-.028h-.396l-.143-.028h-.226l-71.347-7.37-2.665 26.022c-.538 5.301 1.758 10.432 5.499 14.117 4.394 4.335 10.148 6.546 16.27 6.546m386.102-39.316h-.198l-.143.028h-.396v.028h-72.112c-6.603 0-13.181 2.523-17.461 7.71-3.968 4.876-4.932 11.055-3.316 17.008l36.708 136.828c1.559 5.726 4.762 10.488 10.403 12.897 4.961 2.154 10.941 1.956 15.959.028 4.535-1.757 8.476-4.932 10.658-9.241 1.87-3.685 2.436-8.391.935-13.918L376.4 367.657c-1.248-4.706 2.352-9.439 7.228-9.439h91.811c5.953 0 11.735-2.381 15.987-6.548 3.855-3.77 6.066-8.788 5.528-14.117l-2.693-26.022zm-292.758-62.022v15.534h251.656v-15.534z"
}));

const SvgIfcaxMenuxIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  id: "ifcax-menux-icon_svg__Layer_2",
  viewBox: "0 0 1020 1023",
  width: "1em",
  height: "1em"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "ifcax-menux-icon_svg__drop-shadow-1",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: 8.68,
  dy: 8.68
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "blur",
  stdDeviation: 6.2
}), /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#000",
  floodOpacity: 0.39
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "blur",
  operator: "in"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "SourceGraphic"
})), /*#__PURE__*/React.createElement("style", null, ".ifcax-menux-icon_svg__cls-3{fill:#faaf22}.ifcax-menux-icon_svg__cls-4{fill:#231f20}")), /*#__PURE__*/React.createElement("g", {
  id: "ifcax-menux-icon_svg__Layer_1-2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h1020v1023H0z",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M40.38 687.1V244.65h133.7l80.28 301.81 79.38-301.81h134V687.1h-83V338.81l-87.83 348.28H210.9l-87.52-348.28v348.28h-83Z",
  className: "ifcax-menux-icon_svg__cls-4",
  style: {
    filter: "url(#ifcax-menux-icon_svg__drop-shadow-1)"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "m253.66 384.46 144.27-.65 110.98 81.25-82.94 49.26zM525.63 589.18l70.37-56.5 207.85 156.46-145.96-.36z",
  className: "ifcax-menux-icon_svg__cls-3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M240.59 689.15s236.62-257.94 718.7-379.86c0 0-344.86 123.83-558 379.86z",
  className: "ifcax-menux-icon_svg__cls-3"
}), /*#__PURE__*/React.createElement("path", {
  d: "m565.64 651.87 30.67 5.15c-3.94 11.25-10.17 19.81-18.68 25.69s-19.15 8.82-31.93 8.82q-30.345 0-44.91-19.83c-7.67-10.59-11.5-23.95-11.5-40.09q0-28.92 15.12-45.3c10.08-10.92 22.82-16.38 38.23-16.38 17.31 0 30.96 5.71 40.97 17.14 10 11.43 14.79 28.94 14.35 52.53h-77.12c.22 9.13 2.7 16.23 7.45 21.31s10.66 7.61 17.75 7.61c4.82 0 8.87-1.31 12.16-3.94s5.77-6.86 7.45-12.71Zm1.75-31.11c-.22-8.91-2.52-15.68-6.9-20.32q-6.57-6.96-15.99-6.96c-6.72 0-12.27 2.45-16.65 7.34s-6.54 11.54-6.46 19.94h46.01ZM773.72 688.89h-30.78v-59.37c0-12.56-.66-20.69-1.97-24.37-1.31-3.69-3.45-6.55-6.41-8.6-2.96-2.04-6.52-3.07-10.68-3.07-5.33 0-10.12 1.46-14.35 4.38-4.24 2.92-7.14 6.79-8.71 11.61s-2.35 13.73-2.35 26.73v52.69h-30.78V572.55h28.59v17.09c10.15-13.15 22.93-19.72 38.34-19.72 6.79 0 13 1.22 18.62 3.67s9.88 5.57 12.76 9.37 4.89 8.11 6.02 12.93 1.7 11.72 1.7 20.7zM926.38 688.89v-17.42c-4.24 6.21-9.8 11.1-16.71 14.68s-14.19 5.37-21.85 5.37-14.83-1.72-21.03-5.15q-9.315-5.145-13.47-14.46c-2.78-6.21-4.16-14.79-4.16-25.74v-73.61h30.78v53.46c0 16.36.56 26.38 1.7 30.07 1.13 3.69 3.19 6.61 6.19 8.76 2.99 2.15 6.79 3.23 11.39 3.23 5.26 0 9.97-1.44 14.13-4.33 4.16-2.88 7.01-6.46 8.54-10.74 1.53-4.27 2.3-14.73 2.3-31.38v-49.08h30.78v116.34z",
  className: "ifcax-menux-icon_svg__cls-4"
})));

const SvgIfcaxMxIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  id: "ifcax-mx-icon_svg__Layer_2",
  viewBox: "0 0 232.21 231.04",
  width: "1em",
  height: "1em"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "ifcax-mx-icon_svg__drop-shadow-1",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: 2,
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "blur",
  stdDeviation: 5
}), /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#000",
  floodOpacity: 0.39
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "blur",
  operator: "in"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "SourceGraphic"
})), /*#__PURE__*/React.createElement("style", null, ".ifcax-mx-icon_svg__cls-1{fill:#fff}.ifcax-mx-icon_svg__cls-5{opacity:.27}")), /*#__PURE__*/React.createElement("g", {
  id: "ifcax-mx-icon_svg__Layer_1-2"
}, /*#__PURE__*/React.createElement("rect", {
  width: 231.04,
  height: 231.04,
  x: 0.96,
  rx: 57.76,
  ry: 57.76,
  style: {
    fill: "#f9ae21"
  }
}), /*#__PURE__*/React.createElement("g", {
  className: "ifcax-mx-icon_svg__cls-5"
}, /*#__PURE__*/React.createElement("path", {
  d: "m26.69 24.2 7.68-.03 5.9 4.32-4.41 2.61zM41.15 35.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-mx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26 40.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM96.69 24.2l7.68-.03 5.9 4.32-4.41 2.61zM111.15 35.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-mx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M96 40.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM169.69 24.2l7.68-.03 5.9 4.32-4.41 2.61zM184.15 35.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-mx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M169 40.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2z",
  className: "ifcax-mx-icon_svg__cls-1"
})), /*#__PURE__*/React.createElement("g", {
  className: "ifcax-mx-icon_svg__cls-5"
}, /*#__PURE__*/React.createElement("path", {
  d: "m26.69 109.2 7.68-.03 5.9 4.32-4.41 2.61zM41.15 120.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-mx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26 125.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM96.69 109.2l7.68-.03 5.9 4.32-4.41 2.61zM111.15 120.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-mx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M96 125.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM169.69 109.2l7.68-.03 5.9 4.32-4.41 2.61zM184.15 120.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-mx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M169 125.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2z",
  className: "ifcax-mx-icon_svg__cls-1"
})), /*#__PURE__*/React.createElement("g", {
  className: "ifcax-mx-icon_svg__cls-5"
}, /*#__PURE__*/React.createElement("path", {
  d: "m26.69 198.2 7.68-.03 5.9 4.32-4.41 2.61zM41.15 209.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-mx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26 214.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM96.69 198.2l7.68-.03 5.9 4.32-4.41 2.61zM111.15 209.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-mx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M96 214.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM169.69 198.2l7.68-.03 5.9 4.32-4.41 2.61zM184.15 209.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-mx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M169 214.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2z",
  className: "ifcax-mx-icon_svg__cls-1"
})), /*#__PURE__*/React.createElement("g", {
  className: "ifcax-mx-icon_svg__cls-5"
}, /*#__PURE__*/React.createElement("path", {
  d: "m62.69 153.2 7.68-.03 5.9 4.32-4.41 2.61zM77.15 164.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-mx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M62 169.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM.69 153.2l7.68-.03 5.9 4.32-4.41 2.61zM15.15 164.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-mx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 169.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM130.69 153.2l7.68-.03 5.9 4.32-4.41 2.61zM145.15 164.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-mx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M130 169.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM194.69 153.2l7.68-.03 5.9 4.32-4.41 2.61zM209.15 164.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-mx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M194 169.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2z",
  className: "ifcax-mx-icon_svg__cls-1"
})), /*#__PURE__*/React.createElement("g", {
  className: "ifcax-mx-icon_svg__cls-5"
}, /*#__PURE__*/React.createElement("path", {
  d: "m62.69 66.2 7.68-.03 5.9 4.32-4.41 2.61zM77.15 77.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-mx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M62 82.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM.69 66.2l7.68-.03 5.9 4.32-4.41 2.61zM15.15 77.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-mx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 82.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM130.69 66.2l7.68-.03 5.9 4.32-4.41 2.61zM145.15 77.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-mx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M130 82.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM194.69 66.2l7.68-.03 5.9 4.32-4.41 2.61zM209.15 77.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-mx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M194 82.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2z",
  className: "ifcax-mx-icon_svg__cls-1"
})), /*#__PURE__*/React.createElement("g", {
  style: {
    filter: "url(#ifcax-mx-icon_svg__drop-shadow-1)"
  }
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.07 181.02V43.22h41.64l25 94 24.72-94h41.73v137.8h-25.85V72.55L92.96 181.02H66.17L38.91 72.55v108.47z",
  style: {
    fill: "#231f20"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "m54.68 107.32 35.12-.15 27.03 19.78-20.2 11.99zM120.9 157.17l17.13-13.76 50.61 38.1-35.54-.09z",
  className: "ifcax-mx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M51.5 181.51s57.61-62.8 174.99-92.49c0 0-83.97 30.15-135.86 92.49z",
  className: "ifcax-mx-icon_svg__cls-1"
})));

const SvgIfcaxNewProductSales = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 30 30"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 66326"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h30v30H0z",
  "data-name": "Rectangle 27533"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5a5a5a",
  d: "M20.031 6.374v1.438a.71.71 0 0 1-.719.719h-.719V6.374a.71.71 0 0 0-.719-.719h-5.75a.71.71 0 0 0-.719.719V8.53h-.719a.71.71 0 0 1-.719-.719V6.374a2.153 2.153 0 0 1 2.157-2.156h5.75a2.153 2.153 0 0 1 2.157 2.156",
  "data-name": "Path 81732"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#444",
  d: "M17.875 5.656H15V4.218h2.875a2.153 2.153 0 0 1 2.156 2.156v1.438a.71.71 0 0 1-.719.719h-.719V6.374a.71.71 0 0 0-.718-.718",
  "data-name": "Path 81733"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5a5a5a",
  d: "M27.267 7.811v15.814a2.154 2.154 0 0 1-2.156 2.156H4.888a2.154 2.154 0 0 1-2.156-2.155V7.811a.7.7 0 0 1 .216-.5l3.666 8.252h16.772l3.666-8.252a.7.7 0 0 1 .215.5",
  "data-name": "Path 81734"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#444",
  d: "M27.268 7.811v15.814a2.154 2.154 0 0 1-2.156 2.156H15v-10.22h8.386l3.666-8.252a.7.7 0 0 1 .216.502",
  "data-name": "Path 81735"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#6e6e6e",
  d: "m27.047 7.309-2.228 8.252a2.15 2.15 0 0 1-2.085 1.6H7.261a2.15 2.15 0 0 1-2.085-1.6L2.947 7.309a.7.7 0 0 1 .5-.216h23.1a.7.7 0 0 1 .5.216",
  "data-name": "Path 81736"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5a5a5a",
  d: "m27.052 7.309-2.228 8.252a2.15 2.15 0 0 1-2.085 1.6H15V7.093h11.549a.7.7 0 0 1 .503.216",
  "data-name": "Path 81737"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffd400",
  d: "M17.875 15h-5.75a.71.71 0 0 0-.719.719v2.875a.71.71 0 0 0 .719.719h5.75a.71.71 0 0 0 .719-.719v-2.875a.71.71 0 0 0-.719-.719",
  "data-name": "Path 81738"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fdbf00",
  d: "M18.594 15.719v2.875a.71.71 0 0 1-.719.719H15V15h2.875a.71.71 0 0 1 .719.719",
  "data-name": "Path 81739"
})));

const SvgIfcaxNoBug = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 14 14"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h14v14H0z",
  "data-name": "Rectangle 27720"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#898989",
  "data-name": "bug (1)"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 65604"
}, /*#__PURE__*/React.createElement("path", {
  d: "m2.346 12.936-.644-.2.6-1.9 1.743-.684.247.629-1.443.567Z",
  "data-name": "Path 81454"
}), /*#__PURE__*/React.createElement("path", {
  d: "m3.693 7.163-1.388-.545-.6-1.9.644-.2.505 1.591 1.089.428Z",
  "data-name": "Path 81455"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.483 9.936 1 9.464l1.329-1.36h1.487v.676h-1.2Z",
  "data-name": "Path 81456"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 65605"
}, /*#__PURE__*/React.createElement("path", {
  d: "m11.168 12.936-.505-1.591-1.443-.567.247-.629 1.743.684.6 1.9Z",
  "data-name": "Path 81457"
}), /*#__PURE__*/React.createElement("path", {
  d: "m9.821 7.163-.247-.629 1.089-.428.505-1.591.644.2-.6 1.9Z",
  "data-name": "Path 81458"
}), /*#__PURE__*/React.createElement("path", {
  d: "m12.031 9.936-1.13-1.157h-1.2v-.676h1.487l1.329 1.36Z",
  "data-name": "Path 81459"
})), /*#__PURE__*/React.createElement("path", {
  d: "M6.227 3.561h-.676v-.493a.394.394 0 0 0-.393-.393v-.676a1.07 1.07 0 0 1 1.069 1.069Z",
  "data-name": "Path 81460"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.963 3.561h-.676v-.493a1.07 1.07 0 0 1 1.069-1.069v.676a.394.394 0 0 0-.393.393Z",
  "data-name": "Path 81461"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.757 12.284a3.13 3.13 0 0 1-3.129-3.129V6.026h6.256v3.129a3.13 3.13 0 0 1-3.127 3.129",
  "data-name": "Path 81462"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.757 12.285V6.026h3.129v3.129a3.13 3.13 0 0 1-3.129 3.13",
  "data-name": "Path 81463"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.757 3.072a2.21 2.21 0 0 0-2.21 2.21V6.51h4.419V5.277a2.21 2.21 0 0 0-2.209-2.205",
  "data-name": "Path 81464"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.757 3.072V6.51h2.21V5.277a2.21 2.21 0 0 0-2.21-2.205",
  "data-name": "Path 81465"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.883 6.023H3.624l3.129 2.538Z",
  "data-name": "Path 81466"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.886 6.023H6.757v2.538Z",
  "data-name": "Path 81467"
})));

const SvgIfcaxNoFire = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 14 14"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h14v14H0z",
  "data-name": "Rectangle 27721"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#898989",
  "data-name": "fire"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.453 8.581a3.9 3.9 0 0 0-.254-1.171l-.006-.016c-.008-.02-.805-1.964-.432-3.032a.308.308 0 0 0-.3-.409 2.07 2.07 0 0 0-1.176.552 6.8 6.8 0 0 1-.6-2.214.308.308 0 0 0-.466-.243 5.5 5.5 0 0 0-1.875 1.789 4.4 4.4 0 0 0-.633 1.84 5 5 0 0 0 0 1.064.187.187 0 0 1-.257.194l-.792-.324a.3.3 0 0 0-.171-.022.31.31 0 0 0-.248.219 7 7 0 0 0-.165.707 4.86 4.86 0 0 0 .16 2.326 4.06 4.06 0 0 0 1.2 1.843 3.45 3.45 0 0 0 2.282.831 4.5 4.5 0 0 0 1.466-.258 3.21 3.21 0 0 0 1.827-1.566 4.03 4.03 0 0 0 .442-2.106Z",
  "data-name": "Path 81450"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.453 8.578a3.9 3.9 0 0 0-.254-1.171l-.006-.016c-.008-.02-.805-1.964-.432-3.032a.308.308 0 0 0-.3-.409 1.97 1.97 0 0 0-.979.395.2.2 0 0 1-.307-.086 7 7 0 0 1-.49-1.971.308.308 0 0 0-.466-.243q-.244.147-.466.308V12.51a4.5 4.5 0 0 0 1.436-.257 3.21 3.21 0 0 0 1.827-1.566 4.03 4.03 0 0 0 .442-2.106Z",
  "data-name": "Path 81451"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.563 7.337A.308.308 0 0 0 7 7.531c.037.492-.012 1.939-.7 2.127a.97.97 0 0 1-.924-.138.3.3 0 0 0-.3-.087.31.31 0 0 0-.222.223 5 5 0 0 0-.079.34 2.24 2.24 0 0 0 .689 2.089 1.76 1.76 0 0 0 1.164.426 2.3 2.3 0 0 0 .736-.129 1.9 1.9 0 0 0 1-.851 2.3 2.3 0 0 0 .335-1.118 5.45 5.45 0 0 0-1.136-3.076",
  "data-name": "Path 81452"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.208 7.218a.31.31 0 0 0-.207.314 3.84 3.84 0 0 1-.253 1.708v3.268a2.3 2.3 0 0 0 .625-.126 1.9 1.9 0 0 0 1-.851 2.3 2.3 0 0 0 .335-1.118A5.45 5.45 0 0 0 7.56 7.338a.31.31 0 0 0-.352-.12",
  "data-name": "Path 81453"
})));

const SvgIfcaxOldIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  id: "ifcax-old-icon_svg__Layer_2",
  viewBox: "0 0 231.04 231.04",
  width: "1em",
  height: "1em"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "ifcax-old-icon_svg__clippath"
}, /*#__PURE__*/React.createElement("rect", {
  width: 231.04,
  height: 231.04,
  rx: 57.76,
  ry: 57.76,
  style: {
    fill: "none"
  }
})), /*#__PURE__*/React.createElement("filter", {
  id: "ifcax-old-icon_svg__outer-glow-1",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "blur",
  stdDeviation: 7
}), /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#0e1121",
  floodOpacity: 0.34
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "blur",
  operator: "in"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "SourceGraphic"
})), /*#__PURE__*/React.createElement("style", null, ".ifcax-old-icon_svg__cls-3{fill:#f89a33}.ifcax-old-icon_svg__cls-5{fill:#faaf22}.ifcax-old-icon_svg__cls-7{fill:#1a1a1a}")), /*#__PURE__*/React.createElement("g", {
  id: "ifcax-old-icon_svg__Layer_1-2",
  style: {
    filter: "url(#ifcax-old-icon_svg__outer-glow-1)"
  }
}, /*#__PURE__*/React.createElement("g", {
  style: {
    clipPath: "url(#ifcax-old-icon_svg__clippath)"
  }
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.51 0h232.48v233.16H1.51z",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "m39.07 79.43 39.24-.18 30.19 22.11-22.56 13.4zM113.05 135.12l19.14-15.37 56.54 42.56-39.7-.1z",
  className: "ifcax-old-icon_svg__cls-5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M35.52 162.31S99.88 92.15 231.01 58.98c0 0-93.81 33.68-151.78 103.33z",
  className: "ifcax-old-icon_svg__cls-5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M93.46 95.19h-50.2v3.49h3.16c1.41 0 2.76.35 4 1.04.82.48 1.36 1.03 1.61 1.64.26.66.57 2.27.57 6.23v42.13c0 4.86-.62 6.4-.98 6.88-1.06 1.36-2.76 2.03-5.19 2.03h-3.16v3.49h29.7v-3.49h-3.21c-1.39 0-2.74-.35-4.01-1.04-.85-.48-1.4-1.03-1.64-1.64-.26-.65-.57-2.27-.57-6.23v-19.63h11.02c2.03 0 3.55.27 4.53.79.96.52 1.7 1.27 2.25 2.32.56 1.06.86 2.81.89 5.19v.84h.01c1.92 0 3.48-1.56 3.48-3.48v-20.31h-3.39l-.09.75c-.39 3.34-1.15 5.57-2.26 6.62-1.1 1.04-2.91 1.57-5.4 1.57h-8.45a2.58 2.58 0 0 1-2.58-2.58v-21.35h13.53c3.27 0 5.7.3 7.21.9 1.47.58 2.72 1.53 3.73 2.83 1.03 1.33 1.96 3.49 2.76 6.41l.17.63h3.23l-.7-16.04ZM152.96 145.68l-2.85-1.84-.47.66c-3.79 5.26-7.29 8.81-10.4 10.55-3.09 1.73-6.72 2.61-10.79 2.61-4.69 0-8.92-1.12-12.57-3.34-3.63-2.2-6.39-5.42-8.2-9.57-1.84-4.2-2.77-9.24-2.77-15 0-7 .99-12.93 2.94-17.61 1.92-4.62 4.59-8.02 7.91-10.11 3.34-2.1 7.14-3.16 11.28-3.16 4.94 0 9.23 1.41 12.74 4.19 3.53 2.79 6.3 7.47 8.22 13.91l.18.61c1.64 0 2.95-1.39 2.84-3.03l-1.4-20.84h-3.16l-.15.66c-.32 1.38-.84 2.46-1.54 3.18-.48.46-1.03.68-1.67.68-.2 0-.83-.09-2.5-.97-4.68-2.36-9.5-3.55-14.33-3.55-6.19 0-11.97 1.55-17.19 4.61-5.23 3.07-9.39 7.44-12.37 13.01-2.97 5.55-4.48 11.72-4.48 18.34 0 8.23 2.29 15.49 6.8 21.57 6.07 8.21 14.75 12.37 25.79 12.37 6.13 0 11.5-1.4 15.98-4.17 4.47-2.76 8.42-7.15 11.74-13.05l.39-.7ZM217.09 158.62c-2.45-.15-4.38-.81-5.72-1.98-1.39-1.21-2.98-3.96-4.75-8.17L183.7 93.7h-2.82l-23.16 54.19c-1.93 4.58-3.69 7.64-5.24 9.09-.46.44-1.68 1.09-4.85 1.65l-.71.12v3.35h22.24v-3.43l-.79-.06c-3.68-.26-5.11-.84-5.66-1.28-.74-.59-1.1-1.23-1.1-1.95 0-1.13.53-2.93 1.57-5.34l4.2-9.77h24.12l3.72 8.85c1.23 2.93 1.86 5.07 1.86 6.35 0 .79-.34 1.46-1.05 2.03-.53.43-1.78.96-4.77 1.11l-.81.04v3.45h27.44v-3.44l-.8-.05Zm-32.31-23.61h-15.16l10.04-23.32 7.98 19.01c.86 2.05-.64 4.31-2.86 4.31M208.48 92.96c0 4.9-3.84 8.74-8.85 8.74s-8.9-3.84-8.9-8.74 3.95-8.64 8.9-8.64 8.85 3.84 8.85 8.64m-15.53 0c0 3.84 2.84 6.9 6.74 6.9s6.58-3.05 6.58-6.85-2.79-6.95-6.63-6.95-6.69 3.11-6.69 6.9m5.32 4.53h-2v-8.64c.79-.16 1.9-.26 3.32-.26 1.63 0 2.37.26 3 .63.47.37.84 1.05.84 1.9 0 .95-.74 1.69-1.79 2v.11c.84.32 1.32.95 1.58 2.11.26 1.32.42 1.84.63 2.16h-2.16c-.26-.32-.42-1.11-.68-2.11-.16-.95-.68-1.37-1.79-1.37h-.95v3.48Zm.05-4.9h.95c1.11 0 2-.37 2-1.26 0-.79-.58-1.32-1.84-1.32-.53 0-.9.05-1.11.11zM9.9 98.67h3.16c1.39 0 2.74.35 4 1.04.82.48 1.36 1.03 1.61 1.64.26.66.57 2.27.57 6.23v42.13c0 4.86-.62 6.4-.97 6.88-1.06 1.36-2.76 2.03-5.19 2.03H9.92v3.49h29.65v-3.49h-3.21a8.1 8.1 0 0 1-3.96-1.04c-.85-.48-1.4-1.03-1.64-1.64-.26-.65-.57-2.27-.57-6.23v-42.13c0-4.85.64-6.39 1.02-6.88 1.06-1.36 2.74-2.03 5.14-2.03 1.77 0 3.21-1.44 3.21-3.21v-.28H9.9z",
  className: "ifcax-old-icon_svg__cls-7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.45 76.39c.61-1.66 1.01-3.27 1.29-4.73a30 30 0 0 0-4.89-.3q-.885.015-1.74.09c.4.41.79.83 1.16 1.26.16-.07.34-.1.53-.1.78 0 1.4.63 1.4 1.4 0 .31-.1.6-.27.83.7 1 1.33 2.05 1.89 3.16.23-.52.44-1.06.64-1.6ZM13.42 71.22c-.93 1.55-1.55 3.3-1.78 5.17.8-.64 1.62-1.22 2.47-1.75q-.435-1.65-.69-3.42M15.61 73.75c-.02-.08-.02-.17-.02-.26a1.398 1.398 0 0 1 2.47-.9c2.01-.83 4.13-1.41 6.33-1.73-1.85-1.65-3.98-3.05-6.37-4.21-1.54.91-2.88 2.13-3.93 3.57.14 1.24.37 2.59.73 3.99.26-.16.53-.31.8-.45ZM36.22 71.54c-.61-1.09-1.38-2.09-2.26-2.96-.06.72-.16 1.54-.31 2.42.96.16 1.82.35 2.57.53ZM27.86 70.58c1.81-.04 3.51.1 5.02.31.18-1.12.29-2.13.35-2.97a13.1 13.1 0 0 0-8.5-3.11c-2.12 0-4.12.5-5.89 1.39q3.69 1.875 6.54 4.53c.82-.09 1.65-.14 2.49-.16ZM16.99 74.9c-.41 0-.79-.18-1.04-.47-.31.17-.62.35-.93.53.68 2.36 1.75 4.81 3.41 7.04q2.31 3.12 5.73 5.16c2.62-2.28 4.71-5.03 6.24-8.25-.61-1.27-1.3-2.47-2.08-3.6-.16.07-.34.1-.53.1a1.398 1.398 0 0 1-1.12-2.24c-.49-.57-1-1.11-1.54-1.63-2.37.28-4.62.86-6.75 1.73A1.398 1.398 0 0 1 17 74.89ZM36.69 72.48q-.225-.48-.48-.93zh-.03c-.86-.24-1.93-.49-3.15-.7-.28 1.49-.7 3.14-1.32 4.85-.28.78-.6 1.54-.94 2.28.34.74.66 1.5.94 2.28.84 2.31 1.31 4.53 1.57 6.39 2.55-2.4 4.14-5.81 4.14-9.58 0-1.97-.43-3.84-1.21-5.51ZM30.81 79.82a26.5 26.5 0 0 1-5.14 6.98c-.27.26-.54.51-.82.76.23.13.46.25.7.37a1.398 1.398 0 0 1 2.56.78c0 .11-.01.21-.04.31.79.29 1.62.55 2.48.78.9-.44 1.74-.99 2.5-1.61-.24-1.91-.7-4.28-1.61-6.77-.2-.55-.41-1.08-.64-1.6ZM20.75 90.56l-.94-.34c.31.12.62.24.94.34M27.69 89.72c-.25.25-.6.4-.98.4-.78 0-1.4-.63-1.4-1.4v-.03c-.37-.19-.74-.38-1.09-.58-1.07.89-2.23 1.71-3.46 2.45 1.25.4 2.59.61 3.97.61 1.66 0 3.24-.31 4.71-.86-.59-.18-1.17-.37-1.73-.58Z",
  className: "ifcax-old-icon_svg__cls-3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.8 82.46c-1.51-2.04-2.68-4.42-3.47-7.07-.95.61-1.87 1.3-2.77 2.05 0 .18-.01.36-.01.55 0 5.54 3.42 10.29 8.27 12.23 1.33-.76 2.57-1.6 3.71-2.53a20.5 20.5 0 0 1-5.73-5.23",
  className: "ifcax-old-icon_svg__cls-3"
}))));

const SvgIfcaxPdf = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 30 30"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 8117"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#e2574c",
  d: "M4.371 0h15.935l8.444 8.411v19.714A1.875 1.875 0 0 1 26.871 30h-22.5a1.875 1.875 0 0 1-1.875-1.875V1.875A1.875 1.875 0 0 1 4.371 0",
  "data-name": "Path 11620"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#b53629",
  d: "M28.722 8.438h-6.535a1.876 1.876 0 0 1-1.875-1.875V.019Z",
  "data-name": "Path 11621"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M21.717 14.216a.545.545 0 0 0 0-1.079h-1.789a.56.56 0 0 0-.545.609v4.4c0 .392.223.609.525.609s.524-.218.524-.609v-1.207h1.082a.51.51 0 0 0 .5-.548.5.5 0 0 0-.5-.533h-1.082v-1.642Zm-6.046-1.079h-1.309a.58.58 0 0 0-.608.606v4.4a.577.577 0 0 0 .622.59h1.373a2.547 2.547 0 0 0 2.7-2.721 2.614 2.614 0 0 0-2.778-2.876Zm.063 4.513h-.8v-3.428h.719c1.088 0 1.562.73 1.562 1.738.002.943-.463 1.689-1.481 1.689Zm-4.794-4.513h-1.3a.545.545 0 0 0-.571.609v4.4a.552.552 0 1 0 1.1 0v-1.283h.813a1.775 1.775 0 0 0 1.831-1.853 1.8 1.8 0 0 0-1.874-1.874Zm-.022 2.691h-.747V14.17h.747a.833.833 0 0 1 0 1.658",
  "data-name": "Path 11622"
})));

const SvgIfcaxPenalty = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  "data-name": "filled outline",
  viewBox: "0 0 512 512"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#d78e0c",
  d: "M288 182v-28.111a41.89 41.89 0 0 1 23.155-37.467A41.9 41.9 0 0 1 329.889 112H344a16 16 0 0 0 16-16 16 16 0 0 0-16-16h-11.751a76.25 76.25 0 0 0-37.83 10.046A76.25 76.25 0 0 0 256 156.249V181z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 80,
  height: 32,
  x: 216,
  y: 176,
  fill: "#c7830b",
  rx: 16
}), /*#__PURE__*/React.createElement("g", {
  fill: "#ee9d0d"
}, /*#__PURE__*/React.createElement("path", {
  d: "M240 32h32v144h-32zM341.812 294.415 272 233.911h-32l-69.812 60.5A99.07 99.07 0 0 0 136 369.285a115.96 115.96 0 0 0 47.384 93.507l3.535 2.593a116.82 116.82 0 0 0 138.162 0l3.535-2.593A115.96 115.96 0 0 0 376 369.285a99.07 99.07 0 0 0-34.188-74.87M344 371.927a79.17 79.17 0 0 1-32.35 63.841 94.1 94.1 0 0 1-111.3 0A79.17 79.17 0 0 1 168 371.927a79.17 79.17 0 0 1 27.318-59.827L256 259.511l60.682 52.589A79.17 79.17 0 0 1 344 371.927"
}), /*#__PURE__*/React.createElement("rect", {
  width: 80,
  height: 32,
  x: 216,
  y: 144,
  rx: 16
}), /*#__PURE__*/React.createElement("rect", {
  width: 80,
  height: 32,
  x: 216,
  y: 208,
  rx: 16
})), /*#__PURE__*/React.createElement("path", {
  d: "m347.1 288.41-56.766-50.751A23.975 23.975 0 0 0 297.869 200a23.943 23.943 0 0 0 0-32 23.94 23.94 0 0 0-.289-32.315A33.875 33.875 0 0 1 329.889 112H344a24 24 0 0 0 0-48h-11.751A84.1 84.1 0 0 0 280 82.169V24a8 8 0 0 0-8-8h-32a8 8 0 0 0-8 8v104a23.984 23.984 0 0 0-17.869 40 23.943 23.943 0 0 0 0 32 23.975 23.975 0 0 0 7.537 37.659L164.9 288.41a107.02 107.02 0 0 0-36.9 80.875 124.39 124.39 0 0 0 50.653 99.959l3.535 2.592a124.82 124.82 0 0 0 147.624 0l3.535-2.592A124.39 124.39 0 0 0 384 369.285a107.02 107.02 0 0 0-36.9-80.875m10.031 127.959-9.168-18.335A86.8 86.8 0 0 0 352 371.928c0-1.007-.024-2.011-.058-3.013l15.782 7.891a108.1 108.1 0 0 1-10.595 39.563zM264 479.7l17.161-20.594c.071-.085.131-.176.2-.264a102 102 0 0 0 22.927-9l-4.676 21.045A107.8 107.8 0 0 1 264 479.7m-58-11.854 22.39-9.6a101.5 101.5 0 0 0 27.61 3.837c.627 0 1.254-.026 1.881-.037l-14.366 17.24A107.6 107.6 0 0 1 206 467.847zm100.919-38.53a85.77 85.77 0 0 1-101.836 0 71.168 71.168 0 0 1-4.525-111.17L256 270.1l55.443 48.049a71.168 71.168 0 0 1-4.525 111.17zm-161.173-40.8 17.545 7.018A87.8 87.8 0 0 0 172.008 416h-17.317a108.5 108.5 0 0 1-8.946-27.486zM144 369.285a91 91 0 0 1 6.047-32.627l10.439 26.1a87 87 0 0 0-.486 9.173q0 2.567.153 5.117l-16.133-6.453c-.006-.439-.02-.874-.02-1.31m67.826-101.365 3.287 16.44-18.82 16.311-3.2-16zM232 208h48a8 8 0 0 1 0 16h-48a8 8 0 0 1 0-16m-8-24a8.01 8.01 0 0 1 8-8h48a8 8 0 0 1 0 16h-48a8.01 8.01 0 0 1-8-8m42.411 73.948 8.105-12.968L304.738 272h-22.113zM258.76 240l-8.908 14.253-20.832 18.055-3.353-16.763L243.055 240zm90.328 109.6a87 87 0 0 0-12.166-26.669l20.3 3.383a91 91 0 0 1 10.16 32.434zm-12.515-49.14a91 91 0 0 1 7.648 7.467l-24.938-4.157L301.087 288h21.547l13.846 12.379zM304 103.263V86.127a68.4 68.4 0 0 1 22.211-5.851L315.945 98a50 50 0 0 0-8.367 3.264 51 51 0 0 0-3.578 1.999M352 88a8.01 8.01 0 0 1-8 8h-8.406l9.241-15.956A8.01 8.01 0 0 1 352 88m-64 8.306v22.487a50 50 0 0 0-4.758 9.432A24 24 0 0 0 280 128v-23.631a67.5 67.5 0 0 1 8-8.063m-40-19.362 16-8v22.112l-16 8zM264 32v19.056l-16 8V32zm-16 84.944 16-8V128h-16zM232 144h48a8 8 0 0 1 0 16h-48a8 8 0 0 1 0-16m-56.573 156.46.093-.081 3.73-3.335 3.282 16.409a87.1 87.1 0 0 0-15.168 23.417L159.816 318a91.1 91.1 0 0 1 15.611-17.54M164.137 432h19.887a86.4 86.4 0 0 0 11.6 10.219 103.5 103.5 0 0 0 11.949 7.548l-17.937 7.687-1.517-1.113A107.6 107.6 0 0 1 164.137 432m159.748 24.341-3.535 2.593c-.662.485-1.339.944-2.01 1.414l5.369-24.16a87.3 87.3 0 0 0 15.772-19.337l7.9 15.807a107.5 107.5 0 0 1-23.496 23.683"
}));

const SvgIfcaxPostSales = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 30 30"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 66327"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h30v30H0z",
  "data-name": "Rectangle 26197"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#033a5d",
  d: "M17.547 4.695H8.338a.884.884 0 0 0-.9.865v21.65a.883.883 0 0 0 .9.864h16.625a.883.883 0 0 0 .9-.864V5.559a.884.884 0 0 0-.9-.865Z",
  "data-name": "Path 68592"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M24.141 26.779H9.385a.4.4 0 0 1-.4-.394V6.352a.4.4 0 0 1 .4-.394h14.756a.4.4 0 0 1 .4.394v20.033a.4.4 0 0 1-.4.394",
  "data-name": "Path 68593"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00467d",
  d: "M18.234 3.552a1.558 1.558 0 0 0-3.116 0h-3.413v3.329h9.942V3.552Z",
  "data-name": "Path 68594"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M17.341 3.603a.676.676 0 1 1-.676-.676.676.676 0 0 1 .676.676",
  "data-name": "Path 68595"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#033a5d",
  d: "M11.705 5.958h9.942v.924h-9.942z",
  "data-name": "Rectangle 26102"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M15.878 8.572h2.407v.454h-2.407z",
  "data-name": "Rectangle 26103"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M15.919 9.698h6.714v.454h-6.714z",
  "data-name": "Rectangle 26104"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M15.919 10.794h6.714v.454h-6.714z",
  "data-name": "Rectangle 26105"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M15.919 11.89h6.714v.454h-6.714z",
  "data-name": "Rectangle 26106"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M15.919 16.161h6.714v.454h-6.714z",
  "data-name": "Rectangle 26107"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M15.919 17.257h6.714v.454h-6.714z",
  "data-name": "Rectangle 26108"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M15.919 18.353h6.714v.454h-6.714z",
  "data-name": "Rectangle 26109"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M15.919 22.607h6.714v.454h-6.714z",
  "data-name": "Rectangle 26110"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M15.919 23.617h6.714v.454h-6.714z",
  "data-name": "Rectangle 26111"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M15.919 24.737h6.714v.454h-6.714z",
  "data-name": "Rectangle 26112"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M15.878 15.027h2.407v.454h-2.407z",
  "data-name": "Rectangle 26113"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M15.878 21.482h2.407v.454h-2.407z",
  "data-name": "Rectangle 26114"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffcb00",
  d: "M14.694 10.473a1.922 1.922 0 1 1-1.922-1.922 1.92 1.92 0 0 1 1.922 1.922",
  "data-name": "Path 68596"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m12.568 11.509-1.1-1.057.412-.431.673.644 1.1-1.152.431.413Z",
  "data-name": "Path 68597"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4ad395",
  d: "M14.694 23.216a1.922 1.922 0 1 1-1.922-1.922 1.92 1.92 0 0 1 1.922 1.922",
  "data-name": "Path 68598"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m12.568 24.262-1.1-1.057.412-.431.673.644 1.1-1.152.431.413Z",
  "data-name": "Path 68599"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4fabf7",
  d: "M15.977 20.343a4.867 4.867 0 1 0-6.883-.11 4.867 4.867 0 0 0 6.883.11",
  "data-name": "Path 68600"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M12.59 20.697a3.843 3.843 0 1 1 3.9-3.781 3.843 3.843 0 0 1-3.9 3.781",
  "data-name": "Path 68601"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#434b56",
  d: "M9.094 20.166a5 5 0 0 1-.49-.6l-.812.787 1.2 1.239.831-.805a5 5 0 0 1-.73-.618",
  "data-name": "Path 68602"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4fabf7",
  d: "m6.462 23.887 2.531-2.451-1.2-1.24-2.53 2.451a.863.863 0 0 0 1.2 1.239",
  "data-name": "Path 68603"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ff5163",
  d: "M15.688 16.858a3.026 3.026 0 1 1-3.026-3.026 3.026 3.026 0 0 1 3.026 3.026",
  "data-name": "Path 68604"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m12.341 18.509-1.738-1.664.649-.678 1.06 1.014 1.738-1.813.678.65Z",
  "data-name": "Path 68605"
})));

const SvgIfcaxProductGallery = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  width: "1em",
  height: "1em",
  viewBox: "0 0 512 512"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M488.909 411.5H23.091c-8.611 0-15.591-6.98-15.591-15.591V107.091C7.5 98.48 14.48 91.5 23.091 91.5h465.817c8.611 0 15.591 6.98 15.591 15.591v288.817c.001 8.612-6.979 15.592-15.59 15.592",
  style: {
    fill: "#685c79"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M488.909 91.5h-30c8.611 0 15.591 6.98 15.591 15.591v288.817c0 8.611-6.98 15.591-15.591 15.591h30c8.611 0 15.591-6.98 15.591-15.591V107.091c0-8.611-6.98-15.591-15.591-15.591",
  style: {
    fill: "#594f69"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M126 33h260v437H126z",
  style: {
    fill: "#ade7ff"
  },
  transform: "rotate(90 256 251.5)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M385 504.5H127c-8.284 0-15-6.716-15-15s6.716-15 15-15h258c8.284 0 15 6.716 15 15s-6.716 15-15 15",
  style: {
    fill: "#685c79"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M385 474.5h-30.126c8.284 0 15 6.716 15 15s-6.716 15-15 15H385c8.284 0 15-6.716 15-15s-6.716-15-15-15",
  style: {
    fill: "#594f69"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M350.697 474.5H161.303s32.295-21.33 32.295-63h124.804c0 41.67 32.295 63 32.295 63",
  style: {
    fill: "#ade7ff"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M318.402 411.5h-28.333c0 41.67 32.295 63 32.295 63h28.333s-32.295-21.33-32.295-63",
  style: {
    fill: "#82d2f5"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M353 191.343v122.314L256 360l-97-46.343V191.343L256 145z",
  style: {
    fill: "#ff2c5c"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "m353 191.343-30 14.333-94.84-47.375L256 145z",
  style: {
    fill: "#e62753"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M256 237.686V360l-97-46.343V191.343z",
  style: {
    fill: "#4fb1f5"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M256 237.686V360l97-46.343V191.343z",
  style: {
    fill: "#ffd659"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "m353 191.343-30 14.333.452 122.098L353 313.657z",
  style: {
    fill: "#ffbd54"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 391.375,
  cy: 22.5,
  r: 15,
  style: {
    fill: "#ff2c5c"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 256,
  cy: 22.5,
  r: 15,
  style: {
    fill: "#ff2c5c"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 120.625,
  cy: 22.5,
  r: 15,
  style: {
    fill: "#ff2c5c"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M488.908 84H384c-4.143 0-7.5 3.357-7.5 7.5s3.357 7.5 7.5 7.5h104.908c4.462 0 8.092 3.63 8.092 8.092v288.816c0 4.462-3.63 8.092-8.092 8.092H23.092C18.63 404 15 400.37 15 395.908V107.092C15 102.63 18.63 99 23.092 99h164.783v15H37.5a7.5 7.5 0 0 0-7.5 7.5v198.167c0 4.143 3.357 7.5 7.5 7.5s7.5-3.357 7.5-7.5V129h142.875v40.235l-32.108 15.34a7.55 7.55 0 0 0-4.267 6.768v122.314c0 2.89 1.66 5.521 4.267 6.768l97 46.343a7.6 7.6 0 0 0 6.467 0l54.531-26.053a7.5 7.5 0 0 0 3.534-10.001 7.5 7.5 0 0 0-10.001-3.534L263.5 348.104v-105.69l82-39.176v105.69l-11.141 5.322a7.5 7.5 0 0 0-3.534 10.001 7.5 7.5 0 0 0 10.001 3.534l15.407-7.361a7.5 7.5 0 0 0 4.267-6.768V191.343a7.54 7.54 0 0 0-4.267-6.768l-32.108-15.34V129H467v245H45v-22.333c0-4.143-3.357-7.5-7.5-7.5s-7.5 3.357-7.5 7.5V381.5c0 4.143 3.357 7.5 7.5 7.5h437c4.143 0 7.5-3.357 7.5-7.5v-260c0-4.143-3.357-7.5-7.5-7.5H324.125V99H352c4.143 0 7.5-3.357 7.5-7.5S356.143 84 352 84h-27.875V69h67.25c4.143 0 7.5-3.357 7.5-7.5V43.71c8.729-3.096 15-11.433 15-21.21 0-12.406-10.094-22.5-22.5-22.5s-22.5 10.094-22.5 22.5c0 9.777 6.271 18.114 15 21.21V54h-67.25a7.5 7.5 0 0 0-7.5 7.5V84H263.5V43.71c8.729-3.096 15-11.433 15-21.21C278.5 10.094 268.406 0 256 0s-22.5 10.094-22.5 22.5c0 9.777 6.271 18.114 15 21.21V84h-45.625V61.5c0-4.143-3.357-7.5-7.5-7.5h-67.25V43.71c8.729-3.096 15-11.433 15-21.21 0-12.406-10.094-22.5-22.5-22.5s-22.5 10.094-22.5 22.5c0 9.777 6.271 18.114 15 21.21V61.5c0 4.143 3.357 7.5 7.5 7.5h67.25v15H23.092C10.359 84 0 94.359 0 107.092v288.816C0 408.641 10.359 419 23.092 419h162.602c-2.902 27.513-21.091 43.577-26.826 48H127c-12.406 0-22.5 10.094-22.5 22.5S114.594 512 127 512h258c12.406 0 22.5-10.094 22.5-22.5S397.406 467 385 467h-31.849c-5.658-4.407-23.912-20.616-26.839-48h162.596C501.641 419 512 408.641 512 395.908V107.092C512 94.359 501.641 84 488.908 84m-97.533-69c4.136 0 7.5 3.364 7.5 7.5s-3.364 7.5-7.5 7.5-7.5-3.364-7.5-7.5 3.364-7.5 7.5-7.5M256 15c4.136 0 7.5 3.364 7.5 7.5S260.136 30 256 30s-7.5-3.364-7.5-7.5 3.364-7.5 7.5-7.5m-135.375 0c4.136 0 7.5 3.364 7.5 7.5s-3.364 7.5-7.5 7.5-7.5-3.364-7.5-7.5 3.364-7.5 7.5-7.5m82.25 114H248.5v11.271l-45.625 21.798zm132.726 62.343L256 229.373l-79.601-38.03L256 153.313zM166.5 203.238l82 39.176v105.69l-82-39.176zm142.625-41.169L263.5 140.271V129h45.625zm0-63.069v15H263.5V99zM248.5 99v15h-45.625V99zm144 390.5c0 4.136-3.364 7.5-7.5 7.5H127c-4.136 0-7.5-3.364-7.5-7.5s3.364-7.5 7.5-7.5h258c4.136 0 7.5 3.364 7.5 7.5M331.639 467H180.361c8.793-10.271 18.545-26.272 20.416-48h110.445c1.872 21.728 11.624 37.729 20.417 48"
}));

const SvgIfcaxProduct = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 512 512"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#8bb9ff",
  d: "M507.488 278.415a15 15 0 0 0-6.745-4.589L383.5 234.755 256 277.245v193.077l122.758 40.909a15 15 0 0 0 9.484 0l112.5-37.491A15 15 0 0 0 511 459.509V288.057c0-3.615-1.297-7.002-3.512-9.642"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#005edf",
  d: "M383.5 319.734V512c1.602 0 3.203-.256 4.742-.769l112.5-37.491A15 15 0 0 0 511 459.509V288.057c0-3.615-1.297-7.002-3.512-9.642z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4793ff",
  d: "M256 277.245v193.077l122.758 40.909c1.539.513 3.141.769 4.742.769V319.734z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffdd54",
  d: "M379.988 42.849a14.97 14.97 0 0 0-6.746-4.589L260.742.769a15 15 0 0 0-9.485 0l-112.5 37.491a14.97 14.97 0 0 0-6.746 4.589 15 15 0 0 0-3.512 9.642v182.264l127.5 42.49 127.5-42.49V52.491a14.98 14.98 0 0 0-3.511-9.642"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ff8e00",
  d: "M383.5 52.491c0-3.615-1.297-7.002-3.512-9.642L256 84.168v193.077l127.5-42.49z"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#ffb454"
}, /*#__PURE__*/React.createElement("path", {
  d: "M256 84.168 132.012 42.849a15 15 0 0 0-3.512 9.642v182.264l127.5 42.49zM379.988 42.849a14.97 14.97 0 0 0-6.746-4.589L260.742.769A15 15 0 0 0 256 0v84.168z"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#ff6b6b",
  d: "M128.5 234.755 11.257 273.827a14.96 14.96 0 0 0-6.745 4.589A14.98 14.98 0 0 0 1 288.057v171.452a15 15 0 0 0 10.258 14.231l112.5 37.491a15 15 0 0 0 9.484 0L256 470.321V277.245z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f90024",
  d: "M4.512 278.415A15 15 0 0 0 1 288.057v171.452a15 15 0 0 0 10.258 14.231l112.5 37.491c1.539.513 3.141.769 4.742.769V319.734z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#a50017",
  d: "M128.5 319.734V512c1.602 0 3.203-.256 4.742-.769L256 470.321V277.245z"
}));

const SvgIfcaxProject = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 39.698 35.793"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 66527"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#f9cf58",
  d: "m3.843 34.627 2.852.7 2.851-.7v-1.4l-2.851-.7-2.852.7Z",
  "data-name": "Path 82220"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffac3e",
  d: "m12.612 34.627 2.852.7 2.852-.7v-1.4l-2.852-.7-2.852.7Z",
  "data-name": "Path 82221"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#82d361",
  d: "m21.382 34.627 2.852.7 2.852-.7v-1.4l-2.852-.7-2.852.7Z",
  "data-name": "Path 82222"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#6cc4ff",
  d: "m30.151 34.627 2.852.7 2.852-.7v-1.4l-2.852-.7-2.852.7Z",
  "data-name": "Path 82223"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffe27a",
  d: "M9.546 33.229h-5.7v-5.642a.777.777 0 0 1 .777-.777h4.149a.777.777 0 0 1 .777.777v5.642Z",
  "data-name": "Path 82224"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffba57",
  d: "M18.315 33.229h-5.7v-9.882a.777.777 0 0 1 .777-.777h4.15a.777.777 0 0 1 .777.777Z",
  "data-name": "Path 82225"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#98db7c",
  d: "M27.085 33.228h-5.7V19.106a.777.777 0 0 1 .777-.777h4.146a.777.777 0 0 1 .777.777z",
  "data-name": "Path 82226"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#8bcaff",
  d: "M35.854 33.229h-5.7V14.866a.777.777 0 0 1 .777-.777h4.143a.777.777 0 0 1 .777.777v18.363Z",
  "data-name": "Path 82227"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ff4755",
  d: "M32.716 7.167 32.032.35a.388.388 0 0 0-.484-.337l-6.635 1.728a.388.388 0 0 0-.124.695l1.733 1.205S22.076 12.31 6.015 17.267v.433c4.407.024 15.927-1.236 23.152-10.945l1.207-.436 1.734 1.206a.388.388 0 0 0 .608-.358",
  "data-name": "Path 82228"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 66526"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 66525"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 66524"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fc2b3a",
  d: "M29.678 5.827a.39.39 0 0 0-.537.087c-7.229 9.713-16.494 10.932-22.863 11.375a.8.8 0 0 1-.258-.024h-.006a.728.728 0 0 0 .268 1.42c6.436-.448 17.059-2.746 24.091-12.368Z",
  "data-name": "Path 82229"
}))))), /*#__PURE__*/React.createElement("path", {
  fill: "#407093",
  d: "M39.115 35.793H.583a.583.583 0 0 1 0-1.165h38.532a.583.583 0 1 1 0 1.165",
  "data-name": "Path 82230"
}));

const SvgIfcaxPropertyxIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  id: "ifcax-propertyx-icon_svg__Layer_2",
  viewBox: "0 0 1020 1023",
  width: "1em",
  height: "1em"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "ifcax-propertyx-icon_svg__drop-shadow-1",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: 8.68,
  dy: 8.68
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "blur",
  stdDeviation: 6.2
}), /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#000",
  floodOpacity: 0.39
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "blur",
  operator: "in"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "SourceGraphic"
})), /*#__PURE__*/React.createElement("style", null, ".ifcax-propertyx-icon_svg__cls-3{fill:#faaf22}.ifcax-propertyx-icon_svg__cls-4{fill:#231f20}")), /*#__PURE__*/React.createElement("g", {
  id: "ifcax-propertyx-icon_svg__Layer_1-2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h1020v1023H0z",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M48.61 746.44V183.69h182.33c69.1 0 114.13 2.82 135.12 8.44 32.25 8.45 59.24 26.81 81 55.09 21.75 28.28 32.63 64.81 32.63 109.59 0 34.55-6.27 63.59-18.81 87.14q-18.81 35.325-47.79 55.47c-19.33 13.43-38.96 22.33-58.92 26.68-27.13 5.37-66.41 8.06-117.85 8.06h-74.09v212.28zm113.63-467.55v159.69h62.19c44.78 0 74.72-2.94 89.83-8.83 15.1-5.88 26.93-15.1 35.51-27.64 8.57-12.53 12.86-27.12 12.86-43.76 0-20.47-6.02-37.36-18.04-50.67-12.03-13.3-27.26-21.62-45.68-24.95-13.57-2.56-40.82-3.84-81.77-3.84h-54.89Z",
  style: {
    filter: "url(#ifcax-propertyx-icon_svg__drop-shadow-1)"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "m248.5 443.17 144.27-.65 110.98 81.25-82.94 49.26zM520.47 647.89l70.37-56.5 207.85 156.46-145.96-.35z",
  className: "ifcax-propertyx-icon_svg__cls-3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M235.43 747.86S472.05 489.92 954.13 368c0 0-344.86 123.83-558 379.86z",
  className: "ifcax-propertyx-icon_svg__cls-3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M223.81 748.27h-22.16v-83.74h20.58v11.91c3.52-5.62 6.69-9.33 9.5-11.12s6-2.68 9.58-2.68c5.05 0 9.91 1.39 14.59 4.18l-6.86 19.32q-5.595-3.63-10.41-3.63c-4.815 0-5.73.86-7.88 2.56-2.16 1.71-3.85 4.8-5.09 9.26-1.24 4.47-1.85 13.83-1.85 28.07v25.86ZM292.61 705.22c0-7.36 1.81-14.48 5.44-21.37s8.76-12.14 15.42-15.77c6.65-3.63 14.07-5.44 22.28-5.44 12.67 0 23.05 4.11 31.15 12.34 8.09 8.23 12.14 18.62 12.14 31.19s-4.09 23.17-12.26 31.5-18.46 12.5-30.87 12.5c-7.68 0-15-1.73-21.96-5.2-6.97-3.47-12.26-8.56-15.89-15.26s-5.44-14.86-5.44-24.48Zm22.71 1.18q0 12.465 5.91 19.08c3.94 4.42 8.8 6.62 14.59 6.62s10.63-2.21 14.55-6.62c3.92-4.42 5.88-10.83 5.88-19.24s-1.96-14.51-5.88-18.92c-3.92-4.42-8.77-6.62-14.55-6.62s-10.64 2.21-14.59 6.62q-5.91 6.63-5.91 19.08M428.05 664.53h20.66v12.3c2.68-4.2 6.31-7.62 10.88-10.25s9.65-3.94 15.22-3.94c9.72 0 17.98 3.81 24.76 11.43q10.17 11.43 10.17 31.86c0 20.43-3.42 24.85-10.25 32.6s-15.11 11.63-24.84 11.63c-4.63 0-8.82-.92-12.58-2.76s-7.71-4.99-11.87-9.46v42.19h-22.16v-115.6Zm21.92 40.45c0 9.41 1.87 16.36 5.6 20.86 3.73 4.49 8.28 6.74 13.64 6.74s9.44-2.06 12.85-6.19c3.42-4.13 5.13-10.89 5.13-20.3 0-8.78-1.76-15.3-5.28-19.55-3.52-4.26-7.88-6.39-13.09-6.39s-9.91 2.09-13.48 6.27c-3.58 4.18-5.36 10.37-5.36 18.57ZM608.11 721.62l22.08 3.71c-2.84 8.1-7.32 14.26-13.44 18.49s-13.79 6.35-22.99 6.35c-14.56 0-25.34-4.76-32.33-14.27q-8.28-11.43-8.28-28.86c0-13.88 3.63-24.75 10.88-32.6 7.25-7.86 16.43-11.79 27.52-11.79 12.46 0 22.29 4.11 29.49 12.34s10.65 20.83 10.33 37.81h-55.51c.16 6.57 1.94 11.68 5.36 15.34 3.42 3.65 7.67 5.48 12.77 5.48 3.47 0 6.39-.95 8.75-2.84s4.15-4.94 5.36-9.15Zm1.26-22.39c-.16-6.41-1.81-11.29-4.97-14.63-3.15-3.34-6.99-5.01-11.51-5.01-4.84 0-8.83 1.76-11.99 5.28-3.15 3.52-4.71 8.31-4.65 14.35h33.12ZM702.94 748.27h-22.16v-83.74h20.58v11.91c3.52-5.62 6.69-9.33 9.5-11.12s6-2.68 9.58-2.68c5.05 0 9.91 1.39 14.59 4.18l-6.86 19.32q-5.595-3.63-10.41-3.63c-4.815 0-5.73.86-7.88 2.56-2.16 1.71-3.85 4.8-5.09 9.26-1.24 4.47-1.85 13.83-1.85 28.07v25.86ZM815.27 664.53v17.66h-15.14v33.75c0 6.83.14 10.82.43 11.95s.95 2.06 1.97 2.8c1.03.74 2.27 1.1 3.75 1.1q3.075 0 8.91-2.13l1.89 17.19c-5.15 2.21-10.99 3.31-17.5 3.31q-6 0-10.8-2.01c-3.21-1.34-5.56-3.08-7.06-5.2-1.5-2.13-2.54-5.01-3.11-8.63-.47-2.57-.71-7.78-.71-15.61V682.2h-10.17v-17.66h10.17V647.9l22.24-12.93v29.57h15.14ZM852.45 664.53h23.58l20.03 59.45 19.56-59.45h22.95L909 745.12l-5.28 14.59c-1.95 4.89-3.8 8.62-5.56 11.2-1.76 2.57-3.79 4.66-6.07 6.27-2.29 1.6-5.1 2.85-8.44 3.75-3.34.89-7.11 1.34-11.31 1.34s-8.44-.45-12.54-1.34l-1.97-17.35c3.47.68 6.6 1.02 9.38 1.02q7.725 0 11.43-4.53c2.47-3.02 4.36-6.87 5.68-11.55l-31.86-83.98Z",
  className: "ifcax-propertyx-icon_svg__cls-4"
})));

const SvgIfcaxPxIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  id: "ifcax-px-icon_svg__Layer_2",
  viewBox: "0 0 232.21 231.04",
  width: "1em",
  height: "1em"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "ifcax-px-icon_svg__drop-shadow-1",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: 2,
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "blur",
  stdDeviation: 5
}), /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#000",
  floodOpacity: 0.39
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "blur",
  operator: "in"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "SourceGraphic"
})), /*#__PURE__*/React.createElement("style", null, ".ifcax-px-icon_svg__cls-1{fill:#fff}.ifcax-px-icon_svg__cls-4{opacity:.27}")), /*#__PURE__*/React.createElement("g", {
  id: "ifcax-px-icon_svg__Layer_1-2"
}, /*#__PURE__*/React.createElement("rect", {
  width: 231.04,
  height: 231.04,
  x: 0.96,
  rx: 57.76,
  ry: 57.76,
  style: {
    fill: "#f9ae21"
  }
}), /*#__PURE__*/React.createElement("g", {
  className: "ifcax-px-icon_svg__cls-4"
}, /*#__PURE__*/React.createElement("path", {
  d: "m26.69 24.2 7.68-.03 5.9 4.32-4.41 2.61zM41.15 35.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-px-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26 40.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM96.69 24.2l7.68-.03 5.9 4.32-4.41 2.61zM111.15 35.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-px-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M96 40.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM169.69 24.2l7.68-.03 5.9 4.32-4.41 2.61zM184.15 35.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-px-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M169 40.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2z",
  className: "ifcax-px-icon_svg__cls-1"
})), /*#__PURE__*/React.createElement("g", {
  className: "ifcax-px-icon_svg__cls-4"
}, /*#__PURE__*/React.createElement("path", {
  d: "m26.69 109.2 7.68-.03 5.9 4.32-4.41 2.61zM41.15 120.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-px-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26 125.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM96.69 109.2l7.68-.03 5.9 4.32-4.41 2.61zM111.15 120.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-px-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M96 125.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM169.69 109.2l7.68-.03 5.9 4.32-4.41 2.61zM184.15 120.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-px-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M169 125.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2z",
  className: "ifcax-px-icon_svg__cls-1"
})), /*#__PURE__*/React.createElement("g", {
  className: "ifcax-px-icon_svg__cls-4"
}, /*#__PURE__*/React.createElement("path", {
  d: "m26.69 198.2 7.68-.03 5.9 4.32-4.41 2.61zM41.15 209.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-px-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26 214.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM96.69 198.2l7.68-.03 5.9 4.32-4.41 2.61zM111.15 209.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-px-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M96 214.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM169.69 198.2l7.68-.03 5.9 4.32-4.41 2.61zM184.15 209.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-px-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M169 214.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2z",
  className: "ifcax-px-icon_svg__cls-1"
})), /*#__PURE__*/React.createElement("g", {
  className: "ifcax-px-icon_svg__cls-4"
}, /*#__PURE__*/React.createElement("path", {
  d: "m62.69 153.2 7.68-.03 5.9 4.32-4.41 2.61zM77.15 164.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-px-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M62 169.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM.69 153.2l7.68-.03 5.9 4.32-4.41 2.61zM15.15 164.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-px-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 169.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM130.69 153.2l7.68-.03 5.9 4.32-4.41 2.61zM145.15 164.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-px-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M130 169.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM194.69 153.2l7.68-.03 5.9 4.32-4.41 2.61zM209.15 164.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-px-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M194 169.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2z",
  className: "ifcax-px-icon_svg__cls-1"
})), /*#__PURE__*/React.createElement("g", {
  className: "ifcax-px-icon_svg__cls-4"
}, /*#__PURE__*/React.createElement("path", {
  d: "m62.69 66.2 7.68-.03 5.9 4.32-4.41 2.61zM77.15 77.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-px-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M62 82.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM.69 66.2l7.68-.03 5.9 4.32-4.41 2.61zM15.15 77.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-px-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 82.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM130.69 66.2l7.68-.03 5.9 4.32-4.41 2.61zM145.15 77.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-px-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M130 82.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM194.69 66.2l7.68-.03 5.9 4.32-4.41 2.61zM209.15 77.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-px-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M194 82.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2z",
  className: "ifcax-px-icon_svg__cls-1"
})), /*#__PURE__*/React.createElement("path", {
  d: "M13.24 180.86V44.31h44.25c16.77 0 27.69.68 32.79 2.05 7.82 2.05 14.37 6.51 19.65 13.37s7.92 15.73 7.92 26.59c0 8.38-1.52 15.43-4.56 21.14s-6.91 10.2-11.6 13.46-9.45 5.42-14.3 6.47c-6.58 1.3-16.11 1.96-28.6 1.96H40.81v51.51zM40.81 67.41v38.75H55.9c10.87 0 18.13-.71 21.8-2.14 3.66-1.43 6.53-3.66 8.62-6.71q3.12-4.56 3.12-10.62c0-4.97-1.46-9.07-4.38-12.29-2.92-3.23-6.61-5.25-11.08-6.05-3.29-.62-9.91-.93-19.84-.93H40.82Z",
  style: {
    filter: "url(#ifcax-px-icon_svg__drop-shadow-1)"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "m47.75 107.28 35-.16 26.93 19.71-20.12 11.96zM113.74 156.95l17.08-13.71 50.43 37.96-35.42-.08z",
  className: "ifcax-px-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M44.58 181.21S102 118.62 218.97 89.04c0 0-83.68 30.05-135.4 92.17z",
  className: "ifcax-px-icon_svg__cls-1"
})));

const SvgIfcaxReopen = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 18.425 26.08"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 65853"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#033a5d",
  d: "M10.109 2.701H.9a.884.884 0 0 0-.9.865v21.65a.883.883 0 0 0 .9.864h16.625a.883.883 0 0 0 .9-.864V3.565a.884.884 0 0 0-.9-.865Z",
  "data-name": "Path 81489"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M16.703 24.785H1.947a.4.4 0 0 1-.4-.394V4.358a.4.4 0 0 1 .4-.394h14.756a.4.4 0 0 1 .4.394v20.033a.4.4 0 0 1-.4.394",
  "data-name": "Path 81490"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00467d",
  d: "M10.796 1.558a1.558 1.558 0 1 0-3.116 0H4.267v3.329h9.942V1.558Z",
  "data-name": "Path 81491"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M9.903 1.606a.676.676 0 1 1-.2-.478.68.68 0 0 1 .2.478",
  "data-name": "Path 81492"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#033a5d",
  d: "M14.209 3.964H4.267v.924h9.942Z",
  "data-name": "Path 81493"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M10.847 6.578H8.44v.454h2.407Z",
  "data-name": "Path 81494"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M15.195 7.706H8.481v.454h6.714Z",
  "data-name": "Path 81495"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M15.195 8.8H8.481v.454h6.714Z",
  "data-name": "Path 81496"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M15.195 9.896H8.481v.454h6.714Z",
  "data-name": "Path 81497"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M15.195 14.167H8.481v.454h6.714Z",
  "data-name": "Path 81498"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M15.195 15.263H8.481v.454h6.714Z",
  "data-name": "Path 81499"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M15.195 16.359H8.481v.454h6.714Z",
  "data-name": "Path 81500"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M15.195 20.613H8.481v.454h6.714Z",
  "data-name": "Path 81501"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M15.195 21.623H8.481v.454h6.714Z",
  "data-name": "Path 81502"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M15.195 22.743H8.481v.454h6.714Z",
  "data-name": "Path 81503"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M10.847 13.033H8.44v.454h2.407Z",
  "data-name": "Path 81504"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M10.847 19.488H8.44v.454h2.407Z",
  "data-name": "Path 81505"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffed4d",
  fillRule: "evenodd",
  d: "M7.362 7.906a1.9 1.9 0 1 1-1.9-1.9 1.9 1.9 0 0 1 1.9 1.9",
  "data-name": "Path 81506"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M6.201 8.36a.882.882 0 0 1-1.589-.129.119.119 0 0 1 .222-.084.644.644 0 1 0 .175-.711l.168-.027a.119.119 0 0 1 .037.235l-.44.07h-.019a.12.12 0 0 1-.119-.117l-.008-.468a.119.119 0 0 1 .237 0v.117a.882.882 0 0 1 1.333 1.116Z",
  "data-name": "Path 81507"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ff9500",
  fillRule: "evenodd",
  d: "M7.362 20.906a1.9 1.9 0 1 1-1.9-1.9 1.9 1.9 0 0 1 1.9 1.9",
  "data-name": "Path 81508"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M6.201 21.36a.882.882 0 0 1-1.589-.129.119.119 0 0 1 .222-.084.644.644 0 1 0 .175-.711l.168-.027a.119.119 0 0 1 .037.235l-.44.07h-.019a.12.12 0 0 1-.119-.117l-.008-.468a.119.119 0 0 1 .237 0v.117a.882.882 0 0 1 1.333 1.116Z",
  "data-name": "Path 81509"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M5.152 18.706a3.843 3.843 0 1 1 2.733-1.083 3.84 3.84 0 0 1-2.733 1.083",
  "data-name": "Path 81510"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f24134",
  fillRule: "evenodd",
  d: "M8.062 15.006a3 3 0 1 1-3-3 3 3 0 0 1 3 3",
  "data-name": "Path 81511"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M6.229 15.723a1.393 1.393 0 0 1-2.509-.2.188.188 0 1 1 .351-.132 1.017 1.017 0 1 0 .276-1.123l.266-.042a.188.188 0 0 1 .059.37l-.695.111h-.03a.187.187 0 0 1-.187-.184l-.013-.738a.188.188 0 0 1 .375-.007v.185a1.393 1.393 0 0 1 2.1 1.762Z",
  "data-name": "Path 81512"
})));

const SvgIfcaxSaasRenewal = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 30 30"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 66352"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h30v30H0z",
  "data-name": "Rectangle 27534"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 66351"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#4d4d80",
  "data-name": "Group 66345"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.492 14.731A11.287 11.287 0 0 1 14.731 3.492 11.55 11.55 0 0 1 21.2 5.573a.734.734 0 0 0-.849.483.745.745 0 0 0 .474.944l3.165 1.054a.746.746 0 0 0 .943-.943l-1.055-3.166a.746.746 0 1 0-1.415.472l.1.289A13.07 13.07 0 0 0 14.731 2 12.78 12.78 0 0 0 2 14.731a12.7 12.7 0 0 0 .972 4.756.746.746 0 0 0 1.383-.559 11.2 11.2 0 0 1-.863-4.2Z",
  "data-name": "Path 82068"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.491 9.976a.746.746 0 0 0-1.383.559 11.137 11.137 0 0 1-10.377 15.436 11.55 11.55 0 0 1-6.472-2.081.736.736 0 0 0 .85-.483.745.745 0 0 0-.471-.943l-3.165-1.055a.746.746 0 0 0-.943.943l1.054 3.17a.746.746 0 0 0 1.415-.472l-.1-.289a13.07 13.07 0 0 0 7.829 2.707A12.628 12.628 0 0 0 26.491 9.976",
  "data-name": "Path 82069"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#443d66",
  d: "M20.354 6.056a.745.745 0 0 0 .471.943l3.165 1.055a.746.746 0 0 0 .943-.943l-1.055-3.165a.746.746 0 1 0-1.415.472l.1.289A13.07 13.07 0 0 0 14.731 2v1.492a11.55 11.55 0 0 1 6.472 2.081.734.734 0 0 0-.849.483",
  "data-name": "Path 82070"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#443d66",
  d: "M27.462 14.731a12.7 12.7 0 0 0-.972-4.756.746.746 0 0 0-1.383.559 11.137 11.137 0 0 1-10.376 15.437v1.492a12.78 12.78 0 0 0 12.731-12.732",
  "data-name": "Path 82071"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "calendar (2)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fd646f",
  d: "M21.313 9.382v2.293H8V9.382a.894.894 0 0 1 .893-.893H20.42a.894.894 0 0 1 .893.893",
  "data-name": "Path 82082"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fc4755",
  d: "M11.574 8.489v1.668a.3.3 0 0 1-.3.3H9.908a.3.3 0 0 1-.3-.3V8.489Z",
  "data-name": "Path 82083"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fc4755",
  d: "M19.228 8.489v1.668a.3.3 0 0 1-.3.3h-1.366a.3.3 0 0 1-.3-.3V8.489Z",
  "data-name": "Path 82084"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fc4755",
  d: "M8.477 8.592v3.083H8V9.382a.89.89 0 0 1 .477-.79",
  "data-name": "Path 82085"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#e6e6e6",
  "data-name": "Group 66350"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.442 13.458h1.532a.15.15 0 0 1 .149.149v1.531a.15.15 0 0 1-.149.149h-1.532a.15.15 0 0 1-.149-.149v-1.532a.15.15 0 0 1 .149-.148",
  "data-name": "Path 82086"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.442 15.735h1.532a.15.15 0 0 1 .149.149v1.533a.15.15 0 0 1-.149.149h-1.532a.15.15 0 0 1-.149-.149v-1.533a.15.15 0 0 1 .149-.149",
  "data-name": "Path 82087"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.442 18.012h1.532a.15.15 0 0 1 .149.149v1.532a.15.15 0 0 1-.149.149h-1.532a.15.15 0 0 1-.149-.149v-1.532a.15.15 0 0 1 .149-.149",
  "data-name": "Path 82088"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.72 13.458h1.565a.15.15 0 0 1 .149.149v1.531a.15.15 0 0 1-.149.149H12.72a.15.15 0 0 1-.149-.149v-1.532a.15.15 0 0 1 .149-.148",
  "data-name": "Path 82089"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.72 15.735h1.565a.15.15 0 0 1 .149.149v1.533a.15.15 0 0 1-.149.149H12.72a.15.15 0 0 1-.149-.149v-1.533a.15.15 0 0 1 .149-.149",
  "data-name": "Path 82090"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.72 18.012h1.565a.15.15 0 0 1 .149.149v1.532a.15.15 0 0 1-.149.149H12.72a.15.15 0 0 1-.149-.149v-1.532a.15.15 0 0 1 .149-.149",
  "data-name": "Path 82091"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.029 13.458h1.565a.15.15 0 0 1 .149.149v1.531a.15.15 0 0 1-.149.149h-1.565a.15.15 0 0 1-.149-.149v-1.532a.15.15 0 0 1 .149-.148",
  "data-name": "Path 82092"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.029 15.735h1.565a.15.15 0 0 1 .149.149v1.533a.15.15 0 0 1-.149.149h-1.565a.15.15 0 0 1-.149-.149v-1.533a.15.15 0 0 1 .149-.149",
  "data-name": "Path 82093"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.029 18.012h1.565a.15.15 0 0 1 .149.149v1.532a.15.15 0 0 1-.149.149h-1.565a.15.15 0 0 1-.149-.149v-1.532a.15.15 0 0 1 .149-.149",
  "data-name": "Path 82094"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.019 13.607v1.531a.15.15 0 0 1-.149.149h-1.531a.15.15 0 0 1-.149-.149v-1.532a.15.15 0 0 1 .149-.149h1.532a.15.15 0 0 1 .149.149Z",
  "data-name": "Path 82095"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.339 15.735h1.532a.15.15 0 0 1 .149.149v1.533a.15.15 0 0 1-.149.149h-1.532a.15.15 0 0 1-.149-.149v-1.533a.15.15 0 0 1 .149-.149",
  "data-name": "Path 82096"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.339 18.012h1.532a.15.15 0 0 1 .149.149v1.532a.15.15 0 0 1-.149.149h-1.532a.15.15 0 0 1-.149-.149v-1.532a.15.15 0 0 1 .149-.149",
  "data-name": "Path 82097"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#f5f5f5",
  d: "M8 11.467v9.441a.893.893 0 0 0 .893.893H20.42a.893.893 0 0 0 .893-.893v-9.441Z",
  "data-name": "Path 82098"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#50758d",
  d: "M11.574 7.3v2.38a.3.3 0 0 1-.3.3h-.889a.3.3 0 0 1-.3-.3V7.3a.3.3 0 0 1 .3-.3h.893a.3.3 0 0 1 .296.3",
  "data-name": "Path 82099"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffac5c",
  d: "M10.293 13.458h1.83v1.83h-1.83Z",
  "data-name": "Path 82100"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffac5c",
  d: "M17.19 13.458h1.83v1.83h-1.83Z",
  "data-name": "Path 82101"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffac5c",
  d: "M12.57 13.458h1.863v1.83H12.57Z",
  "data-name": "Path 82102"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffac5c",
  d: "M10.293 15.734h1.83v1.83h-1.83Z",
  "data-name": "Path 82103"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e6e6e6",
  d: "M17.19 15.734h1.83v1.83h-1.83Z",
  "data-name": "Path 82104"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffac5c",
  d: "M12.57 15.734h1.863v1.83H12.57Z",
  "data-name": "Path 82105"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e6e6e6",
  d: "M10.293 18.012h1.83v1.83h-1.83Z",
  "data-name": "Path 82106"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e6e6e6",
  d: "M17.19 18.012h1.83v1.83h-1.83Z",
  "data-name": "Path 82107"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e6e6e6",
  d: "M12.57 18.012h1.863v1.83H12.57Z",
  "data-name": "Path 82108"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffac5c",
  d: "M14.88 13.458h1.863v1.83H14.88Z",
  "data-name": "Path 82109"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffac5c",
  d: "M14.88 15.734h1.863v1.83H14.88Z",
  "data-name": "Path 82110"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e6e6e6",
  d: "M14.88 18.012h1.863v1.83H14.88Z",
  "data-name": "Path 82111"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#50758d",
  d: "M19.228 7.3v2.38a.3.3 0 0 1-.3.3h-.889a.3.3 0 0 1-.3-.3V7.3a.3.3 0 0 1 .3-.3h.894a.3.3 0 0 1 .295.3",
  "data-name": "Path 82112"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e6e6e6",
  d: "M8 11.467v9.441a.893.893 0 0 0 .893.893h.33a.89.89 0 0 1-.732-.879v-8.824a.24.24 0 0 1 .223-.155h12.6v-.476Z",
  "data-name": "Path 82113"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2b597f",
  d: "M10.859 9.978h-.474a.3.3 0 0 1-.3-.3V7.3a.3.3 0 0 1 .3-.3h.179v2.68a.3.3 0 0 0 .295.298",
  "data-name": "Path 82114"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2b597f",
  d: "M18.513 9.978h-.474a.3.3 0 0 1-.3-.3V7.3a.3.3 0 0 1 .3-.3h.179v2.68a.3.3 0 0 0 .295.298",
  "data-name": "Path 82115"
})))));

const SvgIfcaxSalesVideo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 30 30"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 66565"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#ffb454",
  d: "M12.014 6.3a.4.4 0 0 1-.307-.143L10.9 5.2a.6.6 0 0 0-.446-.2H5.4a.4.4 0 0 0-.4.4v18.9a1.2 1.2 0 0 0 1.2 1.2h.787l9.463-1.7 1.283-10.242L16.452 6.3Z",
  "data-name": "Path 81631"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ff7d47",
  d: "M22.698 6.301h-6.246v17.5l5.446 1.7a1.2 1.2 0 0 0 1.2-1.2v-17.6a.4.4 0 0 0-.4-.4",
  "data-name": "Path 81632"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f7f9fa",
  d: "m16.452 8.724.4 2.042-.4 1.52H8.864V9.124a.4.4 0 0 1 .4-.4Z",
  "data-name": "Path 81633"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#d7e8ff",
  d: "M23.639 8.724h-7.187v3.562h7.588V9.124a.4.4 0 0 0-.401-.4",
  "data-name": "Path 81634"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffe278",
  d: "m16.452 11.139.681 2.419-.681 11.944H6.201a1.2 1.2 0 0 0 1.2-1.2V11.539a.4.4 0 0 1 .4-.4Z",
  "data-name": "Path 81635"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffb454",
  d: "M25.101 11.139h-8.649v14.362h8.649a.4.4 0 0 0 .4-.4V11.539a.4.4 0 0 0-.4-.4",
  "data-name": "Path 81636"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e33a53",
  d: "m16.452 13.59.681 4.4-.681 5.063h-4.628a.87.87 0 0 1-.869-.869V14.46a.87.87 0 0 1 .869-.87Z",
  "data-name": "Path 81637"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#b8163d",
  d: "M21.952 14.46v7.721a.87.87 0 0 1-.869.869h-4.631v-9.46h4.628a.87.87 0 0 1 .872.87",
  "data-name": "Path 81638"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f7f9fa",
  d: "m16.452 16.494.4 1.573-.4 2.079-.558.322a1.041 1.041 0 0 1-1.562-.9v-2.492a1.041 1.041 0 0 1 1.562-.9Z",
  "data-name": "Path 81639"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#d7e8ff",
  d: "M18.573 18.32a1.03 1.03 0 0 1-.521.9l-1.6.924v-3.65l1.6.924a1.03 1.03 0 0 1 .521.902",
  "data-name": "Path 81640"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h30v30H0z",
  "data-name": "Rectangle 27533"
})));

const SvgIfcaxSales = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 35.339 34.172"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 66490"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 66483"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 66475"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 66474"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 66473"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 66472"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#27d1b3",
  d: "M34.649 31.93H24.437a.69.69 0 0 1-.69-.69v-3.921a4.025 4.025 0 0 1 4.025-4.025h3.542a4.025 4.025 0 0 1 4.025 4.025v3.921a.69.69 0 0 1-.69.69",
  "data-name": "Path 82160"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 66469"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 66468"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fb4a59",
  d: "m31.207 28.697-1.384 1.217a.424.424 0 0 1-.56 0l-1.384-1.217a.43.43 0 0 1-.131-.424l1.275-4.976h1.041l1.275 4.976a.42.42 0 0 1-.132.424",
  "data-name": "Path 82161"
}))), /*#__PURE__*/React.createElement("path", {
  fill: "#20b69f",
  d: "M35.339 27.321v3.921a.69.69 0 0 1-.69.69h-1.4v-4.611a4.026 4.026 0 0 0-4.025-4.025h2.1a4.025 4.025 0 0 1 4.015 4.025",
  "data-name": "Path 82162"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 66471"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 66470"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#ffcec0",
  d: "M29.543 23.646a3.28 3.28 0 0 1-3.282-3.282v-1.185a3.282 3.282 0 0 1 6.563 0v1.185a3.28 3.28 0 0 1-3.281 3.282",
  "data-name": "Path 82163"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fdb0a0",
  d: "M32.824 19.185v1.184a3.284 3.284 0 0 1-4.32 3.114 3.28 3.28 0 0 0 2.242-3.114v-1.184a3.285 3.285 0 0 0-2.242-3.114 3.282 3.282 0 0 1 4.32 3.114",
  "data-name": "Path 82164"
}))))))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 66482"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 66481"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 66480"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fb4a59",
  d: "M10.9 31.93H.69a.69.69 0 0 1-.69-.69v-3.921a4.025 4.025 0 0 1 4.025-4.025h3.542a4.025 4.025 0 0 1 4.025 4.025v3.921a.69.69 0 0 1-.69.69Z",
  "data-name": "Path 82165"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 66477"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 66476"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#f8f3f1",
  d: "m7.46 28.697-1.384 1.217a.424.424 0 0 1-.56 0l-1.384-1.217a.43.43 0 0 1-.131-.424l1.275-4.976h1.041l1.275 4.976a.42.42 0 0 1-.132.424",
  "data-name": "Path 82166"
}))), /*#__PURE__*/React.createElement("path", {
  fill: "#f82f40",
  d: "M11.595 27.321v3.921a.69.69 0 0 1-.69.69h-1.41v-4.611a4.026 4.026 0 0 0-4.025-4.025h2.1a4.025 4.025 0 0 1 4.025 4.025",
  "data-name": "Path 82167"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 66479"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 66478"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#ffcec0",
  d: "M5.796 23.646a3.28 3.28 0 0 1-3.282-3.282v-1.185a3.282 3.282 0 0 1 6.563 0v1.185a3.28 3.28 0 0 1-3.281 3.282",
  "data-name": "Path 82168"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fdb0a0",
  d: "M9.077 19.185v1.184a3.284 3.284 0 0 1-4.32 3.114 3.28 3.28 0 0 0 2.242-3.114v-1.184a3.285 3.285 0 0 0-2.242-3.114 3.282 3.282 0 0 1 4.32 3.114",
  "data-name": "Path 82169"
}))))))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 66489"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#0d5f7f",
  d: "M25.124 34.172H10.215a.69.69 0 0 1-.691-.689v-6.4a5.656 5.656 0 0 1 5.656-5.656h4.976a5.656 5.656 0 0 1 5.656 5.656v6.4a.69.69 0 0 1-.688.689",
  "data-name": "Path 82170"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#094c66",
  d: "M25.817 27.087v6.395a.69.69 0 0 1-.69.69h-2.254v-7.085a5.657 5.657 0 0 0-5.656-5.656h2.944a5.656 5.656 0 0 1 5.656 5.656",
  "data-name": "Path 82171"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m22.013 21.743-4.343 8.272-4.343-8.272a5.7 5.7 0 0 1 1.856-.311h4.971a5.7 5.7 0 0 1 1.859.311",
  "data-name": "Path 82172"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fb4a59",
  d: "m19.886 25.793-2.218 4.223-2.217-4.223 1.6-4.361h1.24Z",
  "data-name": "Path 82173"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 66487"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 66484",
  transform: "translate(10.476 14.26)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 1.747,
  cy: 1.747,
  r: 1.747,
  fill: "#fdb0a0",
  "data-name": "Ellipse 2040"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 66485",
  transform: "translate(21.37 14.26)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 1.747,
  cy: 1.747,
  r: 1.747,
  fill: "#f69583",
  "data-name": "Ellipse 2041"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 66486"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#ffcec0",
  d: "M17.668 21.93a4.61 4.61 0 0 1-4.611-4.611v-1.665a4.611 4.611 0 1 1 9.222 0v1.665a4.61 4.61 0 0 1-4.611 4.611",
  "data-name": "Path 82174"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fdb0a0",
  d: "M22.282 15.654v1.664a4.613 4.613 0 0 1-5.719 4.477 4.61 4.61 0 0 0 3.5-4.477v-1.664a4.614 4.614 0 0 0-3.5-4.477 4.61 4.61 0 0 1 5.719 4.477",
  "data-name": "Path 82175"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#7a7179",
  d: "M23.79 14.41a12.9 12.9 0 0 1-4.344-.239 2.586 2.586 0 0 1-1.892-2.5v-1.76a1.616 1.616 0 0 1 1.616-1.616h1.215a4 4 0 0 1 4 4v1.465a.657.657 0 0 1-.595.65",
  "data-name": "Path 82176"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#685e67",
  d: "M24.382 12.292v1.465a.656.656 0 0 1-.593.653 15 15 0 0 1-2.832.024l.26-.024a.656.656 0 0 0 .592-.653v-1.465a4 4 0 0 0-3.163-3.91 1.6 1.6 0 0 1 .523-.088h1.215a4 4 0 0 1 3.998 3.998",
  "data-name": "Path 82177"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#9b8f99",
  d: "M11.543 14.589a15.4 15.4 0 0 0 5.232-.27 3.05 3.05 0 0 0 2.23-2.949V9.295a1.9 1.9 0 0 0-1.9-1.9h-1.436a4.71 4.71 0 0 0-4.712 4.712v1.833a.656.656 0 0 0 .586.649",
  "data-name": "Path 82178"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#8b8088",
  d: "M19.006 9.295v2.075a3.05 3.05 0 0 1-2.23 2.949 14.5 14.5 0 0 1-4.582.328 11 11 0 0 0 1.989-.328 3.05 3.05 0 0 0 2.231-2.949V9.295a1.905 1.905 0 0 0-1.457-1.851 5 5 0 0 1 .711-.053h1.433a1.9 1.9 0 0 1 1.905 1.904",
  "data-name": "Path 82179"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 66488"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#094c66",
  d: "M17.136 34.168v-4.153a.534.534 0 1 1 1.067 0v4.153Z",
  "data-name": "Path 82180"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M19.676 31.609h-.014a.534.534 0 0 1 0-1.067h.014a.534.534 0 0 1 0 1.067",
  "data-name": "Path 82181"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 66493"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 66491",
  transform: "translate(2.921)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 6.502,
  cy: 6.502,
  r: 6.502,
  fill: "#27d1b3",
  "data-name": "Ellipse 2042"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#20b69f",
  d: "M13.005 6.502a6.507 6.507 0 0 1-8.227 6.271 6.271 6.271 0 0 0 0-12.541 6.508 6.508 0 0 1 8.229 6.27Z",
  "data-name": "Path 82182"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 66492"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#bcea73",
  d: "M7.685 9.684 5.352 7.351a.335.335 0 0 1 0-.473l.964-.964a.335.335 0 0 1 .473 0l1.37 1.37 3.9-3.9a.335.335 0 0 1 .473 0l.964.964a.335.335 0 0 1 0 .473L8.632 9.685a.67.67 0 0 1-.947-.001",
  "data-name": "Path 82183"
}))));

const SvgIfcaxSitexIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  id: "ifcax-sitex-icon_svg__Layer_2",
  viewBox: "0 0 1020 1023",
  width: "1em",
  height: "1em"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "ifcax-sitex-icon_svg__drop-shadow-1",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: 8.68,
  dy: 8.68
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "blur",
  stdDeviation: 6.2
}), /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#000",
  floodOpacity: 0.39
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "blur",
  operator: "in"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "SourceGraphic"
})), /*#__PURE__*/React.createElement("style", null, ".ifcax-sitex-icon_svg__cls-3{fill:#faaf22}.ifcax-sitex-icon_svg__cls-4{fill:#231f20}")), /*#__PURE__*/React.createElement("g", {
  id: "ifcax-sitex-icon_svg__Layer_1-2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h1020v1023H0z",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "m49.24 546.81 104.66-10.18q9.45 52.695 38.34 77.4c19.26 16.48 45.24 24.71 77.95 24.71 34.64 0 60.75-7.32 78.31-21.99 17.56-14.66 26.35-31.8 26.35-51.42 0-12.59-3.7-23.31-11.08-32.16-7.39-8.84-20.29-16.54-38.7-23.08-12.6-4.36-41.31-12.11-86.13-23.26-57.66-14.29-98.12-31.85-121.38-52.69-32.71-29.31-49.06-65.05-49.06-107.2 0-27.13 7.69-52.51 23.08-76.13 15.38-23.62 37.55-41.61 66.5-53.97s63.9-18.53 104.84-18.53c66.87 0 117.2 14.66 150.99 43.97 33.8 29.32 51.54 68.44 53.24 117.38l-107.57 4.72c-4.6-27.37-14.48-47.06-29.62-59.05s-37.86-17.99-68.14-17.99-55.73 6.42-73.41 19.26c-11.39 8.24-17.08 19.26-17.08 33.07q0 18.9 15.99 32.34 20.355 17.085 98.85 35.61c52.33 12.36 91.03 25.14 116.11 38.34 25.07 13.21 44.7 31.25 58.87 54.15 14.17 22.89 21.26 51.18 21.26 84.85 0 30.53-8.48 59.12-25.44 85.76-16.96 26.65-40.95 46.46-71.95 59.42-31.01 12.96-69.65 19.44-115.93 19.44-67.35 0-119.08-15.56-155.17-46.7-36.1-31.13-57.66-76.5-64.69-136.09Z",
  className: "ifcax-sitex-icon_svg__cls-4",
  style: {
    filter: "url(#ifcax-sitex-icon_svg__drop-shadow-1)"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "m328.28 435.09 134.83-.61 103.72 75.94-77.52 46.03zM582.45 626.41l65.77-52.8 194.25 146.22-136.41-.33z",
  className: "ifcax-sitex-icon_svg__cls-3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M316.07 719.84s221.14-241.06 671.67-355.01c0 0-322.3 115.73-521.49 355.01z",
  className: "ifcax-sitex-icon_svg__cls-3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M543.15 560.69v-33.74h36.46v33.74zm0 156.49V579.37h36.46v137.81zM733.33 579.37v29.07h-24.91v55.54c0 11.25.24 17.8.71 19.66s1.56 3.4 3.24 4.61c1.69 1.21 3.74 1.82 6.16 1.82 3.37 0 8.26-1.17 14.66-3.5l3.11 28.29c-8.48 3.63-18.08 5.45-28.81 5.45-6.58 0-12.5-1.1-17.78-3.31s-9.15-5.06-11.61-8.56c-2.47-3.5-4.17-8.24-5.13-14.21-.78-4.24-1.17-12.8-1.17-25.69v-60.08h-16.74v-29.07h16.74v-27.38l36.59-21.28v48.66h24.91ZM891.59 673.32l36.33 6.1c-4.67 13.32-12.05 23.47-22.12 30.43-10.08 6.96-22.69 10.45-37.83 10.45-23.96 0-41.7-7.83-53.2-23.49q-13.62-18.81-13.62-47.49c0-22.84 5.97-40.72 17.91-53.66 11.94-12.93 27.03-19.4 45.29-19.4 20.5 0 36.68 6.77 48.53 20.31s17.52 34.28 17 62.22h-91.35c.26 10.81 3.2 19.23 8.82 25.24s12.63 9.02 21.02 9.02c5.71 0 10.51-1.56 14.4-4.67s6.83-8.13 8.82-15.05Zm2.08-36.85c-.26-10.55-2.98-18.58-8.18-24.07-5.19-5.49-11.51-8.24-18.95-8.24-7.96 0-14.53 2.9-19.72 8.69-5.19 5.8-7.74 13.67-7.66 23.62h54.5Z",
  className: "ifcax-sitex-icon_svg__cls-4"
})));

const SvgIfcaxSoftwareDev = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 400 400"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M78 119c-2 2-2 3.3-2 68.5V254l88.3.2 88.2.3-.4 22.7c-.3 24.6.2 28.3 4.6 31.8 2.4 1.9 4 2 28.5 2 28.1 0 30.3-.4 32.6-5.5.9-1.9 1.2-17.5 1.2-59.6 0-61 0-61.2-4.9-63.9-1.1-.5-6-1-11-1H294v-30.4c0-30.4 0-30.5-2.2-32-2-1.4-13.8-1.6-107-1.6C81.3 117 80 117 78 119m206 34v27h-11.5c-12.4 0-16 1-18.9 5.2-1.4 1.9-1.6 6.6-1.6 31V245l-81.7-.2-81.8-.3 81.3-.2 81.2-.3v-28.4c0-27.2.1-28.4 2.1-31 3.7-4.7 6.8-5.6 18.9-5.6h11v-25.6c0-14.1-.4-25.4-.8-25.2-.5.1-22.5 13.2-48.9 29-44.5 26.7-48.3 28.8-52.6 28.8-4.5 0-4.7.1-4.7 2.9 0 2.5-.9 3.4-8 7.5-4.4 2.5-8 5.1-8 5.6 0 .6-2.7 1-5.9 1-5.3 0-5.9.2-5.4 1.9.2 1-.3 2.5-1.2 3.5-1.5 1.5-1.4 1.6 1.4 1.6 2.9 0 3.1.2 3.1 4v4h8.1l-.3 4.7-.3 4.8-5.7.3-5.8.3V219h-11.9l-.3 4.2-.3 4.3-10.3.3-10.2.3-14.1 8.4c-7.7 4.7-14.2 8.5-14.5 8.5-.2 0-.4-26.8-.4-59.5V126h198zm-98.3 39.2c-.2 1.3-.4.5-.4-1.7-.1-2.2.1-3.2.4-2.3.2 1 .2 2.8 0 4m109.1-3c-.3.9-3.1 1.4-8.3 1.6-8.3.3-11-.2-10-1.8 1-1.5 18.8-1.3 18.3.2m-112.5 6.5c-1.3.2-3.3.2-4.5 0-1.3-.2-.3-.4 2.2-.4s3.5.2 2.3.4M314 242.5V285h-57v-41.8c0-23 .3-42.2.7-42.5.3-.4 13.2-.7 28.5-.7H314zm-142.7-40.8c-1.3.2-3.3.2-4.5 0-1.3-.2-.3-.4 2.2-.4s3.5.2 2.3.4m-7.6 6.5c-.2 1.3-.4.5-.4-1.7-.1-2.2.1-3.2.4-2.3.2 1 .2 2.8 0 4m16 8c-.2 1.3-.4.5-.4-1.7-.1-2.2.1-3.2.4-2.3.2 1 .2 2.8 0 4m11 1c-.2 1.3-.4.3-.4-2.2s.2-3.5.4-2.3c.2 1.3.2 3.3 0 4.5m99.9 77.3c1.9 2.9 1.1 6-2 8.1-5 3.2-10.4-2.4-7.7-8.2 1.5-3.4 7.4-3.4 9.7.1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M148.8 148.9c-.3 3.7-.1 4 2.6 4.5 5.3 1.1 5.6.9 5.6-3.9V145h-3.9c-3.8 0-3.9.1-4.3 3.9M177 149.5v4.5h8v-9h-8zM108.5 153l-6.9 7H117v-7c0-3.9-.3-7-.8-7-.4 0-3.9 3.1-7.7 7M164.4 154.4c-.3.8-.4 2.7-.2 4.3.3 2.5.7 2.8 4.6 3.1l4.2.3V153h-4c-2.6 0-4.3.5-4.6 1.4M196 165.4v4.6h9.1l-.3-4.3c-.3-4.2-.3-4.2-4.5-4.5l-4.3-.3zM184 174v4h9v-8h-9zM166 181.9v4.1h9.1l-.3-3.8c-.3-3.6-.4-3.7-4.5-4l-4.3-.3zM156 189.9c0 3.6.2 3.9 3.5 4.5 4.7.9 5.5.2 5.5-4.5V186h-9zM283.7 294.1c-2.4 1.4-2.2 5.6.4 7 1.8.9 2.5.7 4.2-.9 1.1-1.1 1.7-2.7 1.4-3.6-.9-2.3-4-3.6-6-2.5"
}));

const SvgIfcaxSoftware = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 512 512"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#0052c2",
  d: "M512 46c0-24.853-20.147-45-45-45H45C20.147 1 0 21.147 0 46v90l10 10h492l10-10z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#003481",
  d: "M512 46v90l-10 10H256V1h211c24.85 0 45 20.15 45 45"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0052c2",
  d: "M436 61h-90c-8.284 0-15 6.716-15 15s6.716 15 15 15h90c8.284 0 15-6.716 15-15s-6.716-15-15-15"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 196,
  cy: 76,
  r: 15,
  fill: "#f03800"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 136,
  cy: 76,
  r: 15,
  fill: "#fdbf00"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 76,
  cy: 76,
  r: 15,
  fill: "#37d742"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e0f4ff",
  d: "M0 136v330c0 24.813 20.187 45 45 45h422c24.813 0 45-20.187 45-45V136z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#b8e0f5",
  d: "M512 136v330c0 24.81-20.19 45-45 45H256V136z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ff641a",
  d: "M306.909 197.213c-7.614-3.263-16.433.264-19.696 7.878l-90 210c-3.264 7.614.264 16.433 7.878 19.696 7.617 3.264 16.434-.266 19.696-7.878l90-210c3.264-7.615-.264-16.433-7.878-19.696"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f03800",
  d: "M314.79 216.91 256 354.09v-76.18l31.21-72.82c3.27-7.61 12.08-11.14 19.7-7.88 7.61 3.27 11.14 12.08 7.88 19.7"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ff641a",
  d: "M175.37 364.287 115.012 316l60.358-48.287c6.47-5.175 7.518-14.614 2.343-21.083-5.176-6.469-14.617-7.517-21.083-2.342l-75 60c-7.499 5.997-7.504 17.424 0 23.426l75 60c6.469 5.176 15.91 4.126 21.083-2.342 5.175-6.471 4.127-15.91-2.343-21.085"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f03800",
  d: "m430.37 304.287-75-60c-6.469-5.176-15.909-4.127-21.083 2.342-5.175 6.469-4.127 15.909 2.343 21.083L396.988 316l-60.358 48.287c-6.47 5.175-7.518 14.614-2.343 21.083 5.182 6.476 14.623 7.512 21.083 2.342l75-60c7.499-5.997 7.504-17.423 0-23.425"
}));

const SvgIfcaxSort = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 512 512"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M119.5 52.5c-2.2.8-4.2 1.5-4.5 1.5-.2 0-25.2 24.6-55.3 54.7C.4 167.9 0 168.3 0 178.6c0 18.2 16.8 30.5 34.1 24.9 5-1.6 7.8-4.2 36.7-32.8l31.2-31.1v149c0 165.1-.4 155.1 6.6 163.2 5.5 6.5 10.4 8.7 19.4 8.7s13.9-2.2 19.4-8.7c7-8.1 6.6 1.9 6.6-163.2v-149l31.3 31.1c28.8 28.6 31.6 31.2 36.6 32.8 17.3 5.6 34.2-6.7 34.1-24.9-.1-10.1-.2-10.2-58.3-68.4-32.3-32.4-55.8-55.2-58.2-56.4-5.1-2.7-14.7-3.3-20-1.3M377 51.9c-8.4 2.7-15.1 9.5-17.5 17.5-1.3 4.3-1.5 25.4-1.5 154v149l-31.2-31.1c-28.9-28.6-31.7-31.2-36.7-32.8-17.3-5.6-34.2 6.7-34.1 24.9.1 10.1.2 10.2 58.3 68.4 30.9 31 55.9 55.3 58.2 56.5 3.1 1.7 5.7 2.2 11.5 2.2s8.4-.5 11.5-2.2c2.3-1.2 27.3-25.5 58.2-56.5 58.1-58.2 58.2-58.3 58.3-68.4.1-18.2-16.8-30.5-34.1-24.9-5 1.6-7.8 4.2-36.6 32.8L410 372.4v-149c0-128.6-.2-149.7-1.5-154-1.8-6.1-7.3-12.7-12.8-15.6-4.5-2.2-14.5-3.3-18.7-1.9"
}));

const SvgIfcaxSsaRenewal = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 30 30"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 66348"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 66347"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#4d4d80",
  "data-name": "Group 66345"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.492 14.731A11.287 11.287 0 0 1 14.731 3.492 11.55 11.55 0 0 1 21.2 5.573a.734.734 0 0 0-.849.483.745.745 0 0 0 .474.944l3.165 1.054a.746.746 0 0 0 .943-.943l-1.055-3.166a.746.746 0 1 0-1.415.472l.1.289A13.07 13.07 0 0 0 14.731 2 12.78 12.78 0 0 0 2 14.731a12.7 12.7 0 0 0 .972 4.756.746.746 0 0 0 1.383-.559 11.2 11.2 0 0 1-.863-4.2Z",
  "data-name": "Path 82068"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.491 9.976a.746.746 0 0 0-1.383.559 11.137 11.137 0 0 1-10.377 15.436 11.55 11.55 0 0 1-6.472-2.081.736.736 0 0 0 .85-.483.745.745 0 0 0-.471-.943l-3.165-1.055a.746.746 0 0 0-.943.943l1.054 3.17a.746.746 0 0 0 1.415-.472l-.1-.289a13.07 13.07 0 0 0 7.829 2.707A12.628 12.628 0 0 0 26.491 9.976",
  "data-name": "Path 82069"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#443d66",
  d: "M20.354 6.056a.745.745 0 0 0 .471.943l3.165 1.055a.746.746 0 0 0 .943-.943l-1.055-3.165a.746.746 0 1 0-1.415.472l.1.289A13.07 13.07 0 0 0 14.731 2v1.492a11.55 11.55 0 0 1 6.472 2.081.734.734 0 0 0-.849.483",
  "data-name": "Path 82070"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#443d66",
  d: "M27.462 14.731a12.7 12.7 0 0 0-.972-4.756.746.746 0 0 0-1.383.559 11.137 11.137 0 0 1-10.376 15.437v1.492a12.78 12.78 0 0 0 12.731-12.732",
  "data-name": "Path 82071"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 66346"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#ff9a00",
  d: "M22.783 20.504H6.662a.856.856 0 1 1 0-1.712h16.121a.856.856 0 0 1 0 1.712",
  "data-name": "Path 82072"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ef8800",
  d: "M22.783 19.856H6.662a.86.86 0 0 1-.793-.532.856.856 0 0 0 .793 1.18h16.121a.856.856 0 0 0 .793-1.18.86.86 0 0 1-.793.532",
  "data-name": "Path 82073"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffe55a",
  d: "M22.561 18.792s0-8.7-7.839-8.7-7.839 8.7-7.839 8.7Z",
  "data-name": "Path 82074"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffd500",
  d: "M6.921 18.145c-.037.4-.037.647-.037.647h15.677s0-.243-.037-.647Z",
  "data-name": "Path 82075"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ff9a00",
  d: "M16.151 8.998h-2.858a.54.54 0 0 0-.537.586l.478 5.5a1.494 1.494 0 0 0 2.977 0l.478-5.5a.54.54 0 0 0-.538-.586",
  "data-name": "Path 82076"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ef8800",
  d: "M14.723 15.799a1.74 1.74 0 0 1-1.5-.864l.013.146a1.494 1.494 0 0 0 2.977 0l.013-.146a1.74 1.74 0 0 1-1.503.864",
  "data-name": "Path 82077"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ff9a00",
  d: "M11.18 16.067a.5.5 0 0 1-.559-.426l-.639-4.742a.5.5 0 0 1 .985-.133l.639 4.742a.5.5 0 0 1-.426.559",
  "data-name": "Path 82078"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ef8800",
  d: "m11.606 15.508-.087-.649a.5.5 0 0 1-.98.169l.083.613a.5.5 0 0 0 .985-.133Z",
  "data-name": "Path 82079"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ef8800",
  d: "m17.838 15.508.087-.649a.5.5 0 0 0 .98.169l-.083.613a.5.5 0 0 1-.985-.133Z",
  "data-name": "Path 82080"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ff9a00",
  d: "M18.264 16.067a.5.5 0 0 0 .559-.426l.639-4.742a.5.5 0 0 0-.985-.133l-.639 4.742a.5.5 0 0 0 .426.559",
  "data-name": "Path 82081"
}))), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h30v30H0z",
  "data-name": "Rectangle 27534"
})));

const SvgIfcaxSum = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 512 512"
}, props), /*#__PURE__*/React.createElement("circle", {
  cx: 256,
  cy: 256,
  r: 129.041,
  fill: "#ffe177"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffd15b",
  d: "M320.632 144.293c11.02 19.006 17.334 41.081 17.334 64.632 0 71.267-57.773 129.041-129.041 129.041-23.551 0-45.626-6.313-64.632-17.334C166.621 359.139 208.284 385.04 256 385.04c71.267 0 129.041-57.773 129.041-129.041 0-47.715-25.902-89.378-64.409-111.706"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#9be69d",
  d: "M256 24.976C128.409 24.976 24.976 128.409 24.976 256H7.11c-5.575 0-8.975 6.133-6.02 10.861l34.516 55.226c2.78 4.448 9.259 4.448 12.039 0l34.516-55.226c2.955-4.728-.444-10.861-6.02-10.861H58.276c0-109.025 88.698-197.724 197.724-197.724 51.666 0 98.768 19.919 134.028 52.482 3.265 3.015 8.343 2.871 11.485-.271l11.845-11.845c3.343-3.343 3.231-8.792-.234-12.008C371.899 48.371 316.682 24.976 256 24.976"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#6fd7a3",
  d: "M256 487.024c127.591 0 231.024-103.433 231.024-231.024h17.866c5.575 0 8.975-6.133 6.02-10.861l-34.516-55.226c-2.78-4.448-9.259-4.448-12.039 0l-34.516 55.226c-2.955 4.728.444 10.861 6.02 10.861h17.866c0 109.025-88.698 197.724-197.724 197.724-51.666 0-98.768-19.919-134.028-52.482-3.265-3.015-8.343-2.871-11.485.271l-11.845 11.845c-3.343 3.343-3.231 8.792.234 12.008 41.224 38.263 96.441 61.658 157.123 61.658"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#fd8087"
}, /*#__PURE__*/React.createElement("path", {
  d: "M209.724 220.986q-.038-.103-.08-.204a8.98 8.98 0 0 0-8.332-5.583h-.011a8.98 8.98 0 0 0-8.395 5.77l-25.009 65.663a7.5 7.5 0 0 0 14.018 5.339l4.389-11.523h29.828l4.341 11.502a7.5 7.5 0 0 0 7.018 4.854 7.499 7.499 0 0 0 7.015-10.15zm-17.708 44.461 9.269-24.338 9.185 24.338zM282.303 281.745h-15.821v-59.046c0-4.143-3.357-7.5-7.5-7.5s-7.5 3.357-7.5 7.5v66.546c0 4.143 3.357 7.5 7.5 7.5h23.321c4.143 0 7.5-3.357 7.5-7.5s-3.358-7.5-7.5-7.5M337.095 281.745h-15.821v-59.046c0-4.143-3.357-7.5-7.5-7.5s-7.5 3.357-7.5 7.5v66.546c0 4.143 3.357 7.5 7.5 7.5h23.321c4.143 0 7.5-3.357 7.5-7.5s-3.358-7.5-7.5-7.5"
})));

const SvgIfcaxSxIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  id: "ifcax-sx-icon_svg__Layer_2",
  viewBox: "0 0 232.21 231.04",
  width: "1em",
  height: "1em"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "ifcax-sx-icon_svg__drop-shadow-1",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: 8.68,
  dy: 8.68
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "blur",
  stdDeviation: 6.2
}), /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#000",
  floodOpacity: 0.39
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "blur",
  operator: "in"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "SourceGraphic"
})), /*#__PURE__*/React.createElement("style", null, ".ifcax-sx-icon_svg__cls-1{fill:#fff}.ifcax-sx-icon_svg__cls-5{opacity:.27}")), /*#__PURE__*/React.createElement("g", {
  id: "ifcax-sx-icon_svg__Layer_1-2"
}, /*#__PURE__*/React.createElement("rect", {
  width: 231.04,
  height: 231.04,
  x: 0.96,
  rx: 57.76,
  ry: 57.76,
  style: {
    fill: "#f9ae21"
  }
}), /*#__PURE__*/React.createElement("g", {
  className: "ifcax-sx-icon_svg__cls-5"
}, /*#__PURE__*/React.createElement("path", {
  d: "m26.69 24.2 7.68-.03 5.9 4.32-4.41 2.61zM41.15 35.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-sx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26 40.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM96.69 24.2l7.68-.03 5.9 4.32-4.41 2.61zM111.15 35.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-sx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M96 40.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM169.69 24.2l7.68-.03 5.9 4.32-4.41 2.61zM184.15 35.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-sx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M169 40.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2z",
  className: "ifcax-sx-icon_svg__cls-1"
})), /*#__PURE__*/React.createElement("g", {
  className: "ifcax-sx-icon_svg__cls-5"
}, /*#__PURE__*/React.createElement("path", {
  d: "m26.69 109.2 7.68-.03 5.9 4.32-4.41 2.61zM41.15 120.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-sx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26 125.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM96.69 109.2l7.68-.03 5.9 4.32-4.41 2.61zM111.15 120.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-sx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M96 125.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM169.69 109.2l7.68-.03 5.9 4.32-4.41 2.61zM184.15 120.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-sx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M169 125.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2z",
  className: "ifcax-sx-icon_svg__cls-1"
})), /*#__PURE__*/React.createElement("g", {
  className: "ifcax-sx-icon_svg__cls-5"
}, /*#__PURE__*/React.createElement("path", {
  d: "m26.69 198.2 7.68-.03 5.9 4.32-4.41 2.61zM41.15 209.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-sx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26 214.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM96.69 198.2l7.68-.03 5.9 4.32-4.41 2.61zM111.15 209.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-sx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M96 214.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM169.69 198.2l7.68-.03 5.9 4.32-4.41 2.61zM184.15 209.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-sx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M169 214.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2z",
  className: "ifcax-sx-icon_svg__cls-1"
})), /*#__PURE__*/React.createElement("g", {
  className: "ifcax-sx-icon_svg__cls-5"
}, /*#__PURE__*/React.createElement("path", {
  d: "m62.69 153.2 7.68-.03 5.9 4.32-4.41 2.61zM77.15 164.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-sx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M62 169.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM.69 153.2l7.68-.03 5.9 4.32-4.41 2.61zM15.15 164.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-sx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 169.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM130.69 153.2l7.68-.03 5.9 4.32-4.41 2.61zM145.15 164.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-sx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M130 169.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM194.69 153.2l7.68-.03 5.9 4.32-4.41 2.61zM209.15 164.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-sx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M194 169.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2z",
  className: "ifcax-sx-icon_svg__cls-1"
})), /*#__PURE__*/React.createElement("g", {
  className: "ifcax-sx-icon_svg__cls-5"
}, /*#__PURE__*/React.createElement("path", {
  d: "m62.69 66.2 7.68-.03 5.9 4.32-4.41 2.61zM77.15 77.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-sx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M62 82.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM.69 66.2l7.68-.03 5.9 4.32-4.41 2.61zM15.15 77.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-sx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 82.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM130.69 66.2l7.68-.03 5.9 4.32-4.41 2.61zM145.15 77.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-sx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M130 82.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2zM194.69 66.2l7.68-.03 5.9 4.32-4.41 2.61zM209.15 77.08l3.75-3 11.05 8.32-7.76-.02z",
  className: "ifcax-sx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M194 82.4s12.58-13.71 38.21-20.2c0 0-18.34 6.58-29.67 20.2z",
  className: "ifcax-sx-icon_svg__cls-1"
})), /*#__PURE__*/React.createElement("g", {
  style: {
    filter: "url(#ifcax-sx-icon_svg__drop-shadow-1)"
  }
}, /*#__PURE__*/React.createElement("path", {
  d: "m4.38 135.47 26.26-2.55c1.58 8.81 4.79 15.29 9.62 19.42s11.35 6.2 19.56 6.2q13.035 0 19.65-5.52c4.41-3.68 6.61-7.98 6.61-12.9 0-3.16-.93-5.85-2.78-8.07s-5.09-4.15-9.71-5.79c-3.16-1.09-10.36-3.04-21.61-5.83-14.47-3.59-24.62-7.99-30.45-13.22-8.21-7.35-12.31-16.32-12.31-26.89 0-6.81 1.93-13.17 5.79-19.1s9.42-10.44 16.68-13.54 16.03-4.65 26.3-4.65c16.78 0 29.4 3.68 37.88 11.03s12.93 17.17 13.36 29.45L82.24 84.7c-1.16-6.87-3.63-11.81-7.43-14.81-3.8-3.01-9.5-4.51-17.09-4.51s-13.98 1.61-18.42 4.83c-2.86 2.07-4.28 4.83-4.28 8.3 0 3.16 1.34 5.87 4.01 8.11 3.4 2.86 11.67 5.83 24.8 8.93s22.84 6.31 29.13 9.62 11.21 7.84 14.77 13.58 5.33 12.84 5.33 21.29c0 7.66-2.13 14.83-6.38 21.52-4.26 6.69-10.27 11.66-18.05 14.91s-17.47 4.88-29.08 4.88c-16.9 0-29.87-3.9-38.93-11.72Q7.03 157.915 4.39 135.49Z",
  style: {
    fill: "#231f20"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "m57.54 107.06 35.02-.16 26.94 19.73-20.13 11.95zM123.56 156.75l17.08-13.71 50.46 37.98-35.43-.09z",
  className: "ifcax-sx-icon_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M54.37 181.02s57.44-62.61 174.46-92.21c0 0-83.71 30.06-135.45 92.21z",
  className: "ifcax-sx-icon_svg__cls-1"
})));

const SvgIfcaxTax = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "-32 0 512 512"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#ddf5ff",
  d: "M437.074 512H64.52V10.406C64.52 4.66 69.18 0 74.926 0h362.148c5.746 0 10.406 4.66 10.406 10.406v491.188c0 5.746-4.66 10.406-10.406 10.406m0 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#c1e9f4",
  d: "M420.422 0v201.762c0 8.351-9.406 13.383-16.258 8.601-15.168-10.586-33.605-16.8-53.465-16.8-51.644 0-93.66 42.015-93.66 93.66q.001.97.02 1.941c.12 5.8-4.594 10.547-10.399 10.547H64.52V512h295.546V389.39c0-4.968 3.508-9.261 8.387-10.202 13-2.508 25.05-7.711 35.547-15.008 6.938-4.82 16.422.004 16.422 8.453V512h16.648c5.75 0 10.407-4.66 10.407-10.406V10.406C447.48 4.66 442.82 0 437.074 0zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffda88",
  d: "M256 43.707H149.855c-11.496 0-20.816 9.316-20.816 20.813v91.578c0 11.496 9.32 20.812 20.816 20.812h212.29c11.496 0 20.816-9.316 20.816-20.812V64.52c0-11.497-9.32-20.813-20.816-20.813zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffcd69",
  d: "M362.145 43.707h-19.77c11.492 0 20.813 9.316 20.813 20.813v91.578c0 11.496-9.32 20.812-20.813 20.812h19.77c11.496 0 20.816-9.316 20.816-20.812V64.52c0-11.493-9.32-20.813-20.816-20.813m0 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#abde97",
  d: "M10.406 320.52C4.66 320.52 0 325.18 0 330.926v170.668c0 5.746 4.66 10.402 10.406 10.402h318.442c5.746 0 10.406-4.656 10.406-10.402V320.52zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#82cd64",
  d: "M321.563 320.52V512h7.285c5.746 0 10.406-4.66 10.406-10.406V320.52zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#6dc54a",
  d: "M169.625 479.738H67.652c-4.465 0-8.511-2.816-9.855-7.07-2.484-7.863-8-13.875-16.09-16.441-4.36-1.383-7.363-5.372-7.363-9.946v-59.523c0-4.399 2.84-8.203 6.972-9.711 7.825-2.856 13.801-8.95 16.438-16.45 1.441-4.1 5.402-6.777 9.75-6.777h204.05c4.454 0 8.536 2.742 9.962 6.957 2.66 7.852 8.59 13.782 16.437 16.438 4.219 1.43 6.957 5.512 6.957 9.96v59.114c0 4.484-2.836 8.566-7.125 9.875-7.969 2.434-13.86 8.164-16.394 16.277-1.336 4.29-5.172 7.301-9.664 7.301H169.625zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5db33a",
  d: "M289.582 389.262q.147.065.293.125a2.01 2.01 0 0 1 1.242 1.843v51.098c0 .813-.496 1.527-1.242 1.844a38.83 38.83 0 0 0-20.531 20.535c-.32.746-1.035 1.242-1.844 1.242H54.633a27 27 0 0 1 3.058 6.403c1.43 4.351 5.364 7.39 9.946 7.39h204.09c4.492 0 8.328-3.015 9.664-7.3 2.535-8.114 8.43-13.844 16.394-16.278 4.285-1.309 7.125-5.39 7.125-9.875v-59.113c0-4.45-2.738-8.531-6.957-9.961-7.848-2.656-13.777-8.586-16.437-16.438-1.426-4.215-5.508-6.957-9.961-6.957h-2.711v3.176c0 13.887 8 26.738 20.738 32.266m0 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e5646e",
  d: "M423.547 287.219c0 40.234-32.617 72.847-72.848 72.847s-72.847-32.613-72.847-72.847c0-40.23 32.617-72.844 72.847-72.844s72.848 32.613 72.848 72.844m0 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e04955",
  d: "M394.988 229.402c9.418 12.274 15.028 27.621 15.028 44.29 0 40.23-32.614 72.847-72.844 72.847-16.668 0-32.016-5.61-44.29-15.027 13.313 17.355 34.255 28.554 57.817 28.554 40.23 0 72.848-32.613 72.848-72.847 0-23.563-11.203-44.504-28.559-57.817m0 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#495959",
  d: "M202.926 68.164H161.3a7.805 7.805 0 1 0 0 15.61h13.008v60.878a7.805 7.805 0 1 0 15.61 0V83.773h13.007a7.805 7.805 0 0 0 7.804-7.804 7.8 7.8 0 0 0-7.804-7.805M266.406 68.164h-20.812c-10.043 0-18.211 8.168-18.211 18.211v58.273a7.805 7.805 0 1 0 15.61 0v-26.535h26.015v26.535a7.805 7.805 0 0 0 7.805 7.805 7.8 7.8 0 0 0 7.804-7.805V86.375c0-10.043-8.168-18.21-18.21-18.21m-23.414 34.34V86.375a2.606 2.606 0 0 1 2.602-2.602h20.812a2.603 2.603 0 0 1 2.602 2.602v16.129zM339.012 110.309l18.363-30.297c2.234-3.684 1.055-8.485-2.633-10.719-3.683-2.234-8.484-1.055-10.719 2.629L329.887 95.25l-14.14-23.328a7.804 7.804 0 0 0-13.349 8.09l18.36 30.297-18.36 30.296a7.803 7.803 0 0 0 6.668 11.848 7.79 7.79 0 0 0 6.68-3.758l14.14-23.328 14.137 23.328a7.8 7.8 0 0 0 6.684 3.758 7.75 7.75 0 0 0 4.035-1.129c3.688-2.234 4.867-7.035 2.633-10.719zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5db33a",
  d: "M213.258 408.898h-5.395c-3.625-17.789-19.39-31.218-38.238-31.218-18.844 0-34.613 13.43-38.238 31.218h-5.528a7.805 7.805 0 1 0 0 15.61h5.528c3.625 17.793 19.394 31.222 38.238 31.222 18.848 0 34.613-13.43 38.238-31.222h5.395a7.805 7.805 0 1 0 0-15.61m-43.633 31.22c-12.91 0-23.414-10.505-23.414-23.415s10.504-23.414 23.414-23.414 23.414 10.504 23.414 23.414-10.504 23.414-23.414 23.414M266.16 408.898h-26.2a7.805 7.805 0 1 0 0 15.61h26.2a7.805 7.805 0 1 0 0-15.61M99.293 408.898H73.09a7.805 7.805 0 1 0 0 15.61h26.203a7.805 7.805 0 1 0 0-15.61m0 0"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#495959"
}, /*#__PURE__*/React.createElement("path", {
  d: "M345.57 266.203v-7.547c0-9.058-7.37-16.426-16.425-16.426-9.06 0-16.43 7.368-16.43 16.426v7.547c0 9.059 7.37 16.426 16.43 16.426 9.054 0 16.425-7.367 16.425-16.426M372.258 291.809c-9.059 0-16.43 7.37-16.43 16.425v7.547c0 9.059 7.371 16.426 16.43 16.426 9.055 0 16.426-7.367 16.426-16.426v-7.547c0-9.054-7.371-16.425-16.426-16.425M373.71 243.113a7.807 7.807 0 0 0-10.53 3.313l-38.801 74.367a7.81 7.81 0 0 0 6.914 11.418 7.81 7.81 0 0 0 6.926-4.195l38.8-74.371a7.81 7.81 0 0 0-3.308-10.532M262.242 226.34H129.04a7.805 7.805 0 1 1 0-15.61h133.203a7.805 7.805 0 1 1 0 15.61M220.617 296.066H129.04a7.807 7.807 0 0 1 0-15.613h91.578a7.805 7.805 0 0 1 7.805 7.809 7.805 7.805 0 0 1-7.805 7.804M220.617 261.203H129.04a7.805 7.805 0 1 1 0-15.61h91.578c4.313 0 7.805 3.493 7.805 7.805s-3.492 7.805-7.805 7.805m0 0"
})));

const SvgIfcaxUserAccessLog = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: "1em",
  height: "1em",
  viewBox: "0 0 48 48"
}, props), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ifcax-user-access-log_svg__b",
  x1: 24,
  x2: 24,
  y1: 1.68,
  y2: 47.149,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#ffeef1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ffc6cf"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ifcax-user-access-log_svg__a",
  x1: 24,
  x2: 24,
  y1: 9.681,
  y2: 36.789,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fd4685"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ff9d8c"
})), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#ifcax-user-access-log_svg__a",
  id: "ifcax-user-access-log_svg__c",
  x1: 33,
  x2: 33,
  y1: 9.681,
  y2: 36.789
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ifcax-user-access-log_svg__b)",
  d: "M46.406 10.717a9.683 9.683 0 0 0-9.124-9.124 235 235 0 0 0-26.564 0 9.684 9.684 0 0 0-9.124 9.124 235 235 0 0 0 0 26.565 9.684 9.684 0 0 0 9.124 9.124 235 235 0 0 0 26.564 0 9.683 9.683 0 0 0 9.124-9.124 235 235 0 0 0 0-26.565",
  "data-name": "Layer 2"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 3"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 20,
  r: 4.25,
  fill: "url(#ifcax-user-access-log_svg__a)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ifcax-user-access-log_svg__a)",
  d: "M24 10.25a13.75 13.75 0 0 0 0 27.5 13.6 13.6 0 0 0 4.26-.68 6.25 6.25 0 0 1 .71-8.85A6.246 6.246 0 0 0 17.8 31.2a.751.751 0 1 1-1.49-.19 7.76 7.76 0 0 1 4.66-6.13 5.75 5.75 0 1 1 6.06 0 7.83 7.83 0 0 1 3.2 2.52 6.14 6.14 0 0 1 2.77-.65 6.23 6.23 0 0 1 4.07 1.51 13.6 13.6 0 0 0 .68-4.26A13.77 13.77 0 0 0 24 10.25"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ifcax-user-access-log_svg__c)",
  d: "M33 28.25A4.75 4.75 0 1 0 37.75 33 4.756 4.756 0 0 0 33 28.25m2 5.5h-1.25V35a.75.75 0 0 1-1.5 0v-1.25H31a.75.75 0 0 1 0-1.5h1.25V31a.75.75 0 0 1 1.5 0v1.25H35a.75.75 0 0 1 0 1.5"
})));

const SvgIfcaxUserAccess = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 20.001 20.022"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 51237"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h20v20H0z",
  "data-name": "Rectangle 25739"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 51234"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#81a7c6",
  d: "M.156 7.524a.6.6 0 0 0 .5.412q.441.057.881.087a.61.61 0 0 1 .52.378v.007a.61.61 0 0 1-.1.635q-.29.333-.561.685a.6.6 0 0 0-.062.645 3.14 3.14 0 0 0 1.383 1.383.6.6 0 0 0 .645-.062q.352-.271.685-.561a.61.61 0 0 1 .635-.1h.007a.61.61 0 0 1 .378.52q.03.44.087.881a.6.6 0 0 0 .412.5 3.14 3.14 0 0 0 1.956 0 .6.6 0 0 0 .412-.5q.057-.441.087-.881a.61.61 0 0 1 .378-.52h.007a.61.61 0 0 1 .635.1q.333.29.685.561a.6.6 0 0 0 .645.062 3.14 3.14 0 0 0 1.383-1.383.6.6 0 0 0-.062-.645q-.271-.352-.561-.685a.61.61 0 0 1-.1-.635v-.007a.61.61 0 0 1 .52-.378q.44-.03.881-.087a.6.6 0 0 0 .5-.412 3.14 3.14 0 0 0 0-1.956.6.6 0 0 0-.5-.412q-.441-.057-.881-.087a.61.61 0 0 1-.52-.378v-.007a.61.61 0 0 1 .1-.635q.29-.333.561-.685a.6.6 0 0 0 .062-.645 3.14 3.14 0 0 0-1.383-1.383.6.6 0 0 0-.645.062q-.352.271-.685.561a.61.61 0 0 1-.635.1h-.007a.61.61 0 0 1-.378-.52q-.03-.44-.087-.881a.6.6 0 0 0-.412-.5 3.14 3.14 0 0 0-1.956 0 .6.6 0 0 0-.412.5q-.057.441-.087.881a.61.61 0 0 1-.378.52h-.007a.61.61 0 0 1-.635-.1q-.333-.29-.685-.561a.6.6 0 0 0-.645-.062 3.14 3.14 0 0 0-1.381 1.381.6.6 0 0 0 .062.645q.271.352.561.685a.61.61 0 0 1 .1.635v.007a.61.61 0 0 1-.52.378q-.44.03-.881.087a.6.6 0 0 0-.5.412 3.14 3.14 0 0 0-.002 1.958m6.39-3.873a2.895 2.895 0 1 1-2.9 2.895 2.895 2.895 0 0 1 2.9-2.895",
  "data-name": "Path 68925"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5c90b9",
  d: "M11.032 2.559a.65.65 0 0 1-.062.672q-.271.367-.561.713a.66.66 0 0 0-.1.661v.008a.61.61 0 0 0 .52.394q.44.031.881.091a.61.61 0 0 1 .5.43 3.4 3.4 0 0 1 0 2.038.61.61 0 0 1-.5.43q-.441.059-.881.091a.61.61 0 0 0-.52.394v.008a.66.66 0 0 0 .1.661q.29.347.561.713a.65.65 0 0 1 .062.672 3.2 3.2 0 0 1-1.092 1.266.6.6 0 0 0 .434-.044 3.14 3.14 0 0 0 1.383-1.383.6.6 0 0 0-.062-.645q-.271-.352-.561-.685a.61.61 0 0 1-.1-.635v-.007a.61.61 0 0 1 .52-.378q.44-.03.881-.087a.6.6 0 0 0 .5-.412 3.14 3.14 0 0 0 0-1.956.6.6 0 0 0-.5-.412q-.441-.057-.881-.087a.61.61 0 0 1-.52-.378v-.007a.61.61 0 0 1 .1-.635q.289-.333.561-.685a.6.6 0 0 0 .062-.645 3.14 3.14 0 0 0-1.383-1.383.6.6 0 0 0-.434-.044 3.2 3.2 0 0 1 1.092 1.266M7.212.409q.057.459.087.918a.63.63 0 0 0 .378.542h.007a.6.6 0 0 0 .471 0 .6.6 0 0 1-.131-.335q-.03-.44-.087-.881a.6.6 0 0 0-.412-.5 3.4 3.4 0 0 0-.486-.117.65.65 0 0 1 .171.373Zm.312 12.529a.6.6 0 0 0 .412-.5q.057-.441.087-.881a.6.6 0 0 1 .131-.335.6.6 0 0 0-.471 0h-.007a.63.63 0 0 0-.378.542q-.03.459-.087.918a.65.65 0 0 1-.173.369 3.4 3.4 0 0 0 .487-.114Z",
  "data-name": "Path 68926"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 51235"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#81a7c6",
  d: "M9.073 16.525a.38.38 0 0 0 .314.259q.277.036.554.055a.38.38 0 0 1 .327.238.38.38 0 0 1-.063.4q-.182.209-.353.431a.38.38 0 0 0-.039.406 1.98 1.98 0 0 0 .87.87.38.38 0 0 0 .406-.039q.221-.171.431-.353a.38.38 0 0 1 .4-.063.38.38 0 0 1 .238.327q.019.277.055.554a.38.38 0 0 0 .259.314 1.98 1.98 0 0 0 1.23 0 .38.38 0 0 0 .259-.314q.036-.277.055-.554a.38.38 0 0 1 .238-.327.38.38 0 0 1 .4.063q.209.182.431.353a.38.38 0 0 0 .406.039 1.98 1.98 0 0 0 .87-.87.38.38 0 0 0-.039-.406q-.171-.221-.353-.431a.38.38 0 0 1-.063-.4.38.38 0 0 1 .327-.238q.277-.019.554-.055a.38.38 0 0 0 .314-.259 1.98 1.98 0 0 0 0-1.23.38.38 0 0 0-.314-.259q-.277-.036-.554-.055a.38.38 0 0 1-.327-.238.38.38 0 0 1 .063-.4q.182-.209.353-.431a.38.38 0 0 0 .039-.406 1.98 1.98 0 0 0-.87-.87.38.38 0 0 0-.4.036q-.221.171-.431.353a.38.38 0 0 1-.4.063.38.38 0 0 1-.238-.327q-.019-.279-.055-.556a.38.38 0 0 0-.26-.313 1.98 1.98 0 0 0-1.23 0 .38.38 0 0 0-.259.314q-.036.277-.055.554a.38.38 0 0 1-.238.327.38.38 0 0 1-.4-.063q-.213-.181-.434-.352a.38.38 0 0 0-.406-.039 1.98 1.98 0 0 0-.87.87.38.38 0 0 0 .039.406q.171.221.353.431a.38.38 0 0 1 .063.4.38.38 0 0 1-.327.238q-.277.019-.554.055a.38.38 0 0 0-.314.259 1.98 1.98 0 0 0 0 1.23Zm4.018-2.433a1.821 1.821 0 1 1-1.82 1.818 1.82 1.82 0 0 1 1.82-1.818",
  "data-name": "Path 68927"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5c90b9",
  d: "M15.914 13.401a.41.41 0 0 1-.039.423q-.171.231-.353.449a.41.41 0 0 0-.063.416.39.39 0 0 0 .327.248q.277.02.554.057a.39.39 0 0 1 .314.27 2.14 2.14 0 0 1 0 1.282.39.39 0 0 1-.314.27q-.277.037-.554.057a.39.39 0 0 0-.327.248.41.41 0 0 0 .063.416q.182.218.353.449a.41.41 0 0 1 .039.423 2 2 0 0 1-.687.8.38.38 0 0 0 .273-.025 1.97 1.97 0 0 0 .87-.87.38.38 0 0 0-.039-.406q-.171-.221-.353-.431a.38.38 0 0 1-.063-.4.38.38 0 0 1 .327-.238q.277-.019.554-.055a.38.38 0 0 0 .314-.259 1.98 1.98 0 0 0 0-1.23.38.38 0 0 0-.314-.259q-.277-.036-.554-.055a.38.38 0 0 1-.327-.238.38.38 0 0 1 .063-.4q.182-.209.353-.431a.38.38 0 0 0 .039-.406 1.97 1.97 0 0 0-.87-.87.38.38 0 0 0-.273-.027 2 2 0 0 1 .687.792m-2.402-1.352q.036.289.055.577a.4.4 0 0 0 .238.341.37.37 0 0 0 .3 0 .38.38 0 0 1-.083-.211q-.019-.277-.055-.554a.38.38 0 0 0-.259-.318 2 2 0 0 0-.305-.073.4.4 0 0 1 .109.234Zm.2 7.88a.38.38 0 0 0 .259-.314q.036-.277.055-.554a.4.4 0 0 1 .083-.211.37.37 0 0 0-.3 0 .4.4 0 0 0-.238.341q-.019.289-.055.577a.4.4 0 0 1-.109.232 2 2 0 0 0 .3-.071Z",
  "data-name": "Path 68928"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 51236"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#81a7c6",
  d: "M14.133 9.032a.27.27 0 0 0 .227.187q.2.026.4.04a.28.28 0 0 1 .236.171.28.28 0 0 1-.046.288q-.131.151-.254.311a.27.27 0 0 0-.028.293 1.42 1.42 0 0 0 .627.627.27.27 0 0 0 .293-.028q.16-.123.311-.254a.28.28 0 0 1 .288-.046.28.28 0 0 1 .171.236q.014.2.04.4a.27.27 0 0 0 .187.227 1.43 1.43 0 0 0 .887 0 .27.27 0 0 0 .187-.227q.026-.2.04-.4a.28.28 0 0 1 .171-.236.28.28 0 0 1 .288.046q.151.131.311.254a.27.27 0 0 0 .293.028 1.42 1.42 0 0 0 .627-.627.27.27 0 0 0-.023-.29q-.123-.16-.254-.311a.28.28 0 0 1-.046-.288.28.28 0 0 1 .236-.171q.2-.014.4-.04a.27.27 0 0 0 .228-.19 1.43 1.43 0 0 0 0-.887.27.27 0 0 0-.224-.189q-.2-.026-.4-.04a.28.28 0 0 1-.236-.171.28.28 0 0 1 .046-.288q.131-.151.254-.311a.27.27 0 0 0 .028-.293 1.42 1.42 0 0 0-.627-.627.27.27 0 0 0-.293.028q-.16.123-.311.255a.28.28 0 0 1-.288.046.28.28 0 0 1-.173-.241q-.014-.2-.04-.4a.27.27 0 0 0-.187-.227 1.43 1.43 0 0 0-.887 0 .27.27 0 0 0-.187.227q-.026.2-.04.4a.28.28 0 0 1-.171.236.28.28 0 0 1-.288-.046q-.151-.131-.311-.255a.27.27 0 0 0-.293-.028 1.42 1.42 0 0 0-.627.627.27.27 0 0 0 .028.293q.123.16.254.311a.28.28 0 0 1 .046.288.28.28 0 0 1-.236.171q-.2.014-.4.04a.27.27 0 0 0-.227.187 1.43 1.43 0 0 0 0 .887Zm2.9-1.273a.83.83 0 1 1-.83.83.83.83 0 0 1 .83-.83",
  "data-name": "Path 68929"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5c90b9",
  d: "M19.065 6.777a.3.3 0 0 1-.028.3q-.123.166-.254.324a.3.3 0 0 0-.046.3.28.28 0 0 0 .236.179q.2.014.4.041a.28.28 0 0 1 .227.195 1.55 1.55 0 0 1 0 .925.28.28 0 0 1-.227.2q-.2.027-.4.041a.28.28 0 0 0-.236.179.3.3 0 0 0 .046.3q.131.157.254.324a.3.3 0 0 1 .028.3 1.46 1.46 0 0 1-.5.574.27.27 0 0 0 .2-.02 1.42 1.42 0 0 0 .627-.627.27.27 0 0 0-.028-.293q-.123-.16-.254-.311a.28.28 0 0 1-.046-.288.28.28 0 0 1 .236-.171q.2-.014.4-.04a.27.27 0 0 0 .227-.187 1.43 1.43 0 0 0 0-.887.27.27 0 0 0-.227-.187q-.2-.026-.4-.04a.28.28 0 0 1-.236-.171.28.28 0 0 1 .046-.288q.131-.151.254-.311a.27.27 0 0 0 .028-.293 1.42 1.42 0 0 0-.627-.627.27.27 0 0 0-.2-.02 1.46 1.46 0 0 1 .5.584Zm-1.732-.975q.026.208.04.416a.29.29 0 0 0 .171.246.27.27 0 0 0 .214 0 .27.27 0 0 1-.06-.152q-.014-.2-.04-.4a.27.27 0 0 0-.187-.227 1.5 1.5 0 0 0-.22-.053.3.3 0 0 1 .079.167Zm.142 5.682a.27.27 0 0 0 .187-.227q.026-.2.04-.4a.27.27 0 0 1 .06-.152.27.27 0 0 0-.214 0 .29.29 0 0 0-.171.246q-.014.208-.04.416a.3.3 0 0 1-.079.167 1.5 1.5 0 0 0 .22-.053Z",
  "data-name": "Path 68930"
}))));

const SvgIfcaxVideo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 30 30"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 66562"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#dfe7f4",
  "data-name": "Group 64573"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.638 20.945v2.551h20.495v-2.551z",
  "data-name": "Path 71453"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.885 5.638H4.638v2.551h20.495V5.638Z",
  "data-name": "Path 71454"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#c7cfe1",
  d: "M14.885 5.638h10.247v2.551H14.885Z",
  "data-name": "Path 71455"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#c7cfe1",
  d: "M14.885 20.945h10.247v2.551H14.885Z",
  "data-name": "Path 71456"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ff641a",
  d: "M14.886 8.189h-9.61v12.756h19.219V8.189Z",
  "data-name": "Path 71457"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f03800",
  d: "M14.885 8.189h9.61v12.756h-9.61Z",
  "data-name": "Path 71458"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 64576"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#404a80",
  "data-name": "Group 64574"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4 20.307v3.827h21.77v-3.827zm3.444 2.551H5.276v-1.276h2.168Zm3.4 0H8.72v-1.276h2.126Zm3.4 0h-2.123v-1.276h2.126Zm8.079-1.276h2.169v1.276h-2.166Zm-3.4 0h2.126v1.276h-2.124Zm-3.4 0h2.126v1.276h-2.126Z",
  "data-name": "Path 71459"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.885 5H4v3.827h21.77V5ZM7.444 7.551H5.276V6.276h2.168Zm3.4 0H8.72V6.276h2.126Zm3.4 0h-2.123V6.276h2.126Zm3.4 0h-2.121V6.276h2.126Zm3.4 0h-2.119V6.276h2.126Zm3.444 0h-2.166V6.276h2.173Z",
  "data-name": "Path 71460"
})), /*#__PURE__*/React.createElement("g", {
  fill: "#283366",
  "data-name": "Group 64575"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.649 7.551h-2.126V6.276h2.126Zm3.4 0h-2.126V6.276h2.126ZM14.885 5v3.827H25.77V5Zm9.61 2.551h-2.173V6.276h2.173Z",
  "data-name": "Path 71461"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.77 20.307H14.885v3.827H25.77Zm-8.121 2.551h-2.126v-1.276h2.126Zm3.4 0h-2.126v-1.276h2.126Zm3.444 0h-2.169v-1.276h2.169Z",
  "data-name": "Path 71462"
}))), /*#__PURE__*/React.createElement("path", {
  fill: "#f0f7ff",
  d: "m14.885 12.1-1.913-1.276v7.485l1.913-1.276 3.7-2.467Z",
  "data-name": "Path 71463"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#dfe7f4",
  d: "M14.885 12.1v4.934l3.7-2.467Z",
  "data-name": "Path 71464"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h30v30H0z",
  "data-name": "Rectangle 26199"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M2 2h26v26H2z",
  "data-name": "Rectangle 26200"
})));

const SvgIfcaxXd = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  "data-name": "Layer 1",
  viewBox: "0 0 256 256"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#ff61f6",
  d: "M228 232H28a20 20 0 0 1-20-20V44a20 20 0 0 1 20-20h77.72a20 20 0 0 1 14.14 5.86l18.28 18.28A20 20 0 0 0 152.28 54H228a20 20 0 0 1 20 20v138a20 20 0 0 1-20 20"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#470137",
  d: "M16 62h210a14 14 0 0 1 14 14v134a14 14 0 0 1-14 14H30a14 14 0 0 1-14-14z"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#ff61f6"
}, /*#__PURE__*/React.createElement("path", {
  d: "m132.07 103.21-21.64 37.58 23.32 40c.48.81.28 1.21-.6 1.21h-14.58a1.81 1.81 0 0 1-1.79-1l-16.39-30.42h-.12L84.28 181a1.78 1.78 0 0 1-1.55 1h-14c-.8 0-1-.4-.48-1.21l22.94-38.91L69.34 103c-.47-.65-.31-1 .48-1H84.4a1.63 1.63 0 0 1 1.55.85l15.39 30.06h.12l15.32-30.06a1.64 1.64 0 0 1 1.55-.85h13.27c.87 0 1.03.41.47 1.21M164.13 184c-8.62 0-15.25-2.42-20.4-7.27s-7.73-12-7.73-21.45q0-12.9 8.31-21.21a29.8 29.8 0 0 1 21.9-9 22.4 22.4 0 0 1 5.42.58v-24.96a.61.61 0 0 1 .69-.69h13.57c.39 0 .58.23.58.69v69.82c0 2.92 1.28 5.46 1.51 7.61a.91.91 0 0 1-.57 1c-6.7 3.27-15.41 4.88-23.28 4.88m7.5-11.42V137c-.48-.85-3-1.58-5.66-1.58a14.61 14.61 0 0 0-11.42 5 21.5 21.5 0 0 0-5.19 14.3c0 6.46 2.25 10.87 5.13 13.95a14.83 14.83 0 0 0 11 5c2.79.01 5.51-.4 6.14-1.09"
})));

const SvgLeave = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: "1em",
  height: "1em",
  viewBox: "0 0 30 30"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "leave_svg__a",
  x1: -25.548,
  x2: -25.644,
  y1: -0.052,
  y2: 0.837,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#2b3582"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#150e42"
})), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#leave_svg__a",
  id: "leave_svg__d",
  x1: -4.532,
  x2: -5.492,
  y1: -2.194,
  y2: -0.587
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "leave_svg__b",
  x1: -73.911,
  x2: -71.138,
  y1: 1.493,
  y2: 0.171,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#00c0ff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5558ff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#leave_svg__b",
  id: "leave_svg__e",
  x1: -25.051,
  x2: -24.097,
  y1: 1.049,
  y2: 0.145
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "leave_svg__f",
  x1: 0.5,
  x2: 0.5,
  y2: 1,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#301fe6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#181073"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "leave_svg__c",
  x1: 0.509,
  x2: 0.496,
  y1: 2.145,
  y2: -0.606,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.004,
  stopColor: "#f36f56"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.306,
  stopColor: "#f99c4c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.545,
  stopColor: "#fdb946"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.682,
  stopColor: "#ffc444"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.804,
  stopColor: "#fec144"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.867,
  stopColor: "#fdb946"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.916,
  stopColor: "#fbac49"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.958,
  stopColor: "#f8994d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.995,
  stopColor: "#f58152"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f57e53"
})), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#leave_svg__c",
  id: "leave_svg__g",
  x1: 0.5,
  x2: 0.5,
  y1: 0,
  y2: 1
}), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#leave_svg__c",
  id: "leave_svg__h",
  x1: 0.519,
  x2: 0.477,
  y1: 2.383,
  y2: -0.75
}), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#leave_svg__c",
  id: "leave_svg__i",
  x1: 0.382,
  x2: 1.098,
  y1: -0.274,
  y2: 3.943
}), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#leave_svg__c",
  id: "leave_svg__j",
  x1: 0.514,
  x2: 0.472,
  y1: 2.023,
  y2: -1.11
}), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#leave_svg__c",
  id: "leave_svg__k",
  x1: 0.34,
  x2: 1.055,
  y1: -0.442,
  y2: 3.435
}), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#leave_svg__c",
  id: "leave_svg__l",
  x1: 0.564,
  x2: 0.482,
  y1: -1.077,
  y2: 1.13
}), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#leave_svg__c",
  id: "leave_svg__m",
  x1: 0.536,
  x2: 0.397,
  y1: -0.322,
  y2: 2.901
}), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#leave_svg__c",
  id: "leave_svg__n",
  x1: 0.68,
  x2: 0.419,
  y1: -1.394,
  y2: 1.019
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 56800"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 13246"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 11319",
  transform: "translate(2 4.162)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#leave_svg__a)",
  d: "M264.475 348.631c.343-3.693 1.2-12.865 1.39-14.206.236-1.685 2.172-1.313 2.172-1.313l.415 17.051h-2.7a1.24 1.24 0 0 1-.952-.459 1.47 1.47 0 0 1-.325-1.073",
  "data-name": "Path 14036",
  transform: "translate(-264.469 -331.647)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#leave_svg__d)",
  d: "M338.683 350.89a1.58 1.58 0 0 0 1.494-1.657l-.275-13.8a1.39 1.39 0 0 0-1.3-1.4l-18.839-.594a1.023 1.023 0 0 0-1.021 1.057l.045 15.825a.97.97 0 0 0 .961 1Z",
  "data-name": "Path 14037",
  transform: "translate(-317.181 -331.996)"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 11316"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#5367ff",
  d: "M22.716 17.808a.467.467 0 0 0 .432-.549 79.5 79.5 0 0 1-.871-13.826.43.43 0 0 0-.4-.465L2.953 2.321a.487.487 0 0 0-.487.487c-.081 2.275-.38 11.645.012 14.976a.383.383 0 0 0 .377.35Z",
  "data-name": "Path 14038"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M22.239 17.61a.45.45 0 0 0 .415-.53 77 77 0 0 1-.838-13.34.413.413 0 0 0-.381-.448L3.224 2.668a.47.47 0 0 0-.468.469c-.077 2.2-.366 11.237.012 14.45a.37.37 0 0 0 .363.338Z",
  "data-name": "Path 14039"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#cdd3ff",
  d: "m11.045 6.723.028 1.312a.36.36 0 0 1-.357.366l-1.345.008a.36.36 0 0 1-.361-.351l-.029-1.379a.36.36 0 0 1 .374-.366l1.347.06a.36.36 0 0 1 .343.35",
  "data-name": "Path 14040",
  opacity: 0.72
}), /*#__PURE__*/React.createElement("path", {
  fill: "#cdd3ff",
  d: "m15.749 8.398-1.345.008a.36.36 0 0 1-.361-.351l-.025-1.173a.36.36 0 0 1 .371-.366l1.346.048a.36.36 0 0 1 .346.351l.024 1.117a.36.36 0 0 1-.356.366",
  "data-name": "Path 14041",
  opacity: 0.72
}), /*#__PURE__*/React.createElement("path", {
  fill: "#cdd3ff",
  d: "m14.57 14.907 1.28-.012a.39.39 0 0 1 .4.383l.026 1.2a.39.39 0 0 1-.375.4l-1.279.054a.39.39 0 0 1-.408-.383l-.026-1.24a.39.39 0 0 1 .382-.402",
  "data-name": "Path 14042",
  opacity: 0.72
}), /*#__PURE__*/React.createElement("path", {
  fill: "#cdd3ff",
  d: "m16.723 16.447-.025-1.172a.385.385 0 0 1 .381-.393l1.293-.013a.385.385 0 0 1 .388.376l.024 1.13a.385.385 0 0 1-.368.392l-1.292.055a.385.385 0 0 1-.401-.375",
  "data-name": "Path 14043",
  opacity: 0.72
}), /*#__PURE__*/React.createElement("path", {
  fill: "#cdd3ff",
  d: "m16.61 10.655-.02-.962a.414.414 0 0 1 .415-.423h1.235a.414.414 0 0 1 .413.405l.02.919a.414.414 0 0 1-.4.422l-1.234.04a.414.414 0 0 1-.429-.401",
  "data-name": "Path 14044",
  opacity: 0.72
}), /*#__PURE__*/React.createElement("path", {
  fill: "#cdd3ff",
  d: "m16.67 13.62-.031-1.471a.385.385 0 0 1 .372-.393l1.263-.041a.414.414 0 0 1 .427.405l.032 1.484a.385.385 0 0 1-.385.393h-1.293a.385.385 0 0 1-.385-.377",
  "data-name": "Path 14045",
  opacity: 0.72
}), /*#__PURE__*/React.createElement("path", {
  fill: "#cdd3ff",
  d: "m13.232 8.409-1.345.008a.36.36 0 0 1-.36-.351l-.03-1.273a.36.36 0 0 1 .371-.366l1.346.048a.36.36 0 0 1 .346.351l.026 1.221a.36.36 0 0 1-.354.362",
  "data-name": "Path 14046",
  opacity: 0.72
}), /*#__PURE__*/React.createElement("path", {
  fill: "#cdd3ff",
  d: "m14.154 13.615-.029-1.376a.39.39 0 0 1 .379-.4l1.279-.042a.39.39 0 0 1 .4.383l.03 1.418a.39.39 0 0 1-.391.4h-1.28a.39.39 0 0 1-.388-.383",
  "data-name": "Path 14047",
  opacity: 0.72
}), /*#__PURE__*/React.createElement("path", {
  fill: "#cdd3ff",
  d: "M11.853 9.268h1.469a.3.3 0 0 1 .3.29l.028 1.323a.3.3 0 0 1-.287.3l-1.468.048a.3.3 0 0 1-.306-.29l-.029-1.374a.3.3 0 0 1 .293-.297",
  "data-name": "Path 14048",
  opacity: 0.72
}), /*#__PURE__*/React.createElement("path", {
  fill: "#cdd3ff",
  d: "m11.103 9.633.027 1.26a.373.373 0 0 1-.361.381l-1.316.043a.373.373 0 0 1-.385-.365L9.04 9.647a.373.373 0 0 1 .374-.381h1.317a.373.373 0 0 1 .372.367",
  "data-name": "Path 14049",
  opacity: 0.72
}), /*#__PURE__*/React.createElement("path", {
  fill: "#cdd3ff",
  d: "m15.873 11.101-1.468.048a.3.3 0 0 1-.306-.29l-.027-1.287a.3.3 0 0 1 .3-.3h1.469a.3.3 0 0 1 .3.291l.026 1.236a.3.3 0 0 1-.294.302",
  "data-name": "Path 14050",
  opacity: 0.72
}), /*#__PURE__*/React.createElement("path", {
  fill: "#cdd3ff",
  d: "m11.988 11.924 1.279-.042a.39.39 0 0 1 .4.383l.028 1.336a.39.39 0 0 1-.391.4h-1.28a.39.39 0 0 1-.391-.383l-.027-1.294a.39.39 0 0 1 .382-.4",
  "data-name": "Path 14051",
  opacity: 0.72
}), /*#__PURE__*/React.createElement("path", {
  fill: "#cdd3ff",
  d: "m9.43 12.009 1.369-.045a.346.346 0 0 1 .358.339l.029 1.345a.346.346 0 0 1-.346.354H9.47a.347.347 0 0 1-.347-.339l-.028-1.3a.347.347 0 0 1 .335-.354",
  "data-name": "Path 14052",
  opacity: 0.72
}), /*#__PURE__*/React.createElement("path", {
  fill: "#cdd3ff",
  d: "m18.076 8.37-1.021.006a.5.5 0 0 1-.5-.487l-.018-.842a.443.443 0 0 1 .459-.452l1.136.041a.487.487 0 0 1 .469.476l.015.7a.543.543 0 0 1-.54.558",
  "data-name": "Path 14053",
  opacity: 0.72
}), /*#__PURE__*/React.createElement("path", {
  fill: "#cdd3ff",
  d: "M19.217 15.284a.414.414 0 0 1 .41-.423h.445a.57.57 0 0 1 .62.5l.017.814a.57.57 0 0 1-.592.527l-.477.02a.385.385 0 0 1-.4-.376Z",
  "data-name": "Path 14054",
  opacity: 0.72
}), /*#__PURE__*/React.createElement("path", {
  fill: "#cdd3ff",
  d: "m4.912 15.001.875-.008a.39.39 0 0 1 .4.383l.032 1.526a.39.39 0 0 1-.375.4l-.871.037a.577.577 0 0 1-.645-.5L4.3 15.531a.575.575 0 0 1 .612-.53",
  "data-name": "Path 14055",
  opacity: 0.72
}), /*#__PURE__*/React.createElement("path", {
  fill: "#cdd3ff",
  d: "M20.033 13.995h-.434a.414.414 0 0 1-.414-.405l-.032-1.5a.414.414 0 0 1 .4-.422l.437-.014a.575.575 0 0 1 .637.5l.028 1.308a.577.577 0 0 1-.622.533",
  "data-name": "Path 14056",
  opacity: 0.72
}), /*#__PURE__*/React.createElement("path", {
  fill: "#cdd3ff",
  d: "m19.996 10.961-.547.018a.313.313 0 0 1-.323-.306l-.023-1.08a.313.313 0 0 1 .314-.32h.552a.57.57 0 0 1 .612.5l.014.658a.57.57 0 0 1-.599.53",
  "data-name": "Path 14057",
  opacity: 0.72
}), /*#__PURE__*/React.createElement("path", {
  fill: "#cdd3ff",
  d: "m4.772 6.139.877.031a.373.373 0 0 1 .36.365l.032 1.507a.373.373 0 0 1-.371.381l-.9.005a.57.57 0 0 1-.617-.5l-.027-1.261a.58.58 0 0 1 .646-.528",
  "data-name": "Path 14058",
  opacity: 0.72
}), /*#__PURE__*/React.createElement("path", {
  fill: "#cdd3ff",
  d: "m12.055 14.932 1.28-.012a.39.39 0 0 1 .4.383l.027 1.28a.39.39 0 0 1-.375.4l-1.279.054a.39.39 0 0 1-.408-.383l-.028-1.322a.39.39 0 0 1 .383-.4",
  "data-name": "Path 14059",
  opacity: 0.72
}), /*#__PURE__*/React.createElement("path", {
  fill: "#cdd3ff",
  d: "M4.809 9.263h.889a.373.373 0 0 1 .372.365l.03 1.434a.373.373 0 0 1-.361.381l-.893.029a.575.575 0 0 1-.637-.5L4.184 9.79a.577.577 0 0 1 .625-.527",
  "data-name": "Path 14060",
  opacity: 0.72
}), /*#__PURE__*/React.createElement("path", {
  fill: "#cdd3ff",
  d: "m4.841 12.163.928-.03a.346.346 0 0 1 .358.339l.025 1.18a.347.347 0 0 1-.346.354h-.929a.57.57 0 0 1-.613-.5l-.017-.814a.57.57 0 0 1 .594-.529",
  "data-name": "Path 14061",
  opacity: 0.72
}), /*#__PURE__*/React.createElement("path", {
  fill: "#cdd3ff",
  d: "m8.642 12.388.027 1.263a.347.347 0 0 1-.346.354h-1.37a.347.347 0 0 1-.346-.339l-.022-1.219a.347.347 0 0 1 .335-.354l1.369-.045a.346.346 0 0 1 .353.34",
  "data-name": "Path 14062",
  opacity: 0.72
}), /*#__PURE__*/React.createElement("path", {
  fill: "#cdd3ff",
  d: "m7.023 14.98 1.279-.012a.39.39 0 0 1 .4.383l.031 1.444a.39.39 0 0 1-.375.4l-1.278.054a.39.39 0 0 1-.408-.383l-.032-1.485a.39.39 0 0 1 .383-.401",
  "data-name": "Path 14063",
  opacity: 0.72
}), /*#__PURE__*/React.createElement("path", {
  fill: "#cdd3ff",
  d: "M19.925 8.362h-.535a.313.313 0 0 1-.315-.306l-.022-1.057a.313.313 0 0 1 .324-.32l.567.02a.565.565 0 0 1 .586.5l.013.63a.576.576 0 0 1-.618.533",
  "data-name": "Path 14064",
  opacity: 0.72
}), /*#__PURE__*/React.createElement("path", {
  fill: "#cdd3ff",
  d: "m9.539 14.956 1.258-.012a.413.413 0 0 1 .417.4l.028 1.34a.39.39 0 0 1-.375.4l-1.278.054a.39.39 0 0 1-.408-.383l-.03-1.4a.39.39 0 0 1 .388-.399",
  "data-name": "Path 14065",
  opacity: 0.72
}), /*#__PURE__*/React.createElement("path", {
  fill: "#cdd3ff",
  d: "m8.527 6.629.03 1.4a.373.373 0 0 1-.371.381l-1.316.007a.373.373 0 0 1-.375-.365l-.031-1.457a.373.373 0 0 1 .386-.381l1.318.047a.373.373 0 0 1 .359.368",
  "data-name": "Path 14066",
  opacity: 0.72
}), /*#__PURE__*/React.createElement("path", {
  fill: "#cdd3ff",
  d: "m8.587 9.631.029 1.347a.373.373 0 0 1-.361.381l-1.316.043a.373.373 0 0 1-.385-.365l-.03-1.392a.373.373 0 0 1 .374-.381h1.317a.373.373 0 0 1 .372.367",
  "data-name": "Path 14067",
  opacity: 0.72
}), /*#__PURE__*/React.createElement("path", {
  fill: "#cdd3ff",
  d: "m20.071 5.462-.061.444a.29.29 0 0 1-.283.252h-.021a.29.29 0 0 1-.3-.285l-.01-.455a.292.292 0 0 1 .324-.3l.091.01a.29.29 0 0 1 .26.334",
  "data-name": "Path 14068"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#cdd3ff",
  d: "m18.009 5.341-.061.444a.29.29 0 0 1-.283.252h-.021a.29.29 0 0 1-.3-.285l-.01-.455a.292.292 0 0 1 .324-.3l.091.01a.29.29 0 0 1 .26.334",
  "data-name": "Path 14069"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#cdd3ff",
  d: "m15.473 5.378-.06.444a.29.29 0 0 1-.283.252h-.021a.29.29 0 0 1-.3-.285l-.01-.455a.292.292 0 0 1 .324-.3l.091.01a.29.29 0 0 1 .259.334",
  "data-name": "Path 14070"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#cdd3ff",
  d: "m13.002 5.261-.061.444a.29.29 0 0 1-.283.252h-.021a.29.29 0 0 1-.3-.285l-.01-.455a.292.292 0 0 1 .323-.3l.091.01a.29.29 0 0 1 .261.334",
  "data-name": "Path 14071"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#cdd3ff",
  d: "m10.46 4.918-.061.444a.29.29 0 0 1-.283.252h-.021a.29.29 0 0 1-.3-.285l-.01-.455a.292.292 0 0 1 .323-.3l.091.01a.29.29 0 0 1 .261.334",
  "data-name": "Path 14072"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#cdd3ff",
  d: "m7.776 4.978-.061.444a.29.29 0 0 1-.283.252h-.021a.29.29 0 0 1-.3-.285l-.01-.455a.292.292 0 0 1 .324-.3l.091.01a.29.29 0 0 1 .26.334",
  "data-name": "Path 14073"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#cdd3ff",
  d: "m5.506 4.928-.061.444a.29.29 0 0 1-.283.252h-.021a.29.29 0 0 1-.3-.286l-.01-.455a.292.292 0 0 1 .324-.3l.091.01a.29.29 0 0 1 .26.335",
  "data-name": "Path 14074"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 11317"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#leave_svg__b)",
  d: "M843.9 439.934a.108.108 0 0 1 .18-.079 1.55 1.55 0 0 1 .4.658q.182.415.337.841a8 8 0 0 1 .269.915 6.6 6.6 0 0 1 .5-1.073.1.1 0 0 1 .177.07c-.177.627-.394 1.242-.56 1.872a.2.2 0 0 1-.385-.044 7.2 7.2 0 0 0-.4-1.694c-.1-.262-.2-.52-.311-.776a1.5 1.5 0 0 1-.207-.69",
  "data-name": "Path 14075",
  transform: "translate(-827.291 -434.969)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#leave_svg__e)",
  d: "M788.025 447.391a.142.142 0 0 1 .081.271 1.635 1.635 0 0 0-.45 2.676 5.5 5.5 0 0 0 1.318.934 2.67 2.67 0 0 0 1.536.4c1.261-.127 1.432-1.41 1.055-2.4a3.54 3.54 0 0 0-2.09-2.04c-.123-.046-.075-.245.051-.2a4 4 0 0 1 2.122 1.777 2.44 2.44 0 0 1 .126 2.594 2.15 2.15 0 0 1-2.537.474 4.18 4.18 0 0 1-2.437-2.007 1.8 1.8 0 0 1 1.225-2.479",
  "data-name": "Path 14076",
  transform: "translate(-771.699 -441.961)"
})), /*#__PURE__*/React.createElement("circle", {
  cx: 0.511,
  cy: 0.511,
  r: 0.511,
  fill: "#f1f3ff",
  "data-name": "Ellipse 435",
  transform: "rotate(-45 14.413 -20.675)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 0.511,
  cy: 0.511,
  r: 0.511,
  fill: "#f1f3ff",
  "data-name": "Ellipse 436",
  transform: "translate(14.869 3.592)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 0.511,
  cy: 0.511,
  r: 0.511,
  fill: "#f1f3ff",
  "data-name": "Ellipse 437",
  transform: "rotate(-9.25 27.263 -63.854)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 0.511,
  cy: 0.511,
  r: 0.511,
  fill: "#f1f3ff",
  "data-name": "Ellipse 438",
  transform: "rotate(-22.5 11.865 -14.118)"
}), /*#__PURE__*/React.createElement("g", {
  fill: "url(#leave_svg__f)",
  "data-name": "Group 11318",
  transform: "translate(5.249)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.336.022c.859.188.778 2.448.709 3.366a.414.414 0 0 1-.413.383.212.212 0 0 1-.211-.235c.074-.694.232-2.691-.4-2.8 0 0-.454-.08-.53.8H0S.255-.214 1.336.022",
  "data-name": "Path 14077"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.519.139c.859.188.778 2.449.709 3.367a.414.414 0 0 1-.413.383.212.212 0 0 1-.211-.235c.074-.694.232-2.693-.4-2.8 0 0-.454-.063-.53.8h-.491S4.438-.097 5.519.139",
  "data-name": "Path 14078"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.703.255c.859.187.778 2.449.709 3.367a.414.414 0 0 1-.413.383.212.212 0 0 1-.211-.234c.074-.694.232-2.694-.4-2.8 0 0-.454-.051-.53.813l-.491-.017S8.622.022 9.703.255",
  "data-name": "Path 14079"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.882.39c.859.187.778 2.451.709 3.368a.415.415 0 0 1-.413.384.21.21 0 0 1-.211-.234c.074-.694.232-2.7-.4-2.8 0 0-.454-.066-.53.794h-.491S12.806.154 13.882.39",
  "data-name": "Path 14080"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 11324",
  transform: "translate(18.839 17.56)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#leave_svg__c)",
  d: "m547.439 815.467.093 2.9a.945.945 0 0 0 .941.913l6.956.041a.68.68 0 0 0 .68-.58 12.8 12.8 0 0 0 .091-3.278Z",
  "data-name": "Path 14082",
  transform: "translate(-547.285 -811.336)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#leave_svg__g)",
  d: "M562.119 818.86h-.051a.008.008 0 0 1 0-.017h.051a.008.008 0 1 1 0 .017m.118 0a.01.01 0 0 1-.009-.008.01.01 0 0 1 .008-.009l.05-.005a.01.01 0 0 1 .01.007.01.01 0 0 1-.007.009l-.051.005Zm-.287 0h-.05a.008.008 0 0 1 0-.017h.051a.008.008 0 1 1 0 .017Zm-.169 0h-.051a.008.008 0 0 1 0-.017h.051a.008.008 0 1 1 0 .017m-.169 0h-.051a.01.01 0 0 1-.008-.008.01.01 0 0 1 .009-.008h.05a.008.008 0 1 1 0 .017Zm-.169 0h-.051a.008.008 0 1 1 0-.017h.051a.01.01 0 0 1 .008.008.01.01 0 0 1-.008.005Zm-.169 0h-.051a.01.01 0 0 1-.008-.009.01.01 0 0 1 .008-.008h.051a.008.008 0 0 1 0 .017m-.169 0h-.051a.008.008 0 0 1 0-.017h.051a.008.008 0 0 1 0 .017m-.169 0h-.051a.01.01 0 0 1-.008-.008.01.01 0 0 1 .008-.008h.051a.008.008 0 1 1 0 .017Zm-.169 0h-.051a.01.01 0 0 1-.008-.008.01.01 0 0 1 .008-.008h.051a.008.008 0 1 1 0 .017Zm-.169 0h-.051a.008.008 0 1 1 0-.017h.051a.01.01 0 0 1 .008.009l-.006-.001Zm-.169 0h-.051a.008.008 0 0 1 0-.017h.051a.008.008 0 1 1 0 .017m-.169 0h-.051a.008.008 0 0 1 0-.017h.051a.008.008 0 1 1 0 .017m-.169 0h-.051a.008.008 0 0 1 0-.017h.051a.01.01 0 0 1 .008.009.01.01 0 0 1-.007-.004Zm-.169 0h-.051a.008.008 0 0 1 0-.017h.051a.008.008 0 0 1 0 .017m-.169 0h-.053a.01.01 0 0 1-.008-.008.01.01 0 0 1 .008-.008h.051a.008.008 0 0 1 0 .017Zm-.169 0h-.051a.01.01 0 0 1-.008-.008.01.01 0 0 1 .009-.008h.051a.01.01 0 0 1 .008.008.01.01 0 0 1-.008-.007Zm-.169 0h-.051a.01.01 0 0 1-.008-.008.01.01 0 0 1 .008-.008h.051a.008.008 0 0 1 0 .017Zm-.169 0h-.046a.01.01 0 0 1-.008-.009.01.01 0 0 1 .008-.008h.051a.008.008 0 1 1 0 .017Zm-.169 0h-.051a.008.008 0 0 1 0-.017h.051a.01.01 0 0 1 .008.009.01.01 0 0 1-.007-.01Zm-.169 0h-.051a.01.01 0 0 1-.008-.008.01.01 0 0 1 .009-.008h.051a.008.008 0 0 1 0 .017Zm-.169 0h-.051a.008.008 0 0 1 0-.017h.051a.01.01 0 0 1 .008.009.008.008 0 0 1-.006-.012Zm-.169 0h-.051a.008.008 0 1 1 0-.017h.051a.008.008 0 0 1 0 .017m-.169 0h-.051a.01.01 0 0 1-.008-.008.01.01 0 0 1 .008-.008h.051a.01.01 0 0 1 .008.008.01.01 0 0 1-.009-.013Zm-.169 0h-.051a.01.01 0 0 1-.008-.008.01.01 0 0 1 .008-.008h.051a.008.008 0 1 1 0 .017Zm-.169 0h-.051a.01.01 0 0 1-.008-.009.01.01 0 0 1 .008-.008h.051a.008.008 0 0 1 0 .017m-.169 0h-.051a.008.008 0 0 1 0-.017h.051a.01.01 0 0 1 .008.009.008.008 0 0 1-.002-.017Zm-.169 0h-.051a.01.01 0 0 1-.009-.009.01.01 0 0 1 .009-.008h.051a.01.01 0 0 1 .008.008.009.009 0 0 1-.006-.017Zm-.169 0h-.051a.008.008 0 0 1 0-.017h.051a.008.008 0 0 1 0 .017m-.169 0h-.051a.01.01 0 0 1-.008-.009.01.01 0 0 1 .008-.008h.051a.01.01 0 0 1 .008.009.008.008 0 0 1-.006-.02Zm-.169 0h-.051a.01.01 0 0 1-.008-.008.01.01 0 0 1 .009-.008h.051a.01.01 0 0 1 .008.009.008.008 0 0 1-.006-.022Zm-.169 0H557a.01.01 0 0 1-.008-.008.01.01 0 0 1 .008-.008h.051a.01.01 0 0 1 .008.008.009.009 0 0 1-.007-.021Zm-.169 0h-.051a.01.01 0 0 1-.008-.009.01.01 0 0 1 .009-.008h.051a.01.01 0 0 1 .008.009.008.008 0 0 1-.006-.023Zm-.169 0h-.051a.008.008 0 0 1 0-.017h.051a.008.008 0 1 1 0 .017m5.688 0a.01.01 0 0 1-.008-.006.01.01 0 0 1 .005-.011l.047-.018a.01.01 0 0 1 .011 0 .01.01 0 0 1 0 .011l-.048.018Zm-5.857 0h-.051a.01.01 0 0 1-.008-.008.01.01 0 0 1 .008-.008h.051a.008.008 0 1 1 0 .017Zm-.169 0h-.051a.008.008 0 0 1 0-.017h.051a.008.008 0 1 1 0 .017m-.169 0h-.051a.01.01 0 0 1-.008-.008.01.01 0 0 1 .008-.008h.051a.008.008 0 0 1 0 .017Zm-.169 0h-.051a.008.008 0 1 1 0-.017h.051a.01.01 0 0 1 .008.008.008.008 0 0 1-.005-.027Zm-.169 0h-.051a.008.008 0 1 1 0-.017h.051a.01.01 0 0 1 .008.008.008.008 0 0 1-.005-.028Zm-.169 0h-.051a.008.008 0 1 1 0-.017h.051a.009.009 0 0 1 0 .017m-.169 0h-.051a.008.008 0 1 1 0-.017h.05a.01.01 0 0 1 .008.009.009.009 0 0 1-.003-.031Zm-.167-.024-.049-.013a.01.01 0 0 1-.005-.01.01.01 0 0 1 .01-.006l.048.013a.008.008 0 0 1 0 .017Zm7.189-.042h-.007a.01.01 0 0 1 0-.012l.041-.029a.01.01 0 0 1 .012 0 .01.01 0 0 1 0 .012l-.042.03Zm-7.349-.013-.046-.022a.008.008 0 0 1 .008-.015l.045.022a.01.01 0 0 1 0 .011.008.008 0 0 1-.003-.035Zm-.146-.083-.041-.03a.01.01 0 0 1 0-.012.01.01 0 0 1 .012 0l.04.03a.008.008 0 0 1 0 .015Zm7.623-.014h-.006a.01.01 0 0 1 0-.012l.032-.039a.01.01 0 0 1 .012 0 .01.01 0 0 1 0 .012l-.033.039a.009.009 0 0 1-.001-.04Zm-7.751-.1h-.006l-.035-.038a.01.01 0 0 1 0-.012.01.01 0 0 1 .012 0l.034.037a.01.01 0 0 1 0 .012Zm7.846-.044a.01.01 0 0 1 0-.011l.021-.046a.009.009 0 0 1 .016.006l-.021.047a.009.009 0 0 1-.012-.03Zm-7.952-.088h-.007q-.014-.022-.027-.043a.008.008 0 1 1 .015-.009l.027.043a.01.01 0 0 1 0 .012Zm8.008-.071a.01.01 0 0 1-.006-.01q-.002-.018.007-.038v-.012a.01.01 0 0 1 .009-.007.01.01 0 0 1 .007.01v.012q.002.02-.007.039a.008.008 0 0 1-.006-.028Zm-8.088-.078a.01.01 0 0 1-.008-.005l-.018-.048a.01.01 0 0 1 .005-.011.01.01 0 0 1 .011.005l.018.047a.01.01 0 0 1 0 .011Zm8.113-.089a.01.01 0 0 1-.007-.009l.007-.05a.01.01 0 0 1 .01-.007.01.01 0 0 1 .007.009q.002.026-.007.05a.009.009 0 0 1-.006-.027Zm-8.163-.072a.01.01 0 0 1-.008-.007c0-.017-.006-.034-.009-.05a.01.01 0 0 1 .007-.01.01.01 0 0 1 .01.007q.001.025.009.049a.01.01 0 0 1-.007.01Zm8.185-.1a.01.01 0 0 1-.007-.009l.006-.05a.008.008 0 0 1 .017 0l-.006.05a.008.008 0 0 1-.006-.021Zm-8.2-.072a.01.01 0 0 1-.008-.008v-.051a.01.01 0 0 1 .008-.009.01.01 0 0 1 .009.008v.051a.01.01 0 0 1-.008.009Zm8.225-.1a.01.01 0 0 1-.007-.009l.006-.05a.01.01 0 0 1 .009-.007.01.01 0 0 1 .007.009l-.006.05a.008.008 0 0 1-.01-.018Zm-8.23-.073a.01.01 0 0 1-.008-.008v-.051a.01.01 0 0 1 .008-.009.01.01 0 0 1 .009.008v.051a.01.01 0 0 1-.008.009Zm8.248-.095a.01.01 0 0 1-.008-.009l.005-.05a.01.01 0 0 1 .009-.008.01.01 0 0 1 .008.009l-.005.05a.008.008 0 0 1-.009-.017Zm-8.254-.074a.01.01 0 0 1-.008-.008v-.051a.008.008 0 0 1 .017 0v.051a.01.01 0 0 1-.008.009Zm8.27-.094a.01.01 0 0 1-.008-.009v-.05a.01.01 0 0 1 .009-.008.01.01 0 0 1 .008.009v.05a.008.008 0 0 1-.008-.017Zm-8.276-.075a.01.01 0 0 1-.008-.008v-.051a.01.01 0 0 1 .008-.009.01.01 0 0 1 .009.008v.051a.01.01 0 0 1-.008.009Zm8.291-.094a.01.01 0 0 1-.008-.009v-.05a.009.009 0 0 1 .017 0v.05a.008.008 0 0 1-.009-.016Zm-8.3-.075a.01.01 0 0 1-.008-.008v-.051a.01.01 0 0 1 .008-.009.01.01 0 0 1 .009.008v.051a.01.01 0 0 1-.008.009Zm8.308-.093a.01.01 0 0 1-.008-.009v-.051a.01.01 0 0 1 .009-.008.01.01 0 0 1 .008.009v.051a.008.008 0 0 1-.004-.017Zm-8.314-.076a.01.01 0 0 1-.008-.008v-.051a.01.01 0 0 1 .008-.009.01.01 0 0 1 .009.008v.051a.01.01 0 0 1-.008.009Zm8.324-.093a.01.01 0 0 1-.008-.009v-.051a.01.01 0 0 1 .009-.008.01.01 0 0 1 .008.009v.051a.008.008 0 0 1-.004-.02Zm-8.33-.076a.01.01 0 0 1-.008-.008v-.051a.01.01 0 0 1 .008-.009.01.01 0 0 1 .009.008v.051a.01.01 0 0 1-.008.009Zm8.338-.093a.01.01 0 0 1-.008-.009v-.051a.008.008 0 1 1 .017 0v.051a.008.008 0 0 1-.003-.016Zm-8.344-.076a.01.01 0 0 1-.009-.008v-.051a.01.01 0 0 1 .008-.009.01.01 0 0 1 .009.008v.051a.01.01 0 0 1-.008.009m8.35-.093a.01.01 0 0 1-.008-.009v-.051a.01.01 0 0 1 .009-.008.01.01 0 0 1 .008.009v.051a.008.008 0 0 1-.003-.016Zm-8.355-.076a.01.01 0 0 1-.008-.008v-.051a.01.01 0 0 1 .008-.009.01.01 0 0 1 .009.008v.051a.01.01 0 0 1-.008.009Zm8.359-.093a.01.01 0 0 1-.008-.009v-.051a.01.01 0 0 1 .009-.008.01.01 0 0 1 .008.009v.051a.01.01 0 0 1-.003-.013Zm-8.364-.076a.01.01 0 0 1-.008-.008v-.051a.01.01 0 0 1 .008-.009.01.01 0 0 1 .009.008v.051a.01.01 0 0 1-.008.009Zm8.366-.093a.01.01 0 0 1-.008-.008v-.047a.01.01 0 0 1 .008-.008.01.01 0 0 1 .008.008v.051a.008.008 0 0 1-.003-.02Zm-8.371-.076a.01.01 0 0 1-.008-.008v-.051a.01.01 0 0 1 .008-.009.01.01 0 0 1 .009.008v.051a.01.01 0 0 1-.008.009Zm8.37-.093a.01.01 0 0 1-.009-.008v-.051a.01.01 0 0 1 .008-.009.01.01 0 0 1 .009.008v.051a.01.01 0 0 1-.008.009m-8.375-.076a.01.01 0 0 1-.009-.008v-.051a.008.008 0 1 1 .017 0v.051a.01.01 0 0 1-.008.009Zm8.371-.093a.01.01 0 0 1-.009-.008v-.051a.008.008 0 1 1 .017 0v.051a.01.01 0 0 1-.008.009Zm-8.377-.076a.01.01 0 0 1-.008-.008v-.051a.01.01 0 0 1 .008-.009.01.01 0 0 1 .009.008v.051a.01.01 0 0 1-.008.009Zm8.37-.093a.01.01 0 0 1-.008-.008v-.051a.01.01 0 0 1 .008-.009.01.01 0 0 1 .009.008v.051a.01.01 0 0 1-.008.009Zm-8.375-.076a.01.01 0 0 1-.008-.008v-.051a.01.01 0 0 1 .008-.009.01.01 0 0 1 .009.008v.051a.01.01 0 0 1-.008.009Zm8.365-.093a.01.01 0 0 1-.008-.008v-.05a.01.01 0 0 1 .008-.009.01.01 0 0 1 .009.008v.051a.01.01 0 0 1-.008.009Zm-8.371-.076a.01.01 0 0 1-.009-.008v-.051a.008.008 0 0 1 .017 0v.051a.01.01 0 0 1-.008.009Zm8.358-.093a.01.01 0 0 1-.008-.008v-.05a.008.008 0 1 1 .017 0v.05a.01.01 0 0 1-.008.009Zm-8.363-.076a.01.01 0 0 1-.008-.008v-.051a.01.01 0 0 1 .008-.009.01.01 0 0 1 .009.008v.051a.01.01 0 0 1-.008.009Zm8.347-.092a.01.01 0 0 1-.008-.007l-.006-.05a.01.01 0 0 1 .007-.009.01.01 0 0 1 .009.007q-.001.026.006.05a.01.01 0 0 1-.008.009m-8.352-.077a.01.01 0 0 1-.009-.008v-.059h.031a.008.008 0 0 1 0 .017h-.007v.042a.01.01 0 0 1-.008.009Zm8.3-.051h-.051a.008.008 0 1 1 0-.017h.051a.008.008 0 0 1 0 .017m-.169 0h-.051a.008.008 0 0 1 0-.017h.051a.008.008 0 1 1 0 .017m-.169 0h-.047a.008.008 0 0 1 0-.017h.051a.008.008 0 1 1 0 .017Zm-.169 0h-.051a.008.008 0 1 1 0-.017h.051a.008.008 0 1 1 0 .017m-.169 0h-.051a.008.008 0 1 1 0-.017h.051a.008.008 0 1 1 0 .017m-.169 0h-.051a.008.008 0 0 1 0-.017h.051a.008.008 0 0 1 0 .017m-.169 0h-.051a.008.008 0 1 1 0-.017h.051a.008.008 0 0 1 0 .017m-.169 0h-.051a.008.008 0 1 1 0-.017h.051a.008.008 0 0 1 0 .017m-.169 0h-.051a.008.008 0 1 1 0-.017h.051a.008.008 0 1 1 0 .017m-.169 0h-.051a.008.008 0 1 1 0-.017h.051a.008.008 0 0 1 0 .017m-.169 0h-.051a.008.008 0 0 1 0-.017h.051a.008.008 0 1 1 0 .017m-.169 0h-.051a.008.008 0 0 1 0-.017h.051a.008.008 0 0 1 0 .017m-.169 0h-.051a.008.008 0 1 1 0-.017h.051a.008.008 0 1 1 0 .017m-.169 0h-.051a.008.008 0 0 1 0-.017h.051a.008.008 0 0 1 0 .017m-.169 0h-.051a.008.008 0 1 1 0-.017h.051a.008.008 0 0 1 0 .017m-.169 0h-.05a.008.008 0 1 1 0-.017h.051a.008.008 0 0 1 0 .017Zm-.169 0h-.051a.008.008 0 1 1 0-.017h.051a.008.008 0 1 1 0 .017m-.169 0h-.051a.008.008 0 0 1 0-.017h.051a.008.008 0 0 1 0 .017m-.169 0h-.051a.008.008 0 0 1 0-.017h.051a.008.008 0 1 1 0 .017m-.169 0h-.051a.008.008 0 0 1 0-.017h.051a.008.008 0 0 1 0 .017m-.169 0h-.051a.008.008 0 1 1 0-.017h.051a.008.008 0 1 1 0 .017m-.169 0h-.051a.008.008 0 0 1 0-.017h.051a.008.008 0 0 1 0 .017m-.169 0h-.051a.008.008 0 0 1 0-.017h.051a.008.008 0 0 1 0 .017m-.169 0h-.051a.008.008 0 1 1 0-.017H559a.008.008 0 1 1 0 .017Zm-.169 0h-.051a.008.008 0 1 1 0-.017h.051a.008.008 0 1 1 0 .017m-.169 0h-.051a.008.008 0 0 1 0-.017h.051a.008.008 0 0 1 0 .017m-.169 0h-.051a.008.008 0 0 1 0-.017h.051a.008.008 0 1 1 0 .017m-.169 0h-.051a.008.008 0 0 1 0-.017h.051a.008.008 0 0 1 0 .017m-.169 0h-.051a.008.008 0 1 1 0-.017h.051a.008.008 0 1 1 0 .017m-.169 0h-.051a.008.008 0 1 1 0-.017h.051a.008.008 0 0 1 0 .017m-.169 0h-.051a.008.008 0 1 1 0-.017h.051a.008.008 0 0 1 0 .017m-.169 0h-.046a.008.008 0 1 1 0-.017h.051a.008.008 0 0 1 0 .017Zm-.169 0h-.051a.008.008 0 1 1 0-.017h.051a.008.008 0 1 1 0 .017m-.169 0h-.051a.008.008 0 0 1 0-.017h.051a.008.008 0 0 1 0 .017m-.169 0h-.051a.008.008 0 0 1 0-.017h.051a.008.008 0 1 1 0 .017m-.169 0h-.051a.008.008 0 0 1 0-.017h.051a.008.008 0 0 1 0 .017m-.169 0h-.051a.008.008 0 1 1 0-.017h.051a.008.008 0 1 1 0 .017m-.169 0h-.051a.008.008 0 1 1 0-.017h.051a.008.008 0 0 1 0 .017m-.169 0h-.051a.008.008 0 0 1 0-.017h.051a.008.008 0 0 1 0 .017m-.169 0h-.051a.008.008 0 0 1 0-.017h.051a.008.008 0 1 1 0 .017m-.169 0h-.051a.008.008 0 1 1 0-.017h.051a.008.008 0 1 1 0 .017m-.169 0h-.051a.008.008 0 0 1 0-.017h.051a.008.008 0 0 1 0 .017m-.169 0h-.051a.008.008 0 0 1 0-.017h.051a.008.008 0 0 1 0 .017m-.169 0h-.051a.008.008 0 0 1 0-.017h.051a.008.008 0 1 1 0 .017m-.169 0h-.049a.008.008 0 1 1 0-.017h.051a.008.008 0 1 1 0 .017Zm-.169 0h-.051a.008.008 0 1 1 0-.017h.051a.008.008 0 0 1 0 .017m-.169 0h-.051a.008.008 0 0 1 0-.017h.051a.008.008 0 0 1 0 .017m-.169 0h-.042a.008.008 0 1 1 0-.017h.051a.008.008 0 0 1 0 .017Zm-.169 0h-.051a.008.008 0 0 1 0-.017h.051a.008.008 0 1 1 0 .017",
  "data-name": "Path 14083",
  transform: "translate(-554.22 -811.049)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#leave_svg__h)",
  d: "m618.552 729.656.021-.224a.17.17 0 0 1 .131-.1 1.6 1.6 0 0 1 1.013.1l.039.26Z",
  "data-name": "Path 14084",
  transform: "translate(-616.359 -727.633)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#leave_svg__i)",
  d: "M633.584 706.166a.3.3 0 0 1-.15 0 .14.14 0 0 1-.1-.131v-.7h.357v.7a.136.136 0 0 1-.107.131",
  "data-name": "Path 14085",
  transform: "translate(-630.715 -704.359)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#leave_svg__j)",
  d: "m739.171 729.656.021-.224a.17.17 0 0 1 .131-.1 1.6 1.6 0 0 1 1.013.1l.039.26Z",
  "data-name": "Path 14086",
  transform: "translate(-733.52 -727.633)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#leave_svg__k)",
  d: "M754.2 703.662a.3.3 0 0 1-.15 0 .14.14 0 0 1-.1-.131v-.776h.357v.775a.136.136 0 0 1-.107.132",
  "data-name": "Path 14087",
  transform: "translate(-747.876 -701.855)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#leave_svg__l)",
  d: "m625.781 672.509 3.839-.127a.185.185 0 0 0 .177-.152 1.6 1.6 0 0 0 .012-.487.44.44 0 0 0-.429-.375 11.1 11.1 0 0 0-3.545.381.35.35 0 0 0-.212.244.85.85 0 0 0-.009.39.165.165 0 0 0 .167.126",
  "data-name": "Path 14088",
  transform: "translate(-623.2 -671.363)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#leave_svg__g)",
  d: "M629.076 680.487a.02.02 0 0 1-.017-.015.9.9 0 0 1 .023-.289.32.32 0 0 1 .218-.222 4.2 4.2 0 0 1 .957-.179.017.017 0 0 1 0 .034 4.2 4.2 0 0 0-.948.177.29.29 0 0 0-.195.2.9.9 0 0 0-.022.277.02.02 0 0 1-.015.019Z",
  "data-name": "Path 14089",
  transform: "translate(-626.562 -679.54)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#leave_svg__m)",
  d: "M542.483 738.173c1.24-.016 6.606-.072 8.165.116a.32.32 0 0 1 .273.246 10.5 10.5 0 0 1 .255 2.342.28.28 0 0 1-.228.265l-3.558.673h-1.264l-3.791-.753a.3.3 0 0 1-.239-.275 12.3 12.3 0 0 1 .067-2.343.33.33 0 0 1 .32-.271",
  "data-name": "Path 14090",
  transform: "translate(-542.072 -736.238)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#leave_svg__g)",
  d: "M557.461 751.618h-.051a.008.008 0 1 1 0-.017h.051a.008.008 0 0 1 0 .017m-.169 0h-.051a.008.008 0 1 1 0-.017h.051a.008.008 0 0 1 0 .017m-.169 0h-.051a.008.008 0 1 1 0-.017h.051a.008.008 0 0 1 0 .017m-.169 0h-.054a.008.008 0 0 1 0-.017h.051a.008.008 0 0 1 0 .017Zm-.169 0h-.051a.008.008 0 0 1 0-.017h.051a.008.008 0 0 1 0 .017m-.169 0h-.051a.008.008 0 1 1 0-.017h.051a.008.008 0 1 1 0 .017m-.169 0h-.047a.008.008 0 0 1 0-.017h.051a.008.008 0 0 1 0 .017Zm-.169 0h-.022l-.051-.01a.01.01 0 0 1-.007-.01.01.01 0 0 1 .01-.007l.05.01h.02a.008.008 0 1 1 0 .017m1.3-.022a.01.01 0 0 1-.008-.007.01.01 0 0 1 .007-.01l.05-.009a.009.009 0 0 1 0 .017zm-1.486-.011-.05-.01a.01.01 0 0 1-.007-.01.01.01 0 0 1 .01-.007l.05.01a.008.008 0 0 1 0 .017Zm1.652-.02a.01.01 0 0 1-.008-.007.01.01 0 0 1 .007-.01l.05-.009a.01.01 0 0 1 .01.007.01.01 0 0 1-.007.01l-.05.01Zm-1.818-.013-.05-.01a.01.01 0 0 1-.007-.01.01.01 0 0 1 .01-.007l.05.01a.01.01 0 0 1 .007.01.01.01 0 0 1-.01.007m1.984-.019a.008.008 0 0 1 0-.017l.05-.009a.008.008 0 1 1 0 .017zm-2.149-.014-.05-.01a.01.01 0 0 1-.007-.01.01.01 0 0 1 .01-.007l.05.01a.008.008 0 0 1 0 .017Zm2.315-.017a.008.008 0 0 1 0-.017l.05-.009a.01.01 0 0 1 .01.007.01.01 0 0 1-.007.01l-.05.009Zm-2.481-.016-.05-.01a.01.01 0 0 1-.007-.01.01.01 0 0 1 .01-.007l.05.01a.008.008 0 0 1 0 .017Zm2.647-.016a.01.01 0 0 1-.008-.007.01.01 0 0 1 .007-.01l.05-.009a.008.008 0 1 1 0 .016zm-2.813-.017-.05-.01a.01.01 0 0 1-.007-.01.01.01 0 0 1 .01-.007l.05.01a.008.008 0 0 1 0 .017Zm2.979-.014a.01.01 0 0 1-.008-.007.01.01 0 0 1 .007-.01l.05-.009a.008.008 0 1 1 0 .017zm-3.144-.019-.05-.01a.008.008 0 0 1 0-.017l.05.01a.008.008 0 0 1 0 .017m3.31-.013a.01.01 0 0 1-.008-.007.01.01 0 0 1 .007-.01l.05-.009a.008.008 0 0 1 0 .017zm-3.476-.02-.05-.01a.008.008 0 0 1 0-.017l.05.01a.008.008 0 0 1 0 .017m3.642-.011a.008.008 0 0 1 0-.017l.05-.01a.008.008 0 0 1 0 .017zm-3.808-.022-.05-.01a.008.008 0 0 1 0-.017l.05.01a.01.01 0 0 1 .007.01.01.01 0 0 1-.007.008Zm3.974-.01a.009.009 0 0 1 0-.017l.05-.009a.008.008 0 1 1 0 .017zm-4.139-.023-.05-.01a.01.01 0 0 1-.007-.01.01.01 0 0 1 .01-.007l.05.01a.008.008 0 0 1 0 .017Zm4.305-.008a.01.01 0 0 1-.008-.007.01.01 0 0 1 .007-.01l.05-.01a.01.01 0 0 1 .01.007.01.01 0 0 1-.007.01l-.05.009Zm-4.471-.025-.05-.01a.01.01 0 0 1-.007-.01.01.01 0 0 1 .01-.007l.05.01a.01.01 0 0 1 .007.01.01.01 0 0 1-.011.008Zm4.637-.007a.01.01 0 0 1-.008-.007.01.01 0 0 1 .007-.01l.05-.009a.01.01 0 0 1 .01.007.01.01 0 0 1-.007.01l-.05.009Zm-4.8-.026-.05-.01a.01.01 0 0 1-.007-.01.01.01 0 0 1 .01-.007l.05.01a.01.01 0 0 1 .007.01.01.01 0 0 1-.013.008Zm4.968-.005a.01.01 0 0 1-.008-.007.01.01 0 0 1 .007-.01l.05-.009a.01.01 0 0 1 .01.007.01.01 0 0 1-.007.01l-.05.009Zm-5.134-.028-.05-.01a.008.008 0 1 1 0-.017l.05.01a.01.01 0 0 1 .007.01.01.01 0 0 1-.01.008Zm5.3 0a.008.008 0 0 1 0-.017l.05-.01a.01.01 0 0 1 .01.007.01.01 0 0 1-.007.01l-.05.009Zm-5.466-.029-.05-.01a.01.01 0 0 1-.006-.01.01.01 0 0 1 .01-.007l.05.01a.01.01 0 0 1 .007.01.008.008 0 0 1-.017.004Zm5.632 0a.008.008 0 0 1 0-.017l.05-.01a.009.009 0 1 1 0 .017zm-5.8-.031-.05-.01a.01.01 0 0 1-.007-.01.01.01 0 0 1 .01-.007l.05.01a.01.01 0 0 1 .007.01.01.01 0 0 1-.01.002Zm5.963 0a.008.008 0 0 1 0-.017l.05-.01a.008.008 0 0 1 0 .017zm.166-.031a.01.01 0 0 1-.008-.007.01.01 0 0 1 .007-.01l.05-.009a.008.008 0 1 1 0 .017zm-6.295 0-.05-.01a.01.01 0 0 1-.007-.01.01.01 0 0 1 .01-.007l.05.01a.008.008 0 0 1 0 .017Zm6.461-.03a.008.008 0 0 1 0-.017l.05-.009a.01.01 0 0 1 .01.007.01.01 0 0 1-.007.01l-.05.009Zm-6.627 0-.05-.01a.01.01 0 0 1-.007-.01.01.01 0 0 1 .01-.007l.05.01a.01.01 0 0 1 .007.01.01.01 0 0 1-.01-.003Zm6.792-.029a.008.008 0 0 1 0-.017l.05-.009a.008.008 0 0 1 0 .017zm-6.958 0-.05-.01a.01.01 0 0 1-.007-.01.01.01 0 0 1 .01-.007l.05.01a.008.008 0 0 1 0 .017Zm7.124-.027a.008.008 0 0 1 0-.017l.05-.009a.01.01 0 0 1 .01.007.01.01 0 0 1-.007.01l-.05.009Zm-7.29-.006-.05-.01a.01.01 0 0 1-.007-.01.01.01 0 0 1 .01-.007l.05.01a.008.008 0 0 1 0 .017Zm7.456-.026a.008.008 0 0 1 0-.017l.05-.009a.008.008 0 1 1 0 .017zm-7.621-.007-.05-.01a.01.01 0 0 1-.007-.01.01.01 0 0 1 .01-.007l.05.01a.008.008 0 0 1 0 .017Zm7.787-.024a.01.01 0 0 1-.008-.007.01.01 0 0 1 .007-.01l.05-.009a.01.01 0 0 1 .01.007.01.01 0 0 1-.007.01l-.05.009Zm-7.953-.009-.05-.01a.01.01 0 0 1-.007-.01.01.01 0 0 1 .01-.007l.05.01a.008.008 0 0 1 0 .017Zm-.166-.033-.05-.01a.01.01 0 0 1-.007-.01.01.01 0 0 1 .01-.007l.05.01a.008.008 0 0 1 0 .017Zm-.166-.033-.05-.01a.01.01 0 0 1-.007-.01.01.01 0 0 1 .01-.007l.05.01a.01.01 0 0 1 .007.01.01.01 0 0 1-.009-.006Zm8.359-.034a.01.01 0 0 1-.008-.008v-.065a.01.01 0 0 1 .009-.009.01.01 0 0 1 .008.008v.051a.01.01 0 0 1-.008.01Zm-8.472-.045a.01.01 0 0 1-.008-.008v-.051a.01.01 0 0 1 .008-.009.01.01 0 0 1 .009.008v.05a.01.01 0 0 1-.008.009Zm8.47-.124a.01.01 0 0 1-.008-.008v-.051a.01.01 0 0 1 .008-.009.01.01 0 0 1 .009.008v.051a.01.01 0 0 1-.008.009Zm-8.477-.045a.01.01 0 0 1-.008-.008v-.051a.01.01 0 0 1 .008-.009.01.01 0 0 1 .009.008v.051a.01.01 0 0 1-.008.009Zm8.472-.124a.01.01 0 0 1-.009-.008v-.05a.01.01 0 0 1 .008-.009.01.01 0 0 1 .009.008v.05a.01.01 0 0 1-.008.009m-8.478-.045a.01.01 0 0 1-.008-.008v-.051a.008.008 0 0 1 .017 0v.051a.01.01 0 0 1-.008.009Zm8.469-.124a.01.01 0 0 1-.009-.008v-.05a.01.01 0 0 1 .008-.009.01.01 0 0 1 .009.008v.051a.01.01 0 0 1-.008.009Zm-8.474-.045a.01.01 0 0 1-.008-.008v-.051a.01.01 0 0 1 .008-.009.01.01 0 0 1 .009.008v.051a.01.01 0 0 1-.008.009Zm8.462-.123a.01.01 0 0 1-.008-.008v-.05a.01.01 0 0 1 .008-.009.01.01 0 0 1 .009.008v.051a.01.01 0 0 1-.008.009Zm-8.465-.046a.01.01 0 0 1-.009-.008v-.051a.01.01 0 0 1 .008-.008.01.01 0 0 1 .009.008v.051a.01.01 0 0 1-.008.009Zm8.45-.122a.01.01 0 0 1-.008-.008l-.005-.05a.008.008 0 1 1 .017 0l.005.05a.01.01 0 0 1-.008.009Zm-8.451-.047a.01.01 0 0 1-.009-.008v-.051a.01.01 0 0 1 .009-.008.01.01 0 0 1 .008.008v.051a.01.01 0 0 1-.008.008m8.433-.122a.01.01 0 0 1-.008-.007l-.006-.05a.01.01 0 0 1 .007-.009.01.01 0 0 1 .009.007l.006.05a.01.01 0 0 1-.007.009Zm-8.432-.047a.01.01 0 0 1-.008-.009v-.051a.01.01 0 0 1 .009-.009.01.01 0 0 1 .008.009v.051a.01.01 0 0 1-.007-.005Zm8.412-.12a.01.01 0 0 1-.008-.007q.002-.026-.007-.05a.01.01 0 0 1 .007-.01.01.01 0 0 1 .009.007l.007.05a.01.01 0 0 1-.007.009Zm-8.409-.048a.01.01 0 0 1-.008-.009v-.051a.01.01 0 0 1 .008-.008.01.01 0 0 1 .008.009v.051a.01.01 0 0 1-.006-.005Zm8.386-.119a.01.01 0 0 1-.008-.007l-.007-.05a.01.01 0 0 1 .007-.01.01.01 0 0 1 .01.007l.007.05a.01.01 0 0 1-.007.01Zm-8.381-.05a.01.01 0 0 1-.008-.009v-.051a.008.008 0 1 1 .017 0v.051a.01.01 0 0 1-.008-.004Zm8.356-.117a.01.01 0 0 1-.008-.007l-.008-.05a.008.008 0 1 1 .016 0c0 .016.006.033.008.05a.01.01 0 0 1-.007.01Zm-8.348-.052a.01.01 0 0 1-.008-.009v-.051a.008.008 0 0 1 .017 0v.051l-.008.001Zm8.32-.115a.01.01 0 0 1-.008-.007l-.009-.05a.008.008 0 0 1 .017 0l.009.05a.01.01 0 0 1-.007.01Zm-8.31-.054a.01.01 0 0 1-.008-.009v-.051a.008.008 0 0 1 .017 0v.051a.01.01 0 0 1-.012-.004Zm8.279-.112a.01.01 0 0 1-.008-.007l-.01-.05a.01.01 0 0 1 .007-.01.01.01 0 0 1 .01.007l.01.05a.01.01 0 0 1-.007.01Zm-8.265-.056a.01.01 0 0 1-.008-.009q-.001-.026.005-.05a.01.01 0 0 1 .009-.008.01.01 0 0 1 .008.009q.001.025-.005.05a.01.01 0 0 1-.007-.005Zm8.232-.11a.01.01 0 0 1-.008-.007l-.01-.05a.008.008 0 0 1 .016 0l.01.05a.01.01 0 0 1-.007.01Zm-8.213-.058a.01.01 0 0 1-.007-.01l.007-.05a.008.008 0 0 1 .017 0q.002.025-.007.05a.01.01 0 0 1-.008-.003Zm8.159-.089-.05-.006a.008.008 0 1 1 0-.017l.05.006a.01.01 0 0 1 .007.009l-.002-.006Zm-.168-.017h-.05a.008.008 0 1 1 0-.017h.05a.01.01 0 0 1 .008.009.01.01 0 0 1-.007-.006Zm-.168-.014h-.05a.01.01 0 0 1-.008-.009.01.01 0 0 1 .009-.008h.051a.008.008 0 0 1 0 .017Zm-.169-.012h-.051a.01.01 0 0 1-.008-.009.01.01 0 0 1 .009-.008h.051a.01.01 0 0 1 .008.009.01.01 0 0 1-.007-.006Zm-.169-.01h-.051a.01.01 0 0 1-.008-.009.01.01 0 0 1 .009-.008h.051a.01.01 0 0 1 .008.009.01.01 0 0 1-.007-.006Zm-.169-.009h-.051a.008.008 0 0 1 0-.017h.051a.01.01 0 0 1 .008.009.01.01 0 0 1-.006-.006Zm-.169-.008h-.051a.01.01 0 0 1-.008-.009.01.01 0 0 1 .009-.008h.051a.01.01 0 0 1 .008.009.01.01 0 0 1-.006-.006Zm-.169-.007h-.051a.008.008 0 1 1 0-.017h.051a.008.008 0 0 1 0 .017m-6.954 0a.01.01 0 0 1-.007-.01v-.016a.03.03 0 0 1 .029-.025.01.01 0 0 1 .009.008.01.01 0 0 1-.008.008.013.013 0 0 0-.013.011v.016a.01.01 0 0 1-.007-.006Zm6.785-.006h-.051a.008.008 0 0 1 0-.017h.051a.008.008 0 0 1 0 .017m-.169-.006h-.051a.01.01 0 0 1-.008-.009.01.01 0 0 1 .009-.008h.051a.008.008 0 0 1 0 .017Zm-.169-.005h-.051a.008.008 0 0 1 0-.017h.051a.01.01 0 0 1 .008.008l-.005-.005Zm-.169 0h-.051a.01.01 0 0 1-.008-.009.01.01 0 0 1 .009-.008h.051a.01.01 0 0 1 .008.009.01.01 0 0 1-.005-.012Zm-.169 0h-.051a.01.01 0 0 1-.008-.009.01.01 0 0 1 .009-.008h.051a.01.01 0 0 1 .008.008.01.01 0 0 1-.005-.011Zm-.169 0h-.051a.01.01 0 0 1-.008-.009.01.01 0 0 1 .009-.008h.051a.008.008 0 0 1 0 .017Zm-.169 0h-.051a.01.01 0 0 1-.008-.009.01.01 0 0 1 .009-.008h.051a.008.008 0 0 1 0 .017Zm-5.625 0a.008.008 0 0 1 0-.017h.051a.01.01 0 0 1 .009.008.01.01 0 0 1-.008.009h-.051Zm5.456 0h-.051a.008.008 0 1 1 0-.017h.051a.008.008 0 0 1 0 .017m-5.287 0a.008.008 0 1 1 0-.017h.051a.01.01 0 0 1 .008.008.01.01 0 0 1-.008.009zm5.119 0h-.051a.01.01 0 0 1-.008-.008.01.01 0 0 1 .009-.008H558a.008.008 0 0 1 0 .017Zm-4.95 0a.01.01 0 0 1-.008-.008.01.01 0 0 1 .008-.009h.051a.01.01 0 0 1 .009.008.01.01 0 0 1-.008.008h-.051Zm.169 0a.01.01 0 0 1-.009-.008.01.01 0 0 1 .008-.009h.051a.009.009 0 0 1 0 .017Zm4.612 0h-.051a.01.01 0 0 1-.008-.009.01.01 0 0 1 .008-.008h.051a.01.01 0 0 1 .008.009.008.008 0 0 1-.005-.03Zm-4.443 0a.008.008 0 1 1 0-.017h.051a.01.01 0 0 1 .009.009.01.01 0 0 1-.008.008h-.051Zm4.274 0h-.051a.01.01 0 0 1-.008-.009.01.01 0 0 1 .008-.008h.051a.008.008 0 0 1 0 .017m-4.1 0a.01.01 0 0 1-.008-.008.01.01 0 0 1 .008-.009h.051a.008.008 0 0 1 0 .017zm3.936 0h-.051a.01.01 0 0 1-.008-.009.01.01 0 0 1 .009-.008h.051a.008.008 0 0 1 0 .017Zm-3.767 0a.01.01 0 0 1-.008-.008.01.01 0 0 1 .008-.009h.051a.01.01 0 0 1 .008.008.01.01 0 0 1-.008.009zm.169 0a.01.01 0 0 1-.008-.008.01.01 0 0 1 .008-.008h.051a.01.01 0 0 1 .008.008.01.01 0 0 1-.008.009h-.051Zm3.429 0h-.051a.009.009 0 0 1 0-.017h.051a.008.008 0 0 1 0 .017m-3.26 0a.008.008 0 1 1 0-.017h.051a.008.008 0 0 1 0 .017Zm3.091 0h-.054a.008.008 0 0 1 0-.017h.051a.01.01 0 0 1 .008.008.009.009 0 0 1-.006-.037Zm-2.922 0a.008.008 0 1 1 0-.017h.051a.01.01 0 0 1 .008.008.01.01 0 0 1-.008.009Zm2.753 0h-.051a.01.01 0 0 1-.008-.008.01.01 0 0 1 .009-.009h.051a.01.01 0 0 1 .008.009.009.009 0 0 1-.01-.039Zm-2.584 0a.008.008 0 0 1 0-.017h.051a.008.008 0 0 1 0 .017zm2.415 0h-.051a.01.01 0 0 1-.008-.008.01.01 0 0 1 .009-.008h.051a.01.01 0 0 1 .008.008.008.008 0 0 1-.01-.04Zm-2.247 0a.01.01 0 0 1-.008-.008.01.01 0 0 1 .008-.008h.051a.008.008 0 1 1 0 .017h-.051Zm2.078 0h-.047a.01.01 0 0 1-.008-.008.01.01 0 0 1 .008-.009h.051a.008.008 0 0 1 0 .017Zm-1.909 0a.008.008 0 0 1 0-.017h.051a.009.009 0 0 1 0 .017zm.169 0a.01.01 0 0 1-.008-.008.01.01 0 0 1 .008-.009h.051a.008.008 0 1 1 0 .017zm1.571 0h-.051a.008.008 0 0 1 0-.017h.051a.01.01 0 0 1 .008.008.009.009 0 0 1-.009-.041Zm-1.4 0a.01.01 0 0 1-.008-.008.01.01 0 0 1 .008-.009h.051a.008.008 0 1 1 0 .017Zm1.233 0h-.051a.01.01 0 0 1-.008-.008.01.01 0 0 1 .008-.008h.051a.01.01 0 0 1 .008.008.009.009 0 0 1-.011-.042Zm-1.064 0a.008.008 0 0 1 0-.017h.051a.01.01 0 0 1 .008.008.01.01 0 0 1-.008.008Zm.9 0h-.051a.01.01 0 0 1-.008-.008.01.01 0 0 1 .008-.009h.051a.008.008 0 1 1 0 .017m-.726 0a.01.01 0 0 1-.008-.008.01.01 0 0 1 .008-.008h.051a.01.01 0 0 1 .008.008.01.01 0 0 1-.008.008Zm.557 0h-.051a.008.008 0 1 1 0-.017h.051a.01.01 0 0 1 .008.008.009.009 0 0 1-.016-.042Zm-.388 0a.008.008 0 1 1 0-.017h.051a.008.008 0 0 1 0 .017Zm.22 0h-.051a.008.008 0 0 1 0-.017h.051a.008.008 0 0 1 0 .017",
  "data-name": "Path 14091",
  transform: "translate(-552.172 -746.339)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#leave_svg__n)",
  d: "M671.9 828.988h-1.11a.286.286 0 0 1-.285-.251l-.128-1.065a.286.286 0 0 1 .285-.319h1.33a.286.286 0 0 1 .286.31l-.1 1.065a.286.286 0 0 1-.278.26",
  "data-name": "Path 14092",
  transform: "translate(-666.697 -822.88)"
}), /*#__PURE__*/React.createElement("image", {
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAAsCAYAAADIIYBkAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADaSURBVGhD7ZrBCsJADES3+m3eBNEPVUTxx7yIomtSU1nLrtCeJmEeZCeMtDBkezJdzjmNWEu9pPQH1bKf47X8qV6tv0l9KcNspMoHai+Z47X8qV6rV31IpYUewtbUK0s9hjAh0DC7T+ueLtxkwsAwqDAMKgyDSrgw+0/rH14zVBgGlMzJoMIwqAxhDqau4TVDhWFQYRhAnnqEnczR1C38ZlBhGFQYBpXQYU6mnuj/aVbCX7OzqQfupj2tyVxMkfnZzlBq6yZjVlLlNkRtQ+Kf1/KnekN/laqQ0hsBJpEIoGk2+gAAAABJRU5ErkJggg==",
  width: 1.462,
  height: 1.261,
  "data-name": "Rectangle 7508",
  opacity: 0.32,
  transform: "translate(3.897 4.662)"
})))));

const SvgLogout = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 30 30"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#9dcfff",
  d: "M17.229 16.075a3.25 3.25 0 1 1 0-6.5h2.176V5.248A3.26 3.26 0 0 0 16.141 2H4.448a1.09 1.09 0 0 0-.9.469 1.08 1.08 0 0 0-.12 1l7.89 20.57a1.09 1.09 0 0 0 1.016.7h3.807a3.26 3.26 0 0 0 3.263-3.248v-5.416Z",
  "data-name": "Path 68768"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00467d",
  d: "M13.926 12.771H6.981l4.3 11.266a1.085 1.085 0 0 0 1.015.7h3.807a3.267 3.267 0 0 0 3.263-3.266v-5.437H17.19a3.267 3.267 0 0 1-3.264-3.263",
  "data-name": "Path 68769"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ff7579",
  d: "M22.144 18.196a1.09 1.09 0 0 1-.671-1.005v-3.263h-4.351a1.088 1.088 0 1 1 0-2.176h4.351V8.489a1.087 1.087 0 0 1 1.861-.769l4.347 4.351a1.087 1.087 0 0 1 0 1.538l-4.347 4.351a1.09 1.09 0 0 1-1.186.236Z",
  "data-name": "Path 68770"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fe4a60",
  d: "M27.999 12.822H16.034a1.09 1.09 0 0 0 1.088 1.088h4.351v3.263a1.088 1.088 0 0 0 1.857.769l4.351-4.351a1.09 1.09 0 0 0 .318-.769",
  "data-name": "Path 68771"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#d0e8ff",
  d: "m11.4 4.277-6.532-2.17A2.19 2.19 0 0 0 2 4.166v19.5a2.18 2.18 0 0 0 1.473 2.056l6.536 2.17A2.3 2.3 0 0 0 10.7 28a2.173 2.173 0 0 0 2.176-2.167v-19.5A2.18 2.18 0 0 0 11.4 4.277",
  "data-name": "Path 68772"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3b6bab",
  d: "M12.878 14.947H2v8.7a2.19 2.19 0 0 0 1.473 2.065l6.536 2.179a2.3 2.3 0 0 0 .693.108 2.18 2.18 0 0 0 2.176-2.176Z",
  "data-name": "Path 68773"
}));

const SvgMicrosoftLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 21 21"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#f25022",
  d: "M1 1h9v9H1z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00a4ef",
  d: "M1 11h9v9H1z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#7fba00",
  d: "M11 1h9v9h-9z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffb900",
  d: "M11 11h9v9h-9z"
}));

const SvgOrangeDollar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 30 30"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#ff9800",
  d: "M15.004 2.504a12.5 12.5 0 1 0 12.5 12.5 12.5 12.5 0 0 0-12.5-12.5m1.762 20.106v2.387h-3.341v-2.412c-2.137-.45-3.949-1.824-4.086-4.249h2.449c.125 1.312 1.025 2.337 3.311 2.337 2.449 0 3-1.225 3-1.987 0-1.037-.55-2.012-3.336-2.674-3.1-.75-5.223-2.024-5.223-4.586 0-2.149 1.737-3.549 3.886-4.011V5.004h3.336V7.44a4.42 4.42 0 0 1 3.561 4.236h-2.449c-.062-1.387-.8-2.337-2.774-2.337-1.874 0-3 .85-3 2.049 0 1.05.812 1.737 3.336 2.387s5.223 1.737 5.223 4.886c-.012 2.287-1.724 3.536-3.9 3.949Z",
  "data-name": "Path 1317"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h30v30H0Z",
  "data-name": "Path 1318"
}));

const SvgOutlineblackDollar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 13.678 13.678"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h13.678v13.678H0Z",
  "data-name": "Path 2885"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#212121",
  "data-name": "Group 225"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.84 1.14a5.7 5.7 0 1 0 5.7 5.7 5.7 5.7 0 0 0-5.7-5.7m0 10.258a4.559 4.559 0 1 1 4.558-4.558 4.565 4.565 0 0 1-4.558 4.558",
  "data-name": "Path 2886"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.015 6.35c-1.008-.257-1.333-.536-1.333-.953 0-.479.45-.815 1.2-.815.786 0 1.083.376 1.106.935h.975a1.77 1.77 0 0 0-1.421-1.692V2.85h-1.33v.963a1.72 1.72 0 0 0-1.55 1.6c0 1.02.849 1.533 2.086 1.829 1.111.262 1.334.655 1.334 1.066 0 .3-.222.792-1.2.792-.912 0-1.271-.41-1.322-.935h-.978a1.85 1.85 0 0 0 1.63 1.695v.969h1.33v-.952c.866-.165 1.55-.661 1.556-1.579-.002-1.253-1.079-1.687-2.083-1.948",
  "data-name": "Path 2887"
})));

const SvgPdf = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 30 30"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 24865"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h30v30H0z",
  "data-name": "Rectangle 6198"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2574c",
  d: "M4.371 0h15.935l8.444 8.411v19.714A1.875 1.875 0 0 1 26.871 30h-22.5a1.875 1.875 0 0 1-1.875-1.875V1.875A1.875 1.875 0 0 1 4.371 0",
  "data-name": "Path 11620"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#b53629",
  d: "M28.722 8.438h-6.535a1.876 1.876 0 0 1-1.875-1.875V.019Z",
  "data-name": "Path 11621"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M21.717 14.216a.545.545 0 0 0 0-1.079h-1.789a.56.56 0 0 0-.545.609v4.4c0 .392.223.609.525.609s.524-.218.524-.609v-1.207h1.082a.51.51 0 0 0 .5-.548.5.5 0 0 0-.5-.533h-1.082v-1.642Zm-6.046-1.079h-1.309a.58.58 0 0 0-.608.606v4.4a.577.577 0 0 0 .622.59h1.373a2.547 2.547 0 0 0 2.7-2.721 2.614 2.614 0 0 0-2.778-2.876Zm.063 4.513h-.8v-3.428h.719c1.088 0 1.562.73 1.562 1.738.002.943-.463 1.689-1.481 1.689Zm-4.794-4.513h-1.3a.545.545 0 0 0-.571.609v4.4a.552.552 0 1 0 1.1 0v-1.283h.813a1.775 1.775 0 0 0 1.831-1.853 1.8 1.8 0 0 0-1.874-1.874Zm-.022 2.691h-.747V14.17h.747a.833.833 0 0 1 0 1.658",
  "data-name": "Path 11622"
})));

const SvgProfile = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 30 30"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 61719"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "user (3)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fdd1a3",
  d: "M21.099 8.262a6.06 6.06 0 0 1-1.834 4.428 6.06 6.06 0 0 1-4.426 1.835 6.06 6.06 0 0 1-4.43-1.835 6.06 6.06 0 0 1-1.834-4.428 6.06 6.06 0 0 1 1.834-4.427A6.06 6.06 0 0 1 14.833 2a6.06 6.06 0 0 1 4.428 1.834 6.06 6.06 0 0 1 1.838 4.428m0 0",
  "data-name": "Path 75949"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3b6bab",
  d: "M25.846 23.528a4.32 4.32 0 0 1-1.282 3.266 4.62 4.62 0 0 1-3.3 1.205H8.74a4.61 4.61 0 0 1-3.3-1.205 4.32 4.32 0 0 1-1.286-3.266c0-.522.017-1.039.052-1.535a15 15 0 0 1 .211-1.643 13 13 0 0 1 .4-1.651 8.2 8.2 0 0 1 .679-1.541 5.8 5.8 0 0 1 1.024-1.334 4.5 4.5 0 0 1 1.471-.924 5.1 5.1 0 0 1 1.878-.34 1.9 1.9 0 0 1 1.017.431c.31.2.667.432 1.061.684a6 6 0 0 0 1.371.6 5.5 5.5 0 0 0 1.512.268h.166a5.5 5.5 0 0 0 1.678-.271 6 6 0 0 0 1.372-.6q.601-.382 1.061-.684a1.9 1.9 0 0 1 1.018-.432 5.1 5.1 0 0 1 1.878.34 4.5 4.5 0 0 1 1.471.924 5.8 5.8 0 0 1 1.024 1.334 8 8 0 0 1 .679 1.54 13 13 0 0 1 .4 1.652 16 16 0 0 1 .21 1.643q.052.75.053 1.536Zm0 0",
  "data-name": "Path 75950"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffbb85",
  d: "M14.84 14.524V2a6.06 6.06 0 0 1 4.428 1.834 6.06 6.06 0 0 1 1.834 4.427 6.06 6.06 0 0 1-1.834 4.428 6.06 6.06 0 0 1-4.428 1.834Zm0 0",
  "data-name": "Path 75951"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00467d",
  d: "M25.846 23.528a4.32 4.32 0 0 1-1.282 3.266 4.62 4.62 0 0 1-3.3 1.205h-6.426V16.547h.166a5.5 5.5 0 0 0 1.678-.271 6 6 0 0 0 1.372-.6q.601-.383 1.061-.684a1.9 1.9 0 0 1 1.018-.432 5.1 5.1 0 0 1 1.878.34 4.5 4.5 0 0 1 1.471.924 5.8 5.8 0 0 1 1.024 1.334 8 8 0 0 1 .679 1.54 13 13 0 0 1 .4 1.652 16 16 0 0 1 .21 1.643q.052.75.053 1.536Zm0 0",
  "data-name": "Path 75952"
}))));

const SvgPurchaseOrderOnbehalf = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 30 30"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 51470"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 51493"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h30v30H0z",
  "data-name": "Rectangle 26176"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fac600",
  d: "M6.105 4.948a.1.1 0 0 1 .1-.1h14.754V2.814a.15.15 0 0 0-.149-.149H4.072a.15.15 0 0 0-.149.149v22.238a.15.15 0 0 0 .149.149h2.033Z",
  "data-name": "Path 69423"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e8b800",
  d: "M6.057 4.948a.15.15 0 0 1 .149-.149h.225V2.814a.15.15 0 0 1 .148-.149H4.072a.15.15 0 0 0-.149.149v22.238a.15.15 0 0 0 .149.149h1.985Z",
  "data-name": "Path 69424"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 51470"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff3de",
  d: "M19.215 25.093a.56.56 0 0 1-.561-.561v-4.986a.56.56 0 0 1 .561-.561h3.878v-.872h-3.878a.56.56 0 0 1-.561-.561v-4.99a.56.56 0 0 1 .561-.561h3.878V4.948a.15.15 0 0 0-.149-.149H6.206a.15.15 0 0 0-.149.149v22.238a.15.15 0 0 0 .149.149h16.738a.15.15 0 0 0 .149-.149v-2.093Z",
  "data-name": "Path 69425"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 51471"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#ffe5c2",
  d: "M8.158 27.186V4.948a.15.15 0 0 1 .149-.149h-2.1a.15.15 0 0 0-.149.149v22.238a.15.15 0 0 0 .149.149h2.1a.15.15 0 0 1-.149-.149",
  "data-name": "Path 69426"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 51472"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#f6a96c",
  d: "M17.556 8.402h-5.961a.362.362 0 0 1 0-.723h5.961a.362.362 0 0 1 0 .723",
  "data-name": "Path 69427"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 51482"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 51473"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#f6a96c",
  d: "M19.423 11.231h-9.7a.362.362 0 1 1 0-.723h9.7a.362.362 0 0 1 0 .723",
  "data-name": "Path 69428"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 51474"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#f6a96c",
  d: "M18.654 12.698h-4.083a.362.362 0 0 0 0 .723h4.083Z",
  "data-name": "Path 69429"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 51475"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#f6a96c",
  d: "M13.181 13.421H9.726a.362.362 0 0 1 0-.723h3.455a.362.362 0 1 1 0 .723",
  "data-name": "Path 69430"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 51476"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#f6a96c",
  d: "M18.654 14.891H9.727a.362.362 0 0 0 0 .723h8.927Z",
  "data-name": "Path 69431"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 51477"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#ca6e59",
  d: "M18.654 17.547v-.468H9.727a.362.362 0 0 0 0 .723h8.99a.56.56 0 0 1-.063-.255",
  "data-name": "Path 69432"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 51478"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#ca6e59",
  d: "M18.653 19.546a.56.56 0 0 1 .074-.277h-2.072a.362.362 0 1 0 0 .723h2Z",
  "data-name": "Path 69433"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 51479"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#ca6e59",
  d: "M15.266 19.992h-5.54a.362.362 0 0 1 0-.723h5.54a.362.362 0 1 1 0 .723",
  "data-name": "Path 69434"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 51480"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#ca6e59",
  d: "M18.654 21.459H9.727a.362.362 0 1 0 0 .723h8.927Z",
  "data-name": "Path 69435"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 51481"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#ca6e59",
  d: "M18.654 23.649H9.727a.362.362 0 1 0 0 .723h8.927Z",
  "data-name": "Path 69436"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 51487"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 51483"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#4fc123",
  d: "M24.199 24.779h-4.985a.25.25 0 0 1-.248-.248v-4.985a.25.25 0 0 1 .248-.248h4.985a.25.25 0 0 1 .248.248v4.985a.25.25 0 0 1-.248.248",
  "data-name": "Path 69437"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 51484"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#47a920",
  d: "M20.626 24.531v-4.985a.25.25 0 0 1 .248-.248h-1.66a.25.25 0 0 0-.248.248v4.985a.25.25 0 0 0 .248.248h1.66a.25.25 0 0 1-.248-.248",
  "data-name": "Path 69438"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 51485"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#68ca44",
  d: "M24.199 25.14h-4.984a.61.61 0 0 1-.61-.61v-4.985a.61.61 0 0 1 .61-.61H24.2a.61.61 0 0 1 .61.61v4.982a.61.61 0 0 1-.611.613m-4.872-.723h4.759v-4.759h-4.759Z",
  "data-name": "Path 69439"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 51486"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#3675bb",
  d: "M22.032 23.313a.36.36 0 0 1-.256-.106l-1.6-1.6a.361.361 0 0 1 .511-.511l1.347 1.347 3.428-3.428a.361.361 0 1 1 .511.511l-3.684 3.684a.36.36 0 0 1-.257.103",
  "data-name": "Path 69440"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 51492"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 51488"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#4fc123",
  d: "M24.199 17.795h-4.985a.25.25 0 0 1-.248-.248v-4.986a.25.25 0 0 1 .248-.248h4.985a.25.25 0 0 1 .248.248v4.985a.25.25 0 0 1-.248.249",
  "data-name": "Path 69441"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 51489"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#47a920",
  d: "M20.626 17.547v-4.986a.25.25 0 0 1 .248-.248h-1.66a.25.25 0 0 0-.248.248v4.985a.25.25 0 0 0 .248.248h1.66a.25.25 0 0 1-.248-.247",
  "data-name": "Path 69442"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 51490"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#68ca44",
  d: "M24.199 18.156h-4.984a.61.61 0 0 1-.61-.61v-4.985a.61.61 0 0 1 .61-.61H24.2a.61.61 0 0 1 .61.61v4.985a.61.61 0 0 1-.611.61m-4.872-.723h4.759v-4.759h-4.759Z",
  "data-name": "Path 69443"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 51491"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#3675bb",
  d: "M22.032 16.33a.36.36 0 0 1-.256-.106l-1.6-1.6a.361.361 0 1 1 .511-.511l1.347 1.347 3.428-3.428a.361.361 0 1 1 .511.511l-3.684 3.684a.36.36 0 0 1-.257.103",
  "data-name": "Path 69444"
}))))));

const SvgPurchaseOrder = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 30 30"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 51469"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h30v30H0z",
  "data-name": "Rectangle 26176"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fac3a0",
  d: "M19.729 5.095h4.335v22.962H5.936V5.095z",
  "data-name": "Path 69401"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fafafa",
  d: "M19.729 6.671h2.759v19.81H7.512V6.671z",
  "data-name": "Path 69402"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff0c8",
  d: "M10.271 20.131h9.458v4.2h-9.458Z",
  "data-name": "Path 69403"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#95dcd8",
  d: "M10.271 9.868h9.458v3.941h-9.458Z",
  "data-name": "Path 69404"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e6af8c",
  d: "M19.729 5.095H15v22.962h9.064V5.095Z",
  "data-name": "Path 69405"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e6e6e6",
  d: "M19.729 6.671H15v19.81h7.488V6.671Z",
  "data-name": "Path 69406"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#dd636e",
  d: "M17.056 3.781V1.942h-4.112v1.839h-2.673v4.2h9.458v-4.2Z",
  "data-name": "Path 69407"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#c94f5a",
  d: "M17.056 3.781V1.942H15v6.043h4.729v-4.2Z",
  "data-name": "Path 69408"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#81c8c4",
  d: "M15 9.868h4.729v3.941H15Z",
  "data-name": "Path 69409"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ebdcb4",
  d: "M15 20.131h4.729v4.2H15Z",
  "data-name": "Path 69410"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 51458"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#818181",
  d: "M10.271 24.729a.394.394 0 0 1-.394-.394v-4.2a.394.394 0 1 1 .788 0v4.2a.394.394 0 0 1-.394.394",
  "data-name": "Path 69411"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 51459"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#818181",
  d: "M11.847 23.152a.394.394 0 0 1-.394-.394v-2.627a.394.394 0 1 1 .788 0v2.627a.394.394 0 0 1-.394.394",
  "data-name": "Path 69412"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 51460"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#818181",
  d: "M13.424 23.152a.394.394 0 0 1-.394-.394v-2.627a.394.394 0 1 1 .788 0v2.627a.394.394 0 0 1-.394.394",
  "data-name": "Path 69413"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 51461"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#818181",
  d: "M15 24.729a.394.394 0 0 1-.394-.394v-4.2a.394.394 0 1 1 .788 0v4.2a.394.394 0 0 1-.394.394",
  "data-name": "Path 69414"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 51462"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#6d6d6d",
  d: "M16.576 23.152a.394.394 0 0 1-.394-.394v-2.627a.394.394 0 1 1 .788 0v2.627a.394.394 0 0 1-.394.394",
  "data-name": "Path 69415"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 51463"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#6d6d6d",
  d: "M18.153 23.152a.394.394 0 0 1-.394-.394v-2.627a.394.394 0 1 1 .788 0v2.627a.394.394 0 0 1-.394.394",
  "data-name": "Path 69416"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 51464"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#6d6d6d",
  d: "M19.729 24.729a.394.394 0 0 1-.394-.394v-4.2a.394.394 0 1 1 .788 0v4.2a.394.394 0 0 1-.394.394",
  "data-name": "Path 69417"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 51465"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#818181",
  d: "M16.182 15.78h-5.911a.394.394 0 0 1 0-.788h5.911a.394.394 0 0 1 0 .788",
  "data-name": "Path 69418"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 51466"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#818181",
  d: "M19.729 17.356h-9.458a.394.394 0 1 1 0-.788h9.458a.394.394 0 1 1 0 .788",
  "data-name": "Path 69419"
})), /*#__PURE__*/React.createElement("g", {
  fill: "#6d6d6d",
  "data-name": "Group 51467"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.182 14.992H15v.788h1.182a.394.394 0 0 0 0-.788",
  "data-name": "Path 69420"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.729 16.568H15v.788h4.729a.394.394 0 1 0 0-.788",
  "data-name": "Path 69421"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15 19.737v4.992a.394.394 0 0 0 .394-.394v-4.2a.394.394 0 0 0-.394-.398",
  "data-name": "Path 69422"
}))));

const SvgPurchaseRequisition = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 30 30"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 51454"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h30v30H0z",
  "data-name": "Rectangle 26176"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-20.94 -20.941)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 15,
  height: 22,
  fill: "#348fd9",
  "data-name": "Rectangle 26174",
  rx: 2,
  transform: "translate(23.134 23.134)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#60d1e0",
  d: "M27.186 47.023h12.075a1.294 1.294 0 0 0 1.294-1.294V27.186a1.294 1.294 0 0 0-1.294-1.294h-9.488l-3.881 3.881v15.956a1.294 1.294 0 0 0 1.294 1.294",
  "data-name": "Path 69352"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#8adbe6",
  d: "M29.773 28.479v-2.587l-3.881 3.881h2.587a1.294 1.294 0 0 0 1.294-1.294",
  "data-name": "Path 69353"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#4eb9c7",
  "data-name": "Group 51446"
}, /*#__PURE__*/React.createElement("path", {
  d: "M37.536 31.067h-8.625a1.3 1.3 0 0 0-1.294 1.294v11.212a1.3 1.3 0 0 0 1.294 1.294h8.625a1.3 1.3 0 0 0 1.294-1.294V32.361a1.3 1.3 0 0 0-1.294-1.294m.431 1.294v.862h-6.9v-1.294h6.469a.43.43 0 0 1 .431.432m-7.762 3.881v1.294h-1.726v-1.294Zm-1.725-.862v-1.294h1.725v1.294Zm1.725 3.019v1.294h-1.726v-1.294Zm0 2.156v1.294h-1.726v-1.294Zm.862 0h6.9v1.294h-6.9Zm0-.862v-1.294h6.9v1.294Zm0-2.156v-1.294h6.9v1.294Zm0-2.156v-1.294h6.9v1.294Zm-2.156-3.45h1.294v1.294h-1.726v-.862a.43.43 0 0 1 .432-.433Zm-.431 11.644v-.862h1.725v1.294h-1.294a.43.43 0 0 1-.432-.434Zm9.056.431h-6.469v-1.294h6.9v.862a.43.43 0 0 1-.431.43Z",
  "data-name": "Path 69354"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.067 29.342h3.881v.862h-3.881Z",
  "data-name": "Path 69355"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.067 27.617h7.762v.862h-7.762Z",
  "data-name": "Path 69356"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#ffb531",
  d: "M45.929 45.729h-9.025a1.525 1.525 0 0 1-1.078-2.6 1.42 1.42 0 0 0 .416-1v-4.594a3.45 3.45 0 0 1 3.45-3.45h3.45a3.45 3.45 0 0 1 3.45 3.45v4.587a1.42 1.42 0 0 0 .416 1 1.525 1.525 0 0 1-1.078 2.6Z",
  "data-name": "Path 69357"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fcac1f",
  d: "M44.004 31.498h-5.175l.862 2.587h3.45Z",
  "data-name": "Path 69358"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f98500",
  d: "M43.142 38.398v-.111a1.185 1.185 0 0 0-1.183-1.183h-.111v-.431h-.862v.431h-.111a1.183 1.183 0 0 0-.374 2.306l1.559.52a.321.321 0 0 1-.1.625h-1.084a.32.32 0 0 1-.321-.321v-.111h-.863v.111a1.185 1.185 0 0 0 1.183 1.183h.111v.431h.862v-.431h.111a1.183 1.183 0 0 0 .374-2.305l-1.559-.52a.321.321 0 0 1 .1-.625h1.084a.32.32 0 0 1 .321.321v.111Z",
  "data-name": "Path 69359"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffc361",
  d: "m38.571 36.889-.746-.433a2.17 2.17 0 0 1 .788-.788l.433.746a1.3 1.3 0 0 0-.475.475",
  "data-name": "Path 69360"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffc361",
  d: "M37.535 37.535h.862v2.156h-.862Z",
  "data-name": "Path 69361"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#b7e7eb",
  d: "M47.485 35.971a4.4 4.4 0 0 0-1.957-2.282l.4-.763a5.25 5.25 0 0 1 2.355 2.723Z",
  "data-name": "Path 69362"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fec9a3",
  d: "M46.471 43.636a2.94 2.94 0 0 0-1.633-.495h-.045a2.95 2.95 0 0 0-2.082.862h-3.666a1.077 1.077 0 0 0-.985 1.515l-1.5-1.246a1.16 1.16 0 0 0-.742-.269h-.17a1.135 1.135 0 0 0-1.131 1.138v.02a1.16 1.16 0 0 0 .447.92l3.083 2.4a1.3 1.3 0 0 0 .794.272h8.181v-4.744Z",
  "data-name": "Path 69363"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#348fd9",
  d: "M47.023 44.004h1.725v4.744h-1.725Z",
  "data-name": "Path 69364"
}), /*#__PURE__*/React.createElement("rect", {
  width: 5,
  height: 1,
  fill: "#feb784",
  "data-name": "Rectangle 26175",
  rx: 0.5,
  transform: "translate(38.134 45.134)"
}))));

const SvgPurchases = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "purchases_svg__d",
  x1: -16.56,
  x2: -17.253,
  y1: -0.131,
  y2: 0.802,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#ffc444"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.996,
  stopColor: "#f36f56"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "purchases_svg__f",
  x1: -32.265,
  x2: -31.289,
  y1: 0.088,
  y2: 1.014,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#ab316d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#792d3d"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "purchases_svg__g",
  x1: -32.443,
  x2: -31.443,
  y1: 0.5,
  y2: 0.5,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.004,
  stopColor: "#e38ddd"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9571f6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "purchases_svg__a",
  x1: -17.403,
  x2: -18.523,
  y1: 0.509,
  y2: -0.446,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f57e53"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.005,
  stopColor: "#f58152"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.042,
  stopColor: "#f8994d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.084,
  stopColor: "#fbac49"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.133,
  stopColor: "#fdb946"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.196,
  stopColor: "#fec144"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.318,
  stopColor: "#ffc444"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.455,
  stopColor: "#fdb946"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.694,
  stopColor: "#f99c4c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.996,
  stopColor: "#f36f56"
})), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#purchases_svg__a",
  id: "purchases_svg__i",
  x1: -18.553,
  x2: -17.908,
  y1: -0.333,
  y2: 0.678
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "purchases_svg__b",
  x2: 1,
  y1: 0.5,
  y2: 0.5,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#444b8c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.996,
  stopColor: "#26264f"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "purchases_svg__k",
  x2: 1,
  y1: 0.5,
  y2: 0.5,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#0045ff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#0003c1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#purchases_svg__b",
  id: "purchases_svg__l",
  x1: -0.657,
  x2: -0.454,
  y1: 0.34,
  y2: 0.428
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "purchases_svg__c",
  x1: -0.962,
  x2: -0.224,
  y1: 0.127,
  y2: 0.614,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#5367ff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#181073"
})), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#purchases_svg__c",
  id: "purchases_svg__m",
  x1: -1.532,
  x2: -0.52,
  y1: 0.1,
  y2: 0.587
}), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#purchases_svg__c",
  id: "purchases_svg__n",
  x1: -0.032,
  x2: 0.685,
  y1: 0.323,
  y2: 0.953
}), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#purchases_svg__b",
  id: "purchases_svg__o",
  x1: -0.229,
  x2: -0.053,
  y1: -0.088,
  y2: 1.094
}), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#purchases_svg__c",
  id: "purchases_svg__p",
  x1: -0.168,
  x2: 0.651,
  y1: 0.311,
  y2: 0.944
}), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#purchases_svg__b",
  id: "purchases_svg__q",
  x1: -4.395,
  x2: -4.194,
  y1: 0.249,
  y2: 0.324
}), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#purchases_svg__b",
  id: "purchases_svg__r",
  x1: -4.395,
  x2: -4.194,
  y1: 0.249,
  y2: 0.324
}), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#purchases_svg__b",
  id: "purchases_svg__s",
  x1: -152.252,
  x2: -153.039,
  y1: 26.724,
  y2: 20.049
}), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#purchases_svg__d",
  id: "purchases_svg__t",
  x1: -537.283,
  x2: -537.283,
  y1: 24.007,
  y2: 14.241
}), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#purchases_svg__d",
  id: "purchases_svg__u",
  x1: -359.734,
  x2: -359.734,
  y1: 22.374,
  y2: 12.964
}), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#purchases_svg__b",
  id: "purchases_svg__v",
  x1: -197.55,
  x2: -198.588,
  y1: 14.124,
  y2: 10.391
}), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#purchases_svg__c",
  id: "purchases_svg__w",
  x1: -62.088,
  x2: -62.244,
  y1: 1.125,
  y2: 2.082
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "purchases_svg__x",
  x1: -69.846,
  x2: -70.021,
  y1: 1.125,
  y2: 2.082,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#311944"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#893976"
})), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#purchases_svg__c",
  id: "purchases_svg__y",
  x1: -57.191,
  x2: -59.964,
  y1: 1.458,
  y2: 1.424
}), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#purchases_svg__b",
  id: "purchases_svg__z",
  x1: -42.315,
  x2: -42.85,
  y1: 2.976,
  y2: 3.921
}), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#purchases_svg__a",
  id: "purchases_svg__A",
  x1: -51.997,
  x2: -52.568,
  y1: 3.184,
  y2: 4.354
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "purchases_svg__B",
  x1: -146.184,
  x2: -145.746,
  y1: 19.852,
  y2: 17.876,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#aa80f9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.996,
  stopColor: "#6165d7"
})), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#purchases_svg__b",
  id: "purchases_svg__C",
  x1: -21.719,
  x2: -21.212,
  y1: 2.395,
  y2: 1.261
}), /*#__PURE__*/React.createElement("clipPath", {
  id: "purchases_svg__e"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "m2.137 19.463 3.206-.162a3.5 3.5 0 0 0-.323-2.8c-1.723-2.287.4-3.636 1.205-4.334 1.214-1.053 1.824-2.51-.064-3.036s-.167-3.5 2.038-4.917c2.158-1.387.937-6.024-4.01-3.45-2.954 1.537-2.318 4.719-2.38 6.4S-.738 9.112.218 11.116c.817 1.712 2.266 2.917 1.27 4.173s-1.037 2.613.649 4.174",
  "data-name": "Path 14863"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "purchases_svg__h"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "m5.838 18.191 2.619-.452s.817-1.868-.09-2.457-.393-2.405-.232-3.405c.438-2.713-2.534-2.7-2.249-6.236.075-.939.533-2.705-.2-3.518-.832-.926-1.559-.143-2.082-.9C2.788.036 1.349-.484.379.591s-.089 3.4 2.378 5.422c1.605 1.652 1.6 2.106 1.37 3.2-.157.764-1.057 2.714-.074 3.6s1.712 1.82 1.237 2.659c-.719 1.27.548 2.719.548 2.719",
  "data-name": "Path 14874"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "purchases_svg__j"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "m5.966 9.327 2.429-.122c.124-.351.272-.994-.244-1.125-.718-.182-.787-1.426-.612-1.875.217-.556.7-1.86-.408-2.158-.92-.248-1.564-.221-1.677-1.386S4.672.794 3.616.909C2.505 1.03 1.527-.415.635.12c-1.555.932 0 3.445 1.964 4.109s.886 1.408.875 2.366c-.015 1.308 1.737.954 2.225 1.447a1.4 1.4 0 0 1 .267 1.285",
  "data-name": "Path 14881"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 25433"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h40v40H0z",
  "data-name": "Rectangle 13651"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 25432"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 24716"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 12185"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h40v40H0z",
  "data-name": "Rectangle 7738"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 12184"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 11908"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#purchases_svg__e)",
  "data-name": "Group 11907",
  transform: "translate(5.361)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#purchases_svg__d)",
  d: "m2541.622 209.6 3.206-.162a3.5 3.5 0 0 0-.323-2.8c-1.723-2.287.4-3.636 1.205-4.334 1.214-1.053 1.707-2.359.145-3.111-1.767-.851-.376-3.424 1.829-4.842 2.158-1.387.937-6.024-4.01-3.45-2.954 1.537-2.318 4.719-2.38 6.4s-2.547 1.948-1.591 3.952c.817 1.712 2.266 2.917 1.27 4.173s-1.037 2.613.649 4.174",
  "data-name": "Path 14855",
  transform: "translate(-2539.485 -190.137)"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#beb8f2",
  "data-name": "Group 11906"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.548 19.685a33 33 0 0 1-.68-8.493 15.14 15.14 0 0 1 1.645-6.367 7.92 7.92 0 0 1 5.191-4l.013.051A7.87 7.87 0 0 0 4.559 4.85a15.1 15.1 0 0 0-1.637 6.345 32.9 32.9 0 0 0 .678 8.479Z",
  "data-name": "Path 14856"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.066 5.714a17.7 17.7 0 0 1 .308-5.5l.051.011A17.7 17.7 0 0 0 4.117 5.7Z",
  "data-name": "Path 14857"
}), /*#__PURE__*/React.createElement("path", {
  d: "m4.865 4.338-.03-.043a5.7 5.7 0 0 1 4.442-.963l-.015.051a5.65 5.65 0 0 0-4.397.955",
  "data-name": "Path 14858"
}), /*#__PURE__*/React.createElement("path", {
  d: "m2.89 14.043-.051-.009c.6-3.254 4.95-4.284 4.993-4.286V9.8c-.039.005-4.35 1.034-4.942 4.243",
  "data-name": "Path 14859"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.816 12.691a6.4 6.4 0 0 0-2.817-3.3l.025-.046a6.46 6.46 0 0 1 2.843 3.333Z",
  "data-name": "Path 14860"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.463 19.024h-.052c.036-1.28 1.786-2.369 1.8-2.38l.028.044c-.014.009-1.741 1.084-1.776 2.336",
  "data-name": "Path 14861"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.24 18.056c-.209-.939-1.717-1.937-2.212-2.265a2 2 0 0 1-.151-.1l.038-.037c.009.01.071.05.143.1.5.331 2.02 1.337 2.234 2.3Z",
  "data-name": "Path 14862"
})))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 11920",
  transform: "translate(.966 8.286)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#purchases_svg__f)",
  d: "M2557.278 728.809a.43.43 0 0 1-.271.363 5.9 5.9 0 0 1-2.68 0 .43.43 0 0 1-.269-.349l-.938-1.247h4.947Z",
  "data-name": "Path 14864",
  transform: "translate(-2548.066 -709.859)"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 2.478,
  cy: 0.322,
  fill: "url(#purchases_svg__g)",
  "data-name": "Ellipse 438",
  rx: 2.478,
  ry: 0.322,
  transform: "translate(5.054 17.368)"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 11919"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 11918"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 11917"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 11912"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#purchases_svg__a)",
  d: "M2466.71 376.874a2.14 2.14 0 0 0 .141 2.063.8.8 0 0 1 .2.057 8.6 8.6 0 0 0 1.734.277 3.5 3.5 0 0 0 .807-.1l.35-.09s.754-1.805-.153-2.394-.393-2.405-.232-3.405c.438-2.713-2.534-2.7-2.249-6.236.075-.939.533-2.705-.2-3.518-.832-.926-1.559-.143-2.082-.9-.816-1.187-2.255-1.707-3.225-.632s-.089 3.4 2.378 5.422c1.605 1.652 1.6 2.106 1.37 3.2-.157.764-1.057 2.714-.074 3.6s1.71 1.818 1.235 2.656",
  "data-name": "Path 14865",
  transform: "translate(-2460.8 -361.409)"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 11911"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#purchases_svg__h)",
  "data-name": "Group 11910",
  transform: "translate(.618)"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#fcfdfe",
  "data-name": "Group 11909"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.988 17.86a35 35 0 0 0-.052-.938 33 33 0 0 0-1.08-6.519 26.5 26.5 0 0 0-1.855-4.858 22 22 0 0 0-2.065-3.346A18 18 0 0 0 .259.265C.159.165.051.07-.053-.022a6 6 0 0 1-.416-.394l.038-.036c.127.138.272.266.412.39.1.093.214.19.315.289a18 18 0 0 1 1.682 1.94 22 22 0 0 1 2.07 3.354 26.5 26.5 0 0 1 1.859 4.868 33 33 0 0 1 1.081 6.529q.032.464.052.94Z",
  "data-name": "Path 14866"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.847 7.412c-.8-2.135.355-5.854.366-5.892l.051.016c-.012.037-1.159 3.739-.367 5.857Z",
  "data-name": "Path 14867"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.542 13.532c-.364-1.479-2.989-2.82-3.016-2.834l.024-.047c.026.013 2.673 1.365 3.043 2.868Z",
  "data-name": "Path 14868"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.679 14.403a7.9 7.9 0 0 1 1.278-4l.038-.069.021.009h.031c0 .01 0 .01-.044.088a7.83 7.83 0 0 0-1.271 3.967Z",
  "data-name": "Path 14869"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.956 17.289c-.376-1.02-1.916-1.539-1.932-1.544l.017-.05c.015.005 1.579.532 1.965 1.576Z",
  "data-name": "Path 14870"
}), /*#__PURE__*/React.createElement("path", {
  d: "m7.068 17.872-.05-.016a6.1 6.1 0 0 1 1.612-2.488l.038.037a6.06 6.06 0 0 0-1.6 2.467",
  "data-name": "Path 14871"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.377 2.806a15 15 0 0 1-.86-2.93C1.501-.2 1.489-.261 1.486-.27l.048-.019a1 1 0 0 1 .034.155 15 15 0 0 0 .856 2.919Z",
  "data-name": "Path 14872"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.478 4.56C2.721 3.683.311 3.514.287 3.513V3.46a10 10 0 0 1 1.319.193 3.52 3.52 0 0 1 1.909.873Z",
  "data-name": "Path 14873"
}))))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 11916"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#purchases_svg__i)",
  d: "m2454.637 554.28.03.011a5.5 5.5 0 0 0 2 .34l.448-.036c.11-.361.148-.724-.313-.841-.718-.182-.787-1.426-.612-1.875.217-.556.7-1.86-.408-2.158-.92-.248-1.564-.221-1.677-1.386s-.782-1.867-1.838-1.752c-1.111.121-2.089-1.324-2.981-.789-1.555.932 0 3.445 1.964 4.109s.886 1.408.875 2.366c-.015 1.308 1.737.954 2.225 1.447a1.07 1.07 0 0 1 .287.564",
  "data-name": "Path 14875",
  transform: "translate(-2448.65 -536.759)"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 11915"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#purchases_svg__j)",
  "data-name": "Group 11914",
  transform: "translate(0 8.914)"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#fcfdfe",
  "data-name": "Group 11913"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.09 8.888A12.8 12.8 0 0 0-.037.401l.021-.048a12.86 12.86 0 0 1 7.157 8.522Z",
  "data-name": "Path 14876"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.406 6.895a4.22 4.22 0 0 1 1.2-2.8l.037.037A4.16 4.16 0 0 0 6.46 6.895Z",
  "data-name": "Path 14877"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.9 8.206c-.775-1.291-3.539-1.353-3.568-1.353V6.8c.028 0 2.822.063 3.612 1.379Z",
  "data-name": "Path 14878"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.388 3.705a4.5 4.5 0 0 1 .118-2.9l.05.019a4.43 4.43 0 0 0-.121 2.861Z",
  "data-name": "Path 14879"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.629 2.007a4.73 4.73 0 0 0-3-.177l-.014-.051a4.8 4.8 0 0 1 3.042.181Z",
  "data-name": "Path 14880"
}))))))))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 11933"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#purchases_svg__b)",
  d: "m2625.166 291.117-23.819-1.378a1.123 1.123 0 0 0-1.043 1.074v30.672c0 .7.712.838 1.26.782l23.6-2.41a.9.9 0 0 0 .779-.881v-27.019a.84.84 0 0 0-.777-.84",
  "data-name": "Path 14882",
  transform: "translate(-2592.001 -284.92)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#purchases_svg__k)",
  d: "m2633.264 290.082-23.867-1.174a.9.9 0 0 0-.995.868v30.911a.85.85 0 0 0 .995.815l23.867-2.456a.9.9 0 0 0 .779-.888v-27.23a.843.843 0 0 0-.779-.846",
  "data-name": "Path 14883",
  transform: "translate(-2599.708 -284.128)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#purchases_svg__k)",
  d: "M2618.41 329.342a.46.46 0 0 1-.538-.441v-30.845a.49.49 0 0 1 .538-.47l23.866 1.127a.456.456 0 0 1 .422.458v27.281a.49.49 0 0 1-.422.481Z",
  "data-name": "Path 14884",
  opacity: 0.3,
  style: {
    mixBlendMode: "multiply",
    isolation: "isolate"
  },
  transform: "translate(-2608.72 -292.387)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M32.018 33.813 11.605 35.78V7.322l20.413.769Z",
  "data-name": "Path 14885"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#97a6b7",
  d: "m2761.272 300.618-8.158.1.182-1.84a.5.5 0 0 1 .415-.47l1.381-.212a.5.5 0 0 0 .374-.287l.15-.325 3.614.223Z",
  "data-name": "Path 14886",
  opacity: 0.3,
  style: {
    mixBlendMode: "multiply",
    isolation: "isolate"
  },
  transform: "translate(-2737.418 -292.387)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#purchases_svg__b)",
  d: "M2765.628 232.8a.436.436 0 0 0-.416-.364l-1.3-.058a1.047 1.047 0 0 1-1-1.116l.051-1.411a.46.46 0 0 0-.434-.485l-.428-.026a.542.542 0 0 1-.5-.64.967.967 0 0 0-.9-1.123 1.174 1.174 0 0 0-1.212.994.64.64 0 0 1-.09.251.67.67 0 0 1-.6.321l-.441-.026a.585.585 0 0 0-.59.436l-.367 1.432a1.4 1.4 0 0 1-1.4 1.038l-1.429-.064a.62.62 0 0 0-.572.34l-.862 1.71a.2.2 0 0 0 .17.3l12.4.412a.23.23 0 0 0 .227-.265Zm-5.1-4a.284.284 0 0 1-.264-.332.343.343 0 0 1 .354-.292.283.283 0 0 1 .264.332.343.343 0 0 1-.359.292Z",
  "data-name": "Path 14887",
  transform: "translate(-2737.417 -225.764)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#97a6b7",
  d: "M28.283 7.075a.44.44 0 0 0-.416-.364l-1.3-.058a1.05 1.05 0 0 1-1-1.116l.052-1.411a.46.46 0 0 0-.433-.485l-.429-.026a.542.542 0 0 1-.5-.64.967.967 0 0 0-.9-1.123 1.174 1.174 0 0 0-1.213.994.7.7 0 0 1-.09.251.67.67 0 0 1-.6.321l-.442-.026a.586.586 0 0 0-.59.436l-.367 1.432a1.4 1.4 0 0 1-1.395 1.038l-1.43-.064a.62.62 0 0 0-.571.34l-.862 1.71a.2.2 0 0 0 .17.3l12.4.412a.23.23 0 0 0 .226-.265Zm-5.1-4a.284.284 0 0 1-.265-.332.344.344 0 0 1 .354-.292.284.284 0 0 1 .263.332.344.344 0 0 1-.356.29Z",
  "data-name": "Path 14888"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 11921"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M2765.024 277.98c-1.106-.683-1.955-.2-2.645-.969-.738-.824-.24-1.91-1-2.422-.489-.328-.924-.039-1.493-.127a1.6 1.6 0 0 1-.661-.276l-.306 1.194a1.4 1.4 0 0 1-1.395 1.038l-1.43-.064a.62.62 0 0 0-.571.34l-.862 1.71a.2.2 0 0 0 .17.3l11.27.374a3.4 3.4 0 0 0-1.077-1.098",
  "data-name": "Path 14889",
  opacity: 0.5,
  style: {
    mixBlendMode: "soft-light",
    isolation: "isolate"
  },
  transform: "translate(-2738.863 -270.119)"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 11932"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#d8dee8",
  "data-name": "Group 11931"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 11925"
}, /*#__PURE__*/React.createElement("path", {
  d: "m21.512 13.965-7.314-.012a.21.21 0 0 1-.216-.2v-.465a.206.206 0 0 1 .216-.2l7.314.041a.2.2 0 0 1 .2.192v.449a.2.2 0 0 1-.2.195",
  "data-name": "Path 14890"
}), /*#__PURE__*/React.createElement("path", {
  d: "m14.481 14.129.629 2.306a.35.35 0 0 0 .345.245l4.869-.055a.34.34 0 0 0 .329-.246l.593-2.245Zm1.805 2.171a.175.175 0 0 1-.179.168h-.171a.17.17 0 0 1-.18-.164v-1.787a.173.173 0 0 1 .18-.166h.171a.173.173 0 0 1 .179.165Zm.949-.009a.173.173 0 0 1-.177.167h-.169a.17.17 0 0 1-.178-.163v-1.779a.17.17 0 0 1 .178-.165h.169a.17.17 0 0 1 .177.165Zm.942-.009a.17.17 0 0 1-.175.166h-.168a.17.17 0 0 1-.176-.163v-1.771a.17.17 0 0 1 .176-.165h.168a.17.17 0 0 1 .175.164Zm.933-.009a.17.17 0 0 1-.174.165h-.166a.17.17 0 0 1-.176-.162v-1.763a.17.17 0 0 1 .176-.164h.166a.17.17 0 0 1 .174.163Zm.926-.009a.17.17 0 0 1-.173.164h-.165a.166.166 0 0 1-.173-.161v-1.755a.17.17 0 0 1 .173-.163h.165a.17.17 0 0 1 .173.163Z",
  "data-name": "Path 14891"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 11924"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 11922"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.303 12.864a.284.284 0 0 1-.377-.026.232.232 0 0 1 .026-.347.284.284 0 0 1 .377.027.232.232 0 0 1-.026.346",
  "data-name": "Path 14892"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.649 10.673a.13.13 0 0 0-.169.01l-2.316 1.839c-.058.046-.075.116-.037.156a.13.13 0 0 0 .173-.011l2.313-1.839c.057-.047.074-.115.036-.155",
  "data-name": "Path 14893"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 11923"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.469 12.899a.264.264 0 0 0 .358-.021.23.23 0 0 0-.025-.338.263.263 0 0 0-.357.02.23.23 0 0 0 .024.339",
  "data-name": "Path 14894"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.182 10.682a.13.13 0 0 1 .168.015l2.247 1.869c.056.046.072.114.036.152a.124.124 0 0 1-.164-.014l-2.25-1.869c-.054-.045-.07-.114-.037-.153",
  "data-name": "Path 14895"
})))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 11926"
}, /*#__PURE__*/React.createElement("path", {
  d: "m30.028 11.768-7.542-.1v-.939l7.542.131Z",
  "data-name": "Path 14896"
}), /*#__PURE__*/React.createElement("path", {
  d: "m30.028 13.349-7.542-.036v-.939l7.542.07Z",
  "data-name": "Path 14897"
}), /*#__PURE__*/React.createElement("path", {
  d: "m30.028 14.932-7.542.024v-.939l7.542.01Z",
  "data-name": "Path 14898"
}), /*#__PURE__*/React.createElement("path", {
  d: "m30.028 16.516-7.542.085v-.939l7.542-.05Z",
  "data-name": "Path 14899"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 11927"
}, /*#__PURE__*/React.createElement("path", {
  d: "m27.355 19.123-13.373.322v-.978l13.373-.261Z",
  "data-name": "Path 14900"
}), /*#__PURE__*/React.createElement("path", {
  d: "m27.355 20.728-13.373.429v-.978l13.373-.368Z",
  "data-name": "Path 14901"
}), /*#__PURE__*/React.createElement("path", {
  d: "m27.355 22.332-13.373.536v-.976l13.373-.475Z",
  "data-name": "Path 14902"
}), /*#__PURE__*/React.createElement("path", {
  d: "m27.355 23.937-13.373.643v-.978l13.373-.582Z",
  "data-name": "Path 14903"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 11928"
}, /*#__PURE__*/React.createElement("path", {
  d: "m30.028 19.058-1.759.043v-.912l1.759-.034Z",
  "data-name": "Path 14904"
}), /*#__PURE__*/React.createElement("path", {
  d: "m30.028 20.642-1.762.06v-.912l1.759-.048Z",
  "data-name": "Path 14905"
}), /*#__PURE__*/React.createElement("path", {
  d: "m30.028 22.224-1.759.07v-.912l1.759-.062Z",
  "data-name": "Path 14906"
}), /*#__PURE__*/React.createElement("path", {
  d: "m30.028 23.808-1.759.085v-.912l1.759-.077Z",
  "data-name": "Path 14907"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 11929"
}, /*#__PURE__*/React.createElement("path", {
  d: "m27.355 26.541-13.373.816v-.978l13.373-.755Z",
  "data-name": "Path 14908"
}), /*#__PURE__*/React.createElement("path", {
  d: "m27.355 28.146-13.373.924v-.978l13.373-.862Z",
  "data-name": "Path 14909"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.355 29.749 13.982 30.78v-.978l13.373-.969Z",
  "data-name": "Path 14910"
}), /*#__PURE__*/React.createElement("path", {
  d: "m27.355 31.354-13.373 1.138v-.978l13.373-1.077Z",
  "data-name": "Path 14911"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 11930"
}, /*#__PURE__*/React.createElement("path", {
  d: "m30.028 26.38-1.762.1v-.912l1.759-.1Z",
  "data-name": "Path 14912"
}), /*#__PURE__*/React.createElement("path", {
  d: "m30.028 27.96-1.759.122v-.912l1.759-.113Z",
  "data-name": "Path 14913"
}), /*#__PURE__*/React.createElement("path", {
  d: "m30.028 29.544-1.759.135v-.912l1.759-.127Z",
  "data-name": "Path 14914"
}), /*#__PURE__*/React.createElement("path", {
  d: "m30.028 31.127-1.759.15v-.912l1.759-.142Z",
  "data-name": "Path 14915"
}))))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 11935",
  transform: "translate(1.118 19.718)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#purchases_svg__l)",
  d: "M2533.006 604.012a.17.17 0 0 1-.169-.154 9 9 0 0 0-1.438-4.19 3.12 3.12 0 0 0-2.2-1.607c-2.5 0-3.019 5.737-3.024 5.795a.17.17 0 1 1-.339-.029c.021-.249.556-6.1 3.363-6.107a3.39 3.39 0 0 1 2.477 1.755 9.4 9.4 0 0 1 1.5 4.35.17.17 0 0 1-.154.186Z",
  "data-name": "Path 14916",
  transform: "translate(-2522.255 -597.721)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#purchases_svg__c)",
  d: "m2452.135 723.008 3.287 1.664 1.991-6.111-3.281-8.192-.93.228-1.412 11.766a.64.64 0 0 0 .345.645",
  "data-name": "Path 14917",
  transform: "translate(-2451.785 -704.919)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#purchases_svg__m)",
  d: "m2487.3 718.561-3.281-8.192-.549.135a18 18 0 0 0 .009 2.649c.22 2.789.951 3.565.6 5.511-.294 1.618-.937 1.838-.881 2.926a4.29 4.29 0 0 0 1.871 2.959l.243.123Z",
  "data-name": "Path 14918",
  opacity: 0.35,
  style: {
    mixBlendMode: "multiply",
    isolation: "isolate"
  },
  transform: "translate(-2481.673 -704.919)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#purchases_svg__n)",
  d: "M2500.292 710.369h12.255l4.055 13.093-15.02 1.21Z",
  "data-name": "Path 14919",
  transform: "translate(-2497.946 -704.919)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#purchases_svg__o)",
  d: "M2569.416 606.971a.17.17 0 0 1-.166-.132c-.034-.148-.84-3.657.3-5.378a1.98 1.98 0 0 1 1.351-.9c2.935-.517 4.742 5.786 4.817 6.054a.17.17 0 1 1-.328.092c-.018-.063-1.8-6.276-4.43-5.811a1.63 1.63 0 0 0-1.125.747c-1.056 1.6-.257 5.078-.249 5.113a.17.17 0 0 1-.127.205.2.2 0 0 1-.043.01",
  "data-name": "Path 14920",
  transform: "translate(-2563.273 -600.399)"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 11934",
  opacity: 0.35,
  style: {
    mixBlendMode: "multiply",
    isolation: "isolate"
  }
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#purchases_svg__p)",
  d: "M2552.375 710.369h-6.075a1.65 1.65 0 0 0-.534 1.051c-.095 1.853 4.163 2.461 4.574 5 .3 1.831-1.527 3.945-3.154 4.886-1.714.992-2.875.49-4.034 1.591a3.8 3.8 0 0 0-1 1.716l14.286-1.151Z",
  "data-name": "Path 14921",
  transform: "translate(-2537.774 -704.919)"
})), /*#__PURE__*/React.createElement("circle", {
  cx: 0.476,
  cy: 0.476,
  r: 0.476,
  fill: "url(#purchases_svg__q)",
  "data-name": "Ellipse 439",
  transform: "translate(5.668 6.121)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 0.476,
  cy: 0.476,
  r: 0.476,
  fill: "url(#purchases_svg__r)",
  "data-name": "Ellipse 440",
  transform: "translate(11.88 6.077)"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 11937"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#purchases_svg__s)",
  d: "M3061.475 989.378c.141.225.12.331.1.378-.071.141-.289.038-.816.156a.9.9 0 0 1-.332.023c-.131-.017-.289-.069-.286-.1 0-.013.023-.02.032-.023a36 36 0 0 0 1.042-.428Z",
  "data-name": "Path 14922",
  transform: "translate(-3029.588 -950.712)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#purchases_svg__t)",
  d: "m3080 978.439-.028.539s-.21.185-.291 0a2.8 2.8 0 0 1-.1-.516Z",
  "data-name": "Path 14923",
  transform: "translate(-3048.091 -940.302)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#purchases_svg__u)",
  d: "m3033.1 988.581.287.588.32-.086-.135-.558Z",
  "data-name": "Path 14924",
  transform: "translate(-3003.858 -949.9)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#purchases_svg__v)",
  d: "M3026.016 996.7c.138-.2.281-.2.3-.332a.265.265 0 0 0-.161-.258.36.36 0 0 0-.32.095c-.227.184-.134.424-.353.555a.6.6 0 0 0-.185.137c-.03.034-.1.119-.078.169s.173.041.31.025a.6.6 0 0 0 .322-.087c.099-.076.059-.143.165-.304",
  "data-name": "Path 14925",
  transform: "translate(-2996.351 -957.11)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#purchases_svg__w)",
  d: "M3034.619 712.331a17.6 17.6 0 0 1-.109 3.192 14 14 0 0 0-.229 1.765c-.018 1.411.45 1.574.664 3.149a9.7 9.7 0 0 1-.252 3.711 10 10 0 0 1-.361 1.134c-.149.153-.4.12-.66.088-.227-1.576-.469-3.058-.7-4.635l-1.512-7.075Z",
  "data-name": "Path 14926",
  transform: "translate(-3002.302 -687.068)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#purchases_svg__x)",
  d: "M3033.672 725.371c-.227-1.576-.469-3.058-.7-4.635l-1.512-7.075 3.156-1.331c0 .082.007.161.011.242-1.408 1.443-1.619 2.512-1.544 3.222.09.862.6 1.251.608 2.51.009.9-.247 1.081-.18 1.888a5.4 5.4 0 0 0 .849 2.171 3.78 3.78 0 0 1 .092 2.584 12 12 0 0 1-.122.334c-.147.155-.396.119-.658.09",
  "data-name": "Path 14927",
  opacity: 0.3,
  style: {
    mixBlendMode: "multiply",
    isolation: "isolate"
  },
  transform: "translate(-3002.302 -687.068)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#purchases_svg__y)",
  d: "M2986.823 713.69a18.6 18.6 0 0 0-1.224 3.174 4.5 4.5 0 0 0-.2 1.382 4.3 4.3 0 0 0 .339 1.547 8 8 0 0 1 .543 1.53 8.7 8.7 0 0 1-.125 4.488l-.559.261a32 32 0 0 1-1.772-4.963 17.3 17.3 0 0 1-.638-3.2 13.7 13.7 0 0 1 .719-5.564Z",
  "data-name": "Path 14928",
  transform: "translate(-2956.321 -687.077)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#bfbfbf",
  d: "M29.181 16.068c-1.205.311-2.118.607-2.48 1.281-.382.712.357 1.163.669 2.631.479 2.247-.757 3.2-.191 5.459a6 6 0 0 0 .711 1.673 6.3 6.3 0 0 0 1.962.9c1.276.331 1.865.028 3.541-.015 2.74-.07 3.213.687 4.405.1s2-2 1.685-2.544c-.186-.327-.668-.073-1.418-.431-.967-.461-.872-1.208-1.673-1.776-1.15-.815-2.108.184-3.092-.526s-1.268-2.644-.968-3.829c.2-.774.133-1.592.26-2.38a.5.5 0 0 0-.035-.281c-.189-.431-1.008-.449-1.627-.457a7 7 0 0 0-1.749.195",
  "data-name": "Path 14929"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#bfbfbf",
  d: "M2997.918 660.56c-.4-.22-.254-.951-.844-1.283-.548-.308-.915.185-1.7.014-1.006-.219-1.033-1.168-2-1.392-.694-.161-.863.288-1.836.387a3.9 3.9 0 0 1-3.176-1.162 3.5 3.5 0 0 1-.75-1.286 5.65 5.65 0 0 0-.1 2.91 6 6 0 0 0 .711 1.673 6.3 6.3 0 0 0 1.962.9c1.276.331 1.866.028 3.541-.015 2.741-.07 3.215.687 4.406.1a3.55 3.55 0 0 0 1.622-1.7c-1.013.882-1.546 1.014-1.836.854",
  "data-name": "Path 14930",
  opacity: 0.3,
  style: {
    mixBlendMode: "multiply",
    isolation: "isolate"
  },
  transform: "translate(-2960.334 -633.309)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#dd9e6d",
  d: "M28.3 14.012a3.3 3.3 0 0 0-.269 1.105c.016.445.514.372.514.372v.281a.61.61 0 0 1-.353.561l-.191.089a3.06 3.06 0 0 0 1.975-.387h-.2a.61.61 0 0 1-.589-.5l-.022-.119s.108-1.4-.865-1.402",
  "data-name": "Path 14931"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 11936"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#purchases_svg__z)",
  d: "m2889.836 561.061-1.962-3.384a.11.11 0 0 0-.12-.052l-2.745.642a.11.11 0 0 0-.068.165l2.277 3.641a.11.11 0 0 0 .13.045l2.413-.871Z",
  "data-name": "Path 14932",
  transform: "translate(-2862.852 -539.843)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#purchases_svg__A)",
  d: "m2898.247 565.995-1.588-2.74a.09.09 0 0 0-.1-.042l-2.223.519a.088.088 0 0 0-.055.134l1.843 2.948a.09.09 0 0 0 .106.036l1.953-.706Z",
  "data-name": "Path 14933",
  transform: "translate(-2871.746 -545.162)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#purchases_svg__B)",
  d: "m2906.029 559.659-.127-.22a.08.08 0 0 0-.088-.038l-1.142.257a.08.08 0 0 0-.052.119l.14.239a.08.08 0 0 0 .088.037l1.129-.276a.08.08 0 0 0 .052-.118",
  "data-name": "Path 14934",
  transform: "translate(-2881.584 -541.535)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m22.947 19.069 2.013-.475a.046.046 0 1 0-.021-.09l-2.013.475a.045.045 0 0 0-.034.055.046.046 0 0 0 .055.035",
  "data-name": "Path 14935"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M23.073 19.261h.006l2-.494a.046.046 0 0 0-.022-.09l-2 .494a.046.046 0 0 0 .017.091Z",
  "data-name": "Path 14936"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M24.127 19.478h.006l1.088-.3a.046.046 0 1 0-.025-.089l-1.087.3a.047.047 0 0 0-.032.057.046.046 0 0 0 .05.032",
  "data-name": "Path 14937"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#dd9e6d",
  d: "M23.808 21.337s-.485-.261-.561-.473a3 3 0 0 1-.105-.622l.324.549a.31.31 0 0 0 .159-.246c.035-.2.147-.032.124.116a4 4 0 0 0 .059.676",
  "data-name": "Path 14938"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#bfbfbf",
  d: "M26.895 17.112a3.4 3.4 0 0 0-.834.911c-.786 1.27-.3 2.485-1.006 3.007a1.46 1.46 0 0 1-1.273.122l-.246.166s-.15 1.654 1.825 1.509 2.7-2.694 2.7-2.694Z",
  "data-name": "Path 14939"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#purchases_svg__C)",
  d: "M3007.9 459.531c.067-.011.114-.1.163-.079s.055.146.02.236a.3.3 0 0 1-.11.14.8.8 0 0 1 .171.315 1.14 1.14 0 0 1-.12.744 2.4 2.4 0 0 0 .913 2.238c.48.4.672.21.967.548.573.659-.074 1.489.271 2.411.524 1.4 2.826 1.641 2.921 1.65l.1.009c1.03.077 2.591.194 3.607-.73a3.18 3.18 0 0 0 .9-2.762 3.1 3.1 0 0 0-1.036-1.916 2.83 2.83 0 0 0-1.916-.711c-.525.039-.615.232-1.026.151a2.15 2.15 0 0 1-1.176-.874c-.432-.537-.286-.672-.587-.928-.588-.5-1.19-.02-1.812-.456s-.32-1.105-.906-1.472c-.6-.378-1.683-.14-1.873.387-.158.451.329 1.133.529 1.099",
  "data-name": "Path 14940",
  transform: "translate(-2979.349 -444.907)"
}))))))));

const SvgPxAlert = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 30 31.711"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#dce1eb",
  d: "m29.766 18.915-2.541-5.2A13.6 13.6 0 0 0 10.889.279a13.69 13.69 0 0 0-10.654 11 14.24 14.24 0 0 0 2.378 10.87 15.03 15.03 0 0 1 2.831 8.634.91.91 0 0 0 .908.929h12.705a.91.91 0 0 0 .908-.929v-2.429a.486.486 0 0 1 .472-.483h4.066a2.75 2.75 0 0 0 2.723-2.787V22.3h.49a2.23 2.23 0 0 0 1.942-1.115 2.4 2.4 0 0 0 .108-2.27",
  "data-name": "Path 68747"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#a2b9e2",
  d: "M29.649 21.182a2.3 2.3 0 0 1-1.988 1.118h-.5v2.787a2.783 2.783 0 0 1-2.787 2.787h-4.162a.49.49 0 0 0-.483.483v2.428a.92.92 0 0 1-.929.929h-5.574V0a13.92 13.92 0 0 1 13.935 13.713l2.6 5.2a2.35 2.35 0 0 1-.112 2.269",
  "data-name": "Path 68748"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#d18a56",
  "data-name": "Group 50966"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.619 3.716a2.787 2.787 0 1 0 2.787 2.787 2.783 2.783 0 0 0-2.787-2.787",
  "data-name": "Path 68749"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.548 19.51v1.858a.929.929 0 0 1-1.858 0V19.51a.929.929 0 0 1 1.858 0",
  "data-name": "Path 68750"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#fea832",
  d: "M21.939 19.865a.93.93 0 0 1-.855.576H6.219a.93.93 0 0 1-.855-.576.88.88 0 0 1 .2-1 5.5 5.5 0 0 0 1.282-2.137l2.16-1.863h9.29l2.155 1.858a5.5 5.5 0 0 0 1.282 2.137.88.88 0 0 1 .206 1.005",
  "data-name": "Path 68751"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#c27b48",
  "data-name": "Group 50967"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.509 19.51v1.858a.92.92 0 0 1-.929.929v-3.716a.92.92 0 0 1 .929.929",
  "data-name": "Path 68752"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.58 9.29V3.716a2.787 2.787 0 1 1 0 5.574",
  "data-name": "Path 68753"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#fe9923",
  d: "M21.778 19.865a.93.93 0 0 1-.855.576h-7.432v-5.576h4.645l2.155 1.858a5.5 5.5 0 0 0 1.282 2.137.88.88 0 0 1 .205 1.005",
  "data-name": "Path 68754"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fedb41",
  d: "M20.439 16.722h-13.6a5.4 5.4 0 0 0 .3-1.858v-.932a6.504 6.504 0 0 1 13.007 0v.929a5.4 5.4 0 0 0 .293 1.861",
  "data-name": "Path 68755"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fcbf29",
  d: "M20.321 16.722h-6.8v-9.29a6.51 6.51 0 0 1 6.5 6.5v.929a5.4 5.4 0 0 0 .3 1.861",
  "data-name": "Path 68756"
}));

const SvgPxApproval = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".px-approval_svg__e{fill:#5f5f82}.px-approval_svg__f{fill:#3c3c55}")), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h32v32H0z",
  style: {
    fill: "none"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M133.594 0H123.1a2.1 2.1 0 0 0-2.1 2.1v19.683a2.1 2.1 0 0 0 2.1 2.1h13.994a2.1 2.1 0 0 0 2.1-2.1V5.6Z",
  style: {
    fill: "#e4f2f9"
  },
  transform: "translate(-111.403 4)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M319.5 0H316v23.882h7a2.1 2.1 0 0 0 2.1-2.1V5.6Z",
  style: {
    fill: "#bde0f1"
  },
  transform: "translate(-297.307 4)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M391 0v4.9a.7.7 0 0 0 .7.7h4.9Z",
  style: {
    fill: "#77bee2"
  },
  transform: "translate(-368.808 4)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.825 18.087H13.563a.7.7 0 0 1 0-1.4h10.262a.7.7 0 1 1 0 1.4M23.825 13.889H13.563a.7.7 0 0 1 0-1.4h10.262a.7.7 0 1 1 0 1.4M23.825 22.285H13.563a.7.7 0 1 1 0-1.4h10.262a.7.7 0 1 1 0 1.4",
  className: "px-approval_svg__e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.524 17.387a.7.7 0 0 0-.7-.7h-5.131v1.4h5.131a.7.7 0 0 0 .7-.7M24.524 13.189a.7.7 0 0 0-.7-.7h-5.131v1.4h5.131a.7.7 0 0 0 .7-.7M23.824 22.286a.7.7 0 0 0 0-1.4h-5.131v1.4Z",
  className: "px-approval_svg__f"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.3 254.594a6.3 6.3 0 1 1 6.3-6.3 6.3 6.3 0 0 1-6.3 6.3",
  style: {
    fill: "#49bbff"
  },
  transform: "translate(3 -226.712)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M136 242v12.594A6.3 6.3 0 0 0 136 242",
  style: {
    fill: "#0097ff"
  },
  transform: "translate(-125.703 -226.712)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.077 19.831a.7.7 0 0 0-.989 0l-2.77 2.77-.9-.9a.7.7 0 0 0-.989.99l1.4 1.4a.7.7 0 0 0 .989 0l3.265-3.265a.7.7 0 0 0-.006-.995",
  className: "px-approval_svg__e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.077 19.831a.7.7 0 0 0-.989 0l-1.791 1.794v1.979l2.78-2.78a.7.7 0 0 0 0-.993",
  className: "px-approval_svg__f"
}));

const SvgPxAreaPolicy = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".px-area-policy_svg__cls-5{fill:#1f4254}")), /*#__PURE__*/React.createElement("g", {
  id: "px-area-policy_svg__Group_50397",
  "data-name": "Group 50397",
  transform: "translate(9064 -23237)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-area-policy_svg__icon_placeholder",
  d: "M0 0h32v32H0z",
  style: {
    fill: "none"
  },
  transform: "translate(-9064 23237)"
}), /*#__PURE__*/React.createElement("g", {
  id: "px-area-policy_svg__file",
  transform: "translate(-9055.82 23244.414)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-area-policy_svg__Path_64964",
  d: "M97.585 57.7a1.384 1.384 0 0 0-1.38-1.38h-10.35a1.384 1.384 0 0 0-1.38 1.38v12.88a1.384 1.384 0 0 0 1.38 1.38h7.819l3.91-3.68Z",
  "data-name": "Path 64964",
  style: {
    fill: "#dadee0"
  },
  transform: "translate(-81.945 -53.79)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-area-policy_svg__Path_64965",
  d: "M30.685 3.91a1.384 1.384 0 0 1 1.38-1.38h9.2V1.38A1.384 1.384 0 0 0 39.885 0h-10.35a1.384 1.384 0 0 0-1.38 1.38v12.88a1.384 1.384 0 0 0 1.38 1.38h1.15Z",
  "data-name": "Path 64965",
  style: {
    fill: "#1bb7ea"
  },
  transform: "translate(-28.155)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-area-policy_svg__Path_64966",
  d: "M290.645 322.56h2.53l-3.91 3.68v-2.3a1.384 1.384 0 0 1 1.38-1.38",
  "data-name": "Path 64966",
  style: {
    fill: "#f2f2f2"
  },
  transform: "translate(-277.535 -308.07)"
}), /*#__PURE__*/React.createElement("g", {
  id: "px-area-policy_svg__Group_50324",
  "data-name": "Group 50324",
  transform: "translate(5.635 5.635)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-area-policy_svg__Path_64967",
  d: "M153.94 177.33h6.21a.345.345 0 1 0 0-.69h-6.21a.345.345 0 1 0 0 .69",
  className: "px-area-policy_svg__cls-5",
  "data-name": "Path 64967",
  transform: "translate(-153.595 -174.34)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-area-policy_svg__Path_64968",
  d: "M153.94 126.13h6.21a.345.345 0 1 0 0-.69h-6.21a.345.345 0 1 0 0 .69",
  className: "px-area-policy_svg__cls-5",
  "data-name": "Path 64968",
  transform: "translate(-153.595 -125.44)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-area-policy_svg__Path_64969",
  d: "M153.94 228.53h6.21a.345.345 0 1 0 0-.69h-6.21a.345.345 0 1 0 0 .69",
  className: "px-area-policy_svg__cls-5",
  "data-name": "Path 64969",
  transform: "translate(-153.595 -223.24)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-area-policy_svg__Path_64970",
  d: "M153.94 279.73h3.45a.345.345 0 0 0 0-.69h-3.45a.345.345 0 1 0 0 .69",
  className: "px-area-policy_svg__cls-5",
  "data-name": "Path 64970",
  transform: "translate(-153.595 -272.14)"
})))));

const SvgPxAreaVariance = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#e8edf1",
  d: "M21.518 27.928H4V4.836h14.333l3.185 3.185Z",
  "data-name": "Path 71813"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#eec5a5",
  d: "m20.722 12.801-1.593-.4-4.778 1.194-2.427 4.507a.8.8 0 0 0 .291 1.06l.6.361a.8.8 0 0 0 1.122-.327l1.606-3.212 2.787-.8 2.389-.8Z",
  "data-name": "Path 71814"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#d9dbdd",
  d: "M16.74 7.627H7.585a.4.4 0 0 1 0-.8h9.157a.4.4 0 1 1 0 .8Z",
  "data-name": "Path 71815"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#d9dbdd",
  d: "M12.361 10.016H5.594a.4.4 0 0 1 0-.8h6.768a.4.4 0 0 1 0 .8Z",
  "data-name": "Path 71816"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#d9dbdd",
  d: "M6.787 12.404H5.594a.4.4 0 1 1 0-.8h1.194a.4.4 0 1 1 0 .8Z",
  "data-name": "Path 71817"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#6a7073",
  d: "m12.365 21.16-.8 2.787 2.787-.8Z",
  "data-name": "Path 71818"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#7e8488",
  d: "m25.85 9.964-.3-.3a1.194 1.194 0 0 0-1.689 0l-11.5 11.5 1.991 1.991 11.5-11.5a1.194 1.194 0 0 0-.002-1.691",
  "data-name": "Path 71819"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#eec5a5",
  d: "M27.889 21.956h-1.593l-.728.728a1.6 1.6 0 0 1-1.126.466h-8.1a1.194 1.194 0 0 1-1.194-1.194v-.4a1.194 1.194 0 0 1 1.194-1.194h3.583s1.422-.767.4-3.185l1.593-1.593 1.193-1.193L25.5 16.78h2.389Z",
  "data-name": "Path 71820"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#d9dbdd",
  "data-name": "Group 57446"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21.518 8.021h-3.185V4.836Z",
  "data-name": "Path 71821"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.759 12.404H8.381a.4.4 0 1 1 0-.8h4.38a.4.4 0 1 1 0 .8Z",
  "data-name": "Path 71822"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.166 14.793H5.594a.4.4 0 0 1 0-.8h5.574a.4.4 0 0 1 0 .8Z",
  "data-name": "Path 71823"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.972 17.182H7.983a.4.4 0 1 1 0-.8h1.991a.4.4 0 0 1 0 .8Z",
  "data-name": "Path 71824"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.583 21.96H5.594a.4.4 0 0 1 0-.8h1.991a.4.4 0 0 1 0 .8Z",
  "data-name": "Path 71825"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.972 24.349H5.594a.4.4 0 0 1 0-.8h4.38a.4.4 0 0 1 0 .8Z",
  "data-name": "Path 71826"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.768 19.571H5.594a.4.4 0 0 1 0-.8h5.176a.4.4 0 0 1 0 .8Z",
  "data-name": "Path 71827"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.971 21.96h-.8a.4.4 0 0 1 0-.8h.8a.4.4 0 0 1 0 .8",
  "data-name": "Path 71828"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.388 17.182h-.8a.4.4 0 0 1 0-.8h.8a.4.4 0 0 1 0 .8",
  "data-name": "Path 71829"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.536 10.016h-3.581a.4.4 0 1 1 0-.8h3.583a.4.4 0 0 1 0 .8Z",
  "data-name": "Path 71830"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#6a7073",
  d: "m16.738 16.781 1.194-1.194 1.99 1.99-1.193 1.195Z",
  "data-name": "Path 71831"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#6a7073",
  d: "m23.393 10.128 2.224 2.224a1.194 1.194 0 0 1 0 1.689l-3.02 3.02a.4.4 0 1 1-.563-.563l3.02-3.02a.4.4 0 0 0 0-.563l-2.224-2.224Z",
  "data-name": "Path 71832"
}));

const SvgPxBlackDollar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 30 30"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M15.002 2.502a12.5 12.5 0 1 0 12.5 12.5 12.5 12.5 0 0 0-12.5-12.5m1.76 20.109v2.391h-3.337v-2.416c-2.137-.45-3.949-1.825-4.087-4.249h2.45c.125 1.312 1.025 2.337 3.312 2.337 2.45 0 3-1.225 3-1.987 0-1.037-.55-2.012-3.337-2.674-3.1-.75-5.224-2.025-5.224-4.587 0-2.15 1.737-3.549 3.887-4.012V5.002h3.336v2.437a4.42 4.42 0 0 1 3.562 4.237h-2.45c-.062-1.387-.8-2.337-2.774-2.337-1.875 0-3 .85-3 2.05 0 1.05.812 1.737 3.337 2.387s5.224 1.737 5.224 4.887c-.012 2.287-1.725 3.537-3.9 3.949Z",
  "data-name": "Path 1317"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h30v30H0Z",
  "data-name": "Path 1318"
}));

const SvgPxBlueDollar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 30 30"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#0019d8",
  d: "M15.002 2.502a12.5 12.5 0 1 0 12.5 12.5 12.5 12.5 0 0 0-12.5-12.5m1.76 20.109v2.391h-3.337v-2.416c-2.137-.45-3.949-1.825-4.087-4.249h2.45c.125 1.312 1.025 2.337 3.312 2.337 2.45 0 3-1.225 3-1.987 0-1.037-.55-2.012-3.337-2.674-3.1-.75-5.224-2.025-5.224-4.587 0-2.15 1.737-3.549 3.887-4.012V5.002h3.336v2.437a4.42 4.42 0 0 1 3.562 4.237h-2.45c-.062-1.387-.8-2.337-2.774-2.337-1.875 0-3 .85-3 2.05 0 1.05.812 1.737 3.337 2.387s5.224 1.737 5.224 4.887c-.012 2.287-1.725 3.537-3.9 3.949Z",
  "data-name": "Path 1317"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h30v30H0Z",
  "data-name": "Path 1318"
}));

const SvgPxBridgingFinancing = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".px-bridging-financing_svg__cls-3{fill:#6244bd}.px-bridging-financing_svg__cls-4{fill:#4e2aa5}.px-bridging-financing_svg__cls-5{fill:#e6fcff}.px-bridging-financing_svg__cls-6{fill:#ccebff}.px-bridging-financing_svg__cls-8{fill:#4070ea}.px-bridging-financing_svg__cls-9{fill:#a5c013}.px-bridging-financing_svg__cls-10{fill:#8dae16}")), /*#__PURE__*/React.createElement("g", {
  id: "px-bridging-financing_svg__Group_50396",
  "data-name": "Group 50396",
  transform: "translate(9012 -23237)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-bridging-financing_svg__icon_placeholder",
  d: "M0 0h32v32H0z",
  style: {
    fill: "none"
  },
  transform: "translate(-9012 23237)"
}), /*#__PURE__*/React.createElement("g", {
  id: "px-bridging-financing_svg__payment-method",
  transform: "translate(-9006 23242.797)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-bridging-financing_svg__Path_65044",
  d: "M11.006 22A11.007 11.007 0 0 0 1.89 39.17l7.81 4.76A11.006 11.006 0 1 0 11.006 22m0 0",
  "data-name": "Path 65044",
  style: {
    fill: "#15d4f0"
  },
  transform: "translate(0 -21.008)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-bridging-financing_svg__Path_65045",
  d: "M50.076 23h.051a11 11 0 0 0 3.688-.643 2.52 2.52 0 0 0 .841-1.879V2.522A2.52 2.52 0 0 0 52.133 0h-8.677a2.52 2.52 0 0 0-2.522 2.522v15.564A11 11 0 0 0 50.076 23m0 0",
  className: "px-bridging-financing_svg__cls-3",
  "data-name": "Path 65045",
  transform: "translate(-39.096)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-bridging-financing_svg__Path_65046",
  d: "M43.455 0a2.52 2.52 0 0 0-2.522 2.522v15.564a11.1 11.1 0 0 0 2.7 2.813 2.5 2.5 0 0 1-.036-.421V2.523A2.52 2.52 0 0 1 46.119 0Zm0 0",
  className: "px-bridging-financing_svg__cls-4",
  "data-name": "Path 65046",
  transform: "translate(-39.095)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-bridging-financing_svg__Path_65047",
  d: "M72.9 49.707h7.26a1.2 1.2 0 0 0 1.2-1.2v-17.96a1.2 1.2 0 0 0-1.2-1.2h-1.615a.43.43 0 0 0-.387.243.98.98 0 0 1-.877.547H74.35a.98.98 0 0 1-.877-.547.43.43 0 0 0-.387-.243h-1.609a1.2 1.2 0 0 0-1.2 1.2v17.187a11 11 0 0 0 2.623 1.973m0 0",
  className: "px-bridging-financing_svg__cls-5",
  "data-name": "Path 65047",
  transform: "translate(-67.117 -28.025)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-bridging-financing_svg__Path_65048",
  d: "M71.477 29.352a1.2 1.2 0 0 0-1.2 1.2v17.19a11 11 0 0 0 1.381 1.19 2.5 2.5 0 0 1-.035-.421V30.556a2.5 2.5 0 0 1 .305-1.2Zm0 0",
  className: "px-bridging-financing_svg__cls-6",
  "data-name": "Path 65048",
  transform: "translate(-67.117 -28.033)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-bridging-financing_svg__Path_65049",
  d: "M108.216 176.34h-7.591a.4.4 0 0 0-.4.4v4.853a.4.4 0 0 0 .4.4h7.591a.4.4 0 0 0 .4-.4v-4.853a.4.4 0 0 0-.4-.4m0 0",
  "data-name": "Path 65049",
  style: {
    fill: "#5f83fa"
  },
  transform: "translate(-95.721 -168.418)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-bridging-financing_svg__Path_65050",
  d: "M102.529 181.595v-4.853a.4.4 0 0 1 .4-.4h-2.307a.4.4 0 0 0-.4.4v4.853a.4.4 0 0 0 .4.4h2.307a.4.4 0 0 1-.4-.4m0 0",
  className: "px-bridging-financing_svg__cls-8",
  "data-name": "Path 65050",
  transform: "translate(-95.72 -168.419)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-bridging-financing_svg__Path_65051",
  d: "M162.04 406.169h-1.74a.659.659 0 1 1 0-1.318h1.737a.659.659 0 1 1 0 1.318Zm0 0",
  className: "px-bridging-financing_svg__cls-9",
  "data-name": "Path 65051",
  transform: "translate(-152.473 -386.665)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-bridging-financing_svg__Path_65052",
  d: "M161.049 405.51a.66.66 0 0 1 .659-.659h-1.4a.659.659 0 1 0 0 1.318h1.4a.66.66 0 0 1-.659-.659m0 0",
  className: "px-bridging-financing_svg__cls-10",
  "data-name": "Path 65052",
  transform: "translate(-152.473 -386.665)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-bridging-financing_svg__Path_65053",
  d: "M100.223 204.191h8.394v1.577h-8.394Zm0 0",
  className: "px-bridging-financing_svg__cls-3",
  "data-name": "Path 65053",
  transform: "translate(-95.721 -195.018)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-bridging-financing_svg__Path_65054",
  d: "M100.223 204.191h2.307v1.577h-2.307Zm0 0",
  className: "px-bridging-financing_svg__cls-4",
  "data-name": "Path 65054",
  transform: "translate(-95.721 -195.018)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-bridging-financing_svg__Path_65055",
  d: "M136.486 81.216h-5.846a.659.659 0 1 1 0-1.318h5.846a.659.659 0 1 1 0 1.318m0 0",
  className: "px-bridging-financing_svg__cls-6",
  "data-name": "Path 65055",
  transform: "translate(-124.141 -76.309)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-bridging-financing_svg__Path_65056",
  d: "M132.788 80.557a.66.66 0 0 1 .659-.659h-2.808a.659.659 0 1 0 0 1.318h2.808a.66.66 0 0 1-.659-.659m0 0",
  "data-name": "Path 65056",
  style: {
    fill: "#b8dff4"
  },
  transform: "translate(-124.141 -76.309)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-bridging-financing_svg__Path_65057",
  d: "M99.935 81.216h-1.444a.659.659 0 1 1 0-1.318h1.444a.659.659 0 1 1 0 1.318m0 0",
  "data-name": "Path 65057",
  style: {
    fill: "#fe4675"
  },
  transform: "translate(-93.437 -76.309)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-bridging-financing_svg__Path_65058",
  d: "M99.267 80.557a.66.66 0 0 1 .659-.659h-1.435a.659.659 0 1 0 0 1.318h1.434a.66.66 0 0 1-.658-.659m0 0",
  "data-name": "Path 65058",
  style: {
    fill: "#ec3969"
  },
  transform: "translate(-93.438 -76.309)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-bridging-financing_svg__Path_65059",
  d: "M122.13 144.516v-1.159a.337.337 0 0 0-.337-.337h-6.385a.34.34 0 0 0-.338.337v1.159Zm0 0",
  className: "px-bridging-financing_svg__cls-8",
  "data-name": "Path 65059",
  transform: "translate(-109.901 -136.595)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-bridging-financing_svg__Path_65060",
  d: "M117.715 143.02h-2.307a.34.34 0 0 0-.338.337v1.159h2.307v-1.159a.337.337 0 0 1 .338-.337m0 0",
  "data-name": "Path 65060",
  style: {
    fill: "#205dd9"
  },
  transform: "translate(-109.902 -136.595)"
}), /*#__PURE__*/React.createElement("g", {
  id: "px-bridging-financing_svg__Group_50329",
  "data-name": "Group 50329",
  transform: "translate(6.154 14.997)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-bridging-financing_svg__Path_65061",
  d: "M137.879 334.579h-.521a.366.366 0 0 1 0-.732h.521a.366.366 0 1 1 0 .732m0 0",
  className: "px-bridging-financing_svg__cls-6",
  "data-name": "Path 65061",
  transform: "translate(-136.992 -333.847)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-bridging-financing_svg__Path_65062",
  d: "M180.59 334.579h-.521a.366.366 0 1 1 0-.732h.521a.366.366 0 1 1 0 .732m0 0",
  className: "px-bridging-financing_svg__cls-6",
  "data-name": "Path 65062",
  transform: "translate(-177.784 -333.847)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-bridging-financing_svg__Path_65063",
  d: "M223.3 334.579h-.521a.366.366 0 1 1 0-.732h.521a.366.366 0 0 1 0 .732m0 0",
  className: "px-bridging-financing_svg__cls-6",
  "data-name": "Path 65063",
  transform: "translate(-218.577 -333.847)"
})), /*#__PURE__*/React.createElement("path", {
  id: "px-bridging-financing_svg__Path_65064",
  d: "M252.267 308.885a4.613 4.613 0 1 0-1.688 6.3 4.613 4.613 0 0 0 1.688-6.3m0 0",
  className: "px-bridging-financing_svg__cls-9",
  "data-name": "Path 65064",
  transform: "translate(-232.713 -292.806)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-bridging-financing_svg__Path_65065",
  d: "M248.837 320.092a2.31 2.31 0 0 1 .138-2.518l-.229-.4a2.53 2.53 0 0 1-2.327-1.272 2.31 2.31 0 0 1 .223-2.627 4.613 4.613 0 1 0 4.473 7.951 2.31 2.31 0 0 1-2.279-1.136Zm0 0",
  className: "px-bridging-financing_svg__cls-10",
  "data-name": "Path 65065",
  transform: "translate(-232.72 -299.205)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-bridging-financing_svg__Path_65066",
  d: "M291.887 375.462a.66.66 0 0 1-.466-.193l-1.4-1.4a.659.659 0 1 1 .932-.932l.936.936 2.03-2.03a.659.659 0 1 1 .932.932l-2.5 2.5a.66.66 0 0 1-.464.187m0 0",
  className: "px-bridging-financing_svg__cls-5",
  "data-name": "Path 65066",
  transform: "translate(-276.807 -354.953)"
}))));

const SvgPxBridgingLoan = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#f3f3f3",
  d: "M23.275 6H9.287A1.264 1.264 0 0 0 8 7.287v18.021A1.264 1.264 0 0 0 9.287 26.6h9.526l5.754-3.78V7.287A1.29 1.29 0 0 0 23.275 6",
  "data-name": "Path 71868"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#8ad7f8",
  d: "m24.563 22.82-5.75 3.776 2.875-4.891a2.085 2.085 0 0 0 2.875 1.115",
  "data-name": "Path 71869"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#ced6e0",
  "data-name": "Group 57461"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.716 12.479h13.087v.858H9.716z",
  "data-name": "Rectangle 26179"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.716 15.225h13.087v.858H9.716z",
  "data-name": "Rectangle 26180"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.716 17.928h13.087v.858H9.716z",
  "data-name": "Rectangle 26181"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.716 20.674h13.087v.858H9.716z",
  "data-name": "Rectangle 26182"
})), /*#__PURE__*/React.createElement("g", {
  fill: "#f3705a",
  "data-name": "Group 57462"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.918 10.505V7.759h.644v2.188h1.159v.558Z",
  "data-name": "Path 71870"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.381 10.119a1.4 1.4 0 0 1-1.03.386 1.54 1.54 0 0 1-1.03-.386 1.4 1.4 0 0 1-.429-.987 1.24 1.24 0 0 1 .429-.987 1.4 1.4 0 0 1 1.03-.429 1.54 1.54 0 0 1 1.03.386 1.24 1.24 0 0 1 .429.987 1.5 1.5 0 0 1-.429 1.03m-.215-.987a.93.93 0 0 0-.215-.6.76.76 0 0 0-.558-.257.7.7 0 0 0-.558.257.8.8 0 0 0-.215.6.93.93 0 0 0 .215.6.76.76 0 0 0 .558.257.7.7 0 0 0 .558-.257 1.03 1.03 0 0 0 .215-.6",
  "data-name": "Path 71871"
}), /*#__PURE__*/React.createElement("path", {
  d: "m18.169 10.502-.257-.6h-1.159l-.257.6h-.644l1.159-2.7h.6l1.159 2.7Zm-.858-1.931-.343.772h.687Z",
  "data-name": "Path 71872"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.001 7.759h.6v2.7h-.6l-1.288-1.713v1.716h-.6v-2.7h.558l1.33 1.759z",
  "data-name": "Path 71873"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#415a6b",
  d: "M14.565 24.966a1.45 1.45 0 0 1-.858-.257.73.73 0 0 1-.386-.429.69.69 0 0 1 .129-.687 4 4 0 0 0-.9.386c-.043.043-.086.043-.086.086l-.129.129c-.172.129-.343.172-.472.086a.73.73 0 0 1-.343-.386 1.3 1.3 0 0 0-.129-.172c-.043 0-.086.086-.129.129a1.5 1.5 0 0 1-.257.257.54.54 0 0 1-.558.086.49.49 0 0 1-.257-.472 3.3 3.3 0 0 1 .043-.644c0-.086.129-.172.215-.172s.172.129.172.215a2.5 2.5 0 0 0-.043.558.2.2 0 0 0 .043.129.4.4 0 0 0 .172-.043.6.6 0 0 0 .172-.129.5.5 0 0 1 .429-.257c.129 0 .3.043.472.343a1 1 0 0 0 .129.215.16.16 0 0 0 .129-.043c.043-.043.086-.043.129-.086l.129-.129a2.66 2.66 0 0 1 1.845-.515h.043a4.9 4.9 0 0 1 1.588-.129 1.46 1.46 0 0 1 .815.3.185.185 0 0 1-.215.3 1.6 1.6 0 0 0-.644-.215 3.5 3.5 0 0 0-.944 0 1.25 1.25 0 0 1 .472 1.03v.043a.79.79 0 0 1-.776.473m-.386-1.373a.9.9 0 0 0-.386.215.37.37 0 0 0-.129.386.57.57 0 0 0 .215.257 1.9 1.9 0 0 0 .644.215c.129 0 .3-.043.343-.129a.84.84 0 0 0-.472-.772.22.22 0 0 0-.216-.172Z",
  "data-name": "Path 71874"
}));

const SvgPxBusinessInsight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57654"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#acb3ba",
  d: "M4 18.785h15.806v.823H4z",
  "data-name": "Rectangle 26191"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#cdd6e0",
  d: "M4.659 12.166h2.437v5.96H4.659z",
  "data-name": "Rectangle 26192"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4cdbc4",
  d: "M7.688 9.301h2.437v8.825H7.688z",
  "data-name": "Rectangle 26193"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffd15c",
  d: "M10.684 10.652h2.437v7.475h-2.437z",
  "data-name": "Rectangle 26194"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#84dbff",
  d: "M13.714 13.45h2.437v4.643h-2.437z",
  "data-name": "Rectangle 26195"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ff7058",
  d: "M16.71 8.248h2.437v9.846H16.71z",
  "data-name": "Rectangle 26196"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#cdd6e0",
  d: "M14.339 9.894 9.696 5.251l-4.05 4.05-.461-.461 4.511-4.511 4.643 4.643 3.82-3.82.461.461Z",
  "data-name": "Path 72125"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#40596b",
  "data-name": "Group 57619",
  transform: "translate(4.593 4)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0.823,
  cy: 0.823,
  r: 0.823,
  "data-name": "Ellipse 1468",
  transform: "translate(0 4.248)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 0.823,
  cy: 0.823,
  r: 0.823,
  "data-name": "Ellipse 1469",
  transform: "translate(4.281)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 0.823,
  cy: 0.823,
  r: 0.823,
  "data-name": "Ellipse 1470",
  transform: "translate(8.891 4.643)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 0.823,
  cy: 0.823,
  r: 0.823,
  "data-name": "Ellipse 1471",
  transform: "translate(12.974 .56)"
}))));

const SvgPxBusinessPermit = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#2196f3",
  d: "m23.48 9.862-.092.023-.1-.023h-.767V7.56a.77.77 0 0 0-.767-.767h-11.51a2.3 2.3 0 0 0-2.262 1.918l-.038.192v14.19a2.11 2.11 0 0 0 2.11 2.11H23.48a.58.58 0 0 0 .575-.575V10.437a.58.58 0 0 0-.575-.575",
  "data-name": "Path 64971"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fafafa",
  d: "M16 22.521a4.987 4.987 0 1 1 4.987-4.987A5 5 0 0 1 16 22.521",
  "data-name": "Path 64972"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M20.986 9.861H10.245a.767.767 0 1 1 0-1.534h10.741Z",
  "data-name": "Path 64973"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#607d8b",
  d: "M17.15 19.452a.77.77 0 0 1-.542-.225l-1.151-1.151a.76.76 0 0 1-.225-.542v-2.3a.767.767 0 0 1 1.534 0v1.984l.926.926a.767.767 0 0 1-.542 1.31Z",
  "data-name": "Path 64974"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1d83d4",
  d: "M16 6.793h-5.756a2.3 2.3 0 0 0-2.262 1.918l-.038.192v14.19a2.11 2.11 0 0 0 2.11 2.11H16v-2.682a4.987 4.987 0 0 1 0-9.974V9.862h-5.756a.767.767 0 1 1 0-1.534H16Z",
  "data-name": "Path 64975"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#dadada",
  d: "M16 12.547a4.987 4.987 0 0 0 0 9.974v-3.9l-.542-.542a.76.76 0 0 1-.225-.542v-2.3A.767.767 0 0 1 16 14.47Z",
  "data-name": "Path 64976"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#dedede",
  d: "M14.078 8.327h-3.833a.767.767 0 1 0 0 1.534h5.179V8.327Z",
  "data-name": "Path 64977"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#546d79",
  d: "M15.999 14.465a.767.767 0 0 0-.767.767v2.3a.76.76 0 0 0 .225.542l.542.542Z",
  "data-name": "Path 64978"
}));

const SvgPxCalendarPolicy = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 30 30"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "calendar (14)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#002672",
  d: "M3.385 0h3.052v4.379H3.385Zm0 0",
  "data-name": "Path 11835"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#002672",
  d: "M18.05 0h3.052v4.379H18.05Zm0 0",
  "data-name": "Path 11836"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5367ff",
  d: "M22.874 14.167h-1.619a7.936 7.936 0 1 0 1.619 0m3.557 6.563-4.426 4.439a.5.5 0 0 1-.219.133l-2.82.889a.7.7 0 0 1-.159.026.55.55 0 0 1-.378-.152.54.54 0 0 1-.133-.538l.889-2.82a.6.6 0 0 1 .133-.219l4.439-4.426a.533.533 0 0 1 .75 0l1.918 1.918a.527.527 0 0 1 .007.75Zm0 0",
  "data-name": "Path 11837"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5367ff",
  d: "m20.443 22.859 1.181 1.181 3.676-3.689-1.168-1.168Zm0 0",
  "data-name": "Path 11838"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#002672",
  d: "M24.486 3.179a.645.645 0 0 0-.63-.657h-1.692v2.369a.545.545 0 0 1-.531.551h-4.088a.57.57 0 0 1-.558-.551V2.522H7.501v2.369a.567.567 0 0 1-.551.551H2.861a.55.55 0 0 1-.538-.551V2.522H.638a.65.65 0 0 0-.637.657v4.652h24.485Zm0 0",
  "data-name": "Path 11839"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5367ff",
  d: "m19.623 24.865 1.009-.319-.69-.69Zm0 0",
  "data-name": "Path 11840"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#002672",
  d: "M12.807 8.903h5.508v4.18h-5.508Zm0 0",
  "data-name": "Path 11841"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#002672",
  d: "M21.215 13.083c.279 0 .564-.04.856-.04s.577.04.856.04h1.559v-4.18h-5.109v4.18Zm0 0",
  "data-name": "Path 11842"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#002672",
  d: "M0 14.152h5.109v4.18H0Zm0 0",
  "data-name": "Path 11843"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#002672",
  d: "M6.172 19.402h5.574v4.649H6.172Zm0 0",
  "data-name": "Path 11844"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#002672",
  d: "M6.172 14.152h5.574v4.18H6.172Zm0 0",
  "data-name": "Path 11845"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#002672",
  d: "M0 8.903h5.109v4.18H0Zm0 0",
  "data-name": "Path 11846"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#002672",
  d: "M6.172 8.903h5.574v4.18H6.172Zm0 0",
  "data-name": "Path 11847"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#002672",
  d: "M17.758 14.152h-4.951v4.18h1.075a8.98 8.98 0 0 1 3.876-4.18m0 0",
  "data-name": "Path 11848"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#002672",
  d: "M12.807 19.402v4.649h.484a9 9 0 0 1 .186-4.645Zm0 0",
  "data-name": "Path 11849"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#002672",
  d: "M.001 23.389a.65.65 0 0 0 .637.657H5.11v-4.645H.001Zm0 0",
  "data-name": "Path 11850"
})));

const SvgPxCalendar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  "data-name": "calendar (1)",
  viewBox: "0 0 30 30"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#686bdf",
  d: "M15 0A15 15 0 1 1 0 15 15 15 0 0 1 15 0",
  "data-name": "Path 68668"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#eaf3f9",
  d: "M2.449 23.215A14.99 14.99 0 0 0 15 30h10.91a1.64 1.64 0 0 0 1.646-1.642V8.894h-25.1Z",
  "data-name": "Path 68625"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#c5def3",
  d: "M6.186 8.894H2.449v14.321a15.1 15.1 0 0 0 3.737 3.923z",
  "data-name": "Path 68626"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fb4a34",
  d: "M26.658 2.131H3.338a.89.89 0 0 0-.889.889v5.878h25.1V3.016a.89.89 0 0 0-.891-.885",
  "data-name": "Path 68627"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ed3b2e",
  d: "M7.134 2.131h-3.8a.89.89 0 0 0-.889.889v5.878h3.8V3.016a.89.89 0 0 1 .889-.885",
  "data-name": "Path 68628"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#db2e26",
  "data-name": "Group 50959",
  transform: "translate(5.462 4.333)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0.985,
  cy: 0.985,
  r: 0.985,
  "data-name": "Ellipse 1424"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 0.985,
  cy: 0.985,
  r: 0.985,
  "data-name": "Ellipse 1425",
  transform: "translate(17.105)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 0.985,
  cy: 0.985,
  r: 0.985,
  "data-name": "Ellipse 1426",
  transform: "translate(12.829)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 0.985,
  cy: 0.985,
  r: 0.985,
  "data-name": "Ellipse 1427",
  transform: "translate(8.553)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 0.985,
  cy: 0.985,
  r: 0.985,
  "data-name": "Ellipse 1428",
  transform: "translate(4.276)"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#c5def3",
  d: "m2.557 10.475 1.061.487a.54.54 0 0 0 .452 0l.942-.433a.54.54 0 0 1 .452 0l.943.433a.54.54 0 0 0 .452 0l.942-.433a.54.54 0 0 1 .452 0l.942.433a.54.54 0 0 0 .452 0l.942-.433a.54.54 0 0 1 .452 0l.942.433a.54.54 0 0 0 .452 0l.942-.433a.54.54 0 0 1 .452 0l.943.433a.54.54 0 0 0 .452 0l.942-.433a.54.54 0 0 1 .452 0l.942.433a.54.54 0 0 0 .452 0l.943-.433a.54.54 0 0 1 .452 0l.943.433a.54.54 0 0 0 .452 0l.943-.433a.54.54 0 0 1 .452 0l.943.433a.54.54 0 0 0 .452 0l.943-.433a.54.54 0 0 1 .452 0l.943.433a.54.54 0 0 0 .452 0l1.061-.487a.5.5 0 0 1 .108-.036V8.895h-25.1v1.544a.5.5 0 0 1 .106.036",
  "data-name": "Path 68629"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#a3ccef",
  d: "m2.556 10.475 1.061.487a.54.54 0 0 0 .452 0l.942-.433a.54.54 0 0 1 .452 0l.722.332V8.894H2.449v1.544a.6.6 0 0 1 .107.037",
  "data-name": "Path 68630"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#67aae6",
  d: "M5.311 17.583h1.648a.16.16 0 0 1 .161.161v1.65a.16.16 0 0 1-.161.161H5.311a.16.16 0 0 1-.161-.161v-1.65a.16.16 0 0 1 .161-.161",
  "data-name": "Path 68631"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4c98e0",
  d: "M6.186 17.583h-.875a.16.16 0 0 0-.161.161v1.65a.16.16 0 0 0 .161.161h.875Z",
  "data-name": "Path 68632"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#67aae6",
  d: "M5.311 21.202h1.648a.16.16 0 0 1 .161.161v1.648a.16.16 0 0 1-.161.161H5.311a.16.16 0 0 1-.161-.161v-1.648a.16.16 0 0 1 .161-.161",
  "data-name": "Path 68633"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4c98e0",
  d: "M6.186 21.202h-.875a.16.16 0 0 0-.161.161v1.648a.16.16 0 0 0 .161.161h.875Z",
  "data-name": "Path 68634"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#67aae6",
  d: "M6.959 24.819H5.311a.16.16 0 0 0-.161.161v1.33q.283.247.578.479h1.231a.16.16 0 0 0 .161-.161V24.98a.16.16 0 0 0-.161-.161",
  "data-name": "Path 68635"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4c98e0",
  d: "M6.186 26.79v-1.971h-.875a.16.16 0 0 0-.161.161v1.329l.092.079.169.143.1.082.186.15.032.025h.457Z",
  "data-name": "Path 68636"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#67aae6",
  d: "M8.857 17.583h1.648a.16.16 0 0 1 .161.161v1.65a.16.16 0 0 1-.161.161H8.857a.16.16 0 0 1-.161-.161v-1.65a.16.16 0 0 1 .161-.161",
  "data-name": "Path 68637"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#c5def3",
  d: "M5.311 13.965h1.648a.16.16 0 0 1 .161.161v1.648a.16.16 0 0 1-.161.161H5.311a.16.16 0 0 1-.161-.161v-1.648a.16.16 0 0 1 .161-.161",
  "data-name": "Path 68638"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#a3ccef",
  "data-name": "Group 50960"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.186 13.965h-.875a.16.16 0 0 0-.161.161v1.648a.16.16 0 0 0 .161.161h.875Z",
  "data-name": "Path 68639"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.857 13.965h1.648a.16.16 0 0 1 .161.161v1.648a.16.16 0 0 1-.161.161H8.857a.16.16 0 0 1-.161-.161v-1.648a.16.16 0 0 1 .161-.161",
  "data-name": "Path 68640"
})), /*#__PURE__*/React.createElement("g", {
  fill: "#67aae6",
  "data-name": "Group 50961"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.857 21.202h1.648a.16.16 0 0 1 .161.161v1.648a.16.16 0 0 1-.161.161H8.857a.16.16 0 0 1-.161-.161v-1.648a.16.16 0 0 1 .161-.161",
  "data-name": "Path 68641"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.857 24.819h1.648a.16.16 0 0 1 .161.161v1.648a.16.16 0 0 1-.161.161H8.857a.16.16 0 0 1-.161-.161V24.98a.16.16 0 0 1 .161-.161",
  "data-name": "Path 68642"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.051 15.931h-1.648a.16.16 0 0 1-.161-.161v-1.639a.16.16 0 0 1 .161-.161h1.648a.16.16 0 0 1 .161.161v1.648a.16.16 0 0 1-.161.152",
  "data-name": "Path 68643"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.403 17.583h1.648a.16.16 0 0 1 .161.161v1.65a.16.16 0 0 1-.161.161h-1.648a.16.16 0 0 1-.161-.161v-1.65a.16.16 0 0 1 .161-.161",
  "data-name": "Path 68644"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.403 21.202h1.648a.16.16 0 0 1 .161.161v1.648a.16.16 0 0 1-.161.161h-1.648a.16.16 0 0 1-.161-.161v-1.648a.16.16 0 0 1 .161-.161",
  "data-name": "Path 68645"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.403 24.819h1.648a.16.16 0 0 1 .161.161v1.648a.16.16 0 0 1-.161.161h-1.648a.16.16 0 0 1-.161-.161V24.98a.16.16 0 0 1 .161-.161",
  "data-name": "Path 68646"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.597 15.931h-1.648a.16.16 0 0 1-.161-.161v-1.639a.16.16 0 0 1 .161-.161h1.648a.16.16 0 0 1 .161.161v1.648a.16.16 0 0 1-.161.152",
  "data-name": "Path 68647"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.949 17.583h1.648a.16.16 0 0 1 .161.161v1.65a.16.16 0 0 1-.161.161h-1.648a.16.16 0 0 1-.161-.161v-1.65a.16.16 0 0 1 .161-.161",
  "data-name": "Path 68648"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.949 21.202h1.648a.16.16 0 0 1 .161.161v1.648a.16.16 0 0 1-.161.161h-1.648a.16.16 0 0 1-.161-.161v-1.648a.16.16 0 0 1 .161-.161",
  "data-name": "Path 68649"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#c5def3",
  d: "M15.949 24.819h1.648a.16.16 0 0 1 .161.161v1.648a.16.16 0 0 1-.161.161h-1.648a.16.16 0 0 1-.161-.161V24.98a.16.16 0 0 1 .161-.161",
  "data-name": "Path 68650"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#67aae6",
  "data-name": "Group 50962"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21.143 15.931h-1.648a.16.16 0 0 1-.161-.161v-1.639a.16.16 0 0 1 .161-.161h1.648a.16.16 0 0 1 .161.161v1.648a.16.16 0 0 1-.161.152",
  "data-name": "Path 68651"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.495 17.583h1.648a.16.16 0 0 1 .161.161v1.65a.16.16 0 0 1-.161.161h-1.648a.16.16 0 0 1-.161-.161v-1.65a.16.16 0 0 1 .161-.161",
  "data-name": "Path 68652"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.495 21.202h1.648a.16.16 0 0 1 .161.161v1.648a.16.16 0 0 1-.161.161h-1.648a.16.16 0 0 1-.161-.161v-1.648a.16.16 0 0 1 .161-.161",
  "data-name": "Path 68653"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.693 15.931h-1.648a.16.16 0 0 1-.161-.161v-1.639a.16.16 0 0 1 .161-.161h1.648a.16.16 0 0 1 .161.161v1.648a.16.16 0 0 1-.161.152",
  "data-name": "Path 68654"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.041 17.583h1.652a.16.16 0 0 1 .161.161v1.65a.16.16 0 0 1-.161.161h-1.648a.16.16 0 0 1-.161-.161v-1.65a.16.16 0 0 1 .157-.161",
  "data-name": "Path 68655"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.041 21.202h1.652a.16.16 0 0 1 .161.161v1.648a.16.16 0 0 1-.161.161h-1.648a.16.16 0 0 1-.161-.161v-1.648a.16.16 0 0 1 .157-.161",
  "data-name": "Path 68656"
})), /*#__PURE__*/React.createElement("g", {
  fill: "#c5def3",
  "data-name": "Group 50963"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.495 24.82h1.648a.16.16 0 0 1 .161.161v1.648a.16.16 0 0 1-.161.161h-1.648a.16.16 0 0 1-.161-.161v-1.648a.16.16 0 0 1 .161-.161",
  "data-name": "Path 68657"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.041 24.82h1.652a.16.16 0 0 1 .161.161v1.648a.16.16 0 0 1-.161.161h-1.648a.16.16 0 0 1-.161-.161v-1.648a.16.16 0 0 1 .157-.161",
  "data-name": "Path 68658"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.447 5.559a.48.48 0 0 1-.48-.48V1.17a.48.48 0 0 1 .961 0v3.908a.48.48 0 0 1-.481.481",
  "data-name": "Path 68659"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.727 5.559a.48.48 0 0 1-.48-.48V1.17a.48.48 0 0 1 .961 0v3.908a.48.48 0 0 1-.481.481",
  "data-name": "Path 68660"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15 5.559a.48.48 0 0 1-.48-.48V1.17a.48.48 0 0 1 .961 0v3.908a.48.48 0 0 1-.481.481",
  "data-name": "Path 68661"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.276 5.559a.48.48 0 0 1-.48-.48V1.17a.48.48 0 0 1 .961 0v3.908a.48.48 0 0 1-.481.481",
  "data-name": "Path 68662"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.553 5.559a.48.48 0 0 1-.48-.48V1.17a.48.48 0 0 1 .961 0v3.908a.48.48 0 0 1-.481.481",
  "data-name": "Path 68663"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#a3ccef",
  d: "M27.544 22.94a5.64 5.64 0 0 1-2.01 4.1l-.5.5a7.7 7.7 0 0 1-2.464 2.018 5 5 0 0 1-1.907.443h5.242a1.64 1.64 0 0 0 1.642-1.642v-5.418Z",
  "data-name": "Path 68664"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#85bbeb",
  d: "M24.85 28.358v-.641a6.9 6.9 0 0 1-2.276 1.834 5 5 0 0 1-1.907.443h5.242a1.7 1.7 0 0 0 .291-.026 1.64 1.64 0 0 1-1.35-1.61",
  "data-name": "Path 68665"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#c5def3",
  d: "M23.848 25.124a1.17 1.17 0 0 0-1.17 1.17v.655a3.044 3.044 0 0 1-2.01 3.048 4.85 4.85 0 0 0 2.01-.436 7.55 7.55 0 0 0 2.413-1.977l.49-.49a5.5 5.5 0 0 0 1.971-4.157 3.835 3.835 0 0 1-3.704 2.187",
  "data-name": "Path 68666"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#a3ccef",
  d: "M24.476 26.47a2.12 2.12 0 0 1 .623-1.5 4.8 4.8 0 0 1-1.251.158 1.17 1.17 0 0 0-1.17 1.17v.655a3.044 3.044 0 0 1-2.01 3.048 4.85 4.85 0 0 0 2.01-.436 6.8 6.8 0 0 0 2.236-1.8 2.1 2.1 0 0 1-.438-1.295",
  "data-name": "Path 68667"
}));

const SvgPxCampaign = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".px-campaign_svg__b{fill:#ffdd40}.px-campaign_svg__d{fill:#3c58a0}.px-campaign_svg__e{fill:#deeeff}.px-campaign_svg__f{fill:#d3dcfb}.px-campaign_svg__i{fill:#ff4155}.px-campaign_svg__k{fill:#6289cc}.px-campaign_svg__n{fill:#e80054}.px-campaign_svg__o{fill:#ff7186}")), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h32v32H0z",
  style: {
    fill: "none"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "m6.702 20.014 17.095-8.437a9.557 9.557 0 0 0-17.095 8.437",
  className: "px-campaign_svg__b"
}), /*#__PURE__*/React.createElement("path", {
  d: "M114.695 57.35a1.276 1.276 0 0 1-1.276 1.276h12.527V57.35Z",
  style: {
    fill: "#becaf5"
  },
  transform: "translate(-103.425 -49.113)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.702 8.237v1.276h3.372a1.276 1.276 0 0 0 1.276-1.276Z",
  className: "px-campaign_svg__d"
}), /*#__PURE__*/React.createElement("path", {
  d: "m10.445 9.433.01.011a2.54 2.54 0 0 0-.087 1.737 1.91 1.91 0 0 0 1.062 1.068c.722.33 1.187 2.543 1.344 6.4.114 2.8.024 5.539.015 5.8a1.52 1.52 0 0 0-.363.989 9.57 9.57 0 0 0 8.263-.967l1.836-2.594V9.433Z",
  className: "px-campaign_svg__e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.702 9.433v10.583a9.58 9.58 0 0 0 5.778 5.449 1.44 1.44 0 0 1 .362-.987s.426-11.449-1.393-12.28a2.04 2.04 0 0 1-.931-2.763H6.702Z",
  className: "px-campaign_svg__f"
}), /*#__PURE__*/React.createElement("path", {
  d: "M146.327 0h-10.083a.54.54 0 0 0 0 .766l.051.744a.56.56 0 0 0 .175.8h11.25v-.916A1.4 1.4 0 0 0 146.327 0",
  style: {
    fill: "#2a428c"
  },
  transform: "translate(-125.199 6)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.4 0a1.4 1.4 0 0 0-1.394 1.394v.917h4.648a.56.56 0 0 1-.175-.8l-.052-.745a.54.54 0 0 1 0-.766z",
  style: {
    fill: "#1c2e7a"
  },
  transform: "translate(-22.303 6)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.866 7.155a.449.449 0 1 1-.449-.449.45.45 0 0 1 .449.449",
  className: "px-campaign_svg__i"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.106 7.155a.449.449 0 1 1-.449-.449.45.45 0 0 1 .449.449",
  className: "px-campaign_svg__b"
}), /*#__PURE__*/React.createElement("path", {
  d: "M126.047 18.558a.449.449 0 1 1-.449-.449.45.45 0 0 1 .449.449",
  style: {
    fill: "#88ce65"
  },
  transform: "translate(-114.697 -11.403)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.2 7.156a.3.3 0 0 1 .3-.3h-2.673a.3.3 0 0 0 0 .6H15.5a.3.3 0 0 1-.3-.3",
  className: "px-campaign_svg__d"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.672 7.156a.3.3 0 0 0-.3-.3h-1.953a.3.3 0 1 0 0 .6h1.954a.3.3 0 0 0 .299-.3M20.994 7.455h-.391a.3.3 0 0 1 0-.6h.391a.3.3 0 1 1 0 .6",
  className: "px-campaign_svg__k"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.636 7.455h-.391a.3.3 0 1 1 0-.6h.391a.3.3 0 0 1 0 .6",
  className: "px-campaign_svg__d"
}), /*#__PURE__*/React.createElement("path", {
  d: "M234.155 141.483a1.8 1.8 0 0 0-.458-.061h-7.954a3.135 3.135 0 0 0-.39 4.17 4.02 4.02 0 0 1 .722 4.123l.683 2.622a1.464 1.464 0 0 0 0 2.045h4.286a9.56 9.56 0 0 0 3.112-12.9Z",
  style: {
    fill: "#49b1f7"
  },
  transform: "translate(-210.358 -129.906)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M145.405 141.422h-2.619a1.777 1.777 0 0 0-1.772 1.772v9.416a1.777 1.777 0 0 0 1.772 1.772h3.634a1.464 1.464 0 0 1 0-2.045l-.683-2.622a4.02 4.02 0 0 0-.722-4.123 3.135 3.135 0 0 1 .39-4.17",
  style: {
    fill: "#218ee8"
  },
  transform: "translate(-129.943 -129.906)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m14.186 18.168-.014.02a.73.73 0 0 0-.5-.095 1.23 1.23 0 0 0-.776.617l.116.5a.79.79 0 0 0 .459.548 1.95 1.95 0 0 0 1.112.113.2.2 0 0 1-.02-.055Z",
  className: "px-campaign_svg__i"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.89 16.901a.2.2 0 0 1-.006-.058 1.95 1.95 0 0 0-.95.588.79.79 0 0 0-.173.694l.153.666c.64-1.035 1.271-.52 1.271-.52l.015-.023Z",
  className: "px-campaign_svg__n"
}), /*#__PURE__*/React.createElement("path", {
  d: "m14.12 16.622 1.612-.371-.041-.179a.515.515 0 0 0-.618-.386l-.608.14a.515.515 0 0 0-.386.618ZM17.517 21.859l-.692-1.269v.007a.96.96 0 0 0-.772.055.66.66 0 0 0-.258.527l.683 1.251a.593.593 0 1 0 1.04-.571Z",
  className: "px-campaign_svg__e"
}), /*#__PURE__*/React.createElement("path", {
  d: "m16.87 20.674-.563-1.031-1.2.277.742 1.36c0-.991 1.021-.606 1.021-.606",
  className: "px-campaign_svg__f"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.74 16.961a.99.99 0 0 0-1.113-.176c-.9.405-2.045.784-2.235.846l-.086-.051.4 1.742v.012a4.94 4.94 0 0 1 2.741.352l1.214.53-.7-3.029a2 2 0 0 0-.221-.226",
  className: "px-campaign_svg__e"
}), /*#__PURE__*/React.createElement("path", {
  d: "m19.996 17.322-.795-3.449-.86 1.008a4.94 4.94 0 0 1-2.311 1.516v.012l.289 1.255q.058.036.059.038c.001.002 1.28-.41 2.268-.857a1.09 1.09 0 0 1 1.35.477",
  className: "px-campaign_svg__f"
}), /*#__PURE__*/React.createElement("path", {
  d: "m21.892 16.495-.007.006a1.05 1.05 0 0 0-.735.263.48.48 0 0 0-.082.432q.044.201.068.379a2.1 2.1 0 0 1 .7-.481.23.23 0 0 0 .136-.262Z",
  className: "px-campaign_svg__e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.623 16.17a1.96 1.96 0 0 1-1.151-.28l.451 1.959a1.6 1.6 0 0 1 .266-.327 4 4 0 0 0-.063-.339c-.146-.643.782-.624.782-.624l-.049-.213a.23.23 0 0 0-.236-.176",
  className: "px-campaign_svg__f"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.161 16.561a.3.3 0 0 1-.063-.593l.459-.1a.3.3 0 0 1 .127.586l-.459.1a.3.3 0 0 1-.064.007M22.33 14.946a.3.3 0 0 1-.2-.521l.347-.316a.3.3 0 0 1 .4.444l-.347.316a.3.3 0 0 1-.2.077M23.522 18.516a.3.3 0 0 1-.091-.014l-.447-.143a.3.3 0 0 1 .183-.571l.447.143a.3.3 0 0 1-.091.585Z",
  className: "px-campaign_svg__e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.406 19.236a.59.59 0 0 1 .384-.316.53.53 0 0 1 .381.11l.058.043-.5-2.19a.63.63 0 0 0-.434-.084.66.66 0 0 0-.415.32l.5 2.174c.006-.021.02-.04.026-.057",
  className: "px-campaign_svg__i"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.361 17.617a1.65 1.65 0 0 0-1.133-.224 1.68 1.68 0 0 0-1.06.8l.377 1.637a.265.265 0 0 0 .317.2l1.693-.39a.265.265 0 0 0 .2-.317Z",
  className: "px-campaign_svg__o"
}), /*#__PURE__*/React.createElement("path", {
  d: "m16.379 17.699-.3-1.3a.265.265 0 0 0-.317-.2l-1.693.39a.265.265 0 0 0-.2.317l.314 1.365a1.484 1.484 0 0 1 2.196-.572",
  className: "px-campaign_svg__i"
}), /*#__PURE__*/React.createElement("path", {
  d: "m20.743 16.964-.777-3.372a.436.436 0 0 0-.519-.328h-.009a.436.436 0 0 0-.331.524l.785 3.41a.548.548 0 0 1 .851-.234",
  className: "px-campaign_svg__n"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.208 18.984a.538.538 0 0 0-.852.221l.26 1.131a.436.436 0 0 0 .526.326h.009a.436.436 0 0 0 .323-.522Z",
  className: "px-campaign_svg__o"
}));

const SvgPxCancelation = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".px-cancelation_svg__d{fill:#4b95ff}")), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h32v32H0z",
  style: {
    fill: "none"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "m11.02 23.577-2.443.8a.26.26 0 0 0-.144.379l2.294 3.844a.52.52 0 0 1-.184.709L7.83 30.9a.53.53 0 0 1-.719-.182L4.816 26.87a.264.264 0 0 0-.4-.06l-1.889 1.731A.911.911 0 0 1 1 27.882V17.9a.908.908 0 0 1 1.349-.788l8.826 4.823a.9.9 0 0 1-.155 1.64Z",
  style: {
    fill: "#3778c6"
  },
  transform: "translate(5 -5.679)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.989 1a4.989 4.989 0 1 0 4.989 4.989A4.99 4.99 0 0 0 33.989 1m-3.24 6.688a3.658 3.658 0 0 1 4.939-4.939.333.333 0 0 1 .073.529l-4.483 4.483a.333.333 0 0 1-.529-.073m3.632 1.939a3.65 3.65 0 0 1-2.092-.4.333.333 0 0 1-.073-.529L36.7 4.216a.333.333 0 0 1 .529.073 3.658 3.658 0 0 1-2.847 5.338Z",
  style: {
    fill: "#f26376"
  },
  transform: "translate(-13.688 5)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.331 21.288a.333.333 0 0 1-.333-.332v-5.31a.333.333 0 1 1 .665 0v5.31a.333.333 0 0 1-.332.332M7.331 14.647a.333.333 0 0 1-.333-.33v-.665a.333.333 0 0 1 .665 0v.665a.333.333 0 0 1-.332.33",
  className: "px-cancelation_svg__d"
}));

const SvgPxCommonSetting = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57649"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#ffa001",
  d: "M15.643 6.914v7.216l-6.124 3.517-6.123-3.517V6.914l6.123-3.517Z",
  "data-name": "Path 71924"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f87f02",
  d: "M15.642 6.914v7.216l-6.123 3.517V3.397Z",
  "data-name": "Path 71925"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f4d34e",
  d: "m15.643 6.914-6.124 3.517-6.123-3.517 6.123-3.517Z",
  "data-name": "Path 71926"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffa41f",
  d: "m15.642 6.914-6.123 3.517V3.397Z",
  "data-name": "Path 71927"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#514b7f",
  d: "M19.622 17.031a4 4 0 0 1-.255.615l.456.93-1.249 1.249-.93-.456a4 4 0 0 1-.615.255l-.335.98h-1.767l-.335-.98a4 4 0 0 1-.615-.255l-.93.456-1.25-1.249.456-.93a4 4 0 0 1-.254-.615l-.98-.335v-1.767l.98-.335a4 4 0 0 1 .254-.615l-.456-.93 1.25-1.25.93.456a4 4 0 0 1 .615-.254l.335-.98h1.767l.335.98a4 4 0 0 1 .615.254l.93-.456 1.249 1.25-.456.93a4 4 0 0 1 .255.615l.98.335v1.767Z",
  "data-name": "Path 71928"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2b2f5b",
  d: "M19.622 17.031a4 4 0 0 1-.255.615l.456.93-1.251 1.247-.93-.456a4 4 0 0 1-.615.255l-.335.98h-.883v-9.579h.883l.335.98a4 4 0 0 1 .615.254l.93-.456 1.249 1.25-.456.93a4 4 0 0 1 .255.615l.98.335v1.767Z",
  "data-name": "Path 71929"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f2f2fc",
  d: "M17.929 15.813a2.117 2.117 0 1 1-2.117-2.117 2.117 2.117 0 0 1 2.117 2.117",
  "data-name": "Path 71930"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#d8d8fc",
  d: "M17.929 15.813a2.117 2.117 0 0 1-2.117 2.117v-4.234a2.117 2.117 0 0 1 2.117 2.117",
  "data-name": "Path 71931"
})));

const SvgPxCompany = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".px-company_svg__b{fill:#5aaae0}.px-company_svg__e{fill:#359ed8}.px-company_svg__f{fill:#f7f769}.px-company_svg__g{fill:#ffc943}.px-company_svg__h{fill:#005889}")), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h32v32H0z",
  style: {
    fill: "none"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.001 10.77h6.548v16.357H4.001ZM20.656 10.77h6.606v16.357h-6.606Z",
  className: "px-company_svg__b"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.652 2h10.1v23.127h-10.1Z",
  style: {
    fill: "#7dc7ff"
  },
  transform: "translate(-8.098 2)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.93 44.053a1.51 1.51 0 0 0 .73-1.289 1.542 1.542 0 1 0-3.084 0 1.51 1.51 0 0 0 .73 1.289 2.28 2.28 0 0 0-1.5 2.135v3.043h4.625v-3.043a2.28 2.28 0 0 0-1.5-2.135Z",
  style: {
    fill: "#f73445"
  },
  transform: "translate(-12.495 -22.104)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.108 12.292h.777v.761h-.777ZM12.108 13.813h.777v.761h-.777ZM12.108 15.335h.777v.761h-.777ZM12.108 16.856h.777v.761h-.777ZM13.662 12.292h.777v.761h-.777ZM13.662 13.813h.777v.761h-.777ZM13.662 15.335h.777v.761h-.777ZM13.662 16.856h.777v.761h-.777ZM15.217 12.292h.777v.761h-.777ZM15.217 13.813h.777v.761h-.777ZM15.217 15.335h.777v.761h-.777ZM15.217 16.856h.777v.761h-.777ZM16.771 12.292h.777v.761h-.777ZM13.662 10.77h.777v.761h-.777ZM15.217 10.77h.777v.761h-.777ZM16.771 10.77h.777v.761h-.777ZM16.771 13.813h.777v.761h-.777ZM16.771 15.335h.777v.761h-.777ZM16.771 16.856h.777v.761h-.777ZM18.325 12.292h.777v.761h-.777ZM18.325 13.813h.777v.761h-.777ZM18.325 15.335h.777v.761h-.777ZM18.325 16.856h.777v.761h-.777Z",
  className: "px-company_svg__e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.556 23.46a1.13 1.13 0 0 0 .449-.9 1.157 1.157 0 1 0-2.313 0 1.13 1.13 0 0 0 .449.9 1.9 1.9 0 0 0-1.22 1.766v1.9h3.855v-1.9a1.9 1.9 0 0 0-1.22-1.766",
  className: "px-company_svg__f"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.053 22.318a1.13 1.13 0 0 0 .449-.9 1.157 1.157 0 1 0-2.313 0 1.13 1.13 0 0 0 .449.9 1.9 1.9 0 0 0-1.22 1.766v3.043h3.854v-3.043a1.9 1.9 0 0 0-1.219-1.766",
  className: "px-company_svg__g"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.099 23.46a1.13 1.13 0 0 0 .449-.9 1.157 1.157 0 1 0-2.313 0 1.13 1.13 0 0 0 .449.9 1.9 1.9 0 0 0-1.22 1.766v1.9h3.854v-1.9a1.9 1.9 0 0 0-1.219-1.766",
  className: "px-company_svg__f"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.602 22.318a1.13 1.13 0 0 0 .449-.9 1.157 1.157 0 1 0-2.313 0 1.13 1.13 0 0 0 .449.9 1.9 1.9 0 0 0-1.22 1.766v3.043h3.854v-3.043a1.9 1.9 0 0 0-1.219-1.766",
  className: "px-company_svg__g"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.596 13.433h.777v6.086h-.777ZM24.93 13.433h.777v6.086h-.777ZM5.502 13.433h.777v6.086h-.777ZM7.838 13.433h.777v6.086h-.777Z",
  className: "px-company_svg__h"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.496 5.064h6.217v3.8h-6.217Z",
  className: "px-company_svg__e"
}));

const SvgPxConstructionInfo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".px-construction-info_svg__cls-4{fill:#273b7a}.px-construction-info_svg__cls-7{fill:#fee187}.px-construction-info_svg__cls-8{fill:#ffc61b}")), /*#__PURE__*/React.createElement("g", {
  id: "px-construction-info_svg__Group_50400",
  "data-name": "Group 50400",
  transform: "translate(9168 -23289)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-construction-info_svg__icon_placeholder",
  d: "M0 0h32v32H0z",
  style: {
    fill: "none"
  },
  transform: "translate(-9168 23289)"
}), /*#__PURE__*/React.createElement("g", {
  id: "px-construction-info_svg__worker",
  transform: "translate(-9163.421 23294)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "px-construction-info_svg__Ellipse_808",
  cx: 11.5,
  cy: 11.5,
  r: 11.5,
  "data-name": "Ellipse 808",
  style: {
    fill: "#366695"
  },
  transform: "translate(.42 .001)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-construction-info_svg__Path_65140",
  d: "m216.426 126.637 5.463 5.463a11.51 11.51 0 0 0 7.713-9.369l-7.868-7.868Z",
  "data-name": "Path 65140",
  style: {
    fill: "#38c6d9"
  },
  transform: "translate(-206.574 -109.704)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-construction-info_svg__Path_65141",
  d: "m216.426 126.637 5.463 5.463a11.51 11.51 0 0 0 7.713-9.369l-7.868-7.868Z",
  className: "px-construction-info_svg__cls-4",
  "data-name": "Path 65141",
  transform: "translate(-206.574 -109.704)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-construction-info_svg__Rectangle_21325",
  d: "M0 0h3.833v3.833H0z",
  "data-name": "Rectangle 21325",
  style: {
    fill: "#fcd088"
  },
  transform: "translate(9.713 13.127)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-construction-info_svg__Rectangle_21326",
  d: "M0 0h1.942v3.833H0z",
  "data-name": "Rectangle 21326",
  style: {
    fill: "#ddab62"
  },
  transform: "translate(11.604 13.127)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-construction-info_svg__Path_65142",
  d: "m125.563 338.415-2.031-.406-.359-.524a.25.25 0 0 0-.3-.088h-.01a4.7 4.7 0 0 1-3.734 0 .25.25 0 0 0-.3.085l-.37.526-2.031.406a2.21 2.21 0 0 0-1.779 2.17v2.724a11.5 11.5 0 0 0 12.7 0v-2.724a2.21 2.21 0 0 0-1.786-2.169",
  className: "px-construction-info_svg__cls-7",
  "data-name": "Path 65142",
  transform: "translate(-109.362 -322.221)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-construction-info_svg__Path_65143",
  d: "m260.025 338.415-2.031-.406-.359-.524a.25.25 0 0 0-.3-.088h-.01a4.7 4.7 0 0 1-1.893.384v7.436h.026a11.45 11.45 0 0 0 6.35-1.912v-2.724a2.21 2.21 0 0 0-1.783-2.166",
  className: "px-construction-info_svg__cls-8",
  "data-name": "Path 65143",
  transform: "translate(-243.824 -322.221)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-construction-info_svg__Path_65144",
  d: "M162.341 100.155a5 5 0 0 0 .031-.562 4.15 4.15 0 1 0-8.286 0 5 5 0 0 0 .031.562c-.4.1-.593.723-.427 1.384s.63 1.119 1.034 1.018a.5.5 0 0 0 .1-.042c.749 1.5 1.992 2.722 3.4 2.722s2.652-1.219 3.4-2.722a.5.5 0 0 0 .1.042c.4.1.867-.354 1.034-1.018s-.015-1.28-.417-1.384",
  "data-name": "Path 65144",
  style: {
    fill: "#ffedb5"
  },
  transform: "translate(-146.6 -90.926)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-construction-info_svg__Path_65145",
  d: "M259.564 100.155a5 5 0 0 0 .031-.562 4.27 4.27 0 0 0-4.143-4.39h-.026v10.033h.026c1.408 0 2.652-1.219 3.4-2.722a.5.5 0 0 0 .1.042c.4.1.867-.354 1.034-1.018s-.021-1.279-.422-1.383",
  "data-name": "Path 65145",
  style: {
    fill: "#e8cf89"
  },
  transform: "translate(-243.822 -90.926)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-construction-info_svg__Path_65146",
  d: "M162.047 182.385a6.6 6.6 0 0 0 .271 1.368l.361-.013a1.77 1.77 0 0 1 .671-1.407c.762-.71-1.303.052-1.303.052",
  "data-name": "Path 65146",
  style: {
    fill: "#494948"
  },
  transform: "translate(-154.638 -173.853)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-construction-info_svg__Path_65147",
  d: "M318.652 182.385a6.6 6.6 0 0 1-.271 1.368l-.361-.013a1.77 1.77 0 0 0-.671-1.407c-.762-.71 1.303.052 1.303.052",
  "data-name": "Path 65147",
  style: {
    fill: "#303030"
  },
  transform: "translate(-302.802 -173.853)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-construction-info_svg__Path_65148",
  d: "M166.565 85.547a4.67 4.67 0 0 0-.987-2.952l.127-.146a.226.226 0 0 0-.023-.319l-.791-.684a.226.226 0 0 0-.319.023l-.119.138a4.4 4.4 0 0 0-1.554-.568v-.223a.226.226 0 0 0-.226-.226h-1.045a.226.226 0 0 0-.226.226v.223a4.4 4.4 0 0 0-1.554.568l-.119-.138a.226.226 0 0 0-.319-.023l-.791.684a.226.226 0 0 0-.023.319l.127.146a4.67 4.67 0 0 0-.987 2.952Z",
  className: "px-construction-info_svg__cls-7",
  "data-name": "Path 65148",
  transform: "translate(-150.522 -76.97)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-construction-info_svg__Path_65149",
  d: "m258.877 82.595.127-.146a.226.226 0 0 0-.023-.319l-.791-.684a.226.226 0 0 0-.319.023l-.119.138a4.4 4.4 0 0 0-1.554-.568v-.223a.226.226 0 0 0-.226-.226h-.548v4.956h4.44a4.67 4.67 0 0 0-.987-2.951",
  className: "px-construction-info_svg__cls-8",
  "data-name": "Path 65149",
  transform: "translate(-243.82 -76.969)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-construction-info_svg__Path_65150",
  d: "M158.262 163.74a8.75 8.75 0 0 0-4.547 1.174.1.1 0 0 0 .055.194h8.985a.1.1 0 0 0 .055-.194 8.75 8.75 0 0 0-4.548-1.174",
  "data-name": "Path 65150",
  style: {
    fill: "#ff5419"
  },
  transform: "translate(-146.632 -156.384)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-construction-info_svg__Path_65151",
  d: "M260 164.914a8.75 8.75 0 0 0-4.547-1.174h-.026v1.367h4.518a.1.1 0 0 0 .055-.193",
  "data-name": "Path 65151",
  style: {
    fill: "#ff0f27"
  },
  transform: "translate(-243.822 -156.384)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-construction-info_svg__Path_65152",
  d: "m168.148 353.764-.929.186v6.209a11.5 11.5 0 0 0 7.976 0v-6.209l-.929-.186v2.81h-6.118Z",
  className: "px-construction-info_svg__cls-4",
  "data-name": "Path 65152",
  transform: "translate(-159.578 -337.872)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-construction-info_svg__Path_65153",
  d: "M258.511 353.764v2.81h-3.085v4.3h.026a11.5 11.5 0 0 0 3.988-.713v-6.211Z",
  "data-name": "Path 65153",
  style: {
    fill: "#121149"
  },
  transform: "translate(-243.822 -337.872)"
}))));

const SvgPxCreditControl = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#b5e6a8",
  d: "M28.284 7.085v14.524a1.466 1.466 0 0 1-1.466 1.466H12.773l7.206-15.99Z",
  "data-name": "Path 71760"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#a5d998",
  d: "M26.817 4h-1.954a1.466 1.466 0 0 1 1.466 1.466v16.143a1.466 1.466 0 0 1-1.466 1.466h1.954a1.466 1.466 0 0 0 1.466-1.466V5.466A1.466 1.466 0 0 0 26.817 4",
  "data-name": "Path 71761"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57445"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57438"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#65b9d7",
  d: "M28.283 5.466A1.466 1.466 0 0 0 26.817 4H5.466A1.466 1.466 0 0 0 4 5.466v1.622h24.283Z",
  "data-name": "Path 71762"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#56aac7",
  d: "M26.817 4h-1.954a1.466 1.466 0 0 1 1.466 1.466v1.622h1.954V5.466A1.466 1.466 0 0 0 26.817 4",
  "data-name": "Path 71763"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffe563",
  d: "m12.773 23.075 7.206-15.99H4v14.578a1.466 1.466 0 0 0 1.477 1.466Z",
  "data-name": "Path 71764"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57440"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M24.666 17.609H7.412a1.1 1.1 0 0 1-1.1-1.1v-3.9a1.1 1.1 0 0 1 1.1-1.1h17.254a1.1 1.1 0 0 1 1.1 1.1v3.9a1.1 1.1 0 0 1-1.1 1.1",
  "data-name": "Path 71765"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#ff5781",
  "data-name": "Group 57439"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.851 12.743a.366.366 0 0 0-.366.366v2.894a.367.367 0 1 0 .733 0v-2.894a.366.366 0 0 0-.367-.366",
  "data-name": "Path 71766"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.148 13.476a.367.367 0 0 0 0-.733H14.94a.366.366 0 0 0-.366.366v2.868a.366.366 0 0 0 .366.366h1.208a.367.367 0 0 0 0-.733h-.842v-.7h.753a.367.367 0 1 0 0-.733h-.753v-.7z",
  "data-name": "Path 71767"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.333 12.743h-.8a.367.367 0 0 0-.366.369v2.76a.384.384 0 0 0 .374.412c.024 0 .591 0 .818-.006a1.6 1.6 0 0 0 1.471-1.764 1.563 1.563 0 0 0-1.497-1.771m.017 2.8h-.441v-2.074h.428c.712 0 .768.794.768 1.038-.009.71-.386 1.032-.759 1.038Z",
  "data-name": "Path 71768"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.84 15.314a.366.366 0 0 0-.516.045.84.84 0 0 1-.631.278 1.081 1.081 0 1 1 .6-1.977.366.366 0 1 0 .41-.607 1.813 1.813 0 1 0-1.014 3.317 1.56 1.56 0 0 0 1.192-.539.367.367 0 0 0-.041-.517",
  "data-name": "Path 71769"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.833 12.743h-1.6a.367.367 0 0 0 0 .733h.429v2.527a.367.367 0 1 0 .733 0v-2.527h.436a.367.367 0 0 0 0-.733Z",
  "data-name": "Path 71770"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.921 13.862a1.14 1.14 0 0 0-1.161-1.119h-.77a.366.366 0 0 0-.366.366v2.894a.367.367 0 1 0 .733 0v-.807l.923 1.049a.374.374 0 0 0 .517.033.366.366 0 0 0 .033-.517l-.731-.83a1.13 1.13 0 0 0 .822-1.069m-1.161.386h-.4v-.773h.4a.388.388 0 1 1 0 .771Z",
  "data-name": "Path 71771"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57441"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M5.832 5.94a.367.367 0 0 0 0-.733.367.367 0 0 0 0 .733",
  "data-name": "Path 71772"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57442"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M7.361 5.94a.367.367 0 0 0 0-.733.367.367 0 0 0 0 .733",
  "data-name": "Path 71773"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57443"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M8.89 5.94a.367.367 0 0 0 0-.733.367.367 0 0 0 0 .733",
  "data-name": "Path 71774"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57444"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#ff5781",
  d: "m20.46 19.059.015 9.224 2.648-3.109 4.084.175Z",
  "data-name": "Path 71775"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ff4170",
  d: "m23.538 25.191-.815-1.853a.367.367 0 1 0-.672.293l.811 1.849.261-.307Z",
  "data-name": "Path 71776"
}))));

const SvgPxCreditNote = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 30 30"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 9101"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h30v30H0z",
  "data-name": "Rectangle 6409"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 8916"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 8915"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#002672",
  d: "M.515 7.09h6.516V.515Z",
  "data-name": "Path 12083"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 8920"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 8919"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#002672",
  d: "M4.395 19.395h10.471a8.8 8.8 0 0 1 8.044-5.273V2.637A2.64 2.64 0 0 0 20.273 0H8.789v7.969a.88.88 0 0 1-.879.879H0V27.3A2.69 2.69 0 0 0 2.637 30h15.054a8.92 8.92 0 0 1-3.391-5.332H4.4a.879.879 0 1 1 0-1.758h9.727a8.8 8.8 0 0 1 .178-1.758h-9.9a.879.879 0 0 1 0-1.758Zm7.031-14.063h7.09a.879.879 0 0 1 0 1.758h-7.09a.879.879 0 1 1 0-1.758m0 3.516h7.09a.879.879 0 1 1 0 1.758h-7.09a.879.879 0 1 1 0-1.758m-7.031 3.515h14.121a.879.879 0 1 1 0 1.758H4.395a.879.879 0 0 1 0-1.758m0 3.516H15.33a.879.879 0 0 1 0 1.758H4.395a.879.879 0 0 1 0-1.758",
  "data-name": "Path 12085"
}))), /*#__PURE__*/React.createElement("path", {
  fill: "#5367ff",
  d: "M22.86 15.759a6.86 6.86 0 1 0 6.86 6.86 6.86 6.86 0 0 0-6.86-6.86M19.4 26.084l-.693.693a5.886 5.886 0 0 1 0-8.315l.693.697a4.905 4.905 0 0 0 0 6.93Zm3.46-3.955a1.956 1.956 0 0 1 .49 3.85v1.05h-.98v-1.05a1.96 1.96 0 0 1-1.47-1.89h.98a.98.98 0 1 0 .98-.98 1.956 1.956 0 0 1-.49-3.85v-1.05h.98v1.05a1.96 1.96 0 0 1 1.47 1.89h-.98a.98.98 0 1 0-.98.98m4.158 4.648-.693-.693a4.905 4.905 0 0 0 0-6.93l.693-.693a5.886 5.886 0 0 1 0 8.315Z",
  "data-name": "Path 12241"
})));

const SvgPxDefaultCalendar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".px-default-calendar_svg__cls-3{fill:#2196f3}.px-default-calendar_svg__cls-4{fill:#1976d2}")), /*#__PURE__*/React.createElement("g", {
  id: "px-default-calendar_svg__Group_50398",
  "data-name": "Group 50398",
  transform: "translate(9116 -23237)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-default-calendar_svg__icon_placeholder",
  d: "M0 0h32v32H0z",
  style: {
    fill: "none"
  },
  transform: "translate(-9116 23237)"
}), /*#__PURE__*/React.createElement("g", {
  id: "px-default-calendar_svg__calendar",
  transform: "translate(-9111 23242)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-default-calendar_svg__Path_64955",
  d: "M22.042 171.52H.958a.96.96 0 0 0-.958.958v11.462a2.88 2.88 0 0 0 2.875 2.875h17.25A2.88 2.88 0 0 0 23 183.94v-11.462a.96.96 0 0 0-.958-.958m0 0",
  "data-name": "Path 64955",
  style: {
    fill: "#eceff1"
  },
  transform: "translate(0 -163.815)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-default-calendar_svg__Path_64956",
  d: "M20.125 64H2.875A2.875 2.875 0 0 0 0 66.875v2.913h23v-2.913A2.875 2.875 0 0 0 20.125 64m0 0",
  className: "px-default-calendar_svg__cls-3",
  "data-name": "Path 64956",
  transform: "translate(0 -61.125)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-default-calendar_svg__Path_64957",
  d: "M87.249 0h-.958a.96.96 0 0 0-.958.958v3.834a.96.96 0 0 0 .958.958h.958a.96.96 0 0 0 .958-.958V.958A.96.96 0 0 0 87.249 0m0 0",
  className: "px-default-calendar_svg__cls-4",
  "data-name": "Path 64957",
  transform: "translate(-81.499)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-default-calendar_svg__Path_64958",
  d: "M364.585 0h-.958a.96.96 0 0 0-.958.958v3.834a.96.96 0 0 0 .958.958h.958a.96.96 0 0 0 .958-.958V.958a.96.96 0 0 0-.958-.958m0 0",
  className: "px-default-calendar_svg__cls-4",
  "data-name": "Path 64958",
  transform: "translate(-346.376)"
}), /*#__PURE__*/React.createElement("g", {
  id: "px-default-calendar_svg__Group_50323",
  "data-name": "Group 50323",
  transform: "translate(2.875 10.542)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-default-calendar_svg__Path_64959",
  d: "M67.115 234.668h-2.4a.72.72 0 0 0-.719.719v2.4a.72.72 0 0 0 .719.719h2.4a.72.72 0 0 0 .719-.719v-2.4a.72.72 0 0 0-.719-.719m0 0",
  className: "px-default-calendar_svg__cls-3",
  "data-name": "Path 64959",
  transform: "translate(-64 -234.668)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-default-calendar_svg__Path_64960",
  d: "M67.115 362.668h-2.4a.72.72 0 0 0-.719.719v2.4a.72.72 0 0 0 .719.719h2.4a.72.72 0 0 0 .719-.719v-2.4a.72.72 0 0 0-.719-.719m0 0",
  className: "px-default-calendar_svg__cls-3",
  "data-name": "Path 64960",
  transform: "translate(-64 -356.918)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-default-calendar_svg__Path_64961",
  d: "M216.447 234.668h-2.4a.72.72 0 0 0-.719.719v2.4a.72.72 0 0 0 .719.719h2.4a.72.72 0 0 0 .719-.719v-2.4a.72.72 0 0 0-.719-.719m0 0",
  className: "px-default-calendar_svg__cls-3",
  "data-name": "Path 64961",
  transform: "translate(-206.624 -234.668)"
})), /*#__PURE__*/React.createElement("path", {
  id: "px-default-calendar_svg__Path_64962",
  d: "M216.447 362.668h-2.4a.72.72 0 0 0-.719.719v2.4a.72.72 0 0 0 .719.719h2.4a.72.72 0 0 0 .719-.719v-2.4a.72.72 0 0 0-.719-.719m0 0",
  "data-name": "Path 64962",
  style: {
    fill: "#90caf9"
  },
  transform: "translate(-203.749 -346.376)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-default-calendar_svg__Path_64963",
  d: "M365.783 234.668h-2.4a.72.72 0 0 0-.719.719v2.4a.72.72 0 0 0 .719.719h2.4a.72.72 0 0 0 .719-.719v-2.4a.72.72 0 0 0-.719-.719m0 0",
  className: "px-default-calendar_svg__cls-3",
  "data-name": "Path 64963",
  transform: "translate(-346.376 -224.126)"
}))));

const SvgPxDesignation = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".px-designation_svg__b{fill:#ffaf10}.px-designation_svg__c{fill:#445ea0}.px-designation_svg__e{fill:#293d7c}.px-designation_svg__f{fill:#1a2b63}.px-designation_svg__i{fill:#c3ddf4}.px-designation_svg__j{fill:#ef8318}.px-designation_svg__k{fill:#69cdff}.px-designation_svg__l{fill:#5dc1d8}.px-designation_svg__m{fill:#28a5a5}.px-designation_svg__n{fill:#52bbef}.px-designation_svg__o{fill:#1e99d6}")), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h32v32H0z",
  style: {
    fill: "none"
  }
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(2.394 3.268)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 13,
  cy: 13,
  r: 13,
  className: "px-designation_svg__b",
  transform: "translate(.563 -.268)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.282 19.423h5.74v2.454h-5.74z",
  className: "px-designation_svg__c"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h1.055v2.454H0z",
  style: {
    fill: "#2e4c89"
  },
  transform: "translate(9.282 19.423)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.707 23.153a.267.267 0 0 1-.266.266H6.867a.267.267 0 0 1-.266-.266V22.09a.267.267 0 0 1 .266-.266h10.577a.267.267 0 0 1 .266.266Z",
  className: "px-designation_svg__e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.653 23.153V22.09a.267.267 0 0 1 .266-.266H6.867a.267.267 0 0 0-.266.266v1.063a.267.267 0 0 0 .266.266h1.055a.267.267 0 0 1-.269-.266",
  className: "px-designation_svg__f"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 18.945a.533.533 0 0 0 .532.531h15.954v-3.558H0Z",
  className: "px-designation_svg__e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.055 18.945v-3.027H0v3.027a.533.533 0 0 0 .532.531h1.054a.533.533 0 0 1-.531-.531",
  className: "px-designation_svg__f"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.486 14.488a.213.213 0 0 1 .213-.213H24.3V2.767a.586.586 0 0 0-.584-.584H.584A.586.586 0 0 0 0 2.767v13.2h16.486Z",
  className: "px-designation_svg__c"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.3 88.594a.213.213 0 0 1 .213-.213h6.437V77.723a.267.267 0 0 0-.266-.266H22.25a.267.267 0 0 0-.266.266v10.919a.267.267 0 0 0 .266.266H37.3z",
  style: {
    fill: "#eef6ff"
  },
  transform: "translate(-20.816 -74.105)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 0.739,
  cy: 0.739,
  r: 0.739,
  className: "px-designation_svg__c",
  transform: "translate(11.412 17.003)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.13 10.204a.267.267 0 0 1-.266.266h-8.422a.267.267 0 0 1-.266-.266V6.339a.267.267 0 0 1 .266-.266h8.422a.267.267 0 0 1 .266.266z",
  className: "px-designation_svg__b"
}), /*#__PURE__*/React.createElement("path", {
  d: "M248.96 132.789v-3.865a.267.267 0 0 1 .266-.266h-1.055a.267.267 0 0 0-.266.266v3.865a.267.267 0 0 0 .266.266h1.055a.267.267 0 0 1-.266-.266",
  style: {
    fill: "#ff9518"
  },
  transform: "translate(-234.729 -122.585)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.906 11.997h-2.291a.4.4 0 1 1 0-.8h2.291a.4.4 0 1 1 0 .8M15.906 13.209h-2.291a.4.4 0 0 1 0-.8h2.291a.4.4 0 0 1 0 .8M18.671 11.997h-1.7a.4.4 0 0 1 0-.8h1.7a.4.4 0 1 1 0 .8M18.671 13.209h-1.7a.4.4 0 0 1 0-.8h1.7a.4.4 0 0 1 0 .8M21.886 11.997h-2.17a.4.4 0 0 1 0-.8h2.17a.4.4 0 0 1 0 .8M21.886 13.209h-2.17a.4.4 0 0 1 0-.8h2.17a.4.4 0 0 1 0 .8",
  className: "px-designation_svg__i"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.1 5.139a.267.267 0 0 1-.266.266h-.585a.267.267 0 0 1-.266-.266v-.585a.267.267 0 0 1 .266-.266h.585a.267.267 0 0 1 .266.266ZM20.588 5.139a.267.267 0 0 1-.266.266h-.585a.267.267 0 0 1-.266-.266v-.585a.267.267 0 0 1 .266-.266h.585a.267.267 0 0 1 .266.266ZM22.076 5.139a.267.267 0 0 1-.266.266h-.585a.267.267 0 0 1-.266-.266v-.585a.267.267 0 0 1 .266-.266h.585a.267.267 0 0 1 .266.266Z",
  className: "px-designation_svg__j"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.147 12.892h-.475a.4.4 0 1 1 0-.8h.478a.4.4 0 1 1 0 .8ZM8.34 12.892h-.475a.4.4 0 0 1 0-.8h.478a.4.4 0 1 1 0 .8ZM6.532 12.892h-.474a.4.4 0 1 1 0-.8h.478a.4.4 0 1 1 0 .8ZM4.725 12.892h-.474a.4.4 0 1 1 0-.8h.478a.4.4 0 1 1 0 .8ZM11.702 11.253a.4.4 0 0 1-.4-.4v-.482a.4.4 0 0 1 .8 0v.478a.4.4 0 0 1-.4.404M11.702 9.446a.4.4 0 0 1-.4-.4v-.482a.4.4 0 1 1 .8 0v.478a.4.4 0 0 1-.4.404M11.702 7.639a.4.4 0 0 1-.4-.4v-.482a.4.4 0 0 1 .8 0v.478a.4.4 0 0 1-.4.404M2.666 11.253a.4.4 0 0 1-.4-.4v-.482a.4.4 0 0 1 .8 0v.478a.4.4 0 0 1-.4.404M2.666 9.446a.4.4 0 0 1-.4-.4v-.482a.4.4 0 1 1 .8 0v.478a.4.4 0 0 1-.4.404M2.666 7.639a.4.4 0 0 1-.4-.4v-.482a.4.4 0 0 1 .8 0v.478a.4.4 0 0 1-.4.404M10.147 5.664h-.475a.4.4 0 1 1 0-.8h.478a.4.4 0 1 1 0 .8ZM8.34 5.664h-.475a.4.4 0 0 1 0-.8h.478a.4.4 0 1 1 0 .8ZM6.532 5.664h-.474a.4.4 0 1 1 0-.8h.478a.4.4 0 1 1 0 .8ZM4.725 5.664h-.474a.4.4 0 0 1 0-.8h.478a.4.4 0 0 1 0 .8Z",
  className: "px-designation_svg__k"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.638 11.168a.267.267 0 0 1-.266.266H3.994a.267.267 0 0 1-.266-.266V6.597a.267.267 0 0 1 .266-.266h6.378a.267.267 0 0 1 .266.266Z",
  className: "px-designation_svg__l"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.781 11.168V6.597a.267.267 0 0 1 .266-.266H3.994a.267.267 0 0 0-.266.266v4.571a.267.267 0 0 0 .266.266h1.055a.267.267 0 0 1-.268-.266",
  className: "px-designation_svg__m"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.445 5.666a.267.267 0 0 1-.266.266h-1.116a.267.267 0 0 1-.266-.266V4.55a.267.267 0 0 1 .266-.266h1.116a.267.267 0 0 1 .266.266ZM3.622 5.772a.267.267 0 0 1-.266.266H2.24a.267.267 0 0 1-.266-.266V4.656a.267.267 0 0 1 .266-.266h1.116a.267.267 0 0 1 .266.266ZM12.445 13.1a.267.267 0 0 1-.266.266h-1.116a.267.267 0 0 1-.266-.266v-1.116a.267.267 0 0 1 .266-.266h1.116a.267.267 0 0 1 .266.266ZM3.622 13.1a.267.267 0 0 1-.266.266H2.24a.267.267 0 0 1-.266-.266v-1.116a.267.267 0 0 1 .266-.266h1.116a.267.267 0 0 1 .266.266Z",
  className: "px-designation_svg__n"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.383 5.666V4.55a.267.267 0 0 1 .266-.266h-.586a.267.267 0 0 0-.266.266v1.116a.267.267 0 0 0 .266.266h.589a.267.267 0 0 1-.269-.266M2.56 5.772V4.656a.267.267 0 0 1 .269-.266h-.586a.267.267 0 0 0-.266.266v1.116a.267.267 0 0 0 .266.266h.586a.267.267 0 0 1-.269-.266M11.383 13.1v-1.116a.267.267 0 0 1 .266-.266h-.586a.267.267 0 0 0-.266.266V13.1a.267.267 0 0 0 .266.266h.589a.267.267 0 0 1-.269-.266M2.56 13.1v-1.116a.267.267 0 0 1 .266-.266H2.24a.267.267 0 0 0-.266.266V13.1a.267.267 0 0 0 .266.266h.589a.267.267 0 0 1-.269-.266",
  className: "px-designation_svg__o"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.145 18.728a.1.1 0 0 1-.006-.039h.006a.1.1 0 0 1 .033.007l2.238.822v-5.03a.267.267 0 0 0-.266-.266h-8.451a.267.267 0 0 0-.266.266v6.1a.267.267 0 0 0 .266.266h7.227Z",
  className: "px-designation_svg__l"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.488 20.589v-6.1a.267.267 0 0 1 .266-.266h-1.055a.267.267 0 0 0-.266.266v6.1a.267.267 0 0 0 .266.266h1.059a.267.267 0 0 1-.27-.266",
  className: "px-designation_svg__m"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.196 18.647c-.088-.032-.133.013-.1.1l1.4 3.815a.1.1 0 0 0 .178.039l.744-.744a.17.17 0 0 1 .24 0l.857.857a.17.17 0 0 0 .24 0l.408-.408a.17.17 0 0 0 0-.24l-.857-.857a.17.17 0 0 1 0-.24l.744-.744a.1.1 0 0 0-.039-.178Z",
  className: "px-designation_svg__e"
})));

const SvgPxDigitalReporting = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#9dc6fb",
  d: "M22.012 23.089V6.626A.626.626 0 0 0 21.386 6H8.624a.626.626 0 0 0-.626.626v16.463a.626.626 0 0 0 .626.626h12.762a.626.626 0 0 0 .626-.626",
  "data-name": "Path 71875"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#80b4fb",
  d: "M21.498 6h-1.173a.626.626 0 0 1 .626.626v16.463a.626.626 0 0 1-.626.626h1.173a.626.626 0 0 0 .626-.626V6.626A.626.626 0 0 0 21.498 6",
  "data-name": "Path 71876"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e7ecf6",
  d: "M23.671 24.805V8.342a.626.626 0 0 0-.626-.626h-12.76a.626.626 0 0 0-.626.626v16.463a.626.626 0 0 0 .626.626h12.761a.626.626 0 0 0 .625-.626",
  "data-name": "Path 71877"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e28086",
  d: "M17.914 12.474h-2.8v2.8a2.8 2.8 0 0 0 2.8-2.8",
  "data-name": "Path 71878"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#95d6a4",
  d: "M17.914 12.474a2.8 2.8 0 1 0-2.8 2.8v-2.8Z",
  "data-name": "Path 71879"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57463"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#407093",
  d: "M22.316 11.047h-2.633a.293.293 0 0 1 0-.586h2.633a.293.293 0 0 1 0 .586",
  "data-name": "Path 71880"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57464"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#407093",
  d: "M22.316 12.563h-2.633a.293.293 0 0 1 0-.586h2.633a.293.293 0 0 1 0 .586",
  "data-name": "Path 71881"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57465"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#407093",
  d: "M22.316 14.08h-2.633a.293.293 0 1 1 0-.586h2.633a.293.293 0 1 1 0 .586",
  "data-name": "Path 71882"
})), /*#__PURE__*/React.createElement("g", {
  fill: "#ecbe6b",
  "data-name": "Group 57466"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.696 23.714h-1.26a.117.117 0 0 1-.117-.117v-5.6a.117.117 0 0 1 .117-.117h1.26a.117.117 0 0 1 .117.117v5.6a.117.117 0 0 1-.117.117",
  "data-name": "Path 71883"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.408 23.714h-1.26a.117.117 0 0 1-.117-.117v-4.5a.117.117 0 0 1 .117-.117h1.26a.117.117 0 0 1 .117.117v4.5a.117.117 0 0 1-.117.117",
  "data-name": "Path 71884"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.12 23.714h-1.26a.117.117 0 0 1-.117-.117v-3.103a.117.117 0 0 1 .117-.117h1.26a.117.117 0 0 1 .117.117v3.1a.117.117 0 0 1-.117.12",
  "data-name": "Path 71885"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57467"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#407093",
  d: "M22.316 18.176h-3.827a.293.293 0 0 1 0-.586h3.827a.293.293 0 1 1 0 .586",
  "data-name": "Path 71886"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57468"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#407093",
  d: "M22.316 19.692h-1.2a.293.293 0 0 1 0-.586h1.2a.293.293 0 1 1 0 .586",
  "data-name": "Path 71887"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57469"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#407093",
  d: "M22.316 21.208h-1.2a.293.293 0 0 1 0-.586h1.2a.293.293 0 1 1 0 .586",
  "data-name": "Path 71888"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57470"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#407093",
  d: "M22.316 22.724h-1.2a.293.293 0 1 1 0-.586h1.2a.293.293 0 1 1 0 .586",
  "data-name": "Path 71889"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#d8e2f1",
  d: "M23.157 7.716h-1.173a.626.626 0 0 1 .626.626v16.463a.626.626 0 0 1-.626.626h1.173a.626.626 0 0 0 .626-.626V8.342a.626.626 0 0 0-.626-.626",
  "data-name": "Path 71890"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#80b4fb",
  d: "M8.548 8.342v15.367c.057.007-.021 0 1.108 0V8.342a.626.626 0 0 1 .626-.626H9.174a.626.626 0 0 0-.626.626",
  "data-name": "Path 71891"
}));

const SvgPxDisableBadge = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 30 29"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 9596"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h30v29H0z",
  "data-name": "Rectangle 6574"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#9f9f9f",
  d: "M24.091 0H5.636a2.633 2.633 0 0 0-2.623 2.636L3 19.68a2.64 2.64 0 0 0 1.16 2.188L14.864 29l10.69-7.131a2.64 2.64 0 0 0 1.16-2.188l.013-17.044A2.644 2.644 0 0 0 24.091 0M12.227 19.773l-6.591-6.591 1.859-1.859 4.732 4.719 10-10.005 1.859 1.872Z",
  "data-name": "Path 12352"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#9f9f9f",
  d: "M4 3.458h21.571v16.179H4z",
  "data-name": "Rectangle 6575"
})));

const SvgPxDiscount = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".px-discount_svg__e{fill:#d1dcff}")), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h32v32H0z",
  style: {
    fill: "none"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.054 8.672 7.926 16.8l5.182.926a1.69 1.69 0 0 0 1.913-1.436Z",
  style: {
    fill: "#ffab61"
  },
  transform: "translate(7.512 7.543)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.961 10.612a.6.6 0 0 0-.225.051l-5.81 5.81 1.464.261 5.027-5.061a.62.62 0 0 0-.455-1.061Z",
  style: {
    fill: "#ff8f64"
  },
  transform: "translate(7.512 7.871)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.429.543a3 3 0 0 0-.282.023L10.055 1.7l-9.012 9.011a1.69 1.69 0 0 0 0 2.392l5.512 5.512a1.69 1.69 0 0 0 2.392 0L17.959 9.6l1.108-7.1A1.58 1.58 0 0 0 17.429.543m-1.48 2.231a1.017 1.017 0 1 1-1.017 1.017 1.017 1.017 0 0 1 1.017-1.017",
  style: {
    fill: "#55a1ff"
  },
  transform: "translate(6.266 6.169)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.46 17.768a.916.916 0 1 1-.916-.916.916.916 0 0 1 .916.916M18.146 17.768a.916.916 0 1 1-.916-.916.916.916 0 0 1 .916.916",
  className: "px-discount_svg__e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.216 2.6a.62.62 0 0 0-.64.531l-1.149 7.307 1.186-1.186 1.01-6.476a.62.62 0 0 0-.407-.177Z",
  style: {
    fill: "#488bff"
  },
  transform: "translate(8.611 6.517)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.629 13.607a.325.325 0 0 0-.332.342l-.466 8.268a.311.311 0 1 0 .62.034l.464-8.269a.32.32 0 0 0-.286-.376Z",
  className: "px-discount_svg__e"
}));

const SvgPxDollar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 30 30"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h30v30H0Z",
  "data-name": "Path 2885"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#454545",
  "data-name": "Group 225"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15 2.5A12.5 12.5 0 1 0 27.5 15 12.5 12.5 0 0 0 15 2.5M15 25a10 10 0 1 1 10-10 10.013 10.013 0 0 1-10 10",
  "data-name": "Path 2886"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.388 13.925c-2.212-.562-2.925-1.175-2.925-2.087 0-1.05.988-1.788 2.625-1.788 1.725 0 2.375.825 2.425 2.05h2.137a3.88 3.88 0 0 0-3.112-3.713V6.25h-2.913v2.113c-1.887.4-3.4 1.625-3.4 3.512 0 2.238 1.862 3.363 4.575 4.012 2.437.575 2.925 1.437 2.925 2.338 0 .662-.488 1.737-2.625 1.737-2 0-2.788-.9-2.9-2.05h-2.15a4.05 4.05 0 0 0 3.575 3.712v2.126h2.925v-2.087c1.9-.363 3.4-1.45 3.413-3.463-.013-2.75-2.376-3.7-4.575-4.275",
  "data-name": "Path 2887"
})));

const SvgPxDownpayment = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-6 -14.745)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#d1ed6e",
  d: "M10 23.489h13.642v12.744H10Z",
  "data-name": "Path 71713"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#b0cc3a",
  d: "M21.302 28.93v-2.333h-1.045v2.333h-6.83v7.3h10.215v-7.3Z",
  "data-name": "Path 71714"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffba55",
  d: "M14.472 29.976h13.642V43.05H14.472Z",
  "data-name": "Path 71715"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fc9e22",
  d: "M20.257 38.224v1.045h7.858v-9.293h-7.858Z",
  "data-name": "Path 71716"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#bdd8ff",
  d: "M21.302 38.224h9.507l3.078-4.134v-7.492H21.302Z",
  "data-name": "Path 71717"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#88aad3",
  "data-name": "Group 57429"
}, /*#__PURE__*/React.createElement("path", {
  d: "M33.889 34.084a9.8 9.8 0 0 0-2.286-.586.68.68 0 0 0-.758.707 32 32 0 0 1-.033 4.013Z",
  "data-name": "Path 71718"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.98 30.274h-5.732a.3.3 0 0 1 0-.6h5.732a.3.3 0 1 1 0 .6",
  "data-name": "Path 71719"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.921 32.398h-5.314a.3.3 0 0 1 0-.6h5.314a.3.3 0 0 1 0 .6",
  "data-name": "Path 71720"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.921 34.521h-5.314a.3.3 0 0 1 0-.6h5.314a.3.3 0 0 1 0 .6",
  "data-name": "Path 71721"
})), /*#__PURE__*/React.createElement("circle", {
  cx: 0.535,
  cy: 0.535,
  r: 0.535,
  fill: "#b0cc3a",
  "data-name": "Ellipse 1441",
  transform: "translate(16.286 23.872)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2b313f",
  d: "m16.996 24.423.994-2.447-.744-.179-.566 2.527a.166.166 0 0 0 .316.1Z",
  "data-name": "Path 71722"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1.15,
  cy: 1.15,
  r: 1.15,
  fill: "#f26674",
  "data-name": "Ellipse 1442",
  transform: "translate(16.672 19.895)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 0.529,
  cy: 0.529,
  r: 0.529,
  fill: "#88aad3",
  "data-name": "Ellipse 1443",
  transform: "translate(27.066 27.014)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2b313f",
  d: "m27.778 27.541.994-2.447-.744-.179-.567 2.527a.166.166 0 0 0 .316.1Z",
  "data-name": "Path 71723"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1.15,
  cy: 1.15,
  r: 1.15,
  fill: "#f26674",
  "data-name": "Ellipse 1444",
  transform: "translate(27.375 23.163)"
})));

const SvgPxEducation = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".px-education_svg__b{fill:#463c4b}.px-education_svg__c{fill:#555a6e}.px-education_svg__d{fill:#a5c3dc}.px-education_svg__e{fill:#d7e6f0}.px-education_svg__f{fill:#23aae6}.px-education_svg__h{fill:#058cc8}.px-education_svg__i{fill:#fabe19}.px-education_svg__j{fill:#f5871e}")), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h32v32H0z",
  style: {
    fill: "none"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.41 23.075H4v-10.4a1.734 1.734 0 0 1 1.734-1.739h19.942a1.734 1.734 0 0 1 1.734 1.734Z",
  className: "px-education_svg__b"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.676 23.075H4v-10.4a1.734 1.734 0 0 1 1.734-1.739h18.208a1.734 1.734 0 0 1 1.734 1.734Z",
  className: "px-education_svg__c"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.734 25.243h19.942a1.734 1.734 0 0 0 1.734-1.734v-.434H4v.434a1.734 1.734 0 0 0 1.734 1.734",
  className: "px-education_svg__d"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.942 25.243H5.734A1.734 1.734 0 0 1 4 23.509v-.434h21.676v.434a1.734 1.734 0 0 1-1.734 1.734",
  className: "px-education_svg__e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.104 25.242h3.9v1.734h-3.9Z",
  className: "px-education_svg__d"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.104 26.109h2.6v.867h-2.6Z",
  className: "px-education_svg__e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.173 28.276h-8.67v-.434a.867.867 0 0 1 .867-.867h6.933a.867.867 0 0 1 .867.867Z",
  className: "px-education_svg__e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.172 28.276h-2.6v-.434a.867.867 0 0 1 .867-.867h.867a.867.867 0 0 1 .867.867Z",
  className: "px-education_svg__d"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.601 22.208h8.233V10.936a.867.867 0 0 0-.867-.867h-7.37a.867.867 0 0 0-.867.867v10.4a.867.867 0 0 0 .871.872",
  className: "px-education_svg__f"
}), /*#__PURE__*/React.createElement("path", {
  d: "M72.867 155.272h7.37a.867.867 0 0 1 .867.867v-11.272a.867.867 0 0 0-.867-.867h-7.37a.867.867 0 0 0-.867.867v9.533a.867.867 0 0 0 .867.872",
  style: {
    fill: "#5ad7ff"
  },
  transform: "translate(-66.266 -133.931)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.668 19.606H7.899a.434.434 0 1 1 0-.867h4.769a.434.434 0 1 1 0 .867M12.668 17.872H7.899a.434.434 0 1 1 0-.867h4.769a.434.434 0 1 1 0 .867M12.668 16.138H7.899a.434.434 0 1 1 0-.867h4.769a.434.434 0 1 1 0 .867M12.668 14.404H7.899a.434.434 0 1 1 0-.867h4.769a.434.434 0 1 1 0 .867M12.669 12.67H9.201a.434.434 0 1 1 0-.867h3.468a.434.434 0 1 1 0 .867",
  className: "px-education_svg__f"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.075 22.208h-8.237V10.936a.867.867 0 0 1 .867-.867h7.37a.867.867 0 0 1 .867.867v10.4a.867.867 0 0 1-.867.872",
  className: "px-education_svg__h"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.075 21.341h-7.37a.867.867 0 0 0-.867.867V10.936a.867.867 0 0 1 .867-.867h7.37a.867.867 0 0 1 .867.867v9.533a.867.867 0 0 1-.867.872",
  className: "px-education_svg__f"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.006 19.606h4.766a.434.434 0 1 0 0-.867h-4.769a.434.434 0 0 0 0 .867ZM17.006 17.872h4.766a.434.434 0 1 0 0-.867h-4.769a.434.434 0 0 0 0 .867ZM17.006 16.138h4.766a.434.434 0 1 0 0-.867h-4.769a.434.434 0 0 0 0 .867ZM17.006 14.404h4.766a.434.434 0 1 0 0-.867h-4.769a.434.434 0 0 0 0 .867ZM18.307 12.67h3.466a.434.434 0 1 0 0-.867h-3.468a.434.434 0 0 0 0 .867Z",
  className: "px-education_svg__h"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.292 6.167H6.384a.65.65 0 1 1 0-1.3h16.908a.65.65 0 1 1 0 1.3",
  className: "px-education_svg__b"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.188 6.167h-7.8a.65.65 0 1 1 0-1.3h7.8a.65.65 0 0 1 0 1.3",
  className: "px-education_svg__c"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.04 9.203H9.64a.434.434 0 0 1-.438-.435v-2.6h11.272v2.6a.434.434 0 0 1-.434.435",
  className: "px-education_svg__b"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.838 9.203h-5.2a.434.434 0 0 1-.434-.434V7.035h5.636Z",
  className: "px-education_svg__c"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.771 4h-6.936a.867.867 0 0 0-.867.867h8.67A.867.867 0 0 0 21.771 4",
  className: "px-education_svg__i"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.774 4.867h.867v2.6h-.867Z",
  className: "px-education_svg__j"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.774 7.468h.867v.434h-.867Z",
  className: "px-education_svg__e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.858 10.937h-1.3a.217.217 0 0 1-.217-.217V8.336a.434.434 0 0 1 .434-.434h.867a.434.434 0 0 1 .434.434v2.384a.217.217 0 0 1-.218.217",
  className: "px-education_svg__i"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.425 8.335h.65v2.384a.217.217 0 0 1-.217.217h-.65V8.552a.217.217 0 0 1 .217-.217",
  className: "px-education_svg__j"
}));

const SvgPxEletter = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".px-eletter_svg__c{fill:#d8dce5}.px-eletter_svg__d{fill:#c3c8d1}.px-eletter_svg__f{fill:#00aaf0}.px-eletter_svg__h{fill:#5e6377}.px-eletter_svg__i{fill:#707487}")), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h32v32H0z",
  style: {
    fill: "none"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M43.067 0h-13l-4.76 4.76v19.388a.59.59 0 0 0 .589.589h17.171a.59.59 0 0 0 .589-.589V.589A.59.59 0 0 0 43.067 0",
  style: {
    fill: "#e4eaf8"
  },
  transform: "translate(-20.312 4)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m5.988 7.775-.985.985v19.388a.59.59 0 0 0 .589.589h.4Z",
  className: "px-eletter_svg__c"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.247 11.421H8.097a.373.373 0 1 1 0-.747h12.15a.373.373 0 1 1 0 .747M20.247 13.413H8.097a.373.373 0 1 1 0-.747h12.15a.373.373 0 1 1 0 .747M20.247 15.405H8.097a.373.373 0 1 1 0-.747h12.15a.373.373 0 1 1 0 .747M18.709 17.397H8.097a.373.373 0 0 1 0-.747h10.612a.373.373 0 1 1 0 .747M16.717 19.389h-8.62a.373.373 0 0 1 0-.747h8.62a.373.373 0 1 1 0 .747M14.868 21.381H8.097a.373.373 0 1 1 0-.747h6.771a.373.373 0 1 1 0 .747M14.582 23.373H8.097a.373.373 0 1 1 0-.747h6.485a.373.373 0 0 1 0 .747",
  className: "px-eletter_svg__d"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5 8.76h4.172a.59.59 0 0 0 .589-.589V4Z",
  className: "px-eletter_svg__c"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.76 4 5 8.76h.988L9.76 4.985Z",
  className: "px-eletter_svg__d"
}), /*#__PURE__*/React.createElement("path", {
  d: "m434.383 131.515.5.5a1.01 1.01 0 0 1-.022 1.425l-.411.411-1.9-1.9.411-.411a1.01 1.01 0 0 1 1.422-.025",
  style: {
    fill: "#00c3ff"
  },
  transform: "translate(-407.872 -120.89)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.745 11.362a1.23 1.23 0 0 1 1.16-.344l-.394-.394a1.01 1.01 0 0 0-1.425.022l-.411.411.688.688Z",
  className: "px-eletter_svg__f"
}), /*#__PURE__*/React.createElement("path", {
  d: "m24.709 11.023-8.792 8.792 1.9 1.9 8.792-8.792Z",
  className: "px-eletter_svg__f"
}), /*#__PURE__*/React.createElement("path", {
  d: "m260.072 145.371-8.792 8.792.7.7 8.792-8.792Z",
  style: {
    fill: "#009aef"
  },
  transform: "translate(-235.363 -134.348)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.262 18.938a.373.373 0 0 1 0-.528l3.948-3.948-2.6-2.6a.373.373 0 1 1 .528-.528l2.864 2.864a.373.373 0 0 1 0 .528l-4.212 4.212a.373.373 0 0 1-.528 0",
  className: "px-eletter_svg__h"
}), /*#__PURE__*/React.createElement("path", {
  d: "m17.815 21.713-1.898-1.898 2.373-2.373 1.898 1.898z",
  className: "px-eletter_svg__i"
}), /*#__PURE__*/React.createElement("path", {
  d: "m16.616 20.514-.698-.698 2.373-2.373.698.698zM14.367 23.264a.373.373 0 0 1 0-.528l.97-.97a.373.373 0 0 1 .528.528l-.97.97a.373.373 0 0 1-.528 0",
  className: "px-eletter_svg__h"
}), /*#__PURE__*/React.createElement("path", {
  d: "m228.593 327.349-.759.759a1.342 1.342 0 0 0 1.9 1.9l.759-.759Z",
  style: {
    fill: "#828593"
  },
  transform: "translate(-212.676 -307.534)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m17.814 21.714-1.2-1.2ZM15.855 21.266l.759-.759-.7-.7-.759.759a1.343 1.343 0 0 0 .36 2.155 1.34 1.34 0 0 1 .34-1.455",
  className: "px-eletter_svg__i"
}));

const SvgPxEndFinancier = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57652"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#746bf9",
  d: "m13.068 3.133-3.292.053a8.556 8.556 0 1 0 3.292-.053",
  "data-name": "Path 72016"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5f5f9b",
  d: "M5.589 16.393v3.432a1.06 1.06 0 0 0 1.056 1.056h9.823a1.06 1.06 0 0 0 1.056-1.056v-3.432Z",
  "data-name": "Path 72017"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#47477f",
  d: "m8.407 19.901-.127-3.508H5.589v3.432a1.06 1.06 0 0 0 1.056 1.056h1.762a.653.653 0 0 1 0-.98",
  "data-name": "Path 72018"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3b3868",
  d: "M16.544 16.393H6.568v3.2a.3.3 0 0 0 .3.3h9.369a.3.3 0 0 0 .3-.3Z",
  "data-name": "Path 72019"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57566"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#2d2d59",
  d: "M7.967 19.462v-1.843a.44.44 0 0 1 .184-.356v-.87H6.568v3.2a.3.3 0 0 0 .3.3h1.535a.44.44 0 0 1-.436-.431",
  "data-name": "Path 72020"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#fcad6d",
  d: "M12.122 10.276a.441.441 0 0 0-.882 0 .44.44 0 0 1-.44-.416v-.035a.45.45 0 0 1-.4.449.44.44 0 0 1-.484-.439V5.498h3v.333a.65.65 0 0 0 .157.421 1.55 1.55 0 0 1 .371 1.005v2.579a.44.44 0 0 1-.484.439.45.45 0 0 1-.4-.449v.035a.44.44 0 0 1-.438.415",
  "data-name": "Path 72021"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57567"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#e9efff",
  d: "M15.015 11.449a.265.265 0 0 1-.261-.226 2.73 2.73 0 0 0-.99-1.724 1.2 1.2 0 0 0-.217-.139.265.265 0 1 1 .238-.473 1.7 1.7 0 0 1 .311.2 3.26 3.26 0 0 1 1.181 2.058.265.265 0 0 1-.223.3z",
  "data-name": "Path 72022"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57568"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#bec9f7",
  d: "M14.68 9.7a3.3 3.3 0 0 0-.585-.612 1.8 1.8 0 0 0-.311-.2.265.265 0 0 0-.238.473 1.2 1.2 0 0 1 .217.139 2.8 2.8 0 0 1 .513.543.314.314 0 0 1 .404-.343",
  "data-name": "Path 72023"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57569"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#bec9f7",
  d: "M8.098 11.449a.265.265 0 0 1-.262-.3 3.26 3.26 0 0 1 1.181-2.058 1.7 1.7 0 0 1 .311-.2.265.265 0 1 1 .238.473 1.2 1.2 0 0 0-.217.139 2.73 2.73 0 0 0-.99 1.724.265.265 0 0 1-.261.222",
  "data-name": "Path 72024"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#47477f",
  d: "M13.46 9.23H9.651a.435.435 0 0 1-.433-.4v.65a.435.435 0 0 0 .435.435h3.809a.435.435 0 0 0 .435-.435v-.65a.435.435 0 0 1-.437.4",
  "data-name": "Path 72025"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5f5f9b",
  d: "M13.46 9.266H9.651a.435.435 0 0 1 0-.87h3.809a.435.435 0 0 1 0 .87",
  "data-name": "Path 72026"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fcad6d",
  d: "M11.241 10.314a.44.44 0 0 0 .441-.441V8.632a.441.441 0 0 0-.882 0v1.241a.44.44 0 0 0 .441.441",
  "data-name": "Path 72027"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fcad6d",
  d: "M12.122 10.314a.44.44 0 0 0 .441-.441V8.632a.441.441 0 0 0-.882 0v1.241a.44.44 0 0 0 .441.441",
  "data-name": "Path 72028"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fcad6d",
  d: "M10.36 10.314a.44.44 0 0 0 .441-.441V8.632a.441.441 0 0 0-.882 0v1.241a.44.44 0 0 0 .441.441",
  "data-name": "Path 72029"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fd995b",
  d: "M9.919 8.632v.717a.474.474 0 0 1 .882 0v-.717a.441.441 0 0 0-.882 0",
  "data-name": "Path 72030"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fcad6d",
  d: "M13.003 10.314a.44.44 0 0 0 .441-.441V8.632a.441.441 0 0 0-.882 0v1.241a.44.44 0 0 0 .441.441",
  "data-name": "Path 72031"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fd995b",
  d: "M10.8 8.632v.717a.474.474 0 0 1 .882 0v-.717a.441.441 0 0 0-.882 0",
  "data-name": "Path 72032"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fd995b",
  d: "M11.681 8.632v.717a.474.474 0 0 1 .882 0v-.717a.441.441 0 0 0-.882 0",
  "data-name": "Path 72033"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fd995b",
  d: "M12.562 8.632v.717a.474.474 0 0 1 .882 0v-.717a.441.441 0 0 0-.882 0",
  "data-name": "Path 72034"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fcad6d",
  d: "m10.805 9.106-1.259-.391a.47.47 0 0 1-.3-.285 2.43 2.43 0 0 1 .479-2.259 1 1 0 0 0 .178-.573v-.1h1.29v.863a1.63 1.63 0 0 1-1 1.584c1.041.2 1.034.725.975.959a.29.29 0 0 1-.363.202",
  "data-name": "Path 72035"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fd995b",
  d: "m9.752 8.779.5.156c.284-.491.7-.261.925-.08.045-.252-.012-.726-.985-.91l-.136.047a.51.51 0 0 1-.304.787",
  "data-name": "Path 72036"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fcd7c3",
  d: "M11.171 8.905c0-.017.008-.036.012-.056-.221-.184-.648-.432-.933.084l.558.173a.29.29 0 0 0 .363-.201",
  "data-name": "Path 72037"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fd995b",
  d: "M11.133 6.83a.143.143 0 0 0-.17.094 1.43 1.43 0 0 1-.815.886.144.144 0 0 0 .095.272 1.7 1.7 0 0 0 .551-.36 1.74 1.74 0 0 0 .441-.707.143.143 0 0 0-.102-.185",
  "data-name": "Path 72038"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57570"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fd995b",
  d: "M12.274 6.057a1.07 1.07 0 0 0-.727.225.29.29 0 0 1-.342.029 1.28 1.28 0 0 0-1.643.207c-.03.027-.067.056-.1.08a4 4 0 0 1 .257-.426 1 1 0 0 0 .178-.573v-.1h3.016v.333a.65.65 0 0 0 .157.421 1.6 1.6 0 0 1 .226.353 1.3 1.3 0 0 0-1.022-.549",
  "data-name": "Path 72039"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#47477f",
  d: "M13.069 3.133a8.6 8.6 0 0 0-3.292.053v1.061h3.292Z",
  "data-name": "Path 72040"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e9efff",
  d: "M13.062 4.086H9.783a.16.16 0 0 0-.162.162v1.133a.16.16 0 0 0 .162.162h3.279a.16.16 0 0 0 .162-.162V4.248a.16.16 0 0 0-.162-.162",
  "data-name": "Path 72041"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#bec8f7",
  d: "M11.422 5.381V4.248a.16.16 0 0 1 .162-.162h-1.8a.16.16 0 0 0-.162.162v1.133a.16.16 0 0 0 .162.162h1.8a.16.16 0 0 1-.162-.162",
  "data-name": "Path 72042"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#47477f",
  d: "M17.529 16.433H5.584a.316.316 0 0 1-.315-.315v-4.162a.77.77 0 0 1 .768-.768h11.039a.77.77 0 0 1 .768.768v4.162a.316.316 0 0 1-.315.315",
  "data-name": "Path 72043"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57571"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#3b3868",
  d: "M8.152 13.443a.44.44 0 0 1-.318-.42v-1.4a.44.44 0 0 1 .437-.437H6.037a.77.77 0 0 0-.768.768v4.162a.316.316 0 0 0 .315.315h2.568z",
  "data-name": "Path 72044"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#7272af",
  d: "M7.579 15.516v1.342a.448.448 0 1 0 .895 0v-1.342Z",
  "data-name": "Path 72045"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5f5f9b",
  d: "M8.474 14.633h-.895v-1.169a.1.1 0 0 1 .1-.1h.69a.1.1 0 0 1 .1.1v1.166Z",
  "data-name": "Path 72046"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#7272af",
  d: "M14.639 15.516v1.342a.448.448 0 1 0 .895 0v-1.342Z",
  "data-name": "Path 72047"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#5f5f9b",
  "data-name": "Group 57572"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.579 15.516v1.192a.448.448 0 0 1 .895 0v-1.192Z",
  "data-name": "Path 72048"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.639 15.516v1.192a.448.448 0 0 1 .895 0v-1.192Z",
  "data-name": "Path 72049"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.533 14.633h-.895v-1.169a.1.1 0 0 1 .1-.1h.69a.1.1 0 0 1 .1.1v1.166Z",
  "data-name": "Path 72050"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#3b3868",
  d: "M9.312 12.24H13.8a.313.313 0 0 0 .312-.312v-.743H9v.743a.313.313 0 0 0 .312.312",
  "data-name": "Path 72051"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2d2d59",
  d: "M12.61 11.184v.743a.313.313 0 0 1-.312.312h1.5a.313.313 0 0 0 .312-.312v-.743Z",
  "data-name": "Path 72052"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57573"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#bec8f7",
  d: "M13.906 15.075a.707.707 0 0 1 .706-.706h.949a.706.706 0 1 1 0 1.411h-.949a.707.707 0 0 1-.706-.705m.706-.177a.177.177 0 0 0 0 .353h.949a.177.177 0 0 0 0-.353Z",
  "data-name": "Path 72053"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#e9efff",
  d: "M15.107 15.251h.445a.184.184 0 0 0 .18-.133.178.178 0 0 0-.171-.22h-.454a.265.265 0 0 1 0-.529h.436a.717.717 0 0 1 .723.679.707.707 0 0 1-.705.733h-.454a.265.265 0 0 1 0-.529Z",
  "data-name": "Path 72054"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57574"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#bec8f7",
  d: "M6.846 15.075a.707.707 0 0 1 .706-.706h.949a.706.706 0 1 1 0 1.411h-.949a.707.707 0 0 1-.706-.705m.706-.177a.177.177 0 1 0 0 .353h.949a.177.177 0 0 0 0-.353Z",
  "data-name": "Path 72055"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#e9efff",
  d: "M8.048 15.251h.445a.184.184 0 0 0 .18-.133.178.178 0 0 0-.171-.22h-.454a.265.265 0 1 1 0-.529h.436a.717.717 0 0 1 .723.679.707.707 0 0 1-.705.733h-.454a.265.265 0 1 1 0-.529Z",
  "data-name": "Path 72056"
})));

const SvgPxEndFinancing = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "019---Finance-Accounting",
  transform: "translate(4 4)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#ced2dc",
  d: "M4.55 12.409v8.273a.83.83 0 0 0 .827.827h13.237V6.134a.83.83 0 0 0-.244-.587l-2.82-2.821a.83.83 0 0 0-.589-.244H4.55Z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 9.189,
  height: 11.815,
  fill: "#346d94",
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  width: 6.564,
  height: 3.938,
  fill: "#ffc306",
  "data-name": "Rectangle",
  rx: 1,
  transform: "translate(1.313 1.313)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#8b93a2",
  d: "M18.54 5.791h-2.408a.83.83 0 0 1-.827-.828V2.556a.8.8 0 0 1 .244.17l2.821 2.821a.8.8 0 0 1 .17.244",
  "data-name": "Path"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 5.251,
  cy: 5.251,
  r: 5.251,
  fill: "#ffc306",
  transform: "translate(13.127 13.127)"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#295474",
  "data-name": "Group 57430"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.482 7.859h-.827a.414.414 0 0 1 0-.827h.827a.414.414 0 0 1 0 .827M2.482 9.514h-.827a.414.414 0 1 1 0-.827h.827a.414.414 0 1 1 0 .827M2.482 11.168h-.827a.414.414 0 0 1 0-.827h.827a.414.414 0 0 1 0 .827M4.964 7.859h-.827a.414.414 0 1 1 0-.827h.827a.414.414 0 1 1 0 .827M4.964 9.514h-.827a.414.414 0 1 1 0-.827h.827a.414.414 0 1 1 0 .827M4.964 11.168h-.827a.414.414 0 1 1 0-.827h.827a.414.414 0 1 1 0 .827M7.446 7.859h-.827a.414.414 0 1 1 0-.827h.827a.414.414 0 1 1 0 .827M7.446 9.514h-.827a.414.414 0 1 1 0-.827h.827a.414.414 0 1 1 0 .827M7.446 11.168h-.827a.414.414 0 1 1 0-.827h.827a.414.414 0 1 1 0 .827",
  "data-name": "Path"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#798291",
  d: "M16.546 8.686h-5.377a.414.414 0 1 1 0-.827h5.377a.414.414 0 1 1 0 .827M16.546 10.754h-5.377a.414.414 0 1 1 0-.827h5.377a.414.414 0 1 1 0 .827M16.546 12.823h-5.377a.414.414 0 1 1 0-.827h5.377a.414.414 0 1 1 0 .827M12.405 14.891H6.619a.414.414 0 1 1 0-.827h5.786a.414.414 0 1 1 0 .827M11.582 16.959H6.619a.414.414 0 1 1 0-.827h4.964a.414.414 0 1 1 0 .827ZM11.169 19.027h-4.55a.414.414 0 1 1 0-.827h4.55a.414.414 0 0 1 0 .827",
  "data-name": "Path"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f49100",
  d: "M19.028 18.241v-2.447a1.24 1.24 0 0 1 .827 1.165.414.414 0 0 0 .827 0 2.07 2.07 0 0 0-1.655-2.027v-.041a.414.414 0 1 0-.827 0v.041a2.068 2.068 0 0 0 0 4.054v2.448a1.24 1.24 0 0 1-.827-1.165.414.414 0 1 0-.827 0 2.07 2.07 0 0 0 1.655 2.027v.041a.414.414 0 0 0 .827 0v-.041a2.068 2.068 0 0 0 0-4.054Zm-1.655-1.282a1.24 1.24 0 0 1 .827-1.165v2.33a1.24 1.24 0 0 1-.827-1.165m1.655 4.474v-2.33a1.233 1.233 0 0 1 0 2.33"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f49100",
  d: "M18.614 24.405a5.791 5.791 0 1 1 5.791-5.791 5.79 5.79 0 0 1-5.791 5.791m0-10.755a4.964 4.964 0 1 0 4.964 4.964 4.964 4.964 0 0 0-4.964-4.964",
  "data-name": "Shape"
})));

const SvgPxEngineering = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  id: "px-engineering_svg__Layer_1",
  "data-name": "Layer 1",
  viewBox: "0 0 14 14",
  width: "1em",
  height: "1em"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".px-engineering_svg__cls-1{fill:none}")), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h14v14H0z",
  className: "px-engineering_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.11 0H14v13.89H.11z",
  className: "px-engineering_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.29 8.74c-1.54 0-4.63.77-4.63 2.31v1.16h9.26v-1.16c0-1.54-3.08-2.31-4.63-2.31m-3.47 2.31c.18-.42 1.91-1.16 3.47-1.16s3.36.75 3.47 1.16ZM2.83 5.26H3a2.31 2.31 0 1 0 4.62 0h.16A.28.28 0 0 0 8 5a.28.28 0 0 0-.28-.28H7.6a2.3 2.3 0 0 0-1.15-2v.55a.29.29 0 0 1-.58 0v-.82a2.8 2.8 0 0 0-.58-.08 2.8 2.8 0 0 0-.58.08v.79a.29.29 0 0 1-.58 0v-.55a2.3 2.3 0 0 0-1.13 2h-.17a.28.28 0 0 0-.29.31.28.28 0 0 0 .29.26m3.62 0a1.16 1.16 0 0 1-2.32 0ZM12.8 3.66l.54-.48-.44-.75-.68.22a1.3 1.3 0 0 0-.28-.15l-.14-.71h-.87l-.14.71a1.5 1.5 0 0 0-.28.15l-.68-.22-.44.75.54.48a1.5 1.5 0 0 0 0 .3l-.54.49.44.76.69-.21a2 2 0 0 0 .25.14l.16.71h.87l.16-.7a1.3 1.3 0 0 0 .25-.15l.69.22.43-.75-.54-.47a1.1 1.1 0 0 0 .01-.34m-1.43.88a.73.73 0 0 1-.73-.72.73.73 0 1 1 1.45 0 .72.72 0 0 1-.72.72M11.31 6.3l-.49.16-.19-.11-.11-.51H9.9l-.1.51-.2.11-.49-.17-.31.54.38.34v.22l-.38.35.31.54.5-.16.18.11.11.51h.62l.11-.51.18-.1.49.15.31-.53-.38-.36a.7.7 0 0 0 0-.21l.38-.34Zm-1.1 1.5a.51.51 0 0 1-.52-.51.52.52 0 1 1 1 0 .51.51 0 0 1-.48.51"
}));

const SvgPxFile = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 30 30"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 24797"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h30v30H0z",
  "data-name": "Rectangle 6520"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 9159"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#002672",
  "data-name": "Group 9158"
}, /*#__PURE__*/React.createElement("path", {
  d: "M25.902 3.396h-.877v21.551a2.6 2.6 0 0 1-2.6 2.6H6.472v.8a1.66 1.66 0 0 0 1.657 1.649h17.77a1.66 1.66 0 0 0 1.657-1.657V5.049a1.655 1.655 0 0 0-1.654-1.653",
  "data-name": "Path 12279"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.54 26.6h8.885a1.66 1.66 0 0 0 1.657-1.657V1.657A1.66 1.66 0 0 0 22.425 0H10.586v.548a2 2 0 0 1 .009.175v4.54A2.336 2.336 0 0 1 8.261 7.6h-4.54c-.047 0-.1 0-.144-.006h-.576v17.353A1.66 1.66 0 0 0 4.658 26.6zm.335-5.633H8.082a.783.783 0 1 1 0-1.566h5.8a.783.783 0 1 1 0 1.566Zm5.8-4H8.082a.783.783 0 1 1 0-1.566h11.589a.783.783 0 1 1 0 1.566ZM8.082 11.162h11.589a.783.783 0 1 1 0 1.566H8.082a.783.783 0 0 1 0-1.566",
  "data-name": "Path 12280"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.721 6.657h4.554a1.39 1.39 0 0 0 1.378-1.378V.725a.7.7 0 0 0-.7-.7.68.68 0 0 0-.489.207L3.226 5.467a.7.7 0 0 0 .495 1.19",
  "data-name": "Path 12281"
})))));

const SvgPxFinancier = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".px-financier_svg__b{fill:#4db7e5}.px-financier_svg__d{fill:#fafafa}")), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h32v32H0z",
  style: {
    fill: "none"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.036 10.838a.47.47 0 0 0-.335-.142h-3.722a.47.47 0 0 0-.335.142C12.964 11.538 7 17.8 7 20.466c0 3.849 3.966 6.979 8.84 6.979s8.84-3.13 8.84-6.979c.001-2.67-5.963-8.923-6.644-9.628",
  className: "px-financier_svg__b"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.773 5.736c-.775-.877-2.792.274-3.949 1.052-.533-.754-1.316-1.675-1.983-1.675s-1.453.921-1.983 1.675c-1.155-.78-3.175-1.93-3.949-1.052a1.17 1.17 0 0 0-.279.9c.15 1.723 3.658 4.572 4.057 4.89a.47.47 0 0 0 .293.1h3.722a.47.47 0 0 0 .29-.1c.4-.319 3.908-3.164 4.057-4.89a1.17 1.17 0 0 0-.276-.9",
  className: "px-financier_svg__b"
}), /*#__PURE__*/React.createElement("path", {
  d: "M167.91 128.931h-7.444a.465.465 0 1 1 0-.931h7.444a.465.465 0 1 1 0 .931",
  style: {
    fill: "#2b6bb2"
  },
  transform: "translate(-148.347 -117.304)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.84 23.725a2.154 2.154 0 0 1-2.326-1.733.467.467 0 1 1 .931-.078c.041.486.667.88 1.4.88.757 0 1.4-.426 1.4-.931 0-.454-.441-.744-1.387-.921l-.1-.019c-1.51-.279-2.233-.9-2.233-1.852a2.406 2.406 0 0 1 4.653-.128.467.467 0 0 1-.931.078c-.039-.486-.665-.88-1.4-.88-.757 0-1.4.426-1.4.931 0 .454.442.744 1.389.921l.1.02c1.508.279 2.233.9 2.233 1.852a2.14 2.14 0 0 1-2.329 1.86",
  className: "px-financier_svg__d"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.842 24.655a.465.465 0 0 1-.465-.465v-7.444a.466.466 0 1 1 .931 0v7.444a.465.465 0 0 1-.466.465",
  className: "px-financier_svg__d"
}));

const SvgPxFireInsurance = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".px-fire-insurance_svg__cls-4{fill:#4b5be5}.px-fire-insurance_svg__cls-5{fill:#1c2ede}")), /*#__PURE__*/React.createElement("g", {
  id: "px-fire-insurance_svg__Group_50401",
  "data-name": "Group 50401",
  transform: "translate(9116 -23289)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-fire-insurance_svg__icon_placeholder",
  d: "M0 0h32v32H0z",
  style: {
    fill: "none"
  },
  transform: "translate(-9116 23289)"
}), /*#__PURE__*/React.createElement("g", {
  id: "px-fire-insurance_svg__life-insurance",
  transform: "translate(-9111.104 23294)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "px-fire-insurance_svg__Ellipse_804",
  cx: 11.5,
  cy: 11.5,
  r: 11.5,
  "data-name": "Ellipse 804",
  style: {
    fill: "#ffb74f"
  },
  transform: "translate(.104 .001)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-fire-insurance_svg__Path_65030",
  d: "M152.988 49.958 142.98 39.94a2.79 2.79 0 1 0-4 3.886l.536.533h-1.346a2.015 2.015 0 0 0-2.009 2.009v4.423l2.29 2.292v4.768L140.9 60.3q.321.018.647.018a11.5 11.5 0 0 0 11.441-10.36",
  "data-name": "Path 65030",
  style: {
    fill: "#e67500"
  },
  transform: "translate(-129.889 -37.316)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-fire-insurance_svg__Path_65031",
  d: "M145.753 46.368a2.015 2.015 0 0 0-2.009-2.009H142.2a2.791 2.791 0 1 0-2.493 0h-1.537a2.015 2.015 0 0 0-2.009 2.009v4.423h1.494v-3.069a.4.4 0 0 1 .8 0v10.13h1.877v-5.041a.629.629 0 1 1 1.258 0v5.041h1.877v-10.13a.4.4 0 0 1 .8 0v3.069h1.494v-4.423Z",
  className: "px-fire-insurance_svg__cls-4",
  "data-name": "Path 65031",
  transform: "translate(-129.889 -37.316)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-fire-insurance_svg__Path_65032",
  d: "M247.721 46.37v4.423h-1.494v-3.07a.4.4 0 0 0-.8 0v10.13h-1.876v-5.04a.63.63 0 0 0-.629-.629V39.073a2.791 2.791 0 0 1 1.246 5.288h1.54a2.015 2.015 0 0 1 2.013 2.009",
  className: "px-fire-insurance_svg__cls-5",
  "data-name": "Path 65032",
  transform: "translate(-231.858 -37.317)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-fire-insurance_svg__Path_65033",
  d: "m271.72 193.4-3.385 1.448v3.374c0 .95.153 2.167 3.385 3.791 3.231-1.624 3.385-2.841 3.385-3.791v-3.374Z",
  "data-name": "Path 65033",
  style: {
    fill: "#00efd1"
  },
  transform: "translate(-256.125 -184.717)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-fire-insurance_svg__Path_65034",
  d: "M347.066 194.853v3.374c0 .95-.153 2.167-3.385 3.791V193.4Z",
  "data-name": "Path 65034",
  style: {
    fill: "#00ad95"
  },
  transform: "translate(-328.087 -184.717)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-fire-insurance_svg__Path_65035",
  d: "m299.224 259.632-1.677-1.648.653-.664 1.024 1.006 1.815-1.787.653.664Z",
  className: "px-fire-insurance_svg__cls-4",
  "data-name": "Path 65035",
  transform: "translate(-284.025 -245.015)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-fire-insurance_svg__Path_65036",
  d: "m345.752 257.2-2.072 2.04v-1.307l1.419-1.4Z",
  className: "px-fire-insurance_svg__cls-5",
  "data-name": "Path 65036",
  transform: "translate(-328.086 -245.016)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-fire-insurance_svg__Path_65037",
  d: "m263.305 193.309-.178-.089a8.15 8.15 0 0 1-3.05-2.274 3 3 0 0 1-.553-1.871v-3.635l3.78-1.618 3.78 1.618v3.635a3 3 0 0 1-.553 1.871 8.15 8.15 0 0 1-3.049 2.274Zm-2.989-7.347v3.113c0 .721 0 1.8 2.989 3.347 2.989-1.544 2.989-2.626 2.989-3.347v-3.113l-2.989-1.279Z",
  "data-name": "Path 65037",
  style: {
    fill: "#fff"
  },
  transform: "translate(-247.711 -175.565)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-fire-insurance_svg__Path_65038",
  d: "M343.681 183.823v.861l2.989 1.279v3.113c0 .721 0 1.8-2.989 3.347v.887l.178-.089a8.15 8.15 0 0 0 3.049-2.274 3 3 0 0 0 .553-1.871v-3.635Z",
  "data-name": "Path 65038",
  style: {
    fill: "#ffec97"
  },
  transform: "translate(-328.087 -175.565)"
}))));

const SvgPxFrontDesk = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 30.007 30"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 13638"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h30v30H0z",
  "data-name": "Rectangle 13482"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4b60fe",
  d: "M12.214 3.416a3.416 3.416 0 1 0-3.417 3.416 3.42 3.42 0 0 0 3.415-3.416Z",
  "data-name": "Path 24120"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#002672",
  d: "M14.297 10.988a4.16 4.16 0 0 0-4.156-4.156h-.465v5.466H7.919V6.832h-.465a4.16 4.16 0 0 0-4.156 4.156v4.282h11Z",
  "data-name": "Path 24121"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#002672",
  d: "M.003 29.999h30V21.13H.001Z",
  "data-name": "Path 24122"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4b60fe",
  d: "M0 17.027v2.345h30.007v-2.345Z",
  "data-name": "Path 24123"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#002672",
  d: "M18.218 10.575h9.738v4.694h-9.738Z",
  "data-name": "Path 24124"
})));

const SvgPxGeneralDocument = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 30 30"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 8453"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 8452"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 4535"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#002672",
  d: "M28.513 4.001H22.83a1.477 1.477 0 0 0-1.449 1.495.8.8 0 0 1-.831.806H7.756a1.9 1.9 0 0 0-2.109 1.487l-.257 2.524H1.364c-.75 0-1.364.4-1.364 1.112l2.472 12.283c.256 1.048 1.279 1.317 2.3 1.291h21.652c.234-.007.284-.337.369-.733l3.168-18.77c.203-1.348-.397-1.495-1.448-1.495m-1.3 4.386-2.107 12.045-1.83-8.828c-.178-.914-1.236-1.311-2.216-1.291H6.032l.14-1.925a.854.854 0 0 1 .8-.7h19.666a.57.57 0 0 1 .57.699Z",
  "data-name": "Path 10092"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5367ff",
  d: "M25.177 8.938H7.889c-1.03 0-1.225.391-1.145.679.02.07.183.144.846.144h11.989c.663 0 1.262-.007 1.284-.007s1.4-.014 2.6.021c.969.029 1.672.064 1.665.826l-.337 5.261c.124.651.134 1.55.252.9l1.184-6.565a1.11 1.11 0 0 0-1.05-1.259",
  "data-name": "Path 10093"
})))));

const SvgPxHandDown = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: "1em",
  height: "1em",
  viewBox: "0 0 15 15"
}, props), /*#__PURE__*/React.createElement("image", {
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEACAYAAABccqhmAAAyVElEQVR4Xu1dB3hUxfaXIoQWeuglNOmCL4CggPSiNKUXBaTmQUAEBB9FwAciIFVApIN0RBGBIEHKg9B7lUBCV3oPYID/7+CG/2azu3fm7r1379499/vyWXbmzJnfnTn3zJlTXnmFH0aAEWAEGAFGgBFgBBgBRoARYAQYAUaAEfAHBJLUqVNnvVUm+vfffyevXLny/4YNG/aFVebE82AE9EQgeXh4eB09BzCadvLkyZ8aPSaPxwj4KgJJfZVxV3ynSpUq1mpz4vkwAnohYDkBoBdQTJcRsCICLACs+FZ5ToyAIAIsAASB4maMgBURYAFgxbfKc2IEBBFgASAIFDdjBKyIAAsAK75VnhMjIIgACwBBoLgZI2BFBAwRAEmSJHmWNGlSdtCx4griOfk0Asn14D579ux/VqtW7fcKFSrszJEjxxX6bwiAZ1evXg26cuVKjiNHjpTasGFD7ejo6AJ6jM80GQFGQByB52iqyV/ZsmX3zZ8/v821a9cyKw1///79NL/88kv9WrVqbdBqfKLTqFGjn5TG5t8ZAUbgHwQ00QDSpUt3DwE4Q7p16zY9derUj0TATZs27QO0W0t/y5Yt++Czzz772lsaAQRWpjFjxnz25MmTFCK8m60N4h/igOf9wMDAu45/eDd3M2TIcDt9+vR38G4eou0zs/HP/HgPgSS2r69qDgoVKhQ1Z86cDxGFF6maCDpGRUUV6NChw9xt27ZV9oQONICf8TSWoXHy5MlCRYsWPS3TxxfakmDA398pUqT4mwRD7ty5L9Jfnjx5LuTMmfOy3X+fDwoKugYBwXEUvvBiNeZRtfpfoECBqDNnzgRrxc+9e/fS1K5dO9yTI4GaI8Dp06cL4At6z5NxfbUvbDNxpCUUKVLkVJMmTX4cOHDgyHnz5n147NixYo8ePUqp1btlOuZFQJUAgEp5OzIyspzW04KRMBu+xifUbigWANrYcwICAh6WKlXqcPfu3afOmjWrIzS0glq/a6ZnDgRUCYApU6aE6sX+9u3bK0BtfaxGCLAA0EYAOGJPGhIlj5k0aVLPs2fP5tfr3TNd4xGQFgDlypXbTdl39GS1ffv2c1gA6LOZ1eBq34e0v+bNmy9dsmRJi9u3b6fXcx0wbf0RkBYAq1ataqQ3W6dOnSqk5lzOGoCxQiN//vzRPXr0mAzj7dt6rwmmrw8CUgKADH8wDhlyXdagQYPVsl8rlQIgWI2wkeXNyu3JmEg+HQsWLGgDY25afZYqU9UaAWlXYJwDw2EgeqI1I87o1atXj/wE+PEBBJ49e5bst99+q9WuXbuFISEhe7/44ouh0OIK+wDrfs+ilAawaNGilkYhdujQoeIpU6YkxyJhHlkDEMdKBlc1beF7cKdt27YLIBhqQECQzwk/JkNASgOgoB44kFwyag4Y6wqSfD40ajweR1sE7t69G7hw4cK2OBpsrFq16hY4jLV/8OBBam1HYWqeICAlAPA1fgyPsb88GVCmb5o0aR5myZLlhkwfbmtOBMjDE56ecypWrBg5derU7nfu3Ak0J6f+xZWUAKCc+zj/0/28IQ9FENr8AQwZjwfRH4HDhw+XDg0NnUqRohMnTux58+bNjPqPyiO4QkBKAMD6H4DAmaxGwUmuqDdu3Mhi1Hg8jnEIIP6iWK9evSZBEOz6+uuv+yFU3LB1ZdwszT+SlACIi4tLjheVzahp3bp1KyNfKRmFtnfGQRxG4f79+39dvnz5XSNGjPjP5cuXs3uHE/8cVUoAEERHjx4tZRRUSBxSOjY2NpVR4/E43kMgJiYmePDgwV9CEOwZMmTIsPPnz+fxHjf+M7K0AFi3bl09o+BB1qC6z58/l+bRKP54HO0RuHjxYu7hw4cPgSDYTZGJ586dY0GgPcwJKArfsaPXcxgBY0+cOPGazjy98vDhwwDyOqQxZf7YD0AOLxlsvdEWKeUujRw5ciAbC/XbcVIbjBZB165dp+vHzj+Up02b1k3NgmMBYC0BEL8GECJ+fMaMGZ2QtelVvdeev9GXFgCkBRw8eLC0XkDBgSRtcHDwGRYA1tzMat5rfB+6Ply5cmUTvdaeP9KVFgD0MpACbKteXl02DUMVX6wB+IfQoMxRERER1fxxw2o9Z1UbjYQAPLtmac3M+PHje3nyhWAB4B8CIH6NfPTRR3MpdFzrdehP9FQLAHoJPXv2nPT48WNNwoPJM4ySWLIA8K9N7Mn7pr7knk6GQvYZUSe2PBIA9AIobBfJQVUX+UBWmUBKKuHpQqD+rAH4r/AoU6bMgRUrVryvbhv4by+PBQBtPFT/uTxq1KgBcN3NJAolWXRRSKQtJZ/UYvOzAPDfzW+/fiiRzK5duzRPWCu6rn2tnSYCIP4F0N19WFjYRFT9eff69esZcJ//MrU0ZRJCFFiaLVu2vD1o0KARb7zxxl6tNn48HdYAWAjQWqCbqn79+n2NNahYpcrXNqzW/GoqAOw3dKZMma5TvnnEgm+uXr36xuLFix+l8xryClChUF3GZQGgD656vS+96RYrVuwYHwvciwxdNqLeL9YVfRYALACcrQ3KYmyEB6vWX2e96bGfvd4IM31TIID6k82hiW795ptvPtE7pb0pJizIBAsAQaC4me8jQOXp+/Tp8w2Oo5tgh/KoBqXvo/HPDFgAWOVN8jyEEaD0ZDVq1NjUu3fv8TK3VsID+FBDFgA+9LKYVe0QoOQ2EyZM6F2tWrXf169fX0s7yr5FiQWAb70v5lZjBChHYd26dTfQ1bU/XhmyANB4QTE530QARU/DSBtYu3ZtXd+cgTquWQCow417WRABpKArVb9+/XXklo7kt36RjJYFgAUXMk/JMwSmTJnSg7SBNWvW1PeMkvl7swAw/ztiDr2AAJLflnzvvfd+pWhXK5dAZwHghcXFQ/oOApMnT+5Zs2bNjTt27KjgO1yLc8oCQBwrbumnCOzduzcEQiBi7Nixn1oNAhYAVnujPB9dEEBUa5q+ffuObdiw4c/IfRGsyyBeIMoCwAug85C+i8Dq1asbwpX49+XLl3/gu7P4f85ZAFjhLfIcDEUAxUryNWvWbAUZCH29yjELAEOXDg9mJQTiDYSRkZHlfXVeLAB89c0x36ZAYM+ePeVq1aoVAWHwb1MwJMkECwBJwLg5I+CIwP3799PiODClY8eOM1HROoMvIcQCwJfeFvNqagRmz579MQqWbNi/f79uVbO0BoAFgNaIMj2/RoCOBBACEfPmzWvnC0CwAPCFt8Q8+hQCCCvOgopF8ynhSGxsbICZmWcBYOa3w7z5NAKUcKROnTrhZk5GygLAp5cYM292BLZu3VoF6ccizFrRmAWA2VcQ8+fzCFy+fDnXBx988OOQIUOGmW0yLADM9kaYH8siMHz48CEtW7ZcfPPmzYxmmSQLALO8CebDLxBYsmRJS7ILHDt2rKgZJswCwAxvgXnwKwRs3oMbzZB/kAWAXy09nqxZECC7QOPGjX/GTUEvb/LEAuAf9Kk+Ij+MgKEIPHnyJAV8BSZQEtLHjx+nMHRw22AsAP4BIsmzZ8+SeOMF8JiMACUhRaKR1efPn89tNBosAIA4bX7K+GI0+DweIxCPQHh4eB2KI9i1a1eIkagkN3Iws46VLVu2vyCF/w2VLGXSpEmfkkYgwKurY0MSPM/xvDJ9+vTuJ0+eNIW1V2A+3MTLCGCtFMMNwYZFixaFtm7deolR7NBCtsxfo0aNfjIKOKVx5syZ86GVsOW5GLdPxo0b10dpfWn1u2U2Py1QMwkAHCsCihYteoI3jnEbx0pY9+vX72utNrkrOmwD0BHh1KlTPwoNDf1WxyGYtIURGDNmTL927drNf/DgQWo9p8kagI7ooqpMYL58+WKs9GXiuRir0SDl2IYrV65k12OZsgagB6p2NDNkyHC3W7du03UehslbGIHffvutVr169dYhrLiIHtNkDUAPVO1o/vXXX1mzZ89+hb+cxn45rYZ3/vz5o7dt21ZJy+XKGoCWaLqghWvGax06dJhtwFA8hIURiImJyd+gQYM1WucWYA3AgEUDL69cOA7ctNpXiedjvFbz6quvPoHfSqgWy5Y1AC1QFKCRN2/eS+3bt58n0JSbMAJuEfj7779fRfzAt4MHDx6uBVSsAWiBogANqHB5M2bMeIO/msZ/Na2KeZcuXb7zJJCINQCBjatVExhxznfv3n2aVvSYDiMwY8aMLqhTuNyTLEOsARi4jnAjEJQjR45LVv0i8by8o93UrFnzNzWFSlkDMHDz01C4Ebjaq1evSQYPy8NZHIGNGzfWbNWq1SI1XoOsARi8OMg7MDg4+Ax/Lb3ztbQy7k2bNl0OI6FwlC9rAAZvfhqOvAMR6DHGC0PzkBZHYMWKFU0///zzkTLTZA1ABi2N2lKkYPHixY9a+WvEc/OehrNgwYI2okuVBYAoUhq3s70kS+HPm957m94e+/Tp09/evXv3v0SWrKUWoJnyASiBj7NasooVK27nTWOOTWO191CsWLFjsDeld7cO2QagtEt1/B0unU9HjRo1wJaGTMeRmLQ/IoDoweLDhg0bojR31gCUENL5d5SSnmu1rw/PxxxaTYoUKR5v3779TXdLmAWAzhtciXx0dHQ+dhE2x4axouCqUKHCzkePHqV0tg6F7wuVFjH/rh4B+AScw1Hg64EDB36lnop/9wwICHiUNWvWa5kyZaKIy1dsmZmTXL16NSs85NL7c9p3pBqvMHHiRKpAlCjHIKW/tlRVHBgBf8bT2Ne2Azy4AiCp9xw9erSkr/HuTX7Lli27Hym0FyGn/joI0vNQeZ/ECwD6J335/vzzzyCEY+c7d+5c/j/++OM11OYrf+jQodLwn8/sTd6NHBuC8caRI0dK5cqVixLTJHj4CGDkm3Az1qpVqxpZUQXVY06FChU6PWvWrPauVFulV4qYjCzr16+vOWLEiP+8//77KxCufY7i7PXg1Sw0aa7OcGEBoLRaDPwdGV9Wm2XBmJUPRFRORXFNTZNk3r17Ny1U5TegKvegq2Qr2mQoOa2za0EWAAZucKWhoKYVT5cu3V2zbj5v8hUSErIHJbRqKmGoxe8XL17MMXfuXGTlbjcvZ86cF705by3Hnjp1anc+AmixQnSkAYPgZ1q+dCvQCgsLm4ivdDodYXdJGraC9DieNYDm8W2BAgWifBnPUqVKHXZMIMIagDdWlZsxca5NUb58+V2+vNC04j0oKOgvGb92vV8lhFCapUuXNiW7Qdq0ae9pNU8j6SxbtqypPU4sAPReNSrok/MGOXEYuTDMNlbJkiWPHDx4sJQK+AzpgmKeBUeOHDkANxH7zIadO35IeLEAMGSJeDZI3759KWTYUgJadD6U4ebSpUs5PENQrDd8BF6dMGFC2Jo1a+qJ9UjYClWlk9GNAq4jF6ZKleqB6By91Y4MnKg0FBQ/C0stMF8KBlJabHBgSeePxUVpI6nJbKOEp7vfN23aVJUi6FCeez1i6ptgU6tykjt8+HCx3r17f2P2QjDz5s1rxwLAkxVjUN+1a9fW8daXwhvjUlxEXFxcMoPgTTDM8OHDB8XPmW4ckHu/+7Vr1zKp4QW3CNlHjx7dFwL8uDdwVBoThWpmWVIAkOqo5oWZuU/Hjh1nKr1QK/xOi9Jbm5/eP212fLkv22NJ5biQYefLU6dOFVSzRu7du5d62rRpXcymydFtAM0nSfPmzZeqmZgZ+zx79iwprOe7+/fvb6l0Wzdu3MgEN+FdUVFRhcyIuxY8oWjKXHj2fZwsWbJnWtBTS6NPnz5jv/nmm08d++N4cAfGsx87deo046233topSx9XiYFI4d3122+/7XnhwoU8sv21bk+xExBqll1PWuPldXowMtVC3oA4K3zpHeeAyre/elLcQsuXQ7YAdxgnT578bwirOY6aCm5tKsCIWFeJFzoaDBgw4L/wzb/u7Xe5bt06Ol7y4ysIfPLJJ+O8vWi0Hp+u0K5fv26aoBy4yqbNnTv3BaV5InLzv/brBnPICDfunyHM1qKCr9v4e+pHV4goGz8VX+KHSmPp9fv333//sa+sfeYTCNy/fz9VmTJl9uu1IIymS77pONYUMNvLrVWr1gYRLJYsWdLcnneKOsyTJ8856tuiRYtFkZGRijn59u3bVxptF4uMp3UbZKYebTbsmR8FBLCoyuGrEav1YjCaHkXebdiwoYYZX3jjxo1XieBBajzqPeaznwPCjIsHBgbepv50XECxjh8oyEhpnqtXr65funTpQyLjatWmbt2665T44t9NiIAtrNOn/TccvdHMBDP5IYhuMtz5j3fkfejQoYPt+5NHJ+wGs48fP17Y3Txv3bqVHgZsSgpjyLu1CRwzQc+8iCBATirVqlWLMGqh6DEOkrY0EJmrN9q0bNlSWCWnWAW6pbHnE7kGMqMEHCXeSLCRyQNvyJAhQ3EjkMHdvBD70JqckvTA3Z4mrjjPegNfHlMDBOjsjEX2p96LRA/6hQsX/gP2jDQawKALCWQXCpeZty2RSwJeKIzYFQ368qKW3zvumP/xxx8b0hFChg/ZtqhQ9SJ9Gj8+isDKlSsby750M7QPDQ2dYlbIUashSbly5XbL4OQs9TZlK3JHg650Bw0aNBy+K5SWz+lju2nQ7ThgEzBmfRXMlwgCvhgwNGnSpJ4ic/NGGwQGpZSN+bddzyZgF4lLyMCpuHk7d+48w9U8KRbEpqYr0hEZy7ENBS5xYRBvrDINx/zyyy//U6VKla0aktSdVJYsWa7pPojKAZCLIQAx/26r6TiSdpZxGDcBd/GFJccttw/u4js7MyRSJ9gB7sENfLYSDbW/k3cjCwC16JmkH64En8ycOfNjSoltEpYU2YARM4ViIy81wFc3kISAzPCpU6cmZ54ED2Unhpov5NaMUOTeOPM3djZmw4YNV9nyQsiwJNQWQuoeCwAhqMzdqEiRIlHI9dbN3Fz+P3dwmDEkzl8NHriKyyQroGBMu+04FtUigD1BOKQY7sGj4YUY6EgHFaRP4Eiii7WeMhqxAFCzSkzYp1mzZj/i/vkLE7KWiKWIiAhTOgARoxAAGWUFAKn7jpPEZs74/Plz4f2FegVFYNT9wIkm8UwvAcAagC/sFgkeYY0eBs8zusM29QNf+bdRuLKoGZkkDUCWLzpLOxMAsnSWL1+ewLU4vj8MgTGytETaU/ZpYQklQpDbeB+B6dOnd6XQYe9z4poDnLFTQeU1ZRk0lQLA6RFA9h3s3bs3BEFFiQQQnI10se9AAPARQPYlmb09WY4XLVrUCrnsL5mZV3gCNiLjpdl4pCOALE8ubAAZZOnAQzAjHLwSJR5BqLTTwp6y9B3bswDwFEGT9i9YsGD0woUL2+CeN5F12kws4/58vNkCgmQFAFn7nR0ByAgoizWcgpI5q1eIHAK5ZWmJtCfBxUcAEaR8sE316tW32CrCmpZ7pMtK16ZNm8W7d+9WDJs1ahKyAoC86Wx++wlYhBFQWgMgAs6u/BBxmF+P+efIkeMKCwA9kDUJzS5dusyEp+BYk7DjlA3k4cuKG4yVSE/lNlLOqDnICgBsWBIAzm4BpAUApelC9V4qQ/byQXbkFKhsnFeP+WfOnPkGCwA9kDURza+++moAlUw3EUuJWEHZ7nxNmjRZZVQdAHdYyAoA3KXfx8alAi6OGoD0EYBKeDuW77569WpWRBvqkjGJjwBm3hUa8QYV9Skl20QE2osssGZ9ECtfAmG4S3EsSOstHuG4Q2dwqWtA3KXfQXITitp7+RAdNTYAuu5LkyYNFRZ5+eDrnx+uxqn0wAQC5xZrAHogazKa8L2/8cMPP7Qyu7sw/AMq49jiMjhGb1jJAYgs8TLjkAGQDIH2fYiOGhsAjLdnkRWZAn/sBUA+Mg7K8CTSloQW8hOwABABywptkAf++OzZs9vTOdPM81m8eHErhMGO9AaPdN0mu3GhRt9xTGVOAkA2oIjmGxwcHO04bxyP8uuBRcqUKR9DA7jGGoAe6JqUJrLWrv3uu+86I0jlqUlZfMEWyqMPRA79TkbzSL742LxSd+7OrgCx+dOqubuHAEjk848aAroYACmAiXIXsgAwepV5eTyU3lpo9utBgigsLGwy1UIwEi6NA4FeleGdhDJ8/s849oFhNJcMHdG2+PrfhBCIYwEgipiF2vXs2fNbJBalOnimfSgkF8JqgZHXg1oGAskWOoHx76GjAIAxMenly5d1iZxEOrm/6OWzADDtFtCXscGDB//X7D4CSK6ZDUJgvlH5A9XEAdAtgOObko0EpP4w0F7Fvfwte1qxsbGpEDqdXY+VgJoMVL+ABYAe4PoKzbFjx/ZDSqrvzczvzp0730TGnAlG8CjrA0A8aeUGjNiNK2SYs58npQnHtWiiHAFaYBEfYcgagBZo+jANJBIJRWUaUxeIRdBQJyMSnqjRAOgWwIkGkEF2SZBbruMV4JUrV3LKZicSHZcFgChSFm+H++A4XA92QE07U1eJ+fTTT8fBT6CSnq9DpQZw25EnNU5AJAAc6VDmJNgBpIyJIvgkSZLkWfyVI2sAIohZvA0MULFwFGpTuXLlbWadKs7DqckegK+iLmdimresAKCN5OIaUNoNOHv27FTjIcGjV+o0RInGxl85sgAw64o3mC9yC0VGmmaVKlXabvDQwsOdPXu2IHkKusulL0zMSUNZAWALBEqkAcg6ExEr0AAuO7IEI6guwo5uAOK9QlkAeLJiLNYXX6G/kKijMcqO/W7Wqf3yyy8NUFcgTA/+ZAUAudPCBpDAck98aXUEgLajyxUgqf+k9RGvLAD0WEk+TBNfhutITvk+ymNRiWxTPrjCHHHw4MHSWjJHFYEca/wp0afYfWTVSRC8Q31kNQCy/jvTAPS6ArTPMcgCQOkt++HvOA7cxnGg6XvvvbfGjNOnRCLdunWbDgu5lNuuu7mQ/76sBkDZgB2v7tRoAJS5CQLAmQ1AlyMANICYeCxYAJhxhZuAJ8otuGTJkhaI0//RBOwkYgH+ARVRFUkzb0a6bpNV3ekKEMeABJGAMFYmk9UASOuivAL2k0QikABoANn0wB4aQKKgIz3GYZoWQAALOgB+AkswFV3q03lCl1TwzZs3V9EC5jNnzuSlQhky/FStWnWz49gIBEoFW0qi0uDu6KK02xZHOkgEktlWvVdT3Elg4fhUKn484colWoDMNHwPAainj6Aet6PsMYgk7GqmGZDa3r1792n44lZy5pAjw6uaQCBnV4D4cqcmF16ZsZ3VSkSqtCx6OAHB4/ByoUKFXkYd8hFA5k35aVu67sLm7+asDLa3IUGBkeJDhgwZ7ikfagSAi4pAGSCYpJx36AjgyD8EQJCakGIlHEqUKHEUms5LwyULACXE+PeXCKD02Ai45XZEUpEXV0hmeUgzQVGNNzzhhzacbH9n9QAoEAg3ClLFT51lasIRIJtMaTFR3l9//fUEqeFYAIgix+1eINCpU6c5qGTbxJnnmrcgoi/l559/PsqT8WXVdhrLWSQgDIkZ4uLipI7WOAIk0gAgAKQFksj8kRnqiH07FgAiqHGbBAjUr18/fN26dbWLFi16wizQoMBI7aVLlzZTy4+jFV6EjlYVgRAGnEgAoERYVhEeZNogAciDN998M5IFgAxq3NYpAmXLlj0SHh5ep1atWr+ZBSIcUYarzR0Az7gE13Aic9KqKChq/111HA8CIIsIDzJtoP4fwhXgizwA8Q9rADIIctsECCCpxAVyzYUlfqoZoDl58mTR8ePH91bDS548ec45pvdWouOYwpvay/oSUEZhZ7cAehwBEOz1P6QeS5B1WGmO/DsjIITAhAkTwmxlrTS9t8bgUvTo7hx3+sFCTNs1gh0h+WuvvXZSZjyEJ1d0HAe2iC9laFCJbuT+T5T3D/EYm2ToiLRdvXr1u7K4cHtGQBiBtWvX1smdO/cFkcWoZ5v27dvPEWbariGuE4eJ8lW+fPldzq77QkNDp4jSoHYwpl6G1pDOnl/c/6coXrz4URk6Sm1Jy4BWofmxQg3O3MfCCBw7dqxouXLldistSD1/h3/+I+JDFma43mbFUeC8Em9Qo+PWrFlT1xn91q1bL1Tqb/87rPKHHWMaKBUYQnYpNkBK+3HX3ubNKQsJt2cE5BGg6jqtWrVapOUClqXVo0ePyfKcv/IKqfXuXHlhSb8/bdq0Lq5ot23bdoEMr1D1IxxpoRhILjoayNBRaou4juZq8OA+jIBqBKBSf6G0MPX6HWWvbuBsnVsN80eOHCmG7ENzKdYfrtAP6J+FCxf+AwlUZ6CUeVl3NGVtAM2bN0+UjzEqKiq/bFyCOxxJoMmGOqvBjfswAokQWLBgQWtb0gzN1FlRoTFy5MiBnrwSVOXJiZuFQhSYAx9/If9+HA3qifJH7Ww2gwRsnj59OlhLAaDWJuIJdtyXEXiJAEJ3Q+A0dFxmY2jRtkyZMgfglad5YU13rxb391A+Mt4Q5R++C6QlJXhQDKUgHTVEaSi1g5NUDV6OjIBXEcDXNFedOnXWKy1WLX9H0s6nW7ZsedvoidPxQXQekydP7uHIH2kdiLd4KErDXbu3335729OnT9nfx+hFwOMlRoDKZaEs2SQtFrYoDdt4hr4O3EC8JqrCU9IVR+aQDDSLjBbhDgs2/hn66nkwEQSQ1LOHLaJQd7tAyZIlj+C+Xio4R2QOSm3mzp3bTkRIbdy4sbojLRxbkr7xxht7Rfq7a0O+BLI1CpXmxb8zApogQMFESE5x0dNFrtSffAKOHz9eRBOmJYnMmjWrvVJ2IPvsPPbkW7ZsuVhpbkq/wwDbRpJlbs4IGIcAXbeRoU5pIXv6OzZiB+NmlXAknOcL9+vX72uaZ/y5nmwTdEQgb0IYDTM442306NH9PZl348aNV3lrzjwuIyCMACW+RHgxZR/W7TiA4qLjhRnSqSGp4uSduGnTpne2bt36Fu76g91lNfbEF4DcfqOjo/PrNBUmywhoiwD51COi8Fu9hIDNPVdbpg2gZnMSkhaM8+fPb2sAezwEI6AtAlB7+5F6rLUgQJGTcG05NYba4cOHiyPnwG0ZPHCt+G9juONRGAEdEEBWnw+0ToddoUKFnWRZ14Fd3UmSIVFEACRPnpwSt3bWnSEegBHQG4HIyMgQpK4+LbLwRdo4y9+v9xy0pE9XirakIU6PAyTg1q9fX0vLMZkWI+BVBJDUIz/y1+0Q2eBKbZDI9HuvTkaDwZH+vHDfvn3HkGcfUnsdRHafrV27dp2OOo5NZNOQa8AOk2AE9EcAcfEZmjVrtkxpgyv9biXVmNx6caPwql4l0vV/qzwCIyCBAC34Tz75ZJzSJnf1OxkV9+/fr2klYQn2uSkjwAhogcC8efPaooAGZc+VuhYjVRmFOgx3BdZizkyDEWAE7BCA22xJ2WSZ5HLMIDICjICFEJgzZ85HIhl8UT78cwtNm6fCCDAC8Qigll9mSjnmLIknCQcSEoyWMgJJlJtwC0bAvAjQTQGSflQ+cODAv1Bi6wZlHgoJCdmXKVOm2+blmjljBBgBRoARYAQYAUaAEWAEGAFGwCsIsA3AK7DzoGZG4OHDhympyjBSgafBP9Piv9Mg2CaOknhQQVD888Uf/t8zM89DhDcWACIocRvLIoDNHYA03IW3b99e+Y8//ngNOfkLnT17tiAScwbBCzE5ORHRP1EO7FmyZMniUEE4DsVCHqLMdgyKhUQVKFDgLOXvQ0DObqT/SlTm27LA8cQYAV9FgIp8UKXcLl26fIdbgxNaJCjFrcN1Sns+duzYTyFICvoqNsw3I2BZBJAc9LXPPvvsK9r0mKSUS7FMezoqUE6+5cuXf8A5+S27nHhivoLAoUOHSlDobGBg4B2ZjaxF24oVK26n7LxGVyjylXfDfDICuiGAKsUZBg4c+F+tK+2qEQwUxx8REfGObpNlwowAI/D/CKxataohFQVRs1n17ANNZBoyIWfld8UIMAI6IBAbGxvgSf4APTd/PG0STEgNXkmH6UuT5GtAaci4g1kRoKq6nTt3no3NVUUtj8g5cC1fvnznChYseCZbtmx/0r0/KvU+xBk+OfkF3LlzJ8O5c+fy0XUhvuTZIXBSqxmLbh5GjRo1EMJqopr+3IcRYATsENizZ0/Z4ODgM7JfcCodVr169Y0jRowYhDp91W7cuJFJpJYgHIRSU9UfqjpE14kQGjGyY1N7qhrEL5IRYAQ8QGDDhg01goKC/pTZgHDkOTto0KDhiCIs5cHQL7vC4Jhx0aJFLdVUOerYseNMTuypxVtgGn6HAJ2lZeoI0MYfN25cb8onoBdYKP9V1VabT9jXoEOHDrP04ofpMgKWRADFRYvnyJHjkuiXn8qPXbx4MadRYNBNRKlSpQ6L8tenT5+xRvHG4zACPo3A1atXs1LyD5HNRSW6f/rppwbemDCq/2a21SYU0gbGjx/fyxt88piMgE8h8P77768Q2fxUlhuegCXVTA6BQilg7AuA9T8F/gLu3bunyuJPYw/FI8Iv3Q6Y5YpQDWbchxHQHQEE3PQR2UyNGjX6CVF9qpxuYmJickF9P0Q3C1SmDFF/UbD0R8Ott7XaCaJqbxvYK24p8V6kSJFTsFFkUTsO92MELIsAfc0RjvtAaRN9+OGH8zzxv0dEXwGEAMc5jjNhwoQwT8CFgbAKKv4qCgErlDPzBCfuywg4RaBu3brrlDZ/lSpVtkBlV62u08DkrosYgkTBQ8g2/KGnrwbXhS2U5kDVfjdv3qzaoclTHrk/I2A6BBYuXEjqt1tjGl3znT9/Prda5nHOT4Ow4SLTpk3rCiehWMfxmjRpspKi++A0VJ3awciX8dGjRylkxxs2bNhgpbmUL19+F+oAStOW5YXbMwKmR4A2WbFixY652zRQrW8js08F2clERUUVmDx5cg8qRJo7d+4LIkcM4oPaUSIQ8u3HPf7sqVOndoNjUWkYD1OJ8CByO0DCRoQWt2EELI0ADGhtlb6Y06dP7yIDwuHDh0uQF56IYU5p7PjfyYpPhUm2bdumGOxz9+7dtMWLFz/qjjalG+PahjJvldtaDgFyk6WN4G6joGZghEzJ7IkTJ4ZlzJjxhujGlm0n+uVes2ZNXapg7I4+ZRay3EvlCTECogiEh4fXdLdBUqRI8Xj37t3/EqVHSUJkN7Rs+6VLlzYT5UfJp6FevXq/itLidoyA5RCwXYm5NP41bdp0ueikv//++06ym1lNewiA5qI87dy5MwTZhp+4GodsDQg/5kSjooByO+sgQEE75MrranPQdZnIeZsQuXDhQi53tNRsdFd9ZAQA8dagQYPV7sYfPXp0fz3eanI9iDJNRkArBCi5ByXecEWPrsoqV668Q2S8xYsXt3ZHi2jgGjG6Zs2aERRhOGXKlJ64fUhg0e/Ro8cUyu8XHR1d4PLlyzkRXJQLeQGKUi0BXNmljOcD9oikIjzFt6FowF9++cVlvML69evroi3nDpABldv6PgJ9+/Yd4+7LCGNeT9FZwlC4yR0tSs4RHyaM+/1AZ8lEZ86c2dFxPGQFSnnw4MFSuEr8d9u2bRfkzZv33LJly6QMd+R/QD4MrvijmwoIHJeCUBQDbscI+BQClFbb1aags/GZM2eCRSaEK7c0UP8vu6JFRT3s6eDMnZfy+zu2p02uNN7t27fTYkMHKLVz/D00NHSKOwG1cuXKJrI0ldpLqSlKxPh3RkBLBC5dupQd3nYlXNEsXbr0EQTrxIiMeevWrfRwD07rqi3U+v85/KY6Xya+1vehPTwS4cu+jRMeEpBA2rPysjSV2rMAUEKIf/caAvDQK4QvdzpXDFSqVGkHAnbodkDxQV2/p7hvd9kWX/zCDkSE6CoOLNHgzTff3IEEpBTo5PSBnaGABDmhpiwAhGDiRt5AAOp9oefPn7tcoyVKlCAvOqEHX+U75CrsqvGKFSs+sAXpvGiC44X0F1yIETeN4IZ8iTISuxMAWnsFsgDw9K1xf90QIEu7K+L4mj+D+k9GM6EH5/lHiOmPdtWYSoDDN38J5fIjt2OkGyvjTGOA0xHd1+vygPZT5B6gzMZOH0pHDtuCS41IDVN8DagGNe5jCAKUotvVQPhCx1KJbhlGkCDk5y1btlR11wepwxrTH3z6HznL1IsEI9mopDhUdV00BHdzohBn1CUIBP+UT0CThzUATWBkInog4K7oBn2JodJTvL7w06pVq0VIIko3AYoP7v8DcJefzLHhyJEj/4M0Y4eIFv59IO7na9s2pSJNkQbu5kT8IEVZGhE63IYR8HkEKDwXk3DqAkzZgCmaTnaSq1evftdZph9X44j8f0obFhYWNpGyFMvy49ge1YIGuBqTvB537Njxpqdj2PdnDUBLNJmWpghQOS5XBJGs44k7q76rfg0bNvx17ty5H8lqD+4mRraKSZMmhb311luRgwcPHv706VPV+woxAX+7Govo4liiaYIQ1Yxq+qaZGCPgBAGKrXcFDM7hqdXm/EO+wB8QYVgLUXZrtQQeGkkgSowNbtGixVK1qjrNyxVPEA5xVKtQS57ZCKglmkxLUwRguXe52Mnv3t73XnZg3LnvQZ936QwPo18TCITacLXN5QnNeB5wpdgU14638d+dZfmiAqSu+sCXIc7mnixL1mV7FgCaQcmEtEbA3deOjHSwyAdhzGuejIskoxvQfwMV+4TjUUFkHS5DwT179+4th7x/Ndz5IbgbFzEDnWBv+BlHjjUy/KHgCc3J6QMbwFMIgPsy9JTasgBQQoh/9xoCOXPmdGmxpy81zt4UI095Aj1+oG08BJEjtr9XkFg0J9J1nYRgSHDv/vrrrx8iZxx3LsrxzCD3AKUokxIA7rz9MmfOfENL2wXxyTYAj5cOE9ALgYIFC0a5ow1PQd2SZODL/xxGxkTDd+vWbfq+fftCIiIiqsGGQCnKXT7kc4BjRTZRfCgi0N2cyPHJJqhESSq2YwGgCBE38BYCEACn3VnFoaaH6MUbLO5OtWOSC+QmXKNGjc1Q8RsgijDcFQ9k0IMAyCHK47Fjx4q5y1cAAeDSk1F0DMd2LADUIsf9dEcArrsx2bJl+8vVQJGRkRVFU3Brxaz9FR+E01NY/Be7ok3XmMgvIKwBYD5vu7v6RFr0k1rNI54OCwCtEWV6miEQGBh4v1y5crtdEcQ5PS9CZIWTgWrGmB0hpVsDct4RHRdlw6q7akuxD/Az2CZKS7QdCwBRpLidVxBAyG+kq4HJNRZJMoSz79K5fcyYMX1R90/RdmDzFnQc+jk2NNULfPFcuXIlu83Q55RFOr5Ag/lTBDic/fODP5cCgKIEYYAkIyU/jID/ILBr164Qd667lH7LXc4Ae6TGjRv3oqowAnnuU/3A/v37j0aewJbkwksJQ2Ddf+n7j7N7EDQQx9qAz8aPH9+LbgioCAlVBCJ6rv6oojBdL4q8LVvST5e0KNWYCB1uwwhYCgHy9gsJCSGnHZeb47vvvhNyuEHpru7O6MDj8CF9qem4QcVHca5fQrn6qd6AY3sqBWbLK+C2RiH1QwLRySIvA84/qaiakLs5cnEQESS5jSUR+Oqrrz5ztzmovJZIEU2q3eeOjpa/kcceHIqKiLwQHCM+djc2tJwYUS1HZDxuwwj4FAJ0Zlcq2CmSrNOVBqDlxo+nJVqnEKHEaZW+/r179x7vUy+MmWUEtEagXbt2891tVFLhKUe/u3FtQkJRdfdEIJC9YuzYsWRrEHoGDBgwyt14dDyBjcJlYlShQbgRI+DrCMD77nVnZ3L7zWPLH+ByqrAVkGuubgKAipQgfqCaKNabN2+urKTZfPTRR3NF6XE7RsDSCJBxTmkDDx069AtXICDFWPoZM2Z0ql+//hqtKgNT7QCqKYDbhBbOUoi54gVxDPnpbO9uPsh58AgFR0rr+VJV5z7XkymmzQg4QwABOEUrVKiwWykxJkpzt8WR4Qd3KCKSMCsi/0pjg5Ul91t47AXhLyui8bLSv6O4RwZn42DTnkep8v244juDa8Bj77zzzu/ksSjzxsjnv3bt2hvg+VfJXb+ePXvi1DI5TIY2t2UELI0AEm78R0kLoPv77du3V1ADBL7iyWFxT4WKveWcqecTJkzopYaufR/bnb7bo0iePHnOkTDydCzuzwhYCgG6M0dSzv1KQgCeczHIn6e6kg6qEmVzVhvQdpOgClMKI8ZXfZIS7/Q7tJg2qgbhToyA1RFAFGBZZ5vTcWNRQU1spNZq8EBykPzONios/J+qoYdjRpBSCfD48ahSsJox1PRhG4Aa1LiP1xGge3bE5n8nwsgX/zzDRNrGt4ENIM2cOXM+pvLguNp7iv+fhBJyvvvuu2tgAzgkQwt2hpKw5i+gbENK/aDdHEAegXfgbXhXqS3/zgj4NQJK1XTtv+CUxz8mJiav0YCh3FhL+ChcEVH7qXoxhERJo3nk8RgBn0SA4gRatmxJ8fhCd/swrJ0nzUHmuk4tMPBbKINKRD+J8oYv/q3ff/+9itrxuB8j4JcIULQdUnP9KrrRqB0F/cyePbu9Hv71u3fv/lf79u3nkAefKE9027Bq1aqGfvkCedKMgKcI4F49rYwmEL8xCxcu/EefPn3Gbtu2rRLV+1PLB1yQs8+aNasDCSIlb0VHoUDRhWvWrKmndmxP+7ER0FMEub8pEKBUXb169Zo4ZcqUHrIMkZGPqvIi487/ypYtewD/fpoSkgYFBV2njD6UBATJR5LSkYNSkMGWEIxbgsKnTp0qCn+Dtw4cOFAWRsOMsuOiEGg02QiQ9MRl1iNZmtyeEfBrBCAAQp0k8hCyEdh/nSlpCH2dyW5QtGjRE5TcgwKO6GoRmX6oRLg0Tfs+8AQMhxBxWf7cr18iT54R8AQBePEhh4j7JCKebmC1/UmjQP3AYWrLmnmCC/dlBPwGAbILIDBoqBbagNrN7tiP4gZwx/+237wEnigj4G0EcD4vRem9tC4JLiMUkPDjBGUjgh2BbW7eXhA8vn8iQJZ+cgayVRz26PwuuvlLly59CNF8oUg4msE/UedZMwImQ+Dw4cPFhw8fPgjW/n3ItU8uvpoKAzIcQtD8QEk8jS5aogZqVknUoMZ9fB4B8gZEPH6FrVu3VoXzTgX8lb9582YmROy9KjM5JAS5jyvDF1eIyFWwq3r16ptwc3BJhoY327IA8Cb6PLZpELh+/XomFOcIPn369GvI1hOMugA5qTIw/tLExsamJl8A2uzw2nuIKr03KdwY/gJRcCY6RRse2XuEKwCZZtLMCCPACDACjAAjwAgwAowAI8AIMAKMACPACPgNAv8HMyibBWRqb+YAAAAASUVORK5CYII=",
  width: 15,
  height: 15,
  "data-name": "image-removebg-preview (25)"
}));

const SvgPxHomeW = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 30 30"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "house (1)"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 5951"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 5950"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M15.061 6.137 3.561 17.66v11.453a.87.87 0 0 0 .865.886h6.245v-9.895a.88.88 0 0 1 .888-.875h7.013a.87.87 0 0 1 .877.875v9.895h6.136a.87.87 0 0 0 .865-.886V17.66Zm0 11.309a3.546 3.546 0 1 1 3.506-3.546 3.53 3.53 0 0 1-3.506 3.547Z",
  "data-name": "Path 11046"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 5953"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 5952"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#ffb11f",
  d: "M15.057 12.265a1.773 1.773 0 1 0 1.773 1.773 1.775 1.775 0 0 0-1.773-1.773",
  "data-name": "Path 11047"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 5955"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 5954"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#ffb11f",
  d: "M12.457 21.027h5.319V30h-5.319z",
  "data-name": "Rectangle 3819"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 5957"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 5956"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M29.808 14.046c-.3-.759-8.009-8.373-8.594-8.963l-4.29-4.33a2.684 2.684 0 0 0-3.728 0c-.633.638-12.686 12.5-13 13.288a2.68 2.68 0 0 0 .574 2.882 2.5 2.5 0 0 0 .742.5l12.927-12.91a.873.873 0 0 1 1.243 0l12.812 12.923a2.6 2.6 0 0 0 .734-.513 2.68 2.68 0 0 0 .58-2.877",
  "data-name": "Path 11048"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 5959"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 5958"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M25.57 1.782h-3.546a.85.85 0 0 0-.876.8l5.3 5.308V2.633a.846.846 0 0 0-.878-.851",
  "data-name": "Path 11049"
})))));

const SvgPxHome = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 30 30"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "house (1)"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 5951"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 5950"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#002672",
  d: "M15.061 6.137 3.561 17.66v11.453a.87.87 0 0 0 .865.886h6.245v-9.895a.88.88 0 0 1 .888-.875h7.013a.87.87 0 0 1 .877.875v9.895h6.136a.87.87 0 0 0 .865-.886V17.66Zm0 11.309a3.546 3.546 0 1 1 3.506-3.546 3.53 3.53 0 0 1-3.506 3.547Z",
  "data-name": "Path 11046"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 5953"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 5952"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#5367ff",
  d: "M15.057 12.265a1.773 1.773 0 1 0 1.773 1.773 1.775 1.775 0 0 0-1.773-1.773",
  "data-name": "Path 11047"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 5955"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 5954"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#5367ff",
  d: "M12.457 21.027h5.319V30h-5.319z",
  "data-name": "Rectangle 3819"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 5957"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 5956"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#002672",
  d: "M29.808 14.046c-.3-.759-8.009-8.373-8.594-8.963l-4.29-4.33a2.684 2.684 0 0 0-3.728 0c-.633.638-12.686 12.5-13 13.288a2.68 2.68 0 0 0 .574 2.882 2.5 2.5 0 0 0 .742.5l12.927-12.91a.873.873 0 0 1 1.243 0l12.812 12.923a2.6 2.6 0 0 0 .734-.513 2.68 2.68 0 0 0 .58-2.877",
  "data-name": "Path 11048"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 5959"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 5958"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#002672",
  d: "M25.57 1.782h-3.546a.85.85 0 0 0-.876.8l5.3 5.308V2.633a.846.846 0 0 0-.878-.851",
  "data-name": "Path 11049"
})))));

const SvgPxHumanArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 14 14"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".px-human-arrow_svg__cls-1{fill:#454545}")), /*#__PURE__*/React.createElement("g", {
  id: "px-human-arrow_svg__Group_50404",
  "data-name": "Group 50404",
  transform: "translate(23098 -17657)"
}, /*#__PURE__*/React.createElement("g", {
  id: "px-human-arrow_svg__judge",
  transform: "translate(-23214.916 17658.471)"
}, /*#__PURE__*/React.createElement("g", {
  id: "px-human-arrow_svg__Group_30379",
  "data-name": "Group 30379",
  transform: "translate(121)"
}, /*#__PURE__*/React.createElement("g", {
  id: "px-human-arrow_svg__Group_30378",
  "data-name": "Group 30378"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-human-arrow_svg__Path_31046",
  d: "M125.192 92.1a2.49 2.49 0 0 0 1.186-1.8h-.307a3.38 3.38 0 0 1-2.155-.877 3.38 3.38 0 0 1-2.155.877h-.307a2.49 2.49 0 0 0 1.186 1.8 2.92 2.92 0 0 0-1.64 2.617v3.5a.324.324 0 0 0 .324.324h5.184a.324.324 0 0 0 .324-.324v-3.5a2.92 2.92 0 0 0-1.64-2.617m.408 2.4a.32.32 0 0 1-.281.162h-.572v1.427a.324.324 0 0 1-.324.324h-1.015a.324.324 0 0 1-.324-.324v-1.424h-.572a.324.324 0 0 1-.281-.486l1.047-1.813a2.5 2.5 0 0 0 1.276 0l1.047 1.813a.32.32 0 0 1-.001.321",
  className: "px-human-arrow_svg__cls-1",
  "data-name": "Path 31046",
  transform: "translate(-121 -87.482)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-human-arrow_svg__Path_31047",
  d: "M144.148 1.241a.324.324 0 0 1 .533 0 2.6 2.6 0 0 0 1.9.919h.3a2.484 2.484 0 0 0-4.927 0h.3a2.6 2.6 0 0 0 1.894-.919",
  className: "px-human-arrow_svg__cls-1",
  "data-name": "Path 31047",
  transform: "translate(-141.498)"
})))), /*#__PURE__*/React.createElement("path", {
  id: "px-human-arrow_svg__Rectangle_21328",
  d: "M0 0h14v14H0z",
  "data-name": "Rectangle 21328",
  style: {
    fill: "none"
  },
  transform: "translate(-23098 17657)"
})));

const SvgPxIndustry = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".px-industry_svg__b{fill:#4379ba}.px-industry_svg__c{fill:#569ed8}.px-industry_svg__e{fill:#1d457f}.px-industry_svg__f{fill:#eabe50}")), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h32v32H0z",
  style: {
    fill: "none"
  }
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(4.723 4.723)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 12.443h22.554v10.11H0Z",
  className: "px-industry_svg__b"
}), /*#__PURE__*/React.createElement("rect", {
  width: 5.35,
  height: 13.078,
  className: "px-industry_svg__c",
  rx: 2.675,
  transform: "translate(15.566 7.648)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M96 24h2.333v5.444H96Z",
  style: {
    fill: "#2d57a0"
  },
  transform: "translate(-92.5 -24)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 18.276h7.777v4.277H0ZM7.777 19.443h6.222v3.111H7.777Z",
  className: "px-industry_svg__e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.969 5.738a2.333 2.333 0 0 0-3.3 0l-.55-.55a3.11 3.11 0 0 1 4.4 0Z",
  className: "px-industry_svg__f"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.869 6.838a.78.78 0 0 0-1.1 0l-.55-.55a1.555 1.555 0 0 1 2.2 0ZM21.07 4.638a3.89 3.89 0 0 0-5.5 0l-.55-.55a4.666 4.666 0 0 1 6.6 0Z",
  className: "px-industry_svg__f"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.832 5.444H3.499L1.555 6.999v5.445h6.222V7ZM3.5 0h2.333v1.944H3.5Z",
  className: "px-industry_svg__e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M256 25.555A1.555 1.555 0 0 1 257.555 24h4.666v.049a1.507 1.507 0 0 1-1.507 1.507Z",
  style: {
    fill: "#abdaef"
  },
  transform: "translate(-244.723 -24)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.665 10.888v1.555h-.778v-1.555h-.777v11.666h.778v-3.5h.778v3.5h.778V10.888Zm0 2.333v1.167h-.778v-1.167Zm0 1.944v1.167h-.778v-1.167Zm-.778 3.111v-1.167h.778v1.167Z",
  className: "px-industry_svg__e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.055 13.999a2.333 2.333 0 0 1-2.333 2.333H5.444a.78.78 0 0 0-.778.778v1.75a.972.972 0 1 1-1.944 0v-2.139a2.333 2.333 0 0 1 2.333-2.333h4.277a.78.78 0 0 0 .778-.778V3.111h1.944Z",
  className: "px-industry_svg__c"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.11 4.666h1.944v.778H10.11ZM10.11 6.222h1.944V7H10.11Z",
  className: "px-industry_svg__b"
})));

const SvgPxKeyCollection = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#dc6c33",
  d: "M26.1 16.157a5.762 5.762 0 1 0-8.871-6.988 8.2 8.2 0 0 0-2.623.114 6.3 6.3 0 0 0-1.918.731 2.58 2.58 0 0 0-1.475 2.078v1.491l-1.024.617-.29.77-1.553.039-.016.382-.023.587-1.807.037-.042 1.07-1.922.049-.536.324.042 1.677v1.364l2.842.085 7.616-4.569a7.9 7.9 0 0 0 3.664-.316 5.7 5.7 0 0 0 1.563 1.184v.007a2.3 2.3 0 0 0-.447 1.387v7.129a.854.854 0 0 0 .8.9h6.22a.854.854 0 0 0 .8-.9v-7.129a2.34 2.34 0 0 0-.447-1.387Zm-6.766-1a2.56 2.56 0 0 0 1.4-2v-1.369a2.23 2.23 0 0 0-1.315-1.935 4.8 4.8 0 0 0-.956-.421 4.549 4.549 0 1 1 6.913 5.745l-1.126-1.532a1.293 1.293 0 0 0-2.13 0l-1.657 2.248a4.5 4.5 0 0 1-1.126-.741Z",
  "data-name": "Path 71833"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#eaca6f",
  d: "M14.5 14.649 6.885 19.22l-2.842-.085L4 17.458l.532-.32 1.922-.049.042-1.07 1.814-.042.023-.587.016-.382 1.551-.041.29-.77 1.024-.617.467-.281a3.1 3.1 0 0 0 .845.688 5.6 5.6 0 0 0 1.974.662",
  "data-name": "Path 71834"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#faedbd",
  d: "M6.404 18.641a.326.326 0 0 1-.168-.606l7.26-4.356a.326.326 0 0 1 .336.559l-7.26 4.356a.33.33 0 0 1-.168.047",
  "data-name": "Path 71835"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#bfa057",
  "data-name": "Group 57447"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.503 14.649v1.367l-7.615 4.568V19.22z",
  "data-name": "Path 71836"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.885 19.22v1.364l-2.844-.085v-1.364Z",
  "data-name": "Path 71837"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#f6db6d",
  d: "M20.74 11.787v.026a2.62 2.62 0 0 1-1.471 2.016 6 6 0 0 1-.734.369 7.3 7.3 0 0 1-1.194.365 8 8 0 0 1-2.838.088 5.6 5.6 0 0 1-1.967-.659 3.1 3.1 0 0 1-.845-.688 1.85 1.85 0 0 1-.47-1.2v-.01a2.58 2.58 0 0 1 1.475-2.078 6.3 6.3 0 0 1 1.918-.731 8.2 8.2 0 0 1 2.623-.114q-.056.104-.1.212l1.338.052a4.8 4.8 0 0 1 .956.421 2.23 2.23 0 0 1 1.309 1.931",
  "data-name": "Path 71838"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#bfa057",
  "data-name": "Group 57448"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.907 10.905c.334.24.306.61-.082.853l-.027.018a1.73 1.73 0 0 1-1.18.173 1.2 1.2 0 0 1-.376-.133c-.419-.246-.4-.655.036-.919a1.5 1.5 0 0 1 .431-.167",
  "data-name": "Path 71839"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.74 11.813v1.341a2.56 2.56 0 0 1-1.4 2q-.035.022-.069.046a6 6 0 0 1-1.1.5 7.9 7.9 0 0 1-3.664.316v-1.364a8 8 0 0 0 2.838-.088 7 7 0 0 0 1.194-.365 6 6 0 0 0 .734-.369 2.62 2.62 0 0 0 1.467-2.017",
  "data-name": "Path 71840"
}), /*#__PURE__*/React.createElement("path", {
  d: "m11.687 13.302-.467.281v-1.481a1.85 1.85 0 0 0 .467 1.2",
  "data-name": "Path 71841"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#926f66",
  d: "M23.723 16.112a.91.91 0 0 0-1.18.091 1 1 0 0 0-.091.109.906.906 0 0 0 .091 1.177l.039.036a.91.91 0 0 0 1.247-.036 1 1 0 0 0 .14-.185",
  "data-name": "Path 71842"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#3a3e48",
  "data-name": "Group 57449"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23.599 24.985h-2.731a.327.327 0 0 1 0-.653h2.731a.327.327 0 1 1 0 .653",
  "data-name": "Path 71843"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.689 23.772h-1.82a.327.327 0 1 1 0-.653h1.82a.327.327 0 0 1 0 .653",
  "data-name": "Path 71844"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.599 22.557h-2.731a.326.326 0 1 1 0-.652h2.731a.326.326 0 1 1 0 .652",
  "data-name": "Path 71845"
})), /*#__PURE__*/React.createElement("g", {
  fill: "#928170",
  "data-name": "Group 57450"
}, /*#__PURE__*/React.createElement("path", {
  d: "m20.463 15.893-.734.992a5.7 5.7 0 0 1-1.563-1.184 6 6 0 0 0 1.1-.5q.034-.022.069-.046a4.5 4.5 0 0 0 1.128.738",
  "data-name": "Path 71846"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.143 11.765a5.72 5.72 0 0 1-2.039 4.391 5.64 5.64 0 0 1-2.134 1.148 5.7 5.7 0 0 1-1.387.222l-.039-.036a.905.905 0 0 1-.091-1.178 4.4 4.4 0 0 0 1.269-.2 4.5 4.5 0 0 0 1.661-.933 4.55 4.55 0 1 0-7.559-3.419.1.1 0 0 1-.026.016 1.7 1.7 0 0 1-1.181.173v-.183a5.8 5.8 0 0 1 .51-2.386l.1-.212a5.764 5.764 0 0 1 10.91 2.6Z",
  "data-name": "Path 71847"
})));

const SvgPxKeyContractor = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".px-key-contractor_svg__cls-4{fill:#3b5892}.px-key-contractor_svg__cls-7{fill:#ffcca9}.px-key-contractor_svg__cls-11{fill:#5e87ca}")), /*#__PURE__*/React.createElement("g", {
  id: "px-key-contractor_svg__Group_50388",
  "data-name": "Group 50388",
  transform: "translate(9168 -23133)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-key-contractor_svg__icon_placeholder",
  d: "M0 0h32v32H0z",
  style: {
    fill: "none"
  },
  transform: "translate(-9168 23133)"
}), /*#__PURE__*/React.createElement("g", {
  id: "px-key-contractor_svg__construction-worker",
  transform: "translate(-9167 23136)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-key-contractor_svg__Path_65166",
  d: "M10.361 47h10.174a4.36 4.36 0 0 1 4.365 4.361v1.09H6v-1.09A4.36 4.36 0 0 1 10.361 47",
  "data-name": "Path 65166",
  style: {
    fill: "#ccc"
  },
  transform: "translate(0 -28.648)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-key-contractor_svg__Path_65167",
  d: "M23.329 48.014A4.34 4.34 0 0 0 20.535 47H10.361A4.36 4.36 0 0 0 6 51.361h16.6a.727.727 0 0 0 .727-.727Z",
  "data-name": "Path 65167",
  style: {
    fill: "#d8d8d8"
  },
  transform: "translate(0 -28.648)"
}), /*#__PURE__*/React.createElement("g", {
  id: "px-key-contractor_svg__Group_50382",
  "data-name": "Group 50382",
  transform: "translate(9.997 2.836)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-key-contractor_svg__Path_65168",
  d: "M41 47h1.454v3.27H41Z",
  className: "px-key-contractor_svg__cls-4",
  "data-name": "Path 65168",
  transform: "translate(-32.279 -31.483)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-key-contractor_svg__Path_65169",
  d: "M19 47h1.454v3.27H19Z",
  className: "px-key-contractor_svg__cls-4",
  "data-name": "Path 65169",
  transform: "translate(-18.273 -31.483)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-key-contractor_svg__Path_65170",
  d: "M17 10v-.359A5.45 5.45 0 0 1 21.362 4.3h2.179A5.45 5.45 0 0 1 27.9 9.641V10",
  className: "px-key-contractor_svg__cls-4",
  "data-name": "Path 65170",
  transform: "translate(-17 -4.299)"
})), /*#__PURE__*/React.createElement("path", {
  id: "px-key-contractor_svg__Path_65171",
  d: "M19 26v1.817a4.724 4.724 0 0 0 9.448 0V26",
  "data-name": "Path 65171",
  style: {
    fill: "#fbe1ca"
  },
  transform: "translate(-8.276 -15.279)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-key-contractor_svg__Path_65172",
  d: "M30.634 43v1.454a1.817 1.817 0 0 1-3.634 0V43a4.72 4.72 0 0 0 3.634 0",
  "data-name": "Path 65172",
  style: {
    fill: "#f2b9a1"
  },
  transform: "translate(-13.369 -26.101)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-key-contractor_svg__Path_65173",
  d: "M16.454 27.817h-.727A.727.727 0 0 1 15 27.09V26h1.454Z",
  className: "px-key-contractor_svg__cls-7",
  "data-name": "Path 65173",
  transform: "translate(-5.73 -15.279)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-key-contractor_svg__Path_65174",
  d: "M45 27.817h.727a.727.727 0 0 0 .727-.727V26H45Z",
  className: "px-key-contractor_svg__cls-7",
  "data-name": "Path 65174",
  transform: "translate(-24.828 -15.279)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "px-key-contractor_svg__Rectangle_21327",
  width: 12.92,
  height: 2.423,
  "data-name": "Rectangle 21327",
  rx: 1,
  style: {
    fill: "#78a0d4"
  },
  transform: "translate(8.746 8.46)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-key-contractor_svg__Path_65175",
  d: "M14.363 20a.363.363 0 0 0-.363.363v.727h11.628a.363.363 0 0 0 .363-.363V20Z",
  "data-name": "Path 65175",
  style: {
    fill: "#83aedd"
  },
  transform: "translate(-5.093 -11.459)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-key-contractor_svg__Path_65176",
  d: "M29 7.087v-4.36A.727.727 0 0 1 29.727 2h.727a.727.727 0 0 1 .727.727v4.36",
  "data-name": "Path 65176",
  style: {
    fill: "#4c6cb5"
  },
  transform: "translate(-14.642)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-key-contractor_svg__Path_65177",
  d: "M21 17.454v-.727a.727.727 0 0 1 .727-.727h6.541a.727.727 0 0 1 .727.727v.727",
  className: "px-key-contractor_svg__cls-11",
  "data-name": "Path 65177",
  transform: "translate(-9.549 -8.913)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-key-contractor_svg__Path_65178",
  d: "M21 16.727h6.541a.363.363 0 0 0 .363-.363V16h-6.177a.727.727 0 0 0-.727.727",
  "data-name": "Path 65178",
  style: {
    fill: "#6c98d8"
  },
  transform: "translate(-9.549 -8.913)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-key-contractor_svg__Path_65179",
  d: "M17 58.18v-1.453a.727.727 0 0 1 .727-.727h9.448a.727.727 0 0 1 .727.727v1.453",
  className: "px-key-contractor_svg__cls-11",
  "data-name": "Path 65179",
  transform: "translate(-7.003 -34.377)"
}))));

const SvgPxKeySetting = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".px-key-setting_svg__cls-3{fill:#55c9ff}.px-key-setting_svg__cls-5{fill:#d3d0d4}.px-key-setting_svg__cls-7{fill:#ebdde2}.px-key-setting_svg__cls-8{fill:#f4b147}.px-key-setting_svg__cls-10{fill:#f9cc7b}.px-key-setting_svg__cls-11{fill:#fee7af}")), /*#__PURE__*/React.createElement("g", {
  id: "px-key-setting_svg__Group_50387",
  "data-name": "Group 50387",
  transform: "translate(9116 -23133)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-key-setting_svg__icon_placeholder",
  d: "M0 0h32v32H0z",
  style: {
    fill: "none"
  },
  transform: "translate(-9116 23133)"
}), /*#__PURE__*/React.createElement("g", {
  id: "px-key-setting_svg__key-room",
  transform: "translate(-9110.786 23138)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-key-setting_svg__Path_64996",
  d: "M23.913 46.214a10.7 10.7 0 1 1-10.7-10.7 10.7 10.7 0 0 1 10.7 10.7m0 0",
  "data-name": "Path 64996",
  style: {
    fill: "#514e87"
  },
  transform: "translate(-2.395 -33.917)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-key-setting_svg__Path_64997",
  d: "m233.565 66.443-4.792-4.71a1.6 1.6 0 0 0-1.926-.245l-.879.507-.879.507a1.6 1.6 0 0 0-.751 1.79l1.684 6.5a1.6 1.6 0 0 0 .4.718l4.643 4.757a1.6 1.6 0 0 0 1.949.268l2.021-1.167a1.6 1.6 0 0 0 .742-1.822l-1.8-6.4a1.6 1.6 0 0 0-.42-.71Zm-5.926-1.556a1.044 1.044 0 1 1 .382-1.425 1.044 1.044 0 0 1-.382 1.425m0 0",
  className: "px-key-setting_svg__cls-3",
  "data-name": "Path 64997",
  transform: "translate(-214.213 -58.52)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-key-setting_svg__Path_64998",
  d: "M232.727 88.634 228 83.788a1.64 1.64 0 0 1-.412-.732l-1.715-6.627a1.63 1.63 0 0 1 .278-1.394l-.18.1-.879.507a1.6 1.6 0 0 0-.751 1.79l1.684 6.5a1.6 1.6 0 0 0 .4.718l4.643 4.757a1.6 1.6 0 0 0 1.949.268l.971-.56a1.63 1.63 0 0 1-1.263-.49Zm0 0",
  "data-name": "Path 64998",
  style: {
    fill: "#44a3ea"
  },
  transform: "translate(-214.212 -71.664)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-key-setting_svg__Path_64999",
  d: "M95.965 299.687a.23.23 0 0 0 .075.168l.928.834a.23.23 0 0 1 .075.168v.541a.23.23 0 0 1-.068.161l-.662.648a.225.225 0 0 0 0 .319l.885.906a.23.23 0 0 1 .064.157v.542a.23.23 0 0 1-.065.159l-.763.769a.22.22 0 0 0-.064.139 10.7 10.7 0 0 0 2.675 1.349v-9.076h-3.08v2.219Zm0 0",
  className: "px-key-setting_svg__cls-5",
  "data-name": "Path 64999",
  transform: "translate(-91.654 -284.106)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-key-setting_svg__Path_65000",
  d: "M99.042 299.3v-1.832h-3.077v1.832a2.08 2.08 0 0 1 3.077 0m0 0",
  "data-name": "Path 65000",
  style: {
    fill: "#b7b3ba"
  },
  transform: "translate(-91.654 -284.106)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-key-setting_svg__Path_65001",
  d: "M142.973 306.165q.471.212.965.38v-9.076h-.965Zm0 0",
  className: "px-key-setting_svg__cls-7",
  "data-name": "Path 65001",
  transform: "translate(-136.55 -284.106)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-key-setting_svg__Path_65002",
  d: "M143.938 299.3v-1.832h-.965v1.232a2.1 2.1 0 0 1 .965.6m0 0",
  className: "px-key-setting_svg__cls-5",
  "data-name": "Path 65002",
  transform: "translate(-136.55 -284.106)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-key-setting_svg__Path_65003",
  d: "M9.046 62.038a1.8 1.8 0 0 1-1.3-1.369 1.14 1.14 0 0 0-1.112-.915h-1.57a1.14 1.14 0 0 0-1.112.915 1.8 1.8 0 0 1-1.3 1.369C1.057 62.46 0 63.194 0 64.028a1.37 1.37 0 0 0 .565 1.02.88.88 0 0 1 .308.726c0 .666.577 1.267 1.507 1.7a2.47 2.47 0 0 1 1.42 2.242v.38a.336.336 0 0 0 .336.336h3.431A.336.336 0 0 0 7.9 70.1v-.383a2.46 2.46 0 0 1 1.414-2.241c.931-.43 1.509-1.032 1.509-1.7v-.034a.88.88 0 0 1 .308-.692 1.37 1.37 0 0 0 .565-1.02c0-.834-1.057-1.568-2.654-1.99Zm-3.2 1.5a1.043 1.043 0 1 1 1.044-1.043 1.043 1.043 0 0 1-1.04 1.039Zm0 0",
  className: "px-key-setting_svg__cls-8",
  "data-name": "Path 65003",
  transform: "translate(0 -57.07)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-key-setting_svg__Path_65004",
  d: "M5.289 70.1v-.38a2.56 2.56 0 0 0-1.149-2.249 2.08 2.08 0 0 1-1.222-1.732.98.98 0 0 0-.25-.692 1.48 1.48 0 0 1-.458-1.02c0-.834.857-1.568 2.152-1.99a1.69 1.69 0 0 0 1.052-1.369 1 1 0 0 1 .9-.915H5.063a1.14 1.14 0 0 0-1.112.915 1.8 1.8 0 0 1-1.3 1.369C1.056 62.46 0 63.193 0 64.027a1.37 1.37 0 0 0 .565 1.02.88.88 0 0 1 .308.726c0 .666.577 1.267 1.507 1.7a2.47 2.47 0 0 1 1.42 2.242v.38a.336.336 0 0 0 .336.336h1.43a.31.31 0 0 1-.273-.336Zm0 0",
  "data-name": "Path 65004",
  style: {
    fill: "#e9932a"
  },
  transform: "translate(0 -57.069)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-key-setting_svg__Path_65005",
  d: "M49.207 229.727q.082.042.169.082a2.47 2.47 0 0 1 1.416 2.244v.38a.336.336 0 0 0 .336.336h3.435a.336.336 0 0 0 .336-.336v-.383a2.46 2.46 0 0 1 1.414-2.241q.088-.041.171-.083a10.5 10.5 0 0 1-7.278 0Zm0 0",
  className: "px-key-setting_svg__cls-10",
  "data-name": "Path 65005",
  transform: "translate(-46.996 -219.407)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-key-setting_svg__Path_65006",
  d: "M52.562 232.77a.31.31 0 0 1-.273-.336v-.38a2.83 2.83 0 0 0-.565-1.733 9.4 9.4 0 0 1-2.513-.593c.134.067.174.084.169.082a2.47 2.47 0 0 1 1.416 2.244v.38a.337.337 0 0 0 .336.336Zm0 0",
  className: "px-key-setting_svg__cls-8",
  "data-name": "Path 65006",
  transform: "translate(-47.001 -219.407)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-key-setting_svg__Path_65007",
  d: "M72.519 188.72a.413.413 0 0 1 .169-.809 10.6 10.6 0 0 0 4.217 0 .413.413 0 1 1 .169.809 11.4 11.4 0 0 1-4.554 0Zm0 0",
  className: "px-key-setting_svg__cls-11",
  "data-name": "Path 65007",
  transform: "translate(-68.948 -179.462)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-key-setting_svg__Path_65008",
  d: "M142.973 232.77h1.144a.336.336 0 0 0 .336-.336v-.383a2.46 2.46 0 0 1 1.414-2.241q.088-.041.171-.083a9.7 9.7 0 0 1-3.066.635Zm0 0",
  className: "px-key-setting_svg__cls-11",
  "data-name": "Path 65008",
  transform: "translate(-136.55 -219.407)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-key-setting_svg__Path_65009",
  d: "M394.922 334.269a.413.413 0 0 1 .151-.565l1.409-.813a.413.413 0 1 1 .413.716l-1.409.813a.413.413 0 0 1-.564-.151m0 0",
  "data-name": "Path 65009",
  style: {
    fill: "#95e5ff"
  },
  transform: "translate(-377.128 -317.885)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-key-setting_svg__Path_65010",
  d: "M121.389 8.256a4.128 4.128 0 1 1 4.128-4.128 4.133 4.133 0 0 1-4.128 4.128m0-7.429a3.3 3.3 0 1 0 3.3 3.3 3.305 3.305 0 0 0-3.3-3.3m0 0",
  className: "px-key-setting_svg__cls-7",
  "data-name": "Path 65010",
  transform: "translate(-111.994)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-key-setting_svg__Path_65011",
  d: "M123.955 18.905a3.3 3.3 0 1 1-4.3-4.885.524.524 0 0 1-.407-.72 4.127 4.127 0 1 0 5.379 6.083.524.524 0 0 1-.675-.479Zm0 0",
  className: "px-key-setting_svg__cls-5",
  "data-name": "Path 65011",
  transform: "translate(-111.994 -12.703)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-key-setting_svg__Path_65012",
  d: "M275.809 61.645a3.1 3.1 0 0 1 .149 1.377 1.04 1.04 0 0 1 1.083.221 4.2 4.2 0 0 0-.188-1.954 1.94 1.94 0 0 0-1.044.356m0 0",
  className: "px-key-setting_svg__cls-3",
  "data-name": "Path 65012",
  transform: "translate(-263.419 -58.536)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-key-setting_svg__Path_65013",
  d: "M135.044 133.389a1.173 1.173 0 0 0 .422-1.543 3.158 3.158 0 0 1-4.78-.537 1.04 1.04 0 0 1-.927.566h-.021a4.26 4.26 0 0 0 5.225 1.595 1 1 0 0 1 .081-.08Zm0 0",
  className: "px-key-setting_svg__cls-8",
  "data-name": "Path 65013",
  transform: "translate(-123.91 -125.41)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-key-setting_svg__Path_65014",
  d: "M74.956 188.121a10.3 10.3 0 0 1-2.267-.21.413.413 0 1 0-.169.809 11 11 0 0 0 2.412.227.458.458 0 0 1 .024-.826m0 0",
  className: "px-key-setting_svg__cls-10",
  "data-name": "Path 65014",
  transform: "translate(-68.948 -179.462)"
}))));

const SvgPxLadSetting = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".px-lad-setting_svg__cls-4{fill:#f0f0f0}.px-lad-setting_svg__cls-5{fill:#fab400}.px-lad-setting_svg__cls-7{fill:#fff}.px-lad-setting_svg__cls-8{fill:#0a5078}")), /*#__PURE__*/React.createElement("g", {
  id: "px-lad-setting_svg__Group_50391",
  "data-name": "Group 50391",
  transform: "translate(9116 -23185)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-lad-setting_svg__icon_placeholder",
  d: "M0 0h32v32H0z",
  style: {
    fill: "none"
  },
  transform: "translate(-9116 23185)"
}), /*#__PURE__*/React.createElement("g", {
  id: "px-lad-setting_svg__Icons",
  transform: "translate(-9115 23187)"
}, /*#__PURE__*/React.createElement("g", {
  id: "px-lad-setting_svg__Group_50352",
  "data-name": "Group 50352",
  transform: "translate(4 4)"
}, /*#__PURE__*/React.createElement("g", {
  id: "px-lad-setting_svg__Group_50331",
  "data-name": "Group 50331",
  transform: "translate(0 4.107)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-lad-setting_svg__Path_65087",
  d: "M23.714 14v.821H4.821a.82.82 0 0 0-.821.822v13.143h3.286v-.821h18.893a.82.82 0 0 0 .821-.822V14Z",
  "data-name": "Path 65087",
  style: {
    fill: "#00a0c8"
  },
  transform: "translate(-4 -14)"
})), /*#__PURE__*/React.createElement("path", {
  id: "px-lad-setting_svg__Path_65088",
  d: "M24.726 5A5.124 5.124 0 0 0 20 9.809a4.9 4.9 0 0 0 1.38 3.532 4.04 4.04 0 0 1 1.083 2.819v2.8a.82.82 0 0 0 .821.821h3.286a.82.82 0 0 0 .821-.821V16a3.98 3.98 0 0 1 1.132-2.712A4.922 4.922 0 0 0 24.726 5",
  "data-name": "Path 65088",
  style: {
    fill: "#0082aa"
  },
  transform: "translate(-13.428 -4.589)"
}), /*#__PURE__*/React.createElement("g", {
  id: "px-lad-setting_svg__Group_50332",
  "data-name": "Group 50332",
  transform: "translate(.821 5.75)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-lad-setting_svg__Path_65089",
  d: "M6.411 20.875A.41.41 0 0 1 6 20.464v-2.053A.41.41 0 0 1 6.411 18h2.053a.411.411 0 1 1 0 .821H6.821v1.643a.41.41 0 0 1-.41.411",
  className: "px-lad-setting_svg__cls-4",
  "data-name": "Path 65089",
  transform: "translate(-6 -18)"
})), /*#__PURE__*/React.createElement("g", {
  id: "px-lad-setting_svg__Group_50333",
  "data-name": "Group 50333",
  transform: "translate(19.304 14.375)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-lad-setting_svg__Path_65090",
  d: "M53.464 41.875h-2.053a.411.411 0 0 1 0-.821h1.643v-1.643a.411.411 0 0 1 .821 0v2.054a.41.41 0 0 1-.411.41",
  className: "px-lad-setting_svg__cls-4",
  "data-name": "Path 65090",
  transform: "translate(-51 -39)"
})), /*#__PURE__*/React.createElement("g", {
  id: "px-lad-setting_svg__Group_50337",
  "data-name": "Group 50337",
  transform: "translate(6.571)"
}, /*#__PURE__*/React.createElement("g", {
  id: "px-lad-setting_svg__Group_50334",
  "data-name": "Group 50334"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-lad-setting_svg__Path_65091",
  d: "M29.857 8.929A4.93 4.93 0 0 0 24.726 4 5.124 5.124 0 0 0 20 8.809a4.9 4.9 0 0 0 1.38 3.532 4.04 4.04 0 0 1 1.083 2.819v.34h4.929V15a3.98 3.98 0 0 1 1.132-2.712 4.9 4.9 0 0 0 1.333-3.359",
  className: "px-lad-setting_svg__cls-5",
  "data-name": "Path 65091",
  transform: "translate(-20 -4)"
})), /*#__PURE__*/React.createElement("g", {
  id: "px-lad-setting_svg__Group_50335",
  "data-name": "Group 50335",
  transform: "translate(2.899 2.875)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-lad-setting_svg__Path_65092",
  d: "m30.938 13.76-1.015-.586 1.015-.586a.411.411 0 1 0-.411-.711l-1.015.586v-1.052a.411.411 0 0 0-.821 0v1.052l-1.015-.586a.411.411 0 0 0-.411.711l1.015.586-1.014.586a.411.411 0 1 0 .411.711l1.015-.586v6.792a.411.411 0 0 0 .821 0v-6.792l1.015.586a.411.411 0 1 0 .41-.711",
  className: "px-lad-setting_svg__cls-4",
  "data-name": "Path 65092",
  transform: "translate(-27.059 -11)"
})), /*#__PURE__*/React.createElement("g", {
  id: "px-lad-setting_svg__Group_50336",
  "data-name": "Group 50336",
  transform: "translate(2.464 11.5)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-lad-setting_svg__Path_65093",
  d: "M30.107 35.286h-3.286a.82.82 0 0 1-.821-.822V32h4.929v2.464a.82.82 0 0 1-.822.822",
  "data-name": "Path 65093",
  style: {
    fill: "#00325a"
  },
  transform: "translate(-26 -32)"
}))), /*#__PURE__*/React.createElement("g", {
  id: "px-lad-setting_svg__Group_50338",
  "data-name": "Group 50338",
  transform: "translate(4.107 7.393)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-lad-setting_svg__Path_65094",
  d: "M16.054 22.821h-.411v-.411a.411.411 0 1 0-.821 0v.411h-.411a.411.411 0 1 0 0 .821h.411v.411a.411.411 0 1 0 .821 0v-.411h.411a.411.411 0 1 0 0-.821",
  className: "px-lad-setting_svg__cls-5",
  "data-name": "Path 65094",
  transform: "translate(-14 -22)"
})), /*#__PURE__*/React.createElement("g", {
  id: "px-lad-setting_svg__Group_50339",
  "data-name": "Group 50339",
  transform: "translate(15.607 13.143)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-lad-setting_svg__Path_65095",
  d: "M44.054 36.821h-.411v-.411a.411.411 0 0 0-.821 0v.411h-.411a.411.411 0 0 0 0 .821h.411v.411a.411.411 0 0 0 .821 0v-.411h.411a.411.411 0 0 0 0-.821",
  className: "px-lad-setting_svg__cls-5",
  "data-name": "Path 65095",
  transform: "translate(-42 -36)"
})), /*#__PURE__*/React.createElement("g", {
  id: "px-lad-setting_svg__Group_50340",
  "data-name": "Group 50340",
  transform: "translate(16.429)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-lad-setting_svg__Path_65096",
  d: "M46.054 4.821h-.411v-.41a.411.411 0 0 0-.821 0v.411h-.411a.411.411 0 0 0 0 .821h.411v.411a.411.411 0 0 0 .821 0v-.411h.411a.411.411 0 0 0 0-.821Z",
  className: "px-lad-setting_svg__cls-5",
  "data-name": "Path 65096",
  transform: "translate(-44 -4)"
})), /*#__PURE__*/React.createElement("g", {
  id: "px-lad-setting_svg__Group_50346",
  "data-name": "Group 50346",
  transform: "translate(.821 9.036)"
}, /*#__PURE__*/React.createElement("g", {
  id: "px-lad-setting_svg__Group_50341",
  "data-name": "Group 50341",
  transform: "translate(0 5.75)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-lad-setting_svg__Path_65097",
  d: "M9.7 40.821H6.411a.411.411 0 1 1 0-.821H9.7a.411.411 0 1 1 0 .821",
  className: "px-lad-setting_svg__cls-7",
  "data-name": "Path 65097",
  transform: "translate(-6 -40)"
})), /*#__PURE__*/React.createElement("g", {
  id: "px-lad-setting_svg__Group_50342",
  "data-name": "Group 50342",
  transform: "translate(17.25 1.643)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-lad-setting_svg__Path_65098",
  d: "M51.7 30h-3.289a.411.411 0 0 0 0 .821H51.7a.411.411 0 1 0 0-.821",
  className: "px-lad-setting_svg__cls-4",
  "data-name": "Path 65098",
  transform: "translate(-48 -30)"
})), /*#__PURE__*/React.createElement("g", {
  id: "px-lad-setting_svg__Group_50343",
  "data-name": "Group 50343",
  transform: "translate(15.607)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-lad-setting_svg__Path_65099",
  d: "M49.339 26h-4.928a.411.411 0 0 0 0 .821h4.929a.411.411 0 0 0 0-.821Z",
  className: "px-lad-setting_svg__cls-4",
  "data-name": "Path 65099",
  transform: "translate(-44 -26)"
})), /*#__PURE__*/React.createElement("g", {
  id: "px-lad-setting_svg__Group_50344",
  "data-name": "Group 50344",
  transform: "translate(7.393 7.393)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-lad-setting_svg__Path_65100",
  d: "M27.7 44.821h-3.289a.411.411 0 1 1 0-.821H27.7a.411.411 0 0 1 0 .821",
  className: "px-lad-setting_svg__cls-7",
  "data-name": "Path 65100",
  transform: "translate(-24 -44)"
})), /*#__PURE__*/React.createElement("g", {
  id: "px-lad-setting_svg__Group_50345",
  "data-name": "Group 50345",
  transform: "translate(0 7.393)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-lad-setting_svg__Path_65101",
  d: "M12.161 44.821h-5.75a.411.411 0 0 1 0-.821h5.75a.411.411 0 0 1 0 .821",
  className: "px-lad-setting_svg__cls-7",
  "data-name": "Path 65101",
  transform: "translate(-6 -44)"
}))), /*#__PURE__*/React.createElement("g", {
  id: "px-lad-setting_svg__Group_50347",
  "data-name": "Group 50347",
  transform: "translate(18.071 3.286)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-lad-setting_svg__Path_65102",
  d: "M52.916 12.676a.823.823 0 0 1-.809.966H48v-1.231a.41.41 0 0 1 .411-.411h3.646a.86.86 0 0 1 .859.676",
  className: "px-lad-setting_svg__cls-8",
  "data-name": "Path 65102",
  transform: "translate(-48 -12)"
})), /*#__PURE__*/React.createElement("g", {
  id: "px-lad-setting_svg__Group_50348",
  "data-name": "Group 50348",
  transform: "translate(0 18.071)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-lad-setting_svg__Path_65103",
  d: "M4.013 48.966A.823.823 0 0 1 4.821 48h4.108v1.232a.41.41 0 0 1-.411.411H4.872a.86.86 0 0 1-.859-.677",
  className: "px-lad-setting_svg__cls-8",
  "data-name": "Path 65103",
  transform: "translate(-4 -48)"
})), /*#__PURE__*/React.createElement("g", {
  id: "px-lad-setting_svg__Group_50349",
  "data-name": "Group 50349",
  transform: "translate(21.357 6.571)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-lad-setting_svg__Path_65104",
  d: "M56.411 21.643a.41.41 0 0 1-.411-.411v-.821a.411.411 0 0 1 .821 0v.821a.41.41 0 0 1-.41.411",
  className: "px-lad-setting_svg__cls-7",
  "data-name": "Path 65104",
  transform: "translate(-56 -20)"
})), /*#__PURE__*/React.createElement("g", {
  id: "px-lad-setting_svg__Group_50350",
  "data-name": "Group 50350",
  transform: "translate(19.714 6.571)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-lad-setting_svg__Path_65105",
  d: "M52.411 21.643a.41.41 0 0 1-.411-.411v-.821a.411.411 0 0 1 .821 0v.821a.41.41 0 0 1-.41.411",
  className: "px-lad-setting_svg__cls-7",
  "data-name": "Path 65105",
  transform: "translate(-52 -20)"
})), /*#__PURE__*/React.createElement("g", {
  id: "px-lad-setting_svg__Group_50351",
  "data-name": "Group 50351",
  transform: "translate(18.071 6.571)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-lad-setting_svg__Path_65106",
  d: "M48.411 21.643a.41.41 0 0 1-.411-.411v-.821a.411.411 0 0 1 .821 0v.821a.41.41 0 0 1-.41.411",
  className: "px-lad-setting_svg__cls-7",
  "data-name": "Path 65106",
  transform: "translate(-48 -20)"
}))))));

const SvgPxLad = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57475"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#ffda80",
  d: "M20.911 12.664v9.166h-5.1a1.456 1.456 0 0 1-1.456-1.456v-4.37H12.9v4.369a1.456 1.456 0 0 1-1.456 1.456h-5.1v-9.165l7.225-7.34Z",
  "data-name": "Path 71903"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffb54d",
  d: "M13.613 16.004h.744v4.369a1.456 1.456 0 0 0 1.456 1.453h5.1v-9.162l-7.3-7.3Z",
  "data-name": "Path 71904"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57472"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#5d4d80",
  d: "M15.813 21.829h-4.369v-7.282h4.369Z",
  "data-name": "Path 71905"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57473"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#443d66",
  d: "M27.1 19.429V6.788l.728.728 1.03-1.03L26.371 4l-2.486 2.486 1.03 1.03.728-.728v12.641l-.728-.728-1.03 1.03 2.486 2.486 2.486-2.486-1.03-1.03Z",
  "data-name": "Path 71906"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5d4d80",
  d: "m20.021 24.915.728.728H6.788l.728-.728-1.03-1.03L4 26.371l2.486 2.486 1.03-1.03-.728-.728H20.75l-.728.728 1.03 1.03 2.486-2.486-2.486-2.486Z",
  "data-name": "Path 71907"
})), /*#__PURE__*/React.createElement("g", {
  fill: "#443d66",
  "data-name": "Group 57474"
}, /*#__PURE__*/React.createElement("path", {
  d: "m20.021 24.915.728.728h-6.981V27.1h6.981l-.728.728 1.03 1.03 2.486-2.486-2.486-2.486Z",
  "data-name": "Path 71908"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.628 14.547h2.182v7.282h-2.185Z",
  "data-name": "Path 71909"
}))), /*#__PURE__*/React.createElement("path", {
  fill: "#ff5959",
  d: "m23.4 13.819-1.03 1.03-8.8-8.8-8.54 8.68L4 13.7 13.628 4Z",
  "data-name": "Path 71910"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e63a57",
  d: "M13.613 4.016v2.078l8.754 8.754 1.03-1.03L13.629 4Z",
  "data-name": "Path 71911"
}));

const SvgPxLatePayment = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".px-late-payment_svg__cls-3,.px-late-payment_svg__cls-4{fill:#fff}.px-late-payment_svg__cls-4{fill-rule:evenodd}")), /*#__PURE__*/React.createElement("g", {
  id: "px-late-payment_svg__Group_50393",
  "data-name": "Group 50393",
  transform: "translate(9012 -23185)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-late-payment_svg__icon_placeholder",
  d: "M0 0h32v32H0z",
  style: {
    fill: "none"
  },
  transform: "translate(-9012 23185)"
}), /*#__PURE__*/React.createElement("g", {
  id: "px-late-payment_svg__package",
  transform: "translate(-9008 23189.479)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "px-late-payment_svg__Ellipse_805",
  cx: 11,
  cy: 11,
  r: 11,
  "data-name": "Ellipse 805",
  style: {
    fill: "#0fbcf9"
  },
  transform: "translate(1 .521)"
}), /*#__PURE__*/React.createElement("g", {
  id: "px-late-payment_svg__Group_50328",
  "data-name": "Group 50328",
  transform: "translate(4.587 5.484)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "px-late-payment_svg__Ellipse_806",
  cx: 0.74,
  cy: 0.74,
  r: 0.74,
  className: "px-late-payment_svg__cls-3",
  "data-name": "Ellipse 806",
  transform: "translate(5.292 6.462)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "px-late-payment_svg__Ellipse_807",
  cx: 0.74,
  cy: 0.74,
  r: 0.74,
  className: "px-late-payment_svg__cls-3",
  "data-name": "Ellipse 807",
  transform: "translate(7.608 9.043)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-late-payment_svg__Path_65042",
  d: "m16.282 16.36-2.761 2.958a.478.478 0 1 0 .7.653l2.764-2.959a.478.478 0 1 0-.7-.653Z",
  className: "px-late-payment_svg__cls-4",
  "data-name": "Path 65042",
  transform: "translate(-8.089 -9.782)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-late-payment_svg__Path_65043",
  d: "M12.7 8.206v3.854H7.12l1.047-3.515a.48.48 0 0 1 .459-.345Zm.957 0h4.07a.48.48 0 0 1 .458.341l1.047 3.515h-5.58Zm5.739 4.81H6.956v4.994a.48.48 0 0 0 .478.478h11.479a.48.48 0 0 0 .478-.478ZM6 12.487v5.524a1.435 1.435 0 0 0 1.435 1.435h11.478a1.435 1.435 0 0 0 1.435-1.435v-5.524c0-.029-.852-2.885-1.248-4.212a1.435 1.435 0 0 0-1.378-1.025h-9.1a1.435 1.435 0 0 0-1.371 1.024S6.006 12.458 6 12.487",
  className: "px-late-payment_svg__cls-4",
  "data-name": "Path 65043",
  transform: "translate(-6 -7.25)"
})))));

const SvgPxLetterBBw = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 9.454 11.484"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 0.6,
  transform: "translate(-8.953 -4)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.3 12.82a.82.82 0 0 1-1.122.3.862.862 0 0 1-1.407.125l-.982-1.171.523 1.435a.862.862 0 0 1-.81 1.157.82.82 0 1 1-1.641 0 .862.862 0 0 1-.81-1.157l.523-1.435-.982 1.171a.862.862 0 0 1-1.407-.125.82.82 0 1 1-.82-1.419.86.86 0 0 1 .6-1.28l1.5-.267-1.5-.267a.86.86 0 0 1-.6-1.28.82.82 0 1 1 .82-1.419.862.862 0 0 1 1.407-.125l.982 1.171-.523-1.435a.862.862 0 0 1 .81-1.157.82.82 0 0 1 1.641 0 .862.862 0 0 1 .81 1.157l-.523 1.435.982-1.171a.864.864 0 0 1 1.157-.15 4.8 4.8 0 0 1-3.3 3.041.21.21 0 0 0-.146.252.206.206 0 0 0 .2.152.3.3 0 0 0 .053-.006 5.21 5.21 0 0 0 3.548-3.215A.82.82 0 0 1 18 8.605a.86.86 0 0 1-.6 1.28l-1.5.267 1.5.267a.86.86 0 0 1 .6 1.28.82.82 0 0 1 .3 1.121Z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 0.513,
  cy: 0.513,
  r: 0.513,
  transform: "translate(16.334 4.82)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.18 4.926a.92.92 0 0 1-.411.41.9.9 0 0 1-.126.455.51.51 0 0 0 .536-.864ZM17.667 4.92a.512.512 0 1 0-.811-.509.92.92 0 0 1 .811.509ZM17.359 6.099a1 1 0 0 1-.247.112 5 5 0 0 1-.187.7c.1.07.355.224.355.224a10 10 0 0 0 .254-.946 1 1 0 0 1-.174-.09Z"
})));

const SvgPxLetterB = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 9.454 11.484"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "#f72d2d",
  transform: "translate(-8.953 -4)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.3 12.82a.82.82 0 0 1-1.122.3.862.862 0 0 1-1.407.125l-.982-1.171.523 1.435a.862.862 0 0 1-.81 1.157.82.82 0 1 1-1.641 0 .862.862 0 0 1-.81-1.157l.523-1.435-.982 1.171a.862.862 0 0 1-1.407-.125.82.82 0 1 1-.82-1.419.86.86 0 0 1 .6-1.28l1.5-.267-1.5-.267a.86.86 0 0 1-.6-1.28.82.82 0 1 1 .82-1.419.862.862 0 0 1 1.407-.125l.982 1.171-.523-1.435a.862.862 0 0 1 .81-1.157.82.82 0 0 1 1.641 0 .862.862 0 0 1 .81 1.157l-.523 1.435.982-1.171a.864.864 0 0 1 1.157-.15 4.8 4.8 0 0 1-3.3 3.041.21.21 0 0 0-.146.252.206.206 0 0 0 .2.152.3.3 0 0 0 .053-.006 5.21 5.21 0 0 0 3.548-3.215A.82.82 0 0 1 18 8.605a.86.86 0 0 1-.6 1.28l-1.5.267 1.5.267a.86.86 0 0 1 .6 1.28.82.82 0 0 1 .3 1.121",
  "data-name": "Path 68365"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 0.513,
  cy: 0.513,
  r: 0.513,
  "data-name": "Ellipse 758",
  transform: "translate(16.334 4.82)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.18 4.926a.92.92 0 0 1-.411.41.9.9 0 0 1-.126.455.51.51 0 0 0 .536-.864Z",
  "data-name": "Path 68366"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.667 4.92a.512.512 0 1 0-.811-.509.92.92 0 0 1 .811.509",
  "data-name": "Path 68367"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.359 6.099a1 1 0 0 1-.247.112 5 5 0 0 1-.187.7c.1.07.355.224.355.224a10 10 0 0 0 .254-.946 1 1 0 0 1-.174-.09Z",
  "data-name": "Path 68368"
})));

const SvgPxLogout = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 30 30"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 7891"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h30v30H0z",
  "data-name": "Rectangle 6199"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 7892"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#5367ff",
  d: "M12.072 18.665h7.477v3.9l10.055-7.206-10.055-7.206v3.9h-7.477Z",
  "data-name": "Path 11172"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#002672",
  d: "M3.981 29.974h13.975a3.987 3.987 0 0 0 3.983-3.983v-1.652h-3.307v1.652a.676.676 0 0 1-.676.676H3.981a.676.676 0 0 1-.676-.676V4.732a.676.676 0 0 1 .676-.676h13.975a.676.676 0 0 1 .676.676v1.485h3.307V4.732A3.987 3.987 0 0 0 17.956.749H3.981A3.987 3.987 0 0 0-.002 4.732v21.259a3.987 3.987 0 0 0 3.983 3.983",
  "data-name": "Path 11173"
}))));

const SvgPxMarital = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".px-marital_svg__b{fill:#5ba1f0}.px-marital_svg__d{fill:#ffc661}.px-marital_svg__e{fill:#5b90f0}")), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h32v32H0z",
  style: {
    fill: "none"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.492 8.118H5.661a.985.985 0 0 0-.985.985v7.877a.985.985 0 0 0 .985.985h3.446v2.462l2.461-2.459h4.923a.985.985 0 0 0 .985-.985V9.107a.985.985 0 0 0-.984-.989m0 0",
  className: "px-marital_svg__b"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.384 333.466H1.151a1.152 1.152 0 0 0-.379 2.24l9.074 2.683 8.862-.985v-4.923L17.231 331H12.8a.99.99 0 0 0-.985.985v.492H8.369a.99.99 0 0 0-.985.985Zm0 0",
  style: {
    fill: "#f2c2b8"
  },
  transform: "translate(4.677 -311.066)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.385 21.415v4.923a.99.99 0 0 0 .985.985h2.954v-7.877H24.37a.987.987 0 0 0-.985.985ZM22.4 8.122a1.3 1.3 0 0 1-.079.463 1.471 1.471 0 0 1-2.8 0 1.3 1.3 0 0 1-.079-.463 1.477 1.477 0 0 1 2.954 0Zm0 0",
  className: "px-marital_svg__b"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.4 8.615a2.462 2.462 0 1 1-2.954 0l.079-.03a1.471 1.471 0 0 0 2.8 0Zm0 0",
  className: "px-marital_svg__d"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.323 5.66v8.37a.99.99 0 0 1-.985.985h-4.923v2.461l-2.462-2.462h-3.446a.99.99 0 0 1-.985-.985V5.66a.987.987 0 0 1 .985-.985h10.832a.99.99 0 0 1 .985.985Zm-3.939 4.923a2.45 2.45 0 0 0-.985-1.969l-.079-.03a1.3 1.3 0 0 0 .079-.463 1.477 1.477 0 0 0-2.954 0 1.3 1.3 0 0 0 .079.463l-.079.03a2.462 2.462 0 1 0 3.939 1.969m0 0",
  className: "px-marital_svg__d"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.862 20.923h.985v.985h-.985Zm0 0",
  className: "px-marital_svg__e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M290.959 82.454a2.954 2.954 0 0 1-1.772-5.317l.591.788a1.969 1.969 0 1 0 2.363 0l.591-.788a2.954 2.954 0 0 1-1.772 5.317Zm0 0",
  style: {
    fill: "#eef4fd"
  },
  transform: "translate(-270.036 -68.916)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.924 10.091a1.96 1.96 0 0 1-1.866-1.354 1.7 1.7 0 0 1-.1-.615 1.97 1.97 0 0 1 3.939 0 1.8 1.8 0 0 1-.107.626 1.96 1.96 0 0 1-1.866 1.343m0-2.954a.985.985 0 0 0-.985.985.8.8 0 0 0 .047.288.979.979 0 0 0 1.868.023q.002-.012.008-.023a.8.8 0 0 0 .046-.288.985.985 0 0 0-.984-.985M8.616 9.595h4.431v.985H8.616ZM6.646 11.569h6.4v.985h-6.4ZM6.646 13.538h6.4v.985h-6.4ZM6.646 15.503h6.4v.985h-6.4ZM6.646 9.595h.985v.985h-.985Zm0 0",
  className: "px-marital_svg__e"
}));

const SvgPxMoneyDown = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 48 48"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M35.2 23c6.8 0 12.3 5.5 12.3 12.3S42 47.5 35.2 47.5 23 42 23 35.2 28.5 23 35.2 23m-4.5 9.7h2v-.9c0-.3.3-.6.6-.6h3.8c.3 0 .6.3.6.6v1.8c0 .3-.3.6-.6.6h-3.8c-1.4 0-2.6 1.2-2.6 2.6v1.8c0 1.4 1.2 2.6 2.6 2.6h.9v1.7h2v-1.7h.9c1.4 0 2.6-1.2 2.6-2.6v-.9h-2v.9c0 .3-.3.6-.6.6h-3.8c-.3 0-.6-.3-.6-.6v-1.8c0-.3.3-.6.6-.6h3.8c1.4 0 2.6-1.2 2.6-2.6v-1.8c0-1.4-1.2-2.6-2.6-2.6h-.9v-1.7h-2v1.7h-.9c-1.4 0-2.6 1.2-2.6 2.6zm12.6-12.1-13.8-8.5h-5.7c-.5 0-.9.4-.9 1s.4 1 .9 1H28c1.5 0 2.9 1.1 2.9 2.7.1 1.6-1.2 3-2.8 3H12.5V6.6l.1-.1h17.7c.5 0 1 .1 1.4.4l14.4 8.8c1.2.7 1.7 2.1 1.3 3.4-.7 1.8-2.6 2.4-4.1 1.5M.5.5h9.9v21.4H.5zm3.9 9.4h2.1V4.5H4.4z"
}));

const SvgPxMoney = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48",
  width: "1em",
  height: "1em"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M35.2 25c6.8 0 12.3-5.5 12.3-12.3S42 .5 35.2.5 23 6 23 12.8 28.5 25 35.2 25m-4.5-9.7h2v.9c0 .3.3.6.6.6h3.8c.3 0 .6-.3.6-.6v-1.8c0-.3-.3-.6-.6-.6h-3.8c-1.4 0-2.6-1.2-2.6-2.6V9.4c0-1.4 1.2-2.6 2.6-2.6h.9V5.1h2v1.7h.9c1.4 0 2.6 1.2 2.6 2.6v.9h-2v-.9c0-.3-.3-.6-.6-.6h-3.8c-.3 0-.6.3-.6.6v1.8c0 .3.3.6.6.6h3.8c1.4 0 2.6 1.2 2.6 2.6v1.8c0 1.4-1.2 2.6-2.6 2.6h-.9v1.7h-2v-1.7h-.9c-1.4 0-2.6-1.2-2.6-2.6zM43.3 27.4l-13.8 8.5h-5.7c-.5 0-.9-.4-.9-1s.4-1 .9-1H28c1.5 0 2.9-1.1 2.9-2.7.1-1.6-1.2-3-2.8-3H12.5v13.2l.1.1h17.7c.5 0 1-.1 1.4-.4l14.4-8.8c1.2-.7 1.7-2.1 1.3-3.4-.7-1.8-2.6-2.4-4.1-1.5M.5 47.5h9.9V26.1H.5zm3.9-9.4h2.1v5.4H4.4z"
}));

const SvgPxMotTracking = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#dadee0",
  d: "M25.926 10.672a1.776 1.776 0 0 0-1.771-1.771H10.872a1.776 1.776 0 0 0-1.771 1.771v16.532a1.776 1.776 0 0 0 1.771 1.771h10.036l5.018-4.723Z",
  "data-name": "Path 71848"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1bb7ea",
  d: "M9.099 10.672a1.776 1.776 0 0 1 1.771-1.771h11.811V7.425a1.776 1.776 0 0 0-1.771-1.771H7.625a1.776 1.776 0 0 0-1.771 1.771v16.529a1.776 1.776 0 0 0 1.771 1.771h1.474Z",
  "data-name": "Path 71849"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f2f2f2",
  d: "M22.68 24.252h3.247l-5.018 4.723v-2.952a1.776 1.776 0 0 1 1.771-1.771",
  "data-name": "Path 71850"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#1f4254",
  "data-name": "Group 57451"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.53 16.725h7.971a.443.443 0 0 0 0-.886H13.53a.443.443 0 0 0 0 .886",
  "data-name": "Path 71851"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.53 13.773h7.971a.443.443 0 1 0 0-.886H13.53a.443.443 0 1 0 0 .886",
  "data-name": "Path 71852"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.53 19.677h7.971a.443.443 0 1 0 0-.886H13.53a.443.443 0 1 0 0 .886",
  "data-name": "Path 71853"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.53 22.629h4.428a.443.443 0 1 0 0-.886H13.53a.443.443 0 0 0 0 .886",
  "data-name": "Path 71854"
})));

const SvgPxNewspaper = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  "data-name": "newspaper (1)",
  viewBox: "0 0 26.306 27.391"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 56677"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#e8f0ff",
  d: "M25.22 27.392a2.13 2.13 0 0 1-2.171-2.089V4.565a1.113 1.113 0 0 0-1.113-1.113H1.113A1.113 1.113 0 0 0 0 4.565l.484 18.149c0 1.154.488 4.677 1.687 4.677Z",
  "data-name": "Path 71431"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 56678"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#ff7eb9",
  d: "M1.781 15.412v7.805a.55.55 0 0 0 .551.551h6.692a.55.55 0 0 0 .551-.551v-7.805a.55.55 0 0 0-.551-.551H2.333a.55.55 0 0 0-.552.551",
  "data-name": "Path 71432"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 56679"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fea832",
  d: "M1.781 5.674v6.468a.5.5 0 0 0 .5.5h18.491a.5.5 0 0 0 .5-.5V5.674a.5.5 0 0 0-.5-.5H2.281a.5.5 0 0 0-.5.5",
  "data-name": "Path 71433"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 56680"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#d8e2f1",
  d: "M26.306 0a1.086 1.086 0 0 0-1.09 1.086v19.569a1.113 1.113 0 0 1-1.113 1.113h-1.054V4.565a1.113 1.113 0 0 0-1.113-1.113H2.283V1.086A1.086 1.086 0 0 1 3.369 0Z",
  "data-name": "Path 71434"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 56681"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#033a5d",
  d: "M23.318 25.3c0 1.154.5 2.089 1.124 2.089s1.124-.935 1.124-2.089V1.112c0-.589-.237-1.09-.541-1.111-.32-.022-.582.472-.582 1.085v19.569c0 .615-.258 1.113-.576 1.113h-.547Z",
  "data-name": "Path 71435"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 56702"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 56683"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 56682"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#00467d",
  d: "M20.853 15.278h-9.051a.414.414 0 1 1 0-.827h9.051a.414.414 0 1 1 0 .827",
  "data-name": "Path 71436"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 56685"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 56684"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#00467d",
  d: "M20.853 17.06h-9.051a.414.414 0 1 1 0-.827h9.051a.414.414 0 1 1 0 .827",
  "data-name": "Path 71437"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 56687"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 56686"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#00467d",
  d: "M20.853 18.841h-9.051a.414.414 0 0 1 0-.827h9.051a.414.414 0 0 1 0 .827",
  "data-name": "Path 71438"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 56689"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 56688"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#00467d",
  d: "M20.853 20.623h-9.051a.414.414 0 1 1 0-.827h9.051a.414.414 0 0 1 0 .827",
  "data-name": "Path 71439"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 56691"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 56690"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#00467d",
  d: "M20.853 22.404h-9.051a.414.414 0 1 1 0-.827h9.051a.414.414 0 1 1 0 .827",
  "data-name": "Path 71440"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 56693"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 56692"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#00467d",
  d: "M20.853 24.186h-9.051a.414.414 0 1 1 0-.827h9.051a.414.414 0 0 1 0 .827",
  "data-name": "Path 71441"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 56695"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 56694"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#00467d",
  d: "M20.853 25.967H2.194a.414.414 0 1 1 0-.827h18.659a.414.414 0 0 1 0 .827",
  "data-name": "Path 71442"
})))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 56700"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 56697"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 56696"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M3.413 11.27A.413.413 0 0 1 3 10.857v-3.89a.413.413 0 0 1 .753-.235l1.966 2.847-.025-2.616a.413.413 0 0 1 .409-.417.413.413 0 0 1 .413.409l.036 3.766a.49.49 0 0 1-.328.485.466.466 0 0 1-.526-.2L3.827 8.291v2.564a.413.413 0 0 1-.414.415",
  "data-name": "Path 71443"
}))), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M9.534 10.443H8.306V9.321h1.108a.414.414 0 0 0 0-.827H8.306V7.372h1.229a.414.414 0 0 0 0-.827H7.896a.413.413 0 0 0-.413.413v3.9a.413.413 0 0 0 .413.413h1.642a.414.414 0 0 0 0-.827Z",
  "data-name": "Path 71444"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 56699"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 56698"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M18.464 11.27a2.27 2.27 0 0 1-1.664-.713.413.413 0 0 1 .613-.555 1.43 1.43 0 0 0 1.052.442.73.73 0 0 0 .753-.5c.043-.243-.16-.466-.558-.613-.6-.222-1.137-.46-1.159-.47a.4.4 0 0 1-.057-.031 1.17 1.17 0 0 1-.52-1.154 1.3 1.3 0 0 1 .942-1.046 2.2 2.2 0 0 1 1.909.419.413.413 0 0 1-.53.634 1.37 1.37 0 0 0-1.141-.262.46.46 0 0 0-.362.372.34.34 0 0 0 .131.328c.127.056.583.253 1.073.434a1.4 1.4 0 0 1 1.086 1.534 1.534 1.534 0 0 1-1.568 1.181",
  "data-name": "Path 71445"
}))), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M15.619 6.561a.414.414 0 0 0-.486.325l-.509 2.555-.8-2.6a.413.413 0 0 0-.8.041l-.793 2.563-.507-2.562a.413.413 0 0 0-.811.16l.759 3.839a.4.4 0 0 0 .016.058.5.5 0 0 0 .472.334.5.5 0 0 0 .471-.34v-.011l.791-2.555.787 2.556.006.017a.5.5 0 0 0 .472.333.5.5 0 0 0 .471-.34l.014-.052.762-3.83a.413.413 0 0 0-.315-.491",
  "data-name": "Path 71446"
})));

const SvgPxNoRecords = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 30 30"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "#001088"
}, /*#__PURE__*/React.createElement("path", {
  d: "M26.665 10.627 29.829 7.3a.63.63 0 0 0 .166-.522.62.62 0 0 0-.3-.453l-3.8-2.195a.57.57 0 0 0-.8.243.63.63 0 0 0 .232.836l3.119 1.8-2.713 2.856-9.766-5.635 2.715-2.853 2.745 1.584a.57.57 0 0 0 .8-.243.63.63 0 0 0-.232-.836L18.861.076a.565.565 0 0 0-.7.1L15 3.5 11.836.18a.565.565 0 0 0-.7-.1L.3 6.328a.62.62 0 0 0-.3.453.63.63 0 0 0 .172.519l3.164 3.325-3.164 3.327a.64.64 0 0 0-.166.522.62.62 0 0 0 .3.453l3.274 1.889v6.315a.62.62 0 0 0 .3.54l10.836 6.252a.56.56 0 0 0 .564 0l10.836-6.252a.62.62 0 0 0 .3-.54v-6.315l3.284-1.889a.62.62 0 0 0 .3-.453.63.63 0 0 0-.166-.522ZM15 16.177l-9.618-5.55L15 5.077l9.618 5.55Zm-3.682-14.8 2.715 2.853-9.765 5.635-2.715-2.853Zm-7.05 10.012 9.766 5.635-2.715 2.853-9.766-5.635ZM25.25 22.767l-9.664 5.576v-6.294a.587.587 0 1 0-1.172 0v6.294L4.75 22.767v-5.274l6.389 3.687a.56.56 0 0 0 .282.076.57.57 0 0 0 .415-.18L15 17.75l3.164 3.325a.57.57 0 0 0 .415.18.56.56 0 0 0 .282-.076l6.389-3.687Zm-6.568-2.89-2.715-2.853 9.766-5.635 2.715 2.853Zm0 0",
  "data-name": "Path 12918"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.621 5.094a.748.748 0 1 0-.528-.219.75.75 0 0 0 .528.219m0 0",
  "data-name": "Path 12919"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15 19.212a.748.748 0 1 0 .528.219.75.75 0 0 0-.528-.219m0 0",
  "data-name": "Path 12920"
})));

const SvgPxOpenLeads = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57651"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57510"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57509",
  transform: "translate(3 3)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 9,
  cy: 9,
  r: 9,
  fill: "#382b73",
  "data-name": "Ellipse 1457"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 7.571,
  cy: 7.571,
  r: 7.571,
  fill: "#473080",
  "data-name": "Ellipse 1458",
  transform: "translate(1.335 1.335)"
}))), /*#__PURE__*/React.createElement("g", {
  fill: "#382b73",
  "data-name": "Group 57511",
  transform: "translate(6.778 7.364)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.589 4.093H1.667a.653.653 0 0 0 0 1.306h6.922a.653.653 0 1 0 0-1.306",
  "data-name": "Path 71932"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.098 6.357a2 2 0 0 0-.262-.019A1.836 1.836 0 1 0 3.662 8.37l.476.507.323 1.506a.08.08 0 0 0 .081.065h1.172a.08.08 0 0 0 .081-.065l.323-1.506L7.23 7.693a5.6 5.6 0 0 0 1.3-2.295H1.728a5.6 5.6 0 0 0 .37.959",
  "data-name": "Path 71933"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1.042,
  cy: 1.042,
  r: 1.042,
  "data-name": "Ellipse 1459",
  transform: "rotate(-32.88 4.656 -2.32)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.316 1.279a.64.64 0 1 0-.64-.64.64.64 0 0 0 .64.64",
  "data-name": "Path 71934"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.037 3.313a.818.818 0 1 0-.818-.818.82.82 0 0 0 .818.818",
  "data-name": "Path 71935"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57526"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57512"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#ef5a9d",
  d: "M15.367 12.246H8.445a.653.653 0 0 1 0-1.306h6.922a.653.653 0 0 1 0 1.306",
  "data-name": "Path 71936"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e43d91",
  d: "M15.367 11.834H8.445a.65.65 0 0 1-.619-.447.652.652 0 0 0 .619.859h6.922a.652.652 0 0 0 .619-.859.65.65 0 0 1-.619.447",
  "data-name": "Path 71937"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e43d91",
  d: "M15.305 12.246h-6.8a5.6 5.6 0 0 0 1.3 2.295l1.112 1.184.323 1.506a.08.08 0 0 0 .081.065h1.171a.08.08 0 0 0 .081-.065l.323-1.506 1.112-1.184a5.6 5.6 0 0 0 1.297-2.295",
  "data-name": "Path 71938"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ef5a9d",
  d: "M14.377 12.246H9.435a6.4 6.4 0 0 0 .944 2.295l.808 1.184.245 1.571h.949l.245-1.571.808-1.184a6.4 6.4 0 0 0 .943-2.295",
  "data-name": "Path 71939"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e43d91",
  d: "m11.148 16.805.091.426a.08.08 0 0 0 .081.065h1.172a.08.08 0 0 0 .081-.065l.091-.426Z",
  "data-name": "Path 71940"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57524",
  transform: "translate(6.778 13.185)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 1.836,
  cy: 1.836,
  r: 1.836,
  fill: "#fede3a",
  "data-name": "Ellipse 1460"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e7ad27",
  d: "M3.027 1.782v-.006l-.006-.024a.11.11 0 0 0-.075-.066l-.264-.068.1-.177a.1.1 0 0 0 .015-.054v-.135a.1.1 0 0 0-.019-.068l-.009-.01-.177-.177A.11.11 0 0 0 2.458.98l-.278.164-.029-.012L2.07.82a.11.11 0 0 0-.064-.074L1.979.739h-.283a.11.11 0 0 0-.091.082l-.081.312-.029.012-.278-.164a.11.11 0 0 0-.134.017l-.177.177-.009.01a.1.1 0 0 0-.019.068v.138a.1.1 0 0 0 .015.054l.1.177-.264.068a.1.1 0 0 0-.068.052.1.1 0 0 0-.009.03v.409a.11.11 0 0 0 .083.107l.264.068-.1.177a.1.1 0 0 0-.015.062v.131a.11.11 0 0 0 .032.083l.177.177a.11.11 0 0 0 .134.017l.278-.164.028.012.081.312a.11.11 0 0 0 .107.083h.251a.11.11 0 0 0 .107-.083l.081-.312.028-.012.278.164a.11.11 0 0 0 .134-.017l.177-.177a.11.11 0 0 0 .032-.083v-.131a.1.1 0 0 0-.015-.062l-.1-.177.264-.068a.11.11 0 0 0 .083-.107v-.403Zm-1.584.136a.393.393 0 1 1 .393.393.393.393 0 0 1-.396-.394Z",
  "data-name": "Path 71941"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57523"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57522"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57521"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#e43d91",
  d: "M2.799 1.097V1.09a.1.1 0 0 0-.032-.072L2.59.841a.11.11 0 0 0-.134-.017l-.278.164L2.15.976 2.069.664a.11.11 0 0 0-.107-.083h-.251a.11.11 0 0 0-.107.083l-.081.312-.028.012-.278-.164a.11.11 0 0 0-.134.017l-.177.177a.1.1 0 0 0-.032.072s0 0 0 .007v.136a.1.1 0 0 0 .015.054l.1.177-.264.068a.11.11 0 0 0-.083.107v.393a.11.11 0 0 0 .083.107l.264.068-.1.177a.1.1 0 0 0-.015.056v.131a.11.11 0 0 0 .032.083l.177.177a.11.11 0 0 0 .134.017l.278-.164.028.012.081.312a.11.11 0 0 0 .107.083h.251a.11.11 0 0 0 .107-.083l.081-.312.028-.012.278.164a.11.11 0 0 0 .134-.017l.177-.177a.11.11 0 0 0 .032-.083V2.44a.1.1 0 0 0-.015-.056l-.1-.177.264-.068a.11.11 0 0 0 .083-.107v-.393a.11.11 0 0 0-.083-.107l-.264-.068.1-.177a.1.1 0 0 0 .015-.054ZM1.836 2.16a.395.395 0 1 1 .395-.395.4.4 0 0 1-.391.395Z",
  "data-name": "Path 71942"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57520"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#ef5a9d",
  d: "M1.833.91a.856.856 0 1 0 .856.856.856.856 0 0 0-.856-.856m0 1.249a.393.393 0 1 1 .393-.393.393.393 0 0 1-.393.393",
  "data-name": "Path 71943"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#ef5a9d",
  "data-name": "Group 57517"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57513"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.047 1.123h-.419a.11.11 0 0 1-.107-.138l.085-.328a.11.11 0 0 1 .107-.083h.251a.11.11 0 0 1 .107.083l.085.328a.11.11 0 0 1-.109.138",
  "data-name": "Path 71944"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.629 2.408h.421a.11.11 0 0 1 .107.138l-.085.328a.11.11 0 0 1-.107.083h-.251a.11.11 0 0 1-.107-.083l-.085-.328a.11.11 0 0 1 .107-.138",
  "data-name": "Path 71945"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57514"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.478 1.976v-.421a.11.11 0 0 1 .138-.107l.328.085a.11.11 0 0 1 .083.107v.251a.11.11 0 0 1-.083.107l-.328.085a.11.11 0 0 1-.138-.107",
  "data-name": "Path 71946"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.194 1.554v.421a.11.11 0 0 1-.138.107l-.328-.085a.11.11 0 0 1-.083-.107v-.251a.11.11 0 0 1 .083-.107l.328-.085a.11.11 0 0 1 .138.107",
  "data-name": "Path 71947"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57515"
}, /*#__PURE__*/React.createElement("path", {
  d: "m2.439 1.46-.3-.3a.11.11 0 0 1 .022-.173l.292-.172a.11.11 0 0 1 .134.017l.177.177a.11.11 0 0 1 .017.134l-.172.292a.11.11 0 0 1-.17.025",
  "data-name": "Path 71948"
}), /*#__PURE__*/React.createElement("path", {
  d: "m1.234 2.07.3.3a.11.11 0 0 1-.022.173l-.292.172a.11.11 0 0 1-.134-.017l-.177-.177a.11.11 0 0 1-.017-.134l.172-.292a.11.11 0 0 1 .17-.025",
  "data-name": "Path 71949"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57516"
}, /*#__PURE__*/React.createElement("path", {
  d: "m2.141 2.368.3-.3a.11.11 0 0 1 .174.022l.172.292a.11.11 0 0 1-.017.134l-.177.177a.11.11 0 0 1-.134.017l-.292-.172a.11.11 0 0 1-.026-.17",
  "data-name": "Path 71950"
}), /*#__PURE__*/React.createElement("path", {
  d: "m1.531 1.163-.3.3a.11.11 0 0 1-.173-.022l-.172-.292a.11.11 0 0 1 .017-.134L1.08.838a.11.11 0 0 1 .134-.017l.292.172a.11.11 0 0 1 .025.17",
  "data-name": "Path 71951"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57518"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#f06ea9",
  d: "M1.836 2.481a.716.716 0 1 1 .716-.716.717.717 0 0 1-.716.716m0-1.32a.6.6 0 1 0 .6.6.6.6 0 0 0-.6-.6",
  "data-name": "Path 71952"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57519"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#e43d91",
  d: "M1.836 2.369a.6.6 0 1 1 .6-.6.6.6 0 0 1-.6.6m0-1a.395.395 0 1 0 .395.395.4.4 0 0 0-.395-.394Z",
  "data-name": "Path 71953"
}))))))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57525",
  transform: "translate(9.179 6.847)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 1.042,
  cy: 1.042,
  r: 1.042,
  fill: "#1caee4",
  "data-name": "Ellipse 1461",
  transform: "translate(0 1.424)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#009add",
  d: "M1.042 2.974a1.04 1.04 0 0 1-1.007-.775 1.042 1.042 0 1 0 2.015 0 1.04 1.04 0 0 1-1.008.775",
  "data-name": "Path 71954"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 0.64,
  cy: 0.64,
  r: 0.64,
  fill: "#ef5a9d",
  "data-name": "Ellipse 1462",
  transform: "translate(2.275)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e43d91",
  d: "M2.915.83a.64.64 0 0 1-.6-.415.64.64 0 1 0 1.2 0 .64.64 0 0 1-.6.415",
  "data-name": "Path 71955"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 0.818,
  cy: 0.818,
  r: 0.818,
  fill: "#fede3a",
  "data-name": "Ellipse 1463",
  transform: "translate(3.818 1.682)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f7cb15",
  d: "M4.636 2.737a.82.82 0 0 1-.765-.528.818.818 0 1 0 1.529 0 .82.82 0 0 1-.764.528",
  "data-name": "Path 71956"
})))));

const SvgPxOutlineblackDollar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 13.678 13.678"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h13.678v13.678H0Z",
  "data-name": "Path 2885"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#212121",
  "data-name": "Group 225"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.84 1.14a5.7 5.7 0 1 0 5.7 5.7 5.7 5.7 0 0 0-5.7-5.7m0 10.258a4.559 4.559 0 1 1 4.558-4.558 4.565 4.565 0 0 1-4.558 4.558",
  "data-name": "Path 2886"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.015 6.35c-1.008-.257-1.333-.536-1.333-.953 0-.479.45-.815 1.2-.815.786 0 1.083.376 1.106.935h.975a1.77 1.77 0 0 0-1.421-1.692V2.85h-1.33v.963a1.72 1.72 0 0 0-1.55 1.6c0 1.02.849 1.533 2.086 1.829 1.111.262 1.334.655 1.334 1.066 0 .3-.222.792-1.2.792-.912 0-1.271-.41-1.322-.935h-.978a1.85 1.85 0 0 0 1.63 1.695v.969h1.33v-.952c.866-.165 1.55-.661 1.556-1.579-.002-1.253-1.079-1.687-2.083-1.948",
  "data-name": "Path 2887"
})));

const SvgPxOutlineblueDollar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 13.678 13.678"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h13.678v13.678H0Z",
  "data-name": "Path 2885"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#2f53e6",
  "data-name": "Group 225"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.84 1.14a5.7 5.7 0 1 0 5.7 5.7 5.7 5.7 0 0 0-5.7-5.7m0 10.258a4.559 4.559 0 1 1 4.558-4.558 4.565 4.565 0 0 1-4.558 4.558",
  "data-name": "Path 2886"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.015 6.35c-1.008-.257-1.333-.536-1.333-.953 0-.479.45-.815 1.2-.815.786 0 1.083.376 1.106.935h.975a1.77 1.77 0 0 0-1.421-1.692V2.85h-1.33v.963a1.72 1.72 0 0 0-1.55 1.6c0 1.02.849 1.533 2.086 1.829 1.111.262 1.334.655 1.334 1.066 0 .3-.222.792-1.2.792-.912 0-1.271-.41-1.322-.935h-.978a1.85 1.85 0 0 0 1.63 1.695v.969h1.33v-.952c.866-.165 1.55-.661 1.556-1.579-.002-1.253-1.079-1.687-2.083-1.948",
  "data-name": "Path 2887"
})));

const SvgPxOutlinegreenDollar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 14 14"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h14v14H0Z",
  "data-name": "Path 2885"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#00bf0f",
  "data-name": "Group 225"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7 1.167A5.833 5.833 0 1 0 12.833 7 5.835 5.835 0 0 0 7 1.167m0 10.5A4.667 4.667 0 1 1 11.667 7 4.673 4.673 0 0 1 7 11.667",
  "data-name": "Path 2886"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.181 6.499c-1.031-.263-1.365-.549-1.365-.974 0-.49.461-.834 1.225-.834.8 0 1.108.385 1.132.957h1a1.81 1.81 0 0 0-1.455-1.731v-1h-1.36v.986a1.76 1.76 0 0 0-1.586 1.639c0 1.044.869 1.569 2.135 1.873 1.137.268 1.365.671 1.365 1.091 0 .309-.227.811-1.225.811-.933 0-1.3-.42-1.353-.957h-1a1.89 1.89 0 0 0 1.668 1.733v.992h1.365v-.974c.887-.169 1.587-.677 1.592-1.616C9.31 7.21 8.207 6.767 7.181 6.499",
  "data-name": "Path 2887"
})));

const SvgPxPaymentPlan = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".px-payment-plan_svg__cls-2{fill:#fcc42d}.px-payment-plan_svg__cls-3{fill:#dda519}.px-payment-plan_svg__cls-5{fill:#a2d2f9}.px-payment-plan_svg__cls-6{fill:#fcfafa;opacity:.2}.px-payment-plan_svg__cls-8{fill:#064186}")), /*#__PURE__*/React.createElement("g", {
  id: "px-payment-plan_svg__Group_50390",
  "data-name": "Group 50390",
  transform: "translate(9168 -23185)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-payment-plan_svg__icon_placeholder",
  d: "M0 0h32v32H0z",
  style: {
    fill: "none"
  },
  transform: "translate(-9168 23185)"
}), /*#__PURE__*/React.createElement("g", {
  id: "px-payment-plan_svg__bank",
  transform: "translate(-9162.064 23191.027)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-payment-plan_svg__Path_64902",
  d: "M44.65 392H33.8a.36.36 0 0 0-.359.359v1.441h-1.082a.36.36 0 0 0-.359.359v1.438a.36.36 0 0 0 .359.359h16.532a.36.36 0 0 0 .359-.359v-1.586",
  className: "px-payment-plan_svg__cls-2",
  "data-name": "Path 64902",
  transform: "translate(-31.997 -376.008)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-payment-plan_svg__Path_64903",
  d: "M64 416h14.734v.719H64Z",
  className: "px-payment-plan_svg__cls-3",
  "data-name": "Path 64903",
  transform: "translate(-62.56 -398.93)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-payment-plan_svg__Path_64904",
  d: "M208 232h1.438v5.75H208Z",
  className: "px-payment-plan_svg__cls-2",
  "data-name": "Path 64904",
  transform: "translate(-200.091 -223.195)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-payment-plan_svg__Path_64905",
  d: "M328 232h1.438v5.75H328Z",
  className: "px-payment-plan_svg__cls-2",
  "data-name": "Path 64905",
  transform: "translate(-314.7 -223.195)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-payment-plan_svg__Path_64906",
  d: "M32.658 43.367h15.813a.719.719 0 0 0 .431-1.294L41 36.144a.72.72 0 0 0-.862 0l-7.906 5.93a.719.719 0 0 0 .426 1.293",
  "data-name": "Path 64906",
  style: {
    fill: "#0a529b"
  },
  transform: "translate(-31.938 -36)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "px-payment-plan_svg__Ellipse_799",
  cx: 1.078,
  cy: 1.078,
  r: 1.078,
  className: "px-payment-plan_svg__cls-5",
  "data-name": "Ellipse 799",
  transform: "translate(7.55 3.414)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-payment-plan_svg__Path_64907",
  d: "M88 232h1.438v5.75H88Z",
  className: "px-payment-plan_svg__cls-2",
  "data-name": "Path 64907",
  transform: "translate(-85.482 -223.195)"
}), /*#__PURE__*/React.createElement("g", {
  id: "px-payment-plan_svg__Group_50321",
  "data-name": "Group 50321",
  transform: "translate(1.8 7.367)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-payment-plan_svg__Path_64908",
  d: "M72 200v1.437h2.875V200",
  className: "px-payment-plan_svg__cls-3",
  "data-name": "Path 64908",
  transform: "translate(-72 -200)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-payment-plan_svg__Path_64909",
  d: "M74.875 361.437V360H72v1.437",
  className: "px-payment-plan_svg__cls-3",
  "data-name": "Path 64909",
  transform: "translate(-72 -352.813)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-payment-plan_svg__Path_64910",
  d: "M192 200v1.437h2.875V200",
  className: "px-payment-plan_svg__cls-3",
  "data-name": "Path 64910",
  transform: "translate(-186.609 -200)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-payment-plan_svg__Path_64911",
  d: "M194.875 361.437V360H192v1.437",
  className: "px-payment-plan_svg__cls-3",
  "data-name": "Path 64911",
  transform: "translate(-186.609 -352.813)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-payment-plan_svg__Path_64912",
  d: "M312 200v1.437h2.875V200",
  className: "px-payment-plan_svg__cls-3",
  "data-name": "Path 64912",
  transform: "translate(-301.219 -200)"
})), /*#__PURE__*/React.createElement("path", {
  id: "px-payment-plan_svg__Path_64913",
  d: "m72.288 37.882-2.317-1.738a.72.72 0 0 0-.863 0l-6.834 5.125c5.526.188 8.648-2.041 10.014-3.387",
  className: "px-payment-plan_svg__cls-6",
  "data-name": "Path 64913",
  transform: "translate(-60.912 -36)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-payment-plan_svg__Path_64914",
  d: "M313.455 392a3.957 3.957 0 0 0 4.607 3.169v-1.162l-4.6-2.007Z",
  "data-name": "Path 64914",
  style: {
    opacity: 0.2,
    fill: "#064186"
  },
  transform: "translate(-300.809 -376.008)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "px-payment-plan_svg__Ellipse_800",
  cx: 3.953,
  cy: 3.953,
  r: 3.953,
  className: "px-payment-plan_svg__cls-5",
  "data-name": "Ellipse 800",
  transform: "translate(12.222 10.242)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-payment-plan_svg__Path_64915",
  d: "M352.359 315.593a.359.359 0 0 1-.254-.613l2.875-2.875a.359.359 0 0 1 .508.508l-2.875 2.875a.36.36 0 0 1-.254.105",
  className: "px-payment-plan_svg__cls-8",
  "data-name": "Path 64915",
  transform: "translate(-337.622 -299.601)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "px-payment-plan_svg__Ellipse_801",
  cx: 0.719,
  cy: 0.719,
  r: 0.719,
  className: "px-payment-plan_svg__cls-8",
  "data-name": "Ellipse 801",
  transform: "translate(14.378 12.039)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "px-payment-plan_svg__Ellipse_802",
  cx: 0.719,
  cy: 0.719,
  r: 0.719,
  className: "px-payment-plan_svg__cls-8",
  "data-name": "Ellipse 802",
  transform: "translate(16.893 14.554)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-payment-plan_svg__Path_64916",
  d: "M305.446 269.237a3.954 3.954 0 0 1 5.772-3.51 3.953 3.953 0 1 0-5.076 5.751 3.94 3.94 0 0 1-.696-2.241",
  className: "px-payment-plan_svg__cls-6",
  "data-name": "Path 64916",
  transform: "translate(-291.787 -253.772)"
}))));

const SvgPxPayment = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h32v32H0z",
  style: {
    fill: "none"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "m61.759 53.011-16.615 2.93a1.887 1.887 0 0 1-2.187-1.531l-1.829-10.372a1.887 1.887 0 0 1 1.531-2.187l16.615-2.93a1.887 1.887 0 0 1 2.187 1.531l1.829 10.373a1.887 1.887 0 0 1-1.531 2.187Z",
  style: {
    fill: "#3555a2"
  },
  transform: "translate(-35.159 -32.894)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m258.532 38.921-8.308 1.465 2.484 14.09 8.308-1.465a1.887 1.887 0 0 0 1.531-2.187l-1.829-10.372a1.887 1.887 0 0 0-2.186-1.531",
  style: {
    fill: "#1b3555"
  },
  transform: "translate(-234.417 -32.893)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.4 189.438H1.887A1.887 1.887 0 0 1 0 187.551v-10.274a1.887 1.887 0 0 1 1.887-1.887H18.4a1.887 1.887 0 0 1 1.887 1.887v10.273a1.887 1.887 0 0 1-1.887 1.888",
  style: {
    fill: "#53d8e3"
  },
  transform: "translate(4 -162.951)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M223.258 175.39H215v14.048h8.258a1.887 1.887 0 0 0 1.887-1.887v-10.274a1.887 1.887 0 0 0-1.887-1.887",
  style: {
    fill: "#18a8c9"
  },
  transform: "translate(-200.855 -162.951)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 243.44h20.29v3.211H0Z",
  style: {
    fill: "#ecf6fd"
  },
  transform: "translate(4 -227.79)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.956 407.07h-3.211a.708.708 0 0 0 0 1.416h3.211a.708.708 0 0 0 0-1.416",
  style: {
    fill: "#eaf6ff"
  },
  transform: "translate(-30.337 -383.699)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M215 243.44h10.145v3.211H215Z",
  style: {
    fill: "#d6e8fe"
  },
  transform: "translate(-200.855 -227.79)"
}));

const SvgPxPermitHistory = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 50399"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h32v32H0z",
  style: {
    fill: "none"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "m16.536 3.069-.092.023-.1-.023h-.767V.767A.77.77 0 0 0 14.81 0H3.3a2.3 2.3 0 0 0-2.262 1.918L1 2.11V16.3a2.11 2.11 0 0 0 2.11 2.11h13.426a.58.58 0 0 0 .575-.575V3.644a.58.58 0 0 0-.575-.575",
  "data-name": "Path 64971",
  style: {
    fill: "#2196f3"
  },
  transform: "translate(6.709 8.09)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.987 17.474a4.987 4.987 0 1 1 4.987-4.987 5 5 0 0 1-4.987 4.987",
  "data-name": "Path 64972",
  style: {
    fill: "#fafafa"
  },
  transform: "translate(5.778 6.344)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.508 3.534H3.767a.767.767 0 1 1 0-1.534h10.741Z",
  "data-name": "Path 64973",
  style: {
    fill: "#fff"
  },
  transform: "translate(6.243 7.624)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.418 14.987a.77.77 0 0 1-.542-.225l-1.151-1.151a.76.76 0 0 1-.225-.542v-2.3a.767.767 0 0 1 1.534 0v1.984l.926.926a.767.767 0 0 1-.542 1.31Z",
  "data-name": "Path 64974",
  style: {
    fill: "#607d8b"
  },
  transform: "translate(4.497 5.762)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.056 0H3.3a2.3 2.3 0 0 0-2.262 1.918L1 2.11V16.3a2.11 2.11 0 0 0 2.11 2.11h5.946v-2.682a4.987 4.987 0 0 1 0-9.974V3.069H3.3a.767.767 0 1 1 0-1.534h5.756Z",
  "data-name": "Path 64975",
  style: {
    fill: "#1d83d4"
  },
  transform: "translate(6.709 8.09)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.987 7.5a4.987 4.987 0 0 0 0 9.974v-3.9l-.542-.542a.76.76 0 0 1-.225-.542v-2.3a.767.767 0 0 1 .767-.767Z",
  "data-name": "Path 64976",
  style: {
    fill: "#dadada"
  },
  transform: "translate(5.778 6.344)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.6 2H3.767a.767.767 0 1 0 0 1.534h5.179V2Z",
  "data-name": "Path 64977",
  style: {
    fill: "#dedede"
  },
  transform: "translate(6.243 7.624)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.267 10a.767.767 0 0 0-.767.767v2.3a.76.76 0 0 0 .225.542l.542.542Z",
  "data-name": "Path 64978",
  style: {
    fill: "#546d79"
  },
  transform: "translate(4.497 5.762)"
})));

const SvgPxProfession = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".px-profession_svg__b{fill:#f8b64c}.px-profession_svg__d{fill:#40596b}.px-profession_svg__h{fill:#334a5e}.px-profession_svg__i{fill:#cdd6e0}")), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h32v32H0z",
  style: {
    fill: "none"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.582 16.416h5.808v5.119h-5.808z",
  className: "px-profession_svg__b"
}), /*#__PURE__*/React.createElement("path", {
  d: "M229.754 261.829v1.8l-2.143 1.734-2.321-1.848 1.277-1.688Z",
  className: "px-profession_svg__d",
  style: {
    opacity: 0.1
  },
  transform: "translate(-210.363 -245.414)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.186 12.337c.069.788-.313 1.465-.853 1.512s-1.035-.553-1.1-1.34.313-1.465.853-1.512 1.034.553 1.1 1.34M21.744 12.508c-.069.788-.563 1.388-1.1 1.34s-.923-.724-.854-1.512.563-1.388 1.1-1.34.922.724.853 1.512",
  className: "px-profession_svg__b"
}), /*#__PURE__*/React.createElement("path", {
  d: "M161.906 7.349V8.84a8 8 0 0 1-.062.943 9 9 0 0 1-.329 1.518 8.5 8.5 0 0 1-1.847 3.212l-.434.474a2.09 2.09 0 0 1-1.545.68h-.658a2.1 2.1 0 0 1-1.54-.68l-.43-.474a8.55 8.55 0 0 1-2.176-4.73 8 8 0 0 1-.061-.943 1 1 0 0 1 0-.1V7.375a4.543 4.543 0 0 1 8.911-1.246 4.3 4.3 0 0 1 .176 1.22",
  style: {
    fill: "#ffd15c"
  },
  transform: "translate(-140.875 2.928)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h8.543v6.318H0z",
  style: {
    fill: "#f2f2f2"
  },
  transform: "translate(12.215 20.984)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m233.469 364.685.57 4.817H231.5l.575-4.813-.614-.614 1.307-1.307 1.307 1.307Z",
  style: {
    fill: "#ff7058"
  },
  transform: "translate(-216.285 -342.201)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.972 27.299v-3.6a3.93 3.93 0 0 0-2.6-3.7l-4.981-1.789v.013l-.823 9.075ZM14.407 27.299l-.824-9.087-4.982 1.789a3.93 3.93 0 0 0-2.6 3.7v3.6Z",
  className: "px-profession_svg__d"
}), /*#__PURE__*/React.createElement("path", {
  d: "m21.726 27.299 1.4-2.372a.064.064 0 0 0-.01-.081l-2.376-2.339a.066.066 0 0 1 .02-.107l2.3-1.024a.066.066 0 0 0 .016-.111l-3.684-3.041-.823 9.075h3.159ZM11.248 27.299h3.159l-.823-9.075L9.9 21.265a.066.066 0 0 0 .016.111l2.3 1.024a.066.066 0 0 1 .02.107L9.86 24.846a.064.064 0 0 0-.01.081Z",
  className: "px-profession_svg__h"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.764 13.746a5.65 5.65 0 0 0-.309-2.754 1.7 1.7 0 0 1-.1-.877c.18-1.3-.5-1.127-.5-1.127a8.6 8.6 0 0 1-3.358.708 8.6 8.6 0 0 1-3.357-.708s-.685-.176-.505 1.127a1.7 1.7 0 0 1-.1.877 5.65 5.65 0 0 0-.309 2.754S9.339 5.341 16.49 5.654c7.15-.313 4.275 8.093 4.275 8.093",
  className: "px-profession_svg__d"
}), /*#__PURE__*/React.createElement("path", {
  d: "m16.486 20.567 2.9-2.356-.438 4.832ZM16.486 20.567l-2.9-2.356.438 4.832Z",
  className: "px-profession_svg__i"
}));

const SvgPxProfile = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 30 30"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 7888"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h30v30H0z",
  "data-name": "Rectangle 6199"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 7889"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 6636",
  transform: "translate(2.362)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 7.24,
  cy: 7.24,
  r: 7.24,
  fill: "#5367ff",
  "data-name": "Ellipse 329",
  transform: "rotate(-88.514 10.123 4.472)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#012672",
  d: "M2.569 29.491h20.492a2.568 2.568 0 0 0 2.491-3.194l-1.865-7.43a2.72 2.72 0 0 0-2.141-2.01l-3.733-.689a1.66 1.66 0 0 0-1.482.465l-2.7 2.726a1.15 1.15 0 0 1-1.631 0l-2.7-2.726a1.66 1.66 0 0 0-1.483-.465l-3.733.689a2.72 2.72 0 0 0-2.141 2.01l-1.865 7.43a2.568 2.568 0 0 0 2.491 3.194",
  "data-name": "Path 11180"
})))));

const SvgPxProgressBilling = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "progress billing"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#00efd1",
  d: "M22.604 5a4.993 4.993 0 1 1-4.789 3.568A4.99 4.99 0 0 1 22.604 5m0 0",
  "data-name": "Path 71724"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fedb41",
  d: "M21.933 23.878v.005a2.59 2.59 0 0 1-2.592 2.59h-.008q-.09.002-.178-.006a2.593 2.593 0 0 1-2.412-2.589v-1.676H8.054v-.023l.092-13.614h9.665a5 5 0 0 0 4.118 6.38Zm0 0",
  "data-name": "Path 71725"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00acea",
  d: "M19.155 26.468v.008H7.592A2.59 2.59 0 0 1 5 23.884v-1.682h11.743v1.674a2.593 2.593 0 0 0 2.412 2.589Zm0 0",
  "data-name": "Path 71726"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fedb41",
  d: "M22.582 9.615a.845.845 0 0 1-.045-1.689h.051a.846.846 0 0 1 .839.845.379.379 0 1 0 .757 0 1.605 1.605 0 0 0-1.26-1.566v-.364a.379.379 0 0 0-.757 0v.38a1.6 1.6 0 0 0 .414 3.152.846.846 0 1 1-.846.846.379.379 0 0 0-.757 0 1.606 1.606 0 0 0 1.189 1.548v.415a.379.379 0 0 0 .757 0v-.4a1.6 1.6 0 0 0-.343-3.168Zm0 0",
  "data-name": "Path 71727"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#f4b844",
  "data-name": "Group 57431"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.157 16.212H14.11a.379.379 0 0 1 0-.757h5.047a.379.379 0 1 1 0 .757m0 0",
  "data-name": "Path 71728"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.3 12.921h-4.19a.379.379 0 1 1 0-.757h4.189a.379.379 0 1 1 0 .757Zm0 0",
  "data-name": "Path 71729"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.157 19.503H14.11a.379.379 0 0 1 0-.757h5.047a.379.379 0 1 1 0 .757m0 0",
  "data-name": "Path 71730"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.513 12.54a.834.834 0 1 1-.833-.8.815.815 0 0 1 .833.8m0 0",
  "data-name": "Path 71731"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.513 15.833a.834.834 0 1 1-.833-.795.815.815 0 0 1 .833.795m0 0",
  "data-name": "Path 71732"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.513 19.125a.834.834 0 1 1-.833-.795.814.814 0 0 1 .833.795m0 0",
  "data-name": "Path 71733"
}))));

const SvgPxProjectDetails = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".px-project-details_svg__cls-10{fill:#575757}.px-project-details_svg__cls-11{fill:#3f3f3f}")), /*#__PURE__*/React.createElement("g", {
  id: "px-project-details_svg__Group_50383",
  "data-name": "Group 50383",
  transform: "translate(9168 -23081)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-project-details_svg__icon_placeholder",
  d: "M0 0h32v32H0z",
  style: {
    fill: "none"
  },
  transform: "translate(-9168 23081)"
}), /*#__PURE__*/React.createElement("g", {
  id: "px-project-details_svg__project_1_",
  "data-name": "project (1)",
  transform: "translate(-9161 23088)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-project-details_svg__Path_65067",
  d: "M192.945 11.466h-10.424a.52.52 0 0 1-.521-.521V.521a.52.52 0 0 1 .521-.521h10.423a.52.52 0 0 1 .521.521v10.423a.52.52 0 0 1-.52.522m0 0",
  "data-name": "Path 65067",
  style: {
    fill: "#e1eef1"
  },
  transform: "translate(-175.676)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-project-details_svg__Path_65068",
  d: "M352.212 0H347v11.466h5.212a.52.52 0 0 0 .521-.521V.521a.52.52 0 0 0-.521-.521m0 0",
  "data-name": "Path 65068",
  style: {
    fill: "#c3dce1"
  },
  transform: "translate(-334.944)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-project-details_svg__Path_65069",
  d: "M248.775 67.3h-6.254a.52.52 0 0 1-.521-.521v-4.173a.52.52 0 0 1 .232-.434l3.127-2.085a.52.52 0 0 1 .578 0l3.127 2.085a.52.52 0 0 1 .232.434v4.169a.52.52 0 0 1-.521.525m0 0",
  "data-name": "Path 65069",
  style: {
    fill: "#ffcd00"
  },
  transform: "translate(-233.592 -57.915)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-project-details_svg__Path_65070",
  d: "m350.416 62.173-3.127-2.085A.5.5 0 0 0 347 60v7.3h3.127a.52.52 0 0 0 .521-.521v-4.173a.52.52 0 0 0-.232-.433m0 0",
  "data-name": "Path 65070",
  style: {
    fill: "#faaa00"
  },
  transform: "translate(-334.943 -57.916)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-project-details_svg__Path_65071",
  d: "M305.127 163.822H302v-3.3a.52.52 0 0 1 .521-.521h2.085a.52.52 0 0 1 .521.521Zm0 0",
  "data-name": "Path 65071",
  style: {
    fill: "#ff5a5a"
  },
  transform: "translate(-291.507 -154.441)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-project-details_svg__Path_65072",
  d: "M348.564 160.521a.52.52 0 0 0-.521-.521H347v3.822h1.564Zm0 0",
  "data-name": "Path 65072",
  style: {
    fill: "#fa1e1e"
  },
  transform: "translate(-334.944 -154.441)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-project-details_svg__Path_65073",
  d: "M17.268 17.789H.521A.52.52 0 0 1 0 17.268V.521A.52.52 0 0 1 .521 0h3.127a.52.52 0 0 1 .521.521v13.1h13.1a.52.52 0 0 1 .521.521v3.127a.52.52 0 0 1-.522.52m0 0",
  "data-name": "Path 65073",
  style: {
    fill: "#fffa5f"
  }
}), /*#__PURE__*/React.createElement("path", {
  id: "px-project-details_svg__Path_65074",
  d: "M21.51 392H8.412l-4.017 4.017a.52.52 0 0 0 .368.153H21.51a.52.52 0 0 0 .521-.521v-3.127a.52.52 0 0 0-.521-.522m0 0",
  "data-name": "Path 65074",
  style: {
    fill: "#ffeb14"
  },
  transform: "translate(-4.242 -378.38)"
}), /*#__PURE__*/React.createElement("g", {
  id: "px-project-details_svg__Group_50330",
  "data-name": "Group 50330",
  transform: "translate(1.737 2.154)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-project-details_svg__Path_65075",
  d: "M52.432 63.042h-1.911a.521.521 0 1 1 0-1.042h1.911Zm0 0",
  className: "px-project-details_svg__cls-10",
  "data-name": "Path 65075",
  transform: "translate(-50 -62)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-project-details_svg__Path_65076",
  d: "M62.085 123.042h-1.564a.521.521 0 1 1 0-1.042h1.564Zm0 0",
  className: "px-project-details_svg__cls-10",
  "data-name": "Path 65076",
  transform: "translate(-59.653 -119.915)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-project-details_svg__Path_65077",
  d: "M52.432 183.042h-1.911a.521.521 0 1 1 0-1.042h1.911Zm0 0",
  className: "px-project-details_svg__cls-10",
  "data-name": "Path 65077",
  transform: "translate(-50 -177.831)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-project-details_svg__Path_65078",
  d: "M62.085 243.042h-1.564a.521.521 0 1 1 0-1.042h1.564Zm0 0",
  className: "px-project-details_svg__cls-10",
  "data-name": "Path 65078",
  transform: "translate(-59.653 -235.746)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-project-details_svg__Path_65079",
  d: "M52.432 303.042h-1.911a.521.521 0 1 1 0-1.042h1.911Zm0 0",
  className: "px-project-details_svg__cls-10",
  "data-name": "Path 65079",
  transform: "translate(-50 -293.661)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-project-details_svg__Path_65080",
  d: "M62.085 363.042h-1.564a.521.521 0 1 1 0-1.042h1.564Zm0 0",
  className: "px-project-details_svg__cls-10",
  "data-name": "Path 65080",
  transform: "translate(-59.653 -351.577)"
})), /*#__PURE__*/React.createElement("path", {
  id: "px-project-details_svg__Path_65081",
  d: "M121.042 392v1.563a.521.521 0 1 1-1.042 0V392Zm0 0",
  className: "px-project-details_svg__cls-11",
  "data-name": "Path 65081",
  transform: "translate(-115.831 -378.38)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-project-details_svg__Path_65082",
  d: "M181.042 392v1.911a.521.521 0 1 1-1.042 0V392Zm0 0",
  className: "px-project-details_svg__cls-11",
  "data-name": "Path 65082",
  transform: "translate(-173.746 -378.38)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-project-details_svg__Path_65083",
  d: "M241.042 392v1.563a.521.521 0 1 1-1.042 0V392Zm0 0",
  className: "px-project-details_svg__cls-11",
  "data-name": "Path 65083",
  transform: "translate(-231.661 -378.38)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-project-details_svg__Path_65084",
  d: "M301.042 392v1.911a.521.521 0 1 1-1.042 0V392Zm0 0",
  className: "px-project-details_svg__cls-11",
  "data-name": "Path 65084",
  transform: "translate(-289.577 -378.38)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-project-details_svg__Path_65085",
  d: "M361.042 392v1.563a.521.521 0 1 1-1.042 0V392Zm0 0",
  className: "px-project-details_svg__cls-11",
  "data-name": "Path 65085",
  transform: "translate(-347.492 -378.38)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-project-details_svg__Path_65086",
  d: "M421.042 392v1.911a.521.521 0 1 1-1.042 0V392Zm0 0",
  className: "px-project-details_svg__cls-11",
  "data-name": "Path 65086",
  transform: "translate(-405.407 -378.38)"
}))));

const SvgPxProjectSetup = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57650"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57620"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#e6f7fe",
  d: "M3.791 2h10.118a.8.8 0 0 1 .56.232l3.335 3.335a.8.8 0 0 1 .232.56v14.549a.79.79 0 0 1-.791.791H3.791A.79.79 0 0 1 3 20.676V2.791A.79.79 0 0 1 3.791 2",
  "data-name": "Path 72129"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57621"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#d3effd",
  d: "m17.803 5.567-3.336-3.335a.8.8 0 0 0-.56-.232h-.7v3.007a1.82 1.82 0 0 0 1.82 1.82h1.187a.79.79 0 0 1 .791.791v13.058a.79.79 0 0 1-.791.791h1.029a.79.79 0 0 0 .791-.791V6.126a.8.8 0 0 0-.232-.56Z",
  "data-name": "Path 72130"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57622"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#b2e5fb",
  d: "M14.239 5.007a.79.79 0 0 0 .791.791h2.935a.8.8 0 0 0-.16-.232l-3.336-3.334a.8.8 0 0 0-.232-.16Z",
  "data-name": "Path 72131"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57627"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57624"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57623"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#f7e365",
  d: "M9.172 12.92h-3.64a.554.554 0 0 1-.554-.554V7.934a.554.554 0 0 1 .554-.554h3.64a.554.554 0 0 1 .554.554v4.431a.554.554 0 0 1-.554.555",
  "data-name": "Path 72132"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57626"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57625"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#f7e365",
  d: "M15.503 12.92h-3.64a.554.554 0 0 1-.554-.554V7.934a.554.554 0 0 1 .554-.554h3.64a.554.554 0 0 1 .554.554v4.431a.554.554 0 0 1-.554.555",
  "data-name": "Path 72133"
})))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57632"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57628"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#62a4fb",
  d: "M20.805 15.641v-.378a.31.31 0 0 0-.249-.307l-.554-.115a.31.31 0 0 1-.241-.234q-.032-.141-.074-.278a.31.31 0 0 1 .092-.322l.422-.377a.31.31 0 0 0 .063-.39l-.188-.326a.31.31 0 0 0-.369-.141l-.538.177a.31.31 0 0 1-.325-.082q-.1-.105-.2-.2a.31.31 0 0 1-.082-.325l.177-.538a.31.31 0 0 0-.141-.369l-.326-.188a.31.31 0 0 0-.39.063l-.377.422a.31.31 0 0 1-.322.092q-.137-.042-.278-.074a.31.31 0 0 1-.234-.241l-.115-.554a.31.31 0 0 0-.307-.249h-.377a.31.31 0 0 0-.307.249l-.115.554a.31.31 0 0 1-.234.241q-.141.032-.277.074a.31.31 0 0 1-.322-.092l-.377-.422a.31.31 0 0 0-.39-.063l-.326.188a.31.31 0 0 0-.141.369l.177.538a.31.31 0 0 1-.082.325q-.105.1-.2.2a.31.31 0 0 1-.325.082l-.538-.177a.31.31 0 0 0-.369.141l-.188.326a.31.31 0 0 0 .063.39l.422.377a.31.31 0 0 1 .092.322q-.042.137-.074.278a.31.31 0 0 1-.241.234l-.554.115a.31.31 0 0 0-.249.307v.377a.31.31 0 0 0 .249.307l.554.115a.31.31 0 0 1 .241.234q.032.141.074.278a.31.31 0 0 1-.092.322l-.422.377a.31.31 0 0 0-.063.39l.188.326a.31.31 0 0 0 .369.141l.538-.177a.31.31 0 0 1 .325.082q.1.105.2.2a.31.31 0 0 1 .082.325l-.177.538a.31.31 0 0 0 .141.369l.326.188a.31.31 0 0 0 .39-.063l.377-.422a.31.31 0 0 1 .322-.092q.137.042.277.074a.31.31 0 0 1 .234.241l.115.554a.31.31 0 0 0 .307.249h.377a.31.31 0 0 0 .307-.249l.115-.554a.31.31 0 0 1 .234-.241q.141-.032.278-.074a.31.31 0 0 1 .322.092l.377.422a.31.31 0 0 0 .39.063l.326-.188a.31.31 0 0 0 .141-.369l-.177-.538a.31.31 0 0 1 .082-.325q.105-.1.2-.2a.31.31 0 0 1 .325-.082l.538.177a.31.31 0 0 0 .369-.141l.188-.326a.31.31 0 0 0-.063-.39l-.422-.377a.31.31 0 0 1-.092-.322q.042-.137.074-.278a.31.31 0 0 1 .241-.234l.554-.115a.31.31 0 0 0 .249-.306",
  "data-name": "Path 72134"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57629"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#5392f9",
  d: "m20.556 14.958-.554-.115a.31.31 0 0 1-.241-.234q-.032-.141-.074-.278a.31.31 0 0 1 .092-.322l.422-.377a.31.31 0 0 0 .063-.39l-.188-.326a.31.31 0 0 0-.369-.141l-.538.177a.3.3 0 0 1-.1.015 5.5 5.5 0 0 1 .06.784 4.847 4.847 0 0 1-4.847 4.847 5 5 0 0 1-.716-.053v.018l-.177.538a.31.31 0 0 0 .141.369l.326.188a.31.31 0 0 0 .39-.063l.377-.422a.31.31 0 0 1 .322-.092q.137.042.277.074a.31.31 0 0 1 .234.241l.115.554a.31.31 0 0 0 .307.249h.377a.31.31 0 0 0 .307-.249l.115-.554a.31.31 0 0 1 .234-.241q.141-.032.278-.074a.31.31 0 0 1 .322.092l.377.422a.31.31 0 0 0 .39.063l.326-.188a.31.31 0 0 0 .141-.369l-.177-.538a.31.31 0 0 1 .082-.325q.105-.1.2-.2a.31.31 0 0 1 .325-.082l.538.177a.31.31 0 0 0 .369-.141l.188-.326a.31.31 0 0 0-.063-.39l-.422-.377a.31.31 0 0 1-.092-.322q.042-.137.074-.277a.31.31 0 0 1 .241-.234l.554-.115a.31.31 0 0 0 .249-.307v-.377a.31.31 0 0 0-.255-.309",
  "data-name": "Path 72135"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57630",
  transform: "translate(13.485 12.881)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 2.572,
  cy: 2.572,
  r: 2.572,
  fill: "#e6f7fe",
  "data-name": "Ellipse 1472"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57631",
  transform: "translate(15.108 14.503)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0.95,
  cy: 0.95,
  r: 0.95,
  fill: "#62a4fb",
  "data-name": "Ellipse 1473"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57633"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#e175a5",
  d: "M11.549 4.532H5.006a.313.313 0 0 1-.313-.313V3.58a.313.313 0 0 1 .313-.315h6.543a.313.313 0 0 1 .313.313v.639a.313.313 0 0 1-.313.315",
  "data-name": "Path 72136"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57634"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#ad7fdd",
  d: "M9.729 20.201H5.006a.313.313 0 0 1-.313-.313v-.639a.313.313 0 0 1 .313-.313h4.723a.313.313 0 0 1 .313.313v.639a.313.313 0 0 1-.313.313",
  "data-name": "Path 72137"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57635"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#30569f",
  d: "M7.194 8.933h-.95a.285.285 0 1 1 0-.57h.95a.285.285 0 0 1 0 .57",
  "data-name": "Path 72138"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57636"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#30569f",
  d: "M8.46 10.198H6.244a.285.285 0 1 1 0-.57H8.46a.285.285 0 1 1 0 .57",
  "data-name": "Path 72139"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57637"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#30569f",
  d: "M8.46 11.463H6.244a.285.285 0 1 1 0-.57H8.46a.285.285 0 1 1 0 .57",
  "data-name": "Path 72140"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57638"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#30569f",
  d: "M13.525 8.933h-.95a.285.285 0 0 1 0-.57h.95a.285.285 0 0 1 0 .57",
  "data-name": "Path 72141"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57639"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#30569f",
  d: "M14.554 10.198h-1.978a.285.285 0 0 1 0-.57h1.978a.285.285 0 1 1 0 .57",
  "data-name": "Path 72142"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57640"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#62a4fb",
  d: "M6.244 6.083H4.978a.285.285 0 1 1 0-.57h1.266a.285.285 0 1 1 0 .57",
  "data-name": "Path 72143"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57641"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#62a4fb",
  d: "M11.863 6.083H7.511a.285.285 0 0 1 0-.57h4.352a.285.285 0 1 1 0 .57",
  "data-name": "Path 72144"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57647"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57642"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#e175a5",
  d: "M10.042 15.184H8.218a.285.285 0 0 1 0-.57h1.82a.285.285 0 0 1 0 .57Z",
  "data-name": "Path 72145"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57643"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#e175a5",
  d: "M6.957 15.184h-.792a.285.285 0 1 1 0-.57h.791a.285.285 0 0 1 0 .57Z",
  "data-name": "Path 72146"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57644"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#e175a5",
  d: "M10.043 16.45H4.978a.285.285 0 1 1 0-.57h5.065a.285.285 0 0 1 0 .57",
  "data-name": "Path 72147"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57645"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#e175a5",
  d: "M7.985 17.716H4.978a.285.285 0 1 1 0-.57h3.007a.285.285 0 0 1 0 .57",
  "data-name": "Path 72148"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57646"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#e175a5",
  d: "M10.043 17.716h-.791a.285.285 0 0 1 0-.57h.791a.285.285 0 0 1 0 .57",
  "data-name": "Path 72149"
})))));

const SvgPxProjectType = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".px-project-type_svg__b{fill:#5bb5e7}.px-project-type_svg__d{fill:#fcd981}.px-project-type_svg__e{fill:#474979}.px-project-type_svg__f{fill:#383c6b}.px-project-type_svg__g{fill:#64679c}.px-project-type_svg__h{fill:#a6d6eb}.px-project-type_svg__i{fill:#81c6e9}.px-project-type_svg__k{fill:#aa5821}.px-project-type_svg__m{fill:#4796cd}.px-project-type_svg__n{fill:#60d882}.px-project-type_svg__o{fill:#37c47a}.px-project-type_svg__p{fill:#e8f8fc}")), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h32v32H0z",
  style: {
    fill: "none"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.315 5.016A11.32 11.32 0 0 0 5.8 20.511l19.825 2.256a11.315 11.315 0 0 0-9.31-17.751m0 0",
  className: "px-project-type_svg__b"
}), /*#__PURE__*/React.createElement("path", {
  d: "M108.438 46.366v3.376h7.837v9.629h3.355a11.36 11.36 0 0 0 4.482-3.859v-8.977l-7.921-7.921Zm0 0",
  style: {
    fill: "#fceccd"
  },
  transform: "translate(-98.43 -32.83)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.567 16.162h-1.988a.58.58 0 0 0-.577.577v.172h.845v9.63h2.3v-9.8a.58.58 0 0 0-.577-.577ZM17.76 5.783l-7.752 7.752v3.376h1.794v-2.505a.9.9 0 0 1 .26-.628l6.846-6.846Zm0 0",
  className: "px-project-type_svg__d"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.699 22.298a11.37 11.37 0 0 0 4.731 4.244h6.414v-9.629H6.699Zm0 0",
  className: "px-project-type_svg__e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.699 22.297a11.4 11.4 0 0 0 3.4 3.488v-8.873h-3.4Zm0 0",
  className: "px-project-type_svg__f"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.767 13.955a.65.65 0 0 1 0-.918l8.534-8.534a.65.65 0 0 1 .918 0l8.7 8.7a.65.65 0 1 1-.918.918L17.76 5.88l-8.075 8.075a.65.65 0 0 1-.918 0m0 0",
  className: "px-project-type_svg__e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.844 27.022a.48.48 0 0 1-.481-.481v-9.334a.481.481 0 1 1 .961 0v9.334a.48.48 0 0 1-.48.481m0 0",
  className: "px-project-type_svg__g"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.59 19.812v4.707a.28.28 0 0 0 .278.278h2.457a.28.28 0 0 0 .278-.278v-4.707Zm0 0",
  className: "px-project-type_svg__h"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.804 24.519v-4.707H8.59v4.707a.28.28 0 0 0 .278.278h1.214a.28.28 0 0 1-.278-.278m0 0",
  className: "px-project-type_svg__i"
}), /*#__PURE__*/React.createElement("path", {
  d: "M174.82 342.262h3.112v6.638h-3.112Zm0 0",
  style: {
    fill: "#ce783e"
  },
  transform: "translate(-161.746 -322.455)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.074 19.807h1.218v6.638h-1.218Zm0 0",
  className: "px-project-type_svg__k"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.186 19.908h-3.112v-.942a.28.28 0 0 1 .278-.278h2.555a.28.28 0 0 1 .278.278Zm0 0",
  className: "px-project-type_svg__k"
}), /*#__PURE__*/React.createElement("path", {
  d: "M176.317 318.027H175.1a.28.28 0 0 0-.278.278v.942h1.218v-.942a.28.28 0 0 1 .277-.278m0 0",
  style: {
    fill: "#964e1d"
  },
  transform: "translate(-161.747 -299.339)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.325 18.688H8.863a.28.28 0 0 0-.278.278v.942h3.018v-.942a.28.28 0 0 0-.278-.278m0 0",
  className: "px-project-type_svg__b"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.086 18.688H8.863a.28.28 0 0 0-.278.278v.942h1.218v-.942a.28.28 0 0 1 .283-.278m0 0",
  className: "px-project-type_svg__m"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.187 6.199a3.774 3.774 0 1 0-1.381 5.155 3.774 3.774 0 0 0 1.381-5.155m0 0",
  className: "px-project-type_svg__n"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.961 7.367a1.863 1.863 0 0 1-2.376-2.811 3.774 3.774 0 1 0 4.479 5.615 1.865 1.865 0 0 1-2.1-2.8Zm0 0",
  className: "px-project-type_svg__o"
}), /*#__PURE__*/React.createElement("path", {
  d: "m23.302 9.667-1.339-1.34a.481.481 0 1 1 .68-.68l1 1 1.762-1.762a.481.481 0 0 1 .68.68l-2.1 2.1a.48.48 0 0 1-.683.002M18.716 15.937H6.41a.65.65 0 0 0-.649.649v3.829a11.3 11.3 0 0 0 1.3 2.424v-5.6h11.655a.65.65 0 0 0 0-1.3Zm0 0",
  className: "px-project-type_svg__p"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.767 15.937H6.41a.65.65 0 0 0-.649.649v3.829a11.3 11.3 0 0 0 1.3 2.424v-5.6h4.709a.65.65 0 0 1 0-1.3Zm0 0",
  className: "px-project-type_svg__h"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.05 26.349a11.33 11.33 0 0 0 10.531 0Zm0 0",
  className: "px-project-type_svg__n"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.258 26.349H11.05a11.2 11.2 0 0 0 3.146 1.1.6.6 0 0 1 .062-1.1m0 0",
  className: "px-project-type_svg__o"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.145 19.812v4.707a.28.28 0 0 0 .278.278h2.457a.28.28 0 0 0 .278-.278v-4.707Zm0 0",
  className: "px-project-type_svg__h"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.36 24.519v-4.707h-1.214v4.707a.28.28 0 0 0 .278.278h1.214a.28.28 0 0 1-.278-.278m0 0",
  className: "px-project-type_svg__i"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.881 18.688h-2.457a.28.28 0 0 0-.278.278v.942h3.014v-.942a.28.28 0 0 0-.279-.278m0 0",
  className: "px-project-type_svg__b"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.642 18.688h-1.218a.28.28 0 0 0-.278.278v.942h1.218v-.942a.28.28 0 0 1 .278-.278m0 0",
  className: "px-project-type_svg__m"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.254 11.46v1.918a.28.28 0 0 0 .278.278h2.458a.28.28 0 0 0 .278-.278V11.46Zm0 0",
  className: "px-project-type_svg__h"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.468 13.378V11.46h-1.214v1.918a.28.28 0 0 0 .278.278h1.214a.28.28 0 0 1-.278-.278m0 0",
  className: "px-project-type_svg__i"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.989 10.335h-2.457a.28.28 0 0 0-.278.278v.942h3.014v-.942a.28.28 0 0 0-.279-.278m0 0",
  className: "px-project-type_svg__b"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.75 10.335h-1.218a.28.28 0 0 0-.278.278v.942h1.218v-.942a.28.28 0 0 1 .278-.278m0 0",
  className: "px-project-type_svg__m"
}), /*#__PURE__*/React.createElement("path", {
  d: "m19.907 6.19-1.684-1.687a.65.65 0 0 0-.918 0l-8.534 8.534a.65.65 0 0 0 .918.918l8.075-8.075 1.212 1.212a.666.666 0 0 1 .935-.9Zm0 0",
  className: "px-project-type_svg__f"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.76 6.853a.65.65 0 0 1-.649-.649V4.649a.65.65 0 1 1 1.3 0V6.2a.65.65 0 0 1-.651.653m0 0",
  className: "px-project-type_svg__g"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.76 5.58a.65.65 0 0 1-.649-.649v1.273a.65.65 0 1 0 1.3 0V4.931a.65.65 0 0 1-.651.649m0 0",
  className: "px-project-type_svg__e"
}));

const SvgPxPropertyAgency = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57655"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57556"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#6dcca0",
  d: "M18.721 6.602h3.882v11.484h-3.882Z",
  "data-name": "Path 71982"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f7e07f",
  d: "M11.86 4h4.108v14.087H11.86Z",
  "data-name": "Path 71983"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#ccb969",
  "data-name": "Group 57545"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57543"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.257 5.799h-.7a.11.11 0 0 1-.111-.111v-.7a.11.11 0 0 1 .111-.111h.7a.11.11 0 0 1 .111.111v.7a.11.11 0 0 1-.111.111",
  "data-name": "Path 71984"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.263 7.49h-.7a.11.11 0 0 1-.111-.111v-.7a.11.11 0 0 1 .111-.111h.7a.11.11 0 0 1 .111.111v.7a.11.11 0 0 1-.111.111",
  "data-name": "Path 71985"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.269 9.182h-.7a.11.11 0 0 1-.111-.111v-.7a.11.11 0 0 1 .111-.111h.7a.11.11 0 0 1 .111.111v.7a.11.11 0 0 1-.111.111",
  "data-name": "Path 71986"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.274 10.873h-.7a.11.11 0 0 1-.113-.114v-.7a.11.11 0 0 1 .111-.111h.7a.11.11 0 0 1 .111.111v.7a.11.11 0 0 1-.109.114",
  "data-name": "Path 71987"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57544"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.257 12.668h-.7a.11.11 0 0 1-.111-.111v-.7a.11.11 0 0 1 .111-.111h.7a.11.11 0 0 1 .111.111v.7a.11.11 0 0 1-.111.111",
  "data-name": "Path 71988"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.263 14.36h-.7a.11.11 0 0 1-.111-.111v-.7a.11.11 0 0 1 .111-.111h.7a.11.11 0 0 1 .111.111v.7a.11.11 0 0 1-.111.111",
  "data-name": "Path 71989"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.269 16.055h-.7a.11.11 0 0 1-.111-.111v-.7a.11.11 0 0 1 .111-.111h.7a.11.11 0 0 1 .111.111v.7a.11.11 0 0 1-.111.111",
  "data-name": "Path 71990"
}))), /*#__PURE__*/React.createElement("g", {
  fill: "#59a682",
  "data-name": "Group 57548"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57546"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21.114 8.365h-.7a.11.11 0 0 1-.111-.111v-.7a.11.11 0 0 1 .111-.111h.7a.11.11 0 0 1 .111.111v.7a.11.11 0 0 1-.111.111",
  "data-name": "Path 71991"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.123 10.056h-.7a.11.11 0 0 1-.111-.111v-.7a.11.11 0 0 1 .111-.111h.7a.11.11 0 0 1 .111.111v.7a.11.11 0 0 1-.111.111",
  "data-name": "Path 71992"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.128 11.748h-.7a.11.11 0 0 1-.111-.111v-.7a.11.11 0 0 1 .111-.111h.7a.11.11 0 0 1 .111.111v.7a.11.11 0 0 1-.111.111",
  "data-name": "Path 71993"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.133 13.439h-.7a.11.11 0 0 1-.111-.111v-.7a.11.11 0 0 1 .111-.111h.7a.11.11 0 0 1 .111.111v.7a.11.11 0 0 1-.111.111",
  "data-name": "Path 71994"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57547"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21.114 15.238h-.7a.11.11 0 0 1-.111-.111v-.7a.11.11 0 0 1 .111-.111h.7a.11.11 0 0 1 .111.111v.7a.11.11 0 0 1-.111.111",
  "data-name": "Path 71995"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.123 16.929h-.7a.11.11 0 0 1-.111-.111v-.7a.11.11 0 0 1 .111-.111h.7a.11.11 0 0 1 .111.111v.7a.11.11 0 0 1-.111.111",
  "data-name": "Path 71996"
}))), /*#__PURE__*/React.createElement("path", {
  fill: "#dd8793",
  d: "M15.306 8.966h4.108v9.12h-4.108Z",
  "data-name": "Path 71997"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57555"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#b36d76",
  "data-name": "Group 57551"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57549"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.955 10.705h-.7a.11.11 0 0 1-.111-.111v-.7a.11.11 0 0 1 .111-.111h.7a.11.11 0 0 1 .111.111v.7a.11.11 0 0 1-.111.111",
  "data-name": "Path 71998"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.961 12.397h-.7a.11.11 0 0 1-.111-.111v-.7a.11.11 0 0 1 .111-.111h.7a.11.11 0 0 1 .111.111v.7a.11.11 0 0 1-.111.111",
  "data-name": "Path 71999"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.966 14.088h-.7a.11.11 0 0 1-.111-.111v-.7a.11.11 0 0 1 .111-.111h.7a.11.11 0 0 1 .111.111v.7a.11.11 0 0 1-.111.111",
  "data-name": "Path 72000"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57550"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.456 10.705h-.7a.11.11 0 0 1-.111-.111v-.7a.11.11 0 0 1 .111-.111h.7a.11.11 0 0 1 .111.111v.7a.11.11 0 0 1-.111.111",
  "data-name": "Path 72001"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.462 12.397h-.7a.11.11 0 0 1-.111-.111v-.7a.11.11 0 0 1 .111-.111h.7a.11.11 0 0 1 .111.111v.7a.11.11 0 0 1-.111.111",
  "data-name": "Path 72002"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.467 14.088h-.7a.11.11 0 0 1-.111-.111v-.7a.11.11 0 0 1 .111-.111h.7a.11.11 0 0 1 .111.111v.7a.11.11 0 0 1-.111.111",
  "data-name": "Path 72003"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57554"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57552"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#b36d76",
  d: "M16.955 15.862h-.7a.11.11 0 0 1-.111-.111v-.7a.11.11 0 0 1 .111-.111h.7a.11.11 0 0 1 .111.111v.7a.11.11 0 0 1-.111.111",
  "data-name": "Path 72004"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57553"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#b36d76",
  d: "M18.456 15.862h-.7a.11.11 0 0 1-.111-.111v-.7a.11.11 0 0 1 .111-.111h.7a.11.11 0 0 1 .111.111v.7a.11.11 0 0 1-.111.111",
  "data-name": "Path 72005"
}))))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57565"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#8f4c2e",
  d: "M4.888 8.704a3.7 3.7 0 0 1-.119-1.548 1.9 1.9 0 0 1 .39-.691q.051-.062.105-.12a3.8 3.8 0 0 1 1.793-.938 3.6 3.6 0 0 1 1.079-.093 3 3 0 0 1 .607.1.7.7 0 0 1 .416.279 4.5 4.5 0 0 0 .254.511c.136.161.321.257.46.414a1.6 1.6 0 0 1 .4.836 1.3 1.3 0 0 1-.2.741 5 5 0 0 1-.286.51z",
  "data-name": "Path 72006"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57557"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#f0c0aa",
  d: "M5.894 13.312a2.3 2.3 0 0 0 .221-.875 1.3 1.3 0 0 0-.068-.432v-.975h2.439l.032 1.057a1 1 0 0 0-.032.3 2.2 2.2 0 0 0 .255.928v1.6H5.894Z",
  "data-name": "Path 72007"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#f9c7b2",
  d: "M9.78 8.705V9.85a2.46 2.46 0 1 1-4.895 0V8.705a3.7 3.7 0 0 0 .626-.56 3.89 3.89 0 0 0 3.657.045 3.7 3.7 0 0 0 .612.515",
  "data-name": "Path 72008"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#354458",
  d: "M12.636 19.461H1.998a18.8 18.8 0 0 1 .4-4.2 3.4 3.4 0 0 1 .355-.855 3.16 3.16 0 0 1 1.133-1.1 3 3 0 0 1 .434-.2l1.826 1.985 1.132-.8 1.132.8 1.848-2a3 3 0 0 1 .486.217 3.16 3.16 0 0 1 1.133 1.1 3.4 3.4 0 0 1 .355.855 18.8 18.8 0 0 1 .404 4.198",
  "data-name": "Path 72009"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57561"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57560"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57558"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#2a3747",
  d: "M4.13 16.691v2.77h-.319v-2.77a.16.16 0 0 1 .319 0",
  "data-name": "Path 72010"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57559"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#2a3747",
  d: "M10.824 16.691v2.77h-.319v-2.77a.16.16 0 0 1 .319 0",
  "data-name": "Path 72011"
})))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57562"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#d35f4c",
  d: "m6.545 14.79.735-.5.732.474-.451.779h-.586Z",
  "data-name": "Path 72012"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57563"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#e66753",
  d: "m8.098 19.461-.536-3.916h-.586l-.536 3.916Z",
  "data-name": "Path 72013"
})), /*#__PURE__*/React.createElement("g", {
  fill: "#2a3747",
  "data-name": "Group 57564"
}, /*#__PURE__*/React.createElement("path", {
  d: "m7.281 14.292 1.934-1.356a2.9 2.9 0 0 1 1.047.149l-1.848 2Z",
  "data-name": "Path 72014"
}), /*#__PURE__*/React.createElement("path", {
  d: "m7.28 14.293-1.132.8-1.826-1.985a2.85 2.85 0 0 1 1.1-.167Z",
  "data-name": "Path 72015"
})))));

const SvgPxPropertyTitle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "#ddeafb",
  "data-name": "Group 50353"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.917 21.515 7.843 24.686a.44.44 0 0 1-.5-.363L4.862 7.541a.44.44 0 0 1 .363-.5l11.074-1.783a.44.44 0 0 1 .5.363l2.479 15.394a.44.44 0 0 1-.363.5Z",
  "data-name": "Path 65107"
}), /*#__PURE__*/React.createElement("path", {
  d: "m13.082 21.515 11.074 3.171a.44.44 0 0 0 .5-.363l2.479-16.782a.44.44 0 0 0-.363-.5l-11.07-1.785a.44.44 0 0 0-.5.363l-2.479 15.394a.44.44 0 0 0 .363.5Z",
  "data-name": "Path 65108"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.917 21.515 7.843 24.686a.44.44 0 0 1-.5-.363L4.862 7.541a.44.44 0 0 1 .363-.5l11.074-1.783a.44.44 0 0 1 .5.363l2.479 15.394a.44.44 0 0 1-.363.5Z",
  "data-name": "Path 65109"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#cbe2ff",
  d: "M16.801 5.62a.44.44 0 0 0-.5-.363l-7.26 1.169v15.619c0 .279.226 1.43.5 1.43h4.28l5.093-1.958a.44.44 0 0 0 .363-.5Z",
  "data-name": "Path 65110"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#cbe2ff",
  d: "M15.702 5.257a.44.44 0 0 0-.5.363l-2.479 15.394a.44.44 0 0 0 .363.5l5.093 1.958h4.28c.279 0 .5-1.151.5-1.43V6.426Z",
  "data-name": "Path 65111"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f4fbff",
  d: "M21.608 21.305H10.391a.44.44 0 0 1-.438-.438V5.274a.44.44 0 0 1 .438-.438h11.216a.44.44 0 0 1 .438.438v15.592a.44.44 0 0 1-.437.439",
  "data-name": "Path 65112"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e4f6ff",
  d: "M21.608 4.836H20.52a.44.44 0 0 1 .438.438v15.592a.44.44 0 0 1-.438.438h1.088a.44.44 0 0 0 .438-.438V5.274a.44.44 0 0 0-.438-.438",
  "data-name": "Path 65113"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#698ed5",
  d: "m19.195 18.304-.344.922a.71.71 0 0 1-.664.461h-4.375a.71.71 0 0 1-.664-.461l-.344-.922a.71.71 0 0 0-.664-.461h-7.3a.34.34 0 0 0-.339.339v6.07a2.91 2.91 0 0 0 2.912 2.912h17.173a2.91 2.91 0 0 0 2.915-2.907v-6.07a.34.34 0 0 0-.339-.339h-7.3a.71.71 0 0 0-.667.456",
  "data-name": "Path 65114"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#4073c8",
  "data-name": "Group 50354"
}, /*#__PURE__*/React.createElement("path", {
  d: "m11.409 18.304.344.922a.71.71 0 0 0 .664.461h1.4a.71.71 0 0 1-.664-.461l-.344-.922a.71.71 0 0 0-.664-.461h-1.4a.71.71 0 0 1 .664.461",
  "data-name": "Path 65115"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.103 17.843v6.41a2.91 2.91 0 0 1-2.912 2.912h1.4a2.91 2.91 0 0 0 2.912-2.912v-6.07a.34.34 0 0 0-.339-.339Z",
  "data-name": "Path 65116"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#3b66c1",
  d: "M19.958 23.595h-7.917a.253.253 0 0 1-.253-.253v-1.7a.253.253 0 0 1 .253-.253h7.917a.253.253 0 0 1 .253.253v1.7a.253.253 0 0 1-.253.253",
  "data-name": "Path 65117"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#30579d",
  d: "M19.957 21.393h-1.043a.253.253 0 0 1 .253.253v1.7a.253.253 0 0 1-.253.253h1.043a.253.253 0 0 0 .253-.253v-1.7a.253.253 0 0 0-.253-.253",
  "data-name": "Path 65118"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 50370"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 50357"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 50355"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#30579d",
  d: "M13.18 7.764h-1.284a.347.347 0 1 1 0-.694h1.284a.347.347 0 1 1 0 .694",
  "data-name": "Path 65119"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 50356"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#30579d",
  d: "M20.103 7.764h-4.985a.347.347 0 1 1 0-.694h4.985a.347.347 0 0 1 0 .694",
  "data-name": "Path 65120"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 50360"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 50358"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#30579d",
  d: "M13.18 9.753h-1.284a.347.347 0 1 1 0-.694h1.284a.347.347 0 1 1 0 .694",
  "data-name": "Path 65121"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 50359"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#30579d",
  d: "M20.103 9.753h-4.985a.347.347 0 1 1 0-.694h4.985a.347.347 0 0 1 0 .694",
  "data-name": "Path 65122"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 50363"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 50361"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#30579d",
  d: "M13.18 11.745h-1.284a.347.347 0 1 1 0-.694h1.284a.347.347 0 1 1 0 .694",
  "data-name": "Path 65123"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 50362"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#30579d",
  d: "M20.103 11.745h-4.985a.347.347 0 1 1 0-.694h4.985a.347.347 0 1 1 0 .694",
  "data-name": "Path 65124"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 50366"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 50364"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#30579d",
  d: "M13.18 13.737h-1.284a.347.347 0 0 1 0-.694h1.284a.347.347 0 0 1 0 .694",
  "data-name": "Path 65125"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 50365"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#30579d",
  d: "M20.103 13.737h-4.985a.347.347 0 0 1 0-.694h4.985a.347.347 0 0 1 0 .694",
  "data-name": "Path 65126"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 50369"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 50367"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#30579d",
  d: "M13.18 15.73h-1.284a.347.347 0 1 1 0-.694h1.284a.347.347 0 1 1 0 .694",
  "data-name": "Path 65127"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 50368"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#30579d",
  d: "M20.103 15.73h-4.985a.347.347 0 1 1 0-.694h4.985a.347.347 0 1 1 0 .694",
  "data-name": "Path 65128"
})))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 50371"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#30579d",
  d: "M18.631 25.755h-5.263a.347.347 0 1 1 0-.694h5.263a.347.347 0 1 1 0 .694",
  "data-name": "Path 65129"
})));

const SvgPxPropertyType = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".px-property-type_svg__c{fill:#e4e4e3}.px-property-type_svg__d{fill:#0093b9}.px-property-type_svg__e{fill:#2da4c4}.px-property-type_svg__f{fill:#cacac9}.px-property-type_svg__g{fill:#fbbe1f}.px-property-type_svg__h{fill:#5db9d2}.px-property-type_svg__i{fill:#85bb40}")), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h32v32H0z",
  style: {
    fill: "none"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M56 114.271V112h3.028l1.514 1.514v.757Z",
  style: {
    fill: "#b3b1b3"
  },
  transform: "translate(-49.107 -103.215)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.893 18.627h5.678v7.949H6.893Z",
  className: "px-property-type_svg__c"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.379 10.299h11.356v9.085H5.379Z",
  className: "px-property-type_svg__c"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.893 11.814h9.842v6.056H6.893Z",
  className: "px-property-type_svg__d"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.65 12.571h2.271v4.542H7.65ZM10.678 12.571h5.3v4.542h-5.3Z",
  className: "px-property-type_svg__e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.893 19.384h5.678v.757H6.893Z",
  className: "px-property-type_svg__f"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.028 20.898h.757v.757h-.757Z",
  className: "px-property-type_svg__g"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.542 19.384h1.136v7.192H9.542Z",
  className: "px-property-type_svg__f"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.22 6.893h10.6v19.684h-10.6Z",
  className: "px-property-type_svg__d"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.113 9.542h2.271v2.271h-2.271ZM21.655 9.542h2.271v2.271h-2.271ZM21.655 13.706h2.271v2.271h-2.271ZM21.655 17.87h2.271v2.271h-2.271Z",
  className: "px-property-type_svg__h"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.955 7.65h-12.87V6.136L26.955 5Z",
  className: "px-property-type_svg__g"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.113 13.706h2.271v2.271h-2.271Z",
  className: "px-property-type_svg__h"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.141 18.627v7.949h-9.842v-7.949l4.921-1.893Z",
  className: "px-property-type_svg__c"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.141 18.627v1.4l-4.921-2.153-4.921 2.148v-1.4l4.921-1.888Z",
  className: "px-property-type_svg__f"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.192 21.277h2.271v5.3h-2.271ZM15.977 22.034h2.271v1.893h-2.271Z",
  className: "px-property-type_svg__d"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.949 19.384h.757v.757h-.757Z",
  className: "px-property-type_svg__g"
}), /*#__PURE__*/React.createElement("path", {
  d: "m9.164 17.87 6.057-2.65 6.057 2.65v1.893l-6.057-2.65-6.057 2.649ZM20.899 22.412c-.757 0-1.136.757-1.136 1.514s-.757.757-.757 1.525a1.19 1.19 0 0 0 1.136 1.125h1.514a1.19 1.19 0 0 0 1.136-1.125c0-.768-.757-.768-.757-1.525s-.379-1.514-1.136-1.514",
  className: "px-property-type_svg__i"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5 26.198h22.712v.757H5Z",
  className: "px-property-type_svg__f"
}));

const SvgPxPublic = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".px-public_svg__b{fill:#e1f3ff}.px-public_svg__f{fill:#d0ee7f}.px-public_svg__g{fill:#6b46cf}")), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h32v32H0z",
  style: {
    fill: "none"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.975 26.888H6.8a1.8 1.8 0 0 1-1.8-1.8V8.662a1.8 1.8 0 0 1 1.8-1.8h18.175a1.8 1.8 0 0 1 1.8 1.8v16.422a1.8 1.8 0 0 1-1.8 1.804",
  className: "px-public_svg__b"
}), /*#__PURE__*/React.createElement("path", {
  d: "M417.585 40h-1.753a1.8 1.8 0 0 1 1.8 1.8v16.422a1.8 1.8 0 0 1-1.8 1.8h1.753a1.8 1.8 0 0 0 1.8-1.8V41.8a1.8 1.8 0 0 0-1.8-1.8",
  style: {
    fill: "#ccebff"
  },
  transform: "translate(-392.61 -33.138)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.779 44.857H0V41.8A1.8 1.8 0 0 1 1.8 40h18.175a1.8 1.8 0 0 1 1.8 1.8Z",
  style: {
    fill: "#fe75a7"
  },
  transform: "translate(5 -33.138)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M417.585 40h-1.753a1.8 1.8 0 0 1 1.8 1.8v3.052h1.753V41.8a1.8 1.8 0 0 0-1.8-1.8",
  style: {
    fill: "#fe5995"
  },
  transform: "translate(-392.61 -33.138)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.984 18.783H7.612a1.2 1.2 0 1 1 0-2.393h16.372a1.2 1.2 0 1 1 0 2.393M12.772 22.184h-5.16a1.2 1.2 0 1 1 0-2.393h5.16a1.2 1.2 0 1 1 0 2.393M23.984 15.381h-5.159a1.2 1.2 0 1 1 0-2.393h5.159a1.2 1.2 0 1 1 0 2.393",
  className: "px-public_svg__f"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.906 13.855h-.994a.329.329 0 0 0 0 .657h.994a.329.329 0 0 0 0-.657M12.607 13.855h-.994a.329.329 0 0 0 0 .657h.994a.329.329 0 0 0 0-.657M16.361 13.855h-.994a.329.329 0 0 0 0 .657h.994a.329.329 0 0 0 0-.657M20.115 13.855h-.994a.329.329 0 0 0 0 .657h.994a.329.329 0 0 0 0-.657M22.875 14.513h.994a.329.329 0 1 0 0-.657h-.994a.329.329 0 0 0 0 .657M8.906 17.258h-.994a.329.329 0 1 0 0 .657h.994a.329.329 0 1 0 0-.657M12.607 17.258h-.994a.329.329 0 1 0 0 .657h.994a.329.329 0 1 0 0-.657M16.361 17.258h-.994a.329.329 0 1 0 0 .657h.994a.329.329 0 1 0 0-.657M20.115 17.258h-.994a.329.329 0 0 0 0 .657h.994a.329.329 0 0 0 0-.657M23.869 17.258h-.994a.329.329 0 1 0 0 .657h.994a.329.329 0 1 0 0-.657M8.906 20.659h-.994a.329.329 0 1 0 0 .657h.994a.329.329 0 1 0 0-.657M12.607 20.659h-.994a.329.329 0 1 0 0 .657h.994a.329.329 0 1 0 0-.657M16.361 20.659h-.994a.329.329 0 1 0 0 .657h.994a.329.329 0 1 0 0-.657M20.115 20.659h-.994a.329.329 0 1 0 0 .657h.994a.329.329 0 1 0 0-.657M23.869 20.659h-.994a.329.329 0 1 0 0 .657h.994a.329.329 0 1 0 0-.657M8.906 24.061h-.994a.329.329 0 0 0 0 .657h.994a.329.329 0 0 0 0-.657M12.607 24.061h-.994a.329.329 0 0 0 0 .657h.994a.329.329 0 0 0 0-.657M16.361 24.061h-.994a.329.329 0 0 0 0 .657h.994a.329.329 0 0 0 0-.657M20.115 24.061h-.994a.329.329 0 0 0 0 .657h.994a.329.329 0 0 0 0-.657M23.869 24.061h-.994a.329.329 0 1 0 0 .657h.994a.329.329 0 1 0 0-.657",
  className: "px-public_svg__g"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.073 8.962a.76.76 0 0 1-.76-.76V5.869a.76.76 0 0 1 1.52 0v2.333a.76.76 0 0 1-.76.76M22.707 8.962a.76.76 0 0 1-.76-.76V5.869a.76.76 0 0 1 1.52 0v2.333a.76.76 0 0 1-.76.76",
  className: "px-public_svg__b"
}));

const SvgPxPurchaserAccount = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-5.904 5)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#4ce088",
  d: "M11.6 15.472h20.6a10.906 10.906 0 1 0-20.6 0",
  "data-name": "Path 71734"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#d3dcfb",
  d: "M11.602 3.528v11.944a10.94 10.94 0 0 0 4.19 5.446h12.223a10.94 10.94 0 0 0 4.191-5.447V3.528Z",
  "data-name": "Path 71735"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#bec8f7",
  d: "M11.602 15.472a10.94 10.94 0 0 0 4.19 5.446h4.569V7.608a1.168 1.168 0 0 1-1.162-1.512c-1.572-.69-.743-2.479-.743-2.479a1 1 0 0 1-.112-.089h-6.742Z",
  "data-name": "Path 71736"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e9efff",
  d: "M16.693 2.291a1.326 1.326 0 0 1-1.326 1.326h16.839V2.291Z",
  "data-name": "Path 71737"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#d3dcfb",
  d: "M15.367 3.621h3.088a.852.852 0 0 1-.245-1.246 1 1 0 0 1-.071-.079h-1.446a1.326 1.326 0 0 1-1.326 1.325",
  "data-name": "Path 71738"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4fabf7",
  d: "M11.602 2.291v1.33h3.854a1.326 1.326 0 0 0 1.326-1.326Z",
  "data-name": "Path 71739"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3c58a0",
  d: "M31.447 0H12.361a.76.76 0 0 0-.759.759V2.37h20.6V.759A.76.76 0 0 0 31.447 0",
  "data-name": "Path 71740"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2a428c",
  d: "M18.21 0h-5.85a.76.76 0 0 0-.759.759V2.37h6.609a.577.577 0 0 1-.07-.851V.851A.572.572 0 0 1 18.21 0",
  "data-name": "Path 71741"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 0.467,
  cy: 0.467,
  r: 0.467,
  fill: "#ff4155",
  "data-name": "Ellipse 1445",
  transform: "translate(13.101 .718)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 0.467,
  cy: 0.467,
  r: 0.467,
  fill: "#ffdd40",
  "data-name": "Ellipse 1446",
  transform: "translate(14.474 .718)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 0.467,
  cy: 0.467,
  r: 0.467,
  fill: "#4ce088",
  "data-name": "Ellipse 1447",
  transform: "translate(15.847 .718)"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57432"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#1c2e7a",
  d: "M28.003 1.519h-9.862a.334.334 0 0 1 0-.668h9.862a.334.334 0 0 1 0 .668",
  "data-name": "Path 71742"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57433"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#1c2e7a",
  d: "M30.409 1.519h-.851a.334.334 0 0 1 0-.668h.851a.334.334 0 0 1 0 .668",
  "data-name": "Path 71743"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#e9efff",
  d: "m15.9 20.99 12.228-.15a8.848 8.848 0 1 0-12.233.152Z",
  "data-name": "Path 71744"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#d3dcfb",
  d: "M15.828 20.918h4.537V7.608a1.163 1.163 0 0 1-1.165-1.5 8.848 8.848 0 0 0-3.371 14.81Z",
  "data-name": "Path 71745"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57434"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fcad6d",
  d: "M20.379 17.799a2.49 2.49 0 0 0 3.049 0 4.8 4.8 0 0 0 .967-1.02q-.121-.035-.245-.066a.4.4 0 0 1-.228-.154 2.47 2.47 0 0 1-.325-1.262 3.6 3.6 0 0 1-.522.5 1.915 1.915 0 0 1-2.344 0 3.6 3.6 0 0 1-.522-.5 2.4 2.4 0 0 1-.341 1.285.35.35 0 0 1-.193.127q-.133.033-.264.071a4.8 4.8 0 0 0 .968 1.019",
  "data-name": "Path 71746"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#fd995b",
  d: "M21.885 16.193a1.9 1.9 0 0 1-1.153-.4 3.6 3.6 0 0 1-.522-.5 2.4 2.4 0 0 1-.341 1.285.35.35 0 0 1-.193.126q-.133.033-.264.071a4.8 4.8 0 0 0 .967 1.021 2.5 2.5 0 0 0 .586.337 3.1 3.1 0 0 0 .92-1.94",
  "data-name": "Path 71747"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57435"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#2a428c",
  d: "M21.338 7.28c-1.7.232-1.863 1.2-1.864 1.551a.2.2 0 0 1-.108.176c-.885.431-.408 2.506-.408 2.506a1 1 0 0 1 .292.116 1.5 1.5 0 0 1 .084-.311 1.3 1.3 0 0 1 .114-.227.7.7 0 0 0 .107-.427c-.032-.433-.057-1.246.515-1.5a2.1 2.1 0 0 1 1.457.034 1.2 1.2 0 0 0 .758 0 2.1 2.1 0 0 1 1.457-.034c.57.256.546 1.065.515 1.5a.7.7 0 0 0 .107.43 1.3 1.3 0 0 1 .117.235 1.5 1.5 0 0 1 .081.3.8.8 0 0 1 .36-.114c.013-.454.055-.943.055-.943.502-2.471-1.807-3.542-3.639-3.292",
  "data-name": "Path 71748"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1c2e7a",
  d: "M21.338 7.279c-1.7.232-1.863 1.2-1.864 1.551a.2.2 0 0 1-.108.176c-.885.431-.408 2.506-.408 2.506a1 1 0 0 1 .292.116 1.5 1.5 0 0 1 .084-.31 1.3 1.3 0 0 1 .114-.227.7.7 0 0 0 .107-.427c-.032-.433-.057-1.246.515-1.5a2.1 2.1 0 0 1 1.457.034 1.2 1.2 0 0 0 .287.058 1 1 0 0 0-.062-.088 1.45 1.45 0 0 1 .186-1.919 4 4 0 0 0-.6.03",
  "data-name": "Path 71749"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#fcad6d",
  d: "M25.071 11.572a.48.48 0 0 0-.511.014 1.6 1.6 0 0 1 0 .472l-.135.981q0 .119-.007.233c.328.1.492-.2.519-.4a1.5 1.5 0 0 1 .058-.257c.093-.27.408-.738.076-1.043",
  "data-name": "Path 71750"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fd995b",
  d: "M18.738 11.572a.48.48 0 0 1 .511.014 1.6 1.6 0 0 0 0 .472l.135.981q-.002.119.007.233c-.328.1-.492-.2-.519-.4a1.5 1.5 0 0 0-.058-.257c-.092-.27-.408-.738-.076-1.043",
  "data-name": "Path 71751"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f9ba8f",
  d: "M24.519 11.283a1.3 1.3 0 0 0-.117-.235.7.7 0 0 1-.107-.43c.031-.434.015-1.283-.555-1.54a2.1 2.1 0 0 0-1.457.034 1.2 1.2 0 0 1-.758 0 2.1 2.1 0 0 0-1.457-.034c-.571.257-.587 1.11-.555 1.543a.7.7 0 0 1-.107.427 1.3 1.3 0 0 0-.114.227 1.57 1.57 0 0 0-.089.783l.135.981a3.6 3.6 0 0 0 1.394 2.867 1.914 1.914 0 0 0 2.344 0 3.6 3.6 0 0 0 1.394-2.867l.135-.981a1.6 1.6 0 0 0-.086-.775",
  "data-name": "Path 71752"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57436"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fcad6d",
  d: "M22.558 15.907a3.6 3.6 0 0 1-1.394-2.867l-.135-.981a1.57 1.57 0 0 1 .089-.783 1.3 1.3 0 0 1 .114-.227.7.7 0 0 0 .107-.427 1.75 1.75 0 0 1 .412-1.458 1.2 1.2 0 0 1-.225-.051 2.1 2.1 0 0 0-1.457-.034c-.572.257-.587 1.11-.555 1.543a.7.7 0 0 1-.107.427 1.3 1.3 0 0 0-.114.227 1.57 1.57 0 0 0-.089.783l.135.981a3.6 3.6 0 0 0 1.394 2.867 1.92 1.92 0 0 0 2.085.169 2 2 0 0 1-.26-.169",
  "data-name": "Path 71753"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#3c58a0",
  d: "M26.635 17.726a1.35 1.35 0 0 1-.593-.248 7.6 7.6 0 0 0-1.7-.714 4.6 4.6 0 0 1-.953 1.009 2.43 2.43 0 0 1-2.973 0 4.6 4.6 0 0 1-.953-1.009 7.7 7.7 0 0 0-1.7.714 1.35 1.35 0 0 1-.593.248 2.57 2.57 0 0 0-2.336 1.989l-.019.065a9 9 0 0 0 1.084 1.213 10.91 10.91 0 0 0 12.227-.152 9 9 0 0 0 .877-1l-.037-.128a2.57 2.57 0 0 0-2.331-1.987",
  "data-name": "Path 71754"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2a428c",
  d: "M20.418 17.773a4.6 4.6 0 0 1-.953-1.009 7.7 7.7 0 0 0-1.7.714 1.35 1.35 0 0 1-.593.248 2.57 2.57 0 0 0-2.336 1.989l-.019.065a9 9 0 0 0 1.084 1.213 11 11 0 0 0 1.783.952c.027-2.086.343-2.533 2.313-3.236a2.8 2.8 0 0 0 1-.6 2.4 2.4 0 0 1-.579-.336",
  "data-name": "Path 71755"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4fabf7",
  d: "m28.666 8.238-.229.265a.22.22 0 0 0-.041.209l.11.332a.216.216 0 0 1-.108.261l-.313.157a.22.22 0 0 0-.118.177l-.026.349a.216.216 0 0 1-.2.2l-.349.026a.22.22 0 0 0-.177.118l-.157.313a.216.216 0 0 1-.261.108l-.332-.11a.22.22 0 0 0-.209.041l-.265.229a.216.216 0 0 1-.282 0l-.265-.229a.22.22 0 0 0-.209-.041l-.332.11a.216.216 0 0 1-.261-.108l-.157-.313a.22.22 0 0 0-.177-.118l-.349-.026a.216.216 0 0 1-.2-.2l-.026-.349a.22.22 0 0 0-.118-.177l-.313-.157a.216.216 0 0 1-.108-.261l.11-.332a.22.22 0 0 0-.041-.209l-.229-.265a.216.216 0 0 1 0-.282l.229-.265a.22.22 0 0 0 .041-.209l-.11-.332a.216.216 0 0 1 .108-.261l.313-.157a.22.22 0 0 0 .118-.177l.026-.349a.216.216 0 0 1 .2-.2l.349-.026a.22.22 0 0 0 .177-.118l.157-.313a.216.216 0 0 1 .261-.108l.332.11a.22.22 0 0 0 .209-.041l.265-.229a.216.216 0 0 1 .282 0l.265.229a.22.22 0 0 0 .209.041l.332-.11a.216.216 0 0 1 .261.108l.157.313a.22.22 0 0 0 .177.118l.349.026a.216.216 0 0 1 .2.2l.026.349a.22.22 0 0 0 .118.177l.313.157a.216.216 0 0 1 .108.261l-.11.332a.22.22 0 0 0 .041.209l.229.265a.216.216 0 0 1 0 .282",
  "data-name": "Path 71756"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1886ea",
  d: "m25.235 5.552-.332-.11a.216.216 0 0 0-.261.108l-.157.313a.22.22 0 0 1-.177.118l-.349.026a.216.216 0 0 0-.2.2l-.026.349a.22.22 0 0 1-.118.177l-.313.157a.216.216 0 0 0-.108.261l.11.332a.22.22 0 0 1-.041.209l-.229.265a.216.216 0 0 0 0 .282l.229.265a.22.22 0 0 1 .041.209l-.11.332a.216.216 0 0 0 .108.261l.313.157a.22.22 0 0 1 .118.177l.026.349a.216.216 0 0 0 .2.2l.349.026a.22.22 0 0 1 .177.118l.157.313a.216.216 0 0 0 .261.108l.332-.11a.22.22 0 0 1 .209.041l.265.229a.216.216 0 0 0 .282 0l.265-.229a.22.22 0 0 1 .209-.041l.332.11a.216.216 0 0 0 .261-.108l.157-.313a.22.22 0 0 1 .177-.118l.349-.026a.216.216 0 0 0 .2-.2c-1.766-.315-1.215-1.675-1.215-1.675l-.386-.616c-1.694-.433-.9-2.186-.9-2.186a.22.22 0 0 1-.205.04",
  "data-name": "Path 71757"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57437"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#e9efff",
  d: "M25.693 9.194a.36.36 0 0 1-.251-.1l-.786-.786a.354.354 0 1 1 .5-.5l.535.535 1.016-1.016a.354.354 0 1 1 .5.5L25.94 9.094a.35.35 0 0 1-.247.1",
  "data-name": "Path 71758"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#2a428c",
  d: "M27.155 21.441a2.74 2.74 0 0 0-.729-1.672.332.332 0 0 0-.57.233v2.046a11 11 0 0 0 1.3-.607Z",
  "data-name": "Path 71759"
})));

const SvgPxRace = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".px-race_svg__c{fill:#2ba1cf}.px-race_svg__d{fill:#66baed}.px-race_svg__f{fill:#d8d5d0}.px-race_svg__i{fill:#eab599}.px-race_svg__j{fill:#f6caae}.px-race_svg__k{fill:#3d4159}.px-race_svg__l{fill:#fff}.px-race_svg__m{fill:#bfd5de}.px-race_svg__o{fill:#d3a489}.px-race_svg__p{fill:#f74f4f}.px-race_svg__q{fill:#bf8e75}.px-race_svg__r{fill:#2a2f4f}")), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h32v32H0z",
  style: {
    fill: "none"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.209 12.6a12.6 12.6 0 0 1-8.783 12.014 12.4 12.4 0 0 1-1.817.432H14.6q-.458.073-.926.113l-.2.015q-.141.01-.284.016-.292.014-.586.014t-.6-.014q-.135-.006-.27-.016l-.2-.015q-.479-.04-.948-.116c-.149-.024-.3-.05-.445-.08a12.5 12.5 0 0 1-1.858-.52q-.521-.19-1.02-.424-.17-.08-.338-.165-.43-.218-.841-.467A12.6 12.6 0 1 1 25.209 12.6m0 0",
  style: {
    fill: "#ffe152"
  },
  transform: "translate(3 3.001)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.139 19.358v8.611a12.5 12.5 0 0 1-1.858-.52q-.521-.19-1.02-.424-.17-.08-.338-.165-.43-.218-.841-.467a12.64 12.64 0 0 1-5-5.672v-1.362a3.42 3.42 0 0 1 2.531-3.3q.08-.022.162-.039a3 3 0 0 1 .444-.066q.138-.01.279-.011h2.225a3.4 3.4 0 0 1 .725.077l.04.009.117.029a3.42 3.42 0 0 1 2.532 3.3Zm0 0",
  className: "px-race_svg__c"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.139 19.358v8.611a12.5 12.5 0 0 1-1.858-.52q-.521-.19-1.02-.424-.17-.08-.338-.165-.43-.218-.841-.467a12.7 12.7 0 0 1-3.535-3.188v-3.846a3.42 3.42 0 0 1 2.531-3.3q.08-.022.162-.039a3 3 0 0 1 .444-.066q.138-.01.279-.011h.759a3.4 3.4 0 0 1 .725.077l.04.009.117.029a3.42 3.42 0 0 1 2.532 3.3Zm0 0",
  className: "px-race_svg__d"
}), /*#__PURE__*/React.createElement("path", {
  d: "m77.215 264.4-.008.039-1.022 4.753a.994.994 0 0 1-.967.788H75.2a.994.994 0 0 1-.967-.788l-1.022-4.753-.011-.039Zm0 0",
  style: {
    fill: "#f2f0ec"
  },
  transform: "translate(-66.599 -248.38)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m8.61 17.34-1.538.855-.468-2.176.956-.563M8.61 17.34l1.538.855.468-2.176-.956-.563",
  className: "px-race_svg__f"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.676 57.935v-5.152a4.592 4.592 0 1 1 9.185 0v5.152",
  style: {
    fill: "#cc7a3b"
  },
  transform: "translate(-16.658 -42.818)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.561 52.993a11.3 11.3 0 0 0 1.653 4.951h-3.542v-5.152a4.59 4.59 0 0 1 4.559-4.592c-1.412.035-2.67 2.3-2.67 4.793m0 0",
  style: {
    fill: "#a35418"
  },
  transform: "translate(-16.654 -42.826)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.829 14.62v1.5a1.219 1.219 0 0 1-2.438 0v-1.5Zm0 0",
  className: "px-race_svg__i"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.83 16.026v.095a.881.881 0 1 1-1.707.159q.122.008.245.008a4.2 4.2 0 0 0 1.461-.261ZM5.267 12.174a1.133 1.133 0 1 1-.952-1.119 1.13 1.13 0 0 1 .952 1.119m0 0",
  className: "px-race_svg__j"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.267 12.173a1.13 1.13 0 0 1-.952 1.119 4.24 4.24 0 0 1 0-2.238 1.13 1.13 0 0 1 .952 1.119m0 0",
  className: "px-race_svg__i"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.535 12.173a.405.405 0 1 1-.405-.405.405.405 0 0 1 .405.405m0 0",
  className: "px-race_svg__i"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.521 10.726v3.9a4.2 4.2 0 0 1-2.234 1.111h-.021a4 4 0 0 1-.656.051 4.217 4.217 0 0 1-4.217-4.217V9.965a4 4 0 0 1 .043-.606 2.67 2.67 0 0 0 3.359-.216 2.4 2.4 0 0 0 .634-.99 2.78 2.78 0 0 0 .87 1.737 3.1 3.1 0 0 0 2.222.835Zm0 0",
  className: "px-race_svg__i"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.52 10.727v3.9a4.2 4.2 0 0 1-2.234 1.111h-.021a4.22 4.22 0 0 1-3.56-4.166V9.838a2.64 2.64 0 0 0 2.086-.694 2.4 2.4 0 0 0 .634-.99 2.78 2.78 0 0 0 .87 1.737 3.1 3.1 0 0 0 2.225.836m0 0",
  className: "px-race_svg__j"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.879 11.215a.7.7 0 0 0-1.4 0M7.747 11.215a.7.7 0 1 0-1.4 0",
  className: "px-race_svg__i"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.525 11.513a.478.478 0 1 1-.479-.478.48.48 0 0 1 .479.478M10.653 11.513a.478.478 0 1 1-.478-.478.48.48 0 0 1 .478.478m0 0",
  className: "px-race_svg__k"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.089 12.717h-.957a.206.206 0 1 1 0-.413h.957a.206.206 0 0 1 0 .413M8.611 14.024a2.1 2.1 0 0 1-1.028-.266.188.188 0 1 1 .181-.329 1.75 1.75 0 0 0 1.695 0 .188.188 0 1 1 .181.329 2.1 2.1 0 0 1-1.029.266m0 0",
  className: "px-race_svg__i"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.424 11.429a.205.205 0 1 1-.205-.205.205.205 0 0 1 .205.205M10.58 11.429a.2.2 0 1 1-.2-.205.2.2 0 0 1 .2.205m0 0",
  className: "px-race_svg__l"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.481 12.679a.525.525 0 1 1-.525-.525.525.525 0 0 1 .525.525M6.788 12.679a.525.525 0 1 1-.525-.525.525.525 0 0 1 .525.525m0 0",
  className: "px-race_svg__i"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.078 19.253v1.578a12.66 12.66 0 0 1-6.131 6.193 12.5 12.5 0 0 1-1.521.594 12.4 12.4 0 0 1-1.817.432h-.008v-8.8a3.573 3.573 0 0 1 3.282-3.562 4 4 0 0 1 .292-.012h2.328a3.57 3.57 0 0 1 3.575 3.573Zm0 0",
  className: "px-race_svg__m"
}), /*#__PURE__*/React.createElement("path", {
  d: "M341.276 261.1v1.578a12.65 12.65 0 0 1-6.131 6.193 12.5 12.5 0 0 1-1.521.594V261.1a3.574 3.574 0 0 1 3.575-3.573h.5a3.574 3.574 0 0 1 3.577 3.573m0 0",
  style: {
    fill: "#dde8ed"
  },
  transform: "translate(-314.198 -241.848)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.841 11.738a1.185 1.185 0 1 1-1-1.171 1.186 1.186 0 0 1 1 1.171m0 0",
  className: "px-race_svg__o"
}), /*#__PURE__*/React.createElement("path", {
  d: "m23.298 16.969-.96 1.539-.96-1.539",
  className: "px-race_svg__p"
}), /*#__PURE__*/React.createElement("path", {
  d: "m23.631 22.855-1.291 1.629-1.291-1.629 1.291-4.748Zm0 0",
  className: "px-race_svg__p"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.841 11.737a1.186 1.186 0 0 1-1 1.171 4.43 4.43 0 0 1 0-2.341 1.186 1.186 0 0 1 1 1.17m0 0",
  className: "px-race_svg__q"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.079 11.737a.424.424 0 1 1-.424-.424.424.424 0 0 1 .424.424m0 0",
  className: "px-race_svg__q"
}), /*#__PURE__*/React.createElement("path", {
  d: "m22.338 17.143-1.609.894-.489-2.277 1-.589M22.339 17.143l1.609.894.489-2.277-1-.589",
  className: "px-race_svg__m"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.837 11.738a1.185 1.185 0 1 0 1-1.171 1.186 1.186 0 0 0-1 1.171m0 0",
  className: "px-race_svg__o"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.837 11.737a1.186 1.186 0 0 0 1 1.171 4.43 4.43 0 0 0 0-2.341 1.186 1.186 0 0 0-1 1.17m0 0",
  className: "px-race_svg__q"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.447 11.738a.424.424 0 1 1-.424-.424.424.424 0 0 1 .424.424m0 0",
  className: "px-race_svg__q"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.752 11.108a4.41 4.41 0 0 1-3.7 4.355 4.4 4.4 0 0 1-.708.057 4.41 4.41 0 0 1-4.412-4.412 6.3 6.3 0 0 1 1.125-3.67c.806-.875 2-.742 3.288-.742a4.4 4.4 0 0 1 .708.057 4.41 4.41 0 0 1 3.7 4.355Zm0 0",
  className: "px-race_svg__q"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.615 14.303v1.565a1.275 1.275 0 0 1-2.55 0v-1.565Zm0 0",
  className: "px-race_svg__q"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.614 15.768v.1a.922.922 0 1 1-1.786.166q.128.008.257.008a4.4 4.4 0 0 0 .708-.057 4.3 4.3 0 0 0 .821-.217M26.751 11.107a4.409 4.409 0 1 1-.022-.44q.021.218.022.44m0 0",
  className: "px-race_svg__o"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.34 13.281a2.2 2.2 0 0 1-1.076-.278.2.2 0 1 1 .189-.344 1.83 1.83 0 0 0 1.773 0 .2.2 0 0 1 .189.344 2.2 2.2 0 0 1-1.076.278Zm0 0",
  className: "px-race_svg__q"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.4 10.851a.5.5 0 1 1-.5-.5.5.5 0 0 1 .5.5M24.28 10.851a.5.5 0 1 1-.5-.5.5.5 0 0 1 .5.5m0 0",
  className: "px-race_svg__k"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.297 10.762a.214.214 0 1 1-.214-.214.215.215 0 0 1 .214.214M24.202 10.762a.214.214 0 1 1-.214-.214.215.215 0 0 1 .214.214m0 0",
  className: "px-race_svg__l"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.839 12.111h-1a.216.216 0 1 1 0-.432h1a.216.216 0 1 1 0 .432m0 0",
  className: "px-race_svg__q"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.792 19.136h1.923v.589h-1.923Zm0 0",
  className: "px-race_svg__m"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.081 5.435a2.674 2.674 0 0 1 2.478 2.534l.013.255h.769l.414 2.754 1-.31-.135-2.7a2.674 2.674 0 0 0-2.681-2.541Zm0 0",
  className: "px-race_svg__r"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.538 4.369a2.726 2.726 0 1 1-3.854 3.854Zm0 0",
  className: "px-race_svg__k"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.684 8.223h-3.345l-.414 2.754-1-.31.134-2.7a2.675 2.675 0 0 1 2.681-2.541l4.831.018.639 1.15",
  className: "px-race_svg__k"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.597 5.435a2.674 2.674 0 0 0-2.478 2.534l-.013.255h-.769l-.414 2.754-1-.31.135-2.7a2.674 2.674 0 0 1 2.681-2.541Zm0 0",
  className: "px-race_svg__r"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.947 26.079v.945a12.64 12.64 0 0 1-10.686 0v-.945a4.03 4.03 0 0 1 2.986-3.893 3 3 0 0 1 .19-.046 4 4 0 0 1 .524-.077 4 4 0 0 1 .33-.013h2.625a4 4 0 0 1 .855.091l.047.01.138.034a4.035 4.035 0 0 1 2.986 3.894Zm0 0",
  className: "px-race_svg__k"
}), /*#__PURE__*/React.createElement("path", {
  d: "m17.97 22.139-.01.046-1.286 5.979-.2.015q-.141.01-.284.016-.292.014-.586.014t-.6-.014q-.135-.006-.27-.016l-.2-.015-1.285-5.978-.01-.046Zm0 0",
  className: "px-race_svg__d"
}), /*#__PURE__*/React.createElement("path", {
  d: "m16.687 23.503-1.082 1.735-1.082-1.735",
  className: "px-race_svg__k"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.475 28.179q-.141.01-.284.016-.292.014-.586.014t-.6-.014q-.135-.006-.27-.016l.871-3.392Zm0 0",
  className: "px-race_svg__k"
}), /*#__PURE__*/React.createElement("path", {
  d: "m15.604 23.699-1.815 1.008-.552-2.567 1.127-.664M15.604 23.699l1.814 1.008.552-2.567-1.127-.664",
  className: "px-race_svg__c"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.039 25.604h.576L17.61 28.05a13 13 0 0 1-1.418.145l1.766-6.011.013-.045 1.241.405ZM15.003 28.195a13 13 0 0 1-1.419-.147l-1-2.443h.576l-1.173-3.06 1.242-.405.013.045Zm0 0",
  className: "px-race_svg__r"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.042 20.496v1.765a1.438 1.438 0 0 1-2.876 0v-1.765Zm0 0",
  className: "px-race_svg__i"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.043 22.149v.112a1.04 1.04 0 1 1-2.014.187q.144.009.29.009a5 5 0 0 0 1.724-.308M11.659 17.604a1.34 1.34 0 0 1-1.123 1.32 1.4 1.4 0 0 1-.214.017 1.337 1.337 0 1 1 1.337-1.337m0 0",
  className: "px-race_svg__j"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.659 17.604a1.34 1.34 0 0 1-1.123 1.32 5 5 0 0 1 0-2.64 1.34 1.34 0 0 1 1.123 1.32m0 0",
  className: "px-race_svg__i"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.8 17.604a.478.478 0 1 1-.478-.478.48.48 0 0 1 .478.478m0 0",
  className: "px-race_svg__i"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.549 17.604a1.338 1.338 0 1 0 1.123-1.32 1.34 1.34 0 0 0-1.123 1.32m0 0",
  className: "px-race_svg__j"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.549 17.604a1.34 1.34 0 0 0 1.123 1.32 5 5 0 0 0 0-2.64 1.34 1.34 0 0 0-1.123 1.32m0 0",
  className: "px-race_svg__i"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.579 14.999v1.895a4.976 4.976 0 0 1-4.177 4.911h-.024a5 5 0 0 1-.774.06 4.975 4.975 0 0 1-4.975-4.975v-1.895a4.97 4.97 0 0 1 4.975-4.976 4.97 4.97 0 0 1 4.975 4.976Zm0 0",
  className: "px-race_svg__i"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.364 17.604a.478.478 0 1 1-.478-.478.48.48 0 0 1 .478.478m0 0",
  className: "px-race_svg__i"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.58 14.999v1.895a4.976 4.976 0 0 1-4.177 4.911h-.024a4.976 4.976 0 0 1-4.2-4.915v-1.895a4.253 4.253 0 1 1 8.4 0Zm0 0",
  className: "px-race_svg__j"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.544 16.603a.564.564 0 1 1-.564-.564.564.564 0 0 1 .564.564M17.792 16.603a.564.564 0 1 1-.564-.564.564.564 0 0 1 .564.564m0 0",
  className: "px-race_svg__k"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.429 16.506a.242.242 0 1 1-.242-.242.24.24 0 0 1 .242.242M17.705 16.506a.242.242 0 1 1-.242-.242.24.24 0 0 1 .242.242m0 0",
  className: "px-race_svg__l"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.168 17.803h-1.129a.243.243 0 1 1 0-.487h1.129a.243.243 0 1 1 0 .487M15.604 19.344a2.5 2.5 0 0 1-1.213-.313.221.221 0 0 1 .213-.388 2.07 2.07 0 0 0 2 0 .221.221 0 0 1 .213.388 2.5 2.5 0 0 1-1.213.313m0 0",
  className: "px-race_svg__i"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.579 13.28v1.941h-.926v-1.52l-6.685-1.242-1.414-.263v3.025h-.926V13.28a4.005 4.005 0 0 1 4.005-4.006h2.098a4 4 0 0 1 3.847 4Zm0 0",
  className: "px-race_svg__r"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.58 13.279v1.941h-.926V13.7l-6.685-1.242a3.835 3.835 0 0 1 7.611.821m0 0",
  className: "px-race_svg__k"
}));

const SvgPxRedDollar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 30 30"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#ff1b40",
  d: "M15.002 2.502a12.5 12.5 0 1 0 12.5 12.5 12.5 12.5 0 0 0-12.5-12.5m1.76 20.109v2.391h-3.337v-2.416c-2.137-.45-3.949-1.825-4.087-4.249h2.45c.125 1.312 1.025 2.337 3.312 2.337 2.45 0 3-1.225 3-1.987 0-1.037-.55-2.012-3.337-2.674-3.1-.75-5.224-2.025-5.224-4.587 0-2.15 1.737-3.549 3.887-4.012V5.002h3.336v2.437a4.42 4.42 0 0 1 3.562 4.237h-2.45c-.062-1.387-.8-2.337-2.774-2.337-1.875 0-3 .85-3 2.05 0 1.05.812 1.737 3.337 2.387s5.224 1.737 5.224 4.887c-.012 2.287-1.725 3.537-3.9 3.949Z",
  "data-name": "Path 1317"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h30v30H0Z",
  "data-name": "Path 1318"
}));

const SvgPxRelationship = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".px-relationship_svg__b{fill:#fff36e}.px-relationship_svg__c{fill:#ffcc01}")), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h32v32H0z",
  style: {
    fill: "none"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.001 9.364a.77.77 0 0 1-.768-.767v-3.29a.768.768 0 0 1 1.536 0v3.29a.77.77 0 0 1-.768.767M12.711 10.187a.77.77 0 0 1-.543-.225l-1.645-1.645a.768.768 0 0 1 1.086-1.086l1.645 1.645a.768.768 0 0 1-.543 1.311m0 0",
  className: "px-relationship_svg__b"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.291 10.187a.768.768 0 0 1-.543-1.311l1.645-1.645a.768.768 0 0 1 1.086 1.086l-1.645 1.645a.77.77 0 0 1-.543.225m0 0",
  className: "px-relationship_svg__c"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.1 137.458a1.83 1.83 0 0 0-2.244.1L7.541 140.4a1.7 1.7 0 0 1-1.106.409H4.057A4.054 4.054 0 0 0 0 144.87v7.4a.77.77 0 0 0 .768.768h6.579a.77.77 0 0 0 .768-.768v-7.049l4.989-4.277Zm0 0",
  style: {
    fill: "#00eccf"
  },
  transform: "translate(2.896 -125.582)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M256 137.458a1.83 1.83 0 0 1 2.244.1l3.32 2.845a1.7 1.7 0 0 0 1.106.409h2.378a4.054 4.054 0 0 1 4.057 4.057v7.4a.77.77 0 0 1-.768.768h-6.579a.77.77 0 0 1-.768-.768v-7.049l-4.99-4.273Zm0 0",
  style: {
    fill: "#0051bd"
  },
  transform: "translate(-240 -125.582)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.3 89.439a3.235 3.235 0 1 1 3.237-3.239 3.24 3.24 0 0 1-3.237 3.239m0 0",
  style: {
    fill: "#ffece3"
  },
  transform: "translate(-12.348 -74.208)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M79.266 82.968v6.47a3.235 3.235 0 1 0 0-6.47m0 0",
  style: {
    fill: "#ffdccd"
  },
  transform: "translate(-72.312 -74.208)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M372.77 89.439a3.235 3.235 0 1 1 3.235-3.235 3.24 3.24 0 0 1-3.235 3.235m0 0",
  style: {
    fill: "#e8afa3"
  },
  transform: "translate(-347.723 -74.208)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M432.734 82.968v6.47a3.235 3.235 0 1 0 0-6.47m0 0",
  style: {
    fill: "#d19188"
  },
  transform: "translate(-407.687 -74.208)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m86.068 137.559-3.32 2.845a1.7 1.7 0 0 1-1.106.409h-2.377v12.227h3.29a.77.77 0 0 0 .768-.768v-7.049l4.989-4.276v-3.489a1.83 1.83 0 0 0-2.244.1Zm0 0",
  style: {
    fill: "#00cab1"
  },
  transform: "translate(-72.312 -125.582)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M432.735 209.367v12.227h3.29a.77.77 0 0 0 .768-.768v-7.4a4.054 4.054 0 0 0-4.058-4.059m0 0",
  style: {
    fill: "#00347b"
  },
  transform: "translate(-407.687 -194.136)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.768 8.597v-3.29A.77.77 0 0 0 16 4.539v4.825a.77.77 0 0 0 .768-.767m0 0",
  className: "px-relationship_svg__c"
}));

const SvgPxReligion = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".px-religion_svg__g{fill:#ffb985}.px-religion_svg__i{fill:#e06e3b}.px-religion_svg__l{fill:#fff}.px-religion_svg__m{fill:#d3d3d3}")), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h32v32H0z",
  style: {
    fill: "none"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.668 11.334a11.33 11.33 0 0 1-5.6 9.78c-.762.448-1.581-.732-2.443-.471-.782.236-1.6 1.932-2.443 1.994q-.418.031-.845.031t-.845-.031c-.857-.063-1.687-2.162-2.481-2.405-.849-.259-1.655 1.324-2.406.882a11.334 11.334 0 1 1 17.065-9.78Z",
  style: {
    fill: "#4439c6"
  },
  transform: "translate(5 5)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M124.711 40.608a11.4 11.4 0 0 0-.269-2.465l-7.513-7.513-.229 1.97-1.56-.179 4.668 4.668-.136.606-1.541-1.541-.689 1.185-4.061-4.061.094 1.223-3.875-3.871.232 1.318-2.025.475 4.973 4.973-1.1.091-.174-.174-.282.173-1.265-1.265-1.072 1.406-.606-.606.633 5.061-2.139 4.7 2.765 2.765a.76.76 0 0 1 .517-.039c.793.244 1.624 2.343 2.481 2.405q.418.031.845.031t.845-.031c.843-.062 1.661-1.758 2.443-1.994.862-.261 1.682.919 2.443.471a11.33 11.33 0 0 0 5.597-9.782",
  style: {
    fill: "#21218e"
  },
  transform: "translate(-97.043 -24.274)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m206.048 208.244-.594-1.292.594-.9a.822.822 0 0 1 1.644 0v2.195Z",
  style: {
    fill: "#ea844b"
  },
  transform: "translate(-191.358 -191.141)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m137.1 154.066-.348-1.84.348-2.017v-.848a.822.822 0 1 1 1.644 0v1.213l.4 1.568-.4 1.923H137.1Z",
  style: {
    fill: "#f9a267"
  },
  transform: "translate(-125.698 -136.963)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M114.046 172.285v4.49a1.77 1.77 0 0 1-.845 1.512v4.606a11.25 11.25 0 0 1-4.886-1.523v-3.286l-.845-1.259V168.5a.822.822 0 1 1 1.644 0v3.783h1.644v-3.417a.822.822 0 1 1 1.644 0v3.417Z",
  style: {
    fill: "#ffd3ab"
  },
  transform: "translate(-97.712 -155.257)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.334 17.029v4.49a1.77 1.77 0 0 1-.845 1.512v4.609a11.3 11.3 0 0 1-2.481-.465V17.029h.038v-3.417a.822.822 0 0 1 1.644 0v3.417ZM8.431 16.1v3.766a3.3 3.3 0 0 0 1.059 2.42l.58.536a1.78 1.78 0 0 0 1.205.472h.31v-2.826a1.34 1.34 0 0 0-1.062-1.309l-.656-.138-.009-.831a2.29 2.29 0 0 0-1.427-2.09",
  className: "px-religion_svg__g"
}), /*#__PURE__*/React.createElement("path", {
  d: "m257.644 208.244.594-1.292-.594-.9a.822.822 0 1 0-1.644 0v2.195Z",
  style: {
    fill: "#e2743d"
  },
  transform: "translate(-239.666 -191.141)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m21.266 17.103.348-1.84-.348-2.017v-.848a.822.822 0 0 0-1.644 0v1.213l-.4 1.568.4 1.923z",
  className: "px-religion_svg__i"
}), /*#__PURE__*/React.createElement("path", {
  d: "M262.576 168.5v8.323l-.845 1.259v3.286a11.25 11.25 0 0 1-4.886 1.523v-4.606a1.77 1.77 0 0 1-.845-1.512v-4.49h1.644v-3.417a.822.822 0 1 1 1.644 0v3.417h1.644V168.5a.822.822 0 1 1 1.644 0",
  style: {
    fill: "#f49d62"
  },
  transform: "translate(-239.666 -155.257)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m333.548 176.835-1.233 1.259h.388v3.286a11.3 11.3 0 0 1-2.443 1.07v-10.156h1.64v-3.783a.822.822 0 0 1 1.644 0Z",
  style: {
    fill: "#ea8654"
  },
  transform: "translate(-310.638 -155.266)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.237 16.1v3.766a3.3 3.3 0 0 1-1.059 2.42l-.58.536a1.78 1.78 0 0 1-1.205.472h-.31v-2.826a1.34 1.34 0 0 1 1.062-1.309l.656-.138.009-.831a2.29 2.29 0 0 1 1.427-2.09",
  className: "px-religion_svg__i"
}), /*#__PURE__*/React.createElement("path", {
  d: "m12.554 6.356.55 1.244 1.244.55-1.244.549-.55 1.244-.549-1.244-1.244-.549 1.244-.55Z",
  className: "px-religion_svg__l"
}), /*#__PURE__*/React.createElement("path", {
  d: "m19.886 6.356.55 1.244 1.244.55-1.244.549-.55 1.244-.549-1.244-1.244-.549 1.244-.55Z",
  className: "px-religion_svg__m"
}), /*#__PURE__*/React.createElement("path", {
  d: "m16.334 9.006.51 1.155 1.155.51-1.155.51-.51 1.155-.51-1.155-1.155-.51 1.155-.51Z",
  className: "px-religion_svg__l"
}), /*#__PURE__*/React.createElement("path", {
  d: "m16.844 11.183 1.155-.51-1.155-.51-.51-1.157v3.331Z",
  className: "px-religion_svg__m"
}));

const SvgPxReminder = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#f5f8f9",
  d: "M4 10.966v17.335h12.434l1.187-8.461-1.187-8.874L10.6 9.521Z",
  "data-name": "Path 71701"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e3eaee",
  d: "m28.868 10.963-5.933-1.7-6.5 1.7v17.335h12.434Z",
  "data-name": "Path 71702"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ff3f5c",
  d: "M4 6.322v4.643h12.434l.98-2.219-.98-2.425Z",
  "data-name": "Path 71703"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ca2e43",
  d: "M16.434 6.322h12.434v4.643H16.434Z",
  "data-name": "Path 71704"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#c2bce0",
  d: "M9.443 4h1.548v4.643H9.443Z",
  "data-name": "Path 71705"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#a299d1",
  d: "M21.877 4h1.548v4.643h-1.548Z",
  "data-name": "Path 71706"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#463b84",
  d: "m25.012 24.674-1.3-.847a7.59 7.59 0 0 0 0-8.285l1.3-.847a9.14 9.14 0 0 1 0 9.979",
  "data-name": "Path 71707"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#6e61b6",
  d: "M7.856 24.674a9.14 9.14 0 0 1 0-9.979l1.3.847a7.59 7.59 0 0 0 0 8.285Z",
  "data-name": "Path 71708"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#6e61b6",
  d: "M15.66 23.228v2.544h.774l.413-1.238-.413-1.306Z",
  "data-name": "Path 71709"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#463b84",
  d: "M16.434 23.228h.774v2.544h-.774Z",
  "data-name": "Path 71710"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fc6",
  d: "M12.719 17.931v2.365l-1.625 3.878h5.34l.98-4.8-.98-5.159a3.72 3.72 0 0 0-3.715 3.716",
  "data-name": "Path 71711"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffa64d",
  d: "M20.149 20.296v-2.365a3.72 3.72 0 0 0-3.715-3.715v9.958h5.34Z",
  "data-name": "Path 71712"
}));

const SvgPxRoleAuthorisation = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".px-role-authorisation_svg__cls-3{fill:#e9eef2}.px-role-authorisation_svg__cls-4{fill:#6ed2f0}.px-role-authorisation_svg__cls-5{fill:#dadcde}.px-role-authorisation_svg__cls-6{fill:#eb423f}")), /*#__PURE__*/React.createElement("g", {
  id: "px-role-authorisation_svg__Group_50385",
  "data-name": "Group 50385",
  transform: "translate(9012 -23081)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-role-authorisation_svg__icon_placeholder",
  d: "M0 0h32v32H0z",
  style: {
    fill: "none"
  },
  transform: "translate(-9012 23081)"
}), /*#__PURE__*/React.createElement("g", {
  id: "px-role-authorisation_svg__insurance-policy",
  transform: "translate(-9006.685 23087)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "px-role-authorisation_svg__Rectangle_21301",
  width: 17,
  height: 20,
  "data-name": "Rectangle 21301",
  rx: 8.5,
  style: {
    fill: "#3397e8"
  },
  transform: "translate(-.315 1.001)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-role-authorisation_svg__Path_64979",
  d: "M56 88h12.937v16.531H56Z",
  className: "px-role-authorisation_svg__cls-3",
  "data-name": "Path 64979",
  transform: "translate(-53.997 -85.125)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-role-authorisation_svg__Path_64980",
  d: "M119.906 25.437v2.156H112v-2.156a.72.72 0 0 1 .719-.719h1.438a.72.72 0 0 1 .719-.719h2.156a.72.72 0 0 1 .719.719h1.437a.72.72 0 0 1 .718.719",
  className: "px-role-authorisation_svg__cls-4",
  "data-name": "Path 64980",
  transform: "translate(-107.482 -24)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-role-authorisation_svg__Path_64981",
  d: "M90.422 128.719H80.359a.359.359 0 1 1 0-.719h10.063a.359.359 0 1 1 0 .719",
  className: "px-role-authorisation_svg__cls-5",
  "data-name": "Path 64981",
  transform: "translate(-76.919 -123.328)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-role-authorisation_svg__Path_64982",
  d: "M90.422 160.719H80.359a.359.359 0 1 1 0-.719h10.063a.359.359 0 1 1 0 .719",
  className: "px-role-authorisation_svg__cls-5",
  "data-name": "Path 64982",
  transform: "translate(-76.919 -153.891)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-role-authorisation_svg__Path_64983",
  d: "M96 200h1.438v1.437H96Z",
  className: "px-role-authorisation_svg__cls-6",
  "data-name": "Path 64983",
  transform: "translate(-92.201 -192.094)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-role-authorisation_svg__Path_64984",
  d: "M96 264h1.438v1.437H96Z",
  className: "px-role-authorisation_svg__cls-6",
  "data-name": "Path 64984",
  transform: "translate(-92.201 -253.219)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-role-authorisation_svg__Path_64985",
  d: "M96 328h1.438v1.437H96Z",
  className: "px-role-authorisation_svg__cls-6",
  "data-name": "Path 64985",
  transform: "translate(-92.201 -314.344)"
}), /*#__PURE__*/React.createElement("g", {
  id: "px-role-authorisation_svg__Group_50325",
  "data-name": "Group 50325",
  transform: "translate(6.315 7.547)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-role-authorisation_svg__Path_64986",
  d: "M159.188 192.719h-6.828a.359.359 0 1 1 0-.719h6.828a.359.359 0 1 1 0 .719",
  className: "px-role-authorisation_svg__cls-5",
  "data-name": "Path 64986",
  transform: "translate(-152 -192)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-role-authorisation_svg__Path_64987",
  d: "M159.188 224.719h-6.828a.359.359 0 0 1 0-.719h6.828a.359.359 0 0 1 0 .719",
  className: "px-role-authorisation_svg__cls-5",
  "data-name": "Path 64987",
  transform: "translate(-152 -222.563)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-role-authorisation_svg__Path_64988",
  d: "M159.188 256.719h-6.828a.359.359 0 0 1 0-.719h6.828a.359.359 0 0 1 0 .719",
  className: "px-role-authorisation_svg__cls-5",
  "data-name": "Path 64988",
  transform: "translate(-152 -253.125)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-role-authorisation_svg__Path_64989",
  d: "M159.188 288.719h-6.828a.359.359 0 0 1 0-.719h6.828a.359.359 0 0 1 0 .719",
  className: "px-role-authorisation_svg__cls-5",
  "data-name": "Path 64989",
  transform: "translate(-152 -283.688)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-role-authorisation_svg__Path_64990",
  d: "M159.188 320.719h-6.828a.359.359 0 0 1 0-.719h6.828a.359.359 0 0 1 0 .719",
  className: "px-role-authorisation_svg__cls-5",
  "data-name": "Path 64990",
  transform: "translate(-152 -314.25)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-role-authorisation_svg__Path_64991",
  d: "M159.188 352.719h-6.828a.359.359 0 0 1 0-.719h6.828a.359.359 0 0 1 0 .719",
  className: "px-role-authorisation_svg__cls-5",
  "data-name": "Path 64991",
  transform: "translate(-152 -344.813)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-role-authorisation_svg__Path_64992",
  d: "M189.031 400.719h-4.672a.359.359 0 0 1 0-.719h4.672a.359.359 0 0 1 0 .719",
  className: "px-role-authorisation_svg__cls-5",
  "data-name": "Path 64992",
  transform: "translate(-182.563 -390.656)"
})), /*#__PURE__*/React.createElement("path", {
  id: "px-role-authorisation_svg__Path_64993",
  d: "m284.67 136-4.67 2.875a7.24 7.24 0 0 0 4.664 7.187 7.245 7.245 0 0 0 4.679-7.187c.001-.008-4.673-2.875-4.673-2.875",
  className: "px-role-authorisation_svg__cls-4",
  "data-name": "Path 64993",
  transform: "translate(-267.935 -130.969)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-role-authorisation_svg__Path_64994",
  d: "M315.971 180.38a5.76 5.76 0 0 1-3.193-4.849l3.2-1.969c1.134.7 2.426 1.49 3.2 1.966a5.76 5.76 0 0 1-3.206 4.852Z",
  className: "px-role-authorisation_svg__cls-3",
  "data-name": "Path 64994",
  transform: "translate(-299.241 -166.844)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-role-authorisation_svg__Path_64995",
  d: "M353.078 226.515a.36.36 0 0 1-.254-.105l-.719-.719a.359.359 0 0 1 .508-.508l.465.465 1.543-1.543a.359.359 0 1 1 .508.508l-1.8 1.8a.36.36 0 0 1-.251.102",
  className: "px-role-authorisation_svg__cls-6",
  "data-name": "Path 64995",
  transform: "translate(-336.7 -215.016)"
}))));

const SvgPxSalesAdmin = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57656"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#ff9e22",
  d: "M17.05 12.631a6 6 0 0 1-.267.644l.891 1.447-1.656 1.778h-4.161V4h1.377l.4 1.665a6 6 0 0 1 .644.267l1.458-.9 1.948 1.948-.9 1.458a6 6 0 0 1 .267.644l1.665.4v2.752Z",
  "data-name": "Path 71976"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffd322",
  d: "M11.857 4v12.5H7.864L6.03 14.74l.9-1.465a6 6 0 0 1-.267-.644l-1.665-.4V9.48l1.665-.4a6 6 0 0 1 .267-.644l-.9-1.458L7.978 5.03l1.458.9a6 6 0 0 1 .644-.267L10.48 4Z",
  "data-name": "Path 71977"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#002659",
  d: "M16.581 17.37v2.021h-4.724v-6.248h.5a4.227 4.227 0 0 1 4.227 4.227Z",
  "data-name": "Path 71978"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#39326c",
  d: "M11.857 13.143v6.248H7.133V17.37a4.227 4.227 0 0 1 4.227-4.227Z",
  "data-name": "Path 71979"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5f55ae",
  d: "M14.886 10.991a3.03 3.03 0 0 1-3.029 3.029V7.962a3.03 3.03 0 0 1 3.029 3.029",
  "data-name": "Path 71980"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#918edd",
  d: "M11.858 7.962v6.057a3.029 3.029 0 1 1 0-6.057",
  "data-name": "Path 71981"
})));

const SvgPxSalesCancellation = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57422"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57417"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#23aae6",
  d: "M8.213 29.289h15.573a1.83 1.83 0 0 0 1.832-1.832V6.387a1.83 1.83 0 0 0-1.832-1.832H8.213a1.83 1.83 0 0 0-1.832 1.832v21.068a1.83 1.83 0 0 0 1.832 1.834",
  "data-name": "Path 71692"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57418"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#5ad7ff",
  d: "M8.213 29.289H22.87a1.83 1.83 0 0 0 1.832-1.832V6.387a1.83 1.83 0 0 0-1.832-1.832H8.213a1.83 1.83 0 0 0-1.832 1.832v21.068a1.83 1.83 0 0 0 1.832 1.834",
  "data-name": "Path 71693"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57419"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#d7e6f0",
  d: "M9.129 27.456h12.825a.916.916 0 0 0 .916-.916V7.303a.916.916 0 0 0-.916-.916H9.129a.916.916 0 0 0-.916.916V26.54a.916.916 0 0 0 .916.916",
  "data-name": "Path 71694"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57421"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57420"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#9b5faa",
  d: "M19.206 3.639h-1.832a1.832 1.832 0 1 0-3.664 0h-1.832a.916.916 0 0 0-.916.916v1.832a.916.916 0 0 0 .916.916h7.329a.916.916 0 0 0 .916-.916V4.555a.916.916 0 0 0-.917-.916m-3.664.916a.916.916 0 1 1 .916-.916.916.916 0 0 1-.917.916Z",
  "data-name": "Path 71695"
})))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57425"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57423",
  transform: "translate(9.37 7.786)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 5.979,
  cy: 6.726,
  fill: "#faa019",
  "data-name": "Ellipse 1440",
  rx: 5.979,
  ry: 6.726
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57424"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#ffd205",
  d: "M9.587 15.09a.46.46 0 0 1-.458-.458 6.42 6.42 0 0 1 6.412-6.412.458.458 0 0 1 0 .916 5.5 5.5 0 0 0-5.5 5.5.46.46 0 0 1-.454.454",
  "data-name": "Path 71696"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#f06423",
  d: "m16.837 14.632 2.1-2.1a.92.92 0 0 0-1.3-1.3l-2.1 2.1-2.1-2.1a.92.92 0 0 0-1.3 1.3l2.1 2.1-2.1 2.1a.92.92 0 1 0 1.3 1.3l2.1-2.1 2.1 2.1a.92.92 0 0 0 1.3-1.3Z",
  "data-name": "Path 71697"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57426"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#a5c3dc",
  d: "M21.038 22.876H10.045a.458.458 0 1 1 0-.916h10.993a.458.458 0 0 1 0 .916",
  "data-name": "Path 71698"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57427"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#a5c3dc",
  d: "M21.038 24.709H10.045a.458.458 0 1 1 0-.916h10.993a.458.458 0 1 1 0 .916",
  "data-name": "Path 71699"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57428"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#a5c3dc",
  d: "M21.038 26.541H18.29a.458.458 0 0 1 0-.916h2.748a.458.458 0 1 1 0 .916",
  "data-name": "Path 71700"
})));

const SvgPxSalesContracts = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#ff9f22",
  d: "M29.287 15.899A13.291 13.291 0 0 1 4.228 22.18a.9.9 0 0 1 .8-1.319h2.83A15.254 15.254 0 0 0 23.115 5.606a.44.44 0 0 1 .7-.357 13.27 13.27 0 0 1 5.475 10.65Z",
  "data-name": "Path 71679"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#dd7d00",
  d: "M22.877 20.079v5.719a.26.26 0 0 1-.26.26h-15.3a13.3 13.3 0 0 1-3.079-3.872.9.9 0 0 1 .8-1.325h2.831a15.2 15.2 0 0 0 4.833-.782z",
  "data-name": "Path 71680"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#d3d3d8",
  d: "M23.656 23.656H7.644a.26.26 0 0 1-.26-.26v-7.402A11.986 11.986 0 0 1 18.03 4.085a11.7 11.7 0 0 1 4.51.346 13 13 0 0 1 1.376.9v18.063a.26.26 0 0 1-.26.262",
  "data-name": "Path 71681"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ececf1",
  d: "M22.54 4.429v17.592a.26.26 0 0 1-.26.26H4.726a13.23 13.23 0 0 1-1.574-6.418A12.943 12.943 0 0 1 16.037 2.711a13.2 13.2 0 0 1 6.5 1.718Z",
  "data-name": "Path 71682"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#d3d3d8",
  d: "M7.384 22.281h-3.1A13.3 13.3 0 0 1 19.517 3.182h-.261A13.32 13.32 0 0 0 5.93 16.33a13.3 13.3 0 0 0 1.454 5.951",
  "data-name": "Path 71683"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#b9b9be",
  d: "M13.613 19.072a.26.26 0 0 1-.26.26H7.559a.26.26 0 1 1 0-.519h5.794a.26.26 0 0 1 .26.259m6.489-14.794h-3.116a.26.26 0 1 0 0 .519h3.115a.26.26 0 0 0 0-.519Zm0 1.028h-1.559a.26.26 0 0 0 0 .519H20.1a.26.26 0 0 0 0-.519ZM7.559 11.545h9.554a.26.26 0 1 0 0-.519H7.559a.26.26 0 1 0 0 .519m10.789.623H7.559a.26.26 0 1 0 0 .519h10.788a.26.26 0 1 0 0-.519Zm1.234-2.336H7.559a.26.26 0 1 0 0 .519h12.023a.26.26 0 0 0 0-.519",
  "data-name": "Path 71684"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#8c96dd",
  d: "M9.699 8.224a.26.26 0 0 1-.26.26h-1.88a.26.26 0 0 1 0-.519H9.44a.26.26 0 0 1 .259.259m3.135-1.4H7.559a.26.26 0 0 0 0 .519h5.274a.26.26 0 0 0 0-.519Z",
  "data-name": "Path 71685"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#232e7a",
  d: "M14.705 16.595a.26.26 0 0 1-.26.26h-1.834l-.312.312a.26.26 0 0 1-.4-.045l-.516-.815-.986 1.59a.26.26 0 0 1-.221.123h-.04a.26.26 0 0 1-.212-.194l-.625-2.5-.843 1.4a.26.26 0 0 1-.223.126H7.071a.26.26 0 1 1 0-.519h1.018l1.082-1.817a.26.26 0 0 1 .474.071l.628 2.511.88-1.42a.26.26 0 0 1 .219-.123.26.26 0 0 1 .219.121l.564.891.159-.159a.26.26 0 0 1 .184-.076h1.942a.26.26 0 0 1 .265.263m1-.26h-.075a.26.26 0 1 0 0 .519h.075a.26.26 0 1 0 0-.519",
  "data-name": "Path 71686"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#232e7a",
  d: "M19.062 17.955a.26.26 0 0 1-.26-.26v-3.288a.26.26 0 1 1 .519 0v3.288a.26.26 0 0 1-.259.26m0 7.077a.78.78 0 0 1 .779.779v1.3a.52.52 0 0 1-.519.519h-.519a.52.52 0 0 1-.519-.519v-1.297a.78.78 0 0 1 .778-.782",
  "data-name": "Path 71687"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3342ae",
  d: "M19.062 26.589a.78.78 0 0 1-.779-.779V20.1a.779.779 0 0 1 1.557 0v5.71a.78.78 0 0 1-.778.779",
  "data-name": "Path 71688"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3d4ec6",
  d: "M19.062 21.398a.78.78 0 0 1-.779-.779v-4.672a.779.779 0 1 1 1.557 0v4.672a.78.78 0 0 1-.778.779",
  "data-name": "Path 71689"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#7cd2e3",
  d: "M19.841 16.986h-1.557a.26.26 0 1 1 0-.519h1.557a.26.26 0 0 1 0 .519m.26 5.049v-.915a.26.26 0 1 0-.519 0v1.02a.26.26 0 0 0 .076.184 2.34 2.34 0 0 1 .073 3.227h-1.447a.26.26 0 1 0 0 .519h1.557a.26.26 0 0 0 .184-.076 2.86 2.86 0 0 0 .075-3.959Z",
  "data-name": "Path 71690"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#a6e0ec",
  d: "M19.581 26.067h-.67a.26.26 0 0 1 0-.519h.67a.26.26 0 0 1 0 .519m.26-9.344a.26.26 0 0 0-.26-.26h-.67a.26.26 0 0 0 0 .519h.67a.26.26 0 0 0 .259-.255Z",
  "data-name": "Path 71691"
}));

const SvgPxSalesCrm = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57659",
  transform: "translate(3 -17.281)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#f4fbff",
  d: "M16.732 35.029H4.559v-.977l-1.341-.968-1.863-11.66h13.556l1.4 1.139h1.036v11.848a.62.62 0 0 1-.615.618",
  "data-name": "Path 71957"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e4f6ff",
  d: "M16.464 22.559v11.852a.62.62 0 0 1-.618.618h.886a.62.62 0 0 0 .618-.618V22.559Z",
  "data-name": "Path 71958"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3b66c1",
  d: "M17.35 22.559H0V20.9a.62.62 0 0 1 .618-.618h16.114a.62.62 0 0 1 .618.618z",
  "data-name": "Path 71959"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#30579d",
  d: "M16.732 20.281h-.885a.62.62 0 0 1 .618.618v1.66h.886V20.9a.62.62 0 0 0-.619-.619",
  "data-name": "Path 71960"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57530"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57527"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#ecbe6b",
  d: "M1.355 21.702H.991a.282.282 0 0 1 0-.564h.364a.282.282 0 0 1 0 .564",
  "data-name": "Path 71961"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57528"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#90d8f9",
  d: "M2.915 21.702h-.364a.282.282 0 0 1 0-.564h.364a.282.282 0 0 1 0 .564",
  "data-name": "Path 71962"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57529"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#b3e59f",
  d: "M4.474 21.702H4.11a.282.282 0 1 1 0-.564h.364a.282.282 0 1 1 0 .564",
  "data-name": "Path 71963"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57535"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57532"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57531"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#30579d",
  d: "M14.163 28.377a.35.35 0 0 1-.334-.24v-.01l-.637-2.16-.389 2.154a.282.282 0 0 1-.555-.1l.547-3.033a.352.352 0 0 1 .681-.049v.01l.683 2.316.659-2.313v-.01a.352.352 0 0 1 .68.038l.58 3.037a.282.282 0 1 1-.554.106l-.413-2.158-.615 2.158v.01a.35.35 0 0 1-.333.244",
  "data-name": "Path 71964"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57534"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57533"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#30579d",
  d: "M7.661 28.378a1.839 1.839 0 1 1 1.029-3.364.282.282 0 1 1-.316.467 1.275 1.275 0 1 0-.713 2.333.94.94 0 0 0 .765-.339.282.282 0 1 1 .432.363 1.5 1.5 0 0 1-1.2.54Z",
  "data-name": "Path 71965"
}))), /*#__PURE__*/React.createElement("path", {
  fill: "#30579d",
  d: "M10.676 26.872a1.09 1.09 0 0 0-.154-2.173h-.829a.28.28 0 0 0-.282.282v3.115a.282.282 0 1 0 .564 0V26.93l1.19 1.353a.282.282 0 1 0 .423-.373Zm-.154-1.609a.529.529 0 1 1 0 1.055H9.98v-1.057Z",
  "data-name": "Path 71966"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#90d8f9",
  d: "m18.141 32.705.347.209a.41.41 0 0 1 .2.35v.789c.019.39-.524.434-.688.7l-.769 1.332c-.152.277.082.769-.266.948l-.683.394c-.329.212-.638-.237-.954-.244h-1.54c-.316.007-.625.455-.954.244l-.683-.394c-.347-.179-.114-.671-.266-.948l-.769-1.332c-.164-.27-.707-.314-.688-.7v-.789c-.019-.39.524-.434.688-.7l.769-1.332c.152-.277-.082-.769.266-.948l.683-.394c.329-.212.638.237.954.244h1.538c.316-.007.625-.455.954-.244l.683.394c.347.179.114.671.266.948l.769 1.332a.4.4 0 0 0 .143.141",
  "data-name": "Path 71967"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57536"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#75cef9",
  d: "M18.488 32.913c-.117-.082-.428-.218-.49-.354l-.769-1.332c-.152-.277.082-.769-.266-.948l-.683-.394c-.207-.138-.45.016-.631.124l.469.271c.347.179.114.671.266.948l.769 1.332c.164.27.707.314.688.7v.789c.019.39-.524.434-.688.7l-.769 1.332c-.086.121-.05.462-.062.6.025.32-.468.475-.673.617.182.108.424.262.631.124l.683-.394c.347-.179.114-.671.266-.948l.769-1.332c.164-.27.707-.314.688-.7v-.789a.41.41 0 0 0-.198-.346",
  "data-name": "Path 71968"
})), /*#__PURE__*/React.createElement("circle", {
  cx: 2.33,
  cy: 2.33,
  r: 2.33,
  fill: "#f4fbff",
  "data-name": "Ellipse 1464",
  transform: "translate(12.227 31.327)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e4f6ff",
  d: "M14.557 31.327a2.3 2.3 0 0 0-.423.039 2.33 2.33 0 0 1 0 4.583 2.33 2.33 0 1 0 .423-4.622",
  "data-name": "Path 71969"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#cbe2ff",
  d: "M4.559 35.029H.618A.62.62 0 0 1 0 34.411V22.559h4.559Z",
  "data-name": "Path 71970"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57542"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57537"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#e4f6ff",
  d: "M2.963 24.577H1.597a.282.282 0 1 1 0-.564h1.366a.282.282 0 1 1 0 .564",
  "data-name": "Path 71971"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57538"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#e4f6ff",
  d: "M2.963 26.305H1.597a.282.282 0 0 1 0-.564h1.366a.282.282 0 0 1 0 .564",
  "data-name": "Path 71972"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57539"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#e4f6ff",
  d: "M2.963 28.036H1.597a.282.282 0 1 1 0-.564h1.366a.282.282 0 1 1 0 .564",
  "data-name": "Path 71973"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57540"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#e4f6ff",
  d: "M2.963 29.768H1.597a.282.282 0 0 1 0-.564h1.366a.282.282 0 0 1 0 .564",
  "data-name": "Path 71974"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57541"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#e4f6ff",
  d: "M2.963 31.499H1.597a.282.282 0 1 1 0-.564h1.366a.282.282 0 1 1 0 .564",
  "data-name": "Path 71975"
})))));

const SvgPxSalesOffice = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".px-sales-office_svg__cls-2{fill:#4398d1}.px-sales-office_svg__cls-3{fill:#3f8fc4}.px-sales-office_svg__cls-4{fill:#87ced9}.px-sales-office_svg__cls-6{fill:#88b337}.px-sales-office_svg__cls-7{fill:#79a125}")), /*#__PURE__*/React.createElement("g", {
  id: "px-sales-office_svg__Group_50402",
  "data-name": "Group 50402",
  transform: "translate(9064 -23289)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-sales-office_svg__icon_placeholder",
  d: "M0 0h32v32H0z",
  style: {
    fill: "none"
  },
  transform: "translate(-9064 23289)"
}), /*#__PURE__*/React.createElement("g", {
  id: "px-sales-office_svg__office-building",
  transform: "translate(-9059 23294.469)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-sales-office_svg__Rectangle_21302",
  d: "M0 0h9.995v19.276H0z",
  className: "px-sales-office_svg__cls-2",
  "data-name": "Rectangle 21302",
  transform: "translate(5.711 1.428)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-sales-office_svg__Path_65039",
  d: "M136.533 116.825v5.354h10v-16.46Z",
  className: "px-sales-office_svg__cls-3",
  "data-name": "Path 65039",
  transform: "translate(-130.822 -101.475)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-sales-office_svg__Rectangle_21303",
  d: "M0 0h7.139v1.428H0z",
  className: "px-sales-office_svg__cls-2",
  "data-name": "Rectangle 21303",
  transform: "translate(7.139)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-sales-office_svg__Rectangle_21304",
  d: "M0 0h7.139v.714H0z",
  className: "px-sales-office_svg__cls-3",
  "data-name": "Rectangle 21304",
  transform: "translate(7.139 .714)"
}), /*#__PURE__*/React.createElement("g", {
  id: "px-sales-office_svg__Group_50327",
  "data-name": "Group 50327",
  transform: "translate(7.139 3.213)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-sales-office_svg__Rectangle_21305",
  d: "M0 0h1.428v1.428H0z",
  className: "px-sales-office_svg__cls-4",
  "data-name": "Rectangle 21305"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-sales-office_svg__Rectangle_21306",
  d: "M0 0h1.428v1.428H0z",
  className: "px-sales-office_svg__cls-4",
  "data-name": "Rectangle 21306",
  transform: "translate(2.856)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-sales-office_svg__Rectangle_21307",
  d: "M0 0h1.428v1.428H0z",
  className: "px-sales-office_svg__cls-4",
  "data-name": "Rectangle 21307",
  transform: "translate(5.711)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-sales-office_svg__Rectangle_21308",
  d: "M0 0h1.428v1.428H0z",
  className: "px-sales-office_svg__cls-4",
  "data-name": "Rectangle 21308",
  transform: "translate(0 2.856)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-sales-office_svg__Rectangle_21309",
  d: "M0 0h1.428v1.428H0z",
  className: "px-sales-office_svg__cls-4",
  "data-name": "Rectangle 21309",
  transform: "translate(2.856 2.856)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-sales-office_svg__Rectangle_21310",
  d: "M0 0h1.428v1.428H0z",
  className: "px-sales-office_svg__cls-4",
  "data-name": "Rectangle 21310",
  transform: "translate(5.711 2.856)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-sales-office_svg__Rectangle_21311",
  d: "M0 0h1.428v1.428H0z",
  className: "px-sales-office_svg__cls-4",
  "data-name": "Rectangle 21311",
  transform: "translate(0 5.711)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-sales-office_svg__Rectangle_21312",
  d: "M0 0h1.428v1.428H0z",
  className: "px-sales-office_svg__cls-4",
  "data-name": "Rectangle 21312",
  transform: "translate(2.856 5.711)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-sales-office_svg__Rectangle_21313",
  d: "M0 0h1.428v1.428H0z",
  className: "px-sales-office_svg__cls-4",
  "data-name": "Rectangle 21313",
  transform: "translate(5.711 5.711)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-sales-office_svg__Rectangle_21314",
  d: "M0 0h1.428v1.428H0z",
  className: "px-sales-office_svg__cls-4",
  "data-name": "Rectangle 21314",
  transform: "translate(0 8.567)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-sales-office_svg__Rectangle_21315",
  d: "M0 0h1.428v1.428H0z",
  className: "px-sales-office_svg__cls-4",
  "data-name": "Rectangle 21315",
  transform: "translate(2.856 8.567)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-sales-office_svg__Rectangle_21316",
  d: "M0 0h1.428v1.428H0z",
  className: "px-sales-office_svg__cls-4",
  "data-name": "Rectangle 21316",
  transform: "translate(5.711 8.567)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-sales-office_svg__Rectangle_21317",
  d: "M0 0h1.428v1.428H0z",
  className: "px-sales-office_svg__cls-4",
  "data-name": "Rectangle 21317",
  transform: "translate(0 11.423)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-sales-office_svg__Rectangle_21318",
  d: "M0 0h1.428v1.428H0z",
  className: "px-sales-office_svg__cls-4",
  "data-name": "Rectangle 21318",
  transform: "translate(2.856 11.423)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-sales-office_svg__Rectangle_21319",
  d: "M0 0h1.428v1.428H0z",
  className: "px-sales-office_svg__cls-4",
  "data-name": "Rectangle 21319",
  transform: "translate(5.711 11.423)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-sales-office_svg__Rectangle_21320",
  d: "M0 0h4.284v2.856H0z",
  className: "px-sales-office_svg__cls-4",
  "data-name": "Rectangle 21320",
  transform: "translate(1.428 14.636)"
})), /*#__PURE__*/React.createElement("path", {
  id: "px-sales-office_svg__Rectangle_21321",
  d: "M0 0h.714v2.856H0z",
  "data-name": "Rectangle 21321",
  style: {
    fill: "#61acc9"
  },
  transform: "translate(10.352 17.848)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-sales-office_svg__Path_65040",
  d: "M11.669 321.837a1.44 1.44 0 0 0 .027-.807 1.42 1.42 0 0 0-1.04-1.03 1.43 1.43 0 0 0-1.722 1.762 2.06 2.06 0 0 1-.168 1.59 1.785 1.785 0 1 0 3.121.052 2 2 0 0 1-.218-1.567",
  className: "px-sales-office_svg__cls-6",
  "data-name": "Path 65040",
  transform: "translate(-8.17 -306.755)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-sales-office_svg__Rectangle_21322",
  d: "M0 0h.714v6.425H0z",
  className: "px-sales-office_svg__cls-7",
  "data-name": "Rectangle 21322",
  transform: "translate(1.785 14.636)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-sales-office_svg__Path_65041",
  d: "M421.269 321.837a1.44 1.44 0 0 0 .027-.807 1.42 1.42 0 0 0-1.04-1.027 1.43 1.43 0 0 0-1.722 1.762 2.06 2.06 0 0 1-.168 1.591 1.785 1.785 0 1 0 3.121.052 2 2 0 0 1-.218-1.571",
  className: "px-sales-office_svg__cls-6",
  "data-name": "Path 65041",
  transform: "translate(-400.636 -306.755)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-sales-office_svg__Rectangle_21323",
  d: "M0 0h.714v6.425H0z",
  className: "px-sales-office_svg__cls-7",
  "data-name": "Rectangle 21323",
  transform: "translate(18.919 14.636)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-sales-office_svg__Rectangle_21324",
  d: "M0 0h21.418v.714H0z",
  "data-name": "Rectangle 21324",
  style: {
    fill: "#e0d2c1"
  },
  transform: "translate(0 20.347)"
}))));

const SvgPxSalesPackage = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".px-sales-package_svg__cls-2,.px-sales-package_svg__cls-3{fill:#fe9737;fill-rule:evenodd}.px-sales-package_svg__cls-3{fill:#f36b37}.px-sales-package_svg__cls-4{fill:#f9f7f7}")), /*#__PURE__*/React.createElement("g", {
  id: "px-sales-package_svg__Group_50386",
  "data-name": "Group 50386",
  transform: "translate(8960 -23081)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-sales-package_svg__icon_placeholder",
  d: "M0 0h32v32H0z",
  style: {
    fill: "none"
  },
  transform: "translate(-8960 23081)"
}), /*#__PURE__*/React.createElement("g", {
  id: "px-sales-package_svg__salary",
  transform: "translate(-8955.5 23087.162)"
}, /*#__PURE__*/React.createElement("g", {
  id: "px-sales-package_svg__Group_50373",
  "data-name": "Group 50373",
  transform: "translate(5.99 6.326)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-sales-package_svg__Path_65130",
  d: "M134.631 179.568a5.142 5.142 0 1 1 .46 7.26 5.14 5.14 0 0 1-.46-7.26",
  className: "px-sales-package_svg__cls-2",
  "data-name": "Path 65130",
  transform: "translate(-133.349 -177.824)"
})), /*#__PURE__*/React.createElement("g", {
  id: "px-sales-package_svg__Group_50374",
  "data-name": "Group 50374",
  transform: "translate(9.508 6.326)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-sales-package_svg__Path_65131",
  d: "M216.68 179.1a5.13 5.13 0 0 0-4.418-1.181 5 5 0 0 0-.6.16 5.146 5.146 0 0 1 .5 9.9q.225.05.454.079a5.144 5.144 0 0 0 4.063-8.962Z",
  className: "px-sales-package_svg__cls-3",
  "data-name": "Path 65131",
  transform: "translate(-211.66 -177.82)"
})), /*#__PURE__*/React.createElement("path", {
  id: "px-sales-package_svg__Path_65132",
  d: "M215.068 231.3h-.859a.439.439 0 0 1 0-.878h1.638a.347.347 0 0 0 0-.694h-.865v-.587a.347.347 0 1 0-.694 0v.587h-.079a1.133 1.133 0 0 0 0 2.267h.859a.439.439 0 0 1-.007.878h-1.638a.347.347 0 0 0 0 .694h1.638a1.133 1.133 0 0 0 .007-2.267",
  className: "px-sales-package_svg__cls-4",
  "data-name": "Path 65132",
  transform: "translate(-203.504 -220.176)"
}), /*#__PURE__*/React.createElement("g", {
  id: "px-sales-package_svg__Group_50375",
  "data-name": "Group 50375",
  transform: "translate(1.629 11.589)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-sales-package_svg__Path_65133",
  d: "m37.9 296.635-1.629 2.558L37.9 301.7l3.146.546 4.3.746a4.1 4.1 0 0 0 2.035-.089l7.816-2.338a1.035 1.035 0 1 0-.584-1.977l-.8.188-4.18.977a2.7 2.7 0 0 1-.756.066c-.349-.016-.693-.077-1.084-.108L45 299.243a.786.786 0 1 1 .165-1.563h.888a1.348 1.348 0 1 0 .2-2.686H45.09c-.413 0-.787.012-1.166.045a14.3 14.3 0 0 0-3.037.673l-1.9.585Z",
  "data-name": "Path 65133",
  style: {
    fillRule: "evenodd",
    fill: "#ffe5c1"
  },
  transform: "translate(-36.269 -294.994)"
})), /*#__PURE__*/React.createElement("g", {
  id: "px-sales-package_svg__Group_50376",
  "data-name": "Group 50376",
  transform: "translate(0 12.609)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-sales-package_svg__Path_65134",
  d: "M0 318.265v5.23a.565.565 0 0 0 .564.562h2.129a.567.567 0 0 0 .565-.564v-5.227a.567.567 0 0 0-.565-.566H.564a.566.566 0 0 0-.564.562Z",
  "data-name": "Path 65134",
  style: {
    fillRule: "evenodd",
    fill: "#fe636e"
  },
  transform: "translate(0 -317.699)"
})), /*#__PURE__*/React.createElement("g", {
  id: "px-sales-package_svg__Group_50377",
  "data-name": "Group 50377",
  transform: "translate(3.259 15.489)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-sales-package_svg__Path_65135",
  d: "M72.539 382.952v1.667l3.146.546 4.3.746a4.1 4.1 0 0 0 2.035-.089l7.816-2.338a1.052 1.052 0 0 0 .61-1.671 1.17 1.17 0 0 1-.61.383l-1.387.385-4.483 1.439-2.218.614a3.07 3.07 0 0 1-1.854-.136c-2.484-.485-4.874-1.061-7.355-1.546",
  "data-name": "Path 65135",
  style: {
    fillRule: "evenodd",
    fill: "#fed1a3"
  },
  transform: "translate(-72.539 -381.813)"
})), /*#__PURE__*/React.createElement("g", {
  id: "px-sales-package_svg__Group_50378",
  "data-name": "Group 50378",
  transform: "translate(0 16.629)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-sales-package_svg__Path_65136",
  d: "M3.259 408.844v-1.667a.567.567 0 0 1-.565.564H.564A.565.565 0 0 1 0 407.18v1.773a.565.565 0 0 0 .564.562h2.129a.567.567 0 0 0 .565-.564Z",
  "data-name": "Path 65136",
  style: {
    fillRule: "evenodd",
    fill: "#fb2a39"
  },
  transform: "translate(0 -407.177)"
})), /*#__PURE__*/React.createElement("g", {
  id: "px-sales-package_svg__Group_50379",
  "data-name": "Group 50379",
  transform: "translate(12.718)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-sales-package_svg__Path_65137",
  d: "M284.391 38.748a5.142 5.142 0 1 1 .46 7.26 5.14 5.14 0 0 1-.46-7.26",
  className: "px-sales-package_svg__cls-2",
  "data-name": "Path 65137",
  transform: "translate(-283.108 -37.004)"
})), /*#__PURE__*/React.createElement("g", {
  id: "px-sales-package_svg__Group_50380",
  "data-name": "Group 50380",
  transform: "translate(16.235)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-sales-package_svg__Path_65138",
  d: "M366.434 38.283a5.14 5.14 0 0 0-4.42-1.181 5 5 0 0 0-.6.16 5.147 5.147 0 0 1 .505 9.9q.224.05.454.08a5.2 5.2 0 0 0 1.326 0 5.146 5.146 0 0 0 2.737-8.963Z",
  className: "px-sales-package_svg__cls-3",
  "data-name": "Path 65138",
  transform: "translate(-361.412 -36.999)"
})), /*#__PURE__*/React.createElement("path", {
  id: "px-sales-package_svg__Path_65139",
  d: "M364.846 90.508h-.858a.439.439 0 0 1 0-.878h1.638a.347.347 0 0 0 0-.694h-.865v-.586a.347.347 0 1 0-.694 0v.586h-.079a1.133 1.133 0 0 0 0 2.267h.858a.44.44 0 0 1-.005.88H363.2a.347.347 0 0 0 0 .694h.864v.586a.347.347 0 1 0 .694 0v-.586h.081a1.134 1.134 0 0 0 .005-2.268Z",
  className: "px-sales-package_svg__cls-4",
  "data-name": "Path 65139",
  transform: "translate(-346.555 -85.711)"
}))));

const SvgPxSalutation = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".px-salutation_svg__b{fill:#f3f5f9}.px-salutation_svg__c{fill:#d8e0f0}.px-salutation_svg__f{fill:#67548c}.px-salutation_svg__g{fill:#544473}")), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h32v32H0z",
  style: {
    fill: "none"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.878 7.628a.754.754 0 0 1-.755-.755V3.755a.755.755 0 1 1 1.509 0v3.118a.754.754 0 0 1-.754.755",
  className: "px-salutation_svg__b"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.633 6.873V3.755A.754.754 0 0 0 15.878 3v4.628a.754.754 0 0 0 .755-.755",
  className: "px-salutation_svg__c"
}), /*#__PURE__*/React.createElement("path", {
  d: "m12.144 8.736-1.068-1.068a.754.754 0 0 1 1.067-1.067l1.068 1.068a.754.754 0 0 1-1.067 1.067M18.545 8.736a.754.754 0 0 1 0-1.067l1.068-1.068a.754.754 0 0 1 1.067 1.067l-1.068 1.068a.754.754 0 0 1-1.067 0",
  className: "px-salutation_svg__b"
}), /*#__PURE__*/React.createElement("path", {
  d: "M51.373 255.582H33.264A2.266 2.266 0 0 1 31 253.319v-9.055A2.266 2.266 0 0 1 33.264 242h18.11a2.266 2.266 0 0 1 2.264 2.264v9.055a2.266 2.266 0 0 1-2.265 2.263",
  style: {
    fill: "#9bf"
  },
  transform: "translate(-26.441 -226.826)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M265.055 242H256v13.582h9.055a2.266 2.266 0 0 0 2.264-2.264v-9.055a2.266 2.266 0 0 0-2.264-2.263",
  style: {
    fill: "#738aff"
  },
  transform: "translate(-240.122 -226.826)"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 4.614,
  cy: 4.46,
  className: "px-salutation_svg__b",
  rx: 4.614,
  ry: 4.46,
  transform: "translate(11.284 6.917)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.405 11.4a4.53 4.53 0 0 0-4.527-4.527v9.055a4.53 4.53 0 0 0 4.527-4.528",
  className: "px-salutation_svg__c"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.345 11.937a.754.754 0 0 1 0-1.067l1.509-1.509a.754.754 0 0 1 1.067 1.067l-1.509 1.509a.754.754 0 0 1-1.067 0",
  className: "px-salutation_svg__f"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.387 4.509h-3.018a.755.755 0 0 1 0-1.509h3.018a.755.755 0 1 1 0 1.509",
  className: "px-salutation_svg__b"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.387 4.509a.755.755 0 0 0 0-1.509h-1.509v1.509Z",
  className: "px-salutation_svg__c"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.842 21.21a.755.755 0 0 1-.755-.755.783.783 0 0 1 1.287-.534.754.754 0 0 0 1.068-1.066 2.264 2.264 0 1 0-1.6 3.863.755.755 0 0 1 .755.755.782.782 0 0 1-1.287.534.754.754 0 1 0-1.068 1.066 2.264 2.264 0 1 0 1.6-3.864ZM17.388 24.229h-2.264v-5.282a.755.755 0 0 0-1.509 0v6.037a.754.754 0 0 0 .755.755h3.018a.755.755 0 1 0 0-1.509Z",
  className: "px-salutation_svg__b"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.915 18.192a2.266 2.266 0 0 0-2.264 2.264v4.527a.755.755 0 1 0 1.509 0v-2.264h1.509v2.264a.755.755 0 1 0 1.509 0v-4.527a2.266 2.266 0 0 0-2.263-2.264m-.755 3.018v-.755a.755.755 0 1 1 1.509 0v.755Z",
  className: "px-salutation_svg__c"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.815 7.848 7.306 6.34a.754.754 0 0 0-1.067 1.067l.221.221h-1.2A2.266 2.266 0 0 0 3 9.892v3.018a.755.755 0 0 0 1.509 0V9.892a.755.755 0 0 1 .755-.755h1.2l-.221.221a.754.754 0 0 0 1.067 1.067l1.505-1.507a.757.757 0 0 0 0-1.07",
  className: "px-salutation_svg__f"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.534 10.867a.754.754 0 0 0-1.067 0l-.221.221v-1.2a2.266 2.266 0 0 0-2.263-2.26h-1.509a.755.755 0 0 0 0 1.509h1.509a.755.755 0 0 1 .755.755v1.2l-.221-.221a.754.754 0 0 0-1.067 1.067l1.508 1.508a.756.756 0 0 0 1.069 0l1.508-1.508a.754.754 0 0 0-.001-1.071",
  className: "px-salutation_svg__g"
}), /*#__PURE__*/React.createElement("path", {
  d: "M156.282 72.564a5.282 5.282 0 1 1 5.282-5.282 5.29 5.29 0 0 1-5.282 5.282m0-9.055a3.773 3.773 0 1 0 3.773 3.773 3.777 3.777 0 0 0-3.773-3.773",
  style: {
    fill: "#f98845"
  },
  transform: "translate(-140.404 -55.881)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.387 24.229h-1.509v1.509h1.509a.755.755 0 0 0 0-1.509",
  className: "px-salutation_svg__c"
}), /*#__PURE__*/React.createElement("path", {
  d: "M259.773 67.282A3.777 3.777 0 0 1 256 71.055v1.509A5.282 5.282 0 1 0 256 62v1.509a3.777 3.777 0 0 1 3.773 3.773",
  style: {
    fill: "#f36a3d"
  },
  transform: "translate(-240.122 -55.881)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m16.854 9.358-.976.979v1.822a.75.75 0 0 0 .534-.221l1.509-1.509a.754.754 0 1 0-1.067-1.067Z",
  className: "px-salutation_svg__g"
}));

const SvgPxSignDate = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  id: "px-sign-date_svg__Group_50404",
  width: "1em",
  height: "1em",
  "data-name": "Group 50404",
  viewBox: "0 0 14 14"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".px-sign-date_svg__cls-4{fill:#f9e109}.px-sign-date_svg__cls-5{fill:#39519d}.px-sign-date_svg__cls-6{fill:#fcbc04}.px-sign-date_svg__cls-7{fill:#e59730}.px-sign-date_svg__cls-8{fill:#a1d51c}")), /*#__PURE__*/React.createElement("g", {
  id: "px-sign-date_svg__contract",
  transform: "translate(.836 .85)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-sign-date_svg__Path_25383",
  d: "M8.42 8.039h8.4a.42.42 0 0 1 .42.42V19.8a.42.42 0 0 1-.42.42h-8.4A.42.42 0 0 1 8 19.8V8.459a.42.42 0 0 1 .42-.42m0 0",
  "data-name": "Path 25383",
  style: {
    fill: "#57b7eb"
  },
  transform: "translate(-7.79 -7.829)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-sign-date_svg__Path_25384",
  d: "M13.25 18.539a3.78 3.78 0 0 1-3.78-3.78v-6.72H8.42a.42.42 0 0 0-.42.42V19.8a.42.42 0 0 0 .42.42h8.4a.42.42 0 0 0 .42-.42v-1.26Zm0 0",
  "data-name": "Path 25384",
  style: {
    fill: "#4891d3"
  },
  transform: "translate(-7.79 -7.829)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-sign-date_svg__Path_25385",
  d: "M80 56.039h5.46v.84H80Zm0 0",
  className: "px-sign-date_svg__cls-4",
  "data-name": "Path 25385",
  transform: "translate(-77.9 -54.569)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-sign-date_svg__Path_25386",
  d: "M100.41 112.459h-4.2a.21.21 0 1 1 0-.42h4.2a.21.21 0 1 1 0 .42m0 0",
  className: "px-sign-date_svg__cls-5",
  "data-name": "Path 25386",
  transform: "translate(-93.48 -109.099)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-sign-date_svg__Path_25387",
  d: "M132.83 168.459h-4.62a.21.21 0 1 1 0-.42h4.62a.21.21 0 1 1 0 .42m0 0",
  className: "px-sign-date_svg__cls-5",
  "data-name": "Path 25387",
  transform: "translate(-124.64 -163.629)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-sign-date_svg__Path_25388",
  d: "M60.41 216.459h-4.2a.21.21 0 1 1 0-.42h4.2a.21.21 0 1 1 0 .42m0 0",
  className: "px-sign-date_svg__cls-5",
  "data-name": "Path 25388",
  transform: "translate(-54.53 -210.369)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-sign-date_svg__Path_25389",
  d: "M249.68 216.459h-1.47a.21.21 0 1 1 0-.42h1.47a.21.21 0 1 1 0 .42m0 0",
  className: "px-sign-date_svg__cls-5",
  "data-name": "Path 25389",
  transform: "translate(-241.49 -210.369)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-sign-date_svg__Path_25390",
  d: "M58.31 256.459h-2.1a.21.21 0 1 1 0-.42h2.1a.21.21 0 1 1 0 .42m0 0",
  className: "px-sign-date_svg__cls-5",
  "data-name": "Path 25390",
  transform: "translate(-54.53 -249.319)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-sign-date_svg__Path_25391",
  d: "M169.68 256.459h-1.47a.21.21 0 0 1 0-.42h1.47a.21.21 0 1 1 0 .42m0 0",
  className: "px-sign-date_svg__cls-5",
  "data-name": "Path 25391",
  transform: "translate(-163.59 -249.319)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-sign-date_svg__Path_25392",
  d: "M85.46 56.879H80v-.84Zm0 0",
  className: "px-sign-date_svg__cls-6",
  "data-name": "Path 25392",
  transform: "translate(-77.9 -54.569)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-sign-date_svg__Path_25393",
  d: "M43.15 321.614a1.575 1.575 0 1 1-1.575-1.575 1.575 1.575 0 0 1 1.575 1.575m0 0",
  className: "px-sign-date_svg__cls-4",
  "data-name": "Path 25393",
  transform: "translate(-38.95 -311.639)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-sign-date_svg__Path_25394",
  d: "M41.563 327.476a1.575 1.575 0 0 0 1.5-1.088 3.78 3.78 0 0 1-2.089-1.947 1.575 1.575 0 0 0 .592 3.034Zm0 0",
  className: "px-sign-date_svg__cls-6",
  "data-name": "Path 25394",
  transform: "translate(-38.939 -315.926)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-sign-date_svg__Path_25395",
  d: "M192.207 337.706a.2.2 0 0 1-.067-.01.21.21 0 0 1-.132-.264l.517-1.55a.42.42 0 0 1 .817.1l.071.84.076-.128a.416.416 0 0 1 .75.052l.134.332.611-.777a.21.21 0 0 1 .33.26l-.613.779a.42.42 0 0 1-.718-.107l-.13-.33-.078.128a.42.42 0 0 1-.779-.164l-.071-.852-.506 1.541a.21.21 0 0 1-.212.15m0 0",
  className: "px-sign-date_svg__cls-5",
  "data-name": "Path 25395",
  transform: "translate(-186.957 -326.787)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-sign-date_svg__Path_25396",
  d: "M68.116 357.808a.42.42 0 0 1-.3-.122l-.445-.445a.21.21 0 0 1 .3-.3l.445.445.743-.741a.21.21 0 0 1 .3.3l-.741.743a.42.42 0 0 1-.302.12m0 0",
  className: "px-sign-date_svg__cls-5",
  "data-name": "Path 25396",
  transform: "translate(-65.546 -347.237)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-sign-date_svg__Path_25397",
  d: "m333.14 163.449 1.091.63-1.89 3.273-1.091-.63Zm0 0",
  className: "px-sign-date_svg__cls-6",
  "data-name": "Path 25397",
  transform: "translate(-322.555 -159.16)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-sign-date_svg__Path_25398",
  d: "m332.186 223.082-.987 1.705 1.092.63.319-.556a5.7 5.7 0 0 1-.424-1.779m0 0",
  className: "px-sign-date_svg__cls-7",
  "data-name": "Path 25398",
  transform: "translate(-322.506 -217.227)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-sign-date_svg__Path_25399",
  d: "m315.7 288.829-1.092-.63-.447 1.195.727.42Zm0 0",
  className: "px-sign-date_svg__cls-8",
  "data-name": "Path 25399",
  transform: "translate(-305.914 -280.635)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-sign-date_svg__Path_25400",
  d: "m304.249 333.758.727.42-.21.364a.42.42 0 1 1-.727-.42Zm0 0",
  className: "px-sign-date_svg__cls-7",
  "data-name": "Path 25400",
  transform: "translate(-296.004 -324.998)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-sign-date_svg__Path_25401",
  d: "m403.81 121.914 1.091.63-.63 1.091-1.091-.63Zm0 0",
  className: "px-sign-date_svg__cls-6",
  "data-name": "Path 25401",
  transform: "translate(-392.597 -118.715)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-sign-date_svg__Path_25402",
  d: "M434.893 104.113a.42.42 0 0 1 .154.574l-.21.364-.727-.42.21-.364a.42.42 0 0 1 .574-.154Zm0 0",
  "data-name": "Path 25402",
  style: {
    fill: "#c4f236"
  },
  transform: "translate(-422.715 -101.326)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-sign-date_svg__Path_25403",
  d: "m392.32 168.973.21-.364 1.091.63-.21.364Zm0 0",
  className: "px-sign-date_svg__cls-7",
  "data-name": "Path 25403",
  transform: "translate(-382.022 -164.185)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-sign-date_svg__Path_25404",
  d: "M382.7 150.943a.21.21 0 0 1-.2-.155.2.2 0 0 1 .022-.16l.84-1.455a.21.21 0 0 0-.078-.288l-1.819-1.05a.21.21 0 1 1 .21-.363l1.819 1.05a.63.63 0 0 1 .231.861l-.84 1.455a.21.21 0 0 1-.185.105m0 0",
  className: "px-sign-date_svg__cls-5",
  "data-name": "Path 25404",
  transform: "translate(-371.345 -143.574)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-sign-date_svg__Path_25405",
  d: "M434.733 104.213a1 1 0 0 1 .029-.21.42.42 0 0 0-.393.21l-.21.363.727.42.105-.181a.83.83 0 0 1-.258-.602m0 0",
  className: "px-sign-date_svg__cls-8",
  "data-name": "Path 25405",
  transform: "translate(-422.764 -101.273)"
}), /*#__PURE__*/React.createElement("g", {
  id: "px-sign-date_svg__Group_25995",
  "data-name": "Group 25995"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-sign-date_svg__Path_25406",
  d: "M199.613 96.486a.63.63 0 0 0-1.155-.151l-.1.183a.21.21 0 0 0-.286.076l-.533.909-.183-.1a.21.21 0 1 0-.21.363l.183.1-1.785 3.093-.441 1.178-.21.393a.63.63 0 0 0 .034.68l-.472.58-.132-.332a.42.42 0 0 0-.75-.059l-.076.128-.071-.84a.42.42 0 0 0-.817-.1l-.517 1.55a.21.21 0 0 0 .132.265.2.2 0 0 0 .065.017.21.21 0 0 0 .2-.143l.514-1.55.074.852a.42.42 0 0 0 .779.181l.078-.128.13.33a.42.42 0 0 0 .718.107l.489-.619a.7.7 0 0 0 .166.021.63.63 0 0 0 .548-.311l.21-.351.8-.972 1.8-3.131.183.1a.21.21 0 0 1 .078.288l-.84 1.455a.208.208 0 1 0 .355.218l.84-1.455a.63.63 0 0 0-.231-.861l-.183-.1.525-.909a.21.21 0 0 0-.076-.286l.1-.183a.63.63 0 0 0 .063-.487Zm-.792.059a.2.2 0 0 1 .128-.1.22.22 0 0 1 .16.021.2.2 0 0 1 .1.128.22.22 0 0 1-.021.16l-.1.183-.365-.21Zm-2.862 5.863-.1-.061-.311-.181.3-.8.661.382Zm-.63.607a.21.21 0 0 1-.063-.275l.105-.183.365.21-.1.181a.21.21 0 0 1-.3.067Zm1.413-1.608-.727-.42 1.68-2.911.727.42Zm1.89-3.274-.727-.42.42-.727.727.42Zm0 0",
  className: "px-sign-date_svg__cls-5",
  "data-name": "Path 25406",
  transform: "translate(-187.035 -93.5)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-sign-date_svg__Path_25407",
  d: "m68.859 356.647-.743.741-.445-.445a.21.21 0 1 0-.3.3l.445.445a.423.423 0 0 0 .594 0l.741-.743a.21.21 0 0 0-.3-.3Zm0 0",
  className: "px-sign-date_svg__cls-5",
  "data-name": "Path 25407",
  transform: "translate(-65.545 -347.237)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-sign-date_svg__Path_25408",
  d: "M32 313.826a1.785 1.785 0 0 0 3.57 0 .21.21 0 0 0-.42 0 1.365 1.365 0 1 1-.546-1.092.21.21 0 0 0 .252-.336A1.785 1.785 0 0 0 32 313.826m0 0",
  className: "px-sign-date_svg__cls-5",
  "data-name": "Path 25408",
  transform: "translate(-31.16 -303.851)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-sign-date_svg__Path_25409",
  d: "M77.67 48.459a.21.21 0 1 0 0-.42h-5.46a.21.21 0 0 0-.21.21v.84a.21.21 0 0 0 .21.21h5.46a.21.21 0 1 0 0-.42h-5.25v-.42Zm0 0",
  className: "px-sign-date_svg__cls-5",
  "data-name": "Path 25409",
  transform: "translate(-70.11 -46.779)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-sign-date_svg__Path_25410",
  d: "M96.21 112.039a.21.21 0 1 0 0 .42h4.2a.21.21 0 1 0 0-.42Zm0 0",
  className: "px-sign-date_svg__cls-5",
  "data-name": "Path 25410",
  transform: "translate(-93.48 -109.099)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-sign-date_svg__Path_25411",
  d: "M132.83 168.039h-4.62a.21.21 0 1 0 0 .42h4.62a.21.21 0 1 0 0-.42m0 0",
  className: "px-sign-date_svg__cls-5",
  "data-name": "Path 25411",
  transform: "translate(-124.64 -163.629)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-sign-date_svg__Path_25412",
  d: "M60.62 216.249a.21.21 0 0 0-.21-.21h-4.2a.21.21 0 1 0 0 .42h4.2a.21.21 0 0 0 .21-.21m0 0",
  className: "px-sign-date_svg__cls-5",
  "data-name": "Path 25412",
  transform: "translate(-54.53 -210.369)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-sign-date_svg__Path_25413",
  d: "M249.68 216.039h-1.47a.21.21 0 1 0 0 .42h1.47a.21.21 0 1 0 0-.42m0 0",
  className: "px-sign-date_svg__cls-5",
  "data-name": "Path 25413",
  transform: "translate(-241.49 -210.369)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-sign-date_svg__Path_25414",
  d: "M58.31 256.459a.21.21 0 1 0 0-.42h-2.1a.21.21 0 1 0 0 .42Zm0 0",
  className: "px-sign-date_svg__cls-5",
  "data-name": "Path 25414",
  transform: "translate(-54.53 -249.319)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-sign-date_svg__Path_25415",
  d: "M168.21 256.459h1.47a.21.21 0 1 0 0-.42h-1.47a.21.21 0 0 0 0 .42m0 0",
  className: "px-sign-date_svg__cls-5",
  "data-name": "Path 25415",
  transform: "translate(-163.59 -249.319)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-sign-date_svg__Path_25416",
  d: "M9.45 9.7a.21.21 0 0 0-.21.21v2.1a.21.21 0 0 1-.21.21H.63a.21.21 0 0 1-.21-.21V.669a.21.21 0 0 1 .21-.21h8.4a.21.21 0 0 1 .21.21v3.944a.21.21 0 1 0 .42 0V.669a.63.63 0 0 0-.63-.63H.63a.63.63 0 0 0-.63.63v11.339a.63.63 0 0 0 .63.63h8.4a.63.63 0 0 0 .63-.63v-2.1a.21.21 0 0 0-.21-.208m0 0",
  className: "px-sign-date_svg__cls-5",
  "data-name": "Path 25416",
  transform: "translate(0 -.039)"
}))));

const SvgPxSolicitor = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".px-solicitor_svg__b{fill:#707487}.px-solicitor_svg__d{fill:#d2a073}.px-solicitor_svg__f{fill:#464655}.px-solicitor_svg__l{fill:#fff}.px-solicitor_svg__m{fill:#5a4137}.px-solicitor_svg__n{fill:#e4eaf6}.px-solicitor_svg__o{fill:#5b5d6e}")), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h32v32H0z",
  style: {
    fill: "none"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "m24.312 20.613-1.459-.365-.293-.073H9.714l-1.741.435a2.76 2.76 0 0 0-2.093 2.681v3.369a.79.79 0 0 0 .789.789h18.947a.79.79 0 0 0 .789-.789v-3.369a2.76 2.76 0 0 0-2.093-2.678",
  className: "px-solicitor_svg__b"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h6.315v4.737H0z",
  style: {
    fill: "#e6b47d"
  },
  transform: "translate(12.985 17.184)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.985 17.184v3.222c3.735.489 6.315-2.827 6.315-2.827v-.395Z",
  className: "px-solicitor_svg__d"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h5.526v5.921H0z",
  style: {
    fill: "#d7deed"
  },
  transform: "translate(13.38 21.526)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.984 27.447 11.01 22.71l.789-.789-1.579-.395-.586-1.172a.4.4 0 0 1 .228-.551l3.121-1.04 1.579 8.684M19.3 27.447l1.974-4.737-.789-.789 1.579-.395.586-1.172a.4.4 0 0 0-.228-.551l-3.121-1.04-1.579 8.684",
  className: "px-solicitor_svg__f"
}), /*#__PURE__*/React.createElement("path", {
  d: "m238.585 397.241-.241 5.131h1.579l-.241-5.131Z",
  style: {
    fill: "#69a0c3"
  },
  transform: "translate(-222.991 -374.926)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M142.677 99.886V97.1H133.2v2.783a.99.99 0 0 0-.789.967v.789a.99.99 0 0 0 .789.967v.726a2.43 2.43 0 0 0 .973 1.971l1.755 1.267a2.07 2.07 0 0 0 1.213.4h1.591a2.07 2.07 0 0 0 1.213-.4l1.755-1.267a2.43 2.43 0 0 0 .973-1.971v-.726a.99.99 0 0 0 .789-.967v-.789a.99.99 0 0 0-.785-.964",
  style: {
    fill: "#f0c891"
  },
  transform: "translate(-121.797 -88.208)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M238.345 379.586v.789a.4.4 0 0 0 .395.395h.789a.4.4 0 0 0 .395-.395v-.789Z",
  style: {
    fill: "#578cb1"
  },
  transform: "translate(-222.992 -358.06)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M129.111 0c-2.763 0-3.158 1.184-3.158 1.184-1.579 0-2.368.395-2.368 1.974 0 1.061.395 4.342.395 4.342l.789.395.736-2.765a29.5 29.5 0 0 0 8.343 1.186l.395 1.579.789-.395a30.5 30.5 0 0 0 .395-3.947c0-2.369-3.158-3.553-6.316-3.553",
  style: {
    fill: "#694b41"
  },
  transform: "translate(-113.363 4.553)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M125.954 26.483c-1.579 0-2.368.395-2.368 1.974 0 1.061.395 4.342.395 4.342l.789.395.736-2.765a29.5 29.5 0 0 0 8.343 1.186c-5.526-1.185-7.895-3.948-7.895-5.132",
  style: {
    fill: "#553732"
  },
  transform: "translate(-113.364 -20.746)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.38 13.237a.4.4 0 0 1-.125-.02l-2.368-.789a.395.395 0 0 1 .25-.749l2.368.789a.395.395 0 0 1-.125.769M18.906 13.237a.395.395 0 0 1-.125-.769l2.368-.789a.395.395 0 1 1 .25.749l-2.368.789a.4.4 0 0 1-.125.02",
  className: "px-solicitor_svg__f"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.142 17.031a3.3 3.3 0 0 1-1.347-.277.395.395 0 0 1 .326-.719 2.67 2.67 0 0 0 2.042 0 .395.395 0 0 1 .326.719 3.3 3.3 0 0 1-1.347.277",
  className: "px-solicitor_svg__d"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.959 14.026H13.38a.4.4 0 0 1-.395-.395v-.789a.4.4 0 0 1 .395-.395h1.579a.4.4 0 0 1 .395.395v.789a.4.4 0 0 1-.395.395",
  className: "px-solicitor_svg__l"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.169 13.631a.4.4 0 0 1-.395-.395v-.395a.4.4 0 0 1 .395-.395.4.4 0 0 1 .395.395v.395a.4.4 0 0 1-.395.395",
  className: "px-solicitor_svg__m"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.327 14.026h1.579a.4.4 0 0 0 .395-.395v-.789a.4.4 0 0 0-.395-.395h-1.579a.4.4 0 0 0-.395.395v.789a.4.4 0 0 0 .395.395",
  className: "px-solicitor_svg__l"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.112 13.631a.4.4 0 0 1-.395-.395v-.395a.4.4 0 0 1 .395-.395.4.4 0 0 1 .395.395v.395a.4.4 0 0 1-.395.395",
  className: "px-solicitor_svg__m"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.932 13.63a.4.4 0 0 1-.395-.395.395.395 0 0 0-.789 0 .395.395 0 1 1-.789 0 1.184 1.184 0 0 1 2.368 0 .4.4 0 0 1-.395.395",
  className: "px-solicitor_svg__f"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.353 13.63a.4.4 0 0 1-.395-.395v-.395h-1.579v.395a.395.395 0 1 1-.789 0v-.395a.79.79 0 0 1 .789-.789h1.579a.79.79 0 0 1 .789.789v.395a.4.4 0 0 1-.394.395M19.3 13.63a.4.4 0 0 1-.395-.395v-.395h-1.579v.395a.395.395 0 1 1-.789 0v-.395a.79.79 0 0 1 .789-.789h1.584a.79.79 0 0 1 .789.789v.395a.4.4 0 0 1-.399.395",
  className: "px-solicitor_svg__b"
}), /*#__PURE__*/React.createElement("path", {
  d: "m12.986 18.368 3.158 3.158a5.5 5.5 0 0 0-2.763 1.974s-1.12-3.078-1.473-4.051a.394.394 0 0 1 .152-.463Z",
  className: "px-solicitor_svg__n"
}), /*#__PURE__*/React.createElement("path", {
  d: "m19.301 18.368-3.158 3.158a5.5 5.5 0 0 1 2.763 1.974s1.12-3.078 1.473-4.051a.394.394 0 0 0-.152-.463Z",
  className: "px-solicitor_svg__n"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.593 21.449a2.75 2.75 0 0 0-.713 1.839v3.369a.79.79 0 0 0 .789.789h2.763v-2.172a2.37 2.37 0 0 0-.694-1.675ZM25.693 21.449a2.75 2.75 0 0 1 .713 1.839v3.369a.79.79 0 0 1-.789.789h-2.764v-2.172a2.37 2.37 0 0 1 .694-1.675Z",
  className: "px-solicitor_svg__o"
}));

const SvgPxSolicitor2 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 13 13"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 66684"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h13v13H0Z",
  "data-name": "Path 31031"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#212121"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.995 9.528a2 2 0 0 1-.5.077 1.83 1.83 0 0 1-1.82-1.82 1.86 1.86 0 0 1 .4-1.149c-.115-.038-.249-.057-.383-.1A6.4 6.4 0 0 1 6.619 8.72l-.326-1.36.192-.441h-.838l.192.441-.326 1.36A6.1 6.1 0 0 1 4.44 6.54a3.7 3.7 0 0 0-1.36.517c-.575.441-.92 2.146-1.073 3.238a.8.8 0 0 0 .785.9h6.552a.8.8 0 0 0 .785-.9c-.038-.23-.076-.498-.134-.767",
  "data-name": "Path 82256"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.366 4.49v.61a1.07 1.07 0 0 0 1.073 1.073h1.284A1.07 1.07 0 0 0 7.792 5.1v-.61a.4.4 0 1 0 0-.8v-.445A1.243 1.243 0 0 0 6.547 2h-.92a1.247 1.247 0 0 0-1.261 1.245v.441a.393.393 0 0 0-.4.4.38.38 0 0 0 .4.4Z",
  "data-name": "Path 82257"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.497 6.349a1.437 1.437 0 1 0 1.437 1.437 1.423 1.423 0 0 0-1.437-1.437m0 2.395a.958.958 0 1 1 .958-.958.95.95 0 0 1-.958.958",
  "data-name": "Path 82258"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.516 7.403a.144.144 0 0 1 .134.172h.211a.31.31 0 0 0-.268-.345v-.153h-.115v.153a.294.294 0 0 0-.287.287c0 .249.268.326.326.345s.153.057.153.153a.127.127 0 0 1-.134.134c-.057 0-.153-.019-.153-.172h-.212a.3.3 0 0 0 .077.23.44.44 0 0 0 .23.115v.134h.115v-.134a.27.27 0 0 0 .287-.287c0-.249-.268-.326-.326-.345s-.153-.077-.153-.153c0-.039.019-.134.115-.134",
  "data-name": "Path 82259"
}))));

const SvgPxStakeholder = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1 -2.752)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#474c5b",
  d: "M20.982 21.608h-4.1v-3.389h-.7v3.387h-3.854v.7h3.856v.1h.7v-.1h4.1Z",
  "data-name": "Path 71777"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f4c85b",
  d: "M18.874 21.957a2.222 2.222 0 1 1-.82-1.722 2.22 2.22 0 0 1 .82 1.722",
  "data-name": "Path 71778"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1.732,
  cy: 1.732,
  r: 1.732,
  fill: "#efb250",
  "data-name": "Ellipse 1448",
  transform: "rotate(-9.25 134.844 -80.694)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#efb250",
  d: "M16.577 23.959q-.07 0-.138-.01l.007-.068q.066.007.134.01Zm.412-.026-.011-.067q.067-.011.131-.027l.016.066q-.068.016-.137.028Zm-.954-.071q-.066-.022-.13-.048l.026-.063q.062.025.126.046Zm1.479-.095-.029-.062q.061-.029.119-.062l.033.059q-.06.036-.123.066Zm-1.974-.147q-.058-.039-.112-.081l.042-.052q.053.041.109.079Zm2.43-.155-.045-.051q.051-.044.1-.092l.048.048q-.047.049-.103.095m-2.845-.211q-.045-.053-.086-.109l.055-.041q.04.054.083.105Zm3.206-.205-.057-.037q.037-.056.069-.115l.06.033-.068.119Zm-3.5-.259q-.029-.063-.053-.128l.064-.024q.024.063.052.124Zm3.736-.239-.065-.02q.02-.064.035-.129l.066.016q-.014.069-.033.133Zm-3.894-.289q-.01-.068-.016-.138l.068-.006c0 .045.009.089.016.133Zm3.983-.254h-.068v-.134h.068v.088l.002.046Zm-3.923-.288-.068-.008q.008-.069.022-.137l.067.013q-.011.065-.019.132Zm3.8-.243q-.017-.065-.038-.129l.065-.021q.022.066.039.133Zm-3.663-.271-.063-.027q.027-.064.058-.126l.061.031zm3.457-.221q-.034-.058-.072-.114l.057-.038q.039.057.074.118Zm-3.185-.236-.053-.043q.044-.054.09-.105l.05.046q-.043.05-.085.102Zm2.857-.183q-.048-.047-.1-.09l.044-.052q.053.045.1.093Zm-2.469-.179-.04-.055q.056-.04.116-.077l.036.058q-.057.031-.112.074m2.041-.131q-.059-.032-.12-.059l.028-.062q.063.029.124.061Zm-1.57-.117-.023-.064q.065-.023.132-.042l.019.066q-.065.014-.128.037Zm1.072-.068q-.065-.014-.132-.024l.01-.068q.069.01.137.025Zm-.551-.041v-.068h.139v.068q-.073-.007-.14-.003Z",
  "data-name": "Path 71779"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#cc903a",
  d: "M17.454 22.066a.4.4 0 0 0-.129-.113.6.6 0 0 0-.13-.056.46.46 0 0 0 .2-.17.4.4 0 0 0 .064-.225.46.46 0 0 0-.073-.245.44.44 0 0 0-.2-.174.7.7 0 0 0-.243-.053v-.232h-.244v.228h-.123v-.228h-.249v.228h-.377v.219h.192v1.422h-.192v.219h.377v.229h.244v-.228h.123v.229h.244v-.231a1 1 0 0 0 .213-.03.6.6 0 0 0 .2-.092.5.5 0 0 0 .136-.173.54.54 0 0 0 .056-.243.46.46 0 0 0-.091-.282Zm-1.067-.819h.371a1 1 0 0 1 .283.026.22.22 0 0 1 .127.1.3.3 0 0 1 .045.163.27.27 0 0 1-.048.162.26.26 0 0 1-.141.093 1 1 0 0 1-.235.021h-.4Zm.866 1.258a.26.26 0 0 1-.094.1.4.4 0 0 1-.142.051 1 1 0 0 1-.167.009h-.463v-.639h.43a1 1 0 0 1 .272.031.3.3 0 0 1 .1.054.3.3 0 0 1 .049.054.3.3 0 0 1 .053.181.3.3 0 0 1-.037.156Z",
  "data-name": "Path 71780"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fcd462",
  d: "M17.399 22.066a.4.4 0 0 0-.129-.113.6.6 0 0 0-.13-.056.46.46 0 0 0 .2-.17.4.4 0 0 0 .064-.225.46.46 0 0 0-.073-.245.44.44 0 0 0-.2-.174.7.7 0 0 0-.243-.053v-.232h-.244v.228h-.123v-.228h-.244v.228H15.9v.219h.185v1.422h-.192v.219h.377v.229h.244v-.228h.123v.229h.248v-.231a1 1 0 0 0 .213-.03.6.6 0 0 0 .2-.092.5.5 0 0 0 .136-.173.54.54 0 0 0 .056-.243.46.46 0 0 0-.091-.282Zm-1.067-.819h.371a1 1 0 0 1 .283.026.22.22 0 0 1 .127.1.3.3 0 0 1 .045.163.27.27 0 0 1-.048.162.26.26 0 0 1-.141.093 1 1 0 0 1-.235.021h-.4v-.565Zm.866 1.258a.26.26 0 0 1-.094.1.4.4 0 0 1-.142.051 1 1 0 0 1-.167.009h-.463v-.639h.43a1 1 0 0 1 .272.031.3.3 0 0 1 .1.054.3.3 0 0 1 .049.054.3.3 0 0 1 .053.181.3.3 0 0 1-.038.159",
  "data-name": "Path 71781"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f7be56",
  d: "M17.448 12.803v-.513h-1.831v.513l-.84.384v1.529h3.585v-1.5Z",
  "data-name": "Path 71782"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#d5d6db",
  d: "M14.882 13.598a3.8 3.8 0 0 0-1.462 1.862c-.088.313-.047 1.619.288 1.894a17.4 17.4 0 0 0 3-.026c.76 0 1.522.021 2.282.009.151 0 .766.082.854-.046a3.8 3.8 0 0 0-.19-.816c-.074-.454.035-.983-.077-1.419-.184-.718-.778-.988-1.335-1.335a.454.454 0 0 1-.155-.625l-.49-.224a3.6 3.6 0 0 1-1.05.361 1 1 0 0 1-.242-.029 1.53 1.53 0 0 1-.768-.366l-.475.217a.47.47 0 0 1-.183.541Z",
  "data-name": "Path 71783"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#44c4a1",
  d: "m17.032 17.77-.277-3.759.223-.386-.221-.384h-.443l-.221.384.221.384-.28 3.761Z",
  "data-name": "Path 71784"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#474c5b",
  d: "M16.065 16.971a4.3 4.3 0 0 0-.408-.786 9 9 0 0 1-.333-.938 7.3 7.3 0 0 1-.18-2.161.4.4 0 0 1 .007-.071l-.315.144-.729.333s-1.143.377-1.195 1.249.085 3.023.085 3.023h3.536a13 13 0 0 1-.254-.533.33.33 0 0 1-.212-.261Z",
  "data-name": "Path 71785"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#474c5b",
  d: "M20.155 14.743c-.052-.872-1.195-1.249-1.195-1.249l-.729-.331-.268-.121a.4.4 0 0 1 .008.137 15 15 0 0 1-.134 2.061c-.149.573-.482 1.068-.667 1.613a.38.38 0 0 1-.241.246.36.36 0 0 1-.2.25q-.094.207-.2.419h3.536s.137-2.151.087-3.023Z",
  "data-name": "Path 71786"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 0.538,
  cy: 0.266,
  fill: "#f7be56",
  "data-name": "Ellipse 1449",
  rx: 0.538,
  ry: 0.266,
  transform: "rotate(-85.355 15.188 -4.04)"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 0.266,
  cy: 0.538,
  fill: "#f7be56",
  "data-name": "Ellipse 1450",
  rx: 0.266,
  ry: 0.538,
  transform: "rotate(-4.645 135.399 -173.19)"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 1.671,
  cy: 2.055,
  fill: "#fcd462",
  "data-name": "Ellipse 1451",
  rx: 1.671,
  ry: 2.055,
  transform: "translate(14.889 8.687)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2f4859",
  d: "M16.865 7.763c-1.275-.082-1.729.3-1.707.7 0 0-.656-.117-.592.632.045.528.214 1.5.31 2.022a.09.09 0 0 0 .09.071.09.09 0 0 0 .091-.089 1.3 1.3 0 0 1 .064-.537s-.16-1.164.516-1.125c0 0 .607-.752 1.235.232.549.86 1.277-.014 1.165.745-.026.178.034.494.032.774h.066a.09.09 0 0 0 .087-.062 7.8 7.8 0 0 0 .329-1.526 1.68 1.68 0 0 0-1.69-1.834Z",
  "data-name": "Path 71787"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ebf0f3",
  d: "m17.448 12.554-.9.68.822.988.547-1.215Z",
  "data-name": "Path 71788"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ebf0f3",
  d: "m15.617 12.554.932.68-.822.988-.547-1.215Z",
  "data-name": "Path 71789"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4d5c7d",
  d: "m18.234 14.48.13.408a6.8 6.8 0 0 1-1.83 2.878 10 10 0 0 0 1.22-4.822c0-.07-.006-.106-.006-.106l.487.323.327 1.164Z",
  "data-name": "Path 71790"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4d5c7d",
  d: "M16.532 17.766a6.8 6.8 0 0 1-1.828-2.878l.13-.408-.329-.153.329-1.166.505-.321s0 .031-.008.093a9.8 9.8 0 0 0 1.2 4.835Z",
  "data-name": "Path 71791"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f7be56",
  d: "M10.113 23.823v-.576H8.055v.576l-.944.432v1.719h4.029v-1.681Z",
  "data-name": "Path 71792"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#d5d6db",
  d: "M12.573 27.602a6 6 0 0 0-.2-1.782c-.181-.443-.235-.534-.705-.631a6 6 0 0 0-.233-.045.5.5 0 0 1-.188.11.47.47 0 0 1-.406-.08.5.5 0 0 0-.164.1c-.44.408-1.1-.251-.66-.66a1.7 1.7 0 0 1 .6-.355.5.5 0 0 1 .079-.17l-.412-.188a4 4 0 0 1-1.18.406 1.2 1.2 0 0 1-.272-.032 1.7 1.7 0 0 1-.863-.412l-.436.2a.456.456 0 0 1-.305.587c-1.531.464-1.737 1.47-1.906 2.871-.181 1.486.654 1.223 1.836 1.232 1.846.019 3.691.054 5.536.011a7 7 0 0 1-.122-1.162Z",
  "data-name": "Path 71793"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e56353",
  d: "m9.645 29.401-.311-4.224.249-.431-.249-.431h-.5l-.249.431.249.431-.311 4.224Z",
  "data-name": "Path 71794"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#474c5b",
  d: "M8.559 28.508a5 5 0 0 0-.459-.884 11 11 0 0 1-.374-1.052 8.2 8.2 0 0 1-.2-2.429 1 1 0 0 1 .008-.08l-.354.162-.819.375s-1.285.424-1.343 1.4.1 3.4.1 3.4h3.965c-.1-.2-.2-.4-.285-.6a.37.37 0 0 1-.239-.293Z",
  "data-name": "Path 71795"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#474c5b",
  d: "M13.156 26.003c-.058-.98-1.343-1.4-1.343-1.4l-.819-.372-.3-.136a.4.4 0 0 1 .009.154 17 17 0 0 1-.15 2.316c-.167.644-.541 1.2-.749 1.813a.43.43 0 0 1-.271.277.4.4 0 0 1-.222.281q-.105.232-.226.471h3.975s.154-2.418.1-3.4Z",
  "data-name": "Path 71796"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 0.605,
  cy: 0.299,
  fill: "#f7be56",
  "data-name": "Ellipse 1452",
  rx: 0.605,
  ry: 0.299,
  transform: "rotate(-85.355 17.44 5.327)"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 0.299,
  cy: 0.605,
  fill: "#f7be56",
  "data-name": "Ellipse 1453",
  rx: 0.299,
  ry: 0.605,
  transform: "rotate(-4.645 263.779 -72.851)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fcd462",
  d: "M9.116 18.807c-1.037 0-1.878.651-1.878 2.7a2.13 2.13 0 0 0 1.878 2.31 2.13 2.13 0 0 0 1.878-2.31c0-2.759-.841-2.7-1.878-2.7",
  "data-name": "Path 71797"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ebf0f3",
  d: "m10.113 23.542-1.01.765.924 1.11.615-1.365Z",
  "data-name": "Path 71798"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ebf0f3",
  d: "m8.06 23.542 1.048.765-.924 1.11-.624-1.366Z",
  "data-name": "Path 71799"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4d5c7d",
  d: "m10.994 25.707.147.458A7.6 7.6 0 0 1 9.084 29.4a11.2 11.2 0 0 0 1.371-5.42c0-.079-.007-.119-.007-.119l.547.363.368 1.308Z",
  "data-name": "Path 71800"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4d5c7d",
  d: "M9.084 29.4a7.6 7.6 0 0 1-2.055-3.235l.147-.458-.37-.172.37-1.31.568-.361s0 .035-.009.1a11 11 0 0 0 1.347 5.434Z",
  "data-name": "Path 71801"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#474c5b",
  d: "M10.55 18.935s.042-.569-1.192-.58-2.026.5-2.248 1.318a6.8 6.8 0 0 0 .193 2.471l.162.008a2.5 2.5 0 0 1 .18-1.045s-.195-1.211.293-1.473 1.988.205 2.364-.082c0 0 .56-.13.429.641a1.96 1.96 0 0 0 .184 1.012l-.082.972.1.005a7 7 0 0 0 .287-1.059c.17-.78-.072-2.17-.673-2.189Z",
  "data-name": "Path 71802"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f7be56",
  d: "M25.009 23.827v-.576h-2.058v.576l-.944.432v1.719h4.029v-1.681Z",
  "data-name": "Path 71803"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#d5d6db",
  d: "M26.858 28.889a10 10 0 0 1 .632-.886 3 3 0 0 1-.1-.321 5.2 5.2 0 0 1-.072-1.535 1.41 1.41 0 0 0-.753-1.1c-.069-.031-.607-.174-.653-.106-.331.5-1.139.031-.806-.471a.98.98 0 0 1 .483-.382l-.411-.188a4 4 0 0 1-1.18.406 1.2 1.2 0 0 1-.272-.032 1.7 1.7 0 0 1-.863-.412l-.425.195a.44.44 0 0 1-.122.389c-.747.789-1.734.849-1.82 2.085a14 14 0 0 0 .055 1.8c.047.847-.086.5.519.554 1.225.109 2.511 0 3.742 0h2.044Z",
  "data-name": "Path 71804"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#27a2db",
  d: "m24.541 29.405-.311-4.224.249-.431-.249-.431h-.5l-.249.431.249.431-.311 4.224Z",
  "data-name": "Path 71805"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#474c5b",
  d: "M23.456 28.512a5 5 0 0 0-.459-.884 11 11 0 0 1-.374-1.054 8.2 8.2 0 0 1-.2-2.429 1 1 0 0 1 .008-.08l-.354.162-.819.375s-1.285.424-1.343 1.4.1 3.4.1 3.4h3.975c-.1-.2-.2-.4-.285-.6a.37.37 0 0 1-.239-.293Z",
  "data-name": "Path 71806"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#474c5b",
  d: "M28.053 26.008c-.058-.98-1.343-1.4-1.343-1.4l-.819-.372-.3-.136a.4.4 0 0 1 .009.154 17 17 0 0 1-.15 2.316c-.167.644-.541 1.2-.749 1.813a.43.43 0 0 1-.271.277.4.4 0 0 1-.222.281q-.105.232-.226.471h3.975s.154-2.418.1-3.4Z",
  "data-name": "Path 71807"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 0.605,
  cy: 0.299,
  fill: "#f7be56",
  "data-name": "Ellipse 1454",
  rx: 0.605,
  ry: 0.299,
  transform: "rotate(-85.355 24.891 -2.752)"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 0.299,
  cy: 0.605,
  fill: "#f7be56",
  "data-name": "Ellipse 1455",
  rx: 0.299,
  ry: 0.605,
  transform: "rotate(-4.645 271.241 -256.54)"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 1.878,
  cy: 2.31,
  fill: "#fcd462",
  "data-name": "Ellipse 1456",
  rx: 1.878,
  ry: 2.31,
  transform: "translate(22.134 19.201)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ebf0f3",
  d: "m25.009 23.547-1.01.765.924 1.11.615-1.365Z",
  "data-name": "Path 71808"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ebf0f3",
  d: "m22.951 23.547 1.048.765-.924 1.11-.615-1.365Z",
  "data-name": "Path 71809"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4d5c7d",
  d: "m25.891 25.712.147.458a7.6 7.6 0 0 1-2.057 3.235 11.2 11.2 0 0 0 1.371-5.42c0-.079-.007-.119-.007-.119l.547.363.368 1.308Z",
  "data-name": "Path 71810"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4d5c7d",
  d: "M23.98 29.406a7.6 7.6 0 0 1-2.055-3.235l.147-.458-.37-.172.37-1.31.568-.361s0 .035-.009.1a11 11 0 0 0 1.347 5.434Z",
  "data-name": "Path 71811"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2f4859",
  d: "m25.693 22.02.15.005a11.5 11.5 0 0 1 .206-1.6 1.528 1.528 0 0 0-1.182-1.965 2.71 2.71 0 0 0-2.736.622c-.484.616-.1 1.994-.079 2.238a5 5 0 0 0 .115.649l.225.008s-.313-1.046.067-1.544l.38-.5a3.7 3.7 0 0 0 2.386.1 1.06 1.06 0 0 1 .433.855 10 10 0 0 0 .035 1.132",
  "data-name": "Path 71812"
})));

const SvgPxStandardLetter = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".px-standard-letter_svg__cls-4{fill:#b0d0ff}.px-standard-letter_svg__cls-8{fill:#ffd754}.px-standard-letter_svg__cls-10{fill:#87a9ff}")), /*#__PURE__*/React.createElement("g", {
  id: "px-standard-letter_svg__Group_50395",
  "data-name": "Group 50395",
  transform: "translate(8960 -23237)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-standard-letter_svg__icon_placeholder",
  d: "M0 0h32v32H0z",
  style: {
    fill: "none"
  },
  transform: "translate(-8960 23237)"
}), /*#__PURE__*/React.createElement("g", {
  id: "px-standard-letter_svg__letter",
  transform: "translate(-8955.163 23241.836)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-standard-letter_svg__Path_65015",
  d: "M425.369 167.337a.337.337 0 0 0-.337-.337h-1.011L422 172.011l2.466-1.643c.564-.374.903-2.354.903-3.031",
  "data-name": "Path 65015",
  style: {
    fill: "#775cb3"
  },
  transform: "translate(-403.043 -159.498)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-standard-letter_svg__Path_65016",
  d: "M9.023 176.433S0 172.507 0 167.337A.337.337 0 0 1 .337 167h20.641v9.433Z",
  "data-name": "Path 65016",
  style: {
    fill: "#8d6ed1"
  },
  transform: "translate(0 -159.498)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-standard-letter_svg__Path_65017",
  d: "M75 .337V7.5L82.5 0h-7.163A.337.337 0 0 0 75 .337",
  className: "px-standard-letter_svg__cls-4",
  "data-name": "Path 65017",
  transform: "translate(-71.631)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-standard-letter_svg__Path_65018",
  d: "m88.18 18.66 6.236.756-.756-6.236Z",
  "data-name": "Path 65018",
  style: {
    fill: "#e3f5ff"
  },
  transform: "translate(-84.219 -12.588)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-standard-letter_svg__Path_65019",
  d: "M234.412 0 227 18.346h8.76V.337a.337.337 0 0 0-.337-.337Z",
  className: "px-standard-letter_svg__cls-4",
  "data-name": "Path 65019",
  transform: "translate(-216.803)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-standard-letter_svg__Path_65020",
  d: "M82.5 0a2.02 2.02 0 0 0-2.02 2.021V5.48h-3.459A2.02 2.02 0 0 0 75 7.5v10.846h14.24V0Z",
  "data-name": "Path 65020",
  style: {
    fill: "#c4e3fa"
  },
  transform: "translate(-71.631)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-standard-letter_svg__Path_65021",
  d: "m438.792 176.184-.444.3-1.348 2.238v9.929h2.7V174.5a2.02 2.02 0 0 1-.908 1.684",
  "data-name": "Path 65021",
  style: {
    fill: "#fabf1e"
  },
  transform: "translate(-417.369 -166.661)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-standard-letter_svg__Path_65022",
  d: "M13.3 181.575H9.023L.9 176.184A2.02 2.02 0 0 1 0 174.5v14.15l20.978-1.979v-10.192Z",
  className: "px-standard-letter_svg__cls-8",
  "data-name": "Path 65022",
  transform: "translate(0 -166.661)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-standard-letter_svg__Path_65023",
  d: "M439.358 447.756a.337.337 0 0 0 .337-.337 2.02 2.02 0 0 0-.9-1.684l-.444-.3L437 446.6l1.348 1.158Z",
  className: "px-standard-letter_svg__cls-8",
  "data-name": "Path 65023",
  transform: "translate(-417.369 -425.43)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-standard-letter_svg__Path_65024",
  d: "M20.978 317.81v-2.316l-8.7-5.775a2.02 2.02 0 0 0-2.236 0L.9 315.789a2.02 2.02 0 0 0-.9 1.684.337.337 0 0 0 .337.337Z",
  "data-name": "Path 65024",
  style: {
    fill: "#ffea70"
  },
  transform: "translate(0 -295.485)"
}), /*#__PURE__*/React.createElement("g", {
  id: "px-standard-letter_svg__Group_50326",
  "data-name": "Group 50326",
  transform: "translate(5.728 2.358)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-standard-letter_svg__Path_65025",
  d: "M138.034 175.174h-10.2a.337.337 0 1 1 0-.674h10.2a.337.337 0 1 1 0 .674",
  className: "px-standard-letter_svg__cls-10",
  "data-name": "Path 65025",
  transform: "translate(-127.5 -169.02)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-standard-letter_svg__Path_65026",
  d: "M254.554 83.174h-4.717a.337.337 0 1 1 0-.674h4.717a.337.337 0 1 1 0 .674",
  className: "px-standard-letter_svg__cls-10",
  "data-name": "Path 65026",
  transform: "translate(-244.02 -81.152)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-standard-letter_svg__Path_65027",
  d: "M254.554 53.174h-4.717a.337.337 0 1 1 0-.674h4.717a.337.337 0 1 1 0 .674",
  className: "px-standard-letter_svg__cls-10",
  "data-name": "Path 65027",
  transform: "translate(-244.02 -52.5)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-standard-letter_svg__Path_65028",
  d: "M138.034 205.174h-10.2a.337.337 0 1 1 0-.674h10.2a.337.337 0 1 1 0 .674",
  className: "px-standard-letter_svg__cls-10",
  "data-name": "Path 65028",
  transform: "translate(-127.5 -197.672)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-standard-letter_svg__Path_65029",
  d: "M138.034 235.174h-10.2a.337.337 0 0 1 0-.674h10.2a.337.337 0 1 1 0 .674",
  className: "px-standard-letter_svg__cls-10",
  "data-name": "Path 65029",
  transform: "translate(-127.5 -226.324)"
})))));

const SvgPxStandardMisc = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".px-standard-misc_svg__cls-8{fill-rule:evenodd;fill:#80b4fb}")), /*#__PURE__*/React.createElement("g", {
  id: "px-standard-misc_svg__Group_50392",
  "data-name": "Group 50392",
  transform: "translate(9064 -23185)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-standard-misc_svg__icon_placeholder",
  d: "M0 0h32v32H0z",
  style: {
    fill: "none"
  },
  transform: "translate(-9064 23185)"
}), /*#__PURE__*/React.createElement("g", {
  id: "px-standard-misc_svg__bill",
  transform: "translate(-9062.29 23191)"
}, /*#__PURE__*/React.createElement("g", {
  id: "px-standard-misc_svg__Group_50381",
  "data-name": "Group 50381",
  transform: "translate(4.29)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-standard-misc_svg__Path_65154",
  d: "M47.651 166.554v-12.269a1.023 1.023 0 0 0-1.02-1.02H30.167a1.02 1.02 0 0 0-1.019 1.02v12.269h18.5Z",
  "data-name": "Path 65154",
  style: {
    fill: "#4a80aa",
    fillRule: "evenodd"
  },
  transform: "translate(-28.134 -147.015)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-standard-misc_svg__Path_65155",
  d: "M430.018 166.554v-12.269a1.023 1.023 0 0 0-1.02-1.02h-1.228a1.02 1.02 0 0 1 1.019 1.02v12.269z",
  "data-name": "Path 65155",
  style: {
    fillRule: "evenodd",
    fill: "#407093"
  },
  transform: "translate(-410.502 -147.015)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-standard-misc_svg__Path_65156",
  d: "M5.741 451.743h17.626a.86.86 0 0 0 .846-.611l.514-1.132c.222-.485.036-.823-.514-.823h-6.6a.32.32 0 0 0-.28.242.875.875 0 0 1-.842.633h-3.873a.87.87 0 0 1-.841-.633.32.32 0 0 0-.281-.242h-6.6c-.55 0-.736.338-.514.823l.514 1.128a.86.86 0 0 0 .846.611Z",
  "data-name": "Path 65156",
  style: {
    fillRule: "evenodd",
    fill: "#365e7d"
  },
  transform: "translate(-4.29 -430.864)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-standard-misc_svg__Path_65157",
  d: "M442.025 451.743h1.227a.86.86 0 0 0 .846-.611l.514-1.128c.222-.485.036-.823-.514-.823h-1.227c.55 0 .736.338.514.823l-.514 1.128a.86.86 0 0 1-.846.611",
  "data-name": "Path 65157",
  style: {
    fillRule: "evenodd",
    fill: "#2b4d66"
  },
  transform: "translate(-424.175 -430.864)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-standard-misc_svg__Path_65158",
  d: "M59.722 183.621h15.755a.247.247 0 0 1 .245.246v9.1a.247.247 0 0 1-.245.246H59.722a.25.25 0 0 1-.246-.246v-9.1a.25.25 0 0 1 .246-.246",
  "data-name": "Path 65158",
  style: {
    fillRule: "evenodd",
    fill: "#cbe2ff"
  },
  transform: "translate(-57.226 -176.133)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-standard-misc_svg__Path_65159",
  d: "M421.74 183.621h1.229a.247.247 0 0 1 .245.246v9.1a.247.247 0 0 1-.245.246h-1.229a.247.247 0 0 0 .246-.246v-9.1a.247.247 0 0 0-.246-.246",
  "data-name": "Path 65159",
  style: {
    fillRule: "evenodd",
    fill: "#9dc6fb"
  },
  transform: "translate(-404.717 -176.133)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-standard-misc_svg__Path_65160",
  d: "M98.7 324.407h11.876a.613.613 0 0 0 .61-.611v-1.263a.613.613 0 0 0-.61-.611H98.7a.614.614 0 0 0-.611.611v1.267a.614.614 0 0 0 .611.607",
  className: "px-standard-misc_svg__cls-8",
  "data-name": "Path 65160",
  transform: "translate(-94.259 -308.794)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-standard-misc_svg__Path_65161",
  d: "M374.17 324.407h1.23a.613.613 0 0 0 .61-.611v-1.263a.613.613 0 0 0-.61-.611h-1.23a.613.613 0 0 1 .611.611v1.267a.613.613 0 0 1-.611.607",
  className: "px-standard-misc_svg__cls-8",
  "data-name": "Path 65161",
  transform: "translate(-359.087 -308.794)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-standard-misc_svg__Path_65162",
  d: "m138.97.863-.9-.78a.263.263 0 0 0-.371 0l-.9.78a.27.27 0 0 1-.371 0l-.9-.78a.25.25 0 0 0-.371 0l-.9.78a.51.51 0 0 0-.186.406v12.857a.247.247 0 0 0 .246.246h9.671a.247.247 0 0 0 .246-.246V1.27a.51.51 0 0 0-.186-.406l-.9-.78a.25.25 0 0 0-.371 0l-.9.78a.267.267 0 0 1-.371 0l-.9-.78a.263.263 0 0 0-.371 0l-.9.78a.27.27 0 0 1-.371 0Z",
  "data-name": "Path 65162",
  style: {
    fillRule: "evenodd",
    fill: "#fff6cf"
  },
  transform: "translate(-128.782)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-standard-misc_svg__Path_65163",
  d: "M337.509 14.371h1.228a.247.247 0 0 0 .246-.246V1.27a.51.51 0 0 0-.183-.407l-.9-.78a.25.25 0 0 0-.371 0l-.429.372.471.408a.51.51 0 0 1 .186.406v12.857a.25.25 0 0 1-.248.245",
  "data-name": "Path 65163",
  style: {
    fillRule: "evenodd",
    fill: "#fff0af"
  },
  transform: "translate(-323.527)"
})), /*#__PURE__*/React.createElement("path", {
  id: "px-standard-misc_svg__Path_65164",
  d: "M218.926 55.206a.306.306 0 1 1-.41.456 1.2 1.2 0 0 0-.578-.258v1.913q.178.069.377.139a1.57 1.57 0 0 1 1.009.975 1.65 1.65 0 0 1 .052.835 1.8 1.8 0 0 1-.346.769 1.74 1.74 0 0 1-1.093.658v.5a.307.307 0 0 1-.615 0v-.473a2.17 2.17 0 0 1-1.263-.423.306.306 0 1 1 .335-.513 1.9 1.9 0 0 0 .58.278 1.7 1.7 0 0 0 .348.045v-2.378l-.118-.053a3.5 3.5 0 0 1-.684-.4 1.14 1.14 0 0 1-.386-.577 1.46 1.46 0 0 1-.028-.7 1.55 1.55 0 0 1 .3-.654 1.4 1.4 0 0 1 .7-.481q.111-.032.218-.053v-.449a.307.307 0 0 1 .615 0v.426a1.9 1.9 0 0 1 .987.418m-1.6.234-.043.013a.8.8 0 0 0-.394.27.95.95 0 0 0-.179.394.85.85 0 0 0 .015.4.53.53 0 0 0 .175.269 2.5 2.5 0 0 0 .426.261zm.789 2.594-.174-.063v2.1a1.13 1.13 0 0 0 .608-.406 1.2 1.2 0 0 0 .228-.507 1 1 0 0 0-.031-.526.97.97 0 0 0-.633-.598Z",
  "data-name": "Path 65164",
  style: {
    fill: "#78c2a4"
  },
  transform: "translate(-203.001 -51.851)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-standard-misc_svg__Path_65165",
  d: "M170.712 252.545a.307.307 0 0 1 0-.614h6.588a.307.307 0 0 1 0 .614Zm0 2.446a.307.307 0 0 1 0-.614h5.16a.307.307 0 1 1 0 .614Zm0-1.223a.307.307 0 0 1 0-.614h6.588a.307.307 0 0 1 0 .614Z",
  "data-name": "Path 65165",
  style: {
    fill: "#dd636e"
  },
  transform: "translate(-159.342 -241.657)"
}))));

const SvgPxStandardParameter = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".px-standard-parameter_svg__c{fill:#27498c}.px-standard-parameter_svg__e{fill:#205682}.px-standard-parameter_svg__f{fill:#f29d35}.px-standard-parameter_svg__g{fill:#c1c1c1}")), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h32v32H0z",
  style: {
    fill: "none"
  }
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-18.999 -19)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m39.876 26.346-2.131-2.131a.73.73 0 0 0-.518-.215H24.73a.73.73 0 0 0-.731.731v18.651a.73.73 0 0 0 .731.731h14.629a.73.73 0 0 0 .731-.731V26.863a.73.73 0 0 0-.214-.517",
  style: {
    fill: "#e5e1dc"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "m25.462 29.886.366.33v1.829h1.463v-1.828l.366-.33v-1.735a.73.73 0 0 0-.46-.679l-.909-.364a.73.73 0 0 1-.46-.679v-.15a.732.732 0 1 1 1.463 0v.15a.73.73 0 0 1-.46.679l-.909.364a.73.73 0 0 0-.46.679ZM29.119 29.886l.366.33v1.829h1.463v-1.828l.366-.33v-1.735a.73.73 0 0 0-.46-.679l-.909-.364a.73.73 0 0 1-.46-.679v-.15a.732.732 0 1 1 1.463 0v.15a.73.73 0 0 1-.46.679l-.909.364a.73.73 0 0 0-.46.679ZM32.776 29.886l.366.33v1.829h1.463v-1.828l.366-.33v-1.735a.73.73 0 0 0-.46-.679l-.909-.364a.73.73 0 0 1-.46-.679v-.15a.732.732 0 1 1 1.463 0v.15a.73.73 0 0 1-.46.679l-.909.364a.73.73 0 0 0-.46.679Z",
  className: "px-standard-parameter_svg__c"
}), /*#__PURE__*/React.createElement("rect", {
  width: 10.093,
  height: 12.422,
  rx: 5.046,
  style: {
    fill: "#3b6fd9"
  },
  transform: "translate(34.868 32.789)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.97 34.971h10.24v-1.463a.73.73 0 0 0-.731-.731h-8.777a.73.73 0 0 0-.731.731Z",
  className: "px-standard-parameter_svg__e"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 0.776,
  cy: 0.776,
  r: 0.776,
  className: "px-standard-parameter_svg__e",
  transform: "translate(41.856 35.894)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 0.776,
  cy: 0.776,
  r: 0.776,
  className: "px-standard-parameter_svg__e",
  transform: "translate(39.527 35.894)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 0.776,
  cy: 0.776,
  r: 0.776,
  className: "px-standard-parameter_svg__e",
  transform: "translate(36.421 35.894)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 0.776,
  cy: 0.776,
  r: 0.776,
  className: "px-standard-parameter_svg__e",
  transform: "translate(39.527 39)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 0.776,
  cy: 0.776,
  r: 0.776,
  className: "px-standard-parameter_svg__e",
  transform: "translate(36.421 39)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 0.776,
  cy: 0.776,
  r: 0.776,
  className: "px-standard-parameter_svg__e",
  transform: "translate(39.527 42.105)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 0.776,
  cy: 0.776,
  r: 0.776,
  className: "px-standard-parameter_svg__e",
  transform: "translate(36.421 42.105)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.096 33.874h8.777v.731h-8.777Z",
  className: "px-standard-parameter_svg__f"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.828 33.143h.731v1.1h-.731ZM28.022 33.143h.731v1.1h-.731ZM30.216 33.143h.731v1.1h-.731ZM32.41 33.143h.731v1.1h-.731Z",
  className: "px-standard-parameter_svg__f"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.096 36.069h2.926v.731h-2.926ZM25.096 37.531h5.12v.731h-5.12ZM30.947 37.531h1.1v.731h-1.1ZM32.776 37.531h1.1v.731h-1.1ZM25.096 39.36h5.12v.731h-5.12ZM30.947 39.36h1.1v.731h-1.1ZM32.776 39.36h1.1v.731h-1.1ZM25.096 41.188h5.12v.731h-5.12ZM30.947 41.188h1.1v.731h-1.1ZM32.776 41.188h1.1v.731h-1.1ZM36.433 28.023h2.194v.731h-2.194ZM36.433 30.583h2.194v.731h-2.194Z",
  className: "px-standard-parameter_svg__g"
}), /*#__PURE__*/React.createElement("path", {
  d: "M416 32.411v-7.68a.731.731 0 1 1 1.463 0v7.68l-.731 1.1Z",
  style: {
    fill: "#5dc691"
  },
  transform: "translate(-374.081)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M419.291 67.657h-.731V65.1a.366.366 0 0 0-.366-.366H416V64h2.194a1.1 1.1 0 0 1 1.1 1.1Z",
  style: {
    fill: "#57b584"
  },
  transform: "translate(-374.081 -38.171)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m39.876 26.345-1.066-1.066-1.065-1.069a.7.7 0 0 0-.214-.148v1.762a.73.73 0 0 0 .731.731h1.762a.7.7 0 0 0-.148-.21",
  className: "px-standard-parameter_svg__g"
}), /*#__PURE__*/React.createElement("path", {
  d: "M416 25.829h1.463v-1.1a.731.731 0 1 0-1.463 0Z",
  style: {
    fill: "#4aa071"
  },
  transform: "translate(-374.081)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 0.776,
  cy: 0.776,
  r: 0.776,
  className: "px-standard-parameter_svg__e",
  transform: "translate(41.856 39)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 0.776,
  cy: 0.776,
  r: 0.776,
  className: "px-standard-parameter_svg__e",
  transform: "translate(41.856 42.105)"
})));

const SvgPxSubsale = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57457"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57452"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#5d4d80",
  d: "M14.199 9.558h1.16v3.481h-1.16Z",
  "data-name": "Path 71855"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57453"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#443d66",
  d: "M21.161 9.558h1.16v3.481h-1.16Z",
  "data-name": "Path 71856"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57454"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#f3f5f9",
  d: "M25.803 23.479H10.719v-11.6h15.084Z",
  "data-name": "Path 71857"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#d7dce6",
  d: "M18.26 11.879h7.542v11.6H18.26Z",
  "data-name": "Path 71858"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57455"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#7adfe3",
  d: "M25.802 10.719H7.16V8.398h18.642Z",
  "data-name": "Path 71859"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57456"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#5d4d80",
  d: "M8.321 25.8H6V6h2.321Z",
  "data-name": "Path 71860"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#55b3dc",
  d: "M18.26 8.398h7.542v2.321H18.26Z",
  "data-name": "Path 71861"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57458"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#ffda80",
  d: "m18.26 14.539-2.9 2.9v3.721h2.321l.58-.658.58.658h2.319v-3.721Z",
  "data-name": "Path 71862"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#ffb54d",
  d: "M18.841 21.161h2.32V17.44l-2.9-2.9v5.964Z",
  "data-name": "Path 71863"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57459"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#5d4d80",
  d: "M17.681 18.763h1.16v2.4h-1.16Z",
  "data-name": "Path 71864"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57460"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#ff5959",
  d: "M21.741 19.081 18.26 15.6l-3.481 3.481-.82-.82 4.3-4.3 4.3 4.3Z",
  "data-name": "Path 71865"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#443d66",
  d: "M18.26 18.763h.58v2.4h-.58Z",
  "data-name": "Path 71866"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e63a57",
  d: "m21.741 19.081.82-.82-4.3-4.3v1.641Z",
  "data-name": "Path 71867"
}));

const SvgPxSuperUser = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 15 15"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 49347"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 33532"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M2 2h12v12H2z",
  "data-name": "Rectangle 21199"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 29060"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 29056"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 29055"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#0019d8",
  d: "M6.561 2.27a2.8 2.8 0 1 0 2.8 2.8 2.806 2.806 0 0 0-2.8-2.8",
  "data-name": "Path 30939"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 29058"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 29057"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#0019d8",
  d: "M13.229 8.989q-.008-.2-.006-.394a.18.18 0 0 0-.184-.184 2.47 2.47 0 0 1-1.838-.695.19.19 0 0 0-.258 0 2.47 2.47 0 0 1-1.838.695.18.18 0 0 0-.184.184q.002.192-.006.394c-.025 1.291-.062 3.062 2.1 3.806l.061.012.061-.012c2.142-.744 2.112-2.509 2.092-3.806m-2.306 1.789a.2.2 0 0 1-.129.049h-.006a.17.17 0 0 1-.129-.062l-.572-.633.277-.246.449.5 1-.947.252.271Z",
  "data-name": "Path 30940"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 29059"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#0019d8",
  d: "M10.777 12.898c-2.158-.744-2.121-2.515-2.1-3.806 0-.1.006-.2.006-.3a4 4 0 0 0-1.5-.292H5.94a4 4 0 0 0-2.864 1.208 4.09 4.09 0 0 0-1.184 2.88.31.31 0 0 0 .311.311h8.573Z",
  "data-name": "Path 30941"
}))))));

const SvgPxSuperuserDetail = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 15 15"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 48624"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 33532"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M2 2h12v12H2z",
  "data-name": "Rectangle 21199"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 29060"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 29056"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 29055"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#ff9300",
  d: "M6.561 2.27a2.8 2.8 0 1 0 2.8 2.8 2.806 2.806 0 0 0-2.8-2.8",
  "data-name": "Path 30939"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 29058"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 29057"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#ff9300",
  d: "M13.229 8.989q-.008-.2-.006-.394a.18.18 0 0 0-.184-.184 2.47 2.47 0 0 1-1.838-.695.19.19 0 0 0-.258 0 2.47 2.47 0 0 1-1.838.695.18.18 0 0 0-.184.184q.002.192-.006.394c-.025 1.291-.062 3.062 2.1 3.806l.061.012.061-.012c2.142-.744 2.112-2.509 2.092-3.806m-2.306 1.789a.2.2 0 0 1-.129.049h-.006a.17.17 0 0 1-.129-.062l-.572-.633.277-.246.449.5 1-.947.252.271Z",
  "data-name": "Path 30940"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 29059"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#ff9300",
  d: "M10.777 12.898c-2.158-.744-2.121-2.515-2.1-3.806 0-.1.006-.2.006-.3a4 4 0 0 0-1.5-.292H5.94a4 4 0 0 0-2.864 1.208 4.09 4.09 0 0 0-1.184 2.88.31.31 0 0 0 .311.311h8.573Z",
  "data-name": "Path 30941"
}))))));

const SvgPxSupeuserInactive = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 15 15"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 49347"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 33532"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M2 2h12v12H2z",
  "data-name": "Rectangle 21199"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 29060"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 29056"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 29055"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#9b9b9b",
  d: "M6.561 2.27a2.8 2.8 0 1 0 2.8 2.8 2.806 2.806 0 0 0-2.8-2.8",
  "data-name": "Path 30939"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 29058"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 29057"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#9b9b9b",
  d: "M13.229 8.989q-.008-.2-.006-.394a.18.18 0 0 0-.184-.184 2.47 2.47 0 0 1-1.838-.695.19.19 0 0 0-.258 0 2.47 2.47 0 0 1-1.838.695.18.18 0 0 0-.184.184q.002.192-.006.394c-.025 1.291-.062 3.062 2.1 3.806l.061.012.061-.012c2.142-.744 2.112-2.509 2.092-3.806m-2.306 1.789a.2.2 0 0 1-.129.049h-.006a.17.17 0 0 1-.129-.062l-.572-.633.277-.246.449.5 1-.947.252.271Z",
  "data-name": "Path 30940"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 29059"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#9b9b9b",
  d: "M10.777 12.898c-2.158-.744-2.121-2.515-2.1-3.806 0-.1.006-.2.006-.3a4 4 0 0 0-1.5-.292H5.94a4 4 0 0 0-2.864 1.208 4.09 4.09 0 0 0-1.184 2.88.31.31 0 0 0 .311.311h8.573Z",
  "data-name": "Path 30941"
}))))));

const SvgPxSystemAdmin = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 30 30"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 26071"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h30v30H0z",
  "data-name": "Rectangle 14939"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5367ff",
  d: "m29.305 5.045-.308-.158a3.2 3.2 0 0 0 .064-.8l.33-.106a.879.879 0 1 0-.54-1.673l-.33.106a3.2 3.2 0 0 0-.519-.61l.158-.308a.879.879 0 1 0-1.565-.8l-.158.309a3.3 3.3 0 0 0-.8-.063L25.53.61a.879.879 0 1 0-1.673.54l.107.332a3.3 3.3 0 0 0-.611.517l-.309-.158a.879.879 0 1 0-.8 1.565l.309.158a3.2 3.2 0 0 0-.064.8l-.33.106a.879.879 0 1 0 .54 1.673l.33-.106a3.2 3.2 0 0 0 .519.61l-.158.309a.879.879 0 1 0 1.565.8l.158-.309a3.3 3.3 0 0 0 .658.069h.141l.106.329a.879.879 0 1 0 1.673-.54l-.106-.33a3.2 3.2 0 0 0 .61-.519l.309.158a.879.879 0 0 0 .8-1.565Zm-4.892-1.517a1.53 1.53 0 1 1 .665 2.06 1.53 1.53 0 0 1-.665-2.06",
  "data-name": "Path 27004"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5367ff",
  d: "M14.36 17.024a1.382 1.382 0 1 0-1.382 1.382 1.384 1.384 0 0 0 1.382-1.382",
  "data-name": "Path 27005"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5367ff",
  d: "M12.975 11.915a5.107 5.107 0 0 0-3.767 8.559 4.55 4.55 0 0 1 1.428-1.357 3.14 3.14 0 1 1 4.676 0q.195.118.381.256a4.6 4.6 0 0 1 1.046 1.1 5.107 5.107 0 0 0-3.764-8.558",
  "data-name": "Path 27006"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5367ff",
  d: "M12.979 20.223a2.79 2.79 0 0 0-2.37 1.325 5.1 5.1 0 0 0 4.738 0 2.82 2.82 0 0 0-2.368-1.325",
  "data-name": "Path 27007"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#002672",
  d: "M23.939 14.401a1.63 1.63 0 0 1-1.147-1.04 10 10 0 0 0-.285-.686 1.63 1.63 0 0 1 .075-1.548 2.712 2.712 0 0 0-3.707-3.707 1.63 1.63 0 0 1-1.548.075c-.224-.1-.455-.2-.686-.285a1.63 1.63 0 0 1-1.04-1.147 2.712 2.712 0 0 0-5.243 0 1.63 1.63 0 0 1-1.04 1.147q-.348.13-.686.285a1.63 1.63 0 0 1-1.548-.075A2.712 2.712 0 0 0 3.8 11.681l.106.106a10.3 10.3 0 0 0-1.046 2.524h-.148a2.712 2.712 0 0 0-.694 5.328 1.63 1.63 0 0 1 1.147 1.04q.13.348.285.686a1.63 1.63 0 0 1-.075 1.548 2.712 2.712 0 0 0 3.708 3.707 1.63 1.63 0 0 1 1.548-.075c.224.1.455.2.686.285a1.63 1.63 0 0 1 1.04 1.147 2.712 2.712 0 0 0 5.243 0 1.63 1.63 0 0 1 1.041-1.138q.348-.13.686-.285a1.63 1.63 0 0 1 1.548.075 2.712 2.712 0 0 0 3.707-3.707 1.63 1.63 0 0 1-.075-1.548c.1-.225.2-.456.285-.686a1.63 1.63 0 0 1 1.147-1.04 2.712 2.712 0 0 0 0-5.243Zm-6.752 8.044a.87.87 0 0 1-.446.319 6.884 6.884 0 1 1 .447-.32Z",
  "data-name": "Path 27008"
})));

const SvgPxSystemAdminW = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 30 30"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 26071"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h30v30H0z",
  "data-name": "Rectangle 14939"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffb11f",
  d: "m29.305 5.045-.308-.158a3.2 3.2 0 0 0 .064-.8l.33-.106a.879.879 0 1 0-.54-1.673l-.33.106a3.2 3.2 0 0 0-.519-.61l.158-.308a.879.879 0 1 0-1.565-.8l-.158.309a3.3 3.3 0 0 0-.8-.063L25.53.61a.879.879 0 1 0-1.673.54l.107.332a3.3 3.3 0 0 0-.611.517l-.309-.158a.879.879 0 1 0-.8 1.565l.309.158a3.2 3.2 0 0 0-.064.8l-.33.106a.879.879 0 1 0 .54 1.673l.33-.106a3.2 3.2 0 0 0 .519.61l-.158.309a.879.879 0 1 0 1.565.8l.158-.309a3.3 3.3 0 0 0 .658.069h.141l.106.329a.879.879 0 1 0 1.673-.54l-.106-.33a3.2 3.2 0 0 0 .61-.519l.309.158a.879.879 0 0 0 .8-1.565Zm-4.892-1.517a1.53 1.53 0 1 1 .665 2.06 1.53 1.53 0 0 1-.665-2.06",
  "data-name": "Path 27004"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffb11f",
  d: "M14.36 17.024a1.382 1.382 0 1 0-1.382 1.382 1.384 1.384 0 0 0 1.382-1.382",
  "data-name": "Path 27005"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffb11f",
  d: "M12.975 11.915a5.107 5.107 0 0 0-3.767 8.559 4.55 4.55 0 0 1 1.428-1.357 3.14 3.14 0 1 1 4.676 0q.195.118.381.256a4.6 4.6 0 0 1 1.046 1.1 5.107 5.107 0 0 0-3.764-8.558",
  "data-name": "Path 27006"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffb11f",
  d: "M12.979 20.223a2.79 2.79 0 0 0-2.37 1.325 5.1 5.1 0 0 0 4.738 0 2.82 2.82 0 0 0-2.368-1.325",
  "data-name": "Path 27007"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M23.939 14.401a1.63 1.63 0 0 1-1.147-1.04 10 10 0 0 0-.285-.686 1.63 1.63 0 0 1 .075-1.548 2.712 2.712 0 0 0-3.707-3.707 1.63 1.63 0 0 1-1.548.075c-.224-.1-.455-.2-.686-.285a1.63 1.63 0 0 1-1.04-1.147 2.712 2.712 0 0 0-5.243 0 1.63 1.63 0 0 1-1.04 1.147q-.348.13-.686.285a1.63 1.63 0 0 1-1.548-.075A2.712 2.712 0 0 0 3.8 11.681l.106.106a10.3 10.3 0 0 0-1.046 2.524h-.148a2.712 2.712 0 0 0-.694 5.328 1.63 1.63 0 0 1 1.147 1.04q.13.348.285.686a1.63 1.63 0 0 1-.075 1.548 2.712 2.712 0 0 0 3.708 3.707 1.63 1.63 0 0 1 1.548-.075c.224.1.455.2.686.285a1.63 1.63 0 0 1 1.04 1.147 2.712 2.712 0 0 0 5.243 0 1.63 1.63 0 0 1 1.041-1.138q.348-.13.686-.285a1.63 1.63 0 0 1 1.548.075 2.712 2.712 0 0 0 3.707-3.707 1.63 1.63 0 0 1-.075-1.548c.1-.225.2-.456.285-.686a1.63 1.63 0 0 1 1.147-1.04 2.712 2.712 0 0 0 0-5.243Zm-6.752 8.044a.87.87 0 0 1-.446.319 6.884 6.884 0 1 1 .447-.32Z",
  "data-name": "Path 27008"
})));

const SvgPxTaxSetup = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".px-tax-setup_svg__d{fill:#e2e7f6}.px-tax-setup_svg__e{fill:#f2f2f2}.px-tax-setup_svg__f{fill:#f4a93c}.px-tax-setup_svg__i{fill:#78a0d4}.px-tax-setup_svg__k{fill:#f6b940}")), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h32v32H0z",
  style: {
    fill: "none"
  }
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(1 2)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4 23.407V4.02A2.02 2.02 0 0 1 6.02 2h16.56a.81.81 0 0 1 .808.808v20.6Z",
  style: {
    fill: "#4c6cb5"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.772 18.56V2H6.02A2.02 2.02 0 0 0 4 4.02v16.156h16.156a1.616 1.616 0 0 0 1.616-1.616",
  style: {
    fill: "#5e87ca"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 4.5,
  cy: 4.5,
  r: 4.5,
  className: "px-tax-setup_svg__d",
  transform: "translate(11 11.235)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.541 15.329a4.44 4.44 0 0 0-2.448-3.966 4.439 4.439 0 0 0-2.778 8.336 4.425 4.425 0 0 0 5.226-4.37",
  className: "px-tax-setup_svg__e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.387 16.945h2.02l1.212 2.02-1.212 2.02h-2.02M23.387 11.29h2.02l1.212 2.02-1.212 2.02h-2.02",
  className: "px-tax-setup_svg__f"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4 23.407V4.02A2.02 2.02 0 0 1 6.02 2h1.615v21.407Z",
  style: {
    fill: "#f0ae42"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.212 22.195h18.176v4.039H5.212A1.21 1.21 0 0 1 4 25.022v-1.615a1.21 1.21 0 0 1 1.212-1.212",
  className: "px-tax-setup_svg__d"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.176 22.195H5.212A1.21 1.21 0 0 0 4 23.407v1.212h18.176Z",
  className: "px-tax-setup_svg__e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7 56h18.176v.808H7Z",
  style: {
    fill: "#c8cded"
  },
  transform: "translate(-1.788 -32.189)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.694 4.828V4.02H9.655v.808h1.616v4.443h.808V4.828ZM15.31 4.02a1.616 1.616 0 0 0-1.616 1.616v3.635h.808V7.655h1.616v1.616h.808V5.636A1.616 1.616 0 0 0 15.31 4.02m-.808 2.827V5.636a.808.808 0 1 1 1.616 0v1.211ZM20.964 5.232V4.02h-.808v1.062l-.807.938-.808-.942V4.02h-.808v1.212a.4.4 0 0 0 .1.263l.986 1.151-.986 1.15a.4.4 0 0 0-.1.263v1.212h.808V8.209l.808-.942.808.942v1.062h.808V8.059a.4.4 0 0 0-.1-.263l-.986-1.151.986-1.151a.4.4 0 0 0 .1-.263Z",
  className: "px-tax-setup_svg__e"
}), /*#__PURE__*/React.createElement("path", {
  d: "m13.002 17.466 4.039-4.039.571.571-4.039 4.04Z",
  className: "px-tax-setup_svg__i"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1,
  cy: 1,
  r: 1,
  className: "px-tax-setup_svg__i",
  transform: "translate(13 13.235)"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 0.5,
  cy: 1,
  className: "px-tax-setup_svg__i",
  rx: 0.5,
  ry: 1,
  transform: "translate(16 16.235)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.01 20.609a.81.81 0 0 0 .808-.808V2.05A2.013 2.013 0 0 0 4 4.049v16.56Z",
  style: {
    fill: "#f9d266"
  },
  transform: "translate(0 -.03)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.387 11.29v2.02h3.231l-1.211-2.02ZM23.387 16.945v2.02h3.231l-1.211-2.02Z",
  className: "px-tax-setup_svg__k"
})));

const SvgPxTitleSetup = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".px-title-setup_svg__cls-2{fill:#ddeafb}.px-title-setup_svg__cls-3{fill:#cbe2ff}.px-title-setup_svg__cls-7{fill:#4073c8}.px-title-setup_svg__cls-9{fill:#30579d}")), /*#__PURE__*/React.createElement("g", {
  id: "px-title-setup_svg__Group_50384",
  "data-name": "Group 50384",
  transform: "translate(9064 -23081)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-title-setup_svg__icon_placeholder",
  d: "M0 0h32v32H0z",
  style: {
    fill: "none"
  },
  transform: "translate(-9064 23081)"
}), /*#__PURE__*/React.createElement("g", {
  id: "px-title-setup_svg__project",
  transform: "translate(-9059.498 23085.836)"
}, /*#__PURE__*/React.createElement("g", {
  id: "px-title-setup_svg__Group_50353",
  "data-name": "Group 50353",
  transform: "translate(.356 .415)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-title-setup_svg__Path_65107",
  d: "m21.986 32.947-11.074 3.171a.44.44 0 0 1-.5-.363L7.931 18.973a.44.44 0 0 1 .363-.5l11.074-1.783a.44.44 0 0 1 .5.363l2.479 15.394a.44.44 0 0 1-.363.5Z",
  className: "px-title-setup_svg__cls-2",
  "data-name": "Path 65107",
  transform: "translate(-7.926 -16.683)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-title-setup_svg__Path_65108",
  d: "m183.18 32.947 11.074 3.171a.44.44 0 0 0 .5-.363l2.479-16.782a.44.44 0 0 0-.363-.5l-11.07-1.785a.44.44 0 0 0-.5.363l-2.479 15.394a.44.44 0 0 0 .363.5Z",
  className: "px-title-setup_svg__cls-2",
  "data-name": "Path 65108",
  transform: "translate(-174.955 -16.683)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-title-setup_svg__Path_65109",
  d: "m21.986 32.947-11.074 3.171a.44.44 0 0 1-.5-.363L7.931 18.973a.44.44 0 0 1 .363-.5l11.074-1.783a.44.44 0 0 1 .5.363l2.479 15.394a.44.44 0 0 1-.363.5Z",
  className: "px-title-setup_svg__cls-2",
  "data-name": "Path 65109",
  transform: "translate(-7.926 -16.683)"
})), /*#__PURE__*/React.createElement("path", {
  id: "px-title-setup_svg__Path_65110",
  d: "M108.793 17.051a.44.44 0 0 0-.5-.363l-7.26 1.169v15.619c0 .279.226 1.43.5 1.43h4.28l5.093-1.958a.44.44 0 0 0 .363-.5Z",
  className: "px-title-setup_svg__cls-3",
  "data-name": "Path 65110",
  transform: "translate(-96.493 -16.267)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-title-setup_svg__Path_65111",
  d: "M185.8 16.688a.44.44 0 0 0-.5.363l-2.479 15.394a.44.44 0 0 0 .363.5l5.093 1.958h4.28c.279 0 .5-1.151.5-1.43V17.857Z",
  className: "px-title-setup_svg__cls-3",
  "data-name": "Path 65111",
  transform: "translate(-174.599 -16.267)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-title-setup_svg__Path_65112",
  d: "M133.026 23.908h-11.217a.44.44 0 0 1-.438-.438V7.877a.44.44 0 0 1 .438-.438h11.216a.44.44 0 0 1 .438.438v15.592a.44.44 0 0 1-.437.439",
  "data-name": "Path 65112",
  style: {
    fill: "#f4fbff"
  },
  transform: "translate(-115.919 -7.439)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-title-setup_svg__Path_65113",
  d: "M357.676 7.439h-1.088a.44.44 0 0 1 .438.438v15.592a.44.44 0 0 1-.438.438h1.088a.44.44 0 0 0 .438-.438V7.877a.44.44 0 0 0-.438-.438",
  "data-name": "Path 65113",
  style: {
    fill: "#e4f6ff"
  },
  transform: "translate(-340.569 -7.439)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-title-setup_svg__Path_65114",
  d: "m14.694 297.447-.344.922a.71.71 0 0 1-.664.461H9.311a.71.71 0 0 1-.664-.461l-.344-.922a.71.71 0 0 0-.664-.461h-7.3a.34.34 0 0 0-.339.339v6.07a2.91 2.91 0 0 0 2.912 2.912h17.173A2.91 2.91 0 0 0 23 303.4v-6.07a.34.34 0 0 0-.339-.339h-7.3a.71.71 0 0 0-.667.456",
  "data-name": "Path 65114",
  style: {
    fill: "#698ed5"
  },
  transform: "translate(0 -283.979)"
}), /*#__PURE__*/React.createElement("g", {
  id: "px-title-setup_svg__Group_50354",
  "data-name": "Group 50354",
  transform: "translate(6.244 13.007)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-title-setup_svg__Path_65115",
  d: "m139.657 297.447.344.922a.71.71 0 0 0 .664.461h1.4a.71.71 0 0 1-.664-.461l-.344-.922a.71.71 0 0 0-.664-.461h-1.4a.71.71 0 0 1 .664.461",
  className: "px-title-setup_svg__cls-7",
  "data-name": "Path 65115",
  transform: "translate(-138.993 -296.986)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-title-setup_svg__Path_65116",
  d: "M418.964 296.987v6.41a2.91 2.91 0 0 1-2.912 2.912h1.4a2.91 2.91 0 0 0 2.912-2.912v-6.07a.34.34 0 0 0-.339-.339Z",
  className: "px-title-setup_svg__cls-7",
  "data-name": "Path 65116",
  transform: "translate(-403.606 -296.987)"
})), /*#__PURE__*/React.createElement("path", {
  id: "px-title-setup_svg__Path_65117",
  d: "M170.391 378.224h-7.917a.253.253 0 0 1-.253-.253v-1.7a.253.253 0 0 1 .253-.253h7.917a.253.253 0 0 1 .253.253v1.7a.253.253 0 0 1-.253.253",
  "data-name": "Path 65117",
  style: {
    fill: "#3b66c1"
  },
  transform: "translate(-154.934 -359.465)"
}), /*#__PURE__*/React.createElement("path", {
  id: "px-title-setup_svg__Path_65118",
  d: "M321.9 376.022h-1.043a.253.253 0 0 1 .253.253v1.7a.253.253 0 0 1-.253.253h1.043a.253.253 0 0 0 .253-.253v-1.7a.253.253 0 0 0-.253-.253",
  className: "px-title-setup_svg__cls-9",
  "data-name": "Path 65118",
  transform: "translate(-306.444 -359.465)"
}), /*#__PURE__*/React.createElement("g", {
  id: "px-title-setup_svg__Group_50370",
  "data-name": "Group 50370",
  transform: "translate(7.048 2.231)"
}, /*#__PURE__*/React.createElement("g", {
  id: "px-title-setup_svg__Group_50357",
  "data-name": "Group 50357"
}, /*#__PURE__*/React.createElement("g", {
  id: "px-title-setup_svg__Group_50355",
  "data-name": "Group 50355"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-title-setup_svg__Path_65119",
  d: "M158.522 57.8h-1.284a.347.347 0 1 1 0-.694h1.284a.347.347 0 1 1 0 .694",
  className: "px-title-setup_svg__cls-9",
  "data-name": "Path 65119",
  transform: "translate(-156.891 -57.103)"
})), /*#__PURE__*/React.createElement("g", {
  id: "px-title-setup_svg__Group_50356",
  "data-name": "Group 50356",
  transform: "translate(3.222)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-title-setup_svg__Path_65120",
  d: "M233.953 57.8h-4.985a.347.347 0 1 1 0-.694h4.985a.347.347 0 0 1 0 .694",
  className: "px-title-setup_svg__cls-9",
  "data-name": "Path 65120",
  transform: "translate(-228.621 -57.103)"
}))), /*#__PURE__*/React.createElement("g", {
  id: "px-title-setup_svg__Group_50360",
  "data-name": "Group 50360",
  transform: "translate(0 1.992)"
}, /*#__PURE__*/React.createElement("g", {
  id: "px-title-setup_svg__Group_50358",
  "data-name": "Group 50358"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-title-setup_svg__Path_65121",
  d: "M158.522 102.145h-1.284a.347.347 0 1 1 0-.694h1.284a.347.347 0 1 1 0 .694",
  className: "px-title-setup_svg__cls-9",
  "data-name": "Path 65121",
  transform: "translate(-156.891 -101.451)"
})), /*#__PURE__*/React.createElement("g", {
  id: "px-title-setup_svg__Group_50359",
  "data-name": "Group 50359",
  transform: "translate(3.222)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-title-setup_svg__Path_65122",
  d: "M233.953 102.145h-4.985a.347.347 0 1 1 0-.694h4.985a.347.347 0 0 1 0 .694",
  className: "px-title-setup_svg__cls-9",
  "data-name": "Path 65122",
  transform: "translate(-228.621 -101.451)"
}))), /*#__PURE__*/React.createElement("g", {
  id: "px-title-setup_svg__Group_50363",
  "data-name": "Group 50363",
  transform: "translate(0 3.984)"
}, /*#__PURE__*/React.createElement("g", {
  id: "px-title-setup_svg__Group_50361",
  "data-name": "Group 50361"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-title-setup_svg__Path_65123",
  d: "M158.522 146.493h-1.284a.347.347 0 1 1 0-.694h1.284a.347.347 0 1 1 0 .694",
  className: "px-title-setup_svg__cls-9",
  "data-name": "Path 65123",
  transform: "translate(-156.891 -145.799)"
})), /*#__PURE__*/React.createElement("g", {
  id: "px-title-setup_svg__Group_50362",
  "data-name": "Group 50362",
  transform: "translate(3.222)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-title-setup_svg__Path_65124",
  d: "M233.953 146.493h-4.985a.347.347 0 1 1 0-.694h4.985a.347.347 0 1 1 0 .694",
  className: "px-title-setup_svg__cls-9",
  "data-name": "Path 65124",
  transform: "translate(-228.621 -145.799)"
}))), /*#__PURE__*/React.createElement("g", {
  id: "px-title-setup_svg__Group_50366",
  "data-name": "Group 50366",
  transform: "translate(0 5.976)"
}, /*#__PURE__*/React.createElement("g", {
  id: "px-title-setup_svg__Group_50364",
  "data-name": "Group 50364"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-title-setup_svg__Path_65125",
  d: "M158.522 190.84h-1.284a.347.347 0 0 1 0-.694h1.284a.347.347 0 0 1 0 .694",
  className: "px-title-setup_svg__cls-9",
  "data-name": "Path 65125",
  transform: "translate(-156.891 -190.146)"
})), /*#__PURE__*/React.createElement("g", {
  id: "px-title-setup_svg__Group_50365",
  "data-name": "Group 50365",
  transform: "translate(3.222)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-title-setup_svg__Path_65126",
  d: "M233.953 190.84h-4.985a.347.347 0 0 1 0-.694h4.985a.347.347 0 0 1 0 .694",
  className: "px-title-setup_svg__cls-9",
  "data-name": "Path 65126",
  transform: "translate(-228.621 -190.146)"
}))), /*#__PURE__*/React.createElement("g", {
  id: "px-title-setup_svg__Group_50369",
  "data-name": "Group 50369",
  transform: "translate(0 7.969)"
}, /*#__PURE__*/React.createElement("g", {
  id: "px-title-setup_svg__Group_50367",
  "data-name": "Group 50367"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-title-setup_svg__Path_65127",
  d: "M158.522 235.187h-1.284a.347.347 0 1 1 0-.694h1.284a.347.347 0 1 1 0 .694",
  className: "px-title-setup_svg__cls-9",
  "data-name": "Path 65127",
  transform: "translate(-156.891 -234.493)"
})), /*#__PURE__*/React.createElement("g", {
  id: "px-title-setup_svg__Group_50368",
  "data-name": "Group 50368",
  transform: "translate(3.222)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-title-setup_svg__Path_65128",
  d: "M233.953 235.187h-4.985a.347.347 0 1 1 0-.694h4.985a.347.347 0 1 1 0 .694",
  className: "px-title-setup_svg__cls-9",
  "data-name": "Path 65128",
  transform: "translate(-228.621 -234.493)"
})))), /*#__PURE__*/React.createElement("g", {
  id: "px-title-setup_svg__Group_50371",
  "data-name": "Group 50371",
  transform: "translate(8.52 20.225)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-title-setup_svg__Path_65129",
  d: "M195.274 458.357h-5.263a.347.347 0 1 1 0-.694h5.263a.347.347 0 1 1 0 .694",
  className: "px-title-setup_svg__cls-9",
  "data-name": "Path 65129",
  transform: "translate(-189.664 -457.663)"
})))));

const SvgPxTodoRed = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 30"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 56788"
}, /*#__PURE__*/React.createElement("path", {
  fill: "red",
  d: "M14.437 3.101h-10.6a1.017 1.017 0 0 0-1.031 1v24.9a1.016 1.016 0 0 0 1.031.995h19.128a1.016 1.016 0 0 0 1.031-.995V4.095a1.017 1.017 0 0 0-1.031-1Z",
  "data-name": "Path 68592"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M22.022 28.51H5.045a.46.46 0 0 1-.466-.454V5.008a.46.46 0 0 1 .466-.454h16.977a.46.46 0 0 1 .466.454v23.049a.46.46 0 0 1-.466.454",
  "data-name": "Path 68593"
}), /*#__PURE__*/React.createElement("path", {
  fill: "red",
  d: "M15.228 1.786a1.793 1.793 0 0 0-3.585 0H7.717v3.831h11.439V1.786Z",
  "data-name": "Path 68594"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M14.199 1.845a.778.778 0 1 1-.778-.778.78.78 0 0 1 .778.778",
  "data-name": "Path 68595"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ff4568",
  d: "M7.715 4.554h11.439v1.063H7.715z",
  "data-name": "Rectangle 26102"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M12.516 7.562h2.769v.523h-2.769z",
  "data-name": "Rectangle 26103"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M12.563 8.857h7.725v.523h-7.725z",
  "data-name": "Rectangle 26104"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M12.563 10.118h7.725v.523h-7.725z",
  "data-name": "Rectangle 26105"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M12.563 11.379h7.725v.523h-7.725z",
  "data-name": "Rectangle 26106"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M12.563 16.294h7.725v.523h-7.725z",
  "data-name": "Rectangle 26107"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M12.563 17.554h7.725v.523h-7.725z",
  "data-name": "Rectangle 26108"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M12.563 18.815h7.725v.523h-7.725z",
  "data-name": "Rectangle 26109"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M12.563 23.71h7.725v.523h-7.725z",
  "data-name": "Rectangle 26110"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M12.563 24.872h7.725v.523h-7.725z",
  "data-name": "Rectangle 26111"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M12.563 26.16h7.725v.523h-7.725z",
  "data-name": "Rectangle 26112"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M12.516 14.989h2.769v.523h-2.769z",
  "data-name": "Rectangle 26113"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M12.516 22.416h2.769v.523h-2.769z",
  "data-name": "Rectangle 26114"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffcb00",
  d: "M11.154 9.749a2.212 2.212 0 1 1-2.212-2.212 2.21 2.21 0 0 1 2.212 2.212",
  "data-name": "Path 68596"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m8.708 10.941-1.27-1.216.475-.5.775.741 1.27-1.325.5.475Z",
  "data-name": "Path 68597"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4ad395",
  d: "M11.154 24.411a2.212 2.212 0 1 1-2.212-2.212 2.21 2.21 0 0 1 2.212 2.212",
  "data-name": "Path 68598"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m8.708 25.614-1.27-1.216.475-.5.775.741 1.27-1.325.5.475Z",
  "data-name": "Path 68599"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ff4568",
  d: "M12.63 21.106a5.6 5.6 0 1 0-7.919-.127 5.6 5.6 0 0 0 7.919.127",
  "data-name": "Path 68600"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M8.739 21.511a4.422 4.422 0 1 1 4.492-4.351 4.42 4.42 0 0 1-4.492 4.351",
  "data-name": "Path 68601"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#434b56",
  d: "M4.711 20.902a5.7 5.7 0 0 1-.564-.694l-.934.9 1.382 1.426.956-.926a5.6 5.6 0 0 1-.84-.711",
  "data-name": "Path 68602"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ff4568",
  d: "m1.682 25.185 2.912-2.819-1.381-1.426-2.911 2.82a.993.993 0 0 0 1.381 1.426",
  "data-name": "Path 68603"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ff5163",
  d: "M12.297 17.094a3.481 3.481 0 1 1-3.481-3.481 3.48 3.48 0 0 1 3.481 3.481",
  "data-name": "Path 68604"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m8.448 18.995-2-1.914.747-.78 1.219 1.167 2-2.086.78.747Z",
  "data-name": "Path 68605"
})));

const SvgPxTodo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 30"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 56788"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#033a5d",
  d: "M14.437 3.101h-10.6a1.017 1.017 0 0 0-1.031 1v24.9a1.016 1.016 0 0 0 1.031.995h19.128a1.016 1.016 0 0 0 1.031-.995V4.095a1.017 1.017 0 0 0-1.031-1Z",
  "data-name": "Path 68592"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M22.022 28.51H5.045a.46.46 0 0 1-.466-.454V5.008a.46.46 0 0 1 .466-.454h16.977a.46.46 0 0 1 .466.454v23.049a.46.46 0 0 1-.466.454",
  "data-name": "Path 68593"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00467d",
  d: "M15.228 1.786a1.793 1.793 0 0 0-3.585 0H7.717v3.831h11.439V1.786Z",
  "data-name": "Path 68594"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M14.199 1.845a.778.778 0 1 1-.778-.778.78.78 0 0 1 .778.778",
  "data-name": "Path 68595"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#033a5d",
  d: "M7.715 4.554h11.439v1.063H7.715z",
  "data-name": "Rectangle 26102"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M12.516 7.562h2.769v.523h-2.769z",
  "data-name": "Rectangle 26103"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M12.563 8.857h7.725v.523h-7.725z",
  "data-name": "Rectangle 26104"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M12.563 10.118h7.725v.523h-7.725z",
  "data-name": "Rectangle 26105"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M12.563 11.379h7.725v.523h-7.725z",
  "data-name": "Rectangle 26106"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M12.563 16.294h7.725v.523h-7.725z",
  "data-name": "Rectangle 26107"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M12.563 17.554h7.725v.523h-7.725z",
  "data-name": "Rectangle 26108"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M12.563 18.815h7.725v.523h-7.725z",
  "data-name": "Rectangle 26109"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M12.563 23.71h7.725v.523h-7.725z",
  "data-name": "Rectangle 26110"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M12.563 24.872h7.725v.523h-7.725z",
  "data-name": "Rectangle 26111"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M12.563 26.16h7.725v.523h-7.725z",
  "data-name": "Rectangle 26112"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M12.516 14.989h2.769v.523h-2.769z",
  "data-name": "Rectangle 26113"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M12.516 22.416h2.769v.523h-2.769z",
  "data-name": "Rectangle 26114"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffcb00",
  d: "M11.154 9.749a2.212 2.212 0 1 1-2.212-2.212 2.21 2.21 0 0 1 2.212 2.212",
  "data-name": "Path 68596"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m8.708 10.941-1.27-1.216.475-.5.775.741 1.27-1.325.5.475Z",
  "data-name": "Path 68597"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4ad395",
  d: "M11.154 24.411a2.212 2.212 0 1 1-2.212-2.212 2.21 2.21 0 0 1 2.212 2.212",
  "data-name": "Path 68598"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m8.708 25.614-1.27-1.216.475-.5.775.741 1.27-1.325.5.475Z",
  "data-name": "Path 68599"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4fabf7",
  d: "M12.63 21.106a5.6 5.6 0 1 0-7.919-.127 5.6 5.6 0 0 0 7.919.127",
  "data-name": "Path 68600"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M8.739 21.511a4.422 4.422 0 1 1 4.492-4.351 4.42 4.42 0 0 1-4.492 4.351",
  "data-name": "Path 68601"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#434b56",
  d: "M4.711 20.902a5.7 5.7 0 0 1-.564-.694l-.934.9 1.382 1.426.956-.926a5.6 5.6 0 0 1-.84-.711",
  "data-name": "Path 68602"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4fabf7",
  d: "m1.682 25.185 2.912-2.819-1.381-1.426-2.911 2.82a.993.993 0 0 0 1.381 1.426",
  "data-name": "Path 68603"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ff5163",
  d: "M12.297 17.094a3.481 3.481 0 1 1-3.481-3.481 3.48 3.48 0 0 1 3.481 3.481",
  "data-name": "Path 68604"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m8.448 18.995-2-1.914.747-.78 1.219 1.167 2-2.086.78.747Z",
  "data-name": "Path 68605"
})));

const SvgPxTravelAgent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 30 30"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 13692"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h30v30H0z",
  "data-name": "Rectangle 13496"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 13691"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#002672",
  d: "M12.378 11.265a1.87 1.87 0 0 1-1.963 1.763 1.87 1.87 0 0 1-1.963-1.763v-1.177a1.87 1.87 0 0 1 1.963-1.763 1.87 1.87 0 0 1 1.963 1.763Z",
  "data-name": "Path 24178"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#002672",
  d: "M21.314 11.265a1.87 1.87 0 0 1-1.963 1.763 1.87 1.87 0 0 1-1.963-1.763v-1.177a1.87 1.87 0 0 1 1.963-1.763 1.87 1.87 0 0 1 1.963 1.763Z",
  "data-name": "Path 24179"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#002672",
  d: "M20.656 9.394a8 8 0 0 0-.193-.951 8 8 0 0 0-.5-1.388 7 7 0 0 0-.546-.982c-.05-.079-.1-.159-.159-.234a5.3 5.3 0 0 0-4.263-2.385c-2.265 0-4.229 1.656-5.167 4.064a7.5 7.5 0 0 0-.3.925 8 8 0 0 0-.241 1.323 9 9 0 0 0-.052.963 9 9 0 0 0 .318 2.383c.779 2.847 2.921 4.893 5.439 4.893a5.15 5.15 0 0 0 3.889-1.911 6 6 0 0 1-1.145-.063 3 3 0 0 1-.752-.21 1.68 1.68 0 0 1-1.288.11 1.547 1.547 0 1 1 .925-2.947 1.66 1.66 0 0 1 1.1 1.071 6.4 6.4 0 0 0 1.518.05 4 4 0 0 0 .937-.2 8 8 0 0 0 .262-.8 9.1 9.1 0 0 0 .218-3.71Z",
  "data-name": "Path 24180"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M20.012 10.725a7.6 7.6 0 0 1-.771 3.375 6.4 6.4 0 0 1-1.518-.05 1.66 1.66 0 0 0-1.1-1.071 1.547 1.547 0 1 0-.925 2.947 1.68 1.68 0 0 0 1.288-.109 3 3 0 0 0 .752.21 4.28 4.28 0 0 1-2.742 1.031c-2.768 0-5.012-2.836-5.012-6.333s2.244-6.333 5.012-6.333 5.016 2.836 5.016 6.333",
  "data-name": "Path 24181"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#002672",
  d: "M18.792 5.956a1.22 1.22 0 0 1-.371.835 4.9 4.9 0 0 1-3.411 1.1 4.6 4.6 0 0 1-3.534-1.24 1.14 1.14 0 0 1-.248-.69c0-.713.755-1.336 1.881-1.669a6.8 6.8 0 0 1 1.9-.261 6.8 6.8 0 0 1 1.626.189 3.2 3.2 0 0 1 1.968 1.14 1.2 1.2 0 0 1 .138.289 1 1 0 0 1 .051.307",
  "data-name": "Path 24182"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#002672",
  d: "M9.986 12.56s1-4.9 3.39-4.864l-.669-1.307-.928-.625-.96.6-1.134 2.8Z",
  "data-name": "Path 24183"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 13689"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#5367ff",
  d: "M16.961 18.964c0 .4-.17.728-.38.728h-3.142c-.21 0-.38-.326-.38-.728 0-.4.17-.728.38-.728h3.142c.21 0 .38.326.38.728",
  "data-name": "Path 24184"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5367ff",
  d: "M13.964 18.615h2.029v6.04h-2.029z",
  "data-name": "Rectangle 13495"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#002672",
  d: "M24.979 26.035c0 3.838-4.463 3.965-9.969 3.965s-9.969-.127-9.969-3.965c0-3.23 3.159-5.945 7.441-6.725l2.528 4.652 2.529-4.652c4.279.778 7.44 3.495 7.44 6.725",
  "data-name": "Path 24185"
})), /*#__PURE__*/React.createElement("g", {
  fill: "#5367ff",
  "data-name": "Group 13690",
  transform: "translate(5)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.976 11.587a1.476 1.476 0 0 1-1.488 1.464A1.476 1.476 0 0 1 0 11.587v-2.5a1.476 1.476 0 0 1 1.488-1.464 1.476 1.476 0 0 1 1.488 1.464Z",
  "data-name": "Path 24186"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.69 11.587a1.476 1.476 0 0 1-1.488 1.464 1.476 1.476 0 0 1-1.488-1.464v-2.5a1.476 1.476 0 0 1 1.488-1.464 1.476 1.476 0 0 1 1.488 1.464Z",
  "data-name": "Path 24187"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.169 8.583H17.68c0-3.835-3.466-6.943-7.746-6.943S2.188 4.748 2.188 8.583H.702C.702 4.013 4.835 0 9.935 0s9.234 4.012 9.234 8.583",
  "data-name": "Path 24188"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 1.153,
  cy: 1.274,
  "data-name": "Ellipse 461",
  rx: 1.153,
  ry: 1.274,
  transform: "rotate(-67.275 16.079 .308)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.681 12.453s-1.138 2.913-6 2l-.219.758s5.208 1.8 7.44-2.753Z",
  "data-name": "Path 24189"
})))));

const SvgPxUnitDirection = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".px-unit-direction_svg__b{fill:#f0f7ff}.px-unit-direction_svg__c{fill:#d7e9fc}.px-unit-direction_svg__d{fill:#00b3ff}.px-unit-direction_svg__e{fill:#3a80e8}.px-unit-direction_svg__f{fill:#00f6fe}")), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h32v32H0z",
  style: {
    fill: "none"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.299 10.674v16.462H15.342l.657-16.462Z",
  className: "px-unit-direction_svg__b"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.149 10.674h5.15v16.462h-5.15Z",
  className: "px-unit-direction_svg__c"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.829 13.503h1.408v1.408h-1.408Z",
  className: "px-unit-direction_svg__d"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.062 13.503h1.408v1.408h-1.408Z",
  className: "px-unit-direction_svg__e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.829 16.736h1.408v1.408h-1.408Z",
  className: "px-unit-direction_svg__d"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.062 16.736h1.408v1.408h-1.408Z",
  className: "px-unit-direction_svg__e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.829 19.968h1.408v1.408h-1.408Z",
  className: "px-unit-direction_svg__d"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.062 19.968h1.408v1.408h-1.408Z",
  className: "px-unit-direction_svg__e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.416 3.807h6.867v4.864H7.416Z",
  className: "px-unit-direction_svg__b"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.85 3.807h3.433v4.864H10.85Z",
  className: "px-unit-direction_svg__c"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.829 23.2h1.408v1.408h-1.408Z",
  className: "px-unit-direction_svg__d"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.062 23.2h1.408v1.408h-1.408Z",
  className: "px-unit-direction_svg__e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16 7.24v19.9H5.7V8.957l5.15-.857Z",
  className: "px-unit-direction_svg__d"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16 7.24v19.9h-5.15V8.1Z",
  className: "px-unit-direction_svg__e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.762 10.271h1.408v1.408h-1.408ZM11.762 13.503h1.408v1.408h-1.408Z",
  className: "px-unit-direction_svg__d"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.529 13.503h1.408v1.408H8.529Z",
  className: "px-unit-direction_svg__f"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.762 16.736h1.408v1.408h-1.408Z",
  className: "px-unit-direction_svg__d"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.529 16.736h1.408v1.408H8.529Z",
  className: "px-unit-direction_svg__f"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.762 19.968h1.408v1.408h-1.408Z",
  className: "px-unit-direction_svg__d"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.529 19.968h1.408v1.408H8.529ZM8.53 23.2h4.64v3.936H8.53Z",
  className: "px-unit-direction_svg__f"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.85 23.2h2.32v3.936h-2.32Z",
  className: "px-unit-direction_svg__d"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 482h24.033v1.408H0Z",
  style: {
    fill: "#9dd867"
  },
  transform: "translate(3.983 -455.568)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M256 482h12.017v1.408H256Z",
  style: {
    fill: "#77c080"
  },
  transform: "translate(-240 -455.568)"
}));

const SvgPxUnitSetup = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".px-unit-setup_svg__cls-2{fill:#e6f7fe}.px-unit-setup_svg__cls-5{fill:#f7e365}.px-unit-setup_svg__cls-6{fill:#62a4fb}.px-unit-setup_svg__cls-8{fill:#e175a5}.px-unit-setup_svg__cls-10{fill:#30569f}")), /*#__PURE__*/React.createElement("g", {
  id: "px-unit-setup_svg__Group_50318",
  "data-name": "Group 50318",
  transform: "translate(11468 -20291)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-unit-setup_svg__icon_placeholder",
  d: "M0 0h32v32H0z",
  style: {
    fill: "none"
  },
  transform: "translate(-11468 20291)"
}), /*#__PURE__*/React.createElement("g", {
  id: "px-unit-setup_svg__project-management",
  transform: "translate(-11461.455 20296.297)"
}, /*#__PURE__*/React.createElement("g", {
  id: "px-unit-setup_svg__Group_50250",
  "data-name": "Group 50250"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-unit-setup_svg__Path_64702",
  d: "M22.724 0h11.125a.87.87 0 0 1 .615.255l3.667 3.667a.87.87 0 0 1 .255.615v16a.87.87 0 0 1-.87.87H22.724a.87.87 0 0 1-.87-.87V.87a.87.87 0 0 1 .87-.87",
  className: "px-unit-setup_svg__cls-2",
  "data-name": "Path 64702",
  transform: "translate(-21.854)"
})), /*#__PURE__*/React.createElement("g", {
  id: "px-unit-setup_svg__Group_50251",
  "data-name": "Group 50251",
  transform: "translate(11.224)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-unit-setup_svg__Path_64703",
  d: "M295.394 3.922 291.727.255a.87.87 0 0 0-.615-.255h-.771v3.306a2 2 0 0 0 2 2h1.305a.87.87 0 0 1 .87.87v14.358a.87.87 0 0 1-.87.87h1.131a.87.87 0 0 0 .87-.87v-16a.87.87 0 0 0-.255-.615Z",
  "data-name": "Path 64703",
  style: {
    fill: "#d3effd"
  },
  transform: "translate(-290.341)"
})), /*#__PURE__*/React.createElement("g", {
  id: "px-unit-setup_svg__Group_50252",
  "data-name": "Group 50252",
  transform: "translate(12.355 .079)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-unit-setup_svg__Path_64704",
  d: "M317.4 5.121a.87.87 0 0 0 .87.87h3.23a.9.9 0 0 0-.176-.255l-3.671-3.666a.9.9 0 0 0-.255-.176Z",
  "data-name": "Path 64704",
  style: {
    fill: "#b2e5fb"
  },
  transform: "translate(-317.398 -1.894)"
})), /*#__PURE__*/React.createElement("g", {
  id: "px-unit-setup_svg__Group_50257",
  "data-name": "Group 50257",
  transform: "translate(2.175 5.917)"
}, /*#__PURE__*/React.createElement("g", {
  id: "px-unit-setup_svg__Group_50254",
  "data-name": "Group 50254"
}, /*#__PURE__*/React.createElement("g", {
  id: "px-unit-setup_svg__Group_50253",
  "data-name": "Group 50253"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-unit-setup_svg__Path_64705",
  d: "M78.5 147.62h-4a.61.61 0 0 1-.609-.609v-4.873a.61.61 0 0 1 .609-.609h4a.61.61 0 0 1 .609.609v4.872a.61.61 0 0 1-.609.61",
  className: "px-unit-setup_svg__cls-5",
  "data-name": "Path 64705",
  transform: "translate(-73.886 -141.529)"
}))), /*#__PURE__*/React.createElement("g", {
  id: "px-unit-setup_svg__Group_50256",
  "data-name": "Group 50256",
  transform: "translate(6.961)"
}, /*#__PURE__*/React.createElement("g", {
  id: "px-unit-setup_svg__Group_50255",
  "data-name": "Group 50255"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-unit-setup_svg__Path_64706",
  d: "M245 147.62h-4a.61.61 0 0 1-.609-.609v-4.873a.61.61 0 0 1 .609-.609h4a.61.61 0 0 1 .609.609v4.872a.61.61 0 0 1-.609.61",
  className: "px-unit-setup_svg__cls-5",
  "data-name": "Path 64706",
  transform: "translate(-240.39 -141.529)"
})))), /*#__PURE__*/React.createElement("g", {
  id: "px-unit-setup_svg__Group_50262",
  "data-name": "Group 50262",
  transform: "translate(9.136 9.571)"
}, /*#__PURE__*/React.createElement("g", {
  id: "px-unit-setup_svg__Group_50258",
  "data-name": "Group 50258"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-unit-setup_svg__Path_64707",
  d: "M250.828 234.37v-.414a.345.345 0 0 0-.274-.337l-.609-.127a.34.34 0 0 1-.265-.257q-.035-.155-.081-.305a.34.34 0 0 1 .1-.354l.464-.414a.345.345 0 0 0 .069-.429l-.207-.359a.345.345 0 0 0-.406-.155l-.592.195a.34.34 0 0 1-.357-.09q-.107-.115-.223-.223a.34.34 0 0 1-.09-.357l.195-.592a.345.345 0 0 0-.155-.406l-.359-.207a.345.345 0 0 0-.429.069l-.414.464a.34.34 0 0 1-.354.1q-.15-.046-.305-.081a.34.34 0 0 1-.257-.265l-.127-.609a.345.345 0 0 0-.337-.274h-.415a.345.345 0 0 0-.337.274l-.127.609a.34.34 0 0 1-.257.265q-.155.035-.305.081a.34.34 0 0 1-.354-.1l-.414-.464a.345.345 0 0 0-.429-.069l-.359.207a.345.345 0 0 0-.155.406l.195.592a.34.34 0 0 1-.09.357q-.116.107-.223.223a.34.34 0 0 1-.357.09l-.592-.195a.345.345 0 0 0-.406.155l-.207.359a.345.345 0 0 0 .069.429l.464.414a.34.34 0 0 1 .1.354q-.046.15-.081.305a.34.34 0 0 1-.265.257l-.609.127a.345.345 0 0 0-.274.337v.414a.345.345 0 0 0 .274.337l.609.127a.34.34 0 0 1 .265.257q.035.155.081.305a.34.34 0 0 1-.1.354l-.464.414a.345.345 0 0 0-.069.429l.207.359a.345.345 0 0 0 .406.155l.592-.195a.34.34 0 0 1 .357.09q.107.116.223.223a.34.34 0 0 1 .09.357l-.195.592a.345.345 0 0 0 .155.406l.359.207a.345.345 0 0 0 .429-.069l.414-.464a.34.34 0 0 1 .354-.1q.15.046.305.081a.34.34 0 0 1 .257.265l.127.609a.345.345 0 0 0 .337.274h.414a.345.345 0 0 0 .337-.274l.127-.609a.34.34 0 0 1 .257-.265q.155-.035.305-.081a.34.34 0 0 1 .354.1l.414.464a.345.345 0 0 0 .429.069l.359-.207a.345.345 0 0 0 .155-.406l-.195-.592a.34.34 0 0 1 .09-.357q.116-.107.223-.223a.34.34 0 0 1 .357-.09l.592.195a.345.345 0 0 0 .406-.155l.207-.359a.345.345 0 0 0-.069-.429l-.464-.414a.34.34 0 0 1-.1-.354q.046-.15.081-.305a.34.34 0 0 1 .265-.257l.609-.127a.344.344 0 0 0 .274-.337Z",
  className: "px-unit-setup_svg__cls-6",
  "data-name": "Path 64707",
  transform: "translate(-240.387 -228.942)"
})), /*#__PURE__*/React.createElement("g", {
  id: "px-unit-setup_svg__Group_50259",
  "data-name": "Group 50259",
  transform: "translate(2.259 2.259)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-unit-setup_svg__Path_64708",
  d: "m302.325 285.387-.609-.127a.34.34 0 0 1-.265-.257q-.035-.155-.081-.305a.34.34 0 0 1 .1-.354l.464-.414a.344.344 0 0 0 .066-.43l-.207-.359a.345.345 0 0 0-.406-.155l-.592.195a.4.4 0 0 1-.114.017 6 6 0 0 1 .066.862 5.33 5.33 0 0 1-5.329 5.329 5.4 5.4 0 0 1-.787-.058v.019l-.195.592a.345.345 0 0 0 .155.406l.359.207a.345.345 0 0 0 .429-.069l.414-.464a.34.34 0 0 1 .354-.1q.15.046.305.081a.34.34 0 0 1 .257.265l.127.609a.344.344 0 0 0 .337.274h.414a.344.344 0 0 0 .337-.274l.127-.609a.34.34 0 0 1 .257-.265q.155-.035.305-.081a.34.34 0 0 1 .354.1l.414.464a.345.345 0 0 0 .429.069l.359-.207a.345.345 0 0 0 .155-.406l-.195-.592a.34.34 0 0 1 .09-.357q.116-.107.223-.223a.34.34 0 0 1 .357-.09l.592.195a.345.345 0 0 0 .406-.155l.207-.359a.345.345 0 0 0-.069-.429l-.464-.414a.34.34 0 0 1-.1-.354q.046-.15.081-.305a.34.34 0 0 1 .265-.257l.609-.127a.344.344 0 0 0 .274-.337v-.414a.345.345 0 0 0-.275-.337",
  "data-name": "Path 64708",
  style: {
    fill: "#5392f9"
  },
  transform: "translate(-294.416 -282.969)"
})), /*#__PURE__*/React.createElement("g", {
  id: "px-unit-setup_svg__Group_50260",
  "data-name": "Group 50260",
  transform: "translate(2.393 2.393)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "px-unit-setup_svg__Ellipse_794",
  cx: 2.828,
  cy: 2.828,
  r: 2.828,
  className: "px-unit-setup_svg__cls-2",
  "data-name": "Ellipse 794"
})), /*#__PURE__*/React.createElement("g", {
  id: "px-unit-setup_svg__Group_50261",
  "data-name": "Group 50261",
  transform: "translate(4.177 4.176)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "px-unit-setup_svg__Ellipse_795",
  cx: 1.044,
  cy: 1.044,
  r: 1.044,
  className: "px-unit-setup_svg__cls-6",
  "data-name": "Ellipse 795"
}))), /*#__PURE__*/React.createElement("g", {
  id: "px-unit-setup_svg__Group_50263",
  "data-name": "Group 50263",
  transform: "translate(1.862 1.392)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-unit-setup_svg__Path_64709",
  d: "M73.926 34.693h-7.194a.345.345 0 0 1-.345-.345v-.7a.345.345 0 0 1 .345-.345h7.194a.345.345 0 0 1 .345.345v.7a.345.345 0 0 1-.345.345",
  className: "px-unit-setup_svg__cls-8",
  "data-name": "Path 64709",
  transform: "translate(-66.387 -33.301)"
})), /*#__PURE__*/React.createElement("g", {
  id: "px-unit-setup_svg__Group_50264",
  "data-name": "Group 50264",
  transform: "translate(1.862 18.62)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-unit-setup_svg__Path_64710",
  d: "M71.925 446.791h-5.193a.345.345 0 0 1-.345-.345v-.7a.345.345 0 0 1 .345-.345h5.193a.345.345 0 0 1 .345.345v.7a.345.345 0 0 1-.345.345",
  "data-name": "Path 64710",
  style: {
    fill: "#ad7fdd"
  },
  transform: "translate(-66.387 -445.399)"
})), /*#__PURE__*/React.createElement("g", {
  id: "px-unit-setup_svg__Group_50265",
  "data-name": "Group 50265",
  transform: "translate(3.254 6.995)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-unit-setup_svg__Path_64711",
  d: "M101.045 167.956H100a.314.314 0 0 1 0-.627h1.044a.314.314 0 1 1 0 .627Z",
  className: "px-unit-setup_svg__cls-10",
  "data-name": "Path 64711",
  transform: "translate(-99.687 -167.329)"
})), /*#__PURE__*/React.createElement("g", {
  id: "px-unit-setup_svg__Group_50266",
  "data-name": "Group 50266",
  transform: "translate(3.254 8.387)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-unit-setup_svg__Path_64712",
  d: "M102.437 201.257H100a.314.314 0 0 1 0-.627h2.436a.314.314 0 1 1 0 .627Z",
  className: "px-unit-setup_svg__cls-10",
  "data-name": "Path 64712",
  transform: "translate(-99.687 -200.63)"
})), /*#__PURE__*/React.createElement("g", {
  id: "px-unit-setup_svg__Group_50267",
  "data-name": "Group 50267",
  transform: "translate(3.254 9.78)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-unit-setup_svg__Path_64713",
  d: "M102.437 234.558H100a.314.314 0 1 1 0-.627h2.436a.314.314 0 1 1 0 .627Z",
  className: "px-unit-setup_svg__cls-10",
  "data-name": "Path 64713",
  transform: "translate(-99.687 -233.931)"
})), /*#__PURE__*/React.createElement("g", {
  id: "px-unit-setup_svg__Group_50268",
  "data-name": "Group 50268",
  transform: "translate(10.215 6.995)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-unit-setup_svg__Path_64714",
  d: "M267.549 167.956H266.5a.314.314 0 1 1 0-.627h1.044a.314.314 0 0 1 0 .627Z",
  className: "px-unit-setup_svg__cls-10",
  "data-name": "Path 64714",
  transform: "translate(-266.191 -167.329)"
})), /*#__PURE__*/React.createElement("g", {
  id: "px-unit-setup_svg__Group_50269",
  "data-name": "Group 50269",
  transform: "translate(10.215 8.387)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-unit-setup_svg__Path_64715",
  d: "M268.68 201.257h-2.18a.314.314 0 0 1 0-.627h2.175a.314.314 0 0 1 0 .627Z",
  className: "px-unit-setup_svg__cls-10",
  "data-name": "Path 64715",
  transform: "translate(-266.191 -200.63)"
})), /*#__PURE__*/React.createElement("g", {
  id: "px-unit-setup_svg__Group_50270",
  "data-name": "Group 50270",
  transform: "translate(1.862 3.863)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-unit-setup_svg__Path_64716",
  d: "M68.092 93.029H66.7a.314.314 0 0 1 0-.627h1.392a.314.314 0 1 1 0 .627",
  className: "px-unit-setup_svg__cls-6",
  "data-name": "Path 64716",
  transform: "translate(-66.386 -92.402)"
})), /*#__PURE__*/React.createElement("g", {
  id: "px-unit-setup_svg__Group_50271",
  "data-name": "Group 50271",
  transform: "translate(4.646 3.863)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-unit-setup_svg__Path_64717",
  d: "M138.087 93.029H133.3a.314.314 0 0 1 0-.627h4.786a.314.314 0 1 1 0 .627Z",
  className: "px-unit-setup_svg__cls-6",
  "data-name": "Path 64717",
  transform: "translate(-132.988 -92.402)"
})), /*#__PURE__*/React.createElement("g", {
  id: "px-unit-setup_svg__Group_50277",
  "data-name": "Group 50277",
  transform: "translate(1.862 13.869)"
}, /*#__PURE__*/React.createElement("g", {
  id: "px-unit-setup_svg__Group_50272",
  "data-name": "Group 50272",
  transform: "translate(3.567)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-unit-setup_svg__Path_64718",
  d: "M154.034 332.379h-2a.314.314 0 0 1 0-.627h2a.314.314 0 1 1 0 .627",
  className: "px-unit-setup_svg__cls-8",
  "data-name": "Path 64718",
  transform: "translate(-151.719 -331.752)"
})), /*#__PURE__*/React.createElement("g", {
  id: "px-unit-setup_svg__Group_50273",
  "data-name": "Group 50273",
  transform: "translate(1.305)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-unit-setup_svg__Path_64719",
  d: "M98.789 332.379h-.87a.314.314 0 1 1 0-.627h.87a.314.314 0 0 1 0 .627",
  className: "px-unit-setup_svg__cls-8",
  "data-name": "Path 64719",
  transform: "translate(-97.605 -331.752)"
})), /*#__PURE__*/React.createElement("g", {
  id: "px-unit-setup_svg__Group_50274",
  "data-name": "Group 50274",
  transform: "translate(0 1.392)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-unit-setup_svg__Path_64720",
  d: "M72.268 365.68H66.7a.314.314 0 0 1 0-.627h5.569a.314.314 0 0 1 0 .627Z",
  className: "px-unit-setup_svg__cls-8",
  "data-name": "Path 64720",
  transform: "translate(-66.386 -365.053)"
})), /*#__PURE__*/React.createElement("g", {
  id: "px-unit-setup_svg__Group_50275",
  "data-name": "Group 50275",
  transform: "translate(0 2.784)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-unit-setup_svg__Path_64721",
  d: "M70.006 398.981H66.7a.314.314 0 0 1 0-.627h3.306a.314.314 0 0 1 0 .627",
  className: "px-unit-setup_svg__cls-8",
  "data-name": "Path 64721",
  transform: "translate(-66.386 -398.354)"
})), /*#__PURE__*/React.createElement("g", {
  id: "px-unit-setup_svg__Group_50276",
  "data-name": "Group 50276",
  transform: "translate(4.699 2.784)"
}, /*#__PURE__*/React.createElement("path", {
  id: "px-unit-setup_svg__Path_64722",
  d: "M179.96 398.981h-.87a.314.314 0 1 1 0-.627h.87a.314.314 0 1 1 0 .627",
  className: "px-unit-setup_svg__cls-8",
  "data-name": "Path 64722",
  transform: "translate(-178.776 -398.354)"
}))))));

const SvgPxUnitType = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".px-unit-type_svg__b{fill:#e6f7fe}.px-unit-type_svg__e{fill:#f7e365}.px-unit-type_svg__f{fill:#62a4fb}.px-unit-type_svg__h{fill:#e175a5}.px-unit-type_svg__j{fill:#30569f}")), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h32v32H0z",
  style: {
    fill: "none"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.415 5.297H18.54a.87.87 0 0 1 .615.255l3.667 3.667a.87.87 0 0 1 .255.615v16a.87.87 0 0 1-.87.87H7.415a.87.87 0 0 1-.87-.87V6.167a.87.87 0 0 1 .87-.87",
  className: "px-unit-type_svg__b"
}), /*#__PURE__*/React.createElement("path", {
  d: "M295.394 3.922 291.727.255a.87.87 0 0 0-.615-.255h-.771v3.306a2 2 0 0 0 2 2h1.305a.87.87 0 0 1 .87.87v14.358a.87.87 0 0 1-.87.87h1.131a.87.87 0 0 0 .87-.87v-16a.87.87 0 0 0-.255-.615Z",
  style: {
    fill: "#d3effd"
  },
  transform: "translate(-272.572 5.297)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M317.4 5.121a.87.87 0 0 0 .87.87h3.23a.9.9 0 0 0-.176-.255l-3.671-3.666a.9.9 0 0 0-.255-.176Z",
  style: {
    fill: "#b2e5fb"
  },
  transform: "translate(-298.498 3.482)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.334 17.305h-4a.61.61 0 0 1-.609-.609v-4.873a.61.61 0 0 1 .609-.609h4a.61.61 0 0 1 .609.609v4.872a.61.61 0 0 1-.609.61M20.291 17.305h-4a.61.61 0 0 1-.609-.609v-4.873a.61.61 0 0 1 .609-.609h4a.61.61 0 0 1 .609.609v4.872a.61.61 0 0 1-.609.61",
  className: "px-unit-type_svg__e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.122 20.296v-.414a.345.345 0 0 0-.274-.337l-.609-.127a.34.34 0 0 1-.265-.257q-.035-.155-.081-.305a.34.34 0 0 1 .1-.354l.464-.414a.345.345 0 0 0 .069-.429l-.207-.359a.345.345 0 0 0-.406-.155l-.592.195a.34.34 0 0 1-.357-.09q-.107-.115-.223-.223a.34.34 0 0 1-.09-.357l.195-.592a.345.345 0 0 0-.155-.406l-.359-.207a.345.345 0 0 0-.429.069l-.414.464a.34.34 0 0 1-.354.1q-.15-.046-.305-.081a.34.34 0 0 1-.257-.265l-.127-.609a.345.345 0 0 0-.337-.274h-.415a.345.345 0 0 0-.337.274l-.127.609a.34.34 0 0 1-.257.265q-.155.035-.305.081a.34.34 0 0 1-.354-.1l-.414-.464a.345.345 0 0 0-.429-.069l-.359.207a.345.345 0 0 0-.155.406l.195.592a.34.34 0 0 1-.09.357q-.116.107-.223.223a.34.34 0 0 1-.357.09l-.592-.195a.345.345 0 0 0-.406.155l-.207.359a.345.345 0 0 0 .069.429l.464.414a.34.34 0 0 1 .1.354q-.046.15-.081.305a.34.34 0 0 1-.265.257l-.609.127a.345.345 0 0 0-.274.337v.414a.345.345 0 0 0 .274.337l.609.127a.34.34 0 0 1 .265.257q.035.155.081.305a.34.34 0 0 1-.1.354l-.464.414a.345.345 0 0 0-.069.429l.207.359a.345.345 0 0 0 .406.155l.592-.195a.34.34 0 0 1 .357.09q.107.116.223.223a.34.34 0 0 1 .09.357l-.195.592a.345.345 0 0 0 .155.406l.359.207a.345.345 0 0 0 .429-.069l.414-.464a.34.34 0 0 1 .354-.1q.15.046.305.081a.34.34 0 0 1 .257.265l.127.609a.345.345 0 0 0 .337.274h.414a.345.345 0 0 0 .337-.274l.127-.609a.34.34 0 0 1 .257-.265q.155-.035.305-.081a.34.34 0 0 1 .354.1l.414.464a.345.345 0 0 0 .429.069l.359-.207a.345.345 0 0 0 .155-.406l-.195-.592a.34.34 0 0 1 .09-.357q.116-.107.223-.223a.34.34 0 0 1 .357-.09l.592.195a.345.345 0 0 0 .406-.155l.207-.359a.345.345 0 0 0-.069-.429l-.464-.414a.34.34 0 0 1-.1-.354q.046-.15.081-.305a.34.34 0 0 1 .265-.257l.609-.127a.344.344 0 0 0 .274-.337Z",
  className: "px-unit-type_svg__f"
}), /*#__PURE__*/React.createElement("path", {
  d: "m302.325 285.387-.609-.127a.34.34 0 0 1-.265-.257q-.035-.155-.081-.305a.34.34 0 0 1 .1-.354l.464-.414a.344.344 0 0 0 .066-.43l-.207-.359a.345.345 0 0 0-.406-.155l-.592.195a.4.4 0 0 1-.114.017 6 6 0 0 1 .066.862 5.33 5.33 0 0 1-5.329 5.329 5.4 5.4 0 0 1-.787-.058v.019l-.195.592a.345.345 0 0 0 .155.406l.359.207a.345.345 0 0 0 .429-.069l.414-.464a.34.34 0 0 1 .354-.1q.15.046.305.081a.34.34 0 0 1 .257.265l.127.609a.344.344 0 0 0 .337.274h.414a.344.344 0 0 0 .337-.274l.127-.609a.34.34 0 0 1 .257-.265q.155-.035.305-.081a.34.34 0 0 1 .354.1l.414.464a.345.345 0 0 0 .429.069l.359-.207a.345.345 0 0 0 .155-.406l-.195-.592a.34.34 0 0 1 .09-.357q.116-.107.223-.223a.34.34 0 0 1 .357-.09l.592.195a.345.345 0 0 0 .406-.155l.207-.359a.345.345 0 0 0-.069-.429l-.464-.414a.34.34 0 0 1-.1-.354q.046-.15.081-.305a.34.34 0 0 1 .265-.257l.609-.127a.344.344 0 0 0 .274-.337v-.414a.345.345 0 0 0-.275-.337",
  style: {
    fill: "#5392f9"
  },
  transform: "translate(-276.476 -265.842)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 2.828,
  cy: 2.828,
  r: 2.828,
  className: "px-unit-type_svg__b",
  transform: "translate(18.074 17.261)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1.044,
  cy: 1.044,
  r: 1.044,
  className: "px-unit-type_svg__f",
  transform: "translate(19.858 19.044)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.946 8.081H8.752a.345.345 0 0 1-.345-.345v-.7a.345.345 0 0 1 .345-.345h7.194a.345.345 0 0 1 .345.345v.7a.345.345 0 0 1-.345.345",
  className: "px-unit-type_svg__h"
}), /*#__PURE__*/React.createElement("path", {
  d: "M71.925 446.791h-5.193a.345.345 0 0 1-.345-.345v-.7a.345.345 0 0 1 .345-.345h5.193a.345.345 0 0 1 .345.345v.7a.345.345 0 0 1-.345.345",
  style: {
    fill: "#ad7fdd"
  },
  transform: "translate(-57.98 -421.482)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.157 12.919h-1.045a.314.314 0 0 1 0-.627h1.044a.314.314 0 1 1 0 .627ZM12.549 14.311h-2.437a.314.314 0 0 1 0-.627h2.436a.314.314 0 1 1 0 .627ZM12.549 15.704h-2.437a.314.314 0 1 1 0-.627h2.436a.314.314 0 1 1 0 .627ZM18.118 12.919h-1.049a.314.314 0 1 1 0-.627h1.044a.314.314 0 0 1 0 .627ZM19.249 14.311h-2.18a.314.314 0 0 1 0-.627h2.175a.314.314 0 0 1 0 .627Z",
  className: "px-unit-type_svg__j"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.113 9.787H8.721a.314.314 0 0 1 0-.627h1.392a.314.314 0 1 1 0 .627M16.29 9.787h-4.787a.314.314 0 0 1 0-.627h4.786a.314.314 0 1 1 0 .627Z",
  className: "px-unit-type_svg__f"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.289 19.793h-2a.314.314 0 0 1 0-.627h2a.314.314 0 1 1 0 .627M10.896 19.793h-.87a.314.314 0 1 1 0-.627h.87a.314.314 0 0 1 0 .627M14.289 21.185H8.721a.314.314 0 0 1 0-.627h5.569a.314.314 0 0 1 0 .627ZM12.027 22.577H8.721a.314.314 0 0 1 0-.627h3.306a.314.314 0 0 1 0 .627M14.29 22.577h-.87a.314.314 0 1 1 0-.627h.87a.314.314 0 1 1 0 .627",
  className: "px-unit-type_svg__h"
}));

const SvgPxUser = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 30 30"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 51194"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h30v30H0z",
  "data-name": "Rectangle 25948"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "user (7)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#ffaa20",
  d: "M26.918 15A11.918 11.918 0 1 1 15 3.082 11.89 11.89 0 0 1 26.918 15m0 0",
  "data-name": "Path 72397"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ff8900",
  d: "M26.917 14.999A11.917 11.917 0 0 1 15 26.917V3.082A11.92 11.92 0 0 1 26.918 15Zm0 0",
  "data-name": "Path 72398"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#7985eb",
  d: "M23.031 23.757v.047a11.92 11.92 0 0 1-16.062 0v-.047a8.031 8.031 0 0 1 16.062 0m0 0",
  "data-name": "Path 72399"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4b5be6",
  d: "M23.031 23.757v.047A11.88 11.88 0 0 1 15 26.917v-11.19a8.03 8.03 0 0 1 8.031 8.031Zm0 0",
  "data-name": "Path 72400"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffdba9",
  d: "M19.926 12.156A4.926 4.926 0 1 1 15 7.23a4.93 4.93 0 0 1 4.926 4.926m0 0",
  "data-name": "Path 72401"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffc473",
  d: "M19.926 12.156A4.93 4.93 0 0 1 15 17.082V7.23a4.93 4.93 0 0 1 4.926 4.926m0 0",
  "data-name": "Path 72402"
}))));

const SvgPxUsersAccess = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 30 30"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 13658"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 13651"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h30v30H0z",
  "data-name": "Rectangle 13488"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 -30.631)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 5.5,
  cy: 5,
  fill: "#5367ff",
  "data-name": "Ellipse 157",
  rx: 5.5,
  ry: 5,
  transform: "translate(10 32.631)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3,
  fill: "#5367ff",
  "data-name": "Ellipse 158",
  transform: "translate(23 36.63)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3,
  fill: "#5367ff",
  "data-name": "Ellipse 159",
  transform: "translate(2 36.63)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#002672",
  d: "M7.863 45.72c-1.269-1.039-2.417-.9-3.884-.9A3.97 3.97 0 0 0 0 48.773v6.4a1.72 1.72 0 0 0 1.723 1.711c4.1 0 3.609.074 3.609-.177 0-4.53-.537-7.855 2.531-10.987",
  "data-name": "Path 12309"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#002672",
  d: "M16.395 44.842c-2.562-.214-4.789 0-6.71 1.588-3.214 2.575-2.6 6.041-2.6 10.282a2.055 2.055 0 0 0 2.052 2.052c12.368 0 12.86.4 13.594-1.225.241-.549.175-.375.175-5.629a7.1 7.1 0 0 0-6.511-7.068",
  "data-name": "Path 12310"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#002672",
  d: "M26.021 44.818c-1.475 0-2.617-.136-3.884.9 3.045 3.109 2.531 6.207 2.531 10.992 0 .253-.41.177 3.547.177A1.783 1.783 0 0 0 30 55.109v-6.336a3.97 3.97 0 0 0-3.979-3.955",
  "data-name": "Path 12311"
})))));

const SvgPxUsersAccessW = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 30 30"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 13658"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 13651"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h30v30H0z",
  "data-name": "Rectangle 13488"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 -30.631)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 5.5,
  cy: 5.5,
  r: 5.5,
  fill: "#ffb11f",
  "data-name": "Ellipse 157",
  transform: "translate(10 31.631)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3,
  fill: "#ffb11f",
  "data-name": "Ellipse 158",
  transform: "translate(23 36.63)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3,
  fill: "#ffb11f",
  "data-name": "Ellipse 159",
  transform: "translate(2 36.63)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M7.863 45.72c-1.269-1.039-2.417-.9-3.884-.9A3.97 3.97 0 0 0 0 48.773v6.4a1.72 1.72 0 0 0 1.723 1.711c4.1 0 3.609.074 3.609-.177 0-4.53-.537-7.855 2.531-10.987",
  "data-name": "Path 12309"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M16.395 44.842c-2.562-.214-4.789 0-6.71 1.588-3.214 2.575-2.6 6.041-2.6 10.282a2.055 2.055 0 0 0 2.052 2.052c12.368 0 12.86.4 13.594-1.225.241-.549.175-.375.175-5.629a7.1 7.1 0 0 0-6.511-7.068",
  "data-name": "Path 12310"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M26.021 44.818c-1.475 0-2.617-.136-3.884.9 3.045 3.109 2.531 6.207 2.531 10.992 0 .253-.41.177 3.547.177A1.783 1.783 0 0 0 30 55.109v-6.336a3.97 3.97 0 0 0-3.979-3.955",
  "data-name": "Path 12311"
})))));

const SvgPxUsersRole = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 30 30"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 51126"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h30v30H0z",
  "data-name": "Rectangle 25943"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#b4b4b4",
  d: "m20.243 14.719-.206.005a4.7 4.7 0 0 0-.978-2.625l.173-.127a.586.586 0 0 0 .083-.873 5.6 5.6 0 0 0-1.738-1.259.586.586 0 0 0-.8.352l-.086.265a4.7 4.7 0 0 0-2.853.033l-.1-.293a.586.586 0 0 0-.8-.35 5.6 5.6 0 0 0-1.734 1.265.586.586 0 0 0 .086.872l.235.171a4.7 4.7 0 0 0-.939 2.717h-.232a.586.586 0 0 0-.582.655 5.5 5.5 0 0 0 .666 2.045.586.586 0 0 0 .856.186l.125-.091a4.75 4.75 0 0 0 2.358 1.792l-.026.081a.586.586 0 0 0 .444.756 5.5 5.5 0 0 0 1.072.1 5.6 5.6 0 0 0 1.077-.1.586.586 0 0 0 .443-.756l-.017-.052a4.75 4.75 0 0 0 2.51-1.924l.1.066a.586.586 0 0 0 .851-.21 5.6 5.6 0 0 0 .615-2.056.586.586 0 0 0-.603-.645m-4.931 3.046a2.781 2.781 0 1 1 2.781-2.781 2.784 2.784 0 0 1-2.779 2.78Zm0 0",
  "data-name": "Path 68700"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#9a9999",
  d: "m20.245 14.719-.206.005a4.7 4.7 0 0 0-.978-2.625l.173-.127a.586.586 0 0 0 .083-.873 5.6 5.6 0 0 0-1.738-1.259.586.586 0 0 0-.8.352l-.086.265a4 4 0 0 0-.4-.1 5.493 5.493 0 0 1-2.346 9.825.6.6 0 0 0 .249.115 5.6 5.6 0 0 0 1.072.1 5.6 5.6 0 0 0 1.077-.1.586.586 0 0 0 .443-.756l-.017-.052a4.75 4.75 0 0 0 2.509-1.925l.1.066a.586.586 0 0 0 .851-.209 5.6 5.6 0 0 0 .615-2.057.586.586 0 0 0-.6-.642Zm0 0",
  "data-name": "Path 68701"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f57a73",
  d: "M23.178 19.436a4 4 0 0 0-.574.04 3.97 3.97 0 0 1 3.452 3.905 3.86 3.86 0 0 1-.566 2.017 3 3 0 0 1 .585.721 3.9 3.9 0 0 0 1.129-2.739 3.986 3.986 0 0 0-4.026-3.944m0 0",
  "data-name": "Path 68702"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff4f1",
  d: "M10.228 9.957c-.6-1.032-1.754-2.81-3.082-2.81s-2.49 1.781-3.087 2.818a1 1 0 0 0-.085.191 4.555 4.555 0 0 0 6.254-.2Zm0 0",
  "data-name": "Path 68703"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e8e4e0",
  d: "M7.132 7.154a1.8 1.8 0 0 0-.808.217 3.6 3.6 0 0 1 .926.71 1.873 1.873 0 0 1-.932 3.14l-.117.023a4.6 4.6 0 0 0 .811.067 4.52 4.52 0 0 0 3.222-1.368C9.627 8.914 8.46 7.145 7.132 7.154m0 0",
  "data-name": "Path 68704"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffe056",
  d: "M7.146 8.225a3.55 3.55 0 0 1 3.082 1.731 4.34 4.34 0 0 0 1.26-3.056 4.447 4.447 0 0 0-4.491-4.4 4.447 4.447 0 0 0-4.491 4.4 4.35 4.35 0 0 0 1.467 3.256 1 1 0 0 1 .085-.191 3.55 3.55 0 0 1 3.088-1.74m0 0",
  "data-name": "Path 68705"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f9cd45",
  d: "M6.996 2.5a5 5 0 0 0-.64.045A4.43 4.43 0 0 1 10.207 6.9a4.3 4.3 0 0 1-.632 2.25 3.4 3.4 0 0 1 .652.8 4.34 4.34 0 0 0 1.262-3.05 4.447 4.447 0 0 0-4.493-4.4m0 0",
  "data-name": "Path 68706"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffd5cc",
  d: "M8.13 5.478a1.082 1.082 0 1 0-1.052 1.334A1.22 1.22 0 0 0 8.13 5.478m0 0",
  "data-name": "Path 68707"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff4f1",
  d: "M26.234 9.957c-.6-1.032-1.754-2.81-3.082-2.81s-2.49 1.781-3.087 2.818a1 1 0 0 0-.085.191 4.555 4.555 0 0 0 6.254-.2Zm0 0",
  "data-name": "Path 68708"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e8e4e0",
  d: "M23.141 7.154a1.8 1.8 0 0 0-.808.217 3.6 3.6 0 0 1 .926.71 1.873 1.873 0 0 1-.932 3.14l-.117.023a4.6 4.6 0 0 0 .811.067 4.52 4.52 0 0 0 3.22-1.369c-.608-1.028-1.776-2.797-3.1-2.788m0 0",
  "data-name": "Path 68709"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#9ddbdf",
  d: "M23.151 8.225a3.55 3.55 0 0 1 3.082 1.732 4.34 4.34 0 0 0 1.26-3.055 4.492 4.492 0 0 0-8.982 0 4.35 4.35 0 0 0 1.467 3.254 1 1 0 0 1 .085-.191 3.55 3.55 0 0 1 3.087-1.74Zm0 0",
  "data-name": "Path 68710"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#7cd6e6",
  d: "M23.003 2.5a5 5 0 0 0-.64.045A4.43 4.43 0 0 1 26.214 6.9a4.3 4.3 0 0 1-.632 2.25 3.4 3.4 0 0 1 .652.8 4.34 4.34 0 0 0 1.26-3.055A4.447 4.447 0 0 0 23.003 2.5m0 0",
  "data-name": "Path 68711"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffd5cc",
  d: "M24.14 5.478a1.082 1.082 0 1 0-1.052 1.334 1.22 1.22 0 0 0 1.052-1.334m0 0",
  "data-name": "Path 68712"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff4f1",
  d: "M26.234 26.095c-.6-1.032-1.754-2.809-3.082-2.809s-2.49 1.781-3.087 2.818a1 1 0 0 0-.085.191 4.554 4.554 0 0 0 6.254-.2m0 0",
  "data-name": "Path 68713"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e8e4e0",
  d: "M23.141 23.293a1.8 1.8 0 0 0-.808.217 3.6 3.6 0 0 1 .926.71 1.873 1.873 0 0 1-.932 3.14l-.117.023a4.6 4.6 0 0 0 .811.067 4.52 4.52 0 0 0 3.22-1.368c-.608-1.028-1.776-2.798-3.1-2.789m0 0",
  "data-name": "Path 68714"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fc9086",
  d: "M23.151 24.364a3.55 3.55 0 0 1 3.082 1.732 4.34 4.34 0 0 0 1.26-3.055 4.492 4.492 0 0 0-8.982 0 4.35 4.35 0 0 0 1.467 3.254 1 1 0 0 1 .085-.191 3.55 3.55 0 0 1 3.088-1.74m0 0",
  "data-name": "Path 68715"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f57a73",
  d: "M23.003 18.639a5 5 0 0 0-.64.045 4.43 4.43 0 0 1 3.851 4.357 4.3 4.3 0 0 1-.632 2.25 3.4 3.4 0 0 1 .652.8 4.34 4.34 0 0 0 1.26-3.055 4.447 4.447 0 0 0-4.491-4.397m0 0",
  "data-name": "Path 68716"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffd5cc",
  d: "M24.14 21.617a1.082 1.082 0 1 0-1.052 1.334 1.22 1.22 0 0 0 1.052-1.334m0 0",
  "data-name": "Path 68717"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff4f1",
  d: "M10.228 26.144c-.6-1.032-1.754-2.809-3.082-2.809s-2.49 1.781-3.087 2.818a1 1 0 0 0-.085.191 4.554 4.554 0 0 0 6.254-.2m0 0",
  "data-name": "Path 68718"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e8e4e0",
  d: "M7.132 23.342a1.8 1.8 0 0 0-.808.217 3.6 3.6 0 0 1 .926.71 1.873 1.873 0 0 1-.932 3.14l-.117.023a4.6 4.6 0 0 0 .811.067 4.52 4.52 0 0 0 3.222-1.368c-.607-1.028-1.774-2.798-3.102-2.789m0 0",
  "data-name": "Path 68719"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5e8ee1",
  d: "M7.146 24.413a3.55 3.55 0 0 1 3.082 1.728 4.34 4.34 0 0 0 1.26-3.055 4.447 4.447 0 0 0-4.491-4.4 4.447 4.447 0 0 0-4.491 4.4 4.35 4.35 0 0 0 1.467 3.255 1 1 0 0 1 .085-.191 3.55 3.55 0 0 1 3.088-1.737m0 0",
  "data-name": "Path 68720"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#467bff",
  d: "M6.996 18.688a5 5 0 0 0-.64.045 4.43 4.43 0 0 1 3.851 4.357 4.3 4.3 0 0 1-.632 2.251 3.4 3.4 0 0 1 .652.8 4.34 4.34 0 0 0 1.26-3.055 4.447 4.447 0 0 0-4.491-4.398m0 0",
  "data-name": "Path 68721"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffd5cc",
  d: "M8.13 21.666A1.082 1.082 0 1 0 7.078 23a1.22 1.22 0 0 0 1.052-1.334m0 0",
  "data-name": "Path 68722"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#d0cfd1",
  "data-name": "Group 51126"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.915 4.864h.047a.371.371 0 1 0-.047 0m0 0",
  "data-name": "Path 68723"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.038 5.152a.4.4 0 0 0 .1.013.371.371 0 1 0-.1-.013m0 0",
  "data-name": "Path 68724"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.843 5.341a.371.371 0 1 0-.352-.252.37.37 0 0 0 .352.252m0 0",
  "data-name": "Path 68725"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.015 4.805h.027a.372.372 0 1 0-.027 0m0 0",
  "data-name": "Path 68726"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.029 16.162a.372.372 0 1 0-.4.344h.027a.37.37 0 0 0 .373-.344m0 0",
  "data-name": "Path 68727"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.198 18.59a.4.4 0 0 0 .1.013.371.371 0 1 0-.1-.013m0 0",
  "data-name": "Path 68728"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.122 12.309a.372.372 0 1 0-.352-.253.37.37 0 0 0 .352.253m0 0",
  "data-name": "Path 68729"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.231 14.056a.37.37 0 0 0 .368.325h.047a.372.372 0 1 0-.415-.322Zm0 0",
  "data-name": "Path 68730"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.036 24.865a.371.371 0 1 0 .471.232.37.37 0 0 0-.471-.232m0 0",
  "data-name": "Path 68731"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.036 25.325a.372.372 0 0 0 .046.74h.048a.372.372 0 0 0-.094-.737Zm0 0",
  "data-name": "Path 68732"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.982 25.381a.372.372 0 1 0-.052.741h.026a.372.372 0 0 0 .026-.742Zm0 0",
  "data-name": "Path 68733"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.875 18.62a.372.372 0 1 0-.352-.253.37.37 0 0 0 .352.253m0 0",
  "data-name": "Path 68734"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.03 16.223a.37.37 0 0 0 .368.324h.047a.37.37 0 0 0 .322-.415.372.372 0 0 0-.738.094Zm0 0",
  "data-name": "Path 68735"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.598 12.312a.4.4 0 0 0 .1.013.371.371 0 1 0-.1-.013m0 0",
  "data-name": "Path 68736"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.969 14.023a.37.37 0 0 0 .344.4h.026a.372.372 0 1 0-.371-.4Zm0 0",
  "data-name": "Path 68737"
}))));

const SvgPxVacantPossession = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "033---House-Key",
  transform: "translate(2.764 2.767)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#d1d4d1",
  fillRule: "evenodd",
  d: "M16.431 16.601v3.021a.456.456 0 0 1-.456.456H1.371a.456.456 0 0 1-.456-.456v-10.5l14.626-.909Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f0c419",
  d: "M26.439 11.69a5.95 5.95 0 0 0-5.235-5.266 5.89 5.89 0 0 0-4.522 1.392 5.7 5.7 0 0 0-1.141 1.31 5.932 5.932 0 0 0 2.715 8.671v1.363a.33.33 0 0 0 .1.228l.68.685a.32.32 0 0 1 .032.424l-.639.853a.326.326 0 0 0 .032.424l.575.58a.32.32 0 0 1 .032.424l-.616.826a.95.95 0 0 0-.192.57.96.96 0 0 0 .333.726l1.735 1.49a.32.32 0 0 0 .42 0l1.956-1.681a.32.32 0 0 0 .114-.246V17.79a5.92 5.92 0 0 0 3.619-6.1Zm-5.9-.283a1.369 1.369 0 1 1 1.365-1.369 1.37 1.37 0 0 1-1.366 1.369Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#b19046",
  fillRule: "evenodd",
  d: "M20.994 24.185a.456.456 0 0 1-.456-.458v-6.172a.457.457 0 0 1 .913 0v6.172a.456.456 0 0 1-.457.458",
  "data-name": "Path"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e64c3c",
  fillRule: "evenodd",
  d: "M16.682 7.816a5.7 5.7 0 0 0-1.141 1.31H.459a.456.456 0 0 1-.319-.785L8.354.126a.466.466 0 0 1 .639 0Z",
  "data-name": "Path"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#a56a43",
  fillRule: "evenodd",
  d: "M7.304 15.514h2.738a.456.456 0 0 1 .456.456v4.107h-3.65V15.97a.456.456 0 0 1 .456-.456",
  "data-name": "Path"
}), /*#__PURE__*/React.createElement("rect", {
  width: 3.194,
  height: 3.194,
  fill: "#67b9cc",
  rx: 1,
  transform: "translate(2.741 10.951)"
}), /*#__PURE__*/React.createElement("rect", {
  width: 3.194,
  height: 3.194,
  fill: "#67b9cc",
  "data-name": "Rectangle",
  rx: 1,
  transform: "translate(11.411 10.951)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e64c3c",
  fillRule: "evenodd",
  d: "M3.654 6.844v-5.02a.456.456 0 0 1 .456-.456h1.825a.456.456 0 0 1 .456.456v5.02",
  "data-name": "Path"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#c03a2b",
  fillRule: "evenodd",
  d: "M6.391 1.368a.456.456 0 0 1 .456.456v5.02a.457.457 0 1 1-.913 0V1.368ZM4.11 1.368v5.476a.457.457 0 0 1-.913 0v-5.02a.456.456 0 0 1 .456-.456Z",
  "data-name": "Path"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#bdc3c7",
  fillRule: "evenodd",
  d: "M23.277 6.387a4 4 0 0 1-.032.5 1 1 0 0 1-.023.146 4.5 4.5 0 0 1-1.237 2.537l-.123.123a4.5 4.5 0 0 1-2.4 1.191 1.34 1.34 0 0 1-.3-.844.1.1 0 0 1 0-.037 3.58 3.58 0 0 0 2.154-1.068l.009-.009a3.65 3.65 0 0 0 1-2.14 1 1 0 0 0 .009-.114c.009-.1.014-.187.014-.283a3.648 3.648 0 0 0-6.4-2.4 3.6 3.6 0 0 0-.894 2.218l-.808-.808a4.561 4.561 0 0 1 9.013.99Z",
  "data-name": "Path"
})));

const SvgPxWork = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".px-work_svg__c{fill:#d66e41}.px-work_svg__d{fill:#365e7d}")), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h32v32H0z",
  style: {
    fill: "none"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M175.962 33.091a4.5 4.5 0 0 0-.982-.524 7.23 7.23 0 0 0-5.175 0 4.5 4.5 0 0 0-.982.524.74.74 0 0 0-.292.591v1.166l.743.4.743-.4V34.1a5.6 5.6 0 0 1 4.751 0v.745l.743.4.743-.4v-1.163a.74.74 0 0 0-.292-.591",
  style: {
    fill: "#e8834d"
  },
  transform: "translate(-156.091 -26.088)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.441 8.759v.82l.743.4.743-.4v-.82ZM20.164 8.759h-1.491v.82l.743.4.743-.4Z",
  className: "px-work_svg__c"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.585 17.752v6.6a1.42 1.42 0 0 0 1.419 1.419h18.6a1.42 1.42 0 0 0 1.419-1.419v-6.6Z",
  className: "px-work_svg__d"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.247 279.705v.82c1.179.936 4.294 2.752 10.717 2.752s9.539-1.817 10.717-2.752v-.82z",
  style: {
    fill: "#2b4d66"
  },
  transform: "translate(-7.662 -262.773)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.523 120.049c1.13.92 4.24 2.8 10.779 2.8s9.649-1.882 10.779-2.8a2.37 2.37 0 0 0 .523-1.5v-3.964a1.42 1.42 0 0 0-1.419-1.419H1.419A1.42 1.42 0 0 0 0 114.588v3.964a2.37 2.37 0 0 0 .523 1.5Z",
  style: {
    fill: "#407093"
  },
  transform: "translate(5 -103.589)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.081 16.063c-1.13.92-4.24 2.8-10.779 2.8s-9.649-1.879-10.779-2.8a1.42 1.42 0 0 1-.523-1.1v.82a1.42 1.42 0 0 0 .523 1.101c1.13.92 4.24 2.8 10.779 2.8s9.649-1.882 10.779-2.8a1.42 1.42 0 0 0 .523-1.1v-.82a1.42 1.42 0 0 1-.523 1.099",
  className: "px-work_svg__d"
}), /*#__PURE__*/React.createElement("path", {
  d: "M227.226 307.918c.734 0 1.329-.545 1.329-1.726v-.806a.473.473 0 0 0-.473-.473h-1.712a.473.473 0 0 0-.473.473v.806c.003 1.181.595 1.726 1.329 1.726",
  style: {
    fill: "#ffe27a"
  },
  transform: "translate(-210.924 -286.868)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M227.226 335.2a1.33 1.33 0 0 1-1.329-1.329v.82a1.329 1.329 0 0 0 2.658 0v-.82a1.33 1.33 0 0 1-1.329 1.329",
  style: {
    fill: "#f9cf58"
  },
  transform: "translate(-210.924 -314.55)"
}));

const SvgRpa = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 28 28"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 30611"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 30610"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 11.982,
  cy: 12.035,
  fill: "#0019d8",
  "data-name": "Ellipse 739",
  rx: 11.982,
  ry: 12.035,
  transform: "translate(0 3.93)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 4.5,
  cy: 4.5,
  r: 4.5,
  fill: "#fff",
  "data-name": "Ellipse 740",
  transform: "translate(16.964 1.93)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffb11f",
  d: "M22.353 0a5.648 5.648 0 1 0 5.652 5.648A5.65 5.65 0 0 0 22.353 0m2.824 6.213h-2.259v2.259h-1.13V6.213h-2.259v-1.13h2.259V2.824h1.13v2.259h2.259Z",
  "data-name": "Path 35259"
})), /*#__PURE__*/React.createElement("g", {
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.405 16.348a.7.7 0 1 0-.7-.7.7.7 0 0 0 .7.7M14.474 14.946a.7.7 0 1 0 .7.7.7.7 0 0 0-.7-.7M6.689 15.313h-.14a.41.41 0 0 0-.412.412v.975h-.266a.413.413 0 0 0 0 .825h.266v.912a.41.41 0 0 0 .412.412h.14Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.366 14.449a1.974 1.974 0 0 0-1.972-1.972h-2.539v-.521a1.7 1.7 0 0 1-.824 0v.519H9.486a1.974 1.974 0 0 0-1.972 1.972v5.55a1.974 1.974 0 0 0 1.972 1.972h5.908a1.974 1.974 0 0 0 1.972-1.972v-5.55Zm-2.892 2.724a1.525 1.525 0 1 1 1.525-1.525 1.527 1.527 0 0 1-1.524 1.524Zm-3.106 2.232a.412.412 0 1 1 0-.824h2.144a.412.412 0 1 1 0 .824Zm1.491.76a.41.41 0 0 1-.412.412h-.014a.413.413 0 1 1 0-.825h.014a.41.41 0 0 1 .408.412Zm-.419-3.464a.41.41 0 0 1 .412.412v.5a.412.412 0 1 1-.824 0v-.5a.41.41 0 0 1 .412-.413Zm-.509-1.054a1.525 1.525 0 1 1-1.525-1.525 1.527 1.527 0 0 1 1.525 1.525M12.439 11.184a.882.882 0 1 0-.882-.882.883.883 0 0 0 .882.882M19.099 16.701h-.357v-.975a.41.41 0 0 0-.412-.412h-.042v3.536h.042a.41.41 0 0 0 .412-.412v-.912h.357a.413.413 0 1 0 0-.825"
}))));

const SvgStockTransferIn = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 30 30"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 56808"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 30535"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 49256"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h30v30H0z",
  "data-name": "Rectangle 14592"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 56806"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 49228"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 49211"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#555a6e",
  d: "M24.329 27.43h-1.861a2.791 2.791 0 0 1 0-5.582h1.861a2.791 2.791 0 1 1 0 5.582",
  "data-name": "Path 64169"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 49212",
  transform: "translate(19.504 21.886)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 2.917,
  cy: 2.917,
  r: 2.917,
  fill: "#463c4b",
  "data-name": "Ellipse 1427"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 49213"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#555a6e",
  d: "M19.677 27.43h-1.861a2.791 2.791 0 0 1 0-5.582h1.861a2.791 2.791 0 0 1 0 5.582",
  "data-name": "Path 64170"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 49214"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#5ad7ff",
  d: "M21.537 24.639H2.93a.93.93 0 0 1-.93-.93V12.544a.93.93 0 0 1 .93-.93h18.607a.93.93 0 0 1 .93.93v11.164a.93.93 0 0 1-.93.931",
  "data-name": "Path 64171"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 49215"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#23aae6",
  d: "M15.025 24.639H2.93a.93.93 0 0 1-.93-.93V12.544a.93.93 0 0 1 .93-.93h11.164a.93.93 0 0 1 .93.93Z",
  "data-name": "Path 64172"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 49216"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#5ad7ff",
  d: "M4.791 20.918a.93.93 0 0 1-.93-.93v-5.583a.93.93 0 0 1 1.861 0v5.582a.93.93 0 0 1-.931.931",
  "data-name": "Path 64173"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 49217"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#5ad7ff",
  d: "M8.512 20.918a.93.93 0 0 1-.93-.93v-5.583a.93.93 0 1 1 1.861 0v5.582a.93.93 0 0 1-.931.931",
  "data-name": "Path 64174"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 49218"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#5ad7ff",
  d: "M12.233 20.918a.93.93 0 0 1-.93-.93v-5.583a.93.93 0 1 1 1.861 0v5.582a.93.93 0 0 1-.931.931",
  "data-name": "Path 64175"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 49219"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#555a6e",
  d: "M28.05 20.917H15.025v-5.582h9.823a1.86 1.86 0 0 1 1.765 1.272Z",
  "data-name": "Path 64176"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 49220"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#463c4b",
  d: "M22.468 20.917h-7.443v-5.582h4.241a1.86 1.86 0 0 1 1.765 1.272Z",
  "data-name": "Path 64177"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 49221"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#a5c3dc",
  d: "M27.119 24.638H15.025v-3.721H28.05v2.791a.93.93 0 0 1-.931.93",
  "data-name": "Path 64178"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 49222"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#d7e6f0",
  d: "M21.537 24.638h-6.512v-3.721h7.443v2.791a.93.93 0 0 1-.931.93",
  "data-name": "Path 64179"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 49223",
  transform: "translate(14.642 21.886)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 2.917,
  cy: 2.917,
  r: 2.917,
  fill: "#463c4b",
  "data-name": "Ellipse 1428"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 49224",
  transform: "translate(16.587 23.83)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0.972,
  cy: 0.972,
  r: 0.972,
  fill: "#d7e6f0",
  "data-name": "Ellipse 1429"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 49225"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#555a6e",
  d: "M8.513 27.43H6.652a2.791 2.791 0 1 1 0-5.582h1.861a2.791 2.791 0 1 1 0 5.582",
  "data-name": "Path 64180"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 49226",
  transform: "translate(3.945 21.886)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 2.917,
  cy: 2.917,
  r: 2.917,
  fill: "#463c4b",
  "data-name": "Ellipse 1430"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 49227",
  transform: "translate(5.89 23.83)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0.972,
  cy: 0.972,
  r: 0.972,
  fill: "#d7e6f0",
  "data-name": "Ellipse 1431"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 56805"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 49244"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 49242"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#faa019",
  d: "M12.168 8.152h6.152a1.538 1.538 0 0 0 0-3.076h-6.152a1.538 1.538 0 1 0 0 3.076",
  "data-name": "Path 64188"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 49243"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#faa019",
  d: "M18.32 11.228a1.54 1.54 0 0 0 1.088-.451L22.482 7.7a1.54 1.54 0 0 0 0-2.175l-3.076-3.076a1.538 1.538 0 0 0-2.624 1.089V9.69a1.54 1.54 0 0 0 1.538 1.538",
  "data-name": "Path 64189"
})))))));

const SvgWhiteHome = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 30 30"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "house (1)"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 5951"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 5950"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M15.061 6.137 3.561 17.66v11.453a.87.87 0 0 0 .865.886h6.245v-9.895a.88.88 0 0 1 .888-.875h7.013a.87.87 0 0 1 .877.875v9.895h6.136a.87.87 0 0 0 .865-.886V17.66Zm0 11.309a3.546 3.546 0 1 1 3.506-3.546 3.53 3.53 0 0 1-3.506 3.547Z",
  "data-name": "Path 11046"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 5953"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 5952"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#ffb11f",
  d: "M15.057 12.265a1.773 1.773 0 1 0 1.773 1.773 1.775 1.775 0 0 0-1.773-1.773",
  "data-name": "Path 11047"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 5955"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 5954"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#ffb11f",
  d: "M12.457 21.027h5.319V30h-5.319z",
  "data-name": "Rectangle 3819"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 5957"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 5956"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M29.808 14.046c-.3-.759-8.009-8.373-8.594-8.963l-4.29-4.33a2.684 2.684 0 0 0-3.728 0c-.633.638-12.686 12.5-13 13.288a2.68 2.68 0 0 0 .574 2.882 2.5 2.5 0 0 0 .742.5l12.927-12.91a.873.873 0 0 1 1.243 0l12.812 12.923a2.6 2.6 0 0 0 .734-.513 2.68 2.68 0 0 0 .58-2.877",
  "data-name": "Path 11048"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 5959"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 5958"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M25.57 1.782h-3.546a.85.85 0 0 0-.876.8l5.3 5.308V2.633a.846.846 0 0 0-.878-.851",
  "data-name": "Path 11049"
})))));

const SvgWhiteLogout = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 30 29.5"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M18.516 15.979a1.23 1.23 0 0 0-1.234 1.229v4.917a1.233 1.233 0 0 1-1.235 1.229h-3.7V4.916a2.48 2.48 0 0 0-1.681-2.337l-.366-.121h5.75a1.233 1.233 0 0 1 1.235 1.229v3.688a1.235 1.235 0 0 0 2.469 0V3.687a3.7 3.7 0 0 0-3.707-3.691H2.777a1 1 0 0 0-.132.027c-.059-.001-.116-.027-.176-.027A2.466 2.466 0 0 0 0 2.458v22.125a2.48 2.48 0 0 0 1.681 2.337l7.429 2.466a2.6 2.6 0 0 0 .765.114 2.466 2.466 0 0 0 2.469-2.458v-1.229h3.7a3.7 3.7 0 0 0 3.7-3.688v-4.917a1.23 1.23 0 0 0-1.234-1.229Zm0 0",
  "data-name": "Path 11536"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffb11f",
  d: "m29.633 11.616-5-5a1.249 1.249 0 0 0-2.134.884v3.75h-5a1.25 1.25 0 1 0 0 2.5h5v3.75a1.25 1.25 0 0 0 2.134.884l5-5a1.25 1.25 0 0 0 0-1.768m0 0",
  "data-name": "Path 11537"
}));

export { SvgAccessSecurity as AccessSecurity, SvgBenefitManagement as BenefitManagement, SvgBlackDollar as BlackDollar, SvgCashieringAccessSecurity as CashieringAccessSecurity, SvgCashieringAdvancedSearch as CashieringAdvancedSearch, SvgCashieringBusinessInsight as CashieringBusinessInsight, SvgCashieringCancellation as CashieringCancellation, SvgCashieringCancellationReason as CashieringCancellationReason, SvgCashieringLogout as CashieringLogout, SvgCashieringManager as CashieringManager, SvgCashieringRoles as CashieringRoles, SvgCashieringStationSettings as CashieringStationSettings, SvgCashieringUser as CashieringUser, SvgChangePassword as ChangePassword, SvgChangePasswordContrast as ChangePasswordContrast, SvgCrmBillItemSettings as CrmBillItemSettings, SvgDollarOrange as DollarOrange, SvgEInvoiceDoc as EInvoiceDoc, SvgEInvoiceEnquiryDocs as EInvoiceEnquiryDocs, SvgEInvoicePendingAlertDoc as EInvoicePendingAlertDoc, SvgEInvoicePendingDoc as EInvoicePendingDoc, SvgEInvoicePropertyTitle as EInvoicePropertyTitle, SvgEInvoiceResetLock as EInvoiceResetLock, SvgEinvoiceCompleted as EinvoiceCompleted, SvgEinvoiceConsolidate as EinvoiceConsolidate, SvgEinvoicePending as EinvoicePending, SvgEinvoiceReject as EinvoiceReject, SvgFile as File, SvgHeaderBackIcon as HeaderBackIcon, SvgHeaderSwitchIcon as HeaderSwitchIcon, SvgHimsxAppsIcon as HimsxAppsIcon, SvgHimsxAuditLog as HimsxAuditLog, SvgHimsxLogout as HimsxLogout, SvgHimsxProjectSetup as HimsxProjectSetup, SvgHimsxRaceMapping as HimsxRaceMapping, SvgHimsxSystemSetting as HimsxSystemSetting, SvgHimsxUnitSetup as HimsxUnitSetup, SvgHimsxUnitTypeMapping as HimsxUnitTypeMapping, SvgHome as Home, SvgIfcax7Days as Ifcax7Days, SvgIfcaxAccessSecurity as IfcaxAccessSecurity, SvgIfcaxAccountxIcon as IfcaxAccountxIcon, SvgIfcaxAppDev as IfcaxAppDev, SvgIfcaxAxIcon as IfcaxAxIcon, SvgIfcaxBill as IfcaxBill, SvgIfcaxBilling as IfcaxBilling, SvgIfcaxBrochure as IfcaxBrochure, SvgIfcaxBug as IfcaxBug, SvgIfcaxBusinessman as IfcaxBusinessman, SvgIfcaxCandidate as IfcaxCandidate, SvgIfcaxCashBook as IfcaxCashBook, SvgIfcaxChinaIcon as IfcaxChinaIcon, SvgIfcaxClock as IfcaxClock, SvgIfcaxCompanies as IfcaxCompanies, SvgIfcaxCompany as IfcaxCompany, SvgIfcaxCompanySetting as IfcaxCompanySetting, SvgIfcaxContractxIcon as IfcaxContractxIcon, SvgIfcaxCrosshair as IfcaxCrosshair, SvgIfcaxCustomerAccount as IfcaxCustomerAccount, SvgIfcaxCxIcon as IfcaxCxIcon, SvgIfcaxDemoVideo as IfcaxDemoVideo, SvgIfcaxDocuments as IfcaxDocuments, SvgIfcaxEnhancement as IfcaxEnhancement, SvgIfcaxFaqs as IfcaxFaqs, SvgIfcaxFile as IfcaxFile, SvgIfcaxFire as IfcaxFire, SvgIfcaxGeneralLedger as IfcaxGeneralLedger, SvgIfcaxGeneralSetting as IfcaxGeneralSetting, SvgIfcaxGroupBusinessInsight as IfcaxGroupBusinessInsight, SvgIfcaxHealthInsurance as IfcaxHealthInsurance, SvgIfcaxHotelxIcon as IfcaxHotelxIcon, SvgIfcaxHouse as IfcaxHouse, SvgIfcaxHrxIcon as IfcaxHrxIcon, SvgIfcaxHumanresourcexIcon as IfcaxHumanresourcexIcon, SvgIfcaxHxIcon as IfcaxHxIcon, SvgIfcaxIcon as IfcaxIcon, SvgIfcaxIssueCertified as IfcaxIssueCertified, SvgIfcaxIssueChecked as IfcaxIssueChecked, SvgIfcaxIssueChop as IfcaxIssueChop, SvgIfcaxIssueDeploy as IfcaxIssueDeploy, SvgIfcaxIssueNoAction as IfcaxIssueNoAction, SvgIfcaxIssueOpen as IfcaxIssueOpen, SvgIfcaxIssueProgress as IfcaxIssueProgress, SvgIfcaxIssueQc as IfcaxIssueQc, SvgIfcaxIssueReopened as IfcaxIssueReopened, SvgIfcaxIssues as IfcaxIssues, SvgIfcaxLogOut as IfcaxLogOut, SvgIfcaxMainBrochure as IfcaxMainBrochure, SvgIfcaxMarketing as IfcaxMarketing, SvgIfcaxMeeting as IfcaxMeeting, SvgIfcaxMenuxIcon as IfcaxMenuxIcon, SvgIfcaxMxIcon as IfcaxMxIcon, SvgIfcaxNewProductSales as IfcaxNewProductSales, SvgIfcaxNoBug as IfcaxNoBug, SvgIfcaxNoFire as IfcaxNoFire, SvgIfcaxOldIcon as IfcaxOldIcon, SvgIfcaxPdf as IfcaxPdf, SvgIfcaxPenalty as IfcaxPenalty, SvgIfcaxPostSales as IfcaxPostSales, SvgIfcaxProduct as IfcaxProduct, SvgIfcaxProductGallery as IfcaxProductGallery, SvgIfcaxProject as IfcaxProject, SvgIfcaxPropertyxIcon as IfcaxPropertyxIcon, SvgIfcaxPxIcon as IfcaxPxIcon, SvgIfcaxReopen as IfcaxReopen, SvgIfcaxSaasRenewal as IfcaxSaasRenewal, SvgIfcaxSales as IfcaxSales, SvgIfcaxSalesVideo as IfcaxSalesVideo, SvgIfcaxSitexIcon as IfcaxSitexIcon, SvgIfcaxSoftware as IfcaxSoftware, SvgIfcaxSoftwareDev as IfcaxSoftwareDev, SvgIfcaxSort as IfcaxSort, SvgIfcaxSsaRenewal as IfcaxSsaRenewal, SvgIfcaxSum as IfcaxSum, SvgIfcaxSxIcon as IfcaxSxIcon, SvgIfcaxTax as IfcaxTax, SvgIfcaxUserAccess as IfcaxUserAccess, SvgIfcaxUserAccessLog as IfcaxUserAccessLog, SvgIfcaxVideo as IfcaxVideo, SvgIfcaxXd as IfcaxXd, SvgLeave as Leave, SvgLogout as Logout, SvgMicrosoftLogo as MicrosoftLogo, SvgOrangeDollar as OrangeDollar, SvgOutlineblackDollar as OutlineblackDollar, SvgPdf as Pdf, SvgProfile as Profile, SvgPurchaseOrder as PurchaseOrder, SvgPurchaseOrderOnbehalf as PurchaseOrderOnbehalf, SvgPurchaseRequisition as PurchaseRequisition, SvgPurchases as Purchases, SvgPxAlert as PxAlert, SvgPxApproval as PxApproval, SvgPxAreaPolicy as PxAreaPolicy, SvgPxAreaVariance as PxAreaVariance, SvgPxBlackDollar as PxBlackDollar, SvgPxBlueDollar as PxBlueDollar, SvgPxBridgingFinancing as PxBridgingFinancing, SvgPxBridgingLoan as PxBridgingLoan, SvgPxBusinessInsight as PxBusinessInsight, SvgPxBusinessPermit as PxBusinessPermit, SvgPxCalendar as PxCalendar, SvgPxCalendarPolicy as PxCalendarPolicy, SvgPxCampaign as PxCampaign, SvgPxCancelation as PxCancelation, SvgPxCommonSetting as PxCommonSetting, SvgPxCompany as PxCompany, SvgPxConstructionInfo as PxConstructionInfo, SvgPxCreditControl as PxCreditControl, SvgPxCreditNote as PxCreditNote, SvgPxDefaultCalendar as PxDefaultCalendar, SvgPxDesignation as PxDesignation, SvgPxDigitalReporting as PxDigitalReporting, SvgPxDisableBadge as PxDisableBadge, SvgPxDiscount as PxDiscount, SvgPxDollar as PxDollar, SvgPxDownpayment as PxDownpayment, SvgPxEducation as PxEducation, SvgPxEletter as PxEletter, SvgPxEndFinancier as PxEndFinancier, SvgPxEndFinancing as PxEndFinancing, SvgPxEngineering as PxEngineering, SvgPxFile as PxFile, SvgPxFinancier as PxFinancier, SvgPxFireInsurance as PxFireInsurance, SvgPxFrontDesk as PxFrontDesk, SvgPxGeneralDocument as PxGeneralDocument, SvgPxHandDown as PxHandDown, SvgPxHome as PxHome, SvgPxHomeW as PxHomeW, SvgPxHumanArrow as PxHumanArrow, SvgPxIndustry as PxIndustry, SvgPxKeyCollection as PxKeyCollection, SvgPxKeyContractor as PxKeyContractor, SvgPxKeySetting as PxKeySetting, SvgPxLad as PxLad, SvgPxLadSetting as PxLadSetting, SvgPxLatePayment as PxLatePayment, SvgPxLetterB as PxLetterB, SvgPxLetterBBw as PxLetterBBw, SvgPxLogout as PxLogout, SvgPxMarital as PxMarital, SvgPxMoney as PxMoney, SvgPxMoneyDown as PxMoneyDown, SvgPxMotTracking as PxMotTracking, SvgPxNewspaper as PxNewspaper, SvgPxNoRecords as PxNoRecords, SvgPxOpenLeads as PxOpenLeads, SvgPxOutlineblackDollar as PxOutlineblackDollar, SvgPxOutlineblueDollar as PxOutlineblueDollar, SvgPxOutlinegreenDollar as PxOutlinegreenDollar, SvgPxPayment as PxPayment, SvgPxPaymentPlan as PxPaymentPlan, SvgPxPermitHistory as PxPermitHistory, SvgPxProfession as PxProfession, SvgPxProfile as PxProfile, SvgPxProgressBilling as PxProgressBilling, SvgPxProjectDetails as PxProjectDetails, SvgPxProjectSetup as PxProjectSetup, SvgPxProjectType as PxProjectType, SvgPxPropertyAgency as PxPropertyAgency, SvgPxPropertyTitle as PxPropertyTitle, SvgPxPropertyType as PxPropertyType, SvgPxPublic as PxPublic, SvgPxPurchaserAccount as PxPurchaserAccount, SvgPxRace as PxRace, SvgPxRedDollar as PxRedDollar, SvgPxRelationship as PxRelationship, SvgPxReligion as PxReligion, SvgPxReminder as PxReminder, SvgPxRoleAuthorisation as PxRoleAuthorisation, SvgPxSalesAdmin as PxSalesAdmin, SvgPxSalesCancellation as PxSalesCancellation, SvgPxSalesContracts as PxSalesContracts, SvgPxSalesCrm as PxSalesCrm, SvgPxSalesOffice as PxSalesOffice, SvgPxSalesPackage as PxSalesPackage, SvgPxSalutation as PxSalutation, SvgPxSignDate as PxSignDate, SvgPxSolicitor as PxSolicitor, SvgPxSolicitor2 as PxSolicitor2, SvgPxStakeholder as PxStakeholder, SvgPxStandardLetter as PxStandardLetter, SvgPxStandardMisc as PxStandardMisc, SvgPxStandardParameter as PxStandardParameter, SvgPxSubsale as PxSubsale, SvgPxSuperUser as PxSuperUser, SvgPxSuperuserDetail as PxSuperuserDetail, SvgPxSupeuserInactive as PxSupeuserInactive, SvgPxSystemAdmin as PxSystemAdmin, SvgPxSystemAdminW as PxSystemAdminW, SvgPxTaxSetup as PxTaxSetup, SvgPxTitleSetup as PxTitleSetup, SvgPxTodo as PxTodo, SvgPxTodoRed as PxTodoRed, SvgPxTravelAgent as PxTravelAgent, SvgPxUnitDirection as PxUnitDirection, SvgPxUnitSetup as PxUnitSetup, SvgPxUnitType as PxUnitType, SvgPxUser as PxUser, SvgPxUsersAccess as PxUsersAccess, SvgPxUsersAccessW as PxUsersAccessW, SvgPxUsersRole as PxUsersRole, SvgPxVacantPossession as PxVacantPossession, SvgPxWork as PxWork, SvgRpa as Rpa, SvgStockTransferIn as StockTransferIn, SvgWhiteHome as WhiteHome, SvgWhiteLogout as WhiteLogout };
//# sourceMappingURL=index.esm.js.map
